(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`/*!
 * Cropper.js v1.6.1
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:44:17.565Z
 */.cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{backface-visibility:hidden;display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-wrap-box,.cropper-canvas,.cropper-drag-box,.cropper-crop-box,.cropper-modal{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-wrap-box,.cropper-canvas{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline:1px solid #39f;outline-color:#3399ffbf;overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:calc(100% / 3);left:0;top:calc(100% / 3);width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:calc(100% / 3);top:0;width:calc(100% / 3)}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:before,.cropper-center:after{background-color:#eee;content:" ";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width: 768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width: 992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width: 1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:" ";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC)}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}.sidemenu__button__icon{position:absolute;top:50%;left:50%;margin:-12px 0 0 -12px}.megadraft-modal{position:relative;width:528px;height:394px;text-align:left;z-index:10}.megadraft-modal--open{overflow-y:hidden}.megadraft-modal--close{overflow-y:auto}.megadraft-modal__button{border:0;color:#fff;cursor:pointer;font-size:0;padding:0;-webkit-transition:all .5s ease;transition:all .5s ease;position:relative;background:none;width:64px;height:64px;margin-left:32px}.megadraft-modal__button .sidemenu__button__icon{position:absolute;top:50%;left:50%;margin:-16px 0 0 -16px;width:32px;height:32px}.megadraft-modal__button:before{content:"";width:100%;height:100%;border-radius:100%;display:inline-block;background-color:#181818}.megadraft-modal__button__label{margin:0;font-family:Open Sans,sans-serif;width:129px;height:40px;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.14;color:#3c3c3c;text-align:center;cursor:pointer;z-index:10;padding-top:9px}.megadraft-modal__items{flex-wrap:wrap;display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;margin:-24px}.megadraft-modal__items .megadraft-modal__button{background:none}.megadraft-modal__items .megadraft-modal__button:before{-webkit-transition:all .1s ease-in-out;transition:all .1s ease-in-out;background-color:#181818}.megadraft-modal__item{line-height:0px;height:58px;margin:0 71px 78px 17px;padding-top:31px;cursor:pointer;width:82px}.megadraft-modal__item:hover .megadraft-modal__button__label{color:#0669de}.megadraft-modal__item:hover .megadraft-modal__button:before{background-color:#0669de}.megadraft-editor{position:relative}.megadraft-editor .DraftEditor-root,.megadraft-editor .toolbar{font-family:Open Sans,sans-serif;color:#181818;font-size:1.125rem;letter-spacing:-.037rem;line-height:1.75rem;position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.megadraft-editor .DraftEditor-editorContainer{position:relative;z-index:1}.megadraft-editor .paragraph+.paragraph{margin-top:40px}.megadraft-editor .public-DraftEditor-content figure{margin:0}.megadraft-editor .public-DraftStyleDefault-ul{list-style-type:disc}.megadraft-editor .public-DraftStyleDefault-ol{list-style-type:decimal}.megadraft-editor .public-DraftStyleDefault-ol,.megadraft-editor .public-DraftStyleDefault-ul{line-height:2;padding-left:40px}.megadraft-editor .public-DraftStyleDefault-ol li,.megadraft-editor .public-DraftStyleDefault-ul li{padding-left:10px}.megadraft-editor .public-DraftEditorPlaceholder-root{color:#999;position:absolute;z-index:0}.megadraft-editor.placeholder-list .public-DraftEditorPlaceholder-root{left:50px;top:5px}.megadraft-editor.placeholder-header-two .public-DraftEditorPlaceholder-root{top:2px}.megadraft-editor.placeholder-blockquote .public-DraftEditorPlaceholder-root{left:20px;top:7px}.megadraft-editor.movable .public-DraftEditorPlaceholder-root{padding:8px 0 0 8px}.megadraft-editor.movable.placeholder-blockquote .public-DraftEditorPlaceholder-root{padding:20px 0 0 10px}.megadraft-editor blockquote{border-left:2px solid #ddd;color:#999;font-style:italic;margin:12px 0 40px;padding:6px 0 5px 18px}.megadraft-editor .paragraph+blockquote{margin-top:40px}.megadraft-editor h2{font-family:Open Sans,Sans-serif;font-weight:700;font-size:1.5rem;letter-spacing:-.056rem;line-height:2rem;margin-right:24px}.megadraft-editor h2:first-child{margin-top:0}.megadraft-editor .editor__link{color:#3192e7;text-decoration:none;cursor:pointer}.megadraft-editor .sidebar{position:relative}.megadraft-editor .sidebar__menu{float:left;left:-57px;position:absolute}.megadraft-editor .sidebar__sidemenu-wrapper{padding:0;list-style:none;margin:0}.megadraft-editor .sidemenu{position:relative;width:36px;text-align:center}.megadraft-editor .sidemenu__button{border:0;color:#fff;cursor:pointer;height:32px;font-size:0;padding:0;width:32px;-webkit-transition:all .5s ease;transition:all .5s ease;position:relative;background:none;outline:none}.megadraft-editor .sidemenu__button:before{content:"";width:100%;height:100%;border-radius:100%;display:inline-block;background-color:#181818}.megadraft-editor .sidemenu__button:before:hover{background-color:#333}.megadraft-editor .sidemenu__button--open{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.megadraft-editor .sidemenu__button--open:before{background-color:#0669de}.megadraft-editor .sidemenu__button__icon{position:absolute;top:50%;left:50%;margin:-12px 0 0 -12px}.megadraft-editor .sidemenu__items{list-style:none;padding:2px 0 0;margin-top:8px;-webkit-transition:max-height .5s ease;transition:max-height .5s ease;overflow:hidden;max-height:0;width:36px;text-align:center}.megadraft-editor .sidemenu__items .sidemenu__button{background:none}.megadraft-editor .sidemenu__items .sidemenu__button:before{-webkit-transition:all .1s ease-in-out;transition:all .1s ease-in-out;background-color:#181818}.megadraft-editor .sidemenu__items .sidemenu__button:hover:before{-webkit-transform:scale(1.125);transform:scale(1.125)}.megadraft-editor .sidemenu__item{height:40px}.megadraft-editor .toolbar{background:#ff0;height:0;position:absolute;display:none;z-index:10}.megadraft-editor .toolbar--open{display:block}.megadraft-editor .toolbar__error-msg{margin:0;height:0;-webkit-transition:height .2s ease-in-out;transition:height .2s ease-in-out}.megadraft-editor .toolbar--error .toolbar__wrapper{background-color:#e83f26}.megadraft-editor .toolbar--error .toolbar__arrow{border-color:#E83F26 transparent transparent}.megadraft-editor .toolbar--error .toolbar__error-msg{color:#fff;margin:-8px 0 0 20px;padding-bottom:12px;font-size:.75rem;font-weight:700;height:28px}.megadraft-editor .toolbar--error .toolbar__button{color:#fff}.megadraft-editor .toolbar--error ::-webkit-input-placeholder{color:#fff}.megadraft-editor .toolbar--error :-moz-placeholder{color:#fff}.megadraft-editor .toolbar--error ::-moz-placeholder{color:#fff}.megadraft-editor .toolbar--error :-ms-input-placeholder{color:#fff}.megadraft-editor .toolbar__wrapper{background-color:#181818;border-radius:4px;box-shadow:0 1px 3px #0006;left:-50%;position:relative;-webkit-transition:background-color .2s ease-in-out;transition:background-color .2s ease-in-out}.megadraft-editor .toolbar__list{padding:0 8px;margin:0;white-space:nowrap}.megadraft-editor .toolbar__arrow{display:inline-block;top:100%;left:50%;height:0;width:0;position:absolute;pointer-events:none;border-width:8px;border-style:solid;border-color:#181818 transparent transparent;margin-left:-8px;-webkit-transition:border-color .2s ease-in-out;transition:border-color .2s ease-in-out}.megadraft-editor .toolbar__item{display:inline-block;color:#ccc}.megadraft-editor .toolbar__item:hover{color:#fff}.megadraft-editor .toolbar__item--active,.megadraft-editor .toolbar__item--active:hover{color:#3192e7}.megadraft-editor .toolbar__item--separator{border-right:1px solid #333;height:20px;margin:0 8px}.megadraft-editor .toolbar__button{padding:0;color:inherit;cursor:pointer;border:0;height:56px;width:40px;background:transparent}.megadraft-editor .toolbar__input{background-color:transparent;border:none;color:#fafafa;font-size:.875rem;height:auto;line-height:1.2rem;margin:0;padding:20px;width:250px}.megadraft-editor .toolbar__input:focus{outline:none}.megadraft-editor .toolbar__input-button{padding-right:16px}.megadraft-editor .block__hover{padding:8px;margin:-8px}.megadraft-editor .block__hover:hover{background-color:#eee;border-radius:4px}.megadraft-editor .block__hover--readonly{padding:8px;margin:-8px}.megadraft-editor .block__wrapper{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;border-radius:3px;border:solid 1px #ddd;box-shadow:0 1px 1px #0000001a}.megadraft-editor .block__controls{overflow:auto;padding:8px}.megadraft-editor .block__action-group{color:#999;float:right;list-style:none;margin:0;padding:0}.megadraft-editor .block__action{display:inline-block;padding:0 8px;line-height:40px;cursor:pointer;text-align:center;font-size:0}.megadraft-editor .block__action:hover{color:#000}.megadraft-editor .block__action__icon{vertical-align:middle}.megadraft-editor .block__content{background-color:#eee;line-height:100px;text-align:center;position:relative}.megadraft-editor .block__content--with-padding{padding:16px}.megadraft-editor .block__content:before,.megadraft-editor .block__content:after{position:absolute;width:100%;height:0;border-top:1px solid rgba(0,0,0,.1);content:"";left:0}.megadraft-editor .block__content:before{top:0}.megadraft-editor .block__content:after{bottom:0}.megadraft-editor .block__notfound__icon{color:#999;vertical-align:middle;width:64px;height:64px;margin:104px}.megadraft-editor .block__data{padding:8px 16px 16px;background-color:#fff}.megadraft-editor .block__input{border:0;border-bottom:1px dashed transparent;color:#333;display:block;padding:8px 0;width:100%;font-size:.75rem}.megadraft-editor .block__input--small-padding{padding:8px 0 5px}.megadraft-editor .block__input--big-text{font-size:1rem;font-weight:700}.megadraft-editor .block__input__row{line-height:1rem}.megadraft-editor .block__input__wrapper{position:relative}.megadraft-editor .block__input__icon{position:absolute;top:50%;margin-top:-8px;right:0;width:16px;height:16px;display:none;pointer-events:none}.megadraft-editor .block__input:hover{border-color:#999}.megadraft-editor .block__input:hover+svg.block__input__icon{display:inline-block}.megadraft-editor .block__input:focus{border-color:#0072de;border-style:solid}.megadraft-editor .block__input:focus+svg.block__input__icon{display:inline-block}.megadraft-editor .block__input:placeholder{color:#999}.megadraft-editor .block__input--empty{border-color:#ccc}.megadraft-editor .block__input--empty :hover{border-color:#999}.megadraft-editor .block__input--empty+svg.block__input__icon{color:#999;display:inline-block}.megadraft-editor .block__input--error,.megadraft-editor .block__input--error.block__input--empty,.megadraft-editor .block__input--error:hover{border-color:#ff351e;border-style:solid}.megadraft-editor .block__input--error+svg.block__input__icon{color:#ff351e;display:inline-block}.megadraft-editor .block__input__error-text{color:#ff351e;margin-top:6px;font-size:.75rem}.megadraft-editor .block__input--readonly,.megadraft-editor .block__input--readonly.block__input--empty,.megadraft-editor .block__input--readonly:hover{border:none}.megadraft-editor .block__input--readonly:hover+svg.block__input__icon{display:none}.megadraft-editor .block__input--readonly:focus{border:none}.megadraft-editor .block__input--readonly:focus+svg.block__input__icon{display:none}.megadraft-editor .dropdown__wrapper{border-radius:2px;position:absolute;background:#fff;color:#999;cursor:pointer;font-weight:700;z-index:10}.megadraft-editor .dropdown__wrapper--open{box-shadow:0 1px 2px #00000080;color:#333}.megadraft-editor .dropdown{display:none;list-style:none;margin:0;border-top:1px solid #ddd;padding:8px 0}.megadraft-editor .dropdown--open{display:block}.megadraft-editor .dropdown__arrow{margin-left:5px;vertical-align:middle}.megadraft-editor .dropdown__arrow--open{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.megadraft-editor .dropdown__option{color:#999}.megadraft-editor .dropdown__option:hover{background-color:#0669de;color:#fff}.megadraft-editor .dropdown__item{padding:0 8px;line-height:40px;font-size:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.megadraft-editor .dropdown__item--selected:hover{color:#333}.megadraft-editor .dropdown__item__text{vertical-align:middle;margin-left:8px;font-size:.75rem}.megadraft-editor .dropdown__item__icon{vertical-align:middle}.megadraft-editor .media__message--error{background-color:#e83f26;color:#fff}.megadraft-editor .media__message--warning{background-color:#fff7d8;color:#b59223;border-bottom:1px solid rgba(0,0,0,.1)}.megadraft-editor .media__message-text{text-align:left;padding:8px;font-size:12px;line-height:16px;font-weight:700}.megadraft-editor .move-control{border:8px solid rgba(238,238,238,0);border-radius:4px;display:-webkit-box;display:flex;-webkit-transition:margin .3s;transition:margin .3s}.megadraft-editor .move-control:hover{border:8px solid #eeeeee}.megadraft-editor .move-control:hover .options{border:8px solid #eeeeee;opacity:1}.megadraft-editor .move-control__target{width:100%}.megadraft-editor .move-control--atomic:hover{background-color:#eee}.megadraft-editor .move-control--swapped{margin-left:-8px}.megadraft-editor .options--swapped{margin-left:8px!important}.megadraft-editor .options{width:40px;height:76px;margin:-8px -40px -8px 0;border-radius:4px;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:justify;justify-content:space-between;background-color:#eee;opacity:0;-webkit-transition:margin .3s;transition:margin .3s;cursor:default}.megadraft-editor .options__button{border:0;height:24px;width:24px;font-size:0;padding:0;outline:none;background:none;cursor:pointer}.megadraft-editor .options__button--disabled{pointer-events:none;opacity:.5}.megadraft-editor .options__button:hover{background:#21212114;-webkit-transition:background-color .15s cubic-bezier(.4,0,.2,1) 0ms;transition:background-color .15s cubic-bezier(.4,0,.2,1) 0ms;border-radius:50%}.megadraft-editor .options__button:active{background:#21212129}.megadraft-editor .options__button--up{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.megadraft-editor .megadraft-block{padding-bottom:40px}`)),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
var IA = Object.defineProperty;
var DA = (e, t, r) => t in e ? IA(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var cr = (e, t, r) => DA(e, typeof t != "symbol" ? t + "" : t, r);
import * as Be from "react";
import dt, { useMemo as kt, useState as Xe, useEffect as pt, useRef as bt, useCallback as Kt, createContext as Ac, useContext as qi, Fragment as fE, useLayoutEffect as um, useReducer as cm, forwardRef as Kf, Component as PA, useImperativeHandle as MA, cloneElement as Ns, isValidElement as oc, createRef as AA, PureComponent as NA, memo as Xf, Children as jA } from "react";
import { User as Sh } from "@prismamedia/one-user";
import { useTheme as zo, useMediaQuery as sa, Popper as Jf, ClickAwayListener as dm, Grow as Zf, Card as Bo, CardContent as pE, IconButton as fr, SvgIcon as kA, Typography as Lt, Drawer as ov, List as Nc, Link as LA, ListItem as Qf, ListItemIcon as Va, ListItemText as Ya, Divider as hc, CircularProgress as un, ListSubheader as B0, Box as zt, Chip as Qa, TextField as ln, InputAdornment as hE, Menu as zA, Button as Fr, MenuItem as la, Dialog as jc, Snackbar as fm, SnackbarContent as pm, Slide as gE, DialogTitle as Gl, DialogContent as Ao, DialogContentText as za, ListItemAvatar as BA, Avatar as kc, ListItemSecondaryAction as FA, Tooltip as Nr, DialogActions as ep, alpha as an, ThemeProvider as vE, createTheme as mE, AppBar as Ka, Toolbar as ca, FormControl as ra, InputLabel as hm, Select as gm, darken as WA, Badge as av, Stack as HA, Skeleton as $A, Grid as Dn, Tabs as UA, Tab as GA, CardActions as vm, InputBase as qA, ListItemButton as VA, Accordion as YA, AccordionSummary as KA, AccordionDetails as XA, TableContainer as JA, Table as yE, TableBody as bE, TableRow as wf, TableCell as _n, Slider as ZA, CardActionArea as QA, FormControlLabel as js, Checkbox as Ba, Fab as uo, ButtonBase as eN, Paper as mm, ImageList as tN, ImageListItem as rN, FormHelperText as nN, Collapse as iN, TableHead as oN } from "@mui/material";
import { Close as ql, Mood as aN, Equalizer as sN, DynamicFeed as lN, AccountCircle as uN, PowerSettingsNew as cN, Menu as dN, SubdirectoryArrowRight as fN, ArrowDropUp as ym, ArrowDropDown as Lc, Clear as gc, ArrowDownward as pN, ArrowUpward as hN, Edit as tp, Lock as wE, Mail as gN, AccessTime as vN, Image as mN, ImageSearchOutlined as yN, MobileScreenShare as bN, ArrowBack as bm, FilterCenterFocus as wm, Save as wN, MoreVert as xN, Upload as xm, Search as F0, Folder as _N, ArrowRight as SN, Add as xE, Check as EN, Delete as zc, InfoOutlined as CN, ExpandMore as _m, ExpandCircleDown as W0, Cancel as TN, Error as rp, ZoomOut as ON, ZoomIn as RN, ExpandLess as _E, LinkOff as IN, ContentPasteGo as SE, StrikethroughS as DN, CopyAll as PN, WrapText as EE, Download as CE, OpenInNew as MN, InsertPhoto as AN, Videocam as NN, BurstMode as jN, PhotoCamera as kN, TouchApp as LN, AddPhotoAlternate as zN, ViewDay as BN, YouTube as FN, Facebook as WN, Instagram as HN, Twitter as $N, LinkedIn as UN, Pinterest as GN, Reddit as qN, Public as VN, Code as YN, Refresh as KN, RemoveRedEye as XN, ChevronLeft as H0, ChevronRight as $0 } from "@mui/icons-material";
import { makeStyles as Rt, withStyles as TE, createStyles as OE } from "@mui/styles";
import JN from "@emotion/styled";
import { keyframes as Bc, css as RE } from "@emotion/react";
import * as ZN from "react-dom";
import ac, { unstable_batchedUpdates as QN, findDOMNode as ej } from "react-dom";
import { atom as tj, useRecoilState as rj } from "recoil";
import nj, { ContentBlock as IE, genKey as DE, ContentState as U0, CharacterMetadata as ij, Modifier as np, EditorState as Fc, CompositeDecorator as PE, SelectionState as ME } from "draft-js";
import { editorStateFromRaw as kl, editorStateToJSON as AE, MegadraftIcons as ua, createTypeStrategy as oj, Sidebar as aj, MegadraftEditor as NE, insertDataBlock as Vl } from "megadraft";
import sj from "@prismamedia/image-resizer-client";
import { DateRangePicker as lj, StaticDateTimePicker as uj } from "@mui/lab";
var xi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function cj(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Gd = { exports: {} }, ll = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Eh, G0;
function ip() {
  if (G0) return Eh;
  G0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(s).map(function(h) {
        return s[h];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        f[h] = h;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Eh = i() ? Object.assign : function(o, s) {
    for (var l, c = n(o), f, h = 1; h < arguments.length; h++) {
      l = Object(arguments[h]);
      for (var g in l)
        t.call(l, g) && (c[g] = l[g]);
      if (e) {
        f = e(l);
        for (var S = 0; S < f.length; S++)
          r.call(l, f[S]) && (c[f[S]] = l[f[S]]);
      }
    }
    return c;
  }, Eh;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q0;
function dj() {
  if (q0) return ll;
  q0 = 1, ip();
  var e = dt, t = 60103;
  if (ll.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), ll.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, f) {
    var h, g = {}, S = null, b = null;
    f !== void 0 && (S = "" + f), c.key !== void 0 && (S = "" + c.key), c.ref !== void 0 && (b = c.ref);
    for (h in c) i.call(c, h) && !o.hasOwnProperty(h) && (g[h] = c[h]);
    if (l && l.defaultProps) for (h in c = l.defaultProps, c) g[h] === void 0 && (g[h] = c[h]);
    return { $$typeof: t, type: l, key: S, ref: b, props: g, _owner: n.current };
  }
  return ll.jsx = s, ll.jsxs = s, ll;
}
var Ch = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V0;
function fj() {
  return V0 || (V0 = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = dt, r = ip(), n = 60103, i = 60106;
      e.Fragment = 60107;
      var o = 60108, s = 60114, l = 60109, c = 60110, f = 60112, h = 60113, g = 60120, S = 60115, b = 60116, p = 60121, v = 60122, w = 60117, C = 60129, M = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var L = Symbol.for;
        n = L("react.element"), i = L("react.portal"), e.Fragment = L("react.fragment"), o = L("react.strict_mode"), s = L("react.profiler"), l = L("react.provider"), c = L("react.context"), f = L("react.forward_ref"), h = L("react.suspense"), g = L("react.suspense_list"), S = L("react.memo"), b = L("react.lazy"), p = L("react.block"), v = L("react.server.block"), w = L("react.fundamental"), L("react.scope"), L("react.opaque.id"), C = L("react.debug_trace_mode"), L("react.offscreen"), M = L("react.legacy_hidden");
      }
      var W = typeof Symbol == "function" && Symbol.iterator, z = "@@iterator";
      function B(oe) {
        if (oe === null || typeof oe != "object")
          return null;
        var Qe = W && oe[W] || oe[z];
        return typeof Qe == "function" ? Qe : null;
      }
      var K = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function Z(oe) {
        {
          for (var Qe = arguments.length, lt = new Array(Qe > 1 ? Qe - 1 : 0), _t = 1; _t < Qe; _t++)
            lt[_t - 1] = arguments[_t];
          ee("error", oe, lt);
        }
      }
      function ee(oe, Qe, lt) {
        {
          var _t = K.ReactDebugCurrentFrame, lr = _t.getStackAddendum();
          lr !== "" && (Qe += "%s", lt = lt.concat([lr]));
          var nr = lt.map(function(Ht) {
            return "" + Ht;
          });
          nr.unshift("Warning: " + Qe), Function.prototype.apply.call(console[oe], console, nr);
        }
      }
      var he = !1;
      function _e(oe) {
        return !!(typeof oe == "string" || typeof oe == "function" || oe === e.Fragment || oe === s || oe === C || oe === o || oe === h || oe === g || oe === M || he || typeof oe == "object" && oe !== null && (oe.$$typeof === b || oe.$$typeof === S || oe.$$typeof === l || oe.$$typeof === c || oe.$$typeof === f || oe.$$typeof === w || oe.$$typeof === p || oe[0] === v));
      }
      function Te(oe, Qe, lt) {
        var _t = Qe.displayName || Qe.name || "";
        return oe.displayName || (_t !== "" ? lt + "(" + _t + ")" : lt);
      }
      function fe(oe) {
        return oe.displayName || "Context";
      }
      function Oe(oe) {
        if (oe == null)
          return null;
        if (typeof oe.tag == "number" && Z("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof oe == "function")
          return oe.displayName || oe.name || null;
        if (typeof oe == "string")
          return oe;
        switch (oe) {
          case e.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case h:
            return "Suspense";
          case g:
            return "SuspenseList";
        }
        if (typeof oe == "object")
          switch (oe.$$typeof) {
            case c:
              var Qe = oe;
              return fe(Qe) + ".Consumer";
            case l:
              var lt = oe;
              return fe(lt._context) + ".Provider";
            case f:
              return Te(oe, oe.render, "ForwardRef");
            case S:
              return Oe(oe.type);
            case p:
              return Oe(oe._render);
            case b: {
              var _t = oe, lr = _t._payload, nr = _t._init;
              try {
                return Oe(nr(lr));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var ye = 0, de, ce, Fe, le, J, re, be;
      function Me() {
      }
      Me.__reactDisabledLog = !0;
      function Ae() {
        {
          if (ye === 0) {
            de = console.log, ce = console.info, Fe = console.warn, le = console.error, J = console.group, re = console.groupCollapsed, be = console.groupEnd;
            var oe = {
              configurable: !0,
              enumerable: !0,
              value: Me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: oe,
              log: oe,
              warn: oe,
              error: oe,
              group: oe,
              groupCollapsed: oe,
              groupEnd: oe
            });
          }
          ye++;
        }
      }
      function Re() {
        {
          if (ye--, ye === 0) {
            var oe = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, oe, {
                value: de
              }),
              info: r({}, oe, {
                value: ce
              }),
              warn: r({}, oe, {
                value: Fe
              }),
              error: r({}, oe, {
                value: le
              }),
              group: r({}, oe, {
                value: J
              }),
              groupCollapsed: r({}, oe, {
                value: re
              }),
              groupEnd: r({}, oe, {
                value: be
              })
            });
          }
          ye < 0 && Z("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ee = K.ReactCurrentDispatcher, Ce;
      function X(oe, Qe, lt) {
        {
          if (Ce === void 0)
            try {
              throw Error();
            } catch (lr) {
              var _t = lr.stack.trim().match(/\n( *(at )?)/);
              Ce = _t && _t[1] || "";
            }
          return `
` + Ce + oe;
        }
      }
      var ie = !1, Ie;
      {
        var xe = typeof WeakMap == "function" ? WeakMap : Map;
        Ie = new xe();
      }
      function Pe(oe, Qe) {
        if (!oe || ie)
          return "";
        {
          var lt = Ie.get(oe);
          if (lt !== void 0)
            return lt;
        }
        var _t;
        ie = !0;
        var lr = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var nr;
        nr = Ee.current, Ee.current = null, Ae();
        try {
          if (Qe) {
            var Ht = function() {
              throw Error();
            };
            if (Object.defineProperty(Ht.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Ht, []);
              } catch (Tt) {
                _t = Tt;
              }
              Reflect.construct(oe, [], Ht);
            } else {
              try {
                Ht.call();
              } catch (Tt) {
                _t = Tt;
              }
              oe.call(Ht.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Tt) {
              _t = Tt;
            }
            oe();
          }
        } catch (Tt) {
          if (Tt && _t && typeof Tt.stack == "string") {
            for (var Ft = Tt.stack.split(`
`), Er = _t.stack.split(`
`), Rr = Ft.length - 1, Cr = Er.length - 1; Rr >= 1 && Cr >= 0 && Ft[Rr] !== Er[Cr]; )
              Cr--;
            for (; Rr >= 1 && Cr >= 0; Rr--, Cr--)
              if (Ft[Rr] !== Er[Cr]) {
                if (Rr !== 1 || Cr !== 1)
                  do
                    if (Rr--, Cr--, Cr < 0 || Ft[Rr] !== Er[Cr]) {
                      var fn = `
` + Ft[Rr].replace(" at new ", " at ");
                      return typeof oe == "function" && Ie.set(oe, fn), fn;
                    }
                  while (Rr >= 1 && Cr >= 0);
                break;
              }
          }
        } finally {
          ie = !1, Ee.current = nr, Re(), Error.prepareStackTrace = lr;
        }
        var nn = oe ? oe.displayName || oe.name : "", qr = nn ? X(nn) : "";
        return typeof oe == "function" && Ie.set(oe, qr), qr;
      }
      function ae(oe, Qe, lt) {
        return Pe(oe, !1);
      }
      function rt(oe) {
        var Qe = oe.prototype;
        return !!(Qe && Qe.isReactComponent);
      }
      function Ze(oe, Qe, lt) {
        if (oe == null)
          return "";
        if (typeof oe == "function")
          return Pe(oe, rt(oe));
        if (typeof oe == "string")
          return X(oe);
        switch (oe) {
          case h:
            return X("Suspense");
          case g:
            return X("SuspenseList");
        }
        if (typeof oe == "object")
          switch (oe.$$typeof) {
            case f:
              return ae(oe.render);
            case S:
              return Ze(oe.type, Qe, lt);
            case p:
              return ae(oe._render);
            case b: {
              var _t = oe, lr = _t._payload, nr = _t._init;
              try {
                return Ze(nr(lr), Qe, lt);
              } catch {
              }
            }
          }
        return "";
      }
      var ht = {}, mt = K.ReactDebugCurrentFrame;
      function At(oe) {
        if (oe) {
          var Qe = oe._owner, lt = Ze(oe.type, oe._source, Qe ? Qe.type : null);
          mt.setExtraStackFrame(lt);
        } else
          mt.setExtraStackFrame(null);
      }
      function Bt(oe, Qe, lt, _t, lr) {
        {
          var nr = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Ht in oe)
            if (nr(oe, Ht)) {
              var Ft = void 0;
              try {
                if (typeof oe[Ht] != "function") {
                  var Er = Error((_t || "React class") + ": " + lt + " type `" + Ht + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof oe[Ht] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Er.name = "Invariant Violation", Er;
                }
                Ft = oe[Ht](Qe, Ht, _t, lt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Rr) {
                Ft = Rr;
              }
              Ft && !(Ft instanceof Error) && (At(lr), Z("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _t || "React class", lt, Ht, typeof Ft), At(null)), Ft instanceof Error && !(Ft.message in ht) && (ht[Ft.message] = !0, At(lr), Z("Failed %s type: %s", lt, Ft.message), At(null));
            }
        }
      }
      var Gt = K.ReactCurrentOwner, It = Object.prototype.hasOwnProperty, sr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, et, at;
      function Qt(oe) {
        if (It.call(oe, "ref")) {
          var Qe = Object.getOwnPropertyDescriptor(oe, "ref").get;
          if (Qe && Qe.isReactWarning)
            return !1;
        }
        return oe.ref !== void 0;
      }
      function pr(oe) {
        if (It.call(oe, "key")) {
          var Qe = Object.getOwnPropertyDescriptor(oe, "key").get;
          if (Qe && Qe.isReactWarning)
            return !1;
        }
        return oe.key !== void 0;
      }
      function wr(oe, Qe) {
        typeof oe.ref == "string" && Gt.current;
      }
      function gt(oe, Qe) {
        {
          var lt = function() {
            et || (et = !0, Z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Qe));
          };
          lt.isReactWarning = !0, Object.defineProperty(oe, "key", {
            get: lt,
            configurable: !0
          });
        }
      }
      function hr(oe, Qe) {
        {
          var lt = function() {
            at || (at = !0, Z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Qe));
          };
          lt.isReactWarning = !0, Object.defineProperty(oe, "ref", {
            get: lt,
            configurable: !0
          });
        }
      }
      var Nn = function(oe, Qe, lt, _t, lr, nr, Ht) {
        var Ft = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: oe,
          key: Qe,
          ref: lt,
          props: Ht,
          // Record the component responsible for creating this element.
          _owner: nr
        };
        return Ft._store = {}, Object.defineProperty(Ft._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ft, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _t
        }), Object.defineProperty(Ft, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: lr
        }), Object.freeze && (Object.freeze(Ft.props), Object.freeze(Ft)), Ft;
      };
      function hn(oe, Qe, lt, _t, lr) {
        {
          var nr, Ht = {}, Ft = null, Er = null;
          lt !== void 0 && (Ft = "" + lt), pr(Qe) && (Ft = "" + Qe.key), Qt(Qe) && (Er = Qe.ref, wr(Qe, lr));
          for (nr in Qe)
            It.call(Qe, nr) && !sr.hasOwnProperty(nr) && (Ht[nr] = Qe[nr]);
          if (oe && oe.defaultProps) {
            var Rr = oe.defaultProps;
            for (nr in Rr)
              Ht[nr] === void 0 && (Ht[nr] = Rr[nr]);
          }
          if (Ft || Er) {
            var Cr = typeof oe == "function" ? oe.displayName || oe.name || "Unknown" : oe;
            Ft && gt(Ht, Cr), Er && hr(Ht, Cr);
          }
          return Nn(oe, Ft, Er, lr, _t, Gt.current, Ht);
        }
      }
      var cn = K.ReactCurrentOwner, gn = K.ReactDebugCurrentFrame;
      function tn(oe) {
        if (oe) {
          var Qe = oe._owner, lt = Ze(oe.type, oe._source, Qe ? Qe.type : null);
          gn.setExtraStackFrame(lt);
        } else
          gn.setExtraStackFrame(null);
      }
      var rr;
      rr = !1;
      function Tn(oe) {
        return typeof oe == "object" && oe !== null && oe.$$typeof === n;
      }
      function xr() {
        {
          if (cn.current) {
            var oe = Oe(cn.current.type);
            if (oe)
              return `

Check the render method of \`` + oe + "`.";
          }
          return "";
        }
      }
      function Xi(oe) {
        return "";
      }
      var Ti = {};
      function Gr(oe) {
        {
          var Qe = xr();
          if (!Qe) {
            var lt = typeof oe == "string" ? oe : oe.displayName || oe.name;
            lt && (Qe = `

Check the top-level render call using <` + lt + ">.");
          }
          return Qe;
        }
      }
      function jn(oe, Qe) {
        {
          if (!oe._store || oe._store.validated || oe.key != null)
            return;
          oe._store.validated = !0;
          var lt = Gr(Qe);
          if (Ti[lt])
            return;
          Ti[lt] = !0;
          var _t = "";
          oe && oe._owner && oe._owner !== cn.current && (_t = " It was passed a child from " + Oe(oe._owner.type) + "."), tn(oe), Z('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', lt, _t), tn(null);
        }
      }
      function vn(oe, Qe) {
        {
          if (typeof oe != "object")
            return;
          if (Array.isArray(oe))
            for (var lt = 0; lt < oe.length; lt++) {
              var _t = oe[lt];
              Tn(_t) && jn(_t, Qe);
            }
          else if (Tn(oe))
            oe._store && (oe._store.validated = !0);
          else if (oe) {
            var lr = B(oe);
            if (typeof lr == "function" && lr !== oe.entries)
              for (var nr = lr.call(oe), Ht; !(Ht = nr.next()).done; )
                Tn(Ht.value) && jn(Ht.value, Qe);
          }
        }
      }
      function Ji(oe) {
        {
          var Qe = oe.type;
          if (Qe == null || typeof Qe == "string")
            return;
          var lt;
          if (typeof Qe == "function")
            lt = Qe.propTypes;
          else if (typeof Qe == "object" && (Qe.$$typeof === f || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          Qe.$$typeof === S))
            lt = Qe.propTypes;
          else
            return;
          if (lt) {
            var _t = Oe(Qe);
            Bt(lt, oe.props, "prop", _t, oe);
          } else if (Qe.PropTypes !== void 0 && !rr) {
            rr = !0;
            var lr = Oe(Qe);
            Z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", lr || "Unknown");
          }
          typeof Qe.getDefaultProps == "function" && !Qe.getDefaultProps.isReactClassApproved && Z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function di(oe) {
        {
          for (var Qe = Object.keys(oe.props), lt = 0; lt < Qe.length; lt++) {
            var _t = Qe[lt];
            if (_t !== "children" && _t !== "key") {
              tn(oe), Z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _t), tn(null);
              break;
            }
          }
          oe.ref !== null && (tn(oe), Z("Invalid attribute `ref` supplied to `React.Fragment`."), tn(null));
        }
      }
      function dn(oe, Qe, lt, _t, lr, nr) {
        {
          var Ht = _e(oe);
          if (!Ht) {
            var Ft = "";
            (oe === void 0 || typeof oe == "object" && oe !== null && Object.keys(oe).length === 0) && (Ft += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Er = Xi();
            Er ? Ft += Er : Ft += xr();
            var Rr;
            oe === null ? Rr = "null" : Array.isArray(oe) ? Rr = "array" : oe !== void 0 && oe.$$typeof === n ? (Rr = "<" + (Oe(oe.type) || "Unknown") + " />", Ft = " Did you accidentally export a JSX literal instead of a component?") : Rr = typeof oe, Z("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rr, Ft);
          }
          var Cr = hn(oe, Qe, lt, lr, nr);
          if (Cr == null)
            return Cr;
          if (Ht) {
            var fn = Qe.children;
            if (fn !== void 0)
              if (_t)
                if (Array.isArray(fn)) {
                  for (var nn = 0; nn < fn.length; nn++)
                    vn(fn[nn], oe);
                  Object.freeze && Object.freeze(fn);
                } else
                  Z("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                vn(fn, oe);
          }
          return oe === e.Fragment ? di(Cr) : Ji(Cr), Cr;
        }
      }
      function fi(oe, Qe, lt) {
        return dn(oe, Qe, lt, !0);
      }
      function Oi(oe, Qe, lt) {
        return dn(oe, Qe, lt, !1);
      }
      var rn = Oi, vo = fi;
      e.jsx = rn, e.jsxs = vo;
    }();
  }(Ch)), Ch;
}
var Y0;
function Ci() {
  return Y0 || (Y0 = 1, process.env.NODE_ENV === "production" ? Gd.exports = dj() : Gd.exports = fj()), Gd.exports;
}
var y = Ci();
const pj = (e) => {
  const t = e.trim();
  return !t.startsWith("http://") && !t.startsWith("https://") ? `https://${e}` : t;
}, hj = (e, t) => e.href && e.href.startsWith("http") ? e : { ...e, href: `${t}/${e.href}` };
var jE = /* @__PURE__ */ ((e) => (e[e.xxs = 200] = "xxs", e[e.xs = 400] = "xs", e[e.sm = 600] = "sm", e[e.md = 800] = "md", e[e.lg = 1200] = "lg", e[e.xl = 1600] = "xl", e[e.xxl = 2400] = "xxl", e))(jE || {});
const gj = (e, t, r) => t && r && (e > t || e > r) ? Object.values(jE).filter(Number).filter(
  (i) => i <= t || i <= r
).pop() : e, vj = (e, t, r, n = !1, i, o) => {
  const s = gj(t, i, o), l = e.find((c) => c.size === s && c.square === n) || null;
  return l && hj(l, r);
}, vJ = (e) => typeof e != "number" ? 200 : e > 6 ? 2400 : e >= 6 ? 1600 : e >= 5 ? 800 : e >= 3 ? 600 : e >= 2 ? 400 : 200, mJ = (e, t, r = 800) => {
  let n = null;
  if (e.previews) {
    const i = e.pixelWidth ? parseInt(e.pixelWidth, 10) : void 0, o = e.pixelHeight ? parseInt(e.pixelHeight, 10) : void 0, s = vj(
      e.previews,
      r,
      t,
      !1,
      i,
      o
    );
    n = s && s.href || null;
  }
  return n;
}, mj = (e) => encodeURIComponent(e).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A").replace(/%20/g, "+").replace(/\./g, "%2E").replace(/%/g, "."), yJ = (e) => `https://one.img.pmdstatic.net/original/${mj(
  e
)}/transformation.jpg`;
function sv(e) {
  this.message = e;
}
sv.prototype = new Error(), sv.prototype.name = "InvalidCharacterError";
var K0 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new sv("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, i = 0, o = 0, s = ""; n = t.charAt(o++); ~n && (r = i % 4 ? 64 * r + n : n, i++ % 4) ? s += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return s;
};
function yj(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(K0(r).replace(/(.)/g, function(n, i) {
        var o = i.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      }));
    }(t);
  } catch {
    return K0(t);
  }
}
function xf(e) {
  this.message = e;
}
function qd(e, t) {
  if (typeof e != "string") throw new xf("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(yj(e.split(".")[r]));
  } catch (n) {
    throw new xf("Invalid token specified: " + n.message);
  }
}
xf.prototype = new Error(), xf.prototype.name = "InvalidTokenError";
const en = {
  get(e) {
    try {
      const t = window.localStorage.getItem(e);
      if (t)
        return JSON.parse(t);
    } catch (t) {
      throw console.error(t), t;
    }
  },
  set(e, t) {
    try {
      window.localStorage.setItem(e, JSON.stringify(t));
    } catch (r) {
      if (console.error(r), !(r instanceof DOMException))
        throw r;
    }
  },
  remove(e) {
    try {
      window.localStorage.removeItem(e);
    } catch (t) {
      console.error(t);
    }
  },
  clear() {
    try {
      window.localStorage.clear();
    } catch (e) {
      console.error(e);
    }
  }
}, Th = "jwt", Oh = "mainJwt";
class bJ {
  constructor(t) {
    cr(this, "authBaseUrl");
    cr(this, "user", null);
    cr(this, "getJwt", async () => {
      const t = await this._renewJwtIfExpired(this._getJwt());
      return this._setJwt(t), t;
    });
    cr(this, "getMainJwt", async () => {
      const t = await this._renewJwtIfExpired(this._getMainJwt());
      return this._setMainJwt(t), t;
    });
    cr(this, "isAuthenticated", () => !!this._getJwt());
    cr(this, "isMainAuthenticated", () => !!this._getMainJwt());
    cr(this, "getMainUser", () => this.isMainAuthenticated() ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      new Sh(qd(this._getMainJwt()))
    ) : null);
    cr(this, "isSuperAdmin", () => {
      var t, r;
      return !!((t = this.getMainUser()) != null && t.isSuperAdmin() || (r = this.user) != null && r.isSuperAdmin());
    });
    cr(this, "login", async (t) => {
      const n = {
        headers: new Headers({
          Authorization: `Bearer ${t}`
        }),
        mode: "cors",
        cache: "default"
      }, i = await fetch(`${this.authBaseUrl}/login`, n), { id_token: o } = await i.json();
      return this._setJwt(o), o;
    });
    cr(this, "impersonate", async (t) => {
      const r = await this.getMainJwt() || await this.getJwt();
      if (!r)
        return;
      const i = await (await fetch(
        `${this.authBaseUrl}/impersonification/${t}`,
        { headers: { Authorization: `Bearer ${r}` } }
      )).json();
      this._setMainJwt(r), this._setJwt(i.id_token), location.reload();
    });
    cr(this, "logout", () => {
      this._setMainJwt(null), this._setJwt(null), location.reload();
    });
    cr(this, "backToMainUser", () => {
      const t = this._getMainJwt();
      t && (this._setJwt(t), this._setMainJwt(null), location.reload());
    });
    this.authBaseUrl = t, this.isAuthenticated() && (this.user = new Sh(qd(this._getJwt())));
  }
  _getJwt() {
    return en.get(Th);
  }
  _setJwt(t) {
    t ? (en.set(Th, t), this.user = new Sh(qd(this._getJwt()))) : (en.remove(Th), this.user = null);
  }
  _getMainJwt() {
    return en.get(Oh);
  }
  _setMainJwt(t) {
    t ? en.set(Oh, t) : en.remove(Oh);
  }
  async _renewJwtIfExpired(t) {
    if (!t)
      return null;
    if (qd(t).exp * 1e3 < Date.now() + 1e4) {
      const i = await (await fetch(`${this.authBaseUrl}/login/renew`, {
        headers: { Authorization: `Bearer ${t}` }
      })).json(), o = i == null ? void 0 : i.id_token;
      return o || (this.logout(), null);
    }
    return t;
  }
}
const wJ = (e) => !!(e % 2), kE = "fetch-cache", bj = () => {
  window.caches && window.caches.delete(kE);
};
bj();
async function xJ(e, t) {
  const r = await caches.open(kE), n = await r.match(e);
  if (n) return n;
  const i = await fetch(e, t);
  if (!i.ok)
    throw new Error(`Error ${i.status} (${i.statusText})`);
  return r.put(e, i.clone()), i;
}
async function _J(e, t) {
  const r = await window.fetch(e, t);
  if (!r.ok) throw new Error(`Error ${r.status} (${r.statusText})`);
  return r.json();
}
const Sm = (e, t) => new Promise((r, n) => {
  if (!e) {
    n();
    return;
  }
  let i;
  t && (i = setTimeout(() => {
    n(
      new Error(
        `L'image n'a pas chargé dans les temps (${t / 1e3}s)`
      )
    );
  }, t));
  const o = new Image();
  o.onload = () => {
    clearTimeout(i), r(o);
  }, o.onerror = (s) => {
    clearTimeout(i), n(
      new Error(
        typeof s == "string" ? s : "Erreur lors du chargement de l'image"
      )
    );
  }, o.src = e;
}), SJ = async (e, t) => {
  const r = await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  });
  if (!r.ok) throw new Error(`Error ${r.status} (${r.statusText})`);
  return r;
}, LE = (e) => e.type.includes("image"), EJ = (e) => e.type.includes("video"), CJ = (e, t) => e.size > t * 1024 * 1024, TJ = async (e, t, r) => {
  if (!LE(e))
    throw new Error("imageHasMinDimensions failed (file is not an image)");
  const n = await Sm(window.URL.createObjectURL(e));
  return n.width >= t && n.height >= r;
}, Vd = {
  errors: [],
  errorMessages: {},
  hasError: !1,
  isTouched: !1
}, wj = {
  credit: Vd,
  format: Vd,
  link: Vd,
  source: Vd
}, xj = "Le format du champ %{fieldName}% est invalide", _j = "Les formats des champs %{fieldName}% sont invalides", Sj = "Le champ %{fieldName}% est requis", Ej = "Les champs %{fieldName}% sont requis", _f = (e, t) => {
  const r = /%{([^&\s]*)}%/, n = r.exec(e);
  if (n != null && n.length) {
    if (!t)
      return e.replace(r, "").replace(/\s+/g, " ");
  } else return e;
  return e.split(r).map(
    (i) => i === n[1] ? t || "" : i
  ).filter(Boolean);
}, OJ = (e) => e.charAt(0).toUpperCase() + e.slice(1), RJ = (e) => e != null && e.length ? e.replace(/s\b/gi, "") : e;
function IJ(e, t) {
  if (!t || !e)
    return;
  const r = t.map(({ label: s, validate: l }) => ({ ...l(e), label: s })).filter(({ isValid: s }) => !s);
  if (!(r != null && r.length))
    return;
  const n = /* @__PURE__ */ y.jsx("b", { children: r.map(({ label: s }) => s).join(", ") }, "pattern"), i = r.length > 1 || r.length === 1 && r[0].count > 1, o = _f(i ? _j : xj, n);
  return /* @__PURE__ */ y.jsx("span", { children: o });
}
function DJ(e, t) {
  if (!t || !e)
    return;
  const r = t.filter(({ validate: s }) => !s(e)).map(({ label: s }) => s);
  if (!(r != null && r.length))
    return;
  const n = /* @__PURE__ */ y.jsx("b", { children: r.join(", ") }, "required"), i = r.length > 1, o = _f(i ? Ej : Sj, n);
  return /* @__PURE__ */ y.jsx("span", { children: o });
}
const Sf = (e, t) => Number(e.spacing(t).slice(0, -2)), Cj = (...e) => {
  const t = e.reduce(
    (n, i) => n + (i ? i.trim().split(/[\n\r\s]+/).filter((o) => !!o).length : 0),
    0
  ), r = e.reduce(
    (n, i) => n + (i ? i.length : 0),
    0
  );
  return `${t} mots - ${r} caractères`;
};
function Ll(e) {
  return e != null;
}
const Tj = (e, t) => Object.entries(e).reduce(
  (r, [n, i]) => n === t ? r.concat(i) : typeof i == "object" ? r.concat(Tj(i, t)) : r,
  []
), PJ = (e, t) => JSON.stringify(e) !== JSON.stringify(t), Po = (e, t) => `${e || ""}${t && t > 1 ? "s" : ""}`, MJ = (e, t, r) => new Promise((n, i) => {
  if (!LE(e)) {
    i(new Error("resizeImage failed (file is not an image)"));
    return;
  }
  const o = new FileReader();
  o.readAsDataURL(e), o.onload = async (s) => {
    var S;
    if (typeof ((S = s.target) == null ? void 0 : S.result) != "string") {
      i(new Error("resizeImage failed (result is not a string)"));
      return;
    }
    const l = await Sm(s.target.result);
    let { width: c, height: f } = l;
    if (c <= t && f <= r) {
      n(e);
      return;
    }
    c > f ? (f = f * (t / c), c = t) : (c = c * (r / f), f = r);
    const h = document.createElement("canvas");
    h.width = c, h.height = f;
    const g = h.getContext("2d");
    if (!g) {
      i(new Error("resizeImage failed (context is null)"));
      return;
    }
    g.drawImage(l, 0, 0, c, f), h.toBlob((b) => {
      if (!b) {
        i(new Error("resizeImage failed (blob is null)"));
        return;
      }
      n(new File([b], e.name, { type: e.type }));
    }, e.type);
  };
}), Oj = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/, Rj = (e) => new RegExp(Oj, "i").test(e), AJ = () => {
  const {
    mixins: { toolbar: e },
    breakpoints: t
  } = zo(), r = t.up("sm"), n = `${t.up(
    "xs"
  )} and (orientation: landscape)`, i = sa(r), o = sa(n);
  return kt(() => {
    var s;
    return i || o ? ((s = e[i ? r : n]) == null ? void 0 : s.minHeight) || 52 : e == null ? void 0 : e.minHeight;
  }, [
    i,
    o,
    e,
    r,
    n
  ]);
};
function Wc(e, t = 500) {
  const [r, n] = Xe(e);
  return pt(() => {
    const i = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), r;
}
const Ij = () => {
  const e = bt(!0);
  return e.current ? (e.current = !1, !0) : !1;
}, op = (e) => {
  pt(e, []);
}, zE = () => {
  const e = bt(!1);
  return pt(() => (e.current = !0, () => {
    e.current = !1;
  }), []), Kt(() => e.current, []);
}, NJ = (e) => {
  const [t, r] = Xe(!1), n = kt(
    () => new IntersectionObserver(
      ([i]) => r(i.isIntersecting)
    ),
    []
  );
  return pt(() => {
    if (e != null && e.current)
      return n.observe(e.current), () => {
        n.disconnect();
      };
  }, [n, e]), t;
}, jJ = (e) => {
  const t = bt();
  return pt(() => {
    t.current = e;
  }, [e]), t.current;
};
function BE(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (r = BE(e[t])) && (n && (n += " "), n += r);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function nt() {
  for (var e = 0, t, r, n = ""; e < arguments.length; )
    (t = arguments[e++]) && (r = BE(t)) && (n && (n += " "), n += r);
  return n;
}
const Fn = 10, Dj = Rt((e) => ({
  popper: ({ zIndex: t }) => ({
    zIndex: t || e.zIndex.tooltip,
    width: 300
  }),
  card: {
    margin: e.spacing(2, 0),
    overflow: "visible",
    position: "relative",
    "&:before": {
      content: '""',
      display: "block",
      height: 0,
      position: "absolute",
      width: 0
    }
  },
  cardTop: ({ tipPosition: t }) => ({
    "&:before": {
      borderTop: `${Fn}px solid ${e.palette.common.white}`,
      borderLeft: `${Fn}px solid transparent`,
      borderRight: `${Fn}px solid transparent`,
      left: t || "50%",
      bottom: -Fn,
      transform: "translateX(-50%)"
    }
  }),
  cardRight: ({ tipPosition: t }) => ({
    "&:before": {
      borderBottom: `${Fn}px solid transparent`,
      borderTop: `${Fn}px solid transparent`,
      borderRight: `${Fn}px solid ${e.palette.common.white}`,
      left: -Fn,
      top: t || "50%",
      transform: "translateY(-50%)"
    }
  }),
  cardBottom: ({ tipPosition: t }) => ({
    "&:before": {
      borderBottom: `${Fn}px solid ${e.palette.common.white}`,
      borderRight: `${Fn}px solid transparent`,
      borderLeft: `${Fn}px solid transparent`,
      left: t || "50%",
      top: -Fn,
      transform: "translateX(-50%)"
    }
  }),
  cardLeft: ({ tipPosition: t }) => ({
    "&:before": {
      borderBottom: `${Fn}px solid transparent`,
      borderTop: `${Fn}px solid transparent`,
      borderLeft: `${Fn}px solid ${e.palette.common.white}`,
      right: -Fn,
      top: t || "50%",
      transform: "translateY(-50%)"
    }
  }),
  cardContent: {
    padding: `${e.spacing(2.5, 3, 2.25, 2)} !important`
  },
  closeButton: {
    color: e.palette.grey[500],
    position: "absolute",
    right: e.spacing(1.75),
    top: e.spacing(1.75)
  }
})), Pj = ({
  content: e,
  hasClickAwayListener: t,
  hasCross: r = !0,
  onCloseClick: n,
  tipPosition: i,
  zIndex: o,
  ...s
}) => {
  const l = Dj({ tipPosition: i, zIndex: o });
  return /* @__PURE__ */ y.jsx(Jf, { className: l.popper, transition: !0, ...s, children: ({ TransitionProps: c, placement: f }) => /* @__PURE__ */ y.jsx(
    dm,
    {
      ...t && { mouseEvent: "onMouseDown" },
      onClickAway: (h) => {
        (s == null ? void 0 : s.anchorEl).contains(h.target) || n();
      },
      children: /* @__PURE__ */ y.jsx(
        Zf,
        {
          ...c,
          style: {
            transformOrigin: f === "bottom" ? "center top" : "center bottom"
          },
          children: /* @__PURE__ */ y.jsx(
            Bo,
            {
              className: nt(
                l.card,
                f.includes("top") && l.cardTop,
                f.includes("right") && l.cardRight,
                f.includes("bottom") && l.cardBottom,
                f.includes("left") && l.cardLeft
              ),
              raised: !0,
              children: /* @__PURE__ */ y.jsxs(pE, { className: l.cardContent, children: [
                r && /* @__PURE__ */ y.jsx(
                  fr,
                  {
                    className: l.closeButton,
                    color: "primary",
                    onClick: () => {
                      n();
                    },
                    size: "small",
                    children: /* @__PURE__ */ y.jsx(ql, { fontSize: "small" })
                  }
                ),
                e
              ] })
            }
          )
        }
      )
    }
  ) });
}, Mj = 150, FE = Ac(void 0), kJ = ({ children: e }) => {
  const [t, r] = Xe(!1), [n, i] = Xe(null), o = zE(), s = Kt(
    (v) => {
      r(!1), v && o() && i(null);
    },
    [o]
  ), l = Kt(
    (v) => {
      s(), i(v), setTimeout(() => {
        r(!0);
      }, Mj);
    },
    [s]
  ), {
    anchorRef: c,
    content: f,
    hasClickAwayListener: h,
    hasCross: g,
    tipPosition: S,
    PopperProps: b,
    zIndex: p
  } = n || {};
  return /* @__PURE__ */ y.jsxs(FE.Provider, { value: { closeAdvice: s, openAdvice: l }, children: [
    e,
    /* @__PURE__ */ y.jsx(
      Pj,
      {
        anchorEl: c == null ? void 0 : c.current,
        content: f,
        hasClickAwayListener: h,
        hasCross: g,
        onCloseClick: s,
        open: t,
        tipPosition: S,
        zIndex: p,
        ...b
      }
    )
  ] });
}, LJ = () => {
  const e = qi(FE);
  if (!e)
    throw new Error("You need to wrap useMenu inside AdviceProvider");
  const { closeAdvice: t, ...r } = e;
  return pt(
    () => () => {
      t(!0);
    },
    [t]
  ), { closeAdvice: t, ...r };
};
var jt = /* @__PURE__ */ ((e) => (e.Authors = "Authors", e.Card = "Encart", e.Crud = "Crud", e.Diapo = "Diapo", e.Newsletter = "Newsletter", e.Page = "Pages", e.People = "People", e.Photo = "Photos", e.Recipe = "Recipe", e.Story = "Story", e.Video = "Video", e.Web = "Web", e.Dashboard = "Dashboard", e.Orphans = "Pages Indépendantes", e.Tags = "Tags", e))(jt || {});
const X0 = {
  [jt.Authors]: "#f46873",
  [jt.Card]: "#41c6da",
  [jt.Crud]: "#3F51B5",
  [jt.Diapo]: "#3F51B5",
  [jt.Newsletter]: "#FFC107",
  [jt.Page]: "#0097A7",
  [jt.People]: "#607D8A",
  [jt.Photo]: "#232323",
  [jt.Recipe]: "#E91E63",
  [jt.Story]: "#009688",
  [jt.Video]: "#AD1457",
  [jt.Web]: "#F44336",
  [jt.Dashboard]: "#F44336",
  [jt.Orphans]: "#F44336",
  [jt.Tags]: "#333e45"
}, lv = ({
  appName: e,
  white: t,
  ...r
}) => /* @__PURE__ */ y.jsx(kA, { width: "32px", height: "32px", viewBox: "0 0 32 32", ...r, children: /* @__PURE__ */ y.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ y.jsxs("g", { id: "FavIcon_One_Amber", children: [
  /* @__PURE__ */ y.jsx("g", { id: "Oval", children: /* @__PURE__ */ y.jsx("g", { id: "path-1-link", fill: t ? "#FFF" : X0[e], children: /* @__PURE__ */ y.jsx("circle", { id: "path-1", cx: "16", cy: "16", r: "16" }) }) }),
  /* @__PURE__ */ y.jsxs(
    "g",
    {
      id: "Group",
      transform: "translate(7.529412, 6.588235)",
      stroke: t ? X0[e] : "#FFF",
      children: [
        /* @__PURE__ */ y.jsx(
          "polygon",
          {
            id: "Path-2",
            strokeWidth: "1.87076921",
            points: "8.28325506 0.084596064 0 5.08883646 0 14.4018558 8.28390769 19.3312856 16.6555668 14.4265954 16.6555668 5.09040863"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "polygon",
          {
            id: "Rectangle",
            strokeWidth: "0.935384604",
            fillRule: "nonzero",
            points: "7.96518444 11.211911 8.4790673 11.211911 8.4790673 18.5126903 7.96518444 18.5126903"
          }
        )
      ]
    }
  )
] }) }) }), Aj = {
  [jt.Authors]: "https://one-web.prismamedia.com/#/authors/list",
  [jt.Crud]: "https://one-web.prismamedia.com/#/crud",
  [jt.Diapo]: "https://one-web.prismamedia.com/#/slideshow/list",
  [jt.Newsletter]: "https://newsletter.prismamedia.com/",
  [jt.People]: "https://one-people.prismamedia.com/",
  [jt.Photo]: "https://photos.prismamedia.com/",
  [jt.Recipe]: "https://one-recipe.prismamedia.com/",
  [jt.Story]: "https://topic.prismamedia.com/",
  [jt.Video]: "https://one-web.prismamedia.com/#/video/list",
  [jt.Web]: "https://one-web.prismamedia.com/#/article/list"
}, WE = (e, t) => ({ ...Aj, ...t })[e], J0 = (e, t) => ({
  href: WE(e, t),
  label: e,
  icon: /* @__PURE__ */ y.jsx(lv, { appName: e }),
  openBlank: !0
}), Nj = (e, t) => {
  switch (e) {
    case jt.Web:
    case jt.Diapo:
    case jt.Video:
    case jt.Crud:
      return [
        jt.Photo,
        jt.Story,
        jt.Recipe,
        jt.Newsletter,
        jt.People
      ].map((r) => J0(r, t));
    default:
      return [
        jt.Web,
        jt.Photo,
        jt.Story,
        jt.Recipe,
        jt.Diapo,
        jt.Newsletter,
        jt.People
      ].filter((r) => r !== e).map((r) => J0(r, t));
  }
}, jj = [
  {
    label: "Suite One",
    href: "https://sites.google.com/prismamedia.com/suite-one/accueil",
    icon: /* @__PURE__ */ y.jsx(aN, {}),
    openBlank: !0
  },
  {
    label: "Google Analytics",
    href: "https://www.google.com/analytics/",
    icon: /* @__PURE__ */ y.jsx(sN, {}),
    openBlank: !0
  },
  {
    label: "Parse.ly",
    href: "https://dash.parsely.com/",
    icon: /* @__PURE__ */ y.jsx(lN, {}),
    openBlank: !0
  }
], kj = Rt((e) => ({
  drawerMenu: {
    paddingTop: e.spacing(2),
    width: 280,
    minHeight: "100%",
    overflow: "auto"
  },
  title: {
    display: "flex",
    paddingLeft: e.spacing(2),
    marginBottom: e.spacing(2),
    whiteSpace: "nowrap"
  },
  appBarTitle: {
    color: "white",
    padding: e.spacing(0, 2),
    marginBottom: 0
  },
  icon: { marginRight: e.spacing(2), height: "32px", width: "32px" }
})), zJ = ({
  appName: e,
  topSection: t,
  disconnectUser: r,
  overriddenAppUrls: n
}) => {
  const i = kj(), [o, s] = Xe(!1), l = Kt(
    () => s((b) => !b),
    [s]
  ), c = zo(), f = sa(c.breakpoints.up("md")), h = [jt.Web, jt.Diapo, jt.Video].includes(
    e
  ), g = [
    {
      href: WE(jt.Authors, n),
      icon: /* @__PURE__ */ y.jsx(uN, {}),
      label: "Mes auteurs",
      openBlank: !h,
      selected: location.hash === "#/authors/list"
    },
    ...r ? [
      {
        label: "Déconnexion",
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onClick: r,
        icon: /* @__PURE__ */ y.jsx(cN, {})
      }
    ] : []
  ], S = [
    ...t ? [t] : [],
    Nj(e, n),
    jj,
    g
  ];
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      fr,
      {
        "data-testid": "toggle-drawer-button",
        onClick: l,
        title: "Menu",
        size: "large",
        children: /* @__PURE__ */ y.jsx(dN, { style: { color: "#FFF" } })
      }
    ),
    f && /* @__PURE__ */ y.jsx(y.Fragment, { children: /* @__PURE__ */ y.jsxs(
      Lt,
      {
        className: nt(i.title, i.appBarTitle),
        variant: "h6",
        children: [
          /* @__PURE__ */ y.jsx(lv, { appName: e, white: !0, className: i.icon }),
          /* @__PURE__ */ y.jsxs("span", { children: [
            /* @__PURE__ */ y.jsx("b", { children: "One " }),
            e
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ y.jsx(
      ov,
      {
        anchor: "left",
        open: o,
        onClose: () => s(!1),
        children: /* @__PURE__ */ y.jsxs("div", { "data-testid": "drawer-menu", className: i.drawerMenu, children: [
          /* @__PURE__ */ y.jsxs(Lt, { className: i.title, variant: "h5", children: [
            /* @__PURE__ */ y.jsx(lv, { appName: e, className: i.icon }),
            /* @__PURE__ */ y.jsxs("span", { children: [
              /* @__PURE__ */ y.jsx("b", { children: "One " }),
              e
            ] })
          ] }),
          S.map((b, p) => /* @__PURE__ */ y.jsxs("div", { children: [
            /* @__PURE__ */ y.jsx(Nc, { children: b.map(
              ({
                disabled: v,
                href: w,
                label: C,
                icon: M,
                openBlank: L,
                tooltip: W,
                onClick: z,
                selected: B
              }, K) => /* @__PURE__ */ y.jsx(
                LA,
                {
                  title: W,
                  underline: "none",
                  color: "inherit",
                  href: v ? void 0 : w,
                  onClick: z,
                  target: L ? "_blank" : void 0,
                  children: /* @__PURE__ */ y.jsxs(
                    Qf,
                    {
                      button: !0,
                      disabled: v,
                      selected: B,
                      children: [
                        /* @__PURE__ */ y.jsx(Va, { children: M }),
                        /* @__PURE__ */ y.jsx(Ya, { primary: C })
                      ]
                    },
                    `link-${K}`
                  )
                },
                `link-${K}`
              )
            ) }),
            p < S.length - 1 && /* @__PURE__ */ y.jsx(hc, {})
          ] }, `section-${p}`))
        ] })
      }
    )
  ] });
};
var Ou = {}, Rh = { exports: {} }, Z0;
function Vi() {
  return Z0 || (Z0 = 1, function(e) {
    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(Rh)), Rh.exports;
}
var Ih = {};
function es(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function vc() {
  return vc = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vc.apply(this, arguments);
}
function Zu(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function po(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? vc({}, e) : e;
  return Zu(e) && Zu(t) && Object.keys(t).forEach((i) => {
    i !== "__proto__" && (Zu(t[i]) && i in e && Zu(e[i]) ? n[i] = po(e[i], t[i], r) : n[i] = t[i]);
  }), n;
}
var Yd = { exports: {} }, Kd = { exports: {} }, yr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q0;
function Lj() {
  if (Q0) return yr;
  Q0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
  function L(z) {
    if (typeof z == "object" && z !== null) {
      var B = z.$$typeof;
      switch (B) {
        case t:
          switch (z = z.type, z) {
            case c:
            case f:
            case n:
            case o:
            case i:
            case g:
              return z;
            default:
              switch (z = z && z.$$typeof, z) {
                case l:
                case h:
                case p:
                case b:
                case s:
                  return z;
                default:
                  return B;
              }
          }
        case r:
          return B;
      }
    }
  }
  function W(z) {
    return L(z) === f;
  }
  return yr.AsyncMode = c, yr.ConcurrentMode = f, yr.ContextConsumer = l, yr.ContextProvider = s, yr.Element = t, yr.ForwardRef = h, yr.Fragment = n, yr.Lazy = p, yr.Memo = b, yr.Portal = r, yr.Profiler = o, yr.StrictMode = i, yr.Suspense = g, yr.isAsyncMode = function(z) {
    return W(z) || L(z) === c;
  }, yr.isConcurrentMode = W, yr.isContextConsumer = function(z) {
    return L(z) === l;
  }, yr.isContextProvider = function(z) {
    return L(z) === s;
  }, yr.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === t;
  }, yr.isForwardRef = function(z) {
    return L(z) === h;
  }, yr.isFragment = function(z) {
    return L(z) === n;
  }, yr.isLazy = function(z) {
    return L(z) === p;
  }, yr.isMemo = function(z) {
    return L(z) === b;
  }, yr.isPortal = function(z) {
    return L(z) === r;
  }, yr.isProfiler = function(z) {
    return L(z) === o;
  }, yr.isStrictMode = function(z) {
    return L(z) === i;
  }, yr.isSuspense = function(z) {
    return L(z) === g;
  }, yr.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === n || z === f || z === o || z === i || z === g || z === S || typeof z == "object" && z !== null && (z.$$typeof === p || z.$$typeof === b || z.$$typeof === s || z.$$typeof === l || z.$$typeof === h || z.$$typeof === w || z.$$typeof === C || z.$$typeof === M || z.$$typeof === v);
  }, yr.typeOf = L, yr;
}
var br = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ew;
function zj() {
  return ew || (ew = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
    function L(Pe) {
      return typeof Pe == "string" || typeof Pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Pe === n || Pe === f || Pe === o || Pe === i || Pe === g || Pe === S || typeof Pe == "object" && Pe !== null && (Pe.$$typeof === p || Pe.$$typeof === b || Pe.$$typeof === s || Pe.$$typeof === l || Pe.$$typeof === h || Pe.$$typeof === w || Pe.$$typeof === C || Pe.$$typeof === M || Pe.$$typeof === v);
    }
    function W(Pe) {
      if (typeof Pe == "object" && Pe !== null) {
        var ae = Pe.$$typeof;
        switch (ae) {
          case t:
            var rt = Pe.type;
            switch (rt) {
              case c:
              case f:
              case n:
              case o:
              case i:
              case g:
                return rt;
              default:
                var Ze = rt && rt.$$typeof;
                switch (Ze) {
                  case l:
                  case h:
                  case p:
                  case b:
                  case s:
                    return Ze;
                  default:
                    return ae;
                }
            }
          case r:
            return ae;
        }
      }
    }
    var z = c, B = f, K = l, Z = s, ee = t, he = h, _e = n, Te = p, fe = b, Oe = r, ye = o, de = i, ce = g, Fe = !1;
    function le(Pe) {
      return Fe || (Fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(Pe) || W(Pe) === c;
    }
    function J(Pe) {
      return W(Pe) === f;
    }
    function re(Pe) {
      return W(Pe) === l;
    }
    function be(Pe) {
      return W(Pe) === s;
    }
    function Me(Pe) {
      return typeof Pe == "object" && Pe !== null && Pe.$$typeof === t;
    }
    function Ae(Pe) {
      return W(Pe) === h;
    }
    function Re(Pe) {
      return W(Pe) === n;
    }
    function Ee(Pe) {
      return W(Pe) === p;
    }
    function Ce(Pe) {
      return W(Pe) === b;
    }
    function X(Pe) {
      return W(Pe) === r;
    }
    function ie(Pe) {
      return W(Pe) === o;
    }
    function Ie(Pe) {
      return W(Pe) === i;
    }
    function xe(Pe) {
      return W(Pe) === g;
    }
    br.AsyncMode = z, br.ConcurrentMode = B, br.ContextConsumer = K, br.ContextProvider = Z, br.Element = ee, br.ForwardRef = he, br.Fragment = _e, br.Lazy = Te, br.Memo = fe, br.Portal = Oe, br.Profiler = ye, br.StrictMode = de, br.Suspense = ce, br.isAsyncMode = le, br.isConcurrentMode = J, br.isContextConsumer = re, br.isContextProvider = be, br.isElement = Me, br.isForwardRef = Ae, br.isFragment = Re, br.isLazy = Ee, br.isMemo = Ce, br.isPortal = X, br.isProfiler = ie, br.isStrictMode = Ie, br.isSuspense = xe, br.isValidElementType = L, br.typeOf = W;
  }()), br;
}
var tw;
function Yl() {
  return tw || (tw = 1, process.env.NODE_ENV === "production" ? Kd.exports = Lj() : Kd.exports = zj()), Kd.exports;
}
var Dh, rw;
function Em() {
  if (rw) return Dh;
  rw = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Dh = e, Dh;
}
var Ph, nw;
function Bj() {
  if (nw) return Ph;
  nw = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Em(), r = {}, n = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, l, c, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in o)
        if (n(o, h)) {
          var g;
          try {
            if (typeof o[h] != "function") {
              var S = Error(
                (c || "React class") + ": " + l + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[h] + "`."
              );
              throw S.name = "Invariant Violation", S;
            }
            g = o[h](s, h, c, l, null, t);
          } catch (p) {
            g = p;
          }
          if (g && !(g instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in r)) {
            r[g.message] = !0;
            var b = f ? f() : "";
            e(
              "Failed " + l + " type: " + g.message + (b ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Ph = i, Ph;
}
var Mh, iw;
function Fj() {
  if (iw) return Mh;
  iw = 1;
  var e = Yl(), t = ip(), r = Em(), n = Bj(), i = Function.call.bind(Object.prototype.hasOwnProperty), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Mh = function(l, c) {
    var f = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function g(le) {
      var J = le && (f && le[f] || le[h]);
      if (typeof J == "function")
        return J;
    }
    var S = "<<anonymous>>", b = {
      array: C("array"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: M(),
      arrayOf: L,
      element: W(),
      elementType: z(),
      instanceOf: B,
      node: he(),
      objectOf: Z,
      oneOf: K,
      oneOfType: ee,
      shape: _e,
      exact: Te
    };
    function p(le, J) {
      return le === J ? le !== 0 || 1 / le === 1 / J : le !== le && J !== J;
    }
    function v(le) {
      this.message = le, this.stack = "";
    }
    v.prototype = Error.prototype;
    function w(le) {
      if (process.env.NODE_ENV !== "production")
        var J = {}, re = 0;
      function be(Ae, Re, Ee, Ce, X, ie, Ie) {
        if (Ce = Ce || S, ie = ie || Ee, Ie !== r) {
          if (c) {
            var xe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw xe.name = "Invariant Violation", xe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Pe = Ce + ":" + Ee;
            !J[Pe] && // Avoid spamming the console because they are often not actionable except for lib authors
            re < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ie + "` prop on `" + Ce + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), J[Pe] = !0, re++);
          }
        }
        return Re[Ee] == null ? Ae ? Re[Ee] === null ? new v("The " + X + " `" + ie + "` is marked as required " + ("in `" + Ce + "`, but its value is `null`.")) : new v("The " + X + " `" + ie + "` is marked as required in " + ("`" + Ce + "`, but its value is `undefined`.")) : null : le(Re, Ee, Ce, X, ie);
      }
      var Me = be.bind(null, !1);
      return Me.isRequired = be.bind(null, !0), Me;
    }
    function C(le) {
      function J(re, be, Me, Ae, Re, Ee) {
        var Ce = re[be], X = ye(Ce);
        if (X !== le) {
          var ie = de(Ce);
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + ie + "` supplied to `" + Me + "`, expected ") + ("`" + le + "`."));
        }
        return null;
      }
      return w(J);
    }
    function M() {
      return w(s);
    }
    function L(le) {
      function J(re, be, Me, Ae, Re) {
        if (typeof le != "function")
          return new v("Property `" + Re + "` of component `" + Me + "` has invalid PropType notation inside arrayOf.");
        var Ee = re[be];
        if (!Array.isArray(Ee)) {
          var Ce = ye(Ee);
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + Ce + "` supplied to `" + Me + "`, expected an array."));
        }
        for (var X = 0; X < Ee.length; X++) {
          var ie = le(Ee, X, Me, Ae, Re + "[" + X + "]", r);
          if (ie instanceof Error)
            return ie;
        }
        return null;
      }
      return w(J);
    }
    function W() {
      function le(J, re, be, Me, Ae) {
        var Re = J[re];
        if (!l(Re)) {
          var Ee = ye(Re);
          return new v("Invalid " + Me + " `" + Ae + "` of type " + ("`" + Ee + "` supplied to `" + be + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(le);
    }
    function z() {
      function le(J, re, be, Me, Ae) {
        var Re = J[re];
        if (!e.isValidElementType(Re)) {
          var Ee = ye(Re);
          return new v("Invalid " + Me + " `" + Ae + "` of type " + ("`" + Ee + "` supplied to `" + be + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(le);
    }
    function B(le) {
      function J(re, be, Me, Ae, Re) {
        if (!(re[be] instanceof le)) {
          var Ee = le.name || S, Ce = Fe(re[be]);
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + Ce + "` supplied to `" + Me + "`, expected ") + ("instance of `" + Ee + "`."));
        }
        return null;
      }
      return w(J);
    }
    function K(le) {
      if (!Array.isArray(le))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function J(re, be, Me, Ae, Re) {
        for (var Ee = re[be], Ce = 0; Ce < le.length; Ce++)
          if (p(Ee, le[Ce]))
            return null;
        var X = JSON.stringify(le, function(Ie, xe) {
          var Pe = de(xe);
          return Pe === "symbol" ? String(xe) : xe;
        });
        return new v("Invalid " + Ae + " `" + Re + "` of value `" + String(Ee) + "` " + ("supplied to `" + Me + "`, expected one of " + X + "."));
      }
      return w(J);
    }
    function Z(le) {
      function J(re, be, Me, Ae, Re) {
        if (typeof le != "function")
          return new v("Property `" + Re + "` of component `" + Me + "` has invalid PropType notation inside objectOf.");
        var Ee = re[be], Ce = ye(Ee);
        if (Ce !== "object")
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + Ce + "` supplied to `" + Me + "`, expected an object."));
        for (var X in Ee)
          if (i(Ee, X)) {
            var ie = le(Ee, X, Me, Ae, Re + "." + X, r);
            if (ie instanceof Error)
              return ie;
          }
        return null;
      }
      return w(J);
    }
    function ee(le) {
      if (!Array.isArray(le))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var J = 0; J < le.length; J++) {
        var re = le[J];
        if (typeof re != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(re) + " at index " + J + "."
          ), s;
      }
      function be(Me, Ae, Re, Ee, Ce) {
        for (var X = 0; X < le.length; X++) {
          var ie = le[X];
          if (ie(Me, Ae, Re, Ee, Ce, r) == null)
            return null;
        }
        return new v("Invalid " + Ee + " `" + Ce + "` supplied to " + ("`" + Re + "`."));
      }
      return w(be);
    }
    function he() {
      function le(J, re, be, Me, Ae) {
        return fe(J[re]) ? null : new v("Invalid " + Me + " `" + Ae + "` supplied to " + ("`" + be + "`, expected a ReactNode."));
      }
      return w(le);
    }
    function _e(le) {
      function J(re, be, Me, Ae, Re) {
        var Ee = re[be], Ce = ye(Ee);
        if (Ce !== "object")
          return new v("Invalid " + Ae + " `" + Re + "` of type `" + Ce + "` " + ("supplied to `" + Me + "`, expected `object`."));
        for (var X in le) {
          var ie = le[X];
          if (ie) {
            var Ie = ie(Ee, X, Me, Ae, Re + "." + X, r);
            if (Ie)
              return Ie;
          }
        }
        return null;
      }
      return w(J);
    }
    function Te(le) {
      function J(re, be, Me, Ae, Re) {
        var Ee = re[be], Ce = ye(Ee);
        if (Ce !== "object")
          return new v("Invalid " + Ae + " `" + Re + "` of type `" + Ce + "` " + ("supplied to `" + Me + "`, expected `object`."));
        var X = t({}, re[be], le);
        for (var ie in X) {
          var Ie = le[ie];
          if (!Ie)
            return new v(
              "Invalid " + Ae + " `" + Re + "` key `" + ie + "` supplied to `" + Me + "`.\nBad object: " + JSON.stringify(re[be], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(le), null, "  ")
            );
          var xe = Ie(Ee, ie, Me, Ae, Re + "." + ie, r);
          if (xe)
            return xe;
        }
        return null;
      }
      return w(J);
    }
    function fe(le) {
      switch (typeof le) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !le;
        case "object":
          if (Array.isArray(le))
            return le.every(fe);
          if (le === null || l(le))
            return !0;
          var J = g(le);
          if (J) {
            var re = J.call(le), be;
            if (J !== le.entries) {
              for (; !(be = re.next()).done; )
                if (!fe(be.value))
                  return !1;
            } else
              for (; !(be = re.next()).done; ) {
                var Me = be.value;
                if (Me && !fe(Me[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Oe(le, J) {
      return le === "symbol" ? !0 : J ? J["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && J instanceof Symbol : !1;
    }
    function ye(le) {
      var J = typeof le;
      return Array.isArray(le) ? "array" : le instanceof RegExp ? "object" : Oe(J, le) ? "symbol" : J;
    }
    function de(le) {
      if (typeof le > "u" || le === null)
        return "" + le;
      var J = ye(le);
      if (J === "object") {
        if (le instanceof Date)
          return "date";
        if (le instanceof RegExp)
          return "regexp";
      }
      return J;
    }
    function ce(le) {
      var J = de(le);
      switch (J) {
        case "array":
        case "object":
          return "an " + J;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + J;
        default:
          return J;
      }
    }
    function Fe(le) {
      return !le.constructor || !le.constructor.name ? S : le.constructor.name;
    }
    return b.checkPropTypes = n, b.resetWarningCache = n.resetWarningCache, b.PropTypes = b, b;
  }, Mh;
}
var Ah, ow;
function Wj() {
  if (ow) return Ah;
  ow = 1;
  var e = Em();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Ah = function() {
    function n(s, l, c, f, h, g) {
      if (g !== e) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Ah;
}
var aw;
function Hj() {
  if (aw) return Yd.exports;
  if (aw = 1, process.env.NODE_ENV !== "production") {
    var e = Yl(), t = !0;
    Yd.exports = Fj()(e.isElement, t);
  } else
    Yd.exports = Wj()();
  return Yd.exports;
}
var $j = Hj();
const D = /* @__PURE__ */ jr($j);
function Uj(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function HE(e, t, r, n, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = o.type;
  return typeof c == "function" && !Uj(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Kl = es(D.element, HE);
Kl.isRequired = es(D.element.isRequired, HE);
function Gj(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function qj(e, t, r, n, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof o == "function" && !Gj(o) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Cm = es(D.elementType, qj), Vj = "exact-prop: ​";
function Tm(e) {
  return process.env.NODE_ENV === "production" ? e : vc({}, e, {
    [Vj]: (t) => {
      const r = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function mc(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let r = 1; r < arguments.length; r += 1)
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var Xd = { exports: {} }, Tr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sw;
function Yj() {
  if (sw) return Tr;
  sw = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, s = 60110, l = 60112, c = 60113, f = 60120, h = 60115, g = 60116, S = 60121, b = 60122, p = 60117, v = 60129, w = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var C = Symbol.for;
    e = C("react.element"), t = C("react.portal"), r = C("react.fragment"), n = C("react.strict_mode"), i = C("react.profiler"), o = C("react.provider"), s = C("react.context"), l = C("react.forward_ref"), c = C("react.suspense"), f = C("react.suspense_list"), h = C("react.memo"), g = C("react.lazy"), S = C("react.block"), b = C("react.server.block"), p = C("react.fundamental"), v = C("react.debug_trace_mode"), w = C("react.legacy_hidden");
  }
  function M(fe) {
    if (typeof fe == "object" && fe !== null) {
      var Oe = fe.$$typeof;
      switch (Oe) {
        case e:
          switch (fe = fe.type, fe) {
            case r:
            case i:
            case n:
            case c:
            case f:
              return fe;
            default:
              switch (fe = fe && fe.$$typeof, fe) {
                case s:
                case l:
                case g:
                case h:
                case o:
                  return fe;
                default:
                  return Oe;
              }
          }
        case t:
          return Oe;
      }
    }
  }
  var L = o, W = e, z = l, B = r, K = g, Z = h, ee = t, he = i, _e = n, Te = c;
  return Tr.ContextConsumer = s, Tr.ContextProvider = L, Tr.Element = W, Tr.ForwardRef = z, Tr.Fragment = B, Tr.Lazy = K, Tr.Memo = Z, Tr.Portal = ee, Tr.Profiler = he, Tr.StrictMode = _e, Tr.Suspense = Te, Tr.isAsyncMode = function() {
    return !1;
  }, Tr.isConcurrentMode = function() {
    return !1;
  }, Tr.isContextConsumer = function(fe) {
    return M(fe) === s;
  }, Tr.isContextProvider = function(fe) {
    return M(fe) === o;
  }, Tr.isElement = function(fe) {
    return typeof fe == "object" && fe !== null && fe.$$typeof === e;
  }, Tr.isForwardRef = function(fe) {
    return M(fe) === l;
  }, Tr.isFragment = function(fe) {
    return M(fe) === r;
  }, Tr.isLazy = function(fe) {
    return M(fe) === g;
  }, Tr.isMemo = function(fe) {
    return M(fe) === h;
  }, Tr.isPortal = function(fe) {
    return M(fe) === t;
  }, Tr.isProfiler = function(fe) {
    return M(fe) === i;
  }, Tr.isStrictMode = function(fe) {
    return M(fe) === n;
  }, Tr.isSuspense = function(fe) {
    return M(fe) === c;
  }, Tr.isValidElementType = function(fe) {
    return typeof fe == "string" || typeof fe == "function" || fe === r || fe === i || fe === v || fe === n || fe === c || fe === f || fe === w || typeof fe == "object" && fe !== null && (fe.$$typeof === g || fe.$$typeof === h || fe.$$typeof === o || fe.$$typeof === s || fe.$$typeof === l || fe.$$typeof === p || fe.$$typeof === S || fe[0] === b);
  }, Tr.typeOf = M, Tr;
}
var Or = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lw;
function Kj() {
  return lw || (lw = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, s = 60110, l = 60112, c = 60113, f = 60120, h = 60115, g = 60116, S = 60121, b = 60122, p = 60117, v = 60129, w = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var C = Symbol.for;
      e = C("react.element"), t = C("react.portal"), r = C("react.fragment"), n = C("react.strict_mode"), i = C("react.profiler"), o = C("react.provider"), s = C("react.context"), l = C("react.forward_ref"), c = C("react.suspense"), f = C("react.suspense_list"), h = C("react.memo"), g = C("react.lazy"), S = C("react.block"), b = C("react.server.block"), p = C("react.fundamental"), C("react.scope"), C("react.opaque.id"), v = C("react.debug_trace_mode"), C("react.offscreen"), w = C("react.legacy_hidden");
    }
    var M = !1;
    function L(xe) {
      return !!(typeof xe == "string" || typeof xe == "function" || xe === r || xe === i || xe === v || xe === n || xe === c || xe === f || xe === w || M || typeof xe == "object" && xe !== null && (xe.$$typeof === g || xe.$$typeof === h || xe.$$typeof === o || xe.$$typeof === s || xe.$$typeof === l || xe.$$typeof === p || xe.$$typeof === S || xe[0] === b));
    }
    function W(xe) {
      if (typeof xe == "object" && xe !== null) {
        var Pe = xe.$$typeof;
        switch (Pe) {
          case e:
            var ae = xe.type;
            switch (ae) {
              case r:
              case i:
              case n:
              case c:
              case f:
                return ae;
              default:
                var rt = ae && ae.$$typeof;
                switch (rt) {
                  case s:
                  case l:
                  case g:
                  case h:
                  case o:
                    return rt;
                  default:
                    return Pe;
                }
            }
          case t:
            return Pe;
        }
      }
    }
    var z = s, B = o, K = e, Z = l, ee = r, he = g, _e = h, Te = t, fe = i, Oe = n, ye = c, de = !1, ce = !1;
    function Fe(xe) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function le(xe) {
      return ce || (ce = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(xe) {
      return W(xe) === s;
    }
    function re(xe) {
      return W(xe) === o;
    }
    function be(xe) {
      return typeof xe == "object" && xe !== null && xe.$$typeof === e;
    }
    function Me(xe) {
      return W(xe) === l;
    }
    function Ae(xe) {
      return W(xe) === r;
    }
    function Re(xe) {
      return W(xe) === g;
    }
    function Ee(xe) {
      return W(xe) === h;
    }
    function Ce(xe) {
      return W(xe) === t;
    }
    function X(xe) {
      return W(xe) === i;
    }
    function ie(xe) {
      return W(xe) === n;
    }
    function Ie(xe) {
      return W(xe) === c;
    }
    Or.ContextConsumer = z, Or.ContextProvider = B, Or.Element = K, Or.ForwardRef = Z, Or.Fragment = ee, Or.Lazy = he, Or.Memo = _e, Or.Portal = Te, Or.Profiler = fe, Or.StrictMode = Oe, Or.Suspense = ye, Or.isAsyncMode = Fe, Or.isConcurrentMode = le, Or.isContextConsumer = J, Or.isContextProvider = re, Or.isElement = be, Or.isForwardRef = Me, Or.isFragment = Ae, Or.isLazy = Re, Or.isMemo = Ee, Or.isPortal = Ce, Or.isProfiler = X, Or.isStrictMode = ie, Or.isSuspense = Ie, Or.isValidElementType = L, Or.typeOf = W;
  }()), Or;
}
var uw;
function Xj() {
  return uw || (uw = 1, process.env.NODE_ENV === "production" ? Xd.exports = Yj() : Xd.exports = Kj()), Xd.exports;
}
var cw = Xj();
const Jj = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Zj(e) {
  const t = `${e}`.match(Jj);
  return t && t[1] || "";
}
function $E(e, t = "") {
  return e.displayName || e.name || Zj(e) || t;
}
function dw(e, t, r) {
  const n = $E(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function ff(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return $E(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case cw.ForwardRef:
          return dw(e, e.render, "ForwardRef");
        case cw.Memo:
          return dw(e, e.type, "memo");
        default:
          return;
      }
  }
}
function yc(e, t, r, n, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = e[t], s = i || t;
  return o == null ? null : o && o.nodeType !== 1 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const UE = D.oneOfType([D.func, D.object]);
function Wr(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : mc(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function uv(...e) {
  return e.reduce((t, r) => r == null ? t : function(...i) {
    t.apply(this, i), r.apply(this, i);
  }, () => {
  });
}
function GE(e, t = 166) {
  let r;
  function n(...i) {
    const o = () => {
      e.apply(this, i);
    };
    clearTimeout(r), r = setTimeout(o, t);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function Qj(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (r, n, i, o, s) => {
    const l = i || "<<anonymous>>", c = s || n;
    return typeof r[n] < "u" ? new Error(`The ${o} \`${c}\` of \`${l}\` is deprecated. ${t}`) : null;
  };
}
function Om(e, t) {
  return /* @__PURE__ */ Be.isValidElement(e) && t.indexOf(e.type.muiName) !== -1;
}
function No(e) {
  return e && e.ownerDocument || document;
}
function zl(e) {
  return No(e).defaultView || window;
}
function ek(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const r = t ? vc({}, t.propTypes) : null;
  return (i) => (o, s, l, c, f, ...h) => {
    const g = f || s, S = r == null ? void 0 : r[g];
    if (S) {
      const b = S(o, s, l, c, f, ...h);
      if (b)
        return b;
    }
    return typeof o[s] < "u" && !o[i] ? new Error(`The prop \`${g}\` of \`${e}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function bc(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const wc = typeof window < "u" ? Be.useLayoutEffect : Be.useEffect;
function tk(e) {
  const [t, r] = Be.useState(e), n = e || t;
  return Be.useEffect(() => {
    t == null && r(`mui-${Math.round(Math.random() * 1e9)}`);
  }, [t]), n;
}
function rk(e, t, r, n, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${o}\` is not supported. Please remove it.`) : null;
}
function nk({
  controlled: e,
  default: t,
  name: r,
  state: n = "value"
}) {
  const {
    current: i
  } = Be.useRef(e !== void 0), [o, s] = Be.useState(t), l = i ? e : o;
  if (process.env.NODE_ENV !== "production") {
    Be.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${n} state of ${r} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, r, e]);
    const {
      current: f
    } = Be.useRef(t);
    Be.useEffect(() => {
      !i && f !== t && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = Be.useCallback((f) => {
    i || s(f);
  }, []);
  return [l, c];
}
function Ps(e) {
  const t = Be.useRef(e);
  return wc(() => {
    t.current = e;
  }), Be.useCallback((...r) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, t.current)(...r)
  ), []);
}
function Gi(e, t) {
  return Be.useMemo(() => e == null && t == null ? null : (r) => {
    bc(e, r), bc(t, r);
  }, [e, t]);
}
let ap = !0, cv = !1, fw = null;
const ik = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function ok(e) {
  const {
    type: t,
    tagName: r
  } = e;
  return !!(r === "INPUT" && ik[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function ak(e) {
  e.metaKey || e.altKey || e.ctrlKey || (ap = !0);
}
function Nh() {
  ap = !1;
}
function sk() {
  this.visibilityState === "hidden" && cv && (ap = !0);
}
function lk(e) {
  e.addEventListener("keydown", ak, !0), e.addEventListener("mousedown", Nh, !0), e.addEventListener("pointerdown", Nh, !0), e.addEventListener("touchstart", Nh, !0), e.addEventListener("visibilitychange", sk, !0);
}
function uk(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return ap || ok(t);
}
function qE() {
  const e = Be.useCallback((i) => {
    i != null && lk(i.ownerDocument);
  }, []), t = Be.useRef(!1);
  function r() {
    return t.current ? (cv = !0, window.clearTimeout(fw), fw = window.setTimeout(() => {
      cv = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function n(i) {
    return uk(i) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: r,
    ref: e
  };
}
function ck(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
function dk(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function fk(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const pk = Number.isInteger || fk;
function VE(e, t, r, n) {
  const i = e[t];
  if (i == null || !pk(i)) {
    const o = dk(i);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${o}\` supplied to \`${r}\`, expected \`integer\`.`);
  }
  return null;
}
function YE(e, t, ...r) {
  return e[t] === void 0 ? null : VE(e, t, ...r);
}
function dv() {
  return null;
}
YE.isRequired = VE;
dv.isRequired = dv;
const KE = process.env.NODE_ENV === "production" ? dv : YE;
function it() {
  return it = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, it.apply(this, arguments);
}
function Hr(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function na() {
  return na = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, na.apply(this, arguments);
}
function XE(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Kn(e, t, r) {
  const n = {};
  return Object.keys(e).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      n[i] = e[i].reduce((o, s) => (s && (r && r[s] && o.push(r[s]), o.push(t(s))), o), []).join(" ");
    }
  ), n;
}
function Bl(e) {
  return typeof e == "string";
}
const pw = (e) => e, hk = () => {
  let e = pw;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = pw;
    }
  };
}, Rm = hk(), gk = {
  active: "Mui-active",
  checked: "Mui-checked",
  completed: "Mui-completed",
  disabled: "Mui-disabled",
  error: "Mui-error",
  expanded: "Mui-expanded",
  focused: "Mui-focused",
  focusVisible: "Mui-focusVisible",
  required: "Mui-required",
  selected: "Mui-selected"
};
function Mn(e, t) {
  return gk[t] || `${Rm.generate(e)}-${t}`;
}
function An(e, t) {
  const r = {};
  return t.forEach((n) => {
    r[n] = Mn(e, n);
  }), r;
}
function vk(e) {
  return Mn("MuiBackdrop", e);
}
An("MuiBackdrop", ["root", "invisible"]);
const mk = ["classes", "className", "invisible", "component", "components", "componentsProps", "theme"], yk = (e) => {
  const {
    classes: t,
    invisible: r
  } = e;
  return Kn({
    root: ["root", r && "invisible"]
  }, vk, t);
}, JE = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const {
    classes: n,
    className: i,
    invisible: o = !1,
    component: s = "div",
    components: l = {},
    componentsProps: c = {},
    /* eslint-disable react/prop-types */
    theme: f
  } = t, h = XE(t, mk), g = na({}, t, {
    classes: n,
    invisible: o
  }), S = yk(g), b = l.Root || s, p = c.root || {};
  return /* @__PURE__ */ y.jsx(b, na({
    "aria-hidden": !0
  }, p, !Bl(b) && {
    as: s,
    ownerState: na({}, g, p.ownerState),
    theme: f
  }, {
    ref: r
  }, h, {
    className: nt(S.root, p.className, i)
  }));
});
process.env.NODE_ENV !== "production" && (JE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * The components used for each slot inside the Backdrop.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: D.shape({
    Root: D.elementType
  }),
  /**
   * The props used for each slot inside the Backdrop.
   * @default {}
   */
  componentsProps: D.object,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: D.bool
});
function bk(e) {
  return typeof e == "function" ? e() : e;
}
const Ef = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const {
    children: n,
    container: i,
    disablePortal: o = !1
  } = t, [s, l] = Be.useState(null), c = Gi(/* @__PURE__ */ Be.isValidElement(n) ? n.ref : null, r);
  return wc(() => {
    o || l(bk(i) || document.body);
  }, [i, o]), wc(() => {
    if (s && !o)
      return bc(r, s), () => {
        bc(r, null);
      };
  }, [r, s, o]), o ? /* @__PURE__ */ Be.isValidElement(n) ? /* @__PURE__ */ Be.cloneElement(n, {
    ref: c
  }) : n : s && /* @__PURE__ */ ZN.createPortal(n, s);
});
process.env.NODE_ENV !== "production" && (Ef.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: D.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: D.oneOfType([yc, D.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: D.bool
});
process.env.NODE_ENV !== "production" && (Ef.propTypes = Tm(Ef.propTypes));
function wk(e) {
  const t = No(e);
  return t.body === e ? zl(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function sc(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function hw(e) {
  return parseInt(zl(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function gw(e, t, r, n = [], i) {
  const o = [t, r, ...n], s = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(e.children, (l) => {
    o.indexOf(l) === -1 && s.indexOf(l.tagName) === -1 && sc(l, i);
  });
}
function jh(e, t) {
  let r = -1;
  return e.some((n, i) => t(n) ? (r = i, !0) : !1), r;
}
function xk(e, t) {
  const r = [], n = e.container;
  if (!t.disableScrollLock) {
    if (wk(n)) {
      const c = ck(No(n));
      r.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${hw(n) + c}px`;
      const f = No(n).querySelectorAll(".mui-fixed");
      [].forEach.call(f, (h) => {
        r.push({
          value: h.style.paddingRight,
          property: "padding-right",
          el: h
        }), h.style.paddingRight = `${hw(h) + c}px`;
      });
    }
    const o = n.parentElement, s = zl(n), l = (o == null ? void 0 : o.nodeName) === "HTML" && s.getComputedStyle(o).overflowY === "scroll" ? o : n;
    r.push({
      value: l.style.overflow,
      property: "overflow",
      el: l
    }, {
      value: l.style.overflowX,
      property: "overflow-x",
      el: l
    }, {
      value: l.style.overflowY,
      property: "overflow-y",
      el: l
    }), l.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: o,
      el: s,
      property: l
    }) => {
      o ? s.style.setProperty(l, o) : s.style.removeProperty(l);
    });
  };
}
function _k(e) {
  const t = [];
  return [].forEach.call(e.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && t.push(r);
  }), t;
}
class Sk {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, r) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && sc(t.modalRef, !1);
    const i = _k(r);
    gw(r, t.mount, t.modalRef, i, !0);
    const o = jh(this.containers, (s) => s.container === r);
    return o !== -1 ? (this.containers[o].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: r,
      restore: null,
      hiddenSiblings: i
    }), n);
  }
  mount(t, r) {
    const n = jh(this.containers, (o) => o.modals.indexOf(t) !== -1), i = this.containers[n];
    i.restore || (i.restore = xk(i, r));
  }
  remove(t) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const n = jh(this.containers, (o) => o.modals.indexOf(t) !== -1), i = this.containers[n];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && sc(t.modalRef, !0), gw(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(n, 1);
    else {
      const o = i.modals[i.modals.length - 1];
      o.modalRef && sc(o.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const Ek = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Ck(e) {
  const t = parseInt(e.getAttribute("tabindex"), 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function Tk(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let r = t(`[name="${e.name}"]:checked`);
  return r || (r = t(`[name="${e.name}"]`)), r !== e;
}
function Ok(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Tk(e));
}
function Rk(e) {
  const t = [], r = [];
  return Array.from(e.querySelectorAll(Ek)).forEach((n, i) => {
    const o = Ck(n);
    o === -1 || !Ok(n) || (o === 0 ? t.push(n) : r.push({
      documentOrder: i,
      tabIndex: o,
      node: n
    }));
  }), r.sort((n, i) => n.tabIndex === i.tabIndex ? n.documentOrder - i.documentOrder : n.tabIndex - i.tabIndex).map((n) => n.node).concat(t);
}
function Ik() {
  return !0;
}
function Cf(e) {
  const {
    children: t,
    disableAutoFocus: r = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: i = !1,
    getTabbable: o = Rk,
    isEnabled: s = Ik,
    open: l
  } = e, c = Be.useRef(), f = Be.useRef(null), h = Be.useRef(null), g = Be.useRef(null), S = Be.useRef(null), b = Be.useRef(!1), p = Be.useRef(null), v = Gi(t.ref, p), w = Be.useRef(null);
  Be.useEffect(() => {
    !l || !p.current || (b.current = !r);
  }, [r, l]), Be.useEffect(() => {
    if (!l || !p.current)
      return;
    const L = No(p.current);
    return p.current.contains(L.activeElement) || (p.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), p.current.setAttribute("tabIndex", -1)), b.current && p.current.focus()), () => {
      i || (g.current && g.current.focus && (c.current = !0, g.current.focus()), g.current = null);
    };
  }, [l]), Be.useEffect(() => {
    if (!l || !p.current)
      return;
    const L = No(p.current), W = (K) => {
      const {
        current: Z
      } = p;
      if (Z !== null) {
        if (!L.hasFocus() || n || !s() || c.current) {
          c.current = !1;
          return;
        }
        if (!Z.contains(L.activeElement)) {
          if (K && S.current !== K.target || L.activeElement !== S.current)
            S.current = null;
          else if (S.current !== null)
            return;
          if (!b.current)
            return;
          let _e = [];
          if ((L.activeElement === f.current || L.activeElement === h.current) && (_e = o(p.current)), _e.length > 0) {
            var ee, he;
            const Te = !!((ee = w.current) != null && ee.shiftKey && ((he = w.current) == null ? void 0 : he.key) === "Tab"), fe = _e[0], Oe = _e[_e.length - 1];
            Te ? Oe.focus() : fe.focus();
          } else
            Z.focus();
        }
      }
    }, z = (K) => {
      w.current = K, !(n || !s() || K.key !== "Tab") && L.activeElement === p.current && K.shiftKey && (c.current = !0, h.current.focus());
    };
    L.addEventListener("focusin", W), L.addEventListener("keydown", z, !0);
    const B = setInterval(() => {
      L.activeElement.tagName === "BODY" && W();
    }, 50);
    return () => {
      clearInterval(B), L.removeEventListener("focusin", W), L.removeEventListener("keydown", z, !0);
    };
  }, [r, n, i, s, l, o]);
  const C = (L) => {
    g.current === null && (g.current = L.relatedTarget), b.current = !0, S.current = L.target;
    const W = t.props.onFocus;
    W && W(L);
  }, M = (L) => {
    g.current === null && (g.current = L.relatedTarget), b.current = !0;
  };
  return /* @__PURE__ */ y.jsxs(Be.Fragment, {
    children: [/* @__PURE__ */ y.jsx("div", {
      tabIndex: 0,
      onFocus: M,
      ref: f,
      "data-test": "sentinelStart"
    }), /* @__PURE__ */ Be.cloneElement(t, {
      ref: v,
      onFocus: C
    }), /* @__PURE__ */ y.jsx("div", {
      tabIndex: 0,
      onFocus: M,
      ref: h,
      "data-test": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Cf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A single child content element.
   */
  children: Kl,
  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: D.bool,
  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: D.bool,
  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   * @default false
   */
  disableRestoreFocus: D.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: D.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple trap focus mounted at the same time.
   * @default function defaultIsEnabled() {
   *   return true;
   * }
   */
  isEnabled: D.func,
  /**
   * If `true`, focus is locked.
   */
  open: D.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Cf.propTypes = Tm(Cf.propTypes));
function Dk(e) {
  return Mn("MuiModal", e);
}
An("MuiModal", ["root", "hidden"]);
const Pk = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"], Mk = (e) => {
  const {
    open: t,
    exited: r,
    classes: n
  } = e;
  return Kn({
    root: ["root", !t && r && "hidden"]
  }, Dk, n);
};
function Ak(e) {
  return typeof e == "function" ? e() : e;
}
function Nk(e) {
  return e.children ? e.children.props.hasOwnProperty("in") : !1;
}
const jk = new Sk(), ZE = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const {
    BackdropComponent: n,
    BackdropProps: i,
    children: o,
    classes: s,
    className: l,
    closeAfterTransition: c = !1,
    component: f = "div",
    components: h = {},
    componentsProps: g = {},
    container: S,
    disableAutoFocus: b = !1,
    disableEnforceFocus: p = !1,
    disableEscapeKeyDown: v = !1,
    disablePortal: w = !1,
    disableRestoreFocus: C = !1,
    disableScrollLock: M = !1,
    hideBackdrop: L = !1,
    keepMounted: W = !1,
    // private
    // eslint-disable-next-line react/prop-types
    manager: z = jk,
    onBackdropClick: B,
    onClose: K,
    onKeyDown: Z,
    open: ee,
    /* eslint-disable react/prop-types */
    theme: he,
    onTransitionEnter: _e,
    onTransitionExited: Te
  } = t, fe = XE(t, Pk), [Oe, ye] = Be.useState(!0), de = Be.useRef({}), ce = Be.useRef(null), Fe = Be.useRef(null), le = Gi(Fe, r), J = Nk(t), re = () => No(ce.current), be = () => (de.current.modalRef = Fe.current, de.current.mountNode = ce.current, de.current), Me = () => {
    z.mount(be(), {
      disableScrollLock: M
    }), Fe.current.scrollTop = 0;
  }, Ae = Ps(() => {
    const mt = Ak(S) || re().body;
    z.add(be(), mt), Fe.current && Me();
  }), Re = Be.useCallback(() => z.isTopModal(be()), [z]), Ee = Ps((mt) => {
    ce.current = mt, mt && (ee && Re() ? Me() : sc(Fe.current, !0));
  }), Ce = Be.useCallback(() => {
    z.remove(be());
  }, [z]);
  Be.useEffect(() => () => {
    Ce();
  }, [Ce]), Be.useEffect(() => {
    ee ? Ae() : (!J || !c) && Ce();
  }, [ee, Ce, J, c, Ae]);
  const X = na({}, t, {
    classes: s,
    closeAfterTransition: c,
    disableAutoFocus: b,
    disableEnforceFocus: p,
    disableEscapeKeyDown: v,
    disablePortal: w,
    disableRestoreFocus: C,
    disableScrollLock: M,
    exited: Oe,
    hideBackdrop: L,
    keepMounted: W
  }), ie = Mk(X);
  if (!W && !ee && (!J || Oe))
    return null;
  const Ie = () => {
    ye(!1), _e && _e();
  }, xe = () => {
    ye(!0), Te && Te(), c && Ce();
  }, Pe = (mt) => {
    mt.target === mt.currentTarget && (B && B(mt), K && K(mt, "backdropClick"));
  }, ae = (mt) => {
    Z && Z(mt), !(mt.key !== "Escape" || !Re()) && (v || (mt.stopPropagation(), K && K(mt, "escapeKeyDown")));
  }, rt = {};
  o.props.tabIndex === void 0 && (rt.tabIndex = "-1"), J && (rt.onEnter = uv(Ie, o.props.onEnter), rt.onExited = uv(xe, o.props.onExited));
  const Ze = h.Root || f, ht = g.root || {};
  return /* @__PURE__ */ y.jsx(Ef, {
    ref: Ee,
    container: S,
    disablePortal: w,
    children: /* @__PURE__ */ y.jsxs(Ze, na({
      role: "presentation"
    }, ht, !Bl(Ze) && {
      as: f,
      ownerState: na({}, X, ht.ownerState),
      theme: he
    }, fe, {
      ref: le,
      onKeyDown: ae,
      className: nt(ie.root, ht.className, l),
      children: [!L && n ? /* @__PURE__ */ y.jsx(n, na({
        open: ee,
        onClick: Pe
      }, i)) : null, /* @__PURE__ */ y.jsx(Cf, {
        disableEnforceFocus: p,
        disableAutoFocus: b,
        disableRestoreFocus: C,
        isEnabled: Re,
        open: ee,
        children: /* @__PURE__ */ Be.cloneElement(o, rt)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (ZE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: D.elementType,
  /**
   * Props applied to the [`BackdropUnstyled`](/api/backdrop-unstyled/) element.
   */
  BackdropProps: D.object,
  /**
   * A single child content element.
   */
  children: Kl.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: D.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: D.shape({
    Root: D.elementType
  }),
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  componentsProps: D.object,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: D.oneOfType([yc, D.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: D.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: D.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: D.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: D.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   * @default false
   */
  disableRestoreFocus: D.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: D.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: D.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: D.bool,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: D.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: D.func,
  /**
   * @ignore
   */
  onKeyDown: D.func,
  /**
   * If `true`, the component is shown.
   */
  open: D.bool.isRequired
});
/** @license MUI v5.2.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function QE(e, t) {
  const r = JN(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((o) => o === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
const ts = process.env.NODE_ENV !== "production" ? D.oneOfType([D.number, D.string, D.object, D.array]) : {};
function ci() {
  return ci = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ci.apply(this, arguments);
}
function lc(e, t) {
  return t ? po(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Im = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, vw = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Im[e]}px)`
};
function rs(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const o = n.breakpoints || vw;
    return t.reduce((s, l, c) => (s[o.up(o.keys[c])] = r(t[c]), s), {});
  }
  if (typeof t == "object") {
    const o = n.breakpoints || vw;
    return Object.keys(t).reduce((s, l) => {
      if (Object.keys(o.values || Im).indexOf(l) !== -1) {
        const c = o.up(l);
        s[c] = r(t[l], l);
      } else {
        const c = l;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return r(t);
}
function kk(e = {}) {
  var t;
  return (e == null || (t = e.keys) == null ? void 0 : t.reduce((n, i) => {
    const o = e.up(i);
    return n[o] = {}, n;
  }, {})) || {};
}
function Lk(e, t) {
  return e.reduce((r, n) => {
    const i = r[n];
    return (!i || Object.keys(i).length === 0) && delete r[n], r;
  }, t);
}
function Dm(e, t) {
  return !t || typeof t != "string" ? null : t.split(".").reduce((r, n) => r && r[n] ? r[n] : null, e);
}
function mw(e, t, r, n = r) {
  let i;
  return typeof e == "function" ? i = e(r) : Array.isArray(e) ? i = e[r] || n : i = Dm(e, r) || n, t && (i = t(i)), i;
}
function vt(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: i
  } = e, o = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], c = s.theme, f = Dm(c, n) || {};
    return rs(s, l, (g) => {
      let S = mw(f, i, g);
      return g === S && typeof g == "string" && (S = mw(f, i, `${t}${g === "default" ? "" : Wr(g)}`, g)), r === !1 ? S : {
        [r]: S
      };
    });
  };
  return o.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: ts
  } : {}, o.filterProps = [t], o;
}
function ns(...e) {
  const t = e.reduce((n, i) => (i.filterProps.forEach((o) => {
    n[o] = i;
  }), n), {}), r = (n) => Object.keys(n).reduce((i, o) => t[o] ? lc(i, t[o](n)) : i, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, i) => Object.assign(n, i.propTypes), {}) : {}, r.filterProps = e.reduce((n, i) => n.concat(i.filterProps), []), r;
}
function zk(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const Bk = {
  m: "margin",
  p: "padding"
}, Fk = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, yw = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Wk = zk((e) => {
  if (e.length > 2)
    if (yw[e])
      e = yw[e];
    else
      return [e];
  const [t, r] = e.split(""), n = Bk[t], i = Fk[r] || "";
  return Array.isArray(i) ? i.map((o) => n + o) : [n + i];
}), eC = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], tC = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], Pm = [...eC, ...tC];
function Hc(e, t, r, n) {
  const i = Dm(e, t) || r;
  return typeof i == "number" ? (o) => typeof o == "string" ? o : (process.env.NODE_ENV !== "production" && typeof o != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${o}.`), i * o) : Array.isArray(i) ? (o) => typeof o == "string" ? o : (process.env.NODE_ENV !== "production" && (Number.isInteger(o) ? o > i.length - 1 && console.error([`MUI: The value provided (${o}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${o} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[o]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function rC(e) {
  return Hc(e, "spacing", 8, "spacing");
}
function $c(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const r = Math.abs(t), n = e(r);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function Hk(e, t) {
  return (r) => e.reduce((n, i) => (n[i] = $c(t, r), n), {});
}
function $k(e, t, r, n) {
  if (t.indexOf(r) === -1)
    return null;
  const i = Wk(r), o = Hk(i, n), s = e[r];
  return rs(e, s, o);
}
function Uk(e, t) {
  const r = rC(e.theme);
  return Object.keys(e).map((n) => $k(e, t, n, r)).reduce(lc, {});
}
process.env.NODE_ENV !== "production" && eC.reduce((e, t) => (e[t] = ts, e), {});
process.env.NODE_ENV !== "production" && tC.reduce((e, t) => (e[t] = ts, e), {});
function sp(e) {
  return Uk(e, Pm);
}
sp.propTypes = process.env.NODE_ENV !== "production" ? Pm.reduce((e, t) => (e[t] = ts, e), {}) : {};
sp.filterProps = Pm;
function Uc(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const Gk = vt({
  prop: "border",
  themeKey: "borders",
  transform: Uc
}), qk = vt({
  prop: "borderTop",
  themeKey: "borders",
  transform: Uc
}), Vk = vt({
  prop: "borderRight",
  themeKey: "borders",
  transform: Uc
}), Yk = vt({
  prop: "borderBottom",
  themeKey: "borders",
  transform: Uc
}), Kk = vt({
  prop: "borderLeft",
  themeKey: "borders",
  transform: Uc
}), Xk = vt({
  prop: "borderColor",
  themeKey: "palette"
}), Jk = vt({
  prop: "borderTopColor",
  themeKey: "palette"
}), Zk = vt({
  prop: "borderRightColor",
  themeKey: "palette"
}), Qk = vt({
  prop: "borderBottomColor",
  themeKey: "palette"
}), eL = vt({
  prop: "borderLeftColor",
  themeKey: "palette"
}), Mm = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Hc(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: $c(t, n)
    });
    return rs(e, e.borderRadius, r);
  }
  return null;
};
Mm.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: ts
} : {};
Mm.filterProps = ["borderRadius"];
const nC = ns(Gk, qk, Vk, Yk, Kk, Xk, Jk, Zk, Qk, eL, Mm), tL = vt({
  prop: "displayPrint",
  cssProperty: !1,
  transform: (e) => ({
    "@media print": {
      display: e
    }
  })
}), rL = vt({
  prop: "display"
}), nL = vt({
  prop: "overflow"
}), iL = vt({
  prop: "textOverflow"
}), oL = vt({
  prop: "visibility"
}), aL = vt({
  prop: "whiteSpace"
}), iC = ns(tL, rL, nL, iL, oL, aL), sL = vt({
  prop: "flexBasis"
}), lL = vt({
  prop: "flexDirection"
}), uL = vt({
  prop: "flexWrap"
}), cL = vt({
  prop: "justifyContent"
}), dL = vt({
  prop: "alignItems"
}), fL = vt({
  prop: "alignContent"
}), pL = vt({
  prop: "order"
}), hL = vt({
  prop: "flex"
}), gL = vt({
  prop: "flexGrow"
}), vL = vt({
  prop: "flexShrink"
}), mL = vt({
  prop: "alignSelf"
}), yL = vt({
  prop: "justifyItems"
}), bL = vt({
  prop: "justifySelf"
}), oC = ns(sL, lL, uL, cL, dL, fL, pL, hL, gL, vL, mL, yL, bL), Am = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Hc(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: $c(t, n)
    });
    return rs(e, e.gap, r);
  }
  return null;
};
Am.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: ts
} : {};
Am.filterProps = ["gap"];
const Nm = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Hc(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: $c(t, n)
    });
    return rs(e, e.columnGap, r);
  }
  return null;
};
Nm.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: ts
} : {};
Nm.filterProps = ["columnGap"];
const jm = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Hc(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: $c(t, n)
    });
    return rs(e, e.rowGap, r);
  }
  return null;
};
jm.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: ts
} : {};
jm.filterProps = ["rowGap"];
const wL = vt({
  prop: "gridColumn"
}), xL = vt({
  prop: "gridRow"
}), _L = vt({
  prop: "gridAutoFlow"
}), SL = vt({
  prop: "gridAutoColumns"
}), EL = vt({
  prop: "gridAutoRows"
}), CL = vt({
  prop: "gridTemplateColumns"
}), TL = vt({
  prop: "gridTemplateRows"
}), OL = vt({
  prop: "gridTemplateAreas"
}), RL = vt({
  prop: "gridArea"
}), aC = ns(Am, Nm, jm, wL, xL, _L, SL, EL, CL, TL, OL, RL), IL = vt({
  prop: "color",
  themeKey: "palette"
}), DL = vt({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
}), PL = vt({
  prop: "backgroundColor",
  themeKey: "palette"
}), sC = ns(IL, DL, PL), ML = vt({
  prop: "position"
}), AL = vt({
  prop: "zIndex",
  themeKey: "zIndex"
}), NL = vt({
  prop: "top"
}), jL = vt({
  prop: "right"
}), kL = vt({
  prop: "bottom"
}), LL = vt({
  prop: "left"
}), lC = ns(ML, AL, NL, jL, kL, LL), uC = vt({
  prop: "boxShadow",
  themeKey: "shadows"
});
function is(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const zL = vt({
  prop: "width",
  transform: is
}), cC = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var n, i, o;
      return {
        maxWidth: ((n = e.theme) == null || (i = n.breakpoints) == null || (o = i.values) == null ? void 0 : o[r]) || Im[r] || is(r)
      };
    };
    return rs(e, e.maxWidth, t);
  }
  return null;
};
cC.filterProps = ["maxWidth"];
const BL = vt({
  prop: "minWidth",
  transform: is
}), FL = vt({
  prop: "height",
  transform: is
}), WL = vt({
  prop: "maxHeight",
  transform: is
}), HL = vt({
  prop: "minHeight",
  transform: is
});
vt({
  prop: "size",
  cssProperty: "width",
  transform: is
});
vt({
  prop: "size",
  cssProperty: "height",
  transform: is
});
const $L = vt({
  prop: "boxSizing"
}), dC = ns(zL, cC, BL, FL, WL, HL, $L), UL = vt({
  prop: "fontFamily",
  themeKey: "typography"
}), GL = vt({
  prop: "fontSize",
  themeKey: "typography"
}), qL = vt({
  prop: "fontStyle",
  themeKey: "typography"
}), VL = vt({
  prop: "fontWeight",
  themeKey: "typography"
}), YL = vt({
  prop: "letterSpacing"
}), KL = vt({
  prop: "lineHeight"
}), XL = vt({
  prop: "textAlign"
}), JL = vt({
  prop: "typography",
  cssProperty: !1,
  themeKey: "typography"
}), fC = ns(JL, UL, GL, qL, VL, YL, KL, XL), bw = {
  borders: nC.filterProps,
  display: iC.filterProps,
  flexbox: oC.filterProps,
  grid: aC.filterProps,
  positions: lC.filterProps,
  palette: sC.filterProps,
  shadows: uC.filterProps,
  sizing: dC.filterProps,
  spacing: sp.filterProps,
  typography: fC.filterProps
}, ZL = {
  borders: nC,
  display: iC,
  flexbox: oC,
  grid: aC,
  positions: lC,
  palette: sC,
  shadows: uC,
  sizing: dC,
  spacing: sp,
  typography: fC
}, km = Object.keys(bw).reduce((e, t) => (bw[t].forEach((r) => {
  e[r] = ZL[t];
}), e), {});
function ww(e, t, r) {
  const n = {
    [e]: t,
    theme: r
  }, i = km[e];
  return i ? i(n) : {
    [e]: t
  };
}
function QL(...e) {
  const t = e.reduce((n, i) => n.concat(Object.keys(i)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function e2(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function lp(e) {
  const {
    sx: t,
    theme: r = {}
  } = e || {};
  if (!t)
    return null;
  function n(i) {
    let o = i;
    if (typeof i == "function")
      o = i(r);
    else if (typeof i != "object")
      return i;
    const s = kk(r.breakpoints), l = Object.keys(s);
    let c = s;
    return Object.keys(o).forEach((f) => {
      const h = e2(o[f], r);
      if (h != null)
        if (typeof h == "object")
          if (km[f])
            c = lc(c, ww(f, h, r));
          else {
            const g = rs({
              theme: r
            }, h, (S) => ({
              [f]: S
            }));
            QL(g, h) ? c[f] = lp({
              sx: h,
              theme: r
            }) : c = lc(c, g);
          }
        else
          c = lc(c, ww(f, h, r));
    }), Lk(l, c);
  }
  return Array.isArray(t) ? t.map(n) : n(t);
}
lp.filterProps = ["sx"];
function Fa(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
const t2 = ["sx"], r2 = (e) => {
  const t = {
    systemProps: {},
    otherProps: {}
  };
  return Object.keys(e).forEach((r) => {
    km[r] ? t.systemProps[r] = e[r] : t.otherProps[r] = e[r];
  }), t;
};
function pC(e) {
  const {
    sx: t
  } = e, r = Fa(e, t2), {
    systemProps: n,
    otherProps: i
  } = r2(r);
  let o;
  return Array.isArray(t) ? o = [n, ...t] : typeof t == "function" ? o = (...s) => {
    const l = t(...s);
    return Zu(l) ? ci({}, n, l) : n;
  } : o = ci({}, n, t), ci({}, i, {
    sx: o
  });
}
const n2 = ["values", "unit", "step"];
function i2(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5
  } = e, i = Fa(e, n2), o = Object.keys(t);
  function s(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${r})`;
  }
  function l(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - n / 100}${r})`;
  }
  function c(h, g) {
    const S = o.indexOf(g);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${r}) and (max-width:${(S !== -1 && typeof t[o[S]] == "number" ? t[o[S]] : g) - n / 100}${r})`;
  }
  function f(h) {
    return o.indexOf(h) + 1 < o.length ? c(h, o[o.indexOf(h) + 1]) : s(h);
  }
  return ci({
    keys: o,
    values: t,
    up: s,
    down: l,
    between: c,
    only: f,
    unit: r
  }, i);
}
const o2 = {
  borderRadius: 4
};
function a2(e = 8) {
  if (e.mui)
    return e;
  const t = rC({
    spacing: e
  }), r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((o) => {
    const s = t(o);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return r.mui = !0, r;
}
const s2 = ["breakpoints", "palette", "spacing", "shape"];
function Lm(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: i,
    shape: o = {}
  } = e, s = Fa(e, s2), l = i2(r), c = a2(i);
  let f = po({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: ci({
      mode: "light"
    }, n),
    spacing: c,
    shape: ci({}, o2, o)
  }, s);
  return f = t.reduce((h, g) => po(h, g), f), f;
}
const hC = /* @__PURE__ */ Be.createContext(null);
process.env.NODE_ENV !== "production" && (hC.displayName = "ThemeContext");
function gC() {
  const e = Be.useContext(hC);
  return process.env.NODE_ENV !== "production" && Be.useDebugValue(e), e;
}
const l2 = typeof Symbol == "function" && Symbol.for, u2 = l2 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function c2(e) {
  return Object.keys(e).length === 0;
}
function d2(e = null) {
  const t = gC();
  return !t || c2(t) ? e : t;
}
const f2 = Lm();
function zm(e = f2) {
  return d2(e);
}
const p2 = ["className", "component"];
function h2(e = {}) {
  const {
    defaultTheme: t,
    defaultClassName: r = "MuiBox-root",
    generateClassName: n
  } = e, i = QE("div")(lp), o = /* @__PURE__ */ Be.forwardRef(function(l, c) {
    const f = zm(t), h = pC(l), {
      className: g,
      component: S = "div"
    } = h, b = Fa(h, p2);
    return /* @__PURE__ */ y.jsx(i, ci({
      as: S,
      ref: c,
      className: nt(g, n ? n(r) : r),
      theme: f
    }, b));
  });
  return process.env.NODE_ENV !== "production" && (o.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    /**
     * @ignore
     */
    children: D.node,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: D.elementType,
    /**
     * @ignore
     */
    sx: D.oneOfType([D.object, D.array, D.func])
  }), o;
}
const g2 = ["variant"];
function xw(e) {
  return e.length === 0;
}
function vC(e) {
  const {
    variant: t
  } = e, r = Fa(e, g2);
  let n = t || "";
  return Object.keys(r).sort().forEach((i) => {
    i === "color" ? n += xw(n) ? e[i] : Wr(e[i]) : n += `${xw(n) ? i : Wr(i)}${Wr(e[i].toString())}`;
  }), n;
}
const v2 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"], m2 = ["theme"], y2 = ["theme"];
function Ru(e) {
  return Object.keys(e).length === 0;
}
const b2 = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, w2 = (e, t) => {
  let r = [];
  t && t.components && t.components[e] && t.components[e].variants && (r = t.components[e].variants);
  const n = {};
  return r.forEach((i) => {
    const o = vC(i.props);
    n[o] = i.style;
  }), n;
}, x2 = (e, t, r, n) => {
  var i, o;
  const {
    ownerState: s = {}
  } = e, l = [], c = r == null || (i = r.components) == null || (o = i[n]) == null ? void 0 : o.variants;
  return c && c.forEach((f) => {
    let h = !0;
    Object.keys(f.props).forEach((g) => {
      s[g] !== f.props[g] && e[g] !== f.props[g] && (h = !1);
    }), h && l.push(t[vC(f.props)]);
  }), l;
};
function pf(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const _2 = Lm(), S2 = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function E2(e = {}) {
  const {
    defaultTheme: t = _2,
    rootShouldForwardProp: r = pf,
    slotShouldForwardProp: n = pf
  } = e;
  return (i, o = {}) => {
    const {
      name: s,
      slot: l,
      skipVariantsResolver: c,
      skipSx: f,
      overridesResolver: h
    } = o, g = Fa(o, v2), S = c !== void 0 ? c : l && l !== "Root" || !1, b = f || !1;
    let p;
    process.env.NODE_ENV !== "production" && s && (p = `${s}-${S2(l || "Root")}`);
    let v = pf;
    l === "Root" ? v = r : l && (v = n);
    const w = QE(i, ci({
      shouldForwardProp: v,
      label: p
    }, g));
    return (M, ...L) => {
      const W = L ? L.map((Z) => typeof Z == "function" && Z.__emotion_real !== Z ? (ee) => {
        let {
          theme: he
        } = ee, _e = Fa(ee, m2);
        return Z(ci({
          theme: Ru(he) ? t : he
        }, _e));
      } : Z) : [];
      let z = M;
      s && h && W.push((Z) => {
        const ee = Ru(Z.theme) ? t : Z.theme, he = b2(s, ee);
        return he ? h(Z, he) : null;
      }), s && !S && W.push((Z) => {
        const ee = Ru(Z.theme) ? t : Z.theme;
        return x2(Z, w2(s, ee), ee, s);
      }), b || W.push((Z) => {
        const ee = Ru(Z.theme) ? t : Z.theme;
        return lp(ci({}, Z, {
          theme: ee
        }));
      });
      const B = W.length - L.length;
      if (Array.isArray(M) && B > 0) {
        const Z = new Array(B).fill("");
        z = [...M, ...Z], z.raw = [...M.raw, ...Z];
      } else typeof M == "function" && (z = (Z) => {
        let {
          theme: ee
        } = Z, he = Fa(Z, y2);
        return M(ci({
          theme: Ru(ee) ? t : ee
        }, he));
      });
      const K = w(z, ...W);
      if (process.env.NODE_ENV !== "production") {
        let Z;
        s && (Z = `${s}${l || ""}`), Z === void 0 && (Z = `Styled(${ff(i)})`), K.displayName = Z;
      }
      return K;
    };
  };
}
function C2(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r] || !t.components[r].defaultProps)
    return n;
  const i = ci({}, n), o = t.components[r].defaultProps;
  let s;
  for (s in o)
    i[s] === void 0 && (i[s] = o[s]);
  return i;
}
function T2({
  props: e,
  name: t,
  defaultTheme: r
}) {
  const n = zm(r);
  return C2({
    theme: n,
    name: t,
    props: e
  });
}
function Bm(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), Math.min(Math.max(t, e), r);
}
function O2(e) {
  e = e.substr(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, i) => i < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ls(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ls(O2(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : mc(9, e));
  let n = e.substring(t + 1, e.length - 1), i;
  if (r === "color") {
    if (n = n.split(" "), i = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].substr(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(i) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : mc(10, i));
  } else
    n = n.split(",");
  return n = n.map((o) => parseFloat(o)), {
    type: r,
    values: n,
    colorSpace: i
  };
}
function up(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((i, o) => o < 3 ? parseInt(i, 10) : i) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function R2(e) {
  e = Ls(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, i = t[2] / 100, o = n * Math.min(i, 1 - i), s = (f, h = (f + r / 30) % 12) => i - o * Math.max(Math.min(h - 3, 9 - h, 1), -1);
  let l = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), up({
    type: l,
    values: c
  });
}
function _w(e) {
  e = Ls(e);
  let t = e.type === "hsl" ? Ls(R2(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Sw(e, t) {
  const r = _w(e), n = _w(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function Na(e, t) {
  return e = Ls(e), t = Bm(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, up(e);
}
function I2(e, t) {
  if (e = Ls(e), t = Bm(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return up(e);
}
function D2(e, t) {
  if (e = Ls(e), t = Bm(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return up(e);
}
function P2(e, t, r) {
  return it({
    toolbar: {
      minHeight: 56,
      [`${e.up("xs")} and (orientation: landscape)`]: {
        minHeight: 48
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, r);
}
const xc = {
  black: "#000",
  white: "#fff"
}, mC = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, ul = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, cl = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Iu = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, dl = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, fl = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, pl = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, M2 = ["mode", "contrastThreshold", "tonalOffset"], Ew = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: xc.white,
    default: xc.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, kh = {
  text: {
    primary: xc.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: xc.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Cw(e, t, r, n) {
  const i = n.light || n, o = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = D2(e.main, i) : t === "dark" && (e.dark = I2(e.main, o)));
}
function A2(e = "light") {
  return e === "dark" ? {
    main: dl[200],
    light: dl[50],
    dark: dl[400]
  } : {
    main: dl[700],
    light: dl[400],
    dark: dl[800]
  };
}
function N2(e = "light") {
  return e === "dark" ? {
    main: ul[200],
    light: ul[50],
    dark: ul[400]
  } : {
    main: ul[500],
    light: ul[300],
    dark: ul[700]
  };
}
function j2(e = "light") {
  return e === "dark" ? {
    main: cl[500],
    light: cl[300],
    dark: cl[700]
  } : {
    main: cl[700],
    light: cl[400],
    dark: cl[800]
  };
}
function k2(e = "light") {
  return e === "dark" ? {
    main: fl[400],
    light: fl[300],
    dark: fl[700]
  } : {
    main: fl[700],
    light: fl[500],
    dark: fl[900]
  };
}
function L2(e = "light") {
  return e === "dark" ? {
    main: pl[400],
    light: pl[300],
    dark: pl[700]
  } : {
    main: pl[800],
    light: pl[500],
    dark: pl[900]
  };
}
function z2(e = "light") {
  return e === "dark" ? {
    main: Iu[400],
    light: Iu[300],
    dark: Iu[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Iu[500],
    dark: Iu[900]
  };
}
function B2(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2
  } = e, i = Hr(e, M2), o = e.primary || A2(t), s = e.secondary || N2(t), l = e.error || j2(t), c = e.info || k2(t), f = e.success || L2(t), h = e.warning || z2(t);
  function g(v) {
    const w = Sw(v, kh.text.primary) >= r ? kh.text.primary : Ew.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const C = Sw(v, w);
      C < 3 && console.error([`MUI: The contrast ratio of ${C}:1 for ${w} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return w;
  }
  const S = ({
    color: v,
    name: w,
    mainShade: C = 500,
    lightShade: M = 300,
    darkShade: L = 700
  }) => {
    if (v = it({}, v), !v.main && v[C] && (v.main = v[C]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${w ? ` (${w})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${C}\` property.` : mc(11, w ? ` (${w})` : "", C));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${w ? ` (${w})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : mc(12, w ? ` (${w})` : "", JSON.stringify(v.main)));
    return Cw(v, "light", M, n), Cw(v, "dark", L, n), v.contrastText || (v.contrastText = g(v.main)), v;
  }, b = {
    dark: kh,
    light: Ew
  };
  return process.env.NODE_ENV !== "production" && (b[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), po(it({
    // A collection of common colors.
    common: xc,
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: S({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: S({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: S({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: S({
      color: h,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: S({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: S({
      color: f,
      name: "success"
    }),
    // The grey colors.
    grey: mC,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: g,
    // Generate a rich color object.
    augmentColor: S,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, b[t]), i);
}
const F2 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function W2(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Tw = {
  textTransform: "uppercase"
}, Ow = '"Roboto", "Helvetica", "Arial", sans-serif';
function H2(e, t) {
  const r = typeof t == "function" ? t(e) : t, {
    fontFamily: n = Ow,
    // The default font size of the Material Specification.
    fontSize: i = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: f = 16,
    // Apply the CSS properties to all the variants.
    allVariants: h,
    pxToRem: g
  } = r, S = Hr(r, F2);
  process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof f != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const b = i / 14, p = g || ((C) => `${C / f * b}rem`), v = (C, M, L, W, z) => it({
    fontFamily: n,
    fontWeight: C,
    fontSize: p(M),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: L
  }, n === Ow ? {
    letterSpacing: `${W2(W / M)}em`
  } : {}, z, h), w = {
    h1: v(o, 96, 1.167, -1.5),
    h2: v(o, 60, 1.2, -0.5),
    h3: v(s, 48, 1.167, 0),
    h4: v(s, 34, 1.235, 0.25),
    h5: v(s, 24, 1.334, 0),
    h6: v(l, 20, 1.6, 0.15),
    subtitle1: v(s, 16, 1.75, 0.15),
    subtitle2: v(l, 14, 1.57, 0.1),
    body1: v(s, 16, 1.5, 0.15),
    body2: v(s, 14, 1.43, 0.15),
    button: v(l, 14, 1.75, 0.4, Tw),
    caption: v(s, 12, 1.66, 0.4),
    overline: v(s, 12, 2.66, 1, Tw)
  };
  return po(it({
    htmlFontSize: f,
    pxToRem: p,
    fontFamily: n,
    fontSize: i,
    fontWeightLight: o,
    fontWeightRegular: s,
    fontWeightMedium: l,
    fontWeightBold: c
  }, w), S, {
    clone: !1
    // No need to clone deep
  });
}
const $2 = 0.2, U2 = 0.14, G2 = 0.12;
function Lr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${$2})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${U2})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${G2})`].join(",");
}
const q2 = ["none", Lr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Lr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Lr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Lr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Lr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Lr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Lr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Lr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Lr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Lr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Lr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Lr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Lr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Lr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Lr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Lr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Lr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Lr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Lr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Lr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Lr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Lr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Lr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Lr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], V2 = ["duration", "easing", "delay"], Y2 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, fv = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Rw(e) {
  return `${Math.round(e)}ms`;
}
function K2(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function X2(e) {
  const t = it({}, Y2, e.easing), r = it({}, fv, e.duration);
  return it({
    getAutoHeightDuration: K2,
    create: (i = ["all"], o = {}) => {
      const {
        duration: s = r.standard,
        easing: l = t.easeInOut,
        delay: c = 0
      } = o, f = Hr(o, V2);
      if (process.env.NODE_ENV !== "production") {
        const h = (S) => typeof S == "string", g = (S) => !isNaN(parseFloat(S));
        !h(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !g(s) && !h(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), h(l) || console.error('MUI: Argument "easing" must be a string.'), !g(c) && !h(c) && console.error('MUI: Argument "delay" must be a number or a string.'), Object.keys(f).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(f).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((h) => `${h} ${typeof s == "string" ? s : Rw(s)} ${l} ${typeof c == "string" ? c : Rw(c)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: r
  });
}
const J2 = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Z2 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function yC(e = {}, ...t) {
  const {
    mixins: r = {},
    palette: n = {},
    transitions: i = {},
    typography: o = {}
  } = e, s = Hr(e, Z2), l = B2(n), c = Lm(e);
  let f = po(c, {
    mixins: P2(c.breakpoints, c.spacing, r),
    palette: l,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: q2.slice(),
    typography: H2(l, o),
    transitions: X2(i),
    zIndex: it({}, J2)
  });
  if (f = po(f, s), f = t.reduce((h, g) => po(h, g), f), process.env.NODE_ENV !== "production") {
    const h = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], g = (S, b) => {
      let p;
      for (p in S) {
        const v = S[p];
        if (h.indexOf(p) !== -1 && Object.keys(v).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const w = Mn("", p);
            console.error([`MUI: The \`${b}\` component increases the CSS specificity of the \`${p}\` internal state.`, "You can not override it like this: ", JSON.stringify(S, null, 2), "", `Instead, you need to use the '&.${w}' syntax:`, JSON.stringify({
              root: {
                [`&.${w}`]: v
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          S[p] = {};
        }
      }
    };
    Object.keys(f.components).forEach((S) => {
      const b = f.components[S].styleOverrides;
      b && S.indexOf("Mui") === 0 && g(b, S);
    });
  }
  return f;
}
const Fm = yC();
function Wn({
  props: e,
  name: t
}) {
  return T2({
    props: e,
    name: t,
    defaultTheme: Fm
  });
}
const Q2 = (e) => pf(e) && e !== "classes", Xr = E2({
  defaultTheme: Fm,
  rootShouldForwardProp: Q2
});
function ez(e) {
  return Mn("MuiSvgIcon", e);
}
An("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const tz = ["children", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"], rz = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, i = {
    root: ["root", t !== "inherit" && `color${Wr(t)}`, `fontSize${Wr(r)}`]
  };
  return Kn(i, ez, n);
}, nz = Xr("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${Wr(r.color)}`], t[`fontSize${Wr(r.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: e.transitions.create("fill", {
      duration: e.transitions.duration.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: e.typography.pxToRem(20),
      medium: e.typography.pxToRem(24),
      large: e.typography.pxToRem(35)
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (r = (n = e.palette[t.color]) == null ? void 0 : n.main) != null ? r : {
      action: e.palette.action.active,
      disabled: e.palette.action.disabled,
      inherit: void 0
    }[t.color]
  };
}), Tf = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: o,
    color: s = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: f,
    titleAccess: h,
    viewBox: g = "0 0 24 24"
  } = n, S = Hr(n, tz), b = it({}, n, {
    color: s,
    component: l,
    fontSize: c,
    viewBox: g
  }), p = rz(b);
  return /* @__PURE__ */ y.jsxs(nz, it({
    as: l,
    className: nt(p.root, o),
    ownerState: b,
    focusable: "false",
    viewBox: g,
    color: f,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: r
  }, S, {
    children: [i, h ? /* @__PURE__ */ y.jsx("title", {
      children: h
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Tf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: D.oneOfType([D.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), D.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: D.oneOfType([D.oneOf(["inherit", "large", "medium", "small"]), D.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: D.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: D.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: D.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: D.string
});
Tf.muiName = "SvgIcon";
function iz(e, t) {
  const r = (n, i) => /* @__PURE__ */ y.jsx(Tf, it({
    "data-testid": `${t}Icon`,
    ref: i
  }, n, {
    children: e
  }));
  return process.env.NODE_ENV !== "production" && (r.displayName = `${t}Icon`), r.muiName = Tf.muiName, /* @__PURE__ */ Be.memo(/* @__PURE__ */ Be.forwardRef(r));
}
const oz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Wr,
  createChainedFunction: uv,
  createSvgIcon: iz,
  debounce: GE,
  deprecatedPropType: Qj,
  isMuiElement: Om,
  ownerDocument: No,
  ownerWindow: zl,
  requirePropFactory: ek,
  setRef: bc,
  unstable_ClassNameGenerator: Rm,
  unstable_useEnhancedEffect: wc,
  unstable_useId: tk,
  unsupportedProp: rk,
  useControlled: nk,
  useEventCallback: Ps,
  useForkRef: Gi,
  useIsFocusVisible: qE
}, Symbol.toStringTag, { value: "Module" })), az = /* @__PURE__ */ cj(oz);
var Iw;
function Yi() {
  return Iw || (Iw = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = az;
  }(Ih)), Ih;
}
var Dw;
function sz() {
  if (Dw) return Ou;
  Dw = 1;
  var e = Vi();
  Object.defineProperty(Ou, "__esModule", {
    value: !0
  }), Ou.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }), "CheckCircle");
  return Ou.default = n, Ou;
}
var lz = /* @__PURE__ */ sz();
const bC = /* @__PURE__ */ jr(lz);
var Qu = { exports: {} }, uz = Qu.exports, Pw;
function cz() {
  return Pw || (Pw = 1, function(e, t) {
    (function(r, n) {
      n(t, dt, ac);
    })(uz, function(r, n, i) {
      function o(I, m) {
        if (!(I instanceof m)) throw new TypeError("Cannot call a class as a function");
      }
      function s(I, m) {
        for (var x = 0; x < m.length; x++) {
          var T = m[x];
          T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(I, T.key, T);
        }
      }
      function l(I, m, x) {
        return m && s(I.prototype, m), x && s(I, x), I;
      }
      function c(I, m, x) {
        return m in I ? Object.defineProperty(I, m, {
          value: x,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : I[m] = x, I;
      }
      function f() {
        return (f = Object.assign || function(I) {
          for (var m = 1; m < arguments.length; m++) {
            var x = arguments[m];
            for (var T in x) Object.prototype.hasOwnProperty.call(x, T) && (I[T] = x[T]);
          }
          return I;
        }).apply(this, arguments);
      }
      function h(I, m) {
        var x = Object.keys(I);
        if (Object.getOwnPropertySymbols) {
          var T = Object.getOwnPropertySymbols(I);
          m && (T = T.filter(function(P) {
            return Object.getOwnPropertyDescriptor(I, P).enumerable;
          })), x.push.apply(x, T);
        }
        return x;
      }
      function g(I) {
        for (var m = 1; m < arguments.length; m++) {
          var x = arguments[m] != null ? arguments[m] : {};
          m % 2 ? h(x, !0).forEach(function(T) {
            c(I, T, x[T]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(x)) : h(x).forEach(function(T) {
            Object.defineProperty(I, T, Object.getOwnPropertyDescriptor(x, T));
          });
        }
        return I;
      }
      function S(I, m) {
        if (typeof m != "function" && m !== null) throw new TypeError("Super expression must either be null or a function");
        I.prototype = Object.create(m && m.prototype, {
          constructor: {
            value: I,
            writable: !0,
            configurable: !0
          }
        }), m && p(I, m);
      }
      function b(I) {
        return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
          return m.__proto__ || Object.getPrototypeOf(m);
        })(I);
      }
      function p(I, m) {
        return (p = Object.setPrototypeOf || function(x, T) {
          return x.__proto__ = T, x;
        })(I, m);
      }
      function v(I, m) {
        if (I == null) return {};
        var x, T, P = function(N, H) {
          if (N == null) return {};
          var Y, q, Q = {}, ve = Object.keys(N);
          for (q = 0; q < ve.length; q++) Y = ve[q], 0 <= H.indexOf(Y) || (Q[Y] = N[Y]);
          return Q;
        }(I, m);
        if (Object.getOwnPropertySymbols) {
          var F = Object.getOwnPropertySymbols(I);
          for (T = 0; T < F.length; T++) x = F[T], 0 <= m.indexOf(x) || Object.prototype.propertyIsEnumerable.call(I, x) && (P[x] = I[x]);
        }
        return P;
      }
      function w(I) {
        if (I === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return I;
      }
      function C(I, m) {
        return !m || typeof m != "object" && typeof m != "function" ? w(I) : m;
      }
      function M(I, m) {
        return function(x) {
          if (Array.isArray(x)) return x;
        }(I) || function(x, T) {
          if (Symbol.iterator in Object(x) || Object.prototype.toString.call(x) === "[object Arguments]") {
            var P = [], F = !0, N = !1, H = void 0;
            try {
              for (var Y, q = x[Symbol.iterator](); !(F = (Y = q.next()).done) && (P.push(Y.value), !T || P.length !== T); F = !0) ;
            } catch (Q) {
              N = !0, H = Q;
            } finally {
              try {
                F || q.return == null || q.return();
              } finally {
                if (N) throw H;
              }
            }
            return P;
          }
        }(I, m) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function L(I) {
        return function(m) {
          if (Array.isArray(m)) {
            for (var x = 0, T = new Array(m.length); x < m.length; x++) T[x] = m[x];
            return T;
          }
        }(I) || function(m) {
          if (Symbol.iterator in Object(m) || Object.prototype.toString.call(m) === "[object Arguments]") return Array.from(m);
        }(I) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function W() {
        var I = this.constructor.getDerivedStateFromProps(this.props, this.state);
        I != null && this.setState(I);
      }
      function z(I) {
        this.setState(
          // Call this.constructor.gDSFP to support sub-classes.
          // Use the setState() updater to ensure state isn't stale in certain edge cases.
          (function(m) {
            var x = this.constructor.getDerivedStateFromProps(I, m);
            return x ?? null;
          }).bind(this)
        );
      }
      function B(I, m) {
        try {
          var x = this.props, T = this.state;
          this.props = I, this.state = m, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(x, T);
        } finally {
          this.props = x, this.state = T;
        }
      }
      function K(I) {
        var m = I.prototype;
        if (!m || !m.isReactComponent) throw new Error("Can only polyfill class components");
        if (typeof I.getDerivedStateFromProps != "function" && typeof m.getSnapshotBeforeUpdate != "function") return I;
        var x = null, T = null, P = null;
        if (typeof m.componentWillMount == "function" ? x = "componentWillMount" : typeof m.UNSAFE_componentWillMount == "function" && (x = "UNSAFE_componentWillMount"), typeof m.componentWillReceiveProps == "function" ? T = "componentWillReceiveProps" : typeof m.UNSAFE_componentWillReceiveProps == "function" && (T = "UNSAFE_componentWillReceiveProps"), typeof m.componentWillUpdate == "function" ? P = "componentWillUpdate" : typeof m.UNSAFE_componentWillUpdate == "function" && (P = "UNSAFE_componentWillUpdate"), x !== null || T !== null || P !== null) {
          var F = I.displayName || I.name, N = typeof I.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
          throw Error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

` + F + " uses " + N + " but also contains the following legacy lifecycles:" + (x !== null ? `
  ` + x : "") + (T !== null ? `
  ` + T : "") + (P !== null ? `
  ` + P : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`);
        }
        if (typeof I.getDerivedStateFromProps == "function" && (m.componentWillMount = W, m.componentWillReceiveProps = z), typeof m.getSnapshotBeforeUpdate == "function") {
          if (typeof m.componentDidUpdate != "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
          m.componentWillUpdate = B;
          var H = m.componentDidUpdate;
          m.componentDidUpdate = function(Y, q, Q) {
            var ve = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : Q;
            H.call(this, Y, q, ve);
          };
        }
        return I;
      }
      B.__suppressDeprecationWarning = z.__suppressDeprecationWarning = W.__suppressDeprecationWarning = !0;
      var Z = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "state", {
            scrollToColumn: 0,
            scrollToRow: 0,
            instanceProps: {
              prevScrollToColumn: 0,
              prevScrollToRow: 0
            }
          }), c(w(x), "_columnStartIndex", 0), c(w(x), "_columnStopIndex", 0), c(w(x), "_rowStartIndex", 0), c(w(x), "_rowStopIndex", 0), c(w(x), "_onKeyDown", function(N) {
            var H = x.props, Y = H.columnCount, q = H.disabled, Q = H.mode, ve = H.rowCount;
            if (!q) {
              var Se = x._getScrollState(), We = Se.scrollToColumn, De = Se.scrollToRow, Ne = x._getScrollState(), $e = Ne.scrollToColumn, Ye = Ne.scrollToRow;
              switch (N.key) {
                case "ArrowDown":
                  Ye = Math.min(Q === "cells" ? Ye + 1 : x._rowStopIndex + 1, ve - 1);
                  break;
                case "ArrowLeft":
                  $e = Math.max(Q === "cells" ? $e - 1 : x._columnStartIndex - 1, 0);
                  break;
                case "ArrowRight":
                  $e = Math.min(Q === "cells" ? $e + 1 : x._columnStopIndex + 1, Y - 1);
                  break;
                case "ArrowUp":
                  Ye = Math.max(Q === "cells" ? Ye - 1 : x._rowStartIndex - 1, 0);
              }
              $e === We && Ye === De || (N.preventDefault(), x._updateScrollState({
                scrollToColumn: $e,
                scrollToRow: Ye
              }));
            }
          }), c(w(x), "_onSectionRendered", function(N) {
            var H = N.columnStartIndex, Y = N.columnStopIndex, q = N.rowStartIndex, Q = N.rowStopIndex;
            x._columnStartIndex = H, x._columnStopIndex = Y, x._rowStartIndex = q, x._rowStopIndex = Q;
          }), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "setScrollIndexes",
          value: function(m) {
            var x = m.scrollToColumn, T = m.scrollToRow;
            this.setState({
              scrollToRow: T,
              scrollToColumn: x
            });
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.className, T = m.children, P = this._getScrollState(), F = P.scrollToColumn, N = P.scrollToRow;
            return n.createElement("div", {
              className: x,
              onKeyDown: this._onKeyDown
            }, T({
              onSectionRendered: this._onSectionRendered,
              scrollToColumn: F,
              scrollToRow: N
            }));
          }
        }, {
          key: "_getScrollState",
          value: function() {
            return this.props.isControlled ? this.props : this.state;
          }
        }, {
          key: "_updateScrollState",
          value: function(m) {
            var x = m.scrollToColumn, T = m.scrollToRow, P = this.props, F = P.isControlled, N = P.onScrollToChange;
            typeof N == "function" && N({
              scrollToColumn: x,
              scrollToRow: T
            }), F || this.setState({
              scrollToColumn: x,
              scrollToRow: T
            });
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function(m, x) {
            return m.isControlled ? {} : m.scrollToColumn !== x.instanceProps.prevScrollToColumn || m.scrollToRow !== x.instanceProps.prevScrollToRow ? g({}, x, {
              scrollToColumn: m.scrollToColumn,
              scrollToRow: m.scrollToRow,
              instanceProps: {
                prevScrollToColumn: m.scrollToColumn,
                prevScrollToRow: m.scrollToRow
              }
            }) : {};
          }
        }]), I;
      }();
      function ee(I, m) {
        var x, T, P, F = (x = m !== void 0 ? m : typeof window < "u" ? window : typeof self < "u" ? self : xi).document !== void 0 && x.document.attachEvent;
        if (!F) {
          var N = (P = x.requestAnimationFrame || x.mozRequestAnimationFrame || x.webkitRequestAnimationFrame || function(je) {
            return x.setTimeout(je, 20);
          }, function(je) {
            return P(je);
          }), H = (T = x.cancelAnimationFrame || x.mozCancelAnimationFrame || x.webkitCancelAnimationFrame || x.clearTimeout, function(je) {
            return T(je);
          }), Y = function(je) {
            var He = je.__resizeTriggers__, ke = He.firstElementChild, ut = He.lastElementChild, Ct = ke.firstElementChild;
            ut.scrollLeft = ut.scrollWidth, ut.scrollTop = ut.scrollHeight, Ct.style.width = ke.offsetWidth + 1 + "px", Ct.style.height = ke.offsetHeight + 1 + "px", ke.scrollLeft = ke.scrollWidth, ke.scrollTop = ke.scrollHeight;
          }, q = function(je) {
            if (!(je.target.className && typeof je.target.className.indexOf == "function" && je.target.className.indexOf("contract-trigger") < 0 && je.target.className.indexOf("expand-trigger") < 0)) {
              var He = this;
              Y(this), this.__resizeRAF__ && H(this.__resizeRAF__), this.__resizeRAF__ = N(function() {
                !function(ke) {
                  return ke.offsetWidth != ke.__resizeLast__.width || ke.offsetHeight != ke.__resizeLast__.height;
                }(He) || (He.__resizeLast__.width = He.offsetWidth, He.__resizeLast__.height = He.offsetHeight, He.__resizeListeners__.forEach(function(ke) {
                  ke.call(He, je);
                }));
              });
            }
          }, Q = !1, ve = "", Se = "animationstart", We = "Webkit Moz O ms".split(" "), De = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), Ne = x.document.createElement("fakeelement");
          if (Ne.style.animationName !== void 0 && (Q = !0), Q === !1) {
            for (var $e = 0; $e < We.length; $e++) if (Ne.style[We[$e] + "AnimationName"] !== void 0) {
              ve = "-" + We[$e].toLowerCase() + "-", Se = De[$e], Q = !0;
              break;
            }
          }
          var Ye = "resizeanim", Ke = "@" + ve + "keyframes " + Ye + " { from { opacity: 0; } to { opacity: 0; } } ", tt = ve + "animation: 1ms " + Ye + "; ";
        }
        return {
          addResizeListener: function(je, He) {
            if (F) je.attachEvent("onresize", He);
            else {
              if (!je.__resizeTriggers__) {
                var ke = je.ownerDocument, ut = x.getComputedStyle(je);
                ut && ut.position == "static" && (je.style.position = "relative"), function(xt) {
                  if (!xt.getElementById("detectElementResize")) {
                    var ft = (Ke || "") + ".resize-triggers { " + (tt || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', vr = xt.head || xt.getElementsByTagName("head")[0], ur = xt.createElement("style");
                    ur.id = "detectElementResize", ur.type = "text/css", I != null && ur.setAttribute("nonce", I), ur.styleSheet ? ur.styleSheet.cssText = ft : ur.appendChild(xt.createTextNode(ft)), vr.appendChild(ur);
                  }
                }(ke), je.__resizeLast__ = {}, je.__resizeListeners__ = [], (je.__resizeTriggers__ = ke.createElement("div")).className = "resize-triggers";
                var Ct = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                if (window.trustedTypes) {
                  var er = trustedTypes.createPolicy("react-virtualized-auto-sizer", {
                    createHTML: function() {
                      return Ct;
                    }
                  });
                  je.__resizeTriggers__.innerHTML = er.createHTML("");
                } else je.__resizeTriggers__.innerHTML = Ct;
                je.appendChild(je.__resizeTriggers__), Y(je), je.addEventListener("scroll", q, !0), Se && (je.__resizeTriggers__.__animationListener__ = function(xt) {
                  xt.animationName == Ye && Y(je);
                }, je.__resizeTriggers__.addEventListener(Se, je.__resizeTriggers__.__animationListener__));
              }
              je.__resizeListeners__.push(He);
            }
          },
          removeResizeListener: function(je, He) {
            if (F) je.detachEvent("onresize", He);
            else if (je.__resizeListeners__.splice(je.__resizeListeners__.indexOf(He), 1), !je.__resizeListeners__.length) {
              je.removeEventListener("scroll", q, !0), je.__resizeTriggers__.__animationListener__ && (je.__resizeTriggers__.removeEventListener(Se, je.__resizeTriggers__.__animationListener__), je.__resizeTriggers__.__animationListener__ = null);
              try {
                je.__resizeTriggers__ = !je.removeChild(je.__resizeTriggers__);
              } catch {
              }
            }
          }
        };
      }
      c(Z, "defaultProps", {
        disabled: !1,
        isControlled: !1,
        mode: "edges",
        scrollToColumn: 0,
        scrollToRow: 0
      }), K(Z);
      var he = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "state", {
            height: x.props.defaultHeight || 0,
            width: x.props.defaultWidth || 0
          }), c(w(x), "_parentNode", void 0), c(w(x), "_autoSizer", void 0), c(w(x), "_window", void 0), c(w(x), "_detectElementResize", void 0), c(w(x), "_onResize", function() {
            var N = x.props, H = N.disableHeight, Y = N.disableWidth, q = N.onResize;
            if (x._parentNode) {
              var Q = x._parentNode.offsetHeight || 0, ve = x._parentNode.offsetWidth || 0, Se = (x._window || window).getComputedStyle(x._parentNode) || {}, We = parseInt(Se.paddingLeft, 10) || 0, De = parseInt(Se.paddingRight, 10) || 0, Ne = parseInt(Se.paddingTop, 10) || 0, $e = parseInt(Se.paddingBottom, 10) || 0, Ye = Q - Ne - $e, Ke = ve - We - De;
              (!H && x.state.height !== Ye || !Y && x.state.width !== Ke) && (x.setState({
                height: Q - Ne - $e,
                width: ve - We - De
              }), q({
                height: Q,
                width: ve
              }));
            }
          }), c(w(x), "_setRef", function(N) {
            x._autoSizer = N;
          }), x;
        }
        return S(I, n.Component), l(I, [{
          key: "componentDidMount",
          value: function() {
            var m = this.props.nonce;
            this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._window = this._autoSizer.parentNode.ownerDocument.defaultView, this._detectElementResize = ee(m, this._window), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.children, T = m.className, P = m.disableHeight, F = m.disableWidth, N = m.style, H = this.state, Y = H.height, q = H.width, Q = {
              overflow: "visible"
            }, ve = {};
            return P || (Q.height = 0, ve.height = Y), F || (Q.width = 0, ve.width = q), n.createElement("div", {
              className: T,
              ref: this._setRef,
              style: g({}, Q, {}, N)
            }, x(ve));
          }
        }]), I;
      }();
      c(he, "defaultProps", {
        onResize: function() {
        },
        disableHeight: !1,
        disableWidth: !1,
        style: {}
      });
      var _e = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "_child", void 0), c(w(x), "_measure", function() {
            var N = x.props, H = N.cache, Y = N.columnIndex, q = Y === void 0 ? 0 : Y, Q = N.parent, ve = N.rowIndex, Se = ve === void 0 ? x.props.index || 0 : ve, We = x._getCellMeasurements(), De = We.height, Ne = We.width;
            De === H.getHeight(Se, q) && Ne === H.getWidth(Se, q) || (H.set(Se, q, Ne, De), Q && typeof Q.recomputeGridSize == "function" && Q.recomputeGridSize({
              columnIndex: q,
              rowIndex: Se
            }));
          }), c(w(x), "_registerChild", function(N) {
            !N || N instanceof Element || console.warn("CellMeasurer registerChild expects to be passed Element or null"), (x._child = N) && x._maybeMeasureCell();
          }), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "componentDidMount",
          value: function() {
            this._maybeMeasureCell();
          }
        }, {
          key: "componentDidUpdate",
          value: function() {
            this._maybeMeasureCell();
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props.children;
            return typeof m == "function" ? m({
              measure: this._measure,
              registerChild: this._registerChild
            }) : m;
          }
        }, {
          key: "_getCellMeasurements",
          value: function() {
            var m = this.props.cache, x = this._child || i.findDOMNode(this);
            if (x && x.ownerDocument && x.ownerDocument.defaultView && x instanceof x.ownerDocument.defaultView.HTMLElement) {
              var T = x.style.width, P = x.style.height;
              m.hasFixedWidth() || (x.style.width = "auto"), m.hasFixedHeight() || (x.style.height = "auto");
              var F = Math.ceil(x.offsetHeight), N = Math.ceil(x.offsetWidth);
              return T && (x.style.width = T), P && (x.style.height = P), {
                height: F,
                width: N
              };
            }
            return {
              height: 0,
              width: 0
            };
          }
        }, {
          key: "_maybeMeasureCell",
          value: function() {
            var m = this.props, x = m.cache, T = m.columnIndex, P = T === void 0 ? 0 : T, F = m.parent, N = m.rowIndex, H = N === void 0 ? this.props.index || 0 : N;
            if (!x.has(H, P)) {
              var Y = this._getCellMeasurements(), q = Y.height, Q = Y.width;
              x.set(H, P, Q, q), F && typeof F.invalidateCellSizeAfterRender == "function" && F.invalidateCellSizeAfterRender({
                columnIndex: P,
                rowIndex: H
              });
            }
          }
        }]), I;
      }();
      c(_e, "__internalCellMeasurerFlag", !1), _e.__internalCellMeasurerFlag = !0;
      var Te = function() {
        function I() {
          var m = this, x = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
          o(this, I), c(this, "_cellHeightCache", {}), c(this, "_cellWidthCache", {}), c(this, "_columnWidthCache", {}), c(this, "_rowHeightCache", {}), c(this, "_defaultHeight", void 0), c(this, "_defaultWidth", void 0), c(this, "_minHeight", void 0), c(this, "_minWidth", void 0), c(this, "_keyMapper", void 0), c(this, "_hasFixedHeight", void 0), c(this, "_hasFixedWidth", void 0), c(this, "_columnCount", 0), c(this, "_rowCount", 0), c(this, "columnWidth", function(Q) {
            var ve = Q.index, Se = m._keyMapper(0, ve);
            return m._columnWidthCache[Se] !== void 0 ? m._columnWidthCache[Se] : m._defaultWidth;
          }), c(this, "rowHeight", function(Q) {
            var ve = Q.index, Se = m._keyMapper(ve, 0);
            return m._rowHeightCache[Se] !== void 0 ? m._rowHeightCache[Se] : m._defaultHeight;
          });
          var T = x.defaultHeight, P = x.defaultWidth, F = x.fixedHeight, N = x.fixedWidth, H = x.keyMapper, Y = x.minHeight, q = x.minWidth;
          this._hasFixedHeight = F === !0, this._hasFixedWidth = N === !0, this._minHeight = Y || 0, this._minWidth = q || 0, this._keyMapper = H || fe, this._defaultHeight = Math.max(this._minHeight, typeof T == "number" ? T : 30), this._defaultWidth = Math.max(this._minWidth, typeof P == "number" ? P : 100), this._hasFixedHeight === !1 && this._hasFixedWidth === !1 && console.warn("CellMeasurerCache should only measure a cell's width or height. You have configured CellMeasurerCache to measure both. This will result in poor performance."), this._hasFixedHeight === !1 && this._defaultHeight === 0 && console.warn("Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. Failing to do so will lead to unnecessary layout and poor performance."), this._hasFixedWidth === !1 && this._defaultWidth === 0 && console.warn("Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. Failing to do so will lead to unnecessary layout and poor performance.");
        }
        return l(I, [{
          key: "clear",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0, P = this._keyMapper(m, T);
            delete this._cellHeightCache[P], delete this._cellWidthCache[P], this._updateCachedColumnAndRowSizes(m, T);
          }
        }, {
          key: "clearAll",
          value: function() {
            this._cellHeightCache = {}, this._cellWidthCache = {}, this._columnWidthCache = {}, this._rowHeightCache = {}, this._rowCount = 0, this._columnCount = 0;
          }
        }, {
          key: "hasFixedHeight",
          value: function() {
            return this._hasFixedHeight;
          }
        }, {
          key: "hasFixedWidth",
          value: function() {
            return this._hasFixedWidth;
          }
        }, {
          key: "getHeight",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0;
            if (this._hasFixedHeight) return this._defaultHeight;
            var P = this._keyMapper(m, T);
            return this._cellHeightCache[P] !== void 0 ? Math.max(this._minHeight, this._cellHeightCache[P]) : this._defaultHeight;
          }
        }, {
          key: "getWidth",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0;
            if (this._hasFixedWidth) return this._defaultWidth;
            var P = this._keyMapper(m, T);
            return this._cellWidthCache[P] !== void 0 ? Math.max(this._minWidth, this._cellWidthCache[P]) : this._defaultWidth;
          }
        }, {
          key: "has",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0, P = this._keyMapper(m, T);
            return this._cellHeightCache[P] !== void 0;
          }
        }, {
          key: "set",
          value: function(m, x, T, P) {
            var F = this._keyMapper(m, x);
            x >= this._columnCount && (this._columnCount = x + 1), m >= this._rowCount && (this._rowCount = m + 1), this._cellHeightCache[F] = P, this._cellWidthCache[F] = T, this._updateCachedColumnAndRowSizes(m, x);
          }
        }, {
          key: "_updateCachedColumnAndRowSizes",
          value: function(m, x) {
            if (!this._hasFixedWidth) {
              for (var T = 0, P = 0; P < this._rowCount; P++) T = Math.max(T, this.getWidth(P, x));
              var F = this._keyMapper(0, x);
              this._columnWidthCache[F] = T;
            }
            if (!this._hasFixedHeight) {
              for (var N = 0, H = 0; H < this._columnCount; H++) N = Math.max(N, this.getHeight(m, H));
              var Y = this._keyMapper(m, 0);
              this._rowHeightCache[Y] = N;
            }
          }
        }, {
          key: "defaultHeight",
          get: function() {
            return this._defaultHeight;
          }
        }, {
          key: "defaultWidth",
          get: function() {
            return this._defaultWidth;
          }
        }]), I;
      }();
      function fe(I, m) {
        return "".concat(I, "-").concat(m);
      }
      function Oe(I) {
        return I && I.__esModule && Object.prototype.hasOwnProperty.call(I, "default") ? I.default : I;
      }
      function ye(I, m) {
        return I(m = {
          exports: {}
        }, m.exports), m.exports;
      }
      var de = ye(function(I, m) {
        Object.defineProperty(m, "__esModule", {
          value: !0
        });
        var x = typeof Symbol == "function" && Symbol.for, T = x ? Symbol.for("react.element") : 60103, P = x ? Symbol.for("react.portal") : 60106, F = x ? Symbol.for("react.fragment") : 60107, N = x ? Symbol.for("react.strict_mode") : 60108, H = x ? Symbol.for("react.profiler") : 60114, Y = x ? Symbol.for("react.provider") : 60109, q = x ? Symbol.for("react.context") : 60110, Q = x ? Symbol.for("react.async_mode") : 60111, ve = x ? Symbol.for("react.concurrent_mode") : 60111, Se = x ? Symbol.for("react.forward_ref") : 60112, We = x ? Symbol.for("react.suspense") : 60113, De = x ? Symbol.for("react.suspense_list") : 60120, Ne = x ? Symbol.for("react.memo") : 60115, $e = x ? Symbol.for("react.lazy") : 60116, Ye = x ? Symbol.for("react.fundamental") : 60117, Ke = x ? Symbol.for("react.responder") : 60118, tt = x ? Symbol.for("react.scope") : 60119;
        function je(ke) {
          if (typeof ke == "object" && ke !== null) {
            var ut = ke.$$typeof;
            switch (ut) {
              case T:
                switch (ke = ke.type) {
                  case Q:
                  case ve:
                  case F:
                  case H:
                  case N:
                  case We:
                    return ke;
                  default:
                    switch (ke = ke && ke.$$typeof) {
                      case q:
                      case Se:
                      case Y:
                        return ke;
                      default:
                        return ut;
                    }
                }
              case $e:
              case Ne:
              case P:
                return ut;
            }
          }
        }
        function He(ke) {
          return je(ke) === ve;
        }
        m.typeOf = je, m.AsyncMode = Q, m.ConcurrentMode = ve, m.ContextConsumer = q, m.ContextProvider = Y, m.Element = T, m.ForwardRef = Se, m.Fragment = F, m.Lazy = $e, m.Memo = Ne, m.Portal = P, m.Profiler = H, m.StrictMode = N, m.Suspense = We, m.isValidElementType = function(ke) {
          return typeof ke == "string" || typeof ke == "function" || ke === F || ke === ve || ke === H || ke === N || ke === We || ke === De || typeof ke == "object" && ke !== null && (ke.$$typeof === $e || ke.$$typeof === Ne || ke.$$typeof === Y || ke.$$typeof === q || ke.$$typeof === Se || ke.$$typeof === Ye || ke.$$typeof === Ke || ke.$$typeof === tt);
        }, m.isAsyncMode = function(ke) {
          return He(ke) || je(ke) === Q;
        }, m.isConcurrentMode = He, m.isContextConsumer = function(ke) {
          return je(ke) === q;
        }, m.isContextProvider = function(ke) {
          return je(ke) === Y;
        }, m.isElement = function(ke) {
          return typeof ke == "object" && ke !== null && ke.$$typeof === T;
        }, m.isForwardRef = function(ke) {
          return je(ke) === Se;
        }, m.isFragment = function(ke) {
          return je(ke) === F;
        }, m.isLazy = function(ke) {
          return je(ke) === $e;
        }, m.isMemo = function(ke) {
          return je(ke) === Ne;
        }, m.isPortal = function(ke) {
          return je(ke) === P;
        }, m.isProfiler = function(ke) {
          return je(ke) === H;
        }, m.isStrictMode = function(ke) {
          return je(ke) === N;
        }, m.isSuspense = function(ke) {
          return je(ke) === We;
        };
      });
      Oe(de), de.typeOf, de.AsyncMode, de.ConcurrentMode, de.ContextConsumer, de.ContextProvider, de.Element, de.ForwardRef, de.Fragment, de.Lazy, de.Memo, de.Portal, de.Profiler, de.StrictMode, de.Suspense, de.isValidElementType, de.isAsyncMode, de.isConcurrentMode, de.isContextConsumer, de.isContextProvider, de.isElement, de.isForwardRef, de.isFragment, de.isLazy, de.isMemo, de.isPortal, de.isProfiler, de.isStrictMode, de.isSuspense;
      var ce = ye(function(I, m) {
        (function() {
          Object.defineProperty(m, "__esModule", {
            value: !0
          });
          var x = typeof Symbol == "function" && Symbol.for, T = x ? Symbol.for("react.element") : 60103, P = x ? Symbol.for("react.portal") : 60106, F = x ? Symbol.for("react.fragment") : 60107, N = x ? Symbol.for("react.strict_mode") : 60108, H = x ? Symbol.for("react.profiler") : 60114, Y = x ? Symbol.for("react.provider") : 60109, q = x ? Symbol.for("react.context") : 60110, Q = x ? Symbol.for("react.async_mode") : 60111, ve = x ? Symbol.for("react.concurrent_mode") : 60111, Se = x ? Symbol.for("react.forward_ref") : 60112, We = x ? Symbol.for("react.suspense") : 60113, De = x ? Symbol.for("react.suspense_list") : 60120, Ne = x ? Symbol.for("react.memo") : 60115, $e = x ? Symbol.for("react.lazy") : 60116, Ye = x ? Symbol.for("react.fundamental") : 60117, Ke = x ? Symbol.for("react.responder") : 60118, tt = x ? Symbol.for("react.scope") : 60119, je = function(yt, Hn) {
            if (!yt) {
              for (var Qn = arguments.length, ro = new Array(2 < Qn ? Qn - 2 : 0), on = 2; on < Qn; on++) ro[on - 2] = arguments[on];
              (function(Gs) {
                for (var wa = arguments.length, Ri = new Array(1 < wa ? wa - 1 : 0), Ii = 1; Ii < wa; Ii++) Ri[Ii - 1] = arguments[Ii];
                var us = 0, Go = "Warning: " + Gs.replace(/%s/g, function() {
                  return Ri[us++];
                });
                typeof console < "u" && console.warn(Go);
                try {
                  throw new Error(Go);
                } catch {
                }
              }).apply(void 0, [Hn].concat(ro));
            }
          };
          function He(yt) {
            if (typeof yt == "object" && yt !== null) {
              var Hn = yt.$$typeof;
              switch (Hn) {
                case T:
                  var Qn = yt.type;
                  switch (Qn) {
                    case Q:
                    case ve:
                    case F:
                    case H:
                    case N:
                    case We:
                      return Qn;
                    default:
                      var ro = Qn && Qn.$$typeof;
                      switch (ro) {
                        case q:
                        case Se:
                        case Y:
                          return ro;
                        default:
                          return Hn;
                      }
                  }
                case $e:
                case Ne:
                case P:
                  return Hn;
              }
            }
          }
          var ke = Q, ut = ve, Ct = q, er = Y, xt = T, ft = Se, vr = F, ur = $e, kr = Ne, yn = P, bo = H, to = N, ls = We, Us = !1;
          function Vr(yt) {
            return He(yt) === ve;
          }
          m.typeOf = He, m.AsyncMode = ke, m.ConcurrentMode = ut, m.ContextConsumer = Ct, m.ContextProvider = er, m.Element = xt, m.ForwardRef = ft, m.Fragment = vr, m.Lazy = ur, m.Memo = kr, m.Portal = yn, m.Profiler = bo, m.StrictMode = to, m.Suspense = ls, m.isValidElementType = function(yt) {
            return typeof yt == "string" || typeof yt == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
            yt === F || yt === ve || yt === H || yt === N || yt === We || yt === De || typeof yt == "object" && yt !== null && (yt.$$typeof === $e || yt.$$typeof === Ne || yt.$$typeof === Y || yt.$$typeof === q || yt.$$typeof === Se || yt.$$typeof === Ye || yt.$$typeof === Ke || yt.$$typeof === tt);
          }, m.isAsyncMode = // AsyncMode should be deprecated
          function(yt) {
            return Us || je(!(Us = !0), "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."), Vr(yt) || He(yt) === Q;
          }, m.isConcurrentMode = Vr, m.isContextConsumer = function(yt) {
            return He(yt) === q;
          }, m.isContextProvider = function(yt) {
            return He(yt) === Y;
          }, m.isElement = function(yt) {
            return typeof yt == "object" && yt !== null && yt.$$typeof === T;
          }, m.isForwardRef = function(yt) {
            return He(yt) === Se;
          }, m.isFragment = function(yt) {
            return He(yt) === F;
          }, m.isLazy = function(yt) {
            return He(yt) === $e;
          }, m.isMemo = function(yt) {
            return He(yt) === Ne;
          }, m.isPortal = function(yt) {
            return He(yt) === P;
          }, m.isProfiler = function(yt) {
            return He(yt) === H;
          }, m.isStrictMode = function(yt) {
            return He(yt) === N;
          }, m.isSuspense = function(yt) {
            return He(yt) === We;
          };
        })();
      });
      Oe(ce), ce.typeOf, ce.AsyncMode, ce.ConcurrentMode, ce.ContextConsumer, ce.ContextProvider, ce.Element, ce.ForwardRef, ce.Fragment, ce.Lazy, ce.Memo, ce.Portal, ce.Profiler, ce.StrictMode, ce.Suspense, ce.isValidElementType, ce.isAsyncMode, ce.isConcurrentMode, ce.isContextConsumer, ce.isContextProvider, ce.isElement, ce.isForwardRef, ce.isFragment, ce.isLazy, ce.isMemo, ce.isPortal, ce.isProfiler, ce.isStrictMode, ce.isSuspense;
      var Fe = ye(function(I) {
        I.exports = ce;
      }), le = Object.getOwnPropertySymbols, J = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable, be, Me = function() {
        try {
          if (!Object.assign) return !1;
          var I = new String("abc");
          if (I[5] = "de", Object.getOwnPropertyNames(I)[0] === "5") return !1;
          for (var m = {}, x = 0; x < 10; x++) m["_" + String.fromCharCode(x)] = x;
          if (Object.getOwnPropertyNames(m).map(function(P) {
            return m[P];
          }).join("") !== "0123456789") return !1;
          var T = {};
          return "abcdefghijklmnopqrst".split("").forEach(function(P) {
            T[P] = P;
          }), Object.keys(Object.assign({}, T)).join("") === "abcdefghijklmnopqrst";
        } catch {
          return !1;
        }
      }() ? Object.assign : function(I, m) {
        for (var x, T, P = function(Y) {
          if (Y == null) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(Y);
        }(I), F = 1; F < arguments.length; F++) {
          for (var N in x = Object(arguments[F])) J.call(x, N) && (P[N] = x[N]);
          if (le) {
            T = le(x);
            for (var H = 0; H < T.length; H++) re.call(x, T[H]) && (P[T[H]] = x[T[H]]);
          }
        }
        return P;
      }, Ae = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Re = {}, Ee = Function.call.bind(Object.prototype.hasOwnProperty);
      function Ce(I, m, x, T, P) {
        for (var F in I) if (Ee(I, F)) {
          var N;
          try {
            if (typeof I[F] != "function") {
              var H = Error((T || "React class") + ": " + x + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[F] + "`.");
              throw H.name = "Invariant Violation", H;
            }
            N = I[F](m, F, T, x, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (q) {
            N = q;
          }
          if (!N || N instanceof Error || be((T || "React class") + ": type specification of " + x + " `" + F + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof N + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), N instanceof Error && !(N.message in Re)) {
            Re[N.message] = !0;
            var Y = P ? P() : "";
            be("Failed " + x + " type: " + N.message + (Y ?? ""));
          }
        }
      }
      be = function(I) {
        var m = "Warning: " + I;
        typeof console < "u" && console.error(m);
        try {
          throw new Error(m);
        } catch {
        }
      }, Ce.resetWarningCache = function() {
        Re = {};
      };
      var X, ie = Ce, Ie = Function.call.bind(Object.prototype.hasOwnProperty);
      function xe() {
        return null;
      }
      X = function(I) {
        var m = "Warning: " + I;
        typeof console < "u" && console.error(m);
        try {
          throw new Error(m);
        } catch {
        }
      };
      function Pe(I, m) {
        var x = typeof Symbol == "function" && Symbol.iterator, T = "@@iterator", P = "<<anonymous>>", F = {
          array: q("array"),
          bool: q("boolean"),
          func: q("function"),
          number: q("number"),
          object: q("object"),
          string: q("string"),
          symbol: q("symbol"),
          any: Y(xe),
          arrayOf: function(De) {
            return Y(function(Ne, $e, Ye, Ke, tt) {
              if (typeof De != "function") return new H("Property `" + tt + "` of component `" + Ye + "` has invalid PropType notation inside arrayOf.");
              var je = Ne[$e];
              if (!Array.isArray(je)) return new H("Invalid " + Ke + " `" + tt + "` of type `" + ve(je) + "` supplied to `" + Ye + "`, expected an array.");
              for (var He = 0; He < je.length; He++) {
                var ke = De(je, He, Ye, Ke, tt + "[" + He + "]", Ae);
                if (ke instanceof Error) return ke;
              }
              return null;
            });
          },
          element: Y(function(De, Ne, $e, Ye, Ke) {
            var tt = De[Ne];
            return I(tt) ? null : new H("Invalid " + Ye + " `" + Ke + "` of type `" + ve(tt) + "` supplied to `" + $e + "`, expected a single ReactElement.");
          }),
          elementType: Y(function(De, Ne, $e, Ye, Ke) {
            var tt = De[Ne];
            return Fe.isValidElementType(tt) ? null : new H("Invalid " + Ye + " `" + Ke + "` of type `" + ve(tt) + "` supplied to `" + $e + "`, expected a single ReactElement type.");
          }),
          instanceOf: function(De) {
            return Y(function(Ne, $e, Ye, Ke, tt) {
              if (Ne[$e] instanceof De) return null;
              var je = De.name || P;
              return new H("Invalid " + Ke + " `" + tt + "` of type `" + // Returns class name of the object, if any.
              function(He) {
                return He.constructor && He.constructor.name ? He.constructor.name : P;
              }(Ne[$e]) + "` supplied to `" + Ye + "`, expected instance of `" + je + "`.");
            });
          },
          node: Y(function(De, Ne, $e, Ye, Ke) {
            return Q(De[Ne]) ? null : new H("Invalid " + Ye + " `" + Ke + "` supplied to `" + $e + "`, expected a ReactNode.");
          }),
          objectOf: function(De) {
            return Y(function(Ne, $e, Ye, Ke, tt) {
              if (typeof De != "function") return new H("Property `" + tt + "` of component `" + Ye + "` has invalid PropType notation inside objectOf.");
              var je = Ne[$e], He = ve(je);
              if (He !== "object") return new H("Invalid " + Ke + " `" + tt + "` of type `" + He + "` supplied to `" + Ye + "`, expected an object.");
              for (var ke in je) if (Ie(je, ke)) {
                var ut = De(je, ke, Ye, Ke, tt + "." + ke, Ae);
                if (ut instanceof Error) return ut;
              }
              return null;
            });
          },
          oneOf: function(De) {
            return Array.isArray(De) ? Y(function(Ne, $e, Ye, Ke, tt) {
              for (var je = Ne[$e], He = 0; He < De.length; He++) if (N(je, De[He])) return null;
              var ke = JSON.stringify(De, function(ut, Ct) {
                return Se(Ct) === "symbol" ? String(Ct) : Ct;
              });
              return new H("Invalid " + Ke + " `" + tt + "` of value `" + String(je) + "` supplied to `" + Ye + "`, expected one of " + ke + ".");
            }) : (X(1 < arguments.length ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), xe);
          },
          oneOfType: function(De) {
            if (!Array.isArray(De)) return X("Invalid argument supplied to oneOfType, expected an instance of array."), xe;
            for (var Ne = 0; Ne < De.length; Ne++) {
              var $e = De[Ne];
              if (typeof $e != "function") return X("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + We($e) + " at index " + Ne + "."), xe;
            }
            return Y(function(Ye, Ke, tt, je, He) {
              for (var ke = 0; ke < De.length; ke++)
                if ((0, De[ke])(Ye, Ke, tt, je, He, Ae) == null) return null;
              return new H("Invalid " + je + " `" + He + "` supplied to `" + tt + "`.");
            });
          },
          shape: function(De) {
            return Y(function(Ne, $e, Ye, Ke, tt) {
              var je = Ne[$e], He = ve(je);
              if (He !== "object") return new H("Invalid " + Ke + " `" + tt + "` of type `" + He + "` supplied to `" + Ye + "`, expected `object`.");
              for (var ke in De) {
                var ut = De[ke];
                if (ut) {
                  var Ct = ut(je, ke, Ye, Ke, tt + "." + ke, Ae);
                  if (Ct) return Ct;
                }
              }
              return null;
            });
          },
          exact: function(De) {
            return Y(function(Ne, $e, Ye, Ke, tt) {
              var je = Ne[$e], He = ve(je);
              if (He !== "object") return new H("Invalid " + Ke + " `" + tt + "` of type `" + He + "` supplied to `" + Ye + "`, expected `object`.");
              var ke = Me({}, Ne[$e], De);
              for (var ut in ke) {
                var Ct = De[ut];
                if (!Ct) return new H("Invalid " + Ke + " `" + tt + "` key `" + ut + "` supplied to `" + Ye + "`.\nBad object: " + JSON.stringify(Ne[$e], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(De), null, "  "));
                var er = Ct(je, ut, Ye, Ke, tt + "." + ut, Ae);
                if (er) return er;
              }
              return null;
            });
          }
        };
        function N(De, Ne) {
          return De === Ne ? De !== 0 || 1 / De == 1 / Ne : De != De && Ne != Ne;
        }
        function H(De) {
          this.message = De, this.stack = "";
        }
        function Y(De) {
          function Ne(Ye, Ke, tt, je, He, ke, ut) {
            if (je = je || P, ke = ke || tt, ut !== Ae) {
              var Ct = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw Ct.name = "Invariant Violation", Ct;
            }
            return Ke[tt] == null ? Ye ? Ke[tt] === null ? new H("The " + He + " `" + ke + "` is marked as required in `" + je + "`, but its value is `null`.") : new H("The " + He + " `" + ke + "` is marked as required in `" + je + "`, but its value is `undefined`.") : null : De(Ke, tt, je, He, ke);
          }
          var $e = Ne.bind(null, !1);
          return $e.isRequired = Ne.bind(null, !0), $e;
        }
        function q(De) {
          return Y(function(Ne, $e, Ye, Ke, tt, je) {
            var He = Ne[$e];
            return ve(He) === De ? null : new H("Invalid " + Ke + " `" + tt + "` of type `" + Se(He) + "` supplied to `" + Ye + "`, expected `" + De + "`.");
          });
        }
        function Q(De) {
          switch (typeof De) {
            case "number":
            case "string":
            case "undefined":
              return !0;
            case "boolean":
              return !De;
            case "object":
              if (Array.isArray(De)) return De.every(Q);
              if (De === null || I(De)) return !0;
              var Ne = (
                // Before Symbol spec.
                /**
                * Returns the iterator method function contained on the iterable object.
                *
                * Be sure to invoke the function with the iterable as context:
                *
                *     var iteratorFn = getIteratorFn(myIterable);
                *     if (iteratorFn) {
                *       var iterator = iteratorFn.call(myIterable);
                *       ...
                *     }
                *
                * @param {?object} maybeIterable
                * @return {?function}
                */
                function(tt) {
                  var je = tt && (x && tt[x] || tt[T]);
                  if (typeof je == "function") return je;
                }(De)
              );
              if (!Ne) return !1;
              var $e, Ye = Ne.call(De);
              if (Ne !== De.entries) {
                for (; !($e = Ye.next()).done; ) if (!Q($e.value)) return !1;
              } else
                for (; !($e = Ye.next()).done; ) {
                  var Ke = $e.value;
                  if (Ke && !Q(Ke[1])) return !1;
                }
              return !0;
            default:
              return !1;
          }
        }
        function ve(De) {
          var Ne = typeof De;
          return Array.isArray(De) ? "array" : De instanceof RegExp ? "object" : function($e, Ye) {
            return $e === "symbol" || // falsy value can't be a Symbol
            !!Ye && // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            (Ye["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Ye instanceof Symbol);
          }(Ne, De) ? "symbol" : Ne;
        }
        function Se(De) {
          if (De == null) return "" + De;
          var Ne = ve(De);
          if (Ne === "object") {
            if (De instanceof Date) return "date";
            if (De instanceof RegExp) return "regexp";
          }
          return Ne;
        }
        function We(De) {
          var Ne = Se(De);
          switch (Ne) {
            case "array":
            case "object":
              return "an " + Ne;
            case "boolean":
            case "date":
            case "regexp":
              return "a " + Ne;
            default:
              return Ne;
          }
        }
        return H.prototype = Error.prototype, F.checkPropTypes = ie, F.resetWarningCache = ie.resetWarningCache, F.PropTypes = F;
      }
      var ae = ye(function(I) {
        var m = Fe;
        I.exports = Pe(m.isElement);
      });
      function rt(I) {
        var m, x, T = "";
        if (I) if (typeof I == "object") if (I.push) for (m = 0; m < I.length; m++) I[m] && (x = rt(I[m])) && (T && (T += " "), T += x);
        else for (m in I) I[m] && (x = rt(m)) && (T && (T += " "), T += x);
        else typeof I == "boolean" || I.call || (T && (T += " "), T += I);
        return T;
      }
      function Ze() {
        for (var I, m = 0, x = ""; m < arguments.length; ) (I = rt(arguments[m++])) && (x && (x += " "), x += I);
        return x;
      }
      function ht(I) {
        var m = !(0 < arguments.length && I !== void 0) || I, x = {};
        return function(T) {
          var P = T.callback, F = T.indices, N = Object.keys(F), H = !m || N.every(function(q) {
            var Q = F[q];
            return Array.isArray(Q) ? 0 < Q.length : 0 <= Q;
          }), Y = N.length !== Object.keys(x).length || N.some(function(q) {
            var Q = x[q], ve = F[q];
            return Array.isArray(ve) ? Q.join(",") !== ve.join(",") : Q !== ve;
          });
          x = F, H && Y && P(F);
        };
      }
      var mt, At = !(typeof window > "u" || !window.document || !window.document.createElement);
      function Bt(I) {
        if ((!mt && mt !== 0 || I) && At) {
          var m = document.createElement("div");
          m.style.position = "absolute", m.style.top = "-9999px", m.style.width = "50px", m.style.height = "50px", m.style.overflow = "scroll", document.body.appendChild(m), mt = m.offsetWidth - m.clientWidth, document.body.removeChild(m);
        }
        return mt;
      }
      var Gt = "observed", It = "requested", sr = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "state", {
            isScrolling: !1,
            scrollLeft: 0,
            scrollTop: 0
          }), c(w(x), "_calculateSizeAndPositionDataOnNextUpdate", !1), c(w(x), "_onSectionRenderedMemoizer", ht()), c(w(x), "_onScrollMemoizer", ht(!1)), c(w(x), "_invokeOnSectionRenderedHelper", function() {
            var N = x.props, H = N.cellLayoutManager, Y = N.onSectionRendered;
            x._onSectionRenderedMemoizer({
              callback: Y,
              indices: {
                indices: H.getLastRenderedIndices()
              }
            });
          }), c(w(x), "_setScrollingContainerRef", function(N) {
            x._scrollingContainer = N;
          }), c(w(x), "_updateScrollPositionForScrollToCell", function() {
            var N = x.props, H = N.cellLayoutManager, Y = N.height, q = N.scrollToAlignment, Q = N.scrollToCell, ve = N.width, Se = x.state, We = Se.scrollLeft, De = Se.scrollTop;
            if (0 <= Q) {
              var Ne = H.getScrollPositionForCell({
                align: q,
                cellIndex: Q,
                height: Y,
                scrollLeft: We,
                scrollTop: De,
                width: ve
              });
              Ne.scrollLeft === We && Ne.scrollTop === De || x._setScrollPosition(Ne);
            }
          }), c(w(x), "_onScroll", function(N) {
            if (N.target === x._scrollingContainer) {
              x._enablePointerEventsAfterDelay();
              var H = x.props, Y = H.cellLayoutManager, q = H.height, Q = H.isScrollingChange, ve = H.width, Se = x._scrollbarSize, We = Y.getTotalSize(), De = We.height, Ne = We.width, $e = Math.max(0, Math.min(Ne - ve + Se, N.target.scrollLeft)), Ye = Math.max(0, Math.min(De - q + Se, N.target.scrollTop));
              if (x.state.scrollLeft !== $e || x.state.scrollTop !== Ye) {
                var Ke = N.cancelable ? Gt : It;
                x.state.isScrolling || Q(!0), x.setState({
                  isScrolling: !0,
                  scrollLeft: $e,
                  scrollPositionChangeReason: Ke,
                  scrollTop: Ye
                });
              }
              x._invokeOnScrollMemoizer({
                scrollLeft: $e,
                scrollTop: Ye,
                totalWidth: Ne,
                totalHeight: De
              });
            }
          }), x._scrollbarSize = Bt(), x._scrollbarSize === void 0 ? (x._scrollbarSizeMeasured = !1, x._scrollbarSize = 0) : x._scrollbarSizeMeasured = !0, x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "recomputeCellSizesAndPositions",
          value: function() {
            this._calculateSizeAndPositionDataOnNextUpdate = !0, this.forceUpdate();
          }
        }, {
          key: "componentDidMount",
          value: function() {
            var m = this.props, x = m.cellLayoutManager, T = m.scrollLeft, P = m.scrollToCell, F = m.scrollTop;
            this._scrollbarSizeMeasured || (this._scrollbarSize = Bt(), this._scrollbarSizeMeasured = !0, this.setState({})), 0 <= P ? this._updateScrollPositionForScrollToCell() : (0 <= T || 0 <= F) && this._setScrollPosition({
              scrollLeft: T,
              scrollTop: F
            }), this._invokeOnSectionRenderedHelper();
            var N = x.getTotalSize(), H = N.height, Y = N.width;
            this._invokeOnScrollMemoizer({
              scrollLeft: T || 0,
              scrollTop: F || 0,
              totalHeight: H,
              totalWidth: Y
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function(m, x) {
            var T = this.props, P = T.height, F = T.scrollToAlignment, N = T.scrollToCell, H = T.width, Y = this.state, q = Y.scrollLeft, Q = Y.scrollPositionChangeReason, ve = Y.scrollTop;
            Q === It && (0 <= q && q !== x.scrollLeft && q !== this._scrollingContainer.scrollLeft && (this._scrollingContainer.scrollLeft = q), 0 <= ve && ve !== x.scrollTop && ve !== this._scrollingContainer.scrollTop && (this._scrollingContainer.scrollTop = ve)), P === m.height && F === m.scrollToAlignment && N === m.scrollToCell && H === m.width || this._updateScrollPositionForScrollToCell(), this._invokeOnSectionRenderedHelper();
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId);
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.autoHeight, T = m.cellCount, P = m.cellLayoutManager, F = m.className, N = m.height, H = m.horizontalOverscanSize, Y = m.id, q = m.noContentRenderer, Q = m.style, ve = m.verticalOverscanSize, Se = m.width, We = this.state, De = We.isScrolling, Ne = We.scrollLeft, $e = We.scrollTop;
            this._lastRenderedCellCount === T && this._lastRenderedCellLayoutManager === P && !this._calculateSizeAndPositionDataOnNextUpdate || (this._lastRenderedCellCount = T, this._lastRenderedCellLayoutManager = P, this._calculateSizeAndPositionDataOnNextUpdate = !1, P.calculateSizeAndPositionData());
            var Ye = P.getTotalSize(), Ke = Ye.height, tt = Ye.width, je = Math.max(0, Ne - H), He = Math.max(0, $e - ve), ke = Math.min(tt, Ne + Se + H), ut = Math.min(Ke, $e + N + ve), Ct = 0 < N && 0 < Se ? P.cellRenderers({
              height: ut - He,
              isScrolling: De,
              width: ke - je,
              x: je,
              y: He
            }) : [], er = {
              boxSizing: "border-box",
              direction: "ltr",
              height: x ? "auto" : N,
              position: "relative",
              WebkitOverflowScrolling: "touch",
              width: Se,
              willChange: "transform"
            }, xt = N < Ke ? this._scrollbarSize : 0, ft = Se < tt ? this._scrollbarSize : 0;
            return er.overflowX = tt + xt <= Se ? "hidden" : "auto", er.overflowY = Ke + ft <= N ? "hidden" : "auto", n.createElement("div", {
              ref: this._setScrollingContainerRef,
              "aria-label": this.props["aria-label"],
              className: Ze("ReactVirtualized__Collection", F),
              id: Y,
              onScroll: this._onScroll,
              role: "grid",
              style: g({}, er, {}, Q),
              tabIndex: 0
            }, 0 < T && n.createElement("div", {
              className: "ReactVirtualized__Collection__innerScrollContainer",
              style: {
                height: Ke,
                maxHeight: Ke,
                maxWidth: tt,
                overflow: "hidden",
                pointerEvents: De ? "none" : "",
                width: tt
              }
            }, Ct), T === 0 && q());
          }
        }, {
          key: "_enablePointerEventsAfterDelay",
          value: function() {
            var m = this;
            this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = setTimeout(function() {
              (0, m.props.isScrollingChange)(!1), m._disablePointerEventsTimeoutId = null, m.setState({
                isScrolling: !1
              });
            }, 150);
          }
        }, {
          key: "_invokeOnScrollMemoizer",
          value: function(m) {
            var x = this, T = m.scrollLeft, P = m.scrollTop, F = m.totalHeight, N = m.totalWidth;
            this._onScrollMemoizer({
              callback: function(H) {
                var Y = H.scrollLeft, q = H.scrollTop, Q = x.props, ve = Q.height;
                (0, Q.onScroll)({
                  clientHeight: ve,
                  clientWidth: Q.width,
                  scrollHeight: F,
                  scrollLeft: Y,
                  scrollTop: q,
                  scrollWidth: N
                });
              },
              indices: {
                scrollLeft: T,
                scrollTop: P
              }
            });
          }
        }, {
          key: "_setScrollPosition",
          value: function(m) {
            var x = m.scrollLeft, T = m.scrollTop, P = {
              scrollPositionChangeReason: It
            };
            0 <= x && (P.scrollLeft = x), 0 <= T && (P.scrollTop = T), (0 <= x && x !== this.state.scrollLeft || 0 <= T && T !== this.state.scrollTop) && this.setState(P);
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function(m, x) {
            return m.cellCount !== 0 || x.scrollLeft === 0 && x.scrollTop === 0 ? m.scrollLeft !== x.scrollLeft || m.scrollTop !== x.scrollTop ? {
              scrollLeft: m.scrollLeft != null ? m.scrollLeft : x.scrollLeft,
              scrollTop: m.scrollTop != null ? m.scrollTop : x.scrollTop,
              scrollPositionChangeReason: It
            } : null : {
              scrollLeft: 0,
              scrollTop: 0,
              scrollPositionChangeReason: It
            };
          }
        }]), I;
      }();
      c(sr, "propTypes", {
        "aria-label": ae.string,
        autoHeight: ae.bool,
        cellCount: ae.number.isRequired,
        cellLayoutManager: ae.object.isRequired,
        className: ae.string,
        height: ae.number.isRequired,
        id: ae.string,
        horizontalOverscanSize: ae.number.isRequired,
        isScrollingChange: ae.func,
        noContentRenderer: ae.func.isRequired,
        onScroll: ae.func.isRequired,
        onSectionRendered: ae.func.isRequired,
        scrollLeft: ae.number,
        scrollToAlignment: ae.oneOf(["auto", "end", "start", "center"]).isRequired,
        scrollToCell: ae.number.isRequired,
        scrollTop: ae.number,
        style: ae.object,
        verticalOverscanSize: ae.number.isRequired,
        width: ae.number.isRequired
      }), c(sr, "defaultProps", {
        "aria-label": "grid",
        horizontalOverscanSize: 0,
        noContentRenderer: function() {
          return null;
        },
        onScroll: function() {
          return null;
        },
        onSectionRendered: function() {
          return null;
        },
        scrollToAlignment: "auto",
        scrollToCell: -1,
        style: {},
        verticalOverscanSize: 0
      }), K(sr);
      var et = function() {
        function I(m) {
          var x = m.height, T = m.width, P = m.x, F = m.y;
          o(this, I), this.height = x, this.width = T, this.x = P, this.y = F, this._indexMap = {}, this._indices = [];
        }
        return l(I, [{
          key: "addCellIndex",
          value: function(m) {
            var x = m.index;
            this._indexMap[x] || (this._indexMap[x] = !0, this._indices.push(x));
          }
        }, {
          key: "getCellIndices",
          value: function() {
            return this._indices;
          }
        }, {
          key: "toString",
          value: function() {
            return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
          }
        }]), I;
      }(), at = function() {
        function I() {
          var m = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : 100;
          o(this, I), this._sectionSize = m, this._cellMetadata = [], this._sections = {};
        }
        return l(I, [{
          key: "getCellIndices",
          value: function(m) {
            var x = m.height, T = m.width, P = m.x, F = m.y, N = {};
            return this.getSections({
              height: x,
              width: T,
              x: P,
              y: F
            }).forEach(function(H) {
              return H.getCellIndices().forEach(function(Y) {
                N[Y] = Y;
              });
            }), Object.keys(N).map(function(H) {
              return N[H];
            });
          }
        }, {
          key: "getCellMetadata",
          value: function(m) {
            var x = m.index;
            return this._cellMetadata[x];
          }
        }, {
          key: "getSections",
          value: function(m) {
            for (var x = m.height, T = m.width, P = m.x, F = m.y, N = Math.floor(P / this._sectionSize), H = Math.floor((P + T - 1) / this._sectionSize), Y = Math.floor(F / this._sectionSize), q = Math.floor((F + x - 1) / this._sectionSize), Q = [], ve = N; ve <= H; ve++) for (var Se = Y; Se <= q; Se++) {
              var We = "".concat(ve, ".").concat(Se);
              this._sections[We] || (this._sections[We] = new et({
                height: this._sectionSize,
                width: this._sectionSize,
                x: ve * this._sectionSize,
                y: Se * this._sectionSize
              })), Q.push(this._sections[We]);
            }
            return Q;
          }
        }, {
          key: "getTotalSectionCount",
          value: function() {
            return Object.keys(this._sections).length;
          }
        }, {
          key: "toString",
          value: function() {
            var m = this;
            return Object.keys(this._sections).map(function(x) {
              return m._sections[x].toString();
            });
          }
        }, {
          key: "registerCell",
          value: function(m) {
            var x = m.cellMetadatum, T = m.index;
            this._cellMetadata[T] = x, this.getSections(x).forEach(function(P) {
              return P.addCellIndex({
                index: T
              });
            });
          }
        }]), I;
      }();
      function Qt(I) {
        var m = I.align, x = m === void 0 ? "auto" : m, T = I.cellOffset, P = I.cellSize, F = I.containerSize, N = I.currentOffset, H = T, Y = H - F + P;
        switch (x) {
          case "start":
            return H;
          case "end":
            return Y;
          case "center":
            return H - (F - P) / 2;
          default:
            return Math.max(Y, Math.min(H, N));
        }
      }
      var pr = function() {
        function I(m, x) {
          var T;
          return o(this, I), (T = C(this, b(I).call(this, m, x)))._cellMetadata = [], T._lastRenderedCellIndices = [], T._cellCache = [], T._isScrollingChange = T._isScrollingChange.bind(w(T)), T._setCollectionViewRef = T._setCollectionViewRef.bind(w(T)), T;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "forceUpdate",
          value: function() {
            this._collectionView !== void 0 && this._collectionView.forceUpdate();
          }
        }, {
          key: "recomputeCellSizesAndPositions",
          value: function() {
            this._cellCache = [], this._collectionView.recomputeCellSizesAndPositions();
          }
        }, {
          key: "render",
          value: function() {
            var m = f({}, this.props);
            return n.createElement(sr, f({
              cellLayoutManager: this,
              isScrollingChange: this._isScrollingChange,
              ref: this._setCollectionViewRef
            }, m));
          }
        }, {
          key: "calculateSizeAndPositionData",
          value: function() {
            var m = this.props, x = function(T) {
              for (var P = T.cellCount, F = T.cellSizeAndPositionGetter, N = T.sectionSize, H = [], Y = new at(N), q = 0, Q = 0, ve = 0; ve < P; ve++) {
                var Se = F({
                  index: ve
                });
                if (Se.height == null || isNaN(Se.height) || Se.width == null || isNaN(Se.width) || Se.x == null || isNaN(Se.x) || Se.y == null || isNaN(Se.y)) throw Error("Invalid metadata returned for cell ".concat(ve, `:
        x:`).concat(Se.x, ", y:").concat(Se.y, ", width:").concat(Se.width, ", height:").concat(Se.height));
                q = Math.max(q, Se.y + Se.height), Q = Math.max(Q, Se.x + Se.width), H[ve] = Se, Y.registerCell({
                  cellMetadatum: Se,
                  index: ve
                });
              }
              return {
                cellMetadata: H,
                height: q,
                sectionManager: Y,
                width: Q
              };
            }({
              cellCount: m.cellCount,
              cellSizeAndPositionGetter: m.cellSizeAndPositionGetter,
              sectionSize: m.sectionSize
            });
            this._cellMetadata = x.cellMetadata, this._sectionManager = x.sectionManager, this._height = x.height, this._width = x.width;
          }
        }, {
          key: "getLastRenderedIndices",
          value: function() {
            return this._lastRenderedCellIndices;
          }
        }, {
          key: "getScrollPositionForCell",
          value: function(m) {
            var x = m.align, T = m.cellIndex, P = m.height, F = m.scrollLeft, N = m.scrollTop, H = m.width, Y = this.props.cellCount;
            if (0 <= T && T < Y) {
              var q = this._cellMetadata[T];
              F = Qt({
                align: x,
                cellOffset: q.x,
                cellSize: q.width,
                containerSize: H,
                currentOffset: F
              }), N = Qt({
                align: x,
                cellOffset: q.y,
                cellSize: q.height,
                containerSize: P,
                currentOffset: N
              });
            }
            return {
              scrollLeft: F,
              scrollTop: N
            };
          }
        }, {
          key: "getTotalSize",
          value: function() {
            return {
              height: this._height,
              width: this._width
            };
          }
        }, {
          key: "cellRenderers",
          value: function(m) {
            var x = this, T = m.height, P = m.isScrolling, F = m.width, N = m.x, H = m.y, Y = this.props, q = Y.cellGroupRenderer, Q = Y.cellRenderer;
            return this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
              height: T,
              width: F,
              x: N,
              y: H
            }), q({
              cellCache: this._cellCache,
              cellRenderer: Q,
              cellSizeAndPositionGetter: function(ve) {
                var Se = ve.index;
                return x._sectionManager.getCellMetadata({
                  index: Se
                });
              },
              indices: this._lastRenderedCellIndices,
              isScrolling: P
            });
          }
        }, {
          key: "_isScrollingChange",
          value: function(m) {
            m || (this._cellCache = []);
          }
        }, {
          key: "_setCollectionViewRef",
          value: function(m) {
            this._collectionView = m;
          }
        }]), I;
      }();
      c(pr, "propTypes", {
        "aria-label": ae.string,
        cellCount: ae.number.isRequired,
        cellGroupRenderer: ae.func.isRequired,
        cellRenderer: ae.func.isRequired,
        cellSizeAndPositionGetter: ae.func.isRequired,
        sectionSize: ae.number
      }), c(pr, "defaultProps", {
        "aria-label": "grid",
        cellGroupRenderer: function(I) {
          var m = I.cellCache, x = I.cellRenderer, T = I.cellSizeAndPositionGetter, P = I.indices, F = I.isScrolling;
          return P.map(function(N) {
            var H = T({
              index: N
            }), Y = {
              index: N,
              isScrolling: F,
              key: N,
              style: {
                height: H.height,
                left: H.x,
                position: "absolute",
                top: H.y,
                width: H.width
              }
            };
            return F ? (N in m || (m[N] = x(Y)), m[N]) : x(Y);
          }).filter(function(N) {
            return !!N;
          });
        }
      });
      var wr = function() {
        function I(m, x) {
          var T;
          return o(this, I), (T = C(this, b(I).call(this, m, x)))._registerChild = T._registerChild.bind(w(T)), T;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "componentDidUpdate",
          value: function(m) {
            var x = this.props, T = x.columnMaxWidth, P = x.columnMinWidth, F = x.columnCount, N = x.width;
            T === m.columnMaxWidth && P === m.columnMinWidth && F === m.columnCount && N === m.width || this._registeredChild && this._registeredChild.recomputeGridSize();
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.children, T = m.columnMaxWidth, P = m.columnMinWidth, F = m.columnCount, N = m.width, H = P || 1, Y = T ? Math.min(T, N) : N, q = N / F;
            return q = Math.max(H, q), q = Math.min(Y, q), q = Math.floor(q), x({
              adjustedWidth: Math.min(N, q * F),
              columnWidth: q,
              getColumnWidth: function() {
                return q;
              },
              registerChild: this._registerChild
            });
          }
        }, {
          key: "_registerChild",
          value: function(m) {
            if (m && typeof m.recomputeGridSize != "function") throw Error("Unexpected child type registered; only Grid/MultiGrid children are supported.");
            this._registeredChild = m, this._registeredChild && this._registeredChild.recomputeGridSize();
          }
        }]), I;
      }();
      function gt(I) {
        var m = I.cellCount, x = I.cellSize, T = I.computeMetadataCallback, P = I.computeMetadataCallbackProps, F = I.nextCellsCount, N = I.nextCellSize, H = I.nextScrollToIndex, Y = I.scrollToIndex, q = I.updateScrollOffsetForScrollToIndex;
        m === F && (typeof x != "number" && typeof N != "number" || x === N) || (T(P), 0 <= Y && Y === H && q());
      }
      c(wr, "propTypes", {
        children: ae.func.isRequired,
        columnMaxWidth: ae.number,
        columnMinWidth: ae.number,
        columnCount: ae.number.isRequired,
        width: ae.number.isRequired
      });
      var hr, Nn = function() {
        function I(m) {
          var x = m.cellCount, T = m.cellSizeGetter, P = m.estimatedCellSize;
          o(this, I), c(this, "_cellSizeAndPositionData", {}), c(this, "_lastMeasuredIndex", -1), c(this, "_lastBatchedIndex", -1), c(this, "_cellCount", void 0), c(this, "_cellSizeGetter", void 0), c(this, "_estimatedCellSize", void 0), this._cellSizeGetter = T, this._cellCount = x, this._estimatedCellSize = P;
        }
        return l(I, [{
          key: "areOffsetsAdjusted",
          value: function() {
            return !1;
          }
        }, {
          key: "configure",
          value: function(m) {
            var x = m.cellCount, T = m.estimatedCellSize, P = m.cellSizeGetter;
            this._cellCount = x, this._estimatedCellSize = T, this._cellSizeGetter = P;
          }
        }, {
          key: "getCellCount",
          value: function() {
            return this._cellCount;
          }
        }, {
          key: "getEstimatedCellSize",
          value: function() {
            return this._estimatedCellSize;
          }
        }, {
          key: "getLastMeasuredIndex",
          value: function() {
            return this._lastMeasuredIndex;
          }
        }, {
          key: "getOffsetAdjustment",
          value: function() {
            return 0;
          }
        }, {
          key: "getSizeAndPositionOfCell",
          value: function(m) {
            if (m < 0 || m >= this._cellCount) throw Error("Requested index ".concat(m, " is outside of range 0..").concat(this._cellCount));
            if (m > this._lastMeasuredIndex) for (var x = this.getSizeAndPositionOfLastMeasuredCell(), T = x.offset + x.size, P = this._lastMeasuredIndex + 1; P <= m; P++) {
              var F = this._cellSizeGetter({
                index: P
              });
              if (F === void 0 || isNaN(F)) throw Error("Invalid size returned for cell ".concat(P, " of value ").concat(F));
              F === null ? (this._cellSizeAndPositionData[P] = {
                offset: T,
                size: 0
              }, this._lastBatchedIndex = m) : (this._cellSizeAndPositionData[P] = {
                offset: T,
                size: F
              }, T += F, this._lastMeasuredIndex = m);
            }
            return this._cellSizeAndPositionData[m];
          }
        }, {
          key: "getSizeAndPositionOfLastMeasuredCell",
          value: function() {
            return 0 <= this._lastMeasuredIndex ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
              offset: 0,
              size: 0
            };
          }
        }, {
          key: "getTotalSize",
          value: function() {
            var m = this.getSizeAndPositionOfLastMeasuredCell();
            return m.offset + m.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
          }
        }, {
          key: "getUpdatedOffsetForIndex",
          value: function(m) {
            var x = m.align, T = x === void 0 ? "auto" : x, P = m.containerSize, F = m.currentOffset, N = m.targetIndex;
            if (P <= 0) return 0;
            var H, Y = this.getSizeAndPositionOfCell(N), q = Y.offset, Q = q - P + Y.size;
            switch (T) {
              case "start":
                H = q;
                break;
              case "end":
                H = Q;
                break;
              case "center":
                H = q - (P - Y.size) / 2;
                break;
              default:
                H = Math.max(Q, Math.min(q, F));
            }
            var ve = this.getTotalSize();
            return Math.max(0, Math.min(ve - P, H));
          }
        }, {
          key: "getVisibleCellRange",
          value: function(m) {
            var x = m.containerSize, T = m.offset;
            if (this.getTotalSize() === 0) return {};
            var P = T + x, F = this._findNearestCell(T), N = this.getSizeAndPositionOfCell(F);
            T = N.offset + N.size;
            for (var H = F; T < P && H < this._cellCount - 1; ) H++, T += this.getSizeAndPositionOfCell(H).size;
            return {
              start: F,
              stop: H
            };
          }
        }, {
          key: "resetCell",
          value: function(m) {
            this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, m - 1);
          }
        }, {
          key: "_binarySearch",
          value: function(m, x, T) {
            for (; x <= m; ) {
              var P = x + Math.floor((m - x) / 2), F = this.getSizeAndPositionOfCell(P).offset;
              if (F === T) return P;
              F < T ? x = P + 1 : T < F && (m = P - 1);
            }
            return 0 < x ? x - 1 : 0;
          }
        }, {
          key: "_exponentialSearch",
          value: function(m, x) {
            for (var T = 1; m < this._cellCount && this.getSizeAndPositionOfCell(m).offset < x; ) m += T, T *= 2;
            return this._binarySearch(Math.min(m, this._cellCount - 1), Math.floor(m / 2), x);
          }
        }, {
          key: "_findNearestCell",
          value: function(m) {
            if (isNaN(m)) throw Error("Invalid offset ".concat(m, " specified"));
            m = Math.max(0, m);
            var x = this.getSizeAndPositionOfLastMeasuredCell(), T = Math.max(0, this._lastMeasuredIndex);
            return x.offset >= m ? this._binarySearch(T, 0, m) : this._exponentialSearch(T, m);
          }
        }]), I;
      }(), hn = function() {
        return typeof window < "u" && window.chrome ? 16777100 : 15e5;
      }, cn = function() {
        function I(m) {
          var x = m.maxScrollSize, T = x === void 0 ? hn() : x, P = v(m, ["maxScrollSize"]);
          o(this, I), c(this, "_cellSizeAndPositionManager", void 0), c(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new Nn(P), this._maxScrollSize = T;
        }
        return l(I, [{
          key: "areOffsetsAdjusted",
          value: function() {
            return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
          }
        }, {
          key: "configure",
          value: function(m) {
            this._cellSizeAndPositionManager.configure(m);
          }
        }, {
          key: "getCellCount",
          value: function() {
            return this._cellSizeAndPositionManager.getCellCount();
          }
        }, {
          key: "getEstimatedCellSize",
          value: function() {
            return this._cellSizeAndPositionManager.getEstimatedCellSize();
          }
        }, {
          key: "getLastMeasuredIndex",
          value: function() {
            return this._cellSizeAndPositionManager.getLastMeasuredIndex();
          }
        }, {
          key: "getOffsetAdjustment",
          value: function(m) {
            var x = m.containerSize, T = m.offset, P = this._cellSizeAndPositionManager.getTotalSize(), F = this.getTotalSize(), N = this._getOffsetPercentage({
              containerSize: x,
              offset: T,
              totalSize: F
            });
            return Math.round(N * (F - P));
          }
        }, {
          key: "getSizeAndPositionOfCell",
          value: function(m) {
            return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(m);
          }
        }, {
          key: "getSizeAndPositionOfLastMeasuredCell",
          value: function() {
            return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
          }
        }, {
          key: "getTotalSize",
          value: function() {
            return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
          }
        }, {
          key: "getUpdatedOffsetForIndex",
          value: function(m) {
            var x = m.align, T = x === void 0 ? "auto" : x, P = m.containerSize, F = m.currentOffset, N = m.targetIndex;
            F = this._safeOffsetToOffset({
              containerSize: P,
              offset: F
            });
            var H = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: T,
              containerSize: P,
              currentOffset: F,
              targetIndex: N
            });
            return this._offsetToSafeOffset({
              containerSize: P,
              offset: H
            });
          }
        }, {
          key: "getVisibleCellRange",
          value: function(m) {
            var x = m.containerSize, T = m.offset;
            return T = this._safeOffsetToOffset({
              containerSize: x,
              offset: T
            }), this._cellSizeAndPositionManager.getVisibleCellRange({
              containerSize: x,
              offset: T
            });
          }
        }, {
          key: "resetCell",
          value: function(m) {
            this._cellSizeAndPositionManager.resetCell(m);
          }
        }, {
          key: "_getOffsetPercentage",
          value: function(m) {
            var x = m.containerSize, T = m.offset, P = m.totalSize;
            return P <= x ? 0 : T / (P - x);
          }
        }, {
          key: "_offsetToSafeOffset",
          value: function(m) {
            var x = m.containerSize, T = m.offset, P = this._cellSizeAndPositionManager.getTotalSize(), F = this.getTotalSize();
            if (P === F) return T;
            var N = this._getOffsetPercentage({
              containerSize: x,
              offset: T,
              totalSize: P
            });
            return Math.round(N * (F - x));
          }
        }, {
          key: "_safeOffsetToOffset",
          value: function(m) {
            var x = m.containerSize, T = m.offset, P = this._cellSizeAndPositionManager.getTotalSize(), F = this.getTotalSize();
            if (P === F) return T;
            var N = this._getOffsetPercentage({
              containerSize: x,
              offset: T,
              totalSize: F
            });
            return Math.round(N * (P - x));
          }
        }]), I;
      }();
      function gn(I) {
        var m = I.cellCount, x = I.overscanCellsCount, T = I.scrollDirection, P = I.startIndex, F = I.stopIndex;
        return T === 1 ? {
          overscanStartIndex: Math.max(0, P),
          overscanStopIndex: Math.min(m - 1, F + x)
        } : {
          overscanStartIndex: Math.max(0, P - x),
          overscanStopIndex: Math.min(m - 1, F)
        };
      }
      function tn(I) {
        var m = I.cellSize, x = I.cellSizeAndPositionManager, T = I.previousCellsCount, P = I.previousCellSize, F = I.previousScrollToAlignment, N = I.previousScrollToIndex, H = I.previousSize, Y = I.scrollOffset, q = I.scrollToAlignment, Q = I.scrollToIndex, ve = I.size, Se = I.sizeJustIncreasedFromZero, We = I.updateScrollIndexCallback, De = x.getCellCount(), Ne = 0 <= Q && Q < De;
        Ne && (ve !== H || Se || !P || typeof m == "number" && m !== P || q !== F || Q !== N) ? We(Q) : !Ne && 0 < De && (ve < H || De < T) && Y > x.getTotalSize() - ve && We(De - 1);
      }
      function rr(I) {
        for (var m = I.cellCache, x = I.cellRenderer, T = I.columnSizeAndPositionManager, P = I.columnStartIndex, F = I.columnStopIndex, N = I.deferredMeasurementCache, H = I.horizontalOffsetAdjustment, Y = I.isScrolling, q = I.isScrollingOptOut, Q = I.parent, ve = I.rowSizeAndPositionManager, Se = I.rowStartIndex, We = I.rowStopIndex, De = I.styleCache, Ne = I.verticalOffsetAdjustment, $e = I.visibleColumnIndices, Ye = I.visibleRowIndices, Ke = [], tt = T.areOffsetsAdjusted() || ve.areOffsetsAdjusted(), je = !Y && !tt, He = Se; He <= We; He++) for (var ke = ve.getSizeAndPositionOfCell(He), ut = P; ut <= F; ut++) {
          var Ct = T.getSizeAndPositionOfCell(ut), er = ut >= $e.start && ut <= $e.stop && He >= Ye.start && He <= Ye.stop, xt = "".concat(He, "-").concat(ut), ft = void 0;
          je && De[xt] ? ft = De[xt] : N && !N.has(He, ut) ? ft = {
            height: "auto",
            left: 0,
            position: "absolute",
            top: 0,
            width: "auto"
          } : (ft = {
            height: ke.size,
            left: Ct.offset + H,
            position: "absolute",
            top: ke.offset + Ne,
            width: Ct.size
          }, De[xt] = ft);
          var vr = {
            columnIndex: ut,
            isScrolling: Y,
            isVisible: er,
            key: xt,
            parent: Q,
            rowIndex: He,
            style: ft
          }, ur = void 0;
          (ur = !q && !Y || H || Ne ? x(vr) : (m[xt] || (m[xt] = x(vr)), m[xt])) != null && ur !== !1 && (Tn(Q, ur), Ke.push(ur));
        }
        return Ke;
      }
      function Tn(I, m) {
        m && (m.type && m.type.__internalCellMeasurerFlag && (m = m.props.children), m && m.props && m.props.style === void 0 && I.__warnedAboutMissingStyle !== !0 && (I.__warnedAboutMissingStyle = !0, console.warn("Rendered cell should include style property for positioning.")));
      }
      var xr = (hr = typeof window < "u" ? window : typeof self < "u" ? self : {}).requestAnimationFrame || hr.webkitRequestAnimationFrame || hr.mozRequestAnimationFrame || hr.oRequestAnimationFrame || hr.msRequestAnimationFrame || function(I) {
        return hr.setTimeout(I, 1e3 / 60);
      }, Xi = hr.cancelAnimationFrame || hr.webkitCancelAnimationFrame || hr.mozCancelAnimationFrame || hr.oCancelAnimationFrame || hr.msCancelAnimationFrame || function(I) {
        hr.clearTimeout(I);
      }, Ti = xr, Gr = Xi, jn = function(I) {
        return Gr(I.id);
      }, vn = function(I, m) {
        var x;
        Promise.resolve().then(function() {
          x = Date.now();
        });
        var T = {
          id: Ti(function P() {
            Date.now() - x >= m ? I.call() : T.id = Ti(P);
          })
        };
        return T;
      }, Ji = "observed", di = "requested", dn = function() {
        function I(m) {
          var x;
          o(this, I), c(w(x = C(this, b(I).call(this, m))), "_onGridRenderedMemoizer", ht()), c(w(x), "_onScrollMemoizer", ht(!1)), c(w(x), "_deferredInvalidateColumnIndex", null), c(w(x), "_deferredInvalidateRowIndex", null), c(w(x), "_recomputeScrollLeftFlag", !1), c(w(x), "_recomputeScrollTopFlag", !1), c(w(x), "_horizontalScrollBarSize", 0), c(w(x), "_verticalScrollBarSize", 0), c(w(x), "_scrollbarPresenceChanged", !1), c(w(x), "_scrollingContainer", void 0), c(w(x), "_childrenToDisplay", void 0), c(w(x), "_columnStartIndex", void 0), c(w(x), "_columnStopIndex", void 0), c(w(x), "_rowStartIndex", void 0), c(w(x), "_rowStopIndex", void 0), c(w(x), "_renderedColumnStartIndex", 0), c(w(x), "_renderedColumnStopIndex", 0), c(w(x), "_renderedRowStartIndex", 0), c(w(x), "_renderedRowStopIndex", 0), c(w(x), "_initialScrollTop", void 0), c(w(x), "_initialScrollLeft", void 0), c(w(x), "_disablePointerEventsTimeoutId", void 0), c(w(x), "_styleCache", {}), c(w(x), "_cellCache", {}), c(w(x), "_debounceScrollEndedCallback", function() {
            x._disablePointerEventsTimeoutId = null, x.setState({
              isScrolling: !1,
              needToResetStyleCache: !1
            });
          }), c(w(x), "_invokeOnGridRenderedHelper", function() {
            var F = x.props.onSectionRendered;
            x._onGridRenderedMemoizer({
              callback: F,
              indices: {
                columnOverscanStartIndex: x._columnStartIndex,
                columnOverscanStopIndex: x._columnStopIndex,
                columnStartIndex: x._renderedColumnStartIndex,
                columnStopIndex: x._renderedColumnStopIndex,
                rowOverscanStartIndex: x._rowStartIndex,
                rowOverscanStopIndex: x._rowStopIndex,
                rowStartIndex: x._renderedRowStartIndex,
                rowStopIndex: x._renderedRowStopIndex
              }
            });
          }), c(w(x), "_setScrollingContainerRef", function(F) {
            x._scrollingContainer = F;
          }), c(w(x), "_onScroll", function(F) {
            F.target === x._scrollingContainer && x.handleScrollEvent(F.target);
          });
          var T = new cn({
            cellCount: m.columnCount,
            cellSizeGetter: function(F) {
              return I._wrapSizeGetter(m.columnWidth)(F);
            },
            estimatedCellSize: I._getEstimatedColumnSize(m)
          }), P = new cn({
            cellCount: m.rowCount,
            cellSizeGetter: function(F) {
              return I._wrapSizeGetter(m.rowHeight)(F);
            },
            estimatedCellSize: I._getEstimatedRowSize(m)
          });
          return x.state = {
            instanceProps: {
              columnSizeAndPositionManager: T,
              rowSizeAndPositionManager: P,
              prevColumnWidth: m.columnWidth,
              prevRowHeight: m.rowHeight,
              prevColumnCount: m.columnCount,
              prevRowCount: m.rowCount,
              prevIsScrolling: m.isScrolling === !0,
              prevScrollToColumn: m.scrollToColumn,
              prevScrollToRow: m.scrollToRow,
              scrollbarSize: 0,
              scrollbarSizeMeasured: !1
            },
            isScrolling: !1,
            scrollDirectionHorizontal: 1,
            scrollDirectionVertical: 1,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: !1
          }, 0 < m.scrollToRow && (x._initialScrollTop = x._getCalculatedScrollTop(m, x.state)), 0 < m.scrollToColumn && (x._initialScrollLeft = x._getCalculatedScrollLeft(m, x.state)), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "getOffsetForCell",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.alignment, P = T === void 0 ? this.props.scrollToAlignment : T, F = x.columnIndex, N = F === void 0 ? this.props.scrollToColumn : F, H = x.rowIndex, Y = H === void 0 ? this.props.scrollToRow : H, q = g({}, this.props, {
              scrollToAlignment: P,
              scrollToColumn: N,
              scrollToRow: Y
            });
            return {
              scrollLeft: this._getCalculatedScrollLeft(q),
              scrollTop: this._getCalculatedScrollTop(q)
            };
          }
        }, {
          key: "getTotalRowsHeight",
          value: function() {
            return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
          }
        }, {
          key: "getTotalColumnsWidth",
          value: function() {
            return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
          }
        }, {
          key: "handleScrollEvent",
          value: function(m) {
            var x = m.scrollLeft, T = x === void 0 ? 0 : x, P = m.scrollTop, F = P === void 0 ? 0 : P;
            if (!(F < 0)) {
              this._debounceScrollEnded();
              var N = this.props, H = N.autoHeight, Y = N.autoWidth, q = N.height, Q = N.width, ve = this.state.instanceProps, Se = ve.scrollbarSize, We = ve.rowSizeAndPositionManager.getTotalSize(), De = ve.columnSizeAndPositionManager.getTotalSize(), Ne = Math.min(Math.max(0, De - Q + Se), T), $e = Math.min(Math.max(0, We - q + Se), F);
              if (this.state.scrollLeft !== Ne || this.state.scrollTop !== $e) {
                var Ye = {
                  isScrolling: !0,
                  scrollDirectionHorizontal: Ne !== this.state.scrollLeft ? Ne > this.state.scrollLeft ? 1 : -1 : this.state.scrollDirectionHorizontal,
                  scrollDirectionVertical: $e !== this.state.scrollTop ? $e > this.state.scrollTop ? 1 : -1 : this.state.scrollDirectionVertical,
                  scrollPositionChangeReason: Ji
                };
                H || (Ye.scrollTop = $e), Y || (Ye.scrollLeft = Ne), Ye.needToResetStyleCache = !1, this.setState(Ye);
              }
              this._invokeOnScrollMemoizer({
                scrollLeft: Ne,
                scrollTop: $e,
                totalColumnsWidth: De,
                totalRowsHeight: We
              });
            }
          }
        }, {
          key: "invalidateCellSizeAfterRender",
          value: function(m) {
            var x = m.columnIndex, T = m.rowIndex;
            this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, x) : x, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, T) : T;
          }
        }, {
          key: "measureAllCells",
          value: function() {
            var m = this.props, x = m.columnCount, T = m.rowCount, P = this.state.instanceProps;
            P.columnSizeAndPositionManager.getSizeAndPositionOfCell(x - 1), P.rowSizeAndPositionManager.getSizeAndPositionOfCell(T - 1);
          }
        }, {
          key: "recomputeGridSize",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.columnIndex, P = T === void 0 ? 0 : T, F = x.rowIndex, N = F === void 0 ? 0 : F, H = this.props, Y = H.scrollToColumn, q = H.scrollToRow, Q = this.state.instanceProps;
            Q.columnSizeAndPositionManager.resetCell(P), Q.rowSizeAndPositionManager.resetCell(N), this._recomputeScrollLeftFlag = 0 <= Y && (this.state.scrollDirectionHorizontal === 1 ? P <= Y : Y <= P), this._recomputeScrollTopFlag = 0 <= q && (this.state.scrollDirectionVertical === 1 ? N <= q : q <= N), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
          }
        }, {
          key: "scrollToCell",
          value: function(m) {
            var x = m.columnIndex, T = m.rowIndex, P = this.props.columnCount, F = this.props;
            1 < P && x !== void 0 && this._updateScrollLeftForScrollToColumn(g({}, F, {
              scrollToColumn: x
            })), T !== void 0 && this._updateScrollTopForScrollToRow(g({}, F, {
              scrollToRow: T
            }));
          }
        }, {
          key: "componentDidMount",
          value: function() {
            var m = this.props, x = m.getScrollbarSize, T = m.height, P = m.scrollLeft, F = m.scrollToColumn, N = m.scrollTop, H = m.scrollToRow, Y = m.width, q = this.state.instanceProps;
            if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), q.scrollbarSizeMeasured || this.setState(function(Se) {
              var We = g({}, Se, {
                needToResetStyleCache: !1
              });
              return We.instanceProps.scrollbarSize = x(), We.instanceProps.scrollbarSizeMeasured = !0, We;
            }), typeof P == "number" && 0 <= P || typeof N == "number" && 0 <= N) {
              var Q = I._getScrollToPositionStateUpdate({
                prevState: this.state,
                scrollLeft: P,
                scrollTop: N
              });
              Q && (Q.needToResetStyleCache = !1, this.setState(Q));
            }
            this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
            var ve = 0 < T && 0 < Y;
            0 <= F && ve && this._updateScrollLeftForScrollToColumn(), 0 <= H && ve && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
              scrollLeft: P || 0,
              scrollTop: N || 0,
              totalColumnsWidth: q.columnSizeAndPositionManager.getTotalSize(),
              totalRowsHeight: q.rowSizeAndPositionManager.getTotalSize()
            }), this._maybeCallOnScrollbarPresenceChange();
          }
        }, {
          key: "componentDidUpdate",
          value: function(m, x) {
            var T = this, P = this.props, F = P.autoHeight, N = P.autoWidth, H = P.columnCount, Y = P.height, q = P.rowCount, Q = P.scrollToAlignment, ve = P.scrollToColumn, Se = P.scrollToRow, We = P.width, De = this.state, Ne = De.scrollLeft, $e = De.scrollPositionChangeReason, Ye = De.scrollTop, Ke = De.instanceProps;
            this._handleInvalidatedGridSize();
            var tt = 0 < H && m.columnCount === 0 || 0 < q && m.rowCount === 0;
            $e === di && (!N && 0 <= Ne && (Ne !== this._scrollingContainer.scrollLeft || tt) && (this._scrollingContainer.scrollLeft = Ne), !F && 0 <= Ye && (Ye !== this._scrollingContainer.scrollTop || tt) && (this._scrollingContainer.scrollTop = Ye));
            var je = (m.width === 0 || m.height === 0) && 0 < Y && 0 < We;
            if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : tn({
              cellSizeAndPositionManager: Ke.columnSizeAndPositionManager,
              previousCellsCount: m.columnCount,
              previousCellSize: m.columnWidth,
              previousScrollToAlignment: m.scrollToAlignment,
              previousScrollToIndex: m.scrollToColumn,
              previousSize: m.width,
              scrollOffset: Ne,
              scrollToAlignment: Q,
              scrollToIndex: ve,
              size: We,
              sizeJustIncreasedFromZero: je,
              updateScrollIndexCallback: function() {
                return T._updateScrollLeftForScrollToColumn(T.props);
              }
            }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : tn({
              cellSizeAndPositionManager: Ke.rowSizeAndPositionManager,
              previousCellsCount: m.rowCount,
              previousCellSize: m.rowHeight,
              previousScrollToAlignment: m.scrollToAlignment,
              previousScrollToIndex: m.scrollToRow,
              previousSize: m.height,
              scrollOffset: Ye,
              scrollToAlignment: Q,
              scrollToIndex: Se,
              size: Y,
              sizeJustIncreasedFromZero: je,
              updateScrollIndexCallback: function() {
                return T._updateScrollTopForScrollToRow(T.props);
              }
            }), this._invokeOnGridRenderedHelper(), Ne !== x.scrollLeft || Ye !== x.scrollTop) {
              var He = Ke.rowSizeAndPositionManager.getTotalSize(), ke = Ke.columnSizeAndPositionManager.getTotalSize();
              this._invokeOnScrollMemoizer({
                scrollLeft: Ne,
                scrollTop: Ye,
                totalColumnsWidth: ke,
                totalRowsHeight: He
              });
            }
            this._maybeCallOnScrollbarPresenceChange();
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this._disablePointerEventsTimeoutId && jn(this._disablePointerEventsTimeoutId);
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.autoContainerWidth, T = m.autoHeight, P = m.autoWidth, F = m.className, N = m.containerProps, H = m.containerRole, Y = m.containerStyle, q = m.height, Q = m.id, ve = m.noContentRenderer, Se = m.role, We = m.style, De = m.tabIndex, Ne = m.width, $e = this.state, Ye = $e.instanceProps, Ke = $e.needToResetStyleCache, tt = this._isScrolling(), je = {
              boxSizing: "border-box",
              direction: "ltr",
              height: T ? "auto" : q,
              position: "relative",
              width: P ? "auto" : Ne,
              WebkitOverflowScrolling: "touch",
              willChange: "transform"
            };
            Ke && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
            var He = Ye.columnSizeAndPositionManager.getTotalSize(), ke = Ye.rowSizeAndPositionManager.getTotalSize(), ut = q < ke ? Ye.scrollbarSize : 0, Ct = Ne < He ? Ye.scrollbarSize : 0;
            Ct === this._horizontalScrollBarSize && ut === this._verticalScrollBarSize || (this._horizontalScrollBarSize = Ct, this._verticalScrollBarSize = ut, this._scrollbarPresenceChanged = !0), je.overflowX = He + ut <= Ne ? "hidden" : "auto", je.overflowY = ke + Ct <= q ? "hidden" : "auto";
            var er = this._childrenToDisplay, xt = er.length === 0 && 0 < q && 0 < Ne;
            return n.createElement("div", f({
              ref: this._setScrollingContainerRef
            }, N, {
              "aria-label": this.props["aria-label"],
              "aria-readonly": this.props["aria-readonly"],
              className: Ze("ReactVirtualized__Grid", F),
              id: Q,
              onScroll: this._onScroll,
              role: Se,
              style: g({}, je, {}, We),
              tabIndex: De
            }), 0 < er.length && n.createElement("div", {
              className: "ReactVirtualized__Grid__innerScrollContainer",
              role: H,
              style: g({
                width: x ? "auto" : He,
                height: ke,
                maxWidth: He,
                maxHeight: ke,
                overflow: "hidden",
                pointerEvents: tt ? "none" : "",
                position: "relative"
              }, Y)
            }, er), xt && ve());
          }
        }, {
          key: "_calculateChildrenToRender",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state, F = T.cellRenderer, N = T.cellRangeRenderer, H = T.columnCount, Y = T.deferredMeasurementCache, q = T.height, Q = T.overscanColumnCount, ve = T.overscanIndicesGetter, Se = T.overscanRowCount, We = T.rowCount, De = T.width, Ne = T.isScrollingOptOut, $e = P.scrollDirectionHorizontal, Ye = P.scrollDirectionVertical, Ke = P.instanceProps, tt = 0 < this._initialScrollTop ? this._initialScrollTop : P.scrollTop, je = 0 < this._initialScrollLeft ? this._initialScrollLeft : P.scrollLeft, He = this._isScrolling(T, P);
            if (this._childrenToDisplay = [], 0 < q && 0 < De) {
              var ke = Ke.columnSizeAndPositionManager.getVisibleCellRange({
                containerSize: De,
                offset: je
              }), ut = Ke.rowSizeAndPositionManager.getVisibleCellRange({
                containerSize: q,
                offset: tt
              }), Ct = Ke.columnSizeAndPositionManager.getOffsetAdjustment({
                containerSize: De,
                offset: je
              }), er = Ke.rowSizeAndPositionManager.getOffsetAdjustment({
                containerSize: q,
                offset: tt
              });
              this._renderedColumnStartIndex = ke.start, this._renderedColumnStopIndex = ke.stop, this._renderedRowStartIndex = ut.start, this._renderedRowStopIndex = ut.stop;
              var xt = ve({
                direction: "horizontal",
                cellCount: H,
                overscanCellsCount: Q,
                scrollDirection: $e,
                startIndex: typeof ke.start == "number" ? ke.start : 0,
                stopIndex: typeof ke.stop == "number" ? ke.stop : -1
              }), ft = ve({
                direction: "vertical",
                cellCount: We,
                overscanCellsCount: Se,
                scrollDirection: Ye,
                startIndex: typeof ut.start == "number" ? ut.start : 0,
                stopIndex: typeof ut.stop == "number" ? ut.stop : -1
              }), vr = xt.overscanStartIndex, ur = xt.overscanStopIndex, kr = ft.overscanStartIndex, yn = ft.overscanStopIndex;
              if (Y) {
                if (!Y.hasFixedHeight()) {
                  for (var bo = kr; bo <= yn; bo++) if (!Y.has(bo, 0)) {
                    vr = 0, ur = H - 1;
                    break;
                  }
                }
                if (!Y.hasFixedWidth()) {
                  for (var to = vr; to <= ur; to++) if (!Y.has(0, to)) {
                    kr = 0, yn = We - 1;
                    break;
                  }
                }
              }
              this._childrenToDisplay = N({
                cellCache: this._cellCache,
                cellRenderer: F,
                columnSizeAndPositionManager: Ke.columnSizeAndPositionManager,
                columnStartIndex: vr,
                columnStopIndex: ur,
                deferredMeasurementCache: Y,
                horizontalOffsetAdjustment: Ct,
                isScrolling: He,
                isScrollingOptOut: Ne,
                parent: this,
                rowSizeAndPositionManager: Ke.rowSizeAndPositionManager,
                rowStartIndex: kr,
                rowStopIndex: yn,
                scrollLeft: je,
                scrollTop: tt,
                styleCache: this._styleCache,
                verticalOffsetAdjustment: er,
                visibleColumnIndices: ke,
                visibleRowIndices: ut
              }), this._columnStartIndex = vr, this._columnStopIndex = ur, this._rowStartIndex = kr, this._rowStopIndex = yn;
            }
          }
        }, {
          key: "_debounceScrollEnded",
          value: function() {
            var m = this.props.scrollingResetTimeInterval;
            this._disablePointerEventsTimeoutId && jn(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = vn(this._debounceScrollEndedCallback, m);
          }
        }, {
          key: "_handleInvalidatedGridSize",
          value: function() {
            if (typeof this._deferredInvalidateColumnIndex == "number" && typeof this._deferredInvalidateRowIndex == "number") {
              var m = this._deferredInvalidateColumnIndex, x = this._deferredInvalidateRowIndex;
              this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
                columnIndex: m,
                rowIndex: x
              });
            }
          }
        }, {
          key: "_invokeOnScrollMemoizer",
          value: function(m) {
            var x = this, T = m.scrollLeft, P = m.scrollTop, F = m.totalColumnsWidth, N = m.totalRowsHeight;
            this._onScrollMemoizer({
              callback: function(H) {
                var Y = H.scrollLeft, q = H.scrollTop, Q = x.props, ve = Q.height;
                (0, Q.onScroll)({
                  clientHeight: ve,
                  clientWidth: Q.width,
                  scrollHeight: N,
                  scrollLeft: Y,
                  scrollTop: q,
                  scrollWidth: F
                });
              },
              indices: {
                scrollLeft: T,
                scrollTop: P
              }
            });
          }
        }, {
          key: "_isScrolling",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state;
            return Object.hasOwnProperty.call(T, "isScrolling") ? !!T.isScrolling : !!P.isScrolling;
          }
        }, {
          key: "_maybeCallOnScrollbarPresenceChange",
          value: function() {
            if (this._scrollbarPresenceChanged) {
              var m = this.props.onScrollbarPresenceChange;
              this._scrollbarPresenceChanged = !1, m({
                horizontal: 0 < this._horizontalScrollBarSize,
                size: this.state.instanceProps.scrollbarSize,
                vertical: 0 < this._verticalScrollBarSize
              });
            }
          }
        }, {
          key: "scrollToPosition",
          value: function(m) {
            var x = m.scrollLeft, T = m.scrollTop, P = I._getScrollToPositionStateUpdate({
              prevState: this.state,
              scrollLeft: x,
              scrollTop: T
            });
            P && (P.needToResetStyleCache = !1, this.setState(P));
          }
        }, {
          key: "_getCalculatedScrollLeft",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state;
            return I._getCalculatedScrollLeft(T, P);
          }
        }, {
          key: "_updateScrollLeftForScrollToColumn",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state, F = I._getScrollLeftForScrollToColumnStateUpdate(T, P);
            F && (F.needToResetStyleCache = !1, this.setState(F));
          }
        }, {
          key: "_getCalculatedScrollTop",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state;
            return I._getCalculatedScrollTop(T, P);
          }
        }, {
          key: "_resetStyleCache",
          value: function() {
            var m = this._styleCache, x = this._cellCache, T = this.props.isScrollingOptOut;
            this._cellCache = {}, this._styleCache = {};
            for (var P = this._rowStartIndex; P <= this._rowStopIndex; P++) for (var F = this._columnStartIndex; F <= this._columnStopIndex; F++) {
              var N = "".concat(P, "-").concat(F);
              this._styleCache[N] = m[N], T && (this._cellCache[N] = x[N]);
            }
          }
        }, {
          key: "_updateScrollTopForScrollToRow",
          value: function(m, x) {
            var T = 0 < arguments.length && m !== void 0 ? m : this.props, P = 1 < arguments.length && x !== void 0 ? x : this.state, F = I._getScrollTopForScrollToRowStateUpdate(T, P);
            F && (F.needToResetStyleCache = !1, this.setState(F));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function(m, x) {
            var T = {};
            m.columnCount === 0 && x.scrollLeft !== 0 || m.rowCount === 0 && x.scrollTop !== 0 ? (T.scrollLeft = 0, T.scrollTop = 0) : (m.scrollLeft !== x.scrollLeft && m.scrollToColumn < 0 || m.scrollTop !== x.scrollTop && m.scrollToRow < 0) && Object.assign(T, I._getScrollToPositionStateUpdate({
              prevState: x,
              scrollLeft: m.scrollLeft,
              scrollTop: m.scrollTop
            }));
            var P, F, N = x.instanceProps;
            return T.needToResetStyleCache = !1, m.columnWidth === N.prevColumnWidth && m.rowHeight === N.prevRowHeight || (T.needToResetStyleCache = !0), N.columnSizeAndPositionManager.configure({
              cellCount: m.columnCount,
              estimatedCellSize: I._getEstimatedColumnSize(m),
              cellSizeGetter: I._wrapSizeGetter(m.columnWidth)
            }), N.rowSizeAndPositionManager.configure({
              cellCount: m.rowCount,
              estimatedCellSize: I._getEstimatedRowSize(m),
              cellSizeGetter: I._wrapSizeGetter(m.rowHeight)
            }), N.prevColumnCount !== 0 && N.prevRowCount !== 0 || (N.prevColumnCount = 0, N.prevRowCount = 0), m.autoHeight && m.isScrolling === !1 && N.prevIsScrolling === !0 && Object.assign(T, {
              isScrolling: !1
            }), gt({
              cellCount: N.prevColumnCount,
              cellSize: typeof N.prevColumnWidth == "number" ? N.prevColumnWidth : null,
              computeMetadataCallback: function() {
                return N.columnSizeAndPositionManager.resetCell(0);
              },
              computeMetadataCallbackProps: m,
              nextCellsCount: m.columnCount,
              nextCellSize: typeof m.columnWidth == "number" ? m.columnWidth : null,
              nextScrollToIndex: m.scrollToColumn,
              scrollToIndex: N.prevScrollToColumn,
              updateScrollOffsetForScrollToIndex: function() {
                P = I._getScrollLeftForScrollToColumnStateUpdate(m, x);
              }
            }), gt({
              cellCount: N.prevRowCount,
              cellSize: typeof N.prevRowHeight == "number" ? N.prevRowHeight : null,
              computeMetadataCallback: function() {
                return N.rowSizeAndPositionManager.resetCell(0);
              },
              computeMetadataCallbackProps: m,
              nextCellsCount: m.rowCount,
              nextCellSize: typeof m.rowHeight == "number" ? m.rowHeight : null,
              nextScrollToIndex: m.scrollToRow,
              scrollToIndex: N.prevScrollToRow,
              updateScrollOffsetForScrollToIndex: function() {
                F = I._getScrollTopForScrollToRowStateUpdate(m, x);
              }
            }), N.prevColumnCount = m.columnCount, N.prevColumnWidth = m.columnWidth, N.prevIsScrolling = m.isScrolling === !0, N.prevRowCount = m.rowCount, N.prevRowHeight = m.rowHeight, N.prevScrollToColumn = m.scrollToColumn, N.prevScrollToRow = m.scrollToRow, N.scrollbarSize = m.getScrollbarSize(), N.scrollbarSize === void 0 ? (N.scrollbarSizeMeasured = !1, N.scrollbarSize = 0) : N.scrollbarSizeMeasured = !0, T.instanceProps = N, g({}, T, {}, P, {}, F);
          }
        }, {
          key: "_getEstimatedColumnSize",
          value: function(m) {
            return typeof m.columnWidth == "number" ? m.columnWidth : m.estimatedColumnSize;
          }
        }, {
          key: "_getEstimatedRowSize",
          value: function(m) {
            return typeof m.rowHeight == "number" ? m.rowHeight : m.estimatedRowSize;
          }
        }, {
          key: "_getScrollToPositionStateUpdate",
          value: function(m) {
            var x = m.prevState, T = m.scrollLeft, P = m.scrollTop, F = {
              scrollPositionChangeReason: di
            };
            return typeof T == "number" && 0 <= T && (F.scrollDirectionHorizontal = T > x.scrollLeft ? 1 : -1, F.scrollLeft = T), typeof P == "number" && 0 <= P && (F.scrollDirectionVertical = P > x.scrollTop ? 1 : -1, F.scrollTop = P), typeof T == "number" && 0 <= T && T !== x.scrollLeft || typeof P == "number" && 0 <= P && P !== x.scrollTop ? F : {};
          }
        }, {
          key: "_wrapSizeGetter",
          value: function(m) {
            return typeof m == "function" ? m : function() {
              return m;
            };
          }
        }, {
          key: "_getCalculatedScrollLeft",
          value: function(m, x) {
            var T = m.columnCount, P = m.height, F = m.scrollToAlignment, N = m.scrollToColumn, H = m.width, Y = x.scrollLeft, q = x.instanceProps;
            if (0 < T) {
              var Q = T - 1, ve = N < 0 ? Q : Math.min(Q, N), Se = q.rowSizeAndPositionManager.getTotalSize(), We = q.scrollbarSizeMeasured && P < Se ? q.scrollbarSize : 0;
              return q.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                align: F,
                containerSize: H - We,
                currentOffset: Y,
                targetIndex: ve
              });
            }
            return 0;
          }
        }, {
          key: "_getScrollLeftForScrollToColumnStateUpdate",
          value: function(m, x) {
            var T = x.scrollLeft, P = I._getCalculatedScrollLeft(m, x);
            return typeof P == "number" && 0 <= P && T !== P ? I._getScrollToPositionStateUpdate({
              prevState: x,
              scrollLeft: P,
              scrollTop: -1
            }) : {};
          }
        }, {
          key: "_getCalculatedScrollTop",
          value: function(m, x) {
            var T = m.height, P = m.rowCount, F = m.scrollToAlignment, N = m.scrollToRow, H = m.width, Y = x.scrollTop, q = x.instanceProps;
            if (0 < P) {
              var Q = P - 1, ve = N < 0 ? Q : Math.min(Q, N), Se = q.columnSizeAndPositionManager.getTotalSize(), We = q.scrollbarSizeMeasured && H < Se ? q.scrollbarSize : 0;
              return q.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                align: F,
                containerSize: T - We,
                currentOffset: Y,
                targetIndex: ve
              });
            }
            return 0;
          }
        }, {
          key: "_getScrollTopForScrollToRowStateUpdate",
          value: function(m, x) {
            var T = x.scrollTop, P = I._getCalculatedScrollTop(m, x);
            return typeof P == "number" && 0 <= P && T !== P ? I._getScrollToPositionStateUpdate({
              prevState: x,
              scrollLeft: -1,
              scrollTop: P
            }) : {};
          }
        }]), I;
      }();
      c(dn, "defaultProps", {
        "aria-label": "grid",
        "aria-readonly": !0,
        autoContainerWidth: !1,
        autoHeight: !1,
        autoWidth: !1,
        cellRangeRenderer: rr,
        containerRole: "rowgroup",
        containerStyle: {},
        estimatedColumnSize: 100,
        estimatedRowSize: 30,
        getScrollbarSize: Bt,
        noContentRenderer: function() {
          return null;
        },
        onScroll: function() {
        },
        onScrollbarPresenceChange: function() {
        },
        onSectionRendered: function() {
        },
        overscanColumnCount: 0,
        overscanIndicesGetter: gn,
        overscanRowCount: 10,
        role: "grid",
        scrollingResetTimeInterval: 150,
        scrollToAlignment: "auto",
        scrollToColumn: -1,
        scrollToRow: -1,
        style: {},
        tabIndex: 0,
        isScrollingOptOut: !1
      }), K(dn);
      function fi(I) {
        var m = I.cellCount, x = I.overscanCellsCount, T = I.scrollDirection, P = I.startIndex, F = I.stopIndex;
        return x = Math.max(1, x), T === 1 ? {
          overscanStartIndex: Math.max(0, P - 1),
          overscanStopIndex: Math.min(m - 1, F + x)
        } : {
          overscanStartIndex: Math.max(0, P - x),
          overscanStopIndex: Math.min(m - 1, F + 1)
        };
      }
      var Oi = function() {
        function I(m, x) {
          var T;
          return o(this, I), (T = C(this, b(I).call(this, m, x)))._loadMoreRowsMemoizer = ht(), T._onRowsRendered = T._onRowsRendered.bind(w(T)), T._registerChild = T._registerChild.bind(w(T)), T;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "resetLoadMoreRowsCache",
          value: function(m) {
            this._loadMoreRowsMemoizer = ht(), m && this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
          }
        }, {
          key: "render",
          value: function() {
            return (0, this.props.children)({
              onRowsRendered: this._onRowsRendered,
              registerChild: this._registerChild
            });
          }
        }, {
          key: "_loadUnloadedRanges",
          value: function(m) {
            var x = this, T = this.props.loadMoreRows;
            m.forEach(function(P) {
              var F = T(P);
              F && F.then(function() {
                (function(N) {
                  var H = N.lastRenderedStartIndex, Y = N.lastRenderedStopIndex, q = N.startIndex, Q = N.stopIndex;
                  return !(Y < q || Q < H);
                })({
                  lastRenderedStartIndex: x._lastRenderedStartIndex,
                  lastRenderedStopIndex: x._lastRenderedStopIndex,
                  startIndex: P.startIndex,
                  stopIndex: P.stopIndex
                }) && x._registeredChild && function(N) {
                  var H = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 0, Y = typeof N.recomputeGridSize == "function" ? N.recomputeGridSize : N.recomputeRowHeights;
                  Y ? Y.call(N, H) : N.forceUpdate();
                }(x._registeredChild, x._lastRenderedStartIndex);
              });
            });
          }
        }, {
          key: "_onRowsRendered",
          value: function(m) {
            var x = m.startIndex, T = m.stopIndex;
            this._lastRenderedStartIndex = x, this._lastRenderedStopIndex = T, this._doStuff(x, T);
          }
        }, {
          key: "_doStuff",
          value: function(m, x) {
            var T, P = this, F = this.props, N = F.isRowLoaded, H = F.minimumBatchSize, Y = F.rowCount, q = F.threshold, Q = function(Se) {
              for (var We = Se.isRowLoaded, De = Se.minimumBatchSize, Ne = Se.rowCount, $e = Se.startIndex, Ye = Se.stopIndex, Ke = [], tt = null, je = null, He = $e; He <= Ye; He++)
                We({
                  index: He
                }) ? je !== null && (Ke.push({
                  startIndex: tt,
                  stopIndex: je
                }), tt = je = null) : (je = He, tt === null && (tt = He));
              if (je !== null) {
                for (var ke = Math.min(Math.max(je, tt + De - 1), Ne - 1), ut = je + 1; ut <= ke && !We({
                  index: ut
                }); ut++) je = ut;
                Ke.push({
                  startIndex: tt,
                  stopIndex: je
                });
              }
              if (Ke.length) for (var Ct = Ke[0]; Ct.stopIndex - Ct.startIndex + 1 < De && 0 < Ct.startIndex; ) {
                var er = Ct.startIndex - 1;
                if (We({
                  index: er
                })) break;
                Ct.startIndex = er;
              }
              return Ke;
            }({
              isRowLoaded: N,
              minimumBatchSize: H,
              rowCount: Y,
              startIndex: Math.max(0, m - q),
              stopIndex: Math.min(Y - 1, x + q)
            }), ve = (T = []).concat.apply(T, L(Q.map(function(Se) {
              return [Se.startIndex, Se.stopIndex];
            })));
            this._loadMoreRowsMemoizer({
              callback: function() {
                P._loadUnloadedRanges(Q);
              },
              indices: {
                squashedUnloadedRanges: ve
              }
            });
          }
        }, {
          key: "_registerChild",
          value: function(m) {
            this._registeredChild = m;
          }
        }]), I;
      }();
      c(Oi, "propTypes", {
        children: ae.func.isRequired,
        isRowLoaded: ae.func.isRequired,
        loadMoreRows: ae.func.isRequired,
        minimumBatchSize: ae.number.isRequired,
        rowCount: ae.number.isRequired,
        threshold: ae.number.isRequired
      }), c(Oi, "defaultProps", {
        minimumBatchSize: 10,
        rowCount: 0,
        threshold: 15
      });
      var rn = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "Grid", void 0), c(w(x), "_cellRenderer", function(N) {
            var H = N.parent, Y = N.rowIndex, q = N.style, Q = N.isScrolling, ve = N.isVisible, Se = N.key, We = x.props.rowRenderer, De = Object.getOwnPropertyDescriptor(q, "width");
            return De && De.writable && (q.width = "100%"), We({
              index: Y,
              style: q,
              isScrolling: Q,
              isVisible: ve,
              key: Se,
              parent: H
            });
          }), c(w(x), "_setRef", function(N) {
            x.Grid = N;
          }), c(w(x), "_onScroll", function(N) {
            var H = N.clientHeight, Y = N.scrollHeight, q = N.scrollTop;
            (0, x.props.onScroll)({
              clientHeight: H,
              scrollHeight: Y,
              scrollTop: q
            });
          }), c(w(x), "_onSectionRendered", function(N) {
            var H = N.rowOverscanStartIndex, Y = N.rowOverscanStopIndex, q = N.rowStartIndex, Q = N.rowStopIndex;
            (0, x.props.onRowsRendered)({
              overscanStartIndex: H,
              overscanStopIndex: Y,
              startIndex: q,
              stopIndex: Q
            });
          }), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "forceUpdateGrid",
          value: function() {
            this.Grid && this.Grid.forceUpdate();
          }
        }, {
          key: "getOffsetForRow",
          value: function(m) {
            var x = m.alignment, T = m.index;
            return this.Grid ? this.Grid.getOffsetForCell({
              alignment: x,
              rowIndex: T,
              columnIndex: 0
            }).scrollTop : 0;
          }
        }, {
          key: "invalidateCellSizeAfterRender",
          value: function(m) {
            var x = m.columnIndex, T = m.rowIndex;
            this.Grid && this.Grid.invalidateCellSizeAfterRender({
              rowIndex: T,
              columnIndex: x
            });
          }
        }, {
          key: "measureAllRows",
          value: function() {
            this.Grid && this.Grid.measureAllCells();
          }
        }, {
          key: "recomputeGridSize",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.columnIndex, P = T === void 0 ? 0 : T, F = x.rowIndex, N = F === void 0 ? 0 : F;
            this.Grid && this.Grid.recomputeGridSize({
              rowIndex: N,
              columnIndex: P
            });
          }
        }, {
          key: "recomputeRowHeights",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.recomputeGridSize({
              rowIndex: x,
              columnIndex: 0
            });
          }
        }, {
          key: "scrollToPosition",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.scrollToPosition({
              scrollTop: x
            });
          }
        }, {
          key: "scrollToRow",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.scrollToCell({
              columnIndex: 0,
              rowIndex: x
            });
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.className, T = m.noRowsRenderer, P = m.scrollToIndex, F = m.width, N = Ze("ReactVirtualized__List", x);
            return n.createElement(dn, f({}, this.props, {
              autoContainerWidth: !0,
              cellRenderer: this._cellRenderer,
              className: N,
              columnWidth: F,
              columnCount: 1,
              noContentRenderer: T,
              onScroll: this._onScroll,
              onSectionRendered: this._onSectionRendered,
              ref: this._setRef,
              scrollToRow: P
            }));
          }
        }]), I;
      }();
      c(rn, "defaultProps", {
        autoHeight: !1,
        estimatedRowSize: 30,
        onScroll: function() {
        },
        noRowsRenderer: function() {
          return null;
        },
        onRowsRendered: function() {
        },
        overscanIndicesGetter: fi,
        overscanRowCount: 10,
        scrollToAlignment: "auto",
        scrollToIndex: -1,
        style: {}
      });
      var vo = {
        ge: function(I, m, x, T, P) {
          return typeof x == "function" ? function(F, N, H, Y, q) {
            for (var Q = H + 1; N <= H; ) {
              var ve = N + H >>> 1;
              0 <= q(F[ve], Y) ? H = (Q = ve) - 1 : N = 1 + ve;
            }
            return Q;
          }(I, T === void 0 ? 0 : 0 | T, P === void 0 ? I.length - 1 : 0 | P, m, x) : function(F, N, H, Y) {
            for (var q = H + 1; N <= H; ) {
              var Q = N + H >>> 1;
              Y <= F[Q] ? H = (q = Q) - 1 : N = 1 + Q;
            }
            return q;
          }(I, x === void 0 ? 0 : 0 | x, T === void 0 ? I.length - 1 : 0 | T, m);
        },
        gt: function(I, m, x, T, P) {
          return typeof x == "function" ? function(F, N, H, Y, q) {
            for (var Q = H + 1; N <= H; ) {
              var ve = N + H >>> 1;
              0 < q(F[ve], Y) ? H = (Q = ve) - 1 : N = 1 + ve;
            }
            return Q;
          }(I, T === void 0 ? 0 : 0 | T, P === void 0 ? I.length - 1 : 0 | P, m, x) : function(F, N, H, Y) {
            for (var q = H + 1; N <= H; ) {
              var Q = N + H >>> 1;
              Y < F[Q] ? H = (q = Q) - 1 : N = 1 + Q;
            }
            return q;
          }(I, x === void 0 ? 0 : 0 | x, T === void 0 ? I.length - 1 : 0 | T, m);
        },
        lt: function(I, m, x, T, P) {
          return typeof x == "function" ? function(F, N, H, Y, q) {
            for (var Q = N - 1; N <= H; ) {
              var ve = N + H >>> 1;
              q(F[ve], Y) < 0 ? N = 1 + (Q = ve) : H = ve - 1;
            }
            return Q;
          }(I, T === void 0 ? 0 : 0 | T, P === void 0 ? I.length - 1 : 0 | P, m, x) : function(F, N, H, Y) {
            for (var q = N - 1; N <= H; ) {
              var Q = N + H >>> 1;
              F[Q] < Y ? N = 1 + (q = Q) : H = Q - 1;
            }
            return q;
          }(I, x === void 0 ? 0 : 0 | x, T === void 0 ? I.length - 1 : 0 | T, m);
        },
        le: function(I, m, x, T, P) {
          return typeof x == "function" ? function(F, N, H, Y, q) {
            for (var Q = N - 1; N <= H; ) {
              var ve = N + H >>> 1;
              q(F[ve], Y) <= 0 ? N = 1 + (Q = ve) : H = ve - 1;
            }
            return Q;
          }(I, T === void 0 ? 0 : 0 | T, P === void 0 ? I.length - 1 : 0 | P, m, x) : function(F, N, H, Y) {
            for (var q = N - 1; N <= H; ) {
              var Q = N + H >>> 1;
              F[Q] <= Y ? N = 1 + (q = Q) : H = Q - 1;
            }
            return q;
          }(I, x === void 0 ? 0 : 0 | x, T === void 0 ? I.length - 1 : 0 | T, m);
        },
        eq: function(I, m, x, T, P) {
          return typeof x == "function" ? function(F, N, H, Y, q) {
            for (; N <= H; ) {
              var Q = N + H >>> 1, ve = q(F[Q], Y);
              if (ve === 0) return Q;
              ve <= 0 ? N = 1 + Q : H = Q - 1;
            }
            return -1;
          }(I, T === void 0 ? 0 : 0 | T, P === void 0 ? I.length - 1 : 0 | P, m, x) : function(F, N, H, Y) {
            for (; N <= H; ) {
              var q = N + H >>> 1, Q = F[q];
              if (Q === Y) return q;
              Q <= Y ? N = 1 + q : H = q - 1;
            }
            return -1;
          }(I, x === void 0 ? 0 : 0 | x, T === void 0 ? I.length - 1 : 0 | T, m);
        }
      };
      function oe(I, m, x, T, P) {
        this.mid = I, this.left = m, this.right = x, this.leftPoints = T, this.rightPoints = P, this.count = (m ? m.count : 0) + (x ? x.count : 0) + T.length;
      }
      var Qe = oe.prototype;
      function lt(I, m) {
        I.mid = m.mid, I.left = m.left, I.right = m.right, I.leftPoints = m.leftPoints, I.rightPoints = m.rightPoints, I.count = m.count;
      }
      function _t(I, m) {
        var x = nn(m);
        I.mid = x.mid, I.left = x.left, I.right = x.right, I.leftPoints = x.leftPoints, I.rightPoints = x.rightPoints, I.count = x.count;
      }
      function lr(I, m) {
        var x = I.intervals([]);
        x.push(m), _t(I, x);
      }
      function nr(I, m) {
        var x = I.intervals([]), T = x.indexOf(m);
        return T < 0 ? 0 : (x.splice(T, 1), _t(I, x), 1);
      }
      function Ht(I, m, x) {
        for (var T = 0; T < I.length && I[T][0] <= m; ++T) {
          var P = x(I[T]);
          if (P) return P;
        }
      }
      function Ft(I, m, x) {
        for (var T = I.length - 1; 0 <= T && I[T][1] >= m; --T) {
          var P = x(I[T]);
          if (P) return P;
        }
      }
      function Er(I, m) {
        for (var x = 0; x < I.length; ++x) {
          var T = m(I[x]);
          if (T) return T;
        }
      }
      function Rr(I, m) {
        return I - m;
      }
      function Cr(I, m) {
        var x = I[0] - m[0];
        return x || I[1] - m[1];
      }
      function fn(I, m) {
        var x = I[1] - m[1];
        return x || I[0] - m[0];
      }
      function nn(I) {
        if (I.length === 0) return null;
        for (var m = [], x = 0; x < I.length; ++x) m.push(I[x][0], I[x][1]);
        m.sort(Rr);
        var T = m[m.length >> 1], P = [], F = [], N = [];
        for (x = 0; x < I.length; ++x) {
          var H = I[x];
          H[1] < T ? P.push(H) : T < H[0] ? F.push(H) : N.push(H);
        }
        var Y = N, q = N.slice();
        return Y.sort(Cr), q.sort(fn), new oe(T, nn(P), nn(F), Y, q);
      }
      function qr(I) {
        this.root = I;
      }
      Qe.intervals = function(I) {
        return I.push.apply(I, this.leftPoints), this.left && this.left.intervals(I), this.right && this.right.intervals(I), I;
      }, Qe.insert = function(I) {
        var m = this.count - this.leftPoints.length;
        if (this.count += 1, I[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (1 + m) ? lr(this, I) : this.left.insert(I) : this.left = nn([I]);
        else if (I[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (1 + m) ? lr(this, I) : this.right.insert(I) : this.right = nn([I]);
        else {
          var x = vo.ge(this.leftPoints, I, Cr), T = vo.ge(this.rightPoints, I, fn);
          this.leftPoints.splice(x, 0, I), this.rightPoints.splice(T, 0, I);
        }
      }, Qe.remove = function(I) {
        var m = this.count - this.leftPoints;
        if (I[1] < this.mid)
          return this.left ? 3 * (m - 1) < 4 * (this.right ? this.right.count : 0) ? nr(this, I) : (F = this.left.remove(I)) === 2 ? (this.left = null, this.count -= 1, 1) : (F === 1 && (this.count -= 1), F) : 0;
        if (I[0] > this.mid) return this.right ? 3 * (m - 1) < 4 * (this.left ? this.left.count : 0) ? nr(this, I) : (F = this.right.remove(I)) === 2 ? (this.right = null, this.count -= 1, 1) : (F === 1 && (this.count -= 1), F) : 0;
        if (this.count === 1) return this.leftPoints[0] === I ? 2 : 0;
        if (this.leftPoints.length === 1 && this.leftPoints[0] === I) {
          if (this.left && this.right) {
            for (var x = this, T = this.left; T.right; ) T = (x = T).right;
            if (x === this) T.right = this.right;
            else {
              var P = this.left;
              F = this.right, x.count -= T.count, x.right = T.left, T.left = P, T.right = F;
            }
            lt(this, T), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
          } else this.left ? lt(this, this.left) : lt(this, this.right);
          return 1;
        }
        for (P = vo.ge(this.leftPoints, I, Cr); P < this.leftPoints.length && this.leftPoints[P][0] === I[0]; ++P) if (this.leftPoints[P] === I) {
          for (this.count -= 1, this.leftPoints.splice(P, 1), F = vo.ge(this.rightPoints, I, fn); F < this.rightPoints.length && this.rightPoints[F][1] === I[1]; ++F) if (this.rightPoints[F] === I) return this.rightPoints.splice(F, 1), 1;
        }
        return 0;
        var F;
      }, Qe.queryPoint = function(I, m) {
        if (I < this.mid)
          return this.left && (x = this.left.queryPoint(I, m)) ? x : Ht(this.leftPoints, I, m);
        if (I > this.mid) {
          var x;
          return this.right && (x = this.right.queryPoint(I, m)) ? x : Ft(this.rightPoints, I, m);
        }
        return Er(this.leftPoints, m);
      }, Qe.queryInterval = function(I, m, x) {
        var T;
        return I < this.mid && this.left && (T = this.left.queryInterval(I, m, x)) || m > this.mid && this.right && (T = this.right.queryInterval(I, m, x)) ? T : m < this.mid ? Ht(this.leftPoints, m, x) : I > this.mid ? Ft(this.rightPoints, I, x) : Er(this.leftPoints, x);
      };
      var Tt = qr.prototype;
      Tt.insert = function(I) {
        this.root ? this.root.insert(I) : this.root = new oe(I[0], null, null, [I], [I]);
      }, Tt.remove = function(I) {
        if (this.root) {
          var m = this.root.remove(I);
          return m === 2 && (this.root = null), m !== 0;
        }
        return !1;
      }, Tt.queryPoint = function(I, m) {
        if (this.root) return this.root.queryPoint(I, m);
      }, Tt.queryInterval = function(I, m, x) {
        if (I <= m && this.root) return this.root.queryInterval(I, m, x);
      }, Object.defineProperty(Tt, "count", {
        get: function() {
          return this.root ? this.root.count : 0;
        }
      }), Object.defineProperty(Tt, "intervals", {
        get: function() {
          return this.root ? this.root.intervals([]) : [];
        }
      });
      var Wo = function() {
        function I() {
          o(this, I), c(this, "_columnSizeMap", {}), c(this, "_intervalTree", function(m) {
            return m && m.length !== 0 ? new qr(nn(m)) : new qr(null);
          }()), c(this, "_leftMap", {});
        }
        return l(I, [{
          key: "estimateTotalHeight",
          value: function(m, x, T) {
            var P = m - this.count;
            return this.tallestColumnSize + Math.ceil(P / x) * T;
          }
        }, {
          key: "range",
          value: function(m, x, T) {
            var P = this;
            this._intervalTree.queryInterval(m, m + x, function(F) {
              var N = M(F, 3), H = N[0], Y = (N[1], N[2]);
              return T(Y, P._leftMap[Y], H);
            });
          }
        }, {
          key: "setPosition",
          value: function(m, x, T, P) {
            this._intervalTree.insert([T, T + P, m]), this._leftMap[m] = x;
            var F = this._columnSizeMap, N = F[x];
            F[x] = N === void 0 ? T + P : Math.max(N, T + P);
          }
        }, {
          key: "count",
          get: function() {
            return this._intervalTree.count;
          }
        }, {
          key: "shortestColumnSize",
          get: function() {
            var m = this._columnSizeMap, x = 0;
            for (var T in m) {
              var P = m[T];
              x = x === 0 ? P : Math.min(x, P);
            }
            return x;
          }
        }, {
          key: "tallestColumnSize",
          get: function() {
            var m = this._columnSizeMap, x = 0;
            for (var T in m) {
              var P = m[T];
              x = Math.max(x, P);
            }
            return x;
          }
        }]), I;
      }(), da = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "state", {
            isScrolling: !1,
            scrollTop: 0
          }), c(w(x), "_debounceResetIsScrollingId", void 0), c(w(x), "_invalidateOnUpdateStartIndex", null), c(w(x), "_invalidateOnUpdateStopIndex", null), c(w(x), "_positionCache", new Wo()), c(w(x), "_startIndex", null), c(w(x), "_startIndexMemoized", null), c(w(x), "_stopIndex", null), c(w(x), "_stopIndexMemoized", null), c(w(x), "_debounceResetIsScrollingCallback", function() {
            x.setState({
              isScrolling: !1
            });
          }), c(w(x), "_setScrollingContainerRef", function(N) {
            x._scrollingContainer = N;
          }), c(w(x), "_onScroll", function(N) {
            var H = x.props.height, Y = N.currentTarget.scrollTop, q = Math.min(Math.max(0, x._getEstimatedTotalHeight() - H), Y);
            Y === q && (x._debounceResetIsScrolling(), x.state.scrollTop !== q && x.setState({
              isScrolling: !0,
              scrollTop: q
            }));
          }), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "clearCellPositions",
          value: function() {
            this._positionCache = new Wo(), this.forceUpdate();
          }
        }, {
          key: "invalidateCellSizeAfterRender",
          value: function(m) {
            var x = m.rowIndex;
            this._invalidateOnUpdateStartIndex === null ? (this._invalidateOnUpdateStartIndex = x, this._invalidateOnUpdateStopIndex = x) : (this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, x), this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, x));
          }
        }, {
          key: "recomputeCellPositions",
          value: function() {
            var m = this._positionCache.count - 1;
            this._positionCache = new Wo(), this._populatePositionCache(0, m), this.forceUpdate();
          }
        }, {
          key: "componentDidMount",
          value: function() {
            this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback();
          }
        }, {
          key: "componentDidUpdate",
          value: function(m) {
            this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback(), this.props.scrollTop !== m.scrollTop && this._debounceResetIsScrolling();
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this._debounceResetIsScrollingId && jn(this._debounceResetIsScrollingId);
          }
        }, {
          key: "render",
          value: function() {
            var m, x = this, T = this.props, P = T.autoHeight, F = T.cellCount, N = T.cellMeasurerCache, H = T.cellRenderer, Y = T.className, q = T.height, Q = T.id, ve = T.keyMapper, Se = T.overscanByPixels, We = T.role, De = T.style, Ne = T.tabIndex, $e = T.width, Ye = T.rowDirection, Ke = this.state, tt = Ke.isScrolling, je = Ke.scrollTop, He = [], ke = this._getEstimatedTotalHeight(), ut = this._positionCache.shortestColumnSize, Ct = this._positionCache.count, er = 0;
            if (this._positionCache.range(Math.max(0, je - Se), q + 2 * Se, function(vr, ur, kr) {
              var yn;
              m = m === void 0 ? er = vr : (er = Math.min(er, vr), Math.max(m, vr)), He.push(H({
                index: vr,
                isScrolling: tt,
                key: ve(vr),
                parent: x,
                style: (yn = {
                  height: N.getHeight(vr)
                }, c(yn, Ye === "ltr" ? "left" : "right", ur), c(yn, "position", "absolute"), c(yn, "top", kr), c(yn, "width", N.getWidth(vr)), yn)
              }));
            }), ut < je + q + Se && Ct < F) for (var xt = Math.min(F - Ct, Math.ceil((je + q + Se - ut) / N.defaultHeight * $e / N.defaultWidth)), ft = Ct; ft < Ct + xt; ft++) m = ft, He.push(H({
              index: ft,
              isScrolling: tt,
              key: ve(ft),
              parent: this,
              style: {
                width: N.getWidth(ft)
              }
            }));
            return this._startIndex = er, this._stopIndex = m, n.createElement("div", {
              ref: this._setScrollingContainerRef,
              "aria-label": this.props["aria-label"],
              className: Ze("ReactVirtualized__Masonry", Y),
              id: Q,
              onScroll: this._onScroll,
              role: We,
              style: g({
                boxSizing: "border-box",
                direction: "ltr",
                height: P ? "auto" : q,
                overflowX: "hidden",
                overflowY: ke < q ? "hidden" : "auto",
                position: "relative",
                width: $e,
                WebkitOverflowScrolling: "touch",
                willChange: "transform"
              }, De),
              tabIndex: Ne
            }, n.createElement("div", {
              className: "ReactVirtualized__Masonry__innerScrollContainer",
              style: {
                width: "100%",
                height: ke,
                maxWidth: "100%",
                maxHeight: ke,
                overflow: "hidden",
                pointerEvents: tt ? "none" : "",
                position: "relative"
              }
            }, He));
          }
        }, {
          key: "_checkInvalidateOnUpdate",
          value: function() {
            if (typeof this._invalidateOnUpdateStartIndex == "number") {
              var m = this._invalidateOnUpdateStartIndex, x = this._invalidateOnUpdateStopIndex;
              this._invalidateOnUpdateStartIndex = null, this._invalidateOnUpdateStopIndex = null, this._populatePositionCache(m, x), this.forceUpdate();
            }
          }
        }, {
          key: "_debounceResetIsScrolling",
          value: function() {
            var m = this.props.scrollingResetTimeInterval;
            this._debounceResetIsScrollingId && jn(this._debounceResetIsScrollingId), this._debounceResetIsScrollingId = vn(this._debounceResetIsScrollingCallback, m);
          }
        }, {
          key: "_getEstimatedTotalHeight",
          value: function() {
            var m = this.props, x = m.cellCount, T = m.cellMeasurerCache, P = m.width, F = Math.max(1, Math.floor(P / T.defaultWidth));
            return this._positionCache.estimateTotalHeight(x, F, T.defaultHeight);
          }
        }, {
          key: "_invokeOnScrollCallback",
          value: function() {
            var m = this.props, x = m.height, T = m.onScroll, P = this.state.scrollTop;
            this._onScrollMemoized !== P && (T({
              clientHeight: x,
              scrollHeight: this._getEstimatedTotalHeight(),
              scrollTop: P
            }), this._onScrollMemoized = P);
          }
        }, {
          key: "_invokeOnCellsRenderedCallback",
          value: function() {
            this._startIndexMemoized === this._startIndex && this._stopIndexMemoized === this._stopIndex || ((0, this.props.onCellsRendered)({
              startIndex: this._startIndex,
              stopIndex: this._stopIndex
            }), this._startIndexMemoized = this._startIndex, this._stopIndexMemoized = this._stopIndex);
          }
        }, {
          key: "_populatePositionCache",
          value: function(m, x) {
            for (var T = this.props, P = T.cellMeasurerCache, F = T.cellPositioner, N = m; N <= x; N++) {
              var H = F(N), Y = H.left, q = H.top;
              this._positionCache.setPosition(N, Y, q, P.getHeight(N));
            }
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function(m, x) {
            return m.scrollTop !== void 0 && x.scrollTop !== m.scrollTop ? {
              isScrolling: !0,
              scrollTop: m.scrollTop
            } : null;
          }
        }]), I;
      }();
      function qt() {
      }
      c(da, "defaultProps", {
        autoHeight: !1,
        keyMapper: function(I) {
          return I;
        },
        onCellsRendered: qt,
        onScroll: qt,
        overscanByPixels: 20,
        role: "grid",
        scrollingResetTimeInterval: 150,
        style: {},
        tabIndex: 0,
        rowDirection: "ltr"
      }), K(da);
      var Zi = function() {
        function I() {
          var m = this, x = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
          o(this, I), c(this, "_cellMeasurerCache", void 0), c(this, "_columnIndexOffset", void 0), c(this, "_rowIndexOffset", void 0), c(this, "columnWidth", function(Y) {
            var q = Y.index;
            m._cellMeasurerCache.columnWidth({
              index: q + m._columnIndexOffset
            });
          }), c(this, "rowHeight", function(Y) {
            var q = Y.index;
            m._cellMeasurerCache.rowHeight({
              index: q + m._rowIndexOffset
            });
          });
          var T = x.cellMeasurerCache, P = x.columnIndexOffset, F = P === void 0 ? 0 : P, N = x.rowIndexOffset, H = N === void 0 ? 0 : N;
          this._cellMeasurerCache = T, this._columnIndexOffset = F, this._rowIndexOffset = H;
        }
        return l(I, [{
          key: "clear",
          value: function(m, x) {
            this._cellMeasurerCache.clear(m + this._rowIndexOffset, x + this._columnIndexOffset);
          }
        }, {
          key: "clearAll",
          value: function() {
            this._cellMeasurerCache.clearAll();
          }
        }, {
          key: "hasFixedHeight",
          value: function() {
            return this._cellMeasurerCache.hasFixedHeight();
          }
        }, {
          key: "hasFixedWidth",
          value: function() {
            return this._cellMeasurerCache.hasFixedWidth();
          }
        }, {
          key: "getHeight",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0;
            return this._cellMeasurerCache.getHeight(m + this._rowIndexOffset, T + this._columnIndexOffset);
          }
        }, {
          key: "getWidth",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0;
            return this._cellMeasurerCache.getWidth(m + this._rowIndexOffset, T + this._columnIndexOffset);
          }
        }, {
          key: "has",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : 0;
            return this._cellMeasurerCache.has(m + this._rowIndexOffset, T + this._columnIndexOffset);
          }
        }, {
          key: "set",
          value: function(m, x, T, P) {
            this._cellMeasurerCache.set(m + this._rowIndexOffset, x + this._columnIndexOffset, T, P);
          }
        }, {
          key: "defaultHeight",
          get: function() {
            return this._cellMeasurerCache.defaultHeight;
          }
        }, {
          key: "defaultWidth",
          get: function() {
            return this._cellMeasurerCache.defaultWidth;
          }
        }]), I;
      }(), kn = function() {
        function I(m, x) {
          var T;
          o(this, I), c(w(T = C(this, b(I).call(this, m, x))), "state", {
            scrollLeft: 0,
            scrollTop: 0,
            scrollbarSize: 0,
            showHorizontalScrollbar: !1,
            showVerticalScrollbar: !1
          }), c(w(T), "_deferredInvalidateColumnIndex", null), c(w(T), "_deferredInvalidateRowIndex", null), c(w(T), "_bottomLeftGridRef", function(H) {
            T._bottomLeftGrid = H;
          }), c(w(T), "_bottomRightGridRef", function(H) {
            T._bottomRightGrid = H;
          }), c(w(T), "_cellRendererBottomLeftGrid", function(H) {
            var Y = H.rowIndex, q = v(H, ["rowIndex"]), Q = T.props, ve = Q.cellRenderer, Se = Q.fixedRowCount;
            return Y === Q.rowCount - Se ? n.createElement("div", {
              key: q.key,
              style: g({}, q.style, {
                height: 20
              })
            }) : ve(g({}, q, {
              parent: w(T),
              rowIndex: Y + Se
            }));
          }), c(w(T), "_cellRendererBottomRightGrid", function(H) {
            var Y = H.columnIndex, q = H.rowIndex, Q = v(H, ["columnIndex", "rowIndex"]), ve = T.props, Se = ve.cellRenderer, We = ve.fixedColumnCount, De = ve.fixedRowCount;
            return Se(g({}, Q, {
              columnIndex: Y + We,
              parent: w(T),
              rowIndex: q + De
            }));
          }), c(w(T), "_cellRendererTopRightGrid", function(H) {
            var Y = H.columnIndex, q = v(H, ["columnIndex"]), Q = T.props, ve = Q.cellRenderer, Se = Q.columnCount, We = Q.fixedColumnCount;
            return Y === Se - We ? n.createElement("div", {
              key: q.key,
              style: g({}, q.style, {
                width: 20
              })
            }) : ve(g({}, q, {
              columnIndex: Y + We,
              parent: w(T)
            }));
          }), c(w(T), "_columnWidthRightGrid", function(H) {
            var Y = H.index, q = T.props, Q = q.columnCount, ve = q.fixedColumnCount, Se = q.columnWidth, We = T.state, De = We.scrollbarSize;
            return We.showHorizontalScrollbar && Y === Q - ve ? De : typeof Se == "function" ? Se({
              index: Y + ve
            }) : Se;
          }), c(w(T), "_onScroll", function(H) {
            var Y = H.scrollLeft, q = H.scrollTop;
            T.setState({
              scrollLeft: Y,
              scrollTop: q
            });
            var Q = T.props.onScroll;
            Q && Q(H);
          }), c(w(T), "_onScrollbarPresenceChange", function(H) {
            var Y = H.horizontal, q = H.size, Q = H.vertical, ve = T.state, Se = ve.showHorizontalScrollbar, We = ve.showVerticalScrollbar;
            if (Y !== Se || Q !== We) {
              T.setState({
                scrollbarSize: q,
                showHorizontalScrollbar: Y,
                showVerticalScrollbar: Q
              });
              var De = T.props.onScrollbarPresenceChange;
              typeof De == "function" && De({
                horizontal: Y,
                size: q,
                vertical: Q
              });
            }
          }), c(w(T), "_onScrollLeft", function(H) {
            var Y = H.scrollLeft;
            T._onScroll({
              scrollLeft: Y,
              scrollTop: T.state.scrollTop
            });
          }), c(w(T), "_onScrollTop", function(H) {
            var Y = H.scrollTop;
            T._onScroll({
              scrollTop: Y,
              scrollLeft: T.state.scrollLeft
            });
          }), c(w(T), "_rowHeightBottomGrid", function(H) {
            var Y = H.index, q = T.props, Q = q.fixedRowCount, ve = q.rowCount, Se = q.rowHeight, We = T.state, De = We.scrollbarSize;
            return We.showVerticalScrollbar && Y === ve - Q ? De : typeof Se == "function" ? Se({
              index: Y + Q
            }) : Se;
          }), c(w(T), "_topLeftGridRef", function(H) {
            T._topLeftGrid = H;
          }), c(w(T), "_topRightGridRef", function(H) {
            T._topRightGrid = H;
          });
          var P = m.deferredMeasurementCache, F = m.fixedColumnCount, N = m.fixedRowCount;
          return T._maybeCalculateCachedStyles(!0), P && (T._deferredMeasurementCacheBottomLeftGrid = 0 < N ? new Zi({
            cellMeasurerCache: P,
            columnIndexOffset: 0,
            rowIndexOffset: N
          }) : P, T._deferredMeasurementCacheBottomRightGrid = 0 < F || 0 < N ? new Zi({
            cellMeasurerCache: P,
            columnIndexOffset: F,
            rowIndexOffset: N
          }) : P, T._deferredMeasurementCacheTopRightGrid = 0 < F ? new Zi({
            cellMeasurerCache: P,
            columnIndexOffset: F,
            rowIndexOffset: 0
          }) : P), T;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "forceUpdateGrids",
          value: function() {
            this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate(), this._bottomRightGrid && this._bottomRightGrid.forceUpdate(), this._topLeftGrid && this._topLeftGrid.forceUpdate(), this._topRightGrid && this._topRightGrid.forceUpdate();
          }
        }, {
          key: "invalidateCellSizeAfterRender",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.columnIndex, P = T === void 0 ? 0 : T, F = x.rowIndex, N = F === void 0 ? 0 : F;
            this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, P) : P, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, N) : N;
          }
        }, {
          key: "measureAllCells",
          value: function() {
            this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells(), this._bottomRightGrid && this._bottomRightGrid.measureAllCells(), this._topLeftGrid && this._topLeftGrid.measureAllCells(), this._topRightGrid && this._topRightGrid.measureAllCells();
          }
        }, {
          key: "recomputeGridSize",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.columnIndex, P = T === void 0 ? 0 : T, F = x.rowIndex, N = F === void 0 ? 0 : F, H = this.props, Y = H.fixedColumnCount, q = H.fixedRowCount, Q = Math.max(0, P - Y), ve = Math.max(0, N - q);
            this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
              columnIndex: P,
              rowIndex: ve
            }), this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
              columnIndex: Q,
              rowIndex: ve
            }), this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
              columnIndex: P,
              rowIndex: N
            }), this._topRightGrid && this._topRightGrid.recomputeGridSize({
              columnIndex: Q,
              rowIndex: N
            }), this._leftGridWidth = null, this._topGridHeight = null, this._maybeCalculateCachedStyles(!0);
          }
        }, {
          key: "componentDidMount",
          value: function() {
            var m = this.props, x = m.scrollLeft, T = m.scrollTop;
            if (0 < x || 0 < T) {
              var P = {};
              0 < x && (P.scrollLeft = x), 0 < T && (P.scrollTop = T), this.setState(P);
            }
            this._handleInvalidatedGridSize();
          }
        }, {
          key: "componentDidUpdate",
          value: function() {
            this._handleInvalidatedGridSize();
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props, x = m.onScroll, T = m.onSectionRendered, P = (m.onScrollbarPresenceChange, m.scrollLeft, m.scrollToColumn), F = (m.scrollTop, m.scrollToRow), N = v(m, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);
            if (this._prepareForRender(), this.props.width === 0 || this.props.height === 0) return null;
            var H = this.state, Y = H.scrollLeft, q = H.scrollTop;
            return n.createElement("div", {
              style: this._containerOuterStyle
            }, n.createElement("div", {
              style: this._containerTopStyle
            }, this._renderTopLeftGrid(N), this._renderTopRightGrid(g({}, N, {
              onScroll: x,
              scrollLeft: Y
            }))), n.createElement("div", {
              style: this._containerBottomStyle
            }, this._renderBottomLeftGrid(g({}, N, {
              onScroll: x,
              scrollTop: q
            })), this._renderBottomRightGrid(g({}, N, {
              onScroll: x,
              onSectionRendered: T,
              scrollLeft: Y,
              scrollToColumn: P,
              scrollToRow: F,
              scrollTop: q
            }))));
          }
        }, {
          key: "_getBottomGridHeight",
          value: function(m) {
            return m.height - this._getTopGridHeight(m);
          }
        }, {
          key: "_getLeftGridWidth",
          value: function(m) {
            var x = m.fixedColumnCount, T = m.columnWidth;
            if (this._leftGridWidth == null) if (typeof T == "function") {
              for (var P = 0, F = 0; F < x; F++) P += T({
                index: F
              });
              this._leftGridWidth = P;
            } else this._leftGridWidth = T * x;
            return this._leftGridWidth;
          }
        }, {
          key: "_getRightGridWidth",
          value: function(m) {
            return m.width - this._getLeftGridWidth(m);
          }
        }, {
          key: "_getTopGridHeight",
          value: function(m) {
            var x = m.fixedRowCount, T = m.rowHeight;
            if (this._topGridHeight == null) if (typeof T == "function") {
              for (var P = 0, F = 0; F < x; F++) P += T({
                index: F
              });
              this._topGridHeight = P;
            } else this._topGridHeight = T * x;
            return this._topGridHeight;
          }
        }, {
          key: "_handleInvalidatedGridSize",
          value: function() {
            if (typeof this._deferredInvalidateColumnIndex == "number") {
              var m = this._deferredInvalidateColumnIndex, x = this._deferredInvalidateRowIndex;
              this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
                columnIndex: m,
                rowIndex: x
              }), this.forceUpdate();
            }
          }
        }, {
          key: "_maybeCalculateCachedStyles",
          value: function(m) {
            var x = this.props, T = x.columnWidth, P = x.enableFixedColumnScroll, F = x.enableFixedRowScroll, N = x.height, H = x.fixedColumnCount, Y = x.fixedRowCount, q = x.rowHeight, Q = x.style, ve = x.styleBottomLeftGrid, Se = x.styleBottomRightGrid, We = x.styleTopLeftGrid, De = x.styleTopRightGrid, Ne = x.width, $e = m || N !== this._lastRenderedHeight || Ne !== this._lastRenderedWidth, Ye = m || T !== this._lastRenderedColumnWidth || H !== this._lastRenderedFixedColumnCount, Ke = m || Y !== this._lastRenderedFixedRowCount || q !== this._lastRenderedRowHeight;
            (m || $e || Q !== this._lastRenderedStyle) && (this._containerOuterStyle = g({
              height: N,
              overflow: "visible",
              width: Ne
            }, Q)), (m || $e || Ke) && (this._containerTopStyle = {
              height: this._getTopGridHeight(this.props),
              position: "relative",
              width: Ne
            }, this._containerBottomStyle = {
              height: N - this._getTopGridHeight(this.props),
              overflow: "visible",
              position: "relative",
              width: Ne
            }), !m && ve === this._lastRenderedStyleBottomLeftGrid || (this._bottomLeftGridStyle = g({
              left: 0,
              overflowX: "hidden",
              overflowY: P ? "auto" : "hidden",
              position: "absolute"
            }, ve)), (m || Ye || Se !== this._lastRenderedStyleBottomRightGrid) && (this._bottomRightGridStyle = g({
              left: this._getLeftGridWidth(this.props),
              position: "absolute"
            }, Se)), !m && We === this._lastRenderedStyleTopLeftGrid || (this._topLeftGridStyle = g({
              left: 0,
              overflowX: "hidden",
              overflowY: "hidden",
              position: "absolute",
              top: 0
            }, We)), (m || Ye || De !== this._lastRenderedStyleTopRightGrid) && (this._topRightGridStyle = g({
              left: this._getLeftGridWidth(this.props),
              overflowX: F ? "auto" : "hidden",
              overflowY: "hidden",
              position: "absolute",
              top: 0
            }, De)), this._lastRenderedColumnWidth = T, this._lastRenderedFixedColumnCount = H, this._lastRenderedFixedRowCount = Y, this._lastRenderedHeight = N, this._lastRenderedRowHeight = q, this._lastRenderedStyle = Q, this._lastRenderedStyleBottomLeftGrid = ve, this._lastRenderedStyleBottomRightGrid = Se, this._lastRenderedStyleTopLeftGrid = We, this._lastRenderedStyleTopRightGrid = De, this._lastRenderedWidth = Ne;
          }
        }, {
          key: "_prepareForRender",
          value: function() {
            this._lastRenderedColumnWidth === this.props.columnWidth && this._lastRenderedFixedColumnCount === this.props.fixedColumnCount || (this._leftGridWidth = null), this._lastRenderedFixedRowCount === this.props.fixedRowCount && this._lastRenderedRowHeight === this.props.rowHeight || (this._topGridHeight = null), this._maybeCalculateCachedStyles(), this._lastRenderedColumnWidth = this.props.columnWidth, this._lastRenderedFixedColumnCount = this.props.fixedColumnCount, this._lastRenderedFixedRowCount = this.props.fixedRowCount, this._lastRenderedRowHeight = this.props.rowHeight;
          }
        }, {
          key: "_renderBottomLeftGrid",
          value: function(m) {
            var x = m.enableFixedColumnScroll, T = m.fixedColumnCount, P = m.fixedRowCount, F = m.rowCount, N = m.hideBottomLeftGridScrollbar, H = this.state.showVerticalScrollbar;
            if (!T) return null;
            var Y = H ? 1 : 0, q = this._getBottomGridHeight(m), Q = this._getLeftGridWidth(m), ve = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, Se = N ? Q + ve : Q, We = n.createElement(dn, f({}, m, {
              cellRenderer: this._cellRendererBottomLeftGrid,
              className: this.props.classNameBottomLeftGrid,
              columnCount: T,
              deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
              height: q,
              onScroll: x ? this._onScrollTop : void 0,
              ref: this._bottomLeftGridRef,
              rowCount: Math.max(0, F - P) + Y,
              rowHeight: this._rowHeightBottomGrid,
              style: this._bottomLeftGridStyle,
              tabIndex: null,
              width: Se
            }));
            return N ? n.createElement("div", {
              className: "BottomLeftGrid_ScrollWrapper",
              style: g({}, this._bottomLeftGridStyle, {
                height: q,
                width: Q,
                overflowY: "hidden"
              })
            }, We) : We;
          }
        }, {
          key: "_renderBottomRightGrid",
          value: function(m) {
            var x = m.columnCount, T = m.fixedColumnCount, P = m.fixedRowCount, F = m.rowCount, N = m.scrollToColumn, H = m.scrollToRow;
            return n.createElement(dn, f({}, m, {
              cellRenderer: this._cellRendererBottomRightGrid,
              className: this.props.classNameBottomRightGrid,
              columnCount: Math.max(0, x - T),
              columnWidth: this._columnWidthRightGrid,
              deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
              height: this._getBottomGridHeight(m),
              onScroll: this._onScroll,
              onScrollbarPresenceChange: this._onScrollbarPresenceChange,
              ref: this._bottomRightGridRef,
              rowCount: Math.max(0, F - P),
              rowHeight: this._rowHeightBottomGrid,
              scrollToColumn: N - T,
              scrollToRow: H - P,
              style: this._bottomRightGridStyle,
              width: this._getRightGridWidth(m)
            }));
          }
        }, {
          key: "_renderTopLeftGrid",
          value: function(m) {
            var x = m.fixedColumnCount, T = m.fixedRowCount;
            return x && T ? n.createElement(dn, f({}, m, {
              className: this.props.classNameTopLeftGrid,
              columnCount: x,
              height: this._getTopGridHeight(m),
              ref: this._topLeftGridRef,
              rowCount: T,
              style: this._topLeftGridStyle,
              tabIndex: null,
              width: this._getLeftGridWidth(m)
            })) : null;
          }
        }, {
          key: "_renderTopRightGrid",
          value: function(m) {
            var x = m.columnCount, T = m.enableFixedRowScroll, P = m.fixedColumnCount, F = m.fixedRowCount, N = m.scrollLeft, H = m.hideTopRightGridScrollbar, Y = this.state, q = Y.showHorizontalScrollbar, Q = Y.scrollbarSize;
            if (!F) return null;
            var ve = q ? 1 : 0, Se = this._getTopGridHeight(m), We = this._getRightGridWidth(m), De = q ? Q : 0, Ne = Se, $e = this._topRightGridStyle;
            H && (Ne = Se + De, $e = g({}, this._topRightGridStyle, {
              left: 0
            }));
            var Ye = n.createElement(dn, f({}, m, {
              cellRenderer: this._cellRendererTopRightGrid,
              className: this.props.classNameTopRightGrid,
              columnCount: Math.max(0, x - P) + ve,
              columnWidth: this._columnWidthRightGrid,
              deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
              height: Ne,
              onScroll: T ? this._onScrollLeft : void 0,
              ref: this._topRightGridRef,
              rowCount: F,
              scrollLeft: N,
              style: $e,
              tabIndex: null,
              width: We
            }));
            return H ? n.createElement("div", {
              className: "TopRightGrid_ScrollWrapper",
              style: g({}, this._topRightGridStyle, {
                height: Se,
                width: We,
                overflowX: "hidden"
              })
            }, Ye) : Ye;
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function(m, x) {
            return m.scrollLeft !== x.scrollLeft || m.scrollTop !== x.scrollTop ? {
              scrollLeft: m.scrollLeft != null && 0 <= m.scrollLeft ? m.scrollLeft : x.scrollLeft,
              scrollTop: m.scrollTop != null && 0 <= m.scrollTop ? m.scrollTop : x.scrollTop
            } : null;
          }
        }]), I;
      }();
      c(kn, "propTypes", {
        classNameBottomLeftGrid: ae.string.isRequired,
        classNameBottomRightGrid: ae.string.isRequired,
        classNameTopLeftGrid: ae.string.isRequired,
        classNameTopRightGrid: ae.string.isRequired,
        enableFixedColumnScroll: ae.bool.isRequired,
        enableFixedRowScroll: ae.bool.isRequired,
        fixedColumnCount: ae.number.isRequired,
        fixedRowCount: ae.number.isRequired,
        onScrollbarPresenceChange: ae.func,
        style: ae.object.isRequired,
        styleBottomLeftGrid: ae.object.isRequired,
        styleBottomRightGrid: ae.object.isRequired,
        styleTopLeftGrid: ae.object.isRequired,
        styleTopRightGrid: ae.object.isRequired,
        hideTopRightGridScrollbar: ae.bool,
        hideBottomLeftGridScrollbar: ae.bool
      }), c(kn, "defaultProps", {
        classNameBottomLeftGrid: "",
        classNameBottomRightGrid: "",
        classNameTopLeftGrid: "",
        classNameTopRightGrid: "",
        enableFixedColumnScroll: !1,
        enableFixedRowScroll: !1,
        fixedColumnCount: 0,
        fixedRowCount: 0,
        scrollToColumn: -1,
        scrollToRow: -1,
        style: {},
        styleBottomLeftGrid: {},
        styleBottomRightGrid: {},
        styleTopLeftGrid: {},
        styleTopRightGrid: {},
        hideTopRightGridScrollbar: !1,
        hideBottomLeftGridScrollbar: !1
      }), K(kn);
      var mo = function() {
        function I(m, x) {
          var T;
          return o(this, I), (T = C(this, b(I).call(this, m, x))).state = {
            clientHeight: 0,
            clientWidth: 0,
            scrollHeight: 0,
            scrollLeft: 0,
            scrollTop: 0,
            scrollWidth: 0
          }, T._onScroll = T._onScroll.bind(w(T)), T;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "render",
          value: function() {
            var m = this.props.children, x = this.state, T = x.clientHeight, P = x.clientWidth, F = x.scrollHeight, N = x.scrollLeft, H = x.scrollTop, Y = x.scrollWidth;
            return m({
              clientHeight: T,
              clientWidth: P,
              onScroll: this._onScroll,
              scrollHeight: F,
              scrollLeft: N,
              scrollTop: H,
              scrollWidth: Y
            });
          }
        }, {
          key: "_onScroll",
          value: function(m) {
            var x = m.clientHeight, T = m.clientWidth, P = m.scrollHeight, F = m.scrollLeft, N = m.scrollTop, H = m.scrollWidth;
            this.setState({
              clientHeight: x,
              clientWidth: T,
              scrollHeight: P,
              scrollLeft: F,
              scrollTop: N,
              scrollWidth: H
            });
          }
        }]), I;
      }();
      function Xn(I) {
        var m = I.dataKey, x = I.rowData;
        return typeof x.get == "function" ? x.get(m) : x[m];
      }
      function Jn(I) {
        var m = I.cellData;
        return m == null ? "" : String(m);
      }
      function fa(I) {
        var m = I.className, x = I.columns, T = I.style;
        return n.createElement("div", {
          className: m,
          role: "row",
          style: T
        }, x);
      }
      c(mo, "propTypes", {
        children: ae.func.isRequired
      });
      var Jr = {
        ASC: "ASC",
        DESC: "DESC"
      };
      function Ho(I) {
        var m = I.sortDirection, x = Ze("ReactVirtualized__Table__sortableHeaderIcon", {
          "ReactVirtualized__Table__sortableHeaderIcon--ASC": m === Jr.ASC,
          "ReactVirtualized__Table__sortableHeaderIcon--DESC": m === Jr.DESC
        });
        return n.createElement("svg", {
          className: x,
          width: 18,
          height: 18,
          viewBox: "0 0 24 24"
        }, m === Jr.ASC ? n.createElement("path", {
          d: "M7 14l5-5 5 5z"
        }) : n.createElement("path", {
          d: "M7 10l5 5 5-5z"
        }), n.createElement("path", {
          d: "M0 0h24v24H0z",
          fill: "none"
        }));
      }
      function $o(I) {
        var m = I.dataKey, x = I.label, T = I.sortBy, P = I.sortDirection, F = T === m, N = [n.createElement("span", {
          className: "ReactVirtualized__Table__headerTruncatedText",
          key: "label",
          title: typeof x == "string" ? x : null
        }, x)];
        return F && N.push(n.createElement(Ho, {
          key: "SortIndicator",
          sortDirection: P
        })), N;
      }
      function pa(I) {
        var m = I.className, x = I.columns, T = I.index, P = I.key, F = I.onRowClick, N = I.onRowDoubleClick, H = I.onRowMouseOut, Y = I.onRowMouseOver, q = I.onRowRightClick, Q = I.rowData, ve = I.style, Se = {
          "aria-rowindex": T + 1
        };
        return (F || N || H || Y || q) && (Se["aria-label"] = "row", Se.tabIndex = 0, F && (Se.onClick = function(We) {
          return F({
            event: We,
            index: T,
            rowData: Q
          });
        }), N && (Se.onDoubleClick = function(We) {
          return N({
            event: We,
            index: T,
            rowData: Q
          });
        }), H && (Se.onMouseOut = function(We) {
          return H({
            event: We,
            index: T,
            rowData: Q
          });
        }), Y && (Se.onMouseOver = function(We) {
          return Y({
            event: We,
            index: T,
            rowData: Q
          });
        }), q && (Se.onContextMenu = function(We) {
          return q({
            event: We,
            index: T,
            rowData: Q
          });
        })), n.createElement("div", f({}, Se, {
          className: m,
          key: P,
          role: "row",
          style: ve
        }), x);
      }
      Ho.propTypes = {
        sortDirection: ae.oneOf([Jr.ASC, Jr.DESC])
      };
      var mn = function() {
        function I() {
          return o(this, I), C(this, b(I).apply(this, arguments));
        }
        return S(I, n.Component), I;
      }();
      c(mn, "propTypes", {
        "aria-label": ae.string,
        cellDataGetter: ae.func,
        cellRenderer: ae.func,
        className: ae.string,
        columnData: ae.object,
        dataKey: ae.any.isRequired,
        defaultSortDirection: ae.oneOf([Jr.ASC, Jr.DESC]),
        disableSort: ae.bool,
        flexGrow: ae.number,
        flexShrink: ae.number,
        headerClassName: ae.string,
        headerRenderer: ae.func.isRequired,
        headerStyle: ae.object,
        id: ae.string,
        label: ae.node,
        maxWidth: ae.number,
        minWidth: ae.number,
        style: ae.object,
        width: ae.number.isRequired
      }), c(mn, "defaultProps", {
        cellDataGetter: Xn,
        cellRenderer: Jn,
        defaultSortDirection: Jr.ASC,
        flexGrow: 0,
        flexShrink: 1,
        headerRenderer: $o,
        style: {}
      });
      var ha = function() {
        function I(m) {
          var x;
          return o(this, I), (x = C(this, b(I).call(this, m))).state = {
            scrollbarWidth: 0
          }, x._createColumn = x._createColumn.bind(w(x)), x._createRow = x._createRow.bind(w(x)), x._onScroll = x._onScroll.bind(w(x)), x._onSectionRendered = x._onSectionRendered.bind(w(x)), x._setRef = x._setRef.bind(w(x)), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "forceUpdateGrid",
          value: function() {
            this.Grid && this.Grid.forceUpdate();
          }
        }, {
          key: "getOffsetForRow",
          value: function(m) {
            var x = m.alignment, T = m.index;
            return this.Grid ? this.Grid.getOffsetForCell({
              alignment: x,
              rowIndex: T
            }).scrollTop : 0;
          }
        }, {
          key: "invalidateCellSizeAfterRender",
          value: function(m) {
            var x = m.columnIndex, T = m.rowIndex;
            this.Grid && this.Grid.invalidateCellSizeAfterRender({
              rowIndex: T,
              columnIndex: x
            });
          }
        }, {
          key: "measureAllRows",
          value: function() {
            this.Grid && this.Grid.measureAllCells();
          }
        }, {
          key: "recomputeGridSize",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : {}, T = x.columnIndex, P = T === void 0 ? 0 : T, F = x.rowIndex, N = F === void 0 ? 0 : F;
            this.Grid && this.Grid.recomputeGridSize({
              rowIndex: N,
              columnIndex: P
            });
          }
        }, {
          key: "recomputeRowHeights",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.recomputeGridSize({
              rowIndex: x
            });
          }
        }, {
          key: "scrollToPosition",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.scrollToPosition({
              scrollTop: x
            });
          }
        }, {
          key: "scrollToRow",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : 0;
            this.Grid && this.Grid.scrollToCell({
              columnIndex: 0,
              rowIndex: x
            });
          }
        }, {
          key: "getScrollbarWidth",
          value: function() {
            if (this.Grid) {
              var m = i.findDOMNode(this.Grid), x = m.clientWidth || 0;
              return (m.offsetWidth || 0) - x;
            }
            return 0;
          }
        }, {
          key: "componentDidMount",
          value: function() {
            this._setScrollbarWidth();
          }
        }, {
          key: "componentDidUpdate",
          value: function() {
            this._setScrollbarWidth();
          }
        }, {
          key: "render",
          value: function() {
            var m = this, x = this.props, T = x.children, P = x.className, F = x.disableHeader, N = x.gridClassName, H = x.gridStyle, Y = x.headerHeight, q = x.headerRowRenderer, Q = x.height, ve = x.id, Se = x.noRowsRenderer, We = x.rowClassName, De = x.rowStyle, Ne = x.scrollToIndex, $e = x.style, Ye = x.width, Ke = this.state.scrollbarWidth, tt = F ? Q : Q - Y, je = typeof We == "function" ? We({
              index: -1
            }) : We, He = typeof De == "function" ? De({
              index: -1
            }) : De;
            return this._cachedColumnStyles = [], n.Children.toArray(T).forEach(function(ke, ut) {
              var Ct = m._getFlexStyleForColumn(ke, ke.props.style);
              m._cachedColumnStyles[ut] = g({
                overflow: "hidden"
              }, Ct);
            }), n.createElement("div", {
              "aria-label": this.props["aria-label"],
              "aria-labelledby": this.props["aria-labelledby"],
              "aria-colcount": n.Children.toArray(T).length,
              "aria-rowcount": this.props.rowCount,
              className: Ze("ReactVirtualized__Table", P),
              id: ve,
              role: "grid",
              style: $e
            }, !F && q({
              className: Ze("ReactVirtualized__Table__headerRow", je),
              columns: this._getHeaderColumns(),
              style: g({
                height: Y,
                overflow: "hidden",
                paddingRight: Ke,
                width: Ye
              }, He)
            }), n.createElement(dn, f({}, this.props, {
              "aria-readonly": null,
              autoContainerWidth: !0,
              className: Ze("ReactVirtualized__Table__Grid", N),
              cellRenderer: this._createRow,
              columnWidth: Ye,
              columnCount: 1,
              height: tt,
              id: void 0,
              noContentRenderer: Se,
              onScroll: this._onScroll,
              onSectionRendered: this._onSectionRendered,
              ref: this._setRef,
              role: "rowgroup",
              scrollbarWidth: Ke,
              scrollToRow: Ne,
              style: g({}, H, {
                overflowX: "hidden"
              })
            })));
          }
        }, {
          key: "_createColumn",
          value: function(m) {
            var x = m.column, T = m.columnIndex, P = m.isScrolling, F = m.parent, N = m.rowData, H = m.rowIndex, Y = this.props.onColumnClick, q = x.props, Q = q.cellDataGetter, ve = q.cellRenderer, Se = q.className, We = q.columnData, De = q.dataKey, Ne = q.id, $e = ve({
              cellData: Q({
                columnData: We,
                dataKey: De,
                rowData: N
              }),
              columnData: We,
              columnIndex: T,
              dataKey: De,
              isScrolling: P,
              parent: F,
              rowData: N,
              rowIndex: H
            }), Ye = this._cachedColumnStyles[T], Ke = typeof $e == "string" ? $e : null;
            return n.createElement("div", {
              "aria-colindex": T + 1,
              "aria-describedby": Ne,
              className: Ze("ReactVirtualized__Table__rowColumn", Se),
              key: "Row" + H + "-Col" + T,
              onClick: function(tt) {
                Y && Y({
                  columnData: We,
                  dataKey: De,
                  event: tt
                });
              },
              role: "gridcell",
              style: Ye,
              title: Ke
            }, $e);
          }
        }, {
          key: "_createHeader",
          value: function(m) {
            var x, T, P, F, N, H = m.column, Y = m.index, q = this.props, Q = q.headerClassName, ve = q.headerStyle, Se = q.onHeaderClick, We = q.sort, De = q.sortBy, Ne = q.sortDirection, $e = H.props, Ye = $e.columnData, Ke = $e.dataKey, tt = $e.defaultSortDirection, je = $e.disableSort, He = $e.headerRenderer, ke = $e.id, ut = $e.label, Ct = !je && We, er = Ze("ReactVirtualized__Table__headerColumn", Q, H.props.headerClassName, {
              ReactVirtualized__Table__sortableHeaderColumn: Ct
            }), xt = this._getFlexStyleForColumn(H, g({}, ve, {}, H.props.headerStyle)), ft = He({
              columnData: Ye,
              dataKey: Ke,
              disableSort: je,
              label: ut,
              sortBy: De,
              sortDirection: Ne
            });
            if (Ct || Se) {
              var vr = De !== Ke ? tt : Ne === Jr.DESC ? Jr.ASC : Jr.DESC, ur = function(kr) {
                Ct && We({
                  defaultSortDirection: tt,
                  event: kr,
                  sortBy: Ke,
                  sortDirection: vr
                }), Se && Se({
                  columnData: Ye,
                  dataKey: Ke,
                  event: kr
                });
              };
              N = H.props["aria-label"] || ut || Ke, F = "none", P = 0, x = ur, T = function(kr) {
                kr.key !== "Enter" && kr.key !== " " || ur(kr);
              };
            }
            return De === Ke && (F = Ne === Jr.ASC ? "ascending" : "descending"), n.createElement("div", {
              "aria-label": N,
              "aria-sort": F,
              className: er,
              id: ke,
              key: "Header-Col" + Y,
              onClick: x,
              onKeyDown: T,
              role: "columnheader",
              style: xt,
              tabIndex: P
            }, ft);
          }
        }, {
          key: "_createRow",
          value: function(m) {
            var x = this, T = m.rowIndex, P = m.isScrolling, F = m.key, N = m.parent, H = m.style, Y = this.props, q = Y.children, Q = Y.onRowClick, ve = Y.onRowDoubleClick, Se = Y.onRowRightClick, We = Y.onRowMouseOver, De = Y.onRowMouseOut, Ne = Y.rowClassName, $e = Y.rowGetter, Ye = Y.rowRenderer, Ke = Y.rowStyle, tt = this.state.scrollbarWidth, je = typeof Ne == "function" ? Ne({
              index: T
            }) : Ne, He = typeof Ke == "function" ? Ke({
              index: T
            }) : Ke, ke = $e({
              index: T
            }), ut = n.Children.toArray(q).map(function(xt, ft) {
              return x._createColumn({
                column: xt,
                columnIndex: ft,
                isScrolling: P,
                parent: N,
                rowData: ke,
                rowIndex: T,
                scrollbarWidth: tt
              });
            }), Ct = Ze("ReactVirtualized__Table__row", je), er = g({}, H, {
              height: this._getRowHeight(T),
              overflow: "hidden",
              paddingRight: tt
            }, He);
            return Ye({
              className: Ct,
              columns: ut,
              index: T,
              isScrolling: P,
              key: F,
              onRowClick: Q,
              onRowDoubleClick: ve,
              onRowRightClick: Se,
              onRowMouseOver: We,
              onRowMouseOut: De,
              rowData: ke,
              style: er
            });
          }
        }, {
          key: "_getFlexStyleForColumn",
          value: function(m, x) {
            var T = 1 < arguments.length && x !== void 0 ? x : {}, P = "".concat(m.props.flexGrow, " ").concat(m.props.flexShrink, " ").concat(m.props.width, "px"), F = g({}, T, {
              flex: P,
              msFlex: P,
              WebkitFlex: P
            });
            return m.props.maxWidth && (F.maxWidth = m.props.maxWidth), m.props.minWidth && (F.minWidth = m.props.minWidth), F;
          }
        }, {
          key: "_getHeaderColumns",
          value: function() {
            var m = this, x = this.props, T = x.children;
            return (x.disableHeader ? [] : n.Children.toArray(T)).map(function(P, F) {
              return m._createHeader({
                column: P,
                index: F
              });
            });
          }
        }, {
          key: "_getRowHeight",
          value: function(m) {
            var x = this.props.rowHeight;
            return typeof x == "function" ? x({
              index: m
            }) : x;
          }
        }, {
          key: "_onScroll",
          value: function(m) {
            var x = m.clientHeight, T = m.scrollHeight, P = m.scrollTop;
            (0, this.props.onScroll)({
              clientHeight: x,
              scrollHeight: T,
              scrollTop: P
            });
          }
        }, {
          key: "_onSectionRendered",
          value: function(m) {
            var x = m.rowOverscanStartIndex, T = m.rowOverscanStopIndex, P = m.rowStartIndex, F = m.rowStopIndex;
            (0, this.props.onRowsRendered)({
              overscanStartIndex: x,
              overscanStopIndex: T,
              startIndex: P,
              stopIndex: F
            });
          }
        }, {
          key: "_setRef",
          value: function(m) {
            this.Grid = m;
          }
        }, {
          key: "_setScrollbarWidth",
          value: function() {
            var m = this.getScrollbarWidth();
            this.setState({
              scrollbarWidth: m
            });
          }
        }]), I;
      }();
      c(ha, "propTypes", {
        "aria-label": ae.string,
        "aria-labelledby": ae.string,
        autoHeight: ae.bool,
        children: function(I) {
          for (var m = n.Children.toArray(I.children), x = 0; x < m.length; x++) {
            var T = m[x].type;
            if (T !== mn && !(T.prototype instanceof mn)) return new Error("Table only accepts children of type Column");
          }
        },
        className: ae.string,
        disableHeader: ae.bool,
        estimatedRowSize: ae.number.isRequired,
        gridClassName: ae.string,
        gridStyle: ae.object,
        headerClassName: ae.string,
        headerHeight: ae.number.isRequired,
        headerRowRenderer: ae.func,
        headerStyle: ae.object,
        height: ae.number.isRequired,
        id: ae.string,
        noRowsRenderer: ae.func,
        onColumnClick: ae.func,
        onHeaderClick: ae.func,
        onRowClick: ae.func,
        onRowDoubleClick: ae.func,
        onRowMouseOut: ae.func,
        onRowMouseOver: ae.func,
        onRowRightClick: ae.func,
        onRowsRendered: ae.func,
        onScroll: ae.func.isRequired,
        overscanIndicesGetter: ae.func.isRequired,
        overscanRowCount: ae.number.isRequired,
        rowClassName: ae.oneOfType([ae.string, ae.func]),
        rowGetter: ae.func.isRequired,
        rowHeight: ae.oneOfType([ae.number, ae.func]).isRequired,
        rowCount: ae.number.isRequired,
        rowRenderer: ae.func,
        rowStyle: ae.oneOfType([ae.object, ae.func]).isRequired,
        scrollToAlignment: ae.oneOf(["auto", "end", "start", "center"]).isRequired,
        scrollToIndex: ae.number.isRequired,
        scrollTop: ae.number,
        sort: ae.func,
        sortBy: ae.string,
        sortDirection: ae.oneOf([Jr.ASC, Jr.DESC]),
        style: ae.object,
        tabIndex: ae.number,
        width: ae.number.isRequired
      }), c(ha, "defaultProps", {
        disableHeader: !1,
        estimatedRowSize: 30,
        headerHeight: 0,
        headerStyle: {},
        noRowsRenderer: function() {
          return null;
        },
        onRowsRendered: function() {
          return null;
        },
        onScroll: function() {
          return null;
        },
        overscanIndicesGetter: fi,
        overscanRowCount: 10,
        rowRenderer: pa,
        headerRowRenderer: fa,
        rowStyle: {},
        scrollToAlignment: "auto",
        scrollToIndex: -1,
        style: {}
      });
      var pi = [], yo = null, Zn = null;
      function as() {
        Zn && (Zn = null, document.body && yo != null && (document.body.style.pointerEvents = yo), yo = null);
      }
      function $s() {
        as(), pi.forEach(function(I) {
          return I.__resetIsScrolling();
        });
      }
      function ga(I) {
        I.currentTarget === window && yo == null && document.body && (yo = document.body.style.pointerEvents, document.body.style.pointerEvents = "none"), function() {
          Zn && jn(Zn);
          var m = 0;
          pi.forEach(function(x) {
            m = Math.max(m, x.props.scrollingResetTimeInterval);
          }), Zn = vn($s, m);
        }(), pi.forEach(function(m) {
          m.props.scrollElement === I.currentTarget && m.__handleWindowScrollEvent();
        });
      }
      function Uo(I, m) {
        pi.some(function(x) {
          return x.props.scrollElement === m;
        }) || m.addEventListener("scroll", ga), pi.push(I);
      }
      function va(I, m) {
        (pi = pi.filter(function(x) {
          return x !== I;
        })).length || (m.removeEventListener("scroll", ga), Zn && (jn(Zn), as()));
      }
      var Qi = function(I) {
        return I === window;
      }, eo = function(I) {
        return I.getBoundingClientRect();
      };
      function ss(I, m) {
        if (I) {
          if (Qi(I)) {
            var x = window, T = x.innerHeight, P = x.innerWidth;
            return {
              height: typeof T == "number" ? T : 0,
              width: typeof P == "number" ? P : 0
            };
          }
          return eo(I);
        }
        return {
          height: m.serverHeight,
          width: m.serverWidth
        };
      }
      function ma(I) {
        return Qi(I) && document.documentElement ? {
          top: "scrollY" in window ? window.scrollY : document.documentElement.scrollTop,
          left: "scrollX" in window ? window.scrollX : document.documentElement.scrollLeft
        } : {
          top: I.scrollTop,
          left: I.scrollLeft
        };
      }
      var ya = function() {
        return typeof window < "u" ? window : void 0;
      }, ba = function() {
        function I() {
          var m, x;
          o(this, I);
          for (var T = arguments.length, P = new Array(T), F = 0; F < T; F++) P[F] = arguments[F];
          return c(w(x = C(this, (m = b(I)).call.apply(m, [this].concat(P)))), "_window", ya()), c(w(x), "_isMounted", !1), c(w(x), "_positionFromTop", 0), c(w(x), "_positionFromLeft", 0), c(w(x), "_detectElementResize", void 0), c(w(x), "_child", void 0), c(w(x), "state", g({}, ss(x.props.scrollElement, x.props), {
            isScrolling: !1,
            scrollLeft: 0,
            scrollTop: 0
          })), c(w(x), "_registerChild", function(N) {
            !N || N instanceof Element || console.warn("WindowScroller registerChild expects to be passed Element or null"), x._child = N, x.updatePosition();
          }), c(w(x), "_onChildScroll", function(N) {
            var H = N.scrollTop;
            if (x.state.scrollTop !== H) {
              var Y = x.props.scrollElement;
              Y && (typeof Y.scrollTo == "function" ? Y.scrollTo(0, H + x._positionFromTop) : Y.scrollTop = H + x._positionFromTop);
            }
          }), c(w(x), "_registerResizeListener", function(N) {
            N === window ? window.addEventListener("resize", x._onResize, !1) : x._detectElementResize.addResizeListener(N, x._onResize);
          }), c(w(x), "_unregisterResizeListener", function(N) {
            N === window ? window.removeEventListener("resize", x._onResize, !1) : N && x._detectElementResize.removeResizeListener(N, x._onResize);
          }), c(w(x), "_onResize", function() {
            x.updatePosition();
          }), c(w(x), "__handleWindowScrollEvent", function() {
            if (x._isMounted) {
              var N = x.props.onScroll, H = x.props.scrollElement;
              if (H) {
                var Y = ma(H), q = Math.max(0, Y.left - x._positionFromLeft), Q = Math.max(0, Y.top - x._positionFromTop);
                x.setState({
                  isScrolling: !0,
                  scrollLeft: q,
                  scrollTop: Q
                }), N({
                  scrollLeft: q,
                  scrollTop: Q
                });
              }
            }
          }), c(w(x), "__resetIsScrolling", function() {
            x.setState({
              isScrolling: !1
            });
          }), x;
        }
        return S(I, n.PureComponent), l(I, [{
          key: "updatePosition",
          value: function(m) {
            var x = 0 < arguments.length && m !== void 0 ? m : this.props.scrollElement, T = this.props.onResize, P = this.state, F = P.height, N = P.width, H = this._child || i.findDOMNode(this);
            if (H instanceof Element && x) {
              var Y = function(Q, ve) {
                if (Qi(ve) && document.documentElement) {
                  var Se = document.documentElement, We = eo(Q), De = eo(Se);
                  return {
                    top: We.top - De.top,
                    left: We.left - De.left
                  };
                }
                var Ne = ma(ve), $e = eo(Q), Ye = eo(ve);
                return {
                  top: $e.top + Ne.top - Ye.top,
                  left: $e.left + Ne.left - Ye.left
                };
              }(H, x);
              this._positionFromTop = Y.top, this._positionFromLeft = Y.left;
            }
            var q = ss(x, this.props);
            F === q.height && N === q.width || (this.setState({
              height: q.height,
              width: q.width
            }), T({
              height: q.height,
              width: q.width
            }));
          }
        }, {
          key: "componentDidMount",
          value: function() {
            var m = this.props.scrollElement;
            this._detectElementResize = ee(), this.updatePosition(m), m && (Uo(this, m), this._registerResizeListener(m)), this._isMounted = !0;
          }
        }, {
          key: "componentDidUpdate",
          value: function(m) {
            var x = this.props.scrollElement, T = m.scrollElement;
            T !== x && T != null && x != null && (this.updatePosition(x), va(this, T), Uo(this, x), this._unregisterResizeListener(T), this._registerResizeListener(x));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            var m = this.props.scrollElement;
            m && (va(this, m), this._unregisterResizeListener(m)), this._isMounted = !1;
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props.children, x = this.state, T = x.isScrolling, P = x.scrollTop, F = x.scrollLeft, N = x.height, H = x.width;
            return m({
              onChildScroll: this._onChildScroll,
              registerChild: this._registerChild,
              height: N,
              isScrolling: T,
              scrollLeft: F,
              scrollTop: P,
              width: H
            });
          }
        }]), I;
      }();
      c(ba, "defaultProps", {
        onResize: function() {
        },
        onScroll: function() {
        },
        scrollingResetTimeInterval: 150,
        scrollElement: ya(),
        serverHeight: 0,
        serverWidth: 0
      }), r.ArrowKeyStepper = Z, r.AutoSizer = he, r.CellMeasurer = _e, r.CellMeasurerCache = Te, r.Collection = pr, r.Column = mn, r.ColumnSizer = wr, r.Grid = dn, r.InfiniteLoader = Oi, r.List = rn, r.Masonry = da, r.MultiGrid = kn, r.ScrollSync = mo, r.SortDirection = Jr, r.SortIndicator = Ho, r.Table = ha, r.WindowScroller = ba, r.accessibilityOverscanIndicesGetter = fi, r.createMasonryCellPositioner = function(I) {
        var m, x = I.cellMeasurerCache, T = I.columnCount, P = I.columnWidth, F = I.spacer, N = F === void 0 ? 0 : F;
        function H(q) {
          for (var Q = 0, ve = 1; ve < m.length; ve++) m[ve] < m[Q] && (Q = ve);
          var Se = Q * (P + N), We = m[Q] || 0;
          return m[Q] = We + x.getHeight(q) + N, {
            left: Se,
            top: We
          };
        }
        function Y() {
          m = [];
          for (var q = 0; q < T; q++) m[q] = 0;
        }
        return Y(), H.reset = function(q) {
          T = q.columnCount, P = q.columnWidth, N = q.spacer, Y();
        }, H;
      }, r.createTableMultiSort = function(I) {
        var m = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, x = m.defaultSortBy, T = m.defaultSortDirection, P = T === void 0 ? {} : T;
        if (!I) throw Error('Required parameter "sortCallback" not specified');
        var F = x || [], N = {};
        return F.forEach(function(H) {
          N[H] = P[H] !== void 0 ? P[H] : "ASC";
        }), {
          sort: function(H) {
            var Y = H.defaultSortDirection, q = H.event, Q = H.sortBy;
            if (q.shiftKey) N[Q] !== void 0 ? N[Q] = N[Q] === "ASC" ? "DESC" : "ASC" : (N[Q] = Y, F.push(Q));
            else if (q.ctrlKey || q.metaKey) {
              var ve = F.indexOf(Q);
              0 <= ve && (F.splice(ve, 1), delete N[Q]);
            } else
              F.length = 0, F.push(Q), Object.keys(N).forEach(function(Se) {
                Se !== Q && delete N[Se];
              }), N[Q] !== void 0 ? N[Q] = N[Q] === "ASC" ? "DESC" : "ASC" : N[Q] = Y;
            I({
              sortBy: F,
              sortDirection: N
            });
          },
          sortBy: F,
          sortDirection: N
        };
      }, r.defaultCellRangeRenderer = rr, r.defaultOverscanIndicesGetter = gn, r.defaultTableCellDataGetter = Xn, r.defaultTableCellRenderer = Jn, r.defaultTableHeaderRenderer = $o, r.defaultTableHeaderRowRenderer = fa, r.defaultTableRowRenderer = pa, Object.defineProperty(r, "__esModule", {
        value: !0
      });
    });
  }(Qu, Qu.exports)), Qu.exports;
}
var co = cz();
const wC = Rt((e) => ({
  bigList: {
    height: 300
  },
  card: {
    maxHeight: 300,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  label: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  boxMarginLeft: {
    marginLeft: ({ index: t, level: r }) => t ? r ? (r - 2) * 7 : 0 : -5,
    "& svg": {
      fontSize: 15
    }
  },
  labelWeight: {
    fontWeight: "500"
  },
  listHeader: {
    borderBottom: `solid 1px ${e.palette.grey[100]}`,
    height: 50,
    marginLeft: e.spacing(2),
    paddingLeft: 0,
    paddingRight: e.spacing(2)
  },
  listItem: {
    gap: e.spacing(2),
    paddingLeft: ({ level: t }) => 16 + (t || 0) * 10
  },
  listItemDisabled: {
    filter: "grayscale(1)",
    pointerEvents: "none !important"
  },
  listItemIcon: {
    minWidth: 20,
    position: "relative",
    right: e.spacing(-0.2)
  },
  listItemSecondaryLabel: {
    display: "flex"
  },
  listItemSelected: {
    backgroundColor: "white !important"
  },
  listMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: e.spacing(2)
  },
  popper: {
    zIndex: e.zIndex.tooltip
  },
  secondaryLabel: {
    marginLeft: e.spacing(1)
  },
  wrapperListItemRight: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: "flex-end"
  }
}));
var ec = /* @__PURE__ */ ((e) => (e[e.BASIC = 0] = "BASIC", e[e.MULTIPLE = 1] = "MULTIPLE", e))(ec || {});
const Mw = ({
  item: e,
  index: t,
  disabled: r,
  mode: n,
  onSelect: i,
  showLevelIcons: o,
  isBusy: s,
  style: l
}) => {
  const c = wC({ index: t, level: e.level }), f = r || !e.loading && (e.disabled || e.selected), h = e.isInactive ? `${e.label} (désactivé)` : e.label, g = e.isInactive ? {
    fontStyle: "italic",
    color: "gray"
  } : {};
  return /* @__PURE__ */ y.jsxs(
    Qf,
    {
      button: !0,
      "data-testid": "auto-complete-list-item",
      disabled: f,
      classes: { root: c.listItem },
      className: nt(
        f && c.listItemDisabled,
        (e.selected || e.loading || e.secondaryLabel) && c.listItemSecondaryLabel,
        (e.selected || e.loading) && c.listItemSelected
      ),
      onMouseDown: () => {
        !e.disabled && !e.selected && (i == null || i(e));
      },
      selected: e.selected,
      style: {
        ...l,
        pointerEvents: s ? "none" : "auto"
      },
      children: [
        o && !!e.level && /* @__PURE__ */ y.jsx(zt, { className: c.boxMarginLeft, children: /* @__PURE__ */ y.jsx(fN, { color: "disabled" }) }),
        /* @__PURE__ */ y.jsx(
          Ya,
          {
            classes: {
              primary: nt(
                c.label,
                o && !e.level && c.labelWeight
              )
            },
            primary: e.color ? /* @__PURE__ */ y.jsx(
              Qa,
              {
                label: h,
                color: "primary",
                sx: {
                  backgroundColor: e.color,
                  ...g
                }
              }
            ) : /* @__PURE__ */ y.jsx(zt, { sx: g, children: h })
          }
        ),
        /* @__PURE__ */ y.jsxs("div", { className: c.wrapperListItemRight, children: [
          n === 1 && (e.loading ? /* @__PURE__ */ y.jsx(Va, { className: c.listItemIcon, children: /* @__PURE__ */ y.jsx(un, { size: 15 }) }) : e.selected && /* @__PURE__ */ y.jsx(Va, { className: c.listItemIcon, children: /* @__PURE__ */ y.jsx(bC, { fontSize: "small" }) })),
          e.secondaryLabel && /* @__PURE__ */ y.jsx(
            Ya,
            {
              classes: {
                root: c.secondaryLabel,
                secondary: c.label
              },
              disableTypography: !0,
              primary: e.secondaryLabel
            }
          )
        ] })
      ]
    }
  );
}, Wm = ({
  anchorRef: e,
  disabled: t,
  error: r,
  list: n = [],
  listHeader: i,
  loading: o,
  mode: s,
  onClose: l,
  onSelect: c,
  open: f,
  placeholder: h = "Aucun résultat",
  scrollToItem: g,
  showLevelIcons: S
}) => {
  var L;
  const b = wC({}), p = bt(null), v = kt(
    () => !!n.find(({ loading: W }) => W),
    [n]
  ), w = n.length > 7 - (i ? 1 : 0), C = kt(
    () => typeof h == "function" ? h(l) : h,
    [l, h]
  ), M = kt(
    () => typeof i == "function" ? i(l) : i,
    [l, i]
  );
  return /* @__PURE__ */ y.jsx(
    Jf,
    {
      anchorEl: e.current,
      className: b.popper,
      open: f,
      style: { width: (L = e.current) == null ? void 0 : L.clientWidth },
      transition: !0,
      children: ({ TransitionProps: W, placement: z }) => /* @__PURE__ */ y.jsx(
        Zf,
        {
          ...W,
          style: {
            transformOrigin: z === "bottom" ? "center top" : "center bottom"
          },
          children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
            dm,
            {
              mouseEvent: "onMouseDown",
              onClickAway: (B) => {
                e.current.contains(B.target) || l == null || l();
              },
              touchEvent: "onTouchStart",
              children: /* @__PURE__ */ y.jsx(
                Bo,
                {
                  classes: { root: b.card },
                  raised: !0,
                  ...z !== "bottom" && {
                    style: {
                      borderTopLeftRadius: 4,
                      borderTopRightRadius: 4
                    }
                  },
                  children: o || r || !n.length ? /* @__PURE__ */ y.jsx("div", { className: b.listMessage, children: o ? /* @__PURE__ */ y.jsx(un, { size: 20 }) : /* @__PURE__ */ y.jsx(
                    Lt,
                    {
                      variant: "body2",
                      color: r ? "error" : void 0,
                      children: r ? r.message || "Une erreur est survenue" : C
                    }
                  ) }) : /* @__PURE__ */ y.jsx(
                    Nc,
                    {
                      className: nt(w && b.bigList),
                      "data-testid": "auto-complete-list",
                      dense: !0,
                      children: w ? /* @__PURE__ */ y.jsx(co.AutoSizer, { children: ({ width: B, height: K }) => {
                        var Z;
                        return /* @__PURE__ */ y.jsx(
                          co.Table,
                          {
                            disableHeader: !i,
                            headerHeight: ((Z = p == null ? void 0 : p.current) == null ? void 0 : Z.clientHeight) || 50,
                            headerRowRenderer: () => /* @__PURE__ */ y.jsx(
                              B0,
                              {
                                classes: { root: b.listHeader },
                                ref: p,
                                style: { width: B },
                                children: M
                              }
                            ),
                            height: K,
                            gridStyle: { paddingTop: i ? 8 : 0 },
                            rowHeight: 36,
                            rowStyle: { paddingRight: 16 * 2 },
                            rowCount: n.length,
                            rowGetter: ({ index: ee }) => n[ee],
                            rowRenderer: ({ key: ee, index: he, style: _e }) => /* @__PURE__ */ y.jsx(
                              Mw,
                              {
                                mode: s,
                                onSelect: c,
                                isBusy: v,
                                showLevelIcons: S,
                                disabled: t,
                                item: n[he],
                                index: he,
                                style: _e
                              },
                              ee
                            ),
                            scrollToAlignment: "auto",
                            scrollToIndex: g,
                            style: { outline: 0 },
                            width: B
                          }
                        );
                      } }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                        i && /* @__PURE__ */ y.jsx(
                          B0,
                          {
                            classes: { root: b.listHeader },
                            style: { marginBottom: 8 },
                            children: M
                          }
                        ),
                        n.map((B, K) => /* @__PURE__ */ y.jsx(
                          Mw,
                          {
                            mode: s,
                            onSelect: c,
                            isBusy: v,
                            showLevelIcons: S,
                            disabled: t,
                            item: B,
                            index: K
                          },
                          `autocomplete-item-${K}`
                        ))
                      ] })
                    }
                  )
                }
              )
            }
          ) })
        }
      )
    }
  );
};
var tc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var dz = tc.exports, Aw;
function fz() {
  return Aw || (Aw = 1, function(e, t) {
    (function() {
      var r, n = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", l = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", f = 500, h = "__lodash_placeholder__", g = 1, S = 2, b = 4, p = 1, v = 2, w = 1, C = 2, M = 4, L = 8, W = 16, z = 32, B = 64, K = 128, Z = 256, ee = 512, he = 30, _e = "...", Te = 800, fe = 16, Oe = 1, ye = 2, de = 3, ce = 1 / 0, Fe = 9007199254740991, le = 17976931348623157e292, J = NaN, re = 4294967295, be = re - 1, Me = re >>> 1, Ae = [
        ["ary", K],
        ["bind", w],
        ["bindKey", C],
        ["curry", L],
        ["curryRight", W],
        ["flip", ee],
        ["partial", z],
        ["partialRight", B],
        ["rearg", Z]
      ], Re = "[object Arguments]", Ee = "[object Array]", Ce = "[object AsyncFunction]", X = "[object Boolean]", ie = "[object Date]", Ie = "[object DOMException]", xe = "[object Error]", Pe = "[object Function]", ae = "[object GeneratorFunction]", rt = "[object Map]", Ze = "[object Number]", ht = "[object Null]", mt = "[object Object]", At = "[object Promise]", Bt = "[object Proxy]", Gt = "[object RegExp]", It = "[object Set]", sr = "[object String]", et = "[object Symbol]", at = "[object Undefined]", Qt = "[object WeakMap]", pr = "[object WeakSet]", wr = "[object ArrayBuffer]", gt = "[object DataView]", hr = "[object Float32Array]", Nn = "[object Float64Array]", hn = "[object Int8Array]", cn = "[object Int16Array]", gn = "[object Int32Array]", tn = "[object Uint8Array]", rr = "[object Uint8ClampedArray]", Tn = "[object Uint16Array]", xr = "[object Uint32Array]", Xi = /\b__p \+= '';/g, Ti = /\b(__p \+=) '' \+/g, Gr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, jn = /&(?:amp|lt|gt|quot|#39);/g, vn = /[&<>"']/g, Ji = RegExp(jn.source), di = RegExp(vn.source), dn = /<%-([\s\S]+?)%>/g, fi = /<%([\s\S]+?)%>/g, Oi = /<%=([\s\S]+?)%>/g, rn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vo = /^\w*$/, oe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Qe = /[\\^$.*+?()[\]{}|]/g, lt = RegExp(Qe.source), _t = /^\s+/, lr = /\s/, nr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ht = /\{\n\/\* \[wrapped with (.+)\] \*/, Ft = /,? & /, Er = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Rr = /[()=,{}\[\]\/\s]/, Cr = /\\(\\)?/g, fn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, nn = /\w*$/, qr = /^[-+]0x[0-9a-f]+$/i, Tt = /^0b[01]+$/i, Wo = /^\[object .+?Constructor\]$/, da = /^0o[0-7]+$/i, qt = /^(?:0|[1-9]\d*)$/, Zi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, kn = /($^)/, mo = /['\n\r\u2028\u2029\\]/g, Xn = "\\ud800-\\udfff", Jn = "\\u0300-\\u036f", fa = "\\ufe20-\\ufe2f", Jr = "\\u20d0-\\u20ff", Ho = Jn + fa + Jr, $o = "\\u2700-\\u27bf", pa = "a-z\\xdf-\\xf6\\xf8-\\xff", mn = "\\xac\\xb1\\xd7\\xf7", ha = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", pi = "\\u2000-\\u206f", yo = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Zn = "A-Z\\xc0-\\xd6\\xd8-\\xde", as = "\\ufe0e\\ufe0f", $s = mn + ha + pi + yo, ga = "['’]", Uo = "[" + Xn + "]", va = "[" + $s + "]", Qi = "[" + Ho + "]", eo = "\\d+", ss = "[" + $o + "]", ma = "[" + pa + "]", ya = "[^" + Xn + $s + eo + $o + pa + Zn + "]", ba = "\\ud83c[\\udffb-\\udfff]", I = "(?:" + Qi + "|" + ba + ")", m = "[^" + Xn + "]", x = "(?:\\ud83c[\\udde6-\\uddff]){2}", T = "[\\ud800-\\udbff][\\udc00-\\udfff]", P = "[" + Zn + "]", F = "\\u200d", N = "(?:" + ma + "|" + ya + ")", H = "(?:" + P + "|" + ya + ")", Y = "(?:" + ga + "(?:d|ll|m|re|s|t|ve))?", q = "(?:" + ga + "(?:D|LL|M|RE|S|T|VE))?", Q = I + "?", ve = "[" + as + "]?", Se = "(?:" + F + "(?:" + [m, x, T].join("|") + ")" + ve + Q + ")*", We = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", De = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ne = ve + Q + Se, $e = "(?:" + [ss, x, T].join("|") + ")" + Ne, Ye = "(?:" + [m + Qi + "?", Qi, x, T, Uo].join("|") + ")", Ke = RegExp(ga, "g"), tt = RegExp(Qi, "g"), je = RegExp(ba + "(?=" + ba + ")|" + Ye + Ne, "g"), He = RegExp([
        P + "?" + ma + "+" + Y + "(?=" + [va, P, "$"].join("|") + ")",
        H + "+" + q + "(?=" + [va, P + N, "$"].join("|") + ")",
        P + "?" + N + "+" + Y,
        P + "+" + q,
        De,
        We,
        eo,
        $e
      ].join("|"), "g"), ke = RegExp("[" + F + Xn + Ho + as + "]"), ut = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ct = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], er = -1, xt = {};
      xt[hr] = xt[Nn] = xt[hn] = xt[cn] = xt[gn] = xt[tn] = xt[rr] = xt[Tn] = xt[xr] = !0, xt[Re] = xt[Ee] = xt[wr] = xt[X] = xt[gt] = xt[ie] = xt[xe] = xt[Pe] = xt[rt] = xt[Ze] = xt[mt] = xt[Gt] = xt[It] = xt[sr] = xt[Qt] = !1;
      var ft = {};
      ft[Re] = ft[Ee] = ft[wr] = ft[gt] = ft[X] = ft[ie] = ft[hr] = ft[Nn] = ft[hn] = ft[cn] = ft[gn] = ft[rt] = ft[Ze] = ft[mt] = ft[Gt] = ft[It] = ft[sr] = ft[et] = ft[tn] = ft[rr] = ft[Tn] = ft[xr] = !0, ft[xe] = ft[Pe] = ft[Qt] = !1;
      var vr = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, ur = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, kr = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, yn = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, bo = parseFloat, to = parseInt, ls = typeof xi == "object" && xi && xi.Object === Object && xi, Us = typeof self == "object" && self && self.Object === Object && self, Vr = ls || Us || Function("return this")(), yt = t && !t.nodeType && t, Hn = yt && !0 && e && !e.nodeType && e, Qn = Hn && Hn.exports === yt, ro = Qn && ls.process, on = function() {
        try {
          var G = Hn && Hn.require && Hn.require("util").types;
          return G || ro && ro.binding && ro.binding("util");
        } catch {
        }
      }(), Gs = on && on.isArrayBuffer, wa = on && on.isDate, Ri = on && on.isMap, Ii = on && on.isRegExp, us = on && on.isSet, Go = on && on.isTypedArray;
      function $t(G, ge, ue) {
        switch (ue.length) {
          case 0:
            return G.call(ge);
          case 1:
            return G.call(ge, ue[0]);
          case 2:
            return G.call(ge, ue[0], ue[1]);
          case 3:
            return G.call(ge, ue[0], ue[1], ue[2]);
        }
        return G.apply(ge, ue);
      }
      function td(G, ge, ue, Ve) {
        for (var ot = -1, St = G == null ? 0 : G.length; ++ot < St; ) {
          var gr = G[ot];
          ge(Ve, gr, ue(gr), G);
        }
        return Ve;
      }
      function $n(G, ge) {
        for (var ue = -1, Ve = G == null ? 0 : G.length; ++ue < Ve && ge(G[ue], ue, G) !== !1; )
          ;
        return G;
      }
      function rd(G, ge) {
        for (var ue = G == null ? 0 : G.length; ue-- && ge(G[ue], ue, G) !== !1; )
          ;
        return G;
      }
      function hi(G, ge) {
        for (var ue = -1, Ve = G == null ? 0 : G.length; ++ue < Ve; )
          if (!ge(G[ue], ue, G))
            return !1;
        return !0;
      }
      function Di(G, ge) {
        for (var ue = -1, Ve = G == null ? 0 : G.length, ot = 0, St = []; ++ue < Ve; ) {
          var gr = G[ue];
          ge(gr, ue, G) && (St[ot++] = gr);
        }
        return St;
      }
      function cs(G, ge) {
        var ue = G == null ? 0 : G.length;
        return !!ue && wo(G, ge, 0) > -1;
      }
      function qs(G, ge, ue) {
        for (var Ve = -1, ot = G == null ? 0 : G.length; ++Ve < ot; )
          if (ue(ge, G[Ve]))
            return !0;
        return !1;
      }
      function Jt(G, ge) {
        for (var ue = -1, Ve = G == null ? 0 : G.length, ot = Array(Ve); ++ue < Ve; )
          ot[ue] = ge(G[ue], ue, G);
        return ot;
      }
      function Ir(G, ge) {
        for (var ue = -1, Ve = ge.length, ot = G.length; ++ue < Ve; )
          G[ot + ue] = ge[ue];
        return G;
      }
      function xa(G, ge, ue, Ve) {
        var ot = -1, St = G == null ? 0 : G.length;
        for (Ve && St && (ue = G[++ot]); ++ot < St; )
          ue = ge(ue, G[ot], ot, G);
        return ue;
      }
      function nd(G, ge, ue, Ve) {
        var ot = G == null ? 0 : G.length;
        for (Ve && ot && (ue = G[--ot]); ot--; )
          ue = ge(ue, G[ot], ot, G);
        return ue;
      }
      function ou(G, ge) {
        for (var ue = -1, Ve = G == null ? 0 : G.length; ++ue < Ve; )
          if (ge(G[ue], ue, G))
            return !0;
        return !1;
      }
      var Tp = ei("length");
      function Dr(G) {
        return G.split("");
      }
      function au(G) {
        return G.match(Er) || [];
      }
      function su(G, ge, ue) {
        var Ve;
        return ue(G, function(ot, St, gr) {
          if (ge(ot, St, gr))
            return Ve = St, !1;
        }), Ve;
      }
      function bn(G, ge, ue, Ve) {
        for (var ot = G.length, St = ue + (Ve ? 1 : -1); Ve ? St-- : ++St < ot; )
          if (ge(G[St], St, G))
            return St;
        return -1;
      }
      function wo(G, ge, ue) {
        return ge === ge ? Ip(G, ge, ue) : bn(G, lu, ue);
      }
      function id(G, ge, ue, Ve) {
        for (var ot = ue - 1, St = G.length; ++ot < St; )
          if (Ve(G[ot], ge))
            return ot;
        return -1;
      }
      function lu(G) {
        return G !== G;
      }
      function Vs(G, ge) {
        var ue = G == null ? 0 : G.length;
        return ue ? Ks(G, ge) / ue : J;
      }
      function ei(G) {
        return function(ge) {
          return ge == null ? r : ge[G];
        };
      }
      function Ys(G) {
        return function(ge) {
          return G == null ? r : G[ge];
        };
      }
      function ds(G, ge, ue, Ve, ot) {
        return ot(G, function(St, gr, Zt) {
          ue = Ve ? (Ve = !1, St) : ge(ue, St, gr, Zt);
        }), ue;
      }
      function od(G, ge) {
        var ue = G.length;
        for (G.sort(ge); ue--; )
          G[ue] = G[ue].value;
        return G;
      }
      function Ks(G, ge) {
        for (var ue, Ve = -1, ot = G.length; ++Ve < ot; ) {
          var St = ge(G[Ve]);
          St !== r && (ue = ue === r ? St : ue + St);
        }
        return ue;
      }
      function fs(G, ge) {
        for (var ue = -1, Ve = Array(G); ++ue < G; )
          Ve[ue] = ge(ue);
        return Ve;
      }
      function Yr(G, ge) {
        return Jt(ge, function(ue) {
          return [ue, G[ue]];
        });
      }
      function uu(G) {
        return G && G.slice(0, A(G) + 1).replace(_t, "");
      }
      function Ln(G) {
        return function(ge) {
          return G(ge);
        };
      }
      function xo(G, ge) {
        return Jt(ge, function(ue) {
          return G[ue];
        });
      }
      function no(G, ge) {
        return G.has(ge);
      }
      function cu(G, ge) {
        for (var ue = -1, Ve = G.length; ++ue < Ve && wo(ge, G[ue], 0) > -1; )
          ;
        return ue;
      }
      function Xs(G, ge) {
        for (var ue = G.length; ue-- && wo(ge, G[ue], 0) > -1; )
          ;
        return ue;
      }
      function Pi(G, ge) {
        for (var ue = G.length, Ve = 0; ue--; )
          G[ue] === ge && ++Ve;
        return Ve;
      }
      var wn = Ys(vr), Js = Ys(ur);
      function Op(G) {
        return "\\" + yn[G];
      }
      function Rp(G, ge) {
        return G == null ? r : G[ge];
      }
      function io(G) {
        return ke.test(G);
      }
      function ad(G) {
        return ut.test(G);
      }
      function sd(G) {
        for (var ge, ue = []; !(ge = G.next()).done; )
          ue.push(ge.value);
        return ue;
      }
      function du(G) {
        var ge = -1, ue = Array(G.size);
        return G.forEach(function(Ve, ot) {
          ue[++ge] = [ot, Ve];
        }), ue;
      }
      function fu(G, ge) {
        return function(ue) {
          return G(ge(ue));
        };
      }
      function _o(G, ge) {
        for (var ue = -1, Ve = G.length, ot = 0, St = []; ++ue < Ve; ) {
          var gr = G[ue];
          (gr === ge || gr === h) && (G[ue] = h, St[ot++] = ue);
        }
        return St;
      }
      function Zs(G) {
        var ge = -1, ue = Array(G.size);
        return G.forEach(function(Ve) {
          ue[++ge] = Ve;
        }), ue;
      }
      function ld(G) {
        var ge = -1, ue = Array(G.size);
        return G.forEach(function(Ve) {
          ue[++ge] = [Ve, Ve];
        }), ue;
      }
      function Ip(G, ge, ue) {
        for (var Ve = ue - 1, ot = G.length; ++Ve < ot; )
          if (G[Ve] === ge)
            return Ve;
        return -1;
      }
      function d(G, ge, ue) {
        for (var Ve = ue + 1; Ve--; )
          if (G[Ve] === ge)
            return Ve;
        return Ve;
      }
      function E(G) {
        return io(G) ? V(G) : Tp(G);
      }
      function R(G) {
        return io(G) ? ne(G) : Dr(G);
      }
      function A(G) {
        for (var ge = G.length; ge-- && lr.test(G.charAt(ge)); )
          ;
        return ge;
      }
      var k = Ys(kr);
      function V(G) {
        for (var ge = je.lastIndex = 0; je.test(G); )
          ++ge;
        return ge;
      }
      function ne(G) {
        return G.match(je) || [];
      }
      function me(G) {
        return G.match(He) || [];
      }
      var Le = function G(ge) {
        ge = ge == null ? Vr : ze.defaults(Vr.Object(), ge, ze.pick(Vr, Ct));
        var ue = ge.Array, Ve = ge.Date, ot = ge.Error, St = ge.Function, gr = ge.Math, Zt = ge.Object, _a = ge.RegExp, _O = ge.String, Mi = ge.TypeError, ud = ue.prototype, SO = St.prototype, Qs = Zt.prototype, cd = ge["__core-js_shared__"], dd = SO.toString, _r = Qs.hasOwnProperty, EO = 0, Xy = function() {
          var a = /[^.]+$/.exec(cd && cd.keys && cd.keys.IE_PROTO || "");
          return a ? "Symbol(src)_1." + a : "";
        }(), fd = Qs.toString, CO = dd.call(Zt), TO = Vr._, OO = _a(
          "^" + dd.call(_r).replace(Qe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), pd = Qn ? ge.Buffer : r, Sa = ge.Symbol, hd = ge.Uint8Array, Jy = pd ? pd.allocUnsafe : r, gd = fu(Zt.getPrototypeOf, Zt), Zy = Zt.create, Qy = Qs.propertyIsEnumerable, vd = ud.splice, eb = Sa ? Sa.isConcatSpreadable : r, pu = Sa ? Sa.iterator : r, ps = Sa ? Sa.toStringTag : r, md = function() {
          try {
            var a = ys(Zt, "defineProperty");
            return a({}, "", {}), a;
          } catch {
          }
        }(), RO = ge.clearTimeout !== Vr.clearTimeout && ge.clearTimeout, IO = Ve && Ve.now !== Vr.Date.now && Ve.now, DO = ge.setTimeout !== Vr.setTimeout && ge.setTimeout, yd = gr.ceil, bd = gr.floor, Dp = Zt.getOwnPropertySymbols, PO = pd ? pd.isBuffer : r, tb = ge.isFinite, MO = ud.join, AO = fu(Zt.keys, Zt), pn = gr.max, zn = gr.min, NO = Ve.now, jO = ge.parseInt, rb = gr.random, kO = ud.reverse, Pp = ys(ge, "DataView"), hu = ys(ge, "Map"), Mp = ys(ge, "Promise"), el = ys(ge, "Set"), gu = ys(ge, "WeakMap"), vu = ys(Zt, "create"), wd = gu && new gu(), tl = {}, LO = bs(Pp), zO = bs(hu), BO = bs(Mp), FO = bs(el), WO = bs(gu), xd = Sa ? Sa.prototype : r, mu = xd ? xd.valueOf : r, nb = xd ? xd.toString : r;
        function $(a) {
          if (Kr(a) && !Wt(a) && !(a instanceof ir)) {
            if (a instanceof Ai)
              return a;
            if (_r.call(a, "__wrapped__"))
              return i0(a);
          }
          return new Ai(a);
        }
        var rl = /* @__PURE__ */ function() {
          function a() {
          }
          return function(u) {
            if (!$r(u))
              return {};
            if (Zy)
              return Zy(u);
            a.prototype = u;
            var _ = new a();
            return a.prototype = r, _;
          };
        }();
        function _d() {
        }
        function Ai(a, u) {
          this.__wrapped__ = a, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = r;
        }
        $.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: dn,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: fi,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Oi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: $
          }
        }, $.prototype = _d.prototype, $.prototype.constructor = $, Ai.prototype = rl(_d.prototype), Ai.prototype.constructor = Ai;
        function ir(a) {
          this.__wrapped__ = a, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = re, this.__views__ = [];
        }
        function HO() {
          var a = new ir(this.__wrapped__);
          return a.__actions__ = ti(this.__actions__), a.__dir__ = this.__dir__, a.__filtered__ = this.__filtered__, a.__iteratees__ = ti(this.__iteratees__), a.__takeCount__ = this.__takeCount__, a.__views__ = ti(this.__views__), a;
        }
        function $O() {
          if (this.__filtered__) {
            var a = new ir(this);
            a.__dir__ = -1, a.__filtered__ = !0;
          } else
            a = this.clone(), a.__dir__ *= -1;
          return a;
        }
        function UO() {
          var a = this.__wrapped__.value(), u = this.__dir__, _ = Wt(a), O = u < 0, j = _ ? a.length : 0, U = rI(0, j, this.__views__), te = U.start, se = U.end, we = se - te, Ge = O ? se : te - 1, qe = this.__iteratees__, Je = qe.length, st = 0, wt = zn(we, this.__takeCount__);
          if (!_ || !O && j == we && wt == we)
            return Ob(a, this.__actions__);
          var Dt = [];
          e:
            for (; we-- && st < wt; ) {
              Ge += u;
              for (var Yt = -1, Pt = a[Ge]; ++Yt < Je; ) {
                var tr = qe[Yt], ar = tr.iteratee, mi = tr.type, qn = ar(Pt);
                if (mi == ye)
                  Pt = qn;
                else if (!qn) {
                  if (mi == Oe)
                    continue e;
                  break e;
                }
              }
              Dt[st++] = Pt;
            }
          return Dt;
        }
        ir.prototype = rl(_d.prototype), ir.prototype.constructor = ir;
        function hs(a) {
          var u = -1, _ = a == null ? 0 : a.length;
          for (this.clear(); ++u < _; ) {
            var O = a[u];
            this.set(O[0], O[1]);
          }
        }
        function GO() {
          this.__data__ = vu ? vu(null) : {}, this.size = 0;
        }
        function qO(a) {
          var u = this.has(a) && delete this.__data__[a];
          return this.size -= u ? 1 : 0, u;
        }
        function VO(a) {
          var u = this.__data__;
          if (vu) {
            var _ = u[a];
            return _ === c ? r : _;
          }
          return _r.call(u, a) ? u[a] : r;
        }
        function YO(a) {
          var u = this.__data__;
          return vu ? u[a] !== r : _r.call(u, a);
        }
        function KO(a, u) {
          var _ = this.__data__;
          return this.size += this.has(a) ? 0 : 1, _[a] = vu && u === r ? c : u, this;
        }
        hs.prototype.clear = GO, hs.prototype.delete = qO, hs.prototype.get = VO, hs.prototype.has = YO, hs.prototype.set = KO;
        function qo(a) {
          var u = -1, _ = a == null ? 0 : a.length;
          for (this.clear(); ++u < _; ) {
            var O = a[u];
            this.set(O[0], O[1]);
          }
        }
        function XO() {
          this.__data__ = [], this.size = 0;
        }
        function JO(a) {
          var u = this.__data__, _ = Sd(u, a);
          if (_ < 0)
            return !1;
          var O = u.length - 1;
          return _ == O ? u.pop() : vd.call(u, _, 1), --this.size, !0;
        }
        function ZO(a) {
          var u = this.__data__, _ = Sd(u, a);
          return _ < 0 ? r : u[_][1];
        }
        function QO(a) {
          return Sd(this.__data__, a) > -1;
        }
        function eR(a, u) {
          var _ = this.__data__, O = Sd(_, a);
          return O < 0 ? (++this.size, _.push([a, u])) : _[O][1] = u, this;
        }
        qo.prototype.clear = XO, qo.prototype.delete = JO, qo.prototype.get = ZO, qo.prototype.has = QO, qo.prototype.set = eR;
        function Vo(a) {
          var u = -1, _ = a == null ? 0 : a.length;
          for (this.clear(); ++u < _; ) {
            var O = a[u];
            this.set(O[0], O[1]);
          }
        }
        function tR() {
          this.size = 0, this.__data__ = {
            hash: new hs(),
            map: new (hu || qo)(),
            string: new hs()
          };
        }
        function rR(a) {
          var u = jd(this, a).delete(a);
          return this.size -= u ? 1 : 0, u;
        }
        function nR(a) {
          return jd(this, a).get(a);
        }
        function iR(a) {
          return jd(this, a).has(a);
        }
        function oR(a, u) {
          var _ = jd(this, a), O = _.size;
          return _.set(a, u), this.size += _.size == O ? 0 : 1, this;
        }
        Vo.prototype.clear = tR, Vo.prototype.delete = rR, Vo.prototype.get = nR, Vo.prototype.has = iR, Vo.prototype.set = oR;
        function gs(a) {
          var u = -1, _ = a == null ? 0 : a.length;
          for (this.__data__ = new Vo(); ++u < _; )
            this.add(a[u]);
        }
        function aR(a) {
          return this.__data__.set(a, c), this;
        }
        function sR(a) {
          return this.__data__.has(a);
        }
        gs.prototype.add = gs.prototype.push = aR, gs.prototype.has = sR;
        function oo(a) {
          var u = this.__data__ = new qo(a);
          this.size = u.size;
        }
        function lR() {
          this.__data__ = new qo(), this.size = 0;
        }
        function uR(a) {
          var u = this.__data__, _ = u.delete(a);
          return this.size = u.size, _;
        }
        function cR(a) {
          return this.__data__.get(a);
        }
        function dR(a) {
          return this.__data__.has(a);
        }
        function fR(a, u) {
          var _ = this.__data__;
          if (_ instanceof qo) {
            var O = _.__data__;
            if (!hu || O.length < i - 1)
              return O.push([a, u]), this.size = ++_.size, this;
            _ = this.__data__ = new Vo(O);
          }
          return _.set(a, u), this.size = _.size, this;
        }
        oo.prototype.clear = lR, oo.prototype.delete = uR, oo.prototype.get = cR, oo.prototype.has = dR, oo.prototype.set = fR;
        function ib(a, u) {
          var _ = Wt(a), O = !_ && ws(a), j = !_ && !O && Ra(a), U = !_ && !O && !j && al(a), te = _ || O || j || U, se = te ? fs(a.length, _O) : [], we = se.length;
          for (var Ge in a)
            (u || _r.call(a, Ge)) && !(te && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Ge == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            j && (Ge == "offset" || Ge == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            U && (Ge == "buffer" || Ge == "byteLength" || Ge == "byteOffset") || // Skip index properties.
            Jo(Ge, we))) && se.push(Ge);
          return se;
        }
        function ob(a) {
          var u = a.length;
          return u ? a[$p(0, u - 1)] : r;
        }
        function pR(a, u) {
          return kd(ti(a), vs(u, 0, a.length));
        }
        function hR(a) {
          return kd(ti(a));
        }
        function Ap(a, u, _) {
          (_ !== r && !ao(a[u], _) || _ === r && !(u in a)) && Yo(a, u, _);
        }
        function yu(a, u, _) {
          var O = a[u];
          (!(_r.call(a, u) && ao(O, _)) || _ === r && !(u in a)) && Yo(a, u, _);
        }
        function Sd(a, u) {
          for (var _ = a.length; _--; )
            if (ao(a[_][0], u))
              return _;
          return -1;
        }
        function gR(a, u, _, O) {
          return Ea(a, function(j, U, te) {
            u(O, j, _(j), te);
          }), O;
        }
        function ab(a, u) {
          return a && Eo(u, xn(u), a);
        }
        function vR(a, u) {
          return a && Eo(u, ni(u), a);
        }
        function Yo(a, u, _) {
          u == "__proto__" && md ? md(a, u, {
            configurable: !0,
            enumerable: !0,
            value: _,
            writable: !0
          }) : a[u] = _;
        }
        function Np(a, u) {
          for (var _ = -1, O = u.length, j = ue(O), U = a == null; ++_ < O; )
            j[_] = U ? r : hh(a, u[_]);
          return j;
        }
        function vs(a, u, _) {
          return a === a && (_ !== r && (a = a <= _ ? a : _), u !== r && (a = a >= u ? a : u)), a;
        }
        function Ni(a, u, _, O, j, U) {
          var te, se = u & g, we = u & S, Ge = u & b;
          if (_ && (te = j ? _(a, O, j, U) : _(a)), te !== r)
            return te;
          if (!$r(a))
            return a;
          var qe = Wt(a);
          if (qe) {
            if (te = iI(a), !se)
              return ti(a, te);
          } else {
            var Je = Bn(a), st = Je == Pe || Je == ae;
            if (Ra(a))
              return Db(a, se);
            if (Je == mt || Je == Re || st && !j) {
              if (te = we || st ? {} : Kb(a), !se)
                return we ? VR(a, vR(te, a)) : qR(a, ab(te, a));
            } else {
              if (!ft[Je])
                return j ? a : {};
              te = oI(a, Je, se);
            }
          }
          U || (U = new oo());
          var wt = U.get(a);
          if (wt)
            return wt;
          U.set(a, te), E0(a) ? a.forEach(function(Pt) {
            te.add(Ni(Pt, u, _, Pt, a, U));
          }) : _0(a) && a.forEach(function(Pt, tr) {
            te.set(tr, Ni(Pt, u, _, tr, a, U));
          });
          var Dt = Ge ? we ? eh : Qp : we ? ni : xn, Yt = qe ? r : Dt(a);
          return $n(Yt || a, function(Pt, tr) {
            Yt && (tr = Pt, Pt = a[tr]), yu(te, tr, Ni(Pt, u, _, tr, a, U));
          }), te;
        }
        function mR(a) {
          var u = xn(a);
          return function(_) {
            return sb(_, a, u);
          };
        }
        function sb(a, u, _) {
          var O = _.length;
          if (a == null)
            return !O;
          for (a = Zt(a); O--; ) {
            var j = _[O], U = u[j], te = a[j];
            if (te === r && !(j in a) || !U(te))
              return !1;
          }
          return !0;
        }
        function lb(a, u, _) {
          if (typeof a != "function")
            throw new Mi(s);
          return Cu(function() {
            a.apply(r, _);
          }, u);
        }
        function bu(a, u, _, O) {
          var j = -1, U = cs, te = !0, se = a.length, we = [], Ge = u.length;
          if (!se)
            return we;
          _ && (u = Jt(u, Ln(_))), O ? (U = qs, te = !1) : u.length >= i && (U = no, te = !1, u = new gs(u));
          e:
            for (; ++j < se; ) {
              var qe = a[j], Je = _ == null ? qe : _(qe);
              if (qe = O || qe !== 0 ? qe : 0, te && Je === Je) {
                for (var st = Ge; st--; )
                  if (u[st] === Je)
                    continue e;
                we.push(qe);
              } else U(u, Je, O) || we.push(qe);
            }
          return we;
        }
        var Ea = jb(So), ub = jb(kp, !0);
        function yR(a, u) {
          var _ = !0;
          return Ea(a, function(O, j, U) {
            return _ = !!u(O, j, U), _;
          }), _;
        }
        function Ed(a, u, _) {
          for (var O = -1, j = a.length; ++O < j; ) {
            var U = a[O], te = u(U);
            if (te != null && (se === r ? te === te && !vi(te) : _(te, se)))
              var se = te, we = U;
          }
          return we;
        }
        function bR(a, u, _, O) {
          var j = a.length;
          for (_ = Vt(_), _ < 0 && (_ = -_ > j ? 0 : j + _), O = O === r || O > j ? j : Vt(O), O < 0 && (O += j), O = _ > O ? 0 : T0(O); _ < O; )
            a[_++] = u;
          return a;
        }
        function cb(a, u) {
          var _ = [];
          return Ea(a, function(O, j, U) {
            u(O, j, U) && _.push(O);
          }), _;
        }
        function On(a, u, _, O, j) {
          var U = -1, te = a.length;
          for (_ || (_ = sI), j || (j = []); ++U < te; ) {
            var se = a[U];
            u > 0 && _(se) ? u > 1 ? On(se, u - 1, _, O, j) : Ir(j, se) : O || (j[j.length] = se);
          }
          return j;
        }
        var jp = kb(), db = kb(!0);
        function So(a, u) {
          return a && jp(a, u, xn);
        }
        function kp(a, u) {
          return a && db(a, u, xn);
        }
        function Cd(a, u) {
          return Di(u, function(_) {
            return Zo(a[_]);
          });
        }
        function ms(a, u) {
          u = Ta(u, a);
          for (var _ = 0, O = u.length; a != null && _ < O; )
            a = a[Co(u[_++])];
          return _ && _ == O ? a : r;
        }
        function fb(a, u, _) {
          var O = u(a);
          return Wt(a) ? O : Ir(O, _(a));
        }
        function Un(a) {
          return a == null ? a === r ? at : ht : ps && ps in Zt(a) ? tI(a) : hI(a);
        }
        function Lp(a, u) {
          return a > u;
        }
        function wR(a, u) {
          return a != null && _r.call(a, u);
        }
        function xR(a, u) {
          return a != null && u in Zt(a);
        }
        function _R(a, u, _) {
          return a >= zn(u, _) && a < pn(u, _);
        }
        function zp(a, u, _) {
          for (var O = _ ? qs : cs, j = a[0].length, U = a.length, te = U, se = ue(U), we = 1 / 0, Ge = []; te--; ) {
            var qe = a[te];
            te && u && (qe = Jt(qe, Ln(u))), we = zn(qe.length, we), se[te] = !_ && (u || j >= 120 && qe.length >= 120) ? new gs(te && qe) : r;
          }
          qe = a[0];
          var Je = -1, st = se[0];
          e:
            for (; ++Je < j && Ge.length < we; ) {
              var wt = qe[Je], Dt = u ? u(wt) : wt;
              if (wt = _ || wt !== 0 ? wt : 0, !(st ? no(st, Dt) : O(Ge, Dt, _))) {
                for (te = U; --te; ) {
                  var Yt = se[te];
                  if (!(Yt ? no(Yt, Dt) : O(a[te], Dt, _)))
                    continue e;
                }
                st && st.push(Dt), Ge.push(wt);
              }
            }
          return Ge;
        }
        function SR(a, u, _, O) {
          return So(a, function(j, U, te) {
            u(O, _(j), U, te);
          }), O;
        }
        function wu(a, u, _) {
          u = Ta(u, a), a = Qb(a, u);
          var O = a == null ? a : a[Co(ki(u))];
          return O == null ? r : $t(O, a, _);
        }
        function pb(a) {
          return Kr(a) && Un(a) == Re;
        }
        function ER(a) {
          return Kr(a) && Un(a) == wr;
        }
        function CR(a) {
          return Kr(a) && Un(a) == ie;
        }
        function xu(a, u, _, O, j) {
          return a === u ? !0 : a == null || u == null || !Kr(a) && !Kr(u) ? a !== a && u !== u : TR(a, u, _, O, xu, j);
        }
        function TR(a, u, _, O, j, U) {
          var te = Wt(a), se = Wt(u), we = te ? Ee : Bn(a), Ge = se ? Ee : Bn(u);
          we = we == Re ? mt : we, Ge = Ge == Re ? mt : Ge;
          var qe = we == mt, Je = Ge == mt, st = we == Ge;
          if (st && Ra(a)) {
            if (!Ra(u))
              return !1;
            te = !0, qe = !1;
          }
          if (st && !qe)
            return U || (U = new oo()), te || al(a) ? qb(a, u, _, O, j, U) : QR(a, u, we, _, O, j, U);
          if (!(_ & p)) {
            var wt = qe && _r.call(a, "__wrapped__"), Dt = Je && _r.call(u, "__wrapped__");
            if (wt || Dt) {
              var Yt = wt ? a.value() : a, Pt = Dt ? u.value() : u;
              return U || (U = new oo()), j(Yt, Pt, _, O, U);
            }
          }
          return st ? (U || (U = new oo()), eI(a, u, _, O, j, U)) : !1;
        }
        function OR(a) {
          return Kr(a) && Bn(a) == rt;
        }
        function Bp(a, u, _, O) {
          var j = _.length, U = j, te = !O;
          if (a == null)
            return !U;
          for (a = Zt(a); j--; ) {
            var se = _[j];
            if (te && se[2] ? se[1] !== a[se[0]] : !(se[0] in a))
              return !1;
          }
          for (; ++j < U; ) {
            se = _[j];
            var we = se[0], Ge = a[we], qe = se[1];
            if (te && se[2]) {
              if (Ge === r && !(we in a))
                return !1;
            } else {
              var Je = new oo();
              if (O)
                var st = O(Ge, qe, we, a, u, Je);
              if (!(st === r ? xu(qe, Ge, p | v, O, Je) : st))
                return !1;
            }
          }
          return !0;
        }
        function hb(a) {
          if (!$r(a) || uI(a))
            return !1;
          var u = Zo(a) ? OO : Wo;
          return u.test(bs(a));
        }
        function RR(a) {
          return Kr(a) && Un(a) == Gt;
        }
        function IR(a) {
          return Kr(a) && Bn(a) == It;
        }
        function DR(a) {
          return Kr(a) && Hd(a.length) && !!xt[Un(a)];
        }
        function gb(a) {
          return typeof a == "function" ? a : a == null ? ii : typeof a == "object" ? Wt(a) ? yb(a[0], a[1]) : mb(a) : L0(a);
        }
        function Fp(a) {
          if (!Eu(a))
            return AO(a);
          var u = [];
          for (var _ in Zt(a))
            _r.call(a, _) && _ != "constructor" && u.push(_);
          return u;
        }
        function PR(a) {
          if (!$r(a))
            return pI(a);
          var u = Eu(a), _ = [];
          for (var O in a)
            O == "constructor" && (u || !_r.call(a, O)) || _.push(O);
          return _;
        }
        function Wp(a, u) {
          return a < u;
        }
        function vb(a, u) {
          var _ = -1, O = ri(a) ? ue(a.length) : [];
          return Ea(a, function(j, U, te) {
            O[++_] = u(j, U, te);
          }), O;
        }
        function mb(a) {
          var u = rh(a);
          return u.length == 1 && u[0][2] ? Jb(u[0][0], u[0][1]) : function(_) {
            return _ === a || Bp(_, a, u);
          };
        }
        function yb(a, u) {
          return ih(a) && Xb(u) ? Jb(Co(a), u) : function(_) {
            var O = hh(_, a);
            return O === r && O === u ? gh(_, a) : xu(u, O, p | v);
          };
        }
        function Td(a, u, _, O, j) {
          a !== u && jp(u, function(U, te) {
            if (j || (j = new oo()), $r(U))
              MR(a, u, te, _, Td, O, j);
            else {
              var se = O ? O(ah(a, te), U, te + "", a, u, j) : r;
              se === r && (se = U), Ap(a, te, se);
            }
          }, ni);
        }
        function MR(a, u, _, O, j, U, te) {
          var se = ah(a, _), we = ah(u, _), Ge = te.get(we);
          if (Ge) {
            Ap(a, _, Ge);
            return;
          }
          var qe = U ? U(se, we, _ + "", a, u, te) : r, Je = qe === r;
          if (Je) {
            var st = Wt(we), wt = !st && Ra(we), Dt = !st && !wt && al(we);
            qe = we, st || wt || Dt ? Wt(se) ? qe = se : Zr(se) ? qe = ti(se) : wt ? (Je = !1, qe = Db(we, !0)) : Dt ? (Je = !1, qe = Pb(we, !0)) : qe = [] : Tu(we) || ws(we) ? (qe = se, ws(se) ? qe = O0(se) : (!$r(se) || Zo(se)) && (qe = Kb(we))) : Je = !1;
          }
          Je && (te.set(we, qe), j(qe, we, O, U, te), te.delete(we)), Ap(a, _, qe);
        }
        function bb(a, u) {
          var _ = a.length;
          if (_)
            return u += u < 0 ? _ : 0, Jo(u, _) ? a[u] : r;
        }
        function wb(a, u, _) {
          u.length ? u = Jt(u, function(U) {
            return Wt(U) ? function(te) {
              return ms(te, U.length === 1 ? U[0] : U);
            } : U;
          }) : u = [ii];
          var O = -1;
          u = Jt(u, Ln(Ot()));
          var j = vb(a, function(U, te, se) {
            var we = Jt(u, function(Ge) {
              return Ge(U);
            });
            return { criteria: we, index: ++O, value: U };
          });
          return od(j, function(U, te) {
            return GR(U, te, _);
          });
        }
        function AR(a, u) {
          return xb(a, u, function(_, O) {
            return gh(a, O);
          });
        }
        function xb(a, u, _) {
          for (var O = -1, j = u.length, U = {}; ++O < j; ) {
            var te = u[O], se = ms(a, te);
            _(se, te) && _u(U, Ta(te, a), se);
          }
          return U;
        }
        function NR(a) {
          return function(u) {
            return ms(u, a);
          };
        }
        function Hp(a, u, _, O) {
          var j = O ? id : wo, U = -1, te = u.length, se = a;
          for (a === u && (u = ti(u)), _ && (se = Jt(a, Ln(_))); ++U < te; )
            for (var we = 0, Ge = u[U], qe = _ ? _(Ge) : Ge; (we = j(se, qe, we, O)) > -1; )
              se !== a && vd.call(se, we, 1), vd.call(a, we, 1);
          return a;
        }
        function _b(a, u) {
          for (var _ = a ? u.length : 0, O = _ - 1; _--; ) {
            var j = u[_];
            if (_ == O || j !== U) {
              var U = j;
              Jo(j) ? vd.call(a, j, 1) : qp(a, j);
            }
          }
          return a;
        }
        function $p(a, u) {
          return a + bd(rb() * (u - a + 1));
        }
        function jR(a, u, _, O) {
          for (var j = -1, U = pn(yd((u - a) / (_ || 1)), 0), te = ue(U); U--; )
            te[O ? U : ++j] = a, a += _;
          return te;
        }
        function Up(a, u) {
          var _ = "";
          if (!a || u < 1 || u > Fe)
            return _;
          do
            u % 2 && (_ += a), u = bd(u / 2), u && (a += a);
          while (u);
          return _;
        }
        function Xt(a, u) {
          return sh(Zb(a, u, ii), a + "");
        }
        function kR(a) {
          return ob(sl(a));
        }
        function LR(a, u) {
          var _ = sl(a);
          return kd(_, vs(u, 0, _.length));
        }
        function _u(a, u, _, O) {
          if (!$r(a))
            return a;
          u = Ta(u, a);
          for (var j = -1, U = u.length, te = U - 1, se = a; se != null && ++j < U; ) {
            var we = Co(u[j]), Ge = _;
            if (we === "__proto__" || we === "constructor" || we === "prototype")
              return a;
            if (j != te) {
              var qe = se[we];
              Ge = O ? O(qe, we, se) : r, Ge === r && (Ge = $r(qe) ? qe : Jo(u[j + 1]) ? [] : {});
            }
            yu(se, we, Ge), se = se[we];
          }
          return a;
        }
        var Sb = wd ? function(a, u) {
          return wd.set(a, u), a;
        } : ii, zR = md ? function(a, u) {
          return md(a, "toString", {
            configurable: !0,
            enumerable: !1,
            value: mh(u),
            writable: !0
          });
        } : ii;
        function BR(a) {
          return kd(sl(a));
        }
        function ji(a, u, _) {
          var O = -1, j = a.length;
          u < 0 && (u = -u > j ? 0 : j + u), _ = _ > j ? j : _, _ < 0 && (_ += j), j = u > _ ? 0 : _ - u >>> 0, u >>>= 0;
          for (var U = ue(j); ++O < j; )
            U[O] = a[O + u];
          return U;
        }
        function FR(a, u) {
          var _;
          return Ea(a, function(O, j, U) {
            return _ = u(O, j, U), !_;
          }), !!_;
        }
        function Od(a, u, _) {
          var O = 0, j = a == null ? O : a.length;
          if (typeof u == "number" && u === u && j <= Me) {
            for (; O < j; ) {
              var U = O + j >>> 1, te = a[U];
              te !== null && !vi(te) && (_ ? te <= u : te < u) ? O = U + 1 : j = U;
            }
            return j;
          }
          return Gp(a, u, ii, _);
        }
        function Gp(a, u, _, O) {
          var j = 0, U = a == null ? 0 : a.length;
          if (U === 0)
            return 0;
          u = _(u);
          for (var te = u !== u, se = u === null, we = vi(u), Ge = u === r; j < U; ) {
            var qe = bd((j + U) / 2), Je = _(a[qe]), st = Je !== r, wt = Je === null, Dt = Je === Je, Yt = vi(Je);
            if (te)
              var Pt = O || Dt;
            else Ge ? Pt = Dt && (O || st) : se ? Pt = Dt && st && (O || !wt) : we ? Pt = Dt && st && !wt && (O || !Yt) : wt || Yt ? Pt = !1 : Pt = O ? Je <= u : Je < u;
            Pt ? j = qe + 1 : U = qe;
          }
          return zn(U, be);
        }
        function Eb(a, u) {
          for (var _ = -1, O = a.length, j = 0, U = []; ++_ < O; ) {
            var te = a[_], se = u ? u(te) : te;
            if (!_ || !ao(se, we)) {
              var we = se;
              U[j++] = te === 0 ? 0 : te;
            }
          }
          return U;
        }
        function Cb(a) {
          return typeof a == "number" ? a : vi(a) ? J : +a;
        }
        function gi(a) {
          if (typeof a == "string")
            return a;
          if (Wt(a))
            return Jt(a, gi) + "";
          if (vi(a))
            return nb ? nb.call(a) : "";
          var u = a + "";
          return u == "0" && 1 / a == -ce ? "-0" : u;
        }
        function Ca(a, u, _) {
          var O = -1, j = cs, U = a.length, te = !0, se = [], we = se;
          if (_)
            te = !1, j = qs;
          else if (U >= i) {
            var Ge = u ? null : JR(a);
            if (Ge)
              return Zs(Ge);
            te = !1, j = no, we = new gs();
          } else
            we = u ? [] : se;
          e:
            for (; ++O < U; ) {
              var qe = a[O], Je = u ? u(qe) : qe;
              if (qe = _ || qe !== 0 ? qe : 0, te && Je === Je) {
                for (var st = we.length; st--; )
                  if (we[st] === Je)
                    continue e;
                u && we.push(Je), se.push(qe);
              } else j(we, Je, _) || (we !== se && we.push(Je), se.push(qe));
            }
          return se;
        }
        function qp(a, u) {
          return u = Ta(u, a), a = Qb(a, u), a == null || delete a[Co(ki(u))];
        }
        function Tb(a, u, _, O) {
          return _u(a, u, _(ms(a, u)), O);
        }
        function Rd(a, u, _, O) {
          for (var j = a.length, U = O ? j : -1; (O ? U-- : ++U < j) && u(a[U], U, a); )
            ;
          return _ ? ji(a, O ? 0 : U, O ? U + 1 : j) : ji(a, O ? U + 1 : 0, O ? j : U);
        }
        function Ob(a, u) {
          var _ = a;
          return _ instanceof ir && (_ = _.value()), xa(u, function(O, j) {
            return j.func.apply(j.thisArg, Ir([O], j.args));
          }, _);
        }
        function Vp(a, u, _) {
          var O = a.length;
          if (O < 2)
            return O ? Ca(a[0]) : [];
          for (var j = -1, U = ue(O); ++j < O; )
            for (var te = a[j], se = -1; ++se < O; )
              se != j && (U[j] = bu(U[j] || te, a[se], u, _));
          return Ca(On(U, 1), u, _);
        }
        function Rb(a, u, _) {
          for (var O = -1, j = a.length, U = u.length, te = {}; ++O < j; ) {
            var se = O < U ? u[O] : r;
            _(te, a[O], se);
          }
          return te;
        }
        function Yp(a) {
          return Zr(a) ? a : [];
        }
        function Kp(a) {
          return typeof a == "function" ? a : ii;
        }
        function Ta(a, u) {
          return Wt(a) ? a : ih(a, u) ? [a] : n0(mr(a));
        }
        var WR = Xt;
        function Oa(a, u, _) {
          var O = a.length;
          return _ = _ === r ? O : _, !u && _ >= O ? a : ji(a, u, _);
        }
        var Ib = RO || function(a) {
          return Vr.clearTimeout(a);
        };
        function Db(a, u) {
          if (u)
            return a.slice();
          var _ = a.length, O = Jy ? Jy(_) : new a.constructor(_);
          return a.copy(O), O;
        }
        function Xp(a) {
          var u = new a.constructor(a.byteLength);
          return new hd(u).set(new hd(a)), u;
        }
        function HR(a, u) {
          var _ = u ? Xp(a.buffer) : a.buffer;
          return new a.constructor(_, a.byteOffset, a.byteLength);
        }
        function $R(a) {
          var u = new a.constructor(a.source, nn.exec(a));
          return u.lastIndex = a.lastIndex, u;
        }
        function UR(a) {
          return mu ? Zt(mu.call(a)) : {};
        }
        function Pb(a, u) {
          var _ = u ? Xp(a.buffer) : a.buffer;
          return new a.constructor(_, a.byteOffset, a.length);
        }
        function Mb(a, u) {
          if (a !== u) {
            var _ = a !== r, O = a === null, j = a === a, U = vi(a), te = u !== r, se = u === null, we = u === u, Ge = vi(u);
            if (!se && !Ge && !U && a > u || U && te && we && !se && !Ge || O && te && we || !_ && we || !j)
              return 1;
            if (!O && !U && !Ge && a < u || Ge && _ && j && !O && !U || se && _ && j || !te && j || !we)
              return -1;
          }
          return 0;
        }
        function GR(a, u, _) {
          for (var O = -1, j = a.criteria, U = u.criteria, te = j.length, se = _.length; ++O < te; ) {
            var we = Mb(j[O], U[O]);
            if (we) {
              if (O >= se)
                return we;
              var Ge = _[O];
              return we * (Ge == "desc" ? -1 : 1);
            }
          }
          return a.index - u.index;
        }
        function Ab(a, u, _, O) {
          for (var j = -1, U = a.length, te = _.length, se = -1, we = u.length, Ge = pn(U - te, 0), qe = ue(we + Ge), Je = !O; ++se < we; )
            qe[se] = u[se];
          for (; ++j < te; )
            (Je || j < U) && (qe[_[j]] = a[j]);
          for (; Ge--; )
            qe[se++] = a[j++];
          return qe;
        }
        function Nb(a, u, _, O) {
          for (var j = -1, U = a.length, te = -1, se = _.length, we = -1, Ge = u.length, qe = pn(U - se, 0), Je = ue(qe + Ge), st = !O; ++j < qe; )
            Je[j] = a[j];
          for (var wt = j; ++we < Ge; )
            Je[wt + we] = u[we];
          for (; ++te < se; )
            (st || j < U) && (Je[wt + _[te]] = a[j++]);
          return Je;
        }
        function ti(a, u) {
          var _ = -1, O = a.length;
          for (u || (u = ue(O)); ++_ < O; )
            u[_] = a[_];
          return u;
        }
        function Eo(a, u, _, O) {
          var j = !_;
          _ || (_ = {});
          for (var U = -1, te = u.length; ++U < te; ) {
            var se = u[U], we = O ? O(_[se], a[se], se, _, a) : r;
            we === r && (we = a[se]), j ? Yo(_, se, we) : yu(_, se, we);
          }
          return _;
        }
        function qR(a, u) {
          return Eo(a, nh(a), u);
        }
        function VR(a, u) {
          return Eo(a, Vb(a), u);
        }
        function Id(a, u) {
          return function(_, O) {
            var j = Wt(_) ? td : gR, U = u ? u() : {};
            return j(_, a, Ot(O, 2), U);
          };
        }
        function nl(a) {
          return Xt(function(u, _) {
            var O = -1, j = _.length, U = j > 1 ? _[j - 1] : r, te = j > 2 ? _[2] : r;
            for (U = a.length > 3 && typeof U == "function" ? (j--, U) : r, te && Gn(_[0], _[1], te) && (U = j < 3 ? r : U, j = 1), u = Zt(u); ++O < j; ) {
              var se = _[O];
              se && a(u, se, O, U);
            }
            return u;
          });
        }
        function jb(a, u) {
          return function(_, O) {
            if (_ == null)
              return _;
            if (!ri(_))
              return a(_, O);
            for (var j = _.length, U = u ? j : -1, te = Zt(_); (u ? U-- : ++U < j) && O(te[U], U, te) !== !1; )
              ;
            return _;
          };
        }
        function kb(a) {
          return function(u, _, O) {
            for (var j = -1, U = Zt(u), te = O(u), se = te.length; se--; ) {
              var we = te[a ? se : ++j];
              if (_(U[we], we, U) === !1)
                break;
            }
            return u;
          };
        }
        function YR(a, u, _) {
          var O = u & w, j = Su(a);
          function U() {
            var te = this && this !== Vr && this instanceof U ? j : a;
            return te.apply(O ? _ : this, arguments);
          }
          return U;
        }
        function Lb(a) {
          return function(u) {
            u = mr(u);
            var _ = io(u) ? R(u) : r, O = _ ? _[0] : u.charAt(0), j = _ ? Oa(_, 1).join("") : u.slice(1);
            return O[a]() + j;
          };
        }
        function il(a) {
          return function(u) {
            return xa(j0(N0(u).replace(Ke, "")), a, "");
          };
        }
        function Su(a) {
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return new a();
              case 1:
                return new a(u[0]);
              case 2:
                return new a(u[0], u[1]);
              case 3:
                return new a(u[0], u[1], u[2]);
              case 4:
                return new a(u[0], u[1], u[2], u[3]);
              case 5:
                return new a(u[0], u[1], u[2], u[3], u[4]);
              case 6:
                return new a(u[0], u[1], u[2], u[3], u[4], u[5]);
              case 7:
                return new a(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
            }
            var _ = rl(a.prototype), O = a.apply(_, u);
            return $r(O) ? O : _;
          };
        }
        function KR(a, u, _) {
          var O = Su(a);
          function j() {
            for (var U = arguments.length, te = ue(U), se = U, we = ol(j); se--; )
              te[se] = arguments[se];
            var Ge = U < 3 && te[0] !== we && te[U - 1] !== we ? [] : _o(te, we);
            if (U -= Ge.length, U < _)
              return Hb(
                a,
                u,
                Dd,
                j.placeholder,
                r,
                te,
                Ge,
                r,
                r,
                _ - U
              );
            var qe = this && this !== Vr && this instanceof j ? O : a;
            return $t(qe, this, te);
          }
          return j;
        }
        function zb(a) {
          return function(u, _, O) {
            var j = Zt(u);
            if (!ri(u)) {
              var U = Ot(_, 3);
              u = xn(u), _ = function(se) {
                return U(j[se], se, j);
              };
            }
            var te = a(u, _, O);
            return te > -1 ? j[U ? u[te] : te] : r;
          };
        }
        function Bb(a) {
          return Xo(function(u) {
            var _ = u.length, O = _, j = Ai.prototype.thru;
            for (a && u.reverse(); O--; ) {
              var U = u[O];
              if (typeof U != "function")
                throw new Mi(s);
              if (j && !te && Nd(U) == "wrapper")
                var te = new Ai([], !0);
            }
            for (O = te ? O : _; ++O < _; ) {
              U = u[O];
              var se = Nd(U), we = se == "wrapper" ? th(U) : r;
              we && oh(we[0]) && we[1] == (K | L | z | Z) && !we[4].length && we[9] == 1 ? te = te[Nd(we[0])].apply(te, we[3]) : te = U.length == 1 && oh(U) ? te[se]() : te.thru(U);
            }
            return function() {
              var Ge = arguments, qe = Ge[0];
              if (te && Ge.length == 1 && Wt(qe))
                return te.plant(qe).value();
              for (var Je = 0, st = _ ? u[Je].apply(this, Ge) : qe; ++Je < _; )
                st = u[Je].call(this, st);
              return st;
            };
          });
        }
        function Dd(a, u, _, O, j, U, te, se, we, Ge) {
          var qe = u & K, Je = u & w, st = u & C, wt = u & (L | W), Dt = u & ee, Yt = st ? r : Su(a);
          function Pt() {
            for (var tr = arguments.length, ar = ue(tr), mi = tr; mi--; )
              ar[mi] = arguments[mi];
            if (wt)
              var qn = ol(Pt), yi = Pi(ar, qn);
            if (O && (ar = Ab(ar, O, j, wt)), U && (ar = Nb(ar, U, te, wt)), tr -= yi, wt && tr < Ge) {
              var Qr = _o(ar, qn);
              return Hb(
                a,
                u,
                Dd,
                Pt.placeholder,
                _,
                ar,
                Qr,
                se,
                we,
                Ge - tr
              );
            }
            var so = Je ? _ : this, ea = st ? so[a] : a;
            return tr = ar.length, se ? ar = gI(ar, se) : Dt && tr > 1 && ar.reverse(), qe && we < tr && (ar.length = we), this && this !== Vr && this instanceof Pt && (ea = Yt || Su(ea)), ea.apply(so, ar);
          }
          return Pt;
        }
        function Fb(a, u) {
          return function(_, O) {
            return SR(_, a, u(O), {});
          };
        }
        function Pd(a, u) {
          return function(_, O) {
            var j;
            if (_ === r && O === r)
              return u;
            if (_ !== r && (j = _), O !== r) {
              if (j === r)
                return O;
              typeof _ == "string" || typeof O == "string" ? (_ = gi(_), O = gi(O)) : (_ = Cb(_), O = Cb(O)), j = a(_, O);
            }
            return j;
          };
        }
        function Jp(a) {
          return Xo(function(u) {
            return u = Jt(u, Ln(Ot())), Xt(function(_) {
              var O = this;
              return a(u, function(j) {
                return $t(j, O, _);
              });
            });
          });
        }
        function Md(a, u) {
          u = u === r ? " " : gi(u);
          var _ = u.length;
          if (_ < 2)
            return _ ? Up(u, a) : u;
          var O = Up(u, yd(a / E(u)));
          return io(u) ? Oa(R(O), 0, a).join("") : O.slice(0, a);
        }
        function XR(a, u, _, O) {
          var j = u & w, U = Su(a);
          function te() {
            for (var se = -1, we = arguments.length, Ge = -1, qe = O.length, Je = ue(qe + we), st = this && this !== Vr && this instanceof te ? U : a; ++Ge < qe; )
              Je[Ge] = O[Ge];
            for (; we--; )
              Je[Ge++] = arguments[++se];
            return $t(st, j ? _ : this, Je);
          }
          return te;
        }
        function Wb(a) {
          return function(u, _, O) {
            return O && typeof O != "number" && Gn(u, _, O) && (_ = O = r), u = Qo(u), _ === r ? (_ = u, u = 0) : _ = Qo(_), O = O === r ? u < _ ? 1 : -1 : Qo(O), jR(u, _, O, a);
          };
        }
        function Ad(a) {
          return function(u, _) {
            return typeof u == "string" && typeof _ == "string" || (u = Li(u), _ = Li(_)), a(u, _);
          };
        }
        function Hb(a, u, _, O, j, U, te, se, we, Ge) {
          var qe = u & L, Je = qe ? te : r, st = qe ? r : te, wt = qe ? U : r, Dt = qe ? r : U;
          u |= qe ? z : B, u &= ~(qe ? B : z), u & M || (u &= -4);
          var Yt = [
            a,
            u,
            j,
            wt,
            Je,
            Dt,
            st,
            se,
            we,
            Ge
          ], Pt = _.apply(r, Yt);
          return oh(a) && e0(Pt, Yt), Pt.placeholder = O, t0(Pt, a, u);
        }
        function Zp(a) {
          var u = gr[a];
          return function(_, O) {
            if (_ = Li(_), O = O == null ? 0 : zn(Vt(O), 292), O && tb(_)) {
              var j = (mr(_) + "e").split("e"), U = u(j[0] + "e" + (+j[1] + O));
              return j = (mr(U) + "e").split("e"), +(j[0] + "e" + (+j[1] - O));
            }
            return u(_);
          };
        }
        var JR = el && 1 / Zs(new el([, -0]))[1] == ce ? function(a) {
          return new el(a);
        } : wh;
        function $b(a) {
          return function(u) {
            var _ = Bn(u);
            return _ == rt ? du(u) : _ == It ? ld(u) : Yr(u, a(u));
          };
        }
        function Ko(a, u, _, O, j, U, te, se) {
          var we = u & C;
          if (!we && typeof a != "function")
            throw new Mi(s);
          var Ge = O ? O.length : 0;
          if (Ge || (u &= -97, O = j = r), te = te === r ? te : pn(Vt(te), 0), se = se === r ? se : Vt(se), Ge -= j ? j.length : 0, u & B) {
            var qe = O, Je = j;
            O = j = r;
          }
          var st = we ? r : th(a), wt = [
            a,
            u,
            _,
            O,
            j,
            qe,
            Je,
            U,
            te,
            se
          ];
          if (st && fI(wt, st), a = wt[0], u = wt[1], _ = wt[2], O = wt[3], j = wt[4], se = wt[9] = wt[9] === r ? we ? 0 : a.length : pn(wt[9] - Ge, 0), !se && u & (L | W) && (u &= -25), !u || u == w)
            var Dt = YR(a, u, _);
          else u == L || u == W ? Dt = KR(a, u, se) : (u == z || u == (w | z)) && !j.length ? Dt = XR(a, u, _, O) : Dt = Dd.apply(r, wt);
          var Yt = st ? Sb : e0;
          return t0(Yt(Dt, wt), a, u);
        }
        function Ub(a, u, _, O) {
          return a === r || ao(a, Qs[_]) && !_r.call(O, _) ? u : a;
        }
        function Gb(a, u, _, O, j, U) {
          return $r(a) && $r(u) && (U.set(u, a), Td(a, u, r, Gb, U), U.delete(u)), a;
        }
        function ZR(a) {
          return Tu(a) ? r : a;
        }
        function qb(a, u, _, O, j, U) {
          var te = _ & p, se = a.length, we = u.length;
          if (se != we && !(te && we > se))
            return !1;
          var Ge = U.get(a), qe = U.get(u);
          if (Ge && qe)
            return Ge == u && qe == a;
          var Je = -1, st = !0, wt = _ & v ? new gs() : r;
          for (U.set(a, u), U.set(u, a); ++Je < se; ) {
            var Dt = a[Je], Yt = u[Je];
            if (O)
              var Pt = te ? O(Yt, Dt, Je, u, a, U) : O(Dt, Yt, Je, a, u, U);
            if (Pt !== r) {
              if (Pt)
                continue;
              st = !1;
              break;
            }
            if (wt) {
              if (!ou(u, function(tr, ar) {
                if (!no(wt, ar) && (Dt === tr || j(Dt, tr, _, O, U)))
                  return wt.push(ar);
              })) {
                st = !1;
                break;
              }
            } else if (!(Dt === Yt || j(Dt, Yt, _, O, U))) {
              st = !1;
              break;
            }
          }
          return U.delete(a), U.delete(u), st;
        }
        function QR(a, u, _, O, j, U, te) {
          switch (_) {
            case gt:
              if (a.byteLength != u.byteLength || a.byteOffset != u.byteOffset)
                return !1;
              a = a.buffer, u = u.buffer;
            case wr:
              return !(a.byteLength != u.byteLength || !U(new hd(a), new hd(u)));
            case X:
            case ie:
            case Ze:
              return ao(+a, +u);
            case xe:
              return a.name == u.name && a.message == u.message;
            case Gt:
            case sr:
              return a == u + "";
            case rt:
              var se = du;
            case It:
              var we = O & p;
              if (se || (se = Zs), a.size != u.size && !we)
                return !1;
              var Ge = te.get(a);
              if (Ge)
                return Ge == u;
              O |= v, te.set(a, u);
              var qe = qb(se(a), se(u), O, j, U, te);
              return te.delete(a), qe;
            case et:
              if (mu)
                return mu.call(a) == mu.call(u);
          }
          return !1;
        }
        function eI(a, u, _, O, j, U) {
          var te = _ & p, se = Qp(a), we = se.length, Ge = Qp(u), qe = Ge.length;
          if (we != qe && !te)
            return !1;
          for (var Je = we; Je--; ) {
            var st = se[Je];
            if (!(te ? st in u : _r.call(u, st)))
              return !1;
          }
          var wt = U.get(a), Dt = U.get(u);
          if (wt && Dt)
            return wt == u && Dt == a;
          var Yt = !0;
          U.set(a, u), U.set(u, a);
          for (var Pt = te; ++Je < we; ) {
            st = se[Je];
            var tr = a[st], ar = u[st];
            if (O)
              var mi = te ? O(ar, tr, st, u, a, U) : O(tr, ar, st, a, u, U);
            if (!(mi === r ? tr === ar || j(tr, ar, _, O, U) : mi)) {
              Yt = !1;
              break;
            }
            Pt || (Pt = st == "constructor");
          }
          if (Yt && !Pt) {
            var qn = a.constructor, yi = u.constructor;
            qn != yi && "constructor" in a && "constructor" in u && !(typeof qn == "function" && qn instanceof qn && typeof yi == "function" && yi instanceof yi) && (Yt = !1);
          }
          return U.delete(a), U.delete(u), Yt;
        }
        function Xo(a) {
          return sh(Zb(a, r, s0), a + "");
        }
        function Qp(a) {
          return fb(a, xn, nh);
        }
        function eh(a) {
          return fb(a, ni, Vb);
        }
        var th = wd ? function(a) {
          return wd.get(a);
        } : wh;
        function Nd(a) {
          for (var u = a.name + "", _ = tl[u], O = _r.call(tl, u) ? _.length : 0; O--; ) {
            var j = _[O], U = j.func;
            if (U == null || U == a)
              return j.name;
          }
          return u;
        }
        function ol(a) {
          var u = _r.call($, "placeholder") ? $ : a;
          return u.placeholder;
        }
        function Ot() {
          var a = $.iteratee || yh;
          return a = a === yh ? gb : a, arguments.length ? a(arguments[0], arguments[1]) : a;
        }
        function jd(a, u) {
          var _ = a.__data__;
          return lI(u) ? _[typeof u == "string" ? "string" : "hash"] : _.map;
        }
        function rh(a) {
          for (var u = xn(a), _ = u.length; _--; ) {
            var O = u[_], j = a[O];
            u[_] = [O, j, Xb(j)];
          }
          return u;
        }
        function ys(a, u) {
          var _ = Rp(a, u);
          return hb(_) ? _ : r;
        }
        function tI(a) {
          var u = _r.call(a, ps), _ = a[ps];
          try {
            a[ps] = r;
            var O = !0;
          } catch {
          }
          var j = fd.call(a);
          return O && (u ? a[ps] = _ : delete a[ps]), j;
        }
        var nh = Dp ? function(a) {
          return a == null ? [] : (a = Zt(a), Di(Dp(a), function(u) {
            return Qy.call(a, u);
          }));
        } : xh, Vb = Dp ? function(a) {
          for (var u = []; a; )
            Ir(u, nh(a)), a = gd(a);
          return u;
        } : xh, Bn = Un;
        (Pp && Bn(new Pp(new ArrayBuffer(1))) != gt || hu && Bn(new hu()) != rt || Mp && Bn(Mp.resolve()) != At || el && Bn(new el()) != It || gu && Bn(new gu()) != Qt) && (Bn = function(a) {
          var u = Un(a), _ = u == mt ? a.constructor : r, O = _ ? bs(_) : "";
          if (O)
            switch (O) {
              case LO:
                return gt;
              case zO:
                return rt;
              case BO:
                return At;
              case FO:
                return It;
              case WO:
                return Qt;
            }
          return u;
        });
        function rI(a, u, _) {
          for (var O = -1, j = _.length; ++O < j; ) {
            var U = _[O], te = U.size;
            switch (U.type) {
              case "drop":
                a += te;
                break;
              case "dropRight":
                u -= te;
                break;
              case "take":
                u = zn(u, a + te);
                break;
              case "takeRight":
                a = pn(a, u - te);
                break;
            }
          }
          return { start: a, end: u };
        }
        function nI(a) {
          var u = a.match(Ht);
          return u ? u[1].split(Ft) : [];
        }
        function Yb(a, u, _) {
          u = Ta(u, a);
          for (var O = -1, j = u.length, U = !1; ++O < j; ) {
            var te = Co(u[O]);
            if (!(U = a != null && _(a, te)))
              break;
            a = a[te];
          }
          return U || ++O != j ? U : (j = a == null ? 0 : a.length, !!j && Hd(j) && Jo(te, j) && (Wt(a) || ws(a)));
        }
        function iI(a) {
          var u = a.length, _ = new a.constructor(u);
          return u && typeof a[0] == "string" && _r.call(a, "index") && (_.index = a.index, _.input = a.input), _;
        }
        function Kb(a) {
          return typeof a.constructor == "function" && !Eu(a) ? rl(gd(a)) : {};
        }
        function oI(a, u, _) {
          var O = a.constructor;
          switch (u) {
            case wr:
              return Xp(a);
            case X:
            case ie:
              return new O(+a);
            case gt:
              return HR(a, _);
            case hr:
            case Nn:
            case hn:
            case cn:
            case gn:
            case tn:
            case rr:
            case Tn:
            case xr:
              return Pb(a, _);
            case rt:
              return new O();
            case Ze:
            case sr:
              return new O(a);
            case Gt:
              return $R(a);
            case It:
              return new O();
            case et:
              return UR(a);
          }
        }
        function aI(a, u) {
          var _ = u.length;
          if (!_)
            return a;
          var O = _ - 1;
          return u[O] = (_ > 1 ? "& " : "") + u[O], u = u.join(_ > 2 ? ", " : " "), a.replace(nr, `{
/* [wrapped with ` + u + `] */
`);
        }
        function sI(a) {
          return Wt(a) || ws(a) || !!(eb && a && a[eb]);
        }
        function Jo(a, u) {
          var _ = typeof a;
          return u = u ?? Fe, !!u && (_ == "number" || _ != "symbol" && qt.test(a)) && a > -1 && a % 1 == 0 && a < u;
        }
        function Gn(a, u, _) {
          if (!$r(_))
            return !1;
          var O = typeof u;
          return (O == "number" ? ri(_) && Jo(u, _.length) : O == "string" && u in _) ? ao(_[u], a) : !1;
        }
        function ih(a, u) {
          if (Wt(a))
            return !1;
          var _ = typeof a;
          return _ == "number" || _ == "symbol" || _ == "boolean" || a == null || vi(a) ? !0 : vo.test(a) || !rn.test(a) || u != null && a in Zt(u);
        }
        function lI(a) {
          var u = typeof a;
          return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? a !== "__proto__" : a === null;
        }
        function oh(a) {
          var u = Nd(a), _ = $[u];
          if (typeof _ != "function" || !(u in ir.prototype))
            return !1;
          if (a === _)
            return !0;
          var O = th(_);
          return !!O && a === O[0];
        }
        function uI(a) {
          return !!Xy && Xy in a;
        }
        var cI = cd ? Zo : _h;
        function Eu(a) {
          var u = a && a.constructor, _ = typeof u == "function" && u.prototype || Qs;
          return a === _;
        }
        function Xb(a) {
          return a === a && !$r(a);
        }
        function Jb(a, u) {
          return function(_) {
            return _ == null ? !1 : _[a] === u && (u !== r || a in Zt(_));
          };
        }
        function dI(a) {
          var u = Fd(a, function(O) {
            return _.size === f && _.clear(), O;
          }), _ = u.cache;
          return u;
        }
        function fI(a, u) {
          var _ = a[1], O = u[1], j = _ | O, U = j < (w | C | K), te = O == K && _ == L || O == K && _ == Z && a[7].length <= u[8] || O == (K | Z) && u[7].length <= u[8] && _ == L;
          if (!(U || te))
            return a;
          O & w && (a[2] = u[2], j |= _ & w ? 0 : M);
          var se = u[3];
          if (se) {
            var we = a[3];
            a[3] = we ? Ab(we, se, u[4]) : se, a[4] = we ? _o(a[3], h) : u[4];
          }
          return se = u[5], se && (we = a[5], a[5] = we ? Nb(we, se, u[6]) : se, a[6] = we ? _o(a[5], h) : u[6]), se = u[7], se && (a[7] = se), O & K && (a[8] = a[8] == null ? u[8] : zn(a[8], u[8])), a[9] == null && (a[9] = u[9]), a[0] = u[0], a[1] = j, a;
        }
        function pI(a) {
          var u = [];
          if (a != null)
            for (var _ in Zt(a))
              u.push(_);
          return u;
        }
        function hI(a) {
          return fd.call(a);
        }
        function Zb(a, u, _) {
          return u = pn(u === r ? a.length - 1 : u, 0), function() {
            for (var O = arguments, j = -1, U = pn(O.length - u, 0), te = ue(U); ++j < U; )
              te[j] = O[u + j];
            j = -1;
            for (var se = ue(u + 1); ++j < u; )
              se[j] = O[j];
            return se[u] = _(te), $t(a, this, se);
          };
        }
        function Qb(a, u) {
          return u.length < 2 ? a : ms(a, ji(u, 0, -1));
        }
        function gI(a, u) {
          for (var _ = a.length, O = zn(u.length, _), j = ti(a); O--; ) {
            var U = u[O];
            a[O] = Jo(U, _) ? j[U] : r;
          }
          return a;
        }
        function ah(a, u) {
          if (!(u === "constructor" && typeof a[u] == "function") && u != "__proto__")
            return a[u];
        }
        var e0 = r0(Sb), Cu = DO || function(a, u) {
          return Vr.setTimeout(a, u);
        }, sh = r0(zR);
        function t0(a, u, _) {
          var O = u + "";
          return sh(a, aI(O, vI(nI(O), _)));
        }
        function r0(a) {
          var u = 0, _ = 0;
          return function() {
            var O = NO(), j = fe - (O - _);
            if (_ = O, j > 0) {
              if (++u >= Te)
                return arguments[0];
            } else
              u = 0;
            return a.apply(r, arguments);
          };
        }
        function kd(a, u) {
          var _ = -1, O = a.length, j = O - 1;
          for (u = u === r ? O : u; ++_ < u; ) {
            var U = $p(_, j), te = a[U];
            a[U] = a[_], a[_] = te;
          }
          return a.length = u, a;
        }
        var n0 = dI(function(a) {
          var u = [];
          return a.charCodeAt(0) === 46 && u.push(""), a.replace(oe, function(_, O, j, U) {
            u.push(j ? U.replace(Cr, "$1") : O || _);
          }), u;
        });
        function Co(a) {
          if (typeof a == "string" || vi(a))
            return a;
          var u = a + "";
          return u == "0" && 1 / a == -ce ? "-0" : u;
        }
        function bs(a) {
          if (a != null) {
            try {
              return dd.call(a);
            } catch {
            }
            try {
              return a + "";
            } catch {
            }
          }
          return "";
        }
        function vI(a, u) {
          return $n(Ae, function(_) {
            var O = "_." + _[0];
            u & _[1] && !cs(a, O) && a.push(O);
          }), a.sort();
        }
        function i0(a) {
          if (a instanceof ir)
            return a.clone();
          var u = new Ai(a.__wrapped__, a.__chain__);
          return u.__actions__ = ti(a.__actions__), u.__index__ = a.__index__, u.__values__ = a.__values__, u;
        }
        function mI(a, u, _) {
          (_ ? Gn(a, u, _) : u === r) ? u = 1 : u = pn(Vt(u), 0);
          var O = a == null ? 0 : a.length;
          if (!O || u < 1)
            return [];
          for (var j = 0, U = 0, te = ue(yd(O / u)); j < O; )
            te[U++] = ji(a, j, j += u);
          return te;
        }
        function yI(a) {
          for (var u = -1, _ = a == null ? 0 : a.length, O = 0, j = []; ++u < _; ) {
            var U = a[u];
            U && (j[O++] = U);
          }
          return j;
        }
        function bI() {
          var a = arguments.length;
          if (!a)
            return [];
          for (var u = ue(a - 1), _ = arguments[0], O = a; O--; )
            u[O - 1] = arguments[O];
          return Ir(Wt(_) ? ti(_) : [_], On(u, 1));
        }
        var wI = Xt(function(a, u) {
          return Zr(a) ? bu(a, On(u, 1, Zr, !0)) : [];
        }), xI = Xt(function(a, u) {
          var _ = ki(u);
          return Zr(_) && (_ = r), Zr(a) ? bu(a, On(u, 1, Zr, !0), Ot(_, 2)) : [];
        }), _I = Xt(function(a, u) {
          var _ = ki(u);
          return Zr(_) && (_ = r), Zr(a) ? bu(a, On(u, 1, Zr, !0), r, _) : [];
        });
        function SI(a, u, _) {
          var O = a == null ? 0 : a.length;
          return O ? (u = _ || u === r ? 1 : Vt(u), ji(a, u < 0 ? 0 : u, O)) : [];
        }
        function EI(a, u, _) {
          var O = a == null ? 0 : a.length;
          return O ? (u = _ || u === r ? 1 : Vt(u), u = O - u, ji(a, 0, u < 0 ? 0 : u)) : [];
        }
        function CI(a, u) {
          return a && a.length ? Rd(a, Ot(u, 3), !0, !0) : [];
        }
        function TI(a, u) {
          return a && a.length ? Rd(a, Ot(u, 3), !0) : [];
        }
        function OI(a, u, _, O) {
          var j = a == null ? 0 : a.length;
          return j ? (_ && typeof _ != "number" && Gn(a, u, _) && (_ = 0, O = j), bR(a, u, _, O)) : [];
        }
        function o0(a, u, _) {
          var O = a == null ? 0 : a.length;
          if (!O)
            return -1;
          var j = _ == null ? 0 : Vt(_);
          return j < 0 && (j = pn(O + j, 0)), bn(a, Ot(u, 3), j);
        }
        function a0(a, u, _) {
          var O = a == null ? 0 : a.length;
          if (!O)
            return -1;
          var j = O - 1;
          return _ !== r && (j = Vt(_), j = _ < 0 ? pn(O + j, 0) : zn(j, O - 1)), bn(a, Ot(u, 3), j, !0);
        }
        function s0(a) {
          var u = a == null ? 0 : a.length;
          return u ? On(a, 1) : [];
        }
        function RI(a) {
          var u = a == null ? 0 : a.length;
          return u ? On(a, ce) : [];
        }
        function II(a, u) {
          var _ = a == null ? 0 : a.length;
          return _ ? (u = u === r ? 1 : Vt(u), On(a, u)) : [];
        }
        function DI(a) {
          for (var u = -1, _ = a == null ? 0 : a.length, O = {}; ++u < _; ) {
            var j = a[u];
            O[j[0]] = j[1];
          }
          return O;
        }
        function l0(a) {
          return a && a.length ? a[0] : r;
        }
        function PI(a, u, _) {
          var O = a == null ? 0 : a.length;
          if (!O)
            return -1;
          var j = _ == null ? 0 : Vt(_);
          return j < 0 && (j = pn(O + j, 0)), wo(a, u, j);
        }
        function MI(a) {
          var u = a == null ? 0 : a.length;
          return u ? ji(a, 0, -1) : [];
        }
        var AI = Xt(function(a) {
          var u = Jt(a, Yp);
          return u.length && u[0] === a[0] ? zp(u) : [];
        }), NI = Xt(function(a) {
          var u = ki(a), _ = Jt(a, Yp);
          return u === ki(_) ? u = r : _.pop(), _.length && _[0] === a[0] ? zp(_, Ot(u, 2)) : [];
        }), jI = Xt(function(a) {
          var u = ki(a), _ = Jt(a, Yp);
          return u = typeof u == "function" ? u : r, u && _.pop(), _.length && _[0] === a[0] ? zp(_, r, u) : [];
        });
        function kI(a, u) {
          return a == null ? "" : MO.call(a, u);
        }
        function ki(a) {
          var u = a == null ? 0 : a.length;
          return u ? a[u - 1] : r;
        }
        function LI(a, u, _) {
          var O = a == null ? 0 : a.length;
          if (!O)
            return -1;
          var j = O;
          return _ !== r && (j = Vt(_), j = j < 0 ? pn(O + j, 0) : zn(j, O - 1)), u === u ? d(a, u, j) : bn(a, lu, j, !0);
        }
        function zI(a, u) {
          return a && a.length ? bb(a, Vt(u)) : r;
        }
        var BI = Xt(u0);
        function u0(a, u) {
          return a && a.length && u && u.length ? Hp(a, u) : a;
        }
        function FI(a, u, _) {
          return a && a.length && u && u.length ? Hp(a, u, Ot(_, 2)) : a;
        }
        function WI(a, u, _) {
          return a && a.length && u && u.length ? Hp(a, u, r, _) : a;
        }
        var HI = Xo(function(a, u) {
          var _ = a == null ? 0 : a.length, O = Np(a, u);
          return _b(a, Jt(u, function(j) {
            return Jo(j, _) ? +j : j;
          }).sort(Mb)), O;
        });
        function $I(a, u) {
          var _ = [];
          if (!(a && a.length))
            return _;
          var O = -1, j = [], U = a.length;
          for (u = Ot(u, 3); ++O < U; ) {
            var te = a[O];
            u(te, O, a) && (_.push(te), j.push(O));
          }
          return _b(a, j), _;
        }
        function lh(a) {
          return a == null ? a : kO.call(a);
        }
        function UI(a, u, _) {
          var O = a == null ? 0 : a.length;
          return O ? (_ && typeof _ != "number" && Gn(a, u, _) ? (u = 0, _ = O) : (u = u == null ? 0 : Vt(u), _ = _ === r ? O : Vt(_)), ji(a, u, _)) : [];
        }
        function GI(a, u) {
          return Od(a, u);
        }
        function qI(a, u, _) {
          return Gp(a, u, Ot(_, 2));
        }
        function VI(a, u) {
          var _ = a == null ? 0 : a.length;
          if (_) {
            var O = Od(a, u);
            if (O < _ && ao(a[O], u))
              return O;
          }
          return -1;
        }
        function YI(a, u) {
          return Od(a, u, !0);
        }
        function KI(a, u, _) {
          return Gp(a, u, Ot(_, 2), !0);
        }
        function XI(a, u) {
          var _ = a == null ? 0 : a.length;
          if (_) {
            var O = Od(a, u, !0) - 1;
            if (ao(a[O], u))
              return O;
          }
          return -1;
        }
        function JI(a) {
          return a && a.length ? Eb(a) : [];
        }
        function ZI(a, u) {
          return a && a.length ? Eb(a, Ot(u, 2)) : [];
        }
        function QI(a) {
          var u = a == null ? 0 : a.length;
          return u ? ji(a, 1, u) : [];
        }
        function eD(a, u, _) {
          return a && a.length ? (u = _ || u === r ? 1 : Vt(u), ji(a, 0, u < 0 ? 0 : u)) : [];
        }
        function tD(a, u, _) {
          var O = a == null ? 0 : a.length;
          return O ? (u = _ || u === r ? 1 : Vt(u), u = O - u, ji(a, u < 0 ? 0 : u, O)) : [];
        }
        function rD(a, u) {
          return a && a.length ? Rd(a, Ot(u, 3), !1, !0) : [];
        }
        function nD(a, u) {
          return a && a.length ? Rd(a, Ot(u, 3)) : [];
        }
        var iD = Xt(function(a) {
          return Ca(On(a, 1, Zr, !0));
        }), oD = Xt(function(a) {
          var u = ki(a);
          return Zr(u) && (u = r), Ca(On(a, 1, Zr, !0), Ot(u, 2));
        }), aD = Xt(function(a) {
          var u = ki(a);
          return u = typeof u == "function" ? u : r, Ca(On(a, 1, Zr, !0), r, u);
        });
        function sD(a) {
          return a && a.length ? Ca(a) : [];
        }
        function lD(a, u) {
          return a && a.length ? Ca(a, Ot(u, 2)) : [];
        }
        function uD(a, u) {
          return u = typeof u == "function" ? u : r, a && a.length ? Ca(a, r, u) : [];
        }
        function uh(a) {
          if (!(a && a.length))
            return [];
          var u = 0;
          return a = Di(a, function(_) {
            if (Zr(_))
              return u = pn(_.length, u), !0;
          }), fs(u, function(_) {
            return Jt(a, ei(_));
          });
        }
        function c0(a, u) {
          if (!(a && a.length))
            return [];
          var _ = uh(a);
          return u == null ? _ : Jt(_, function(O) {
            return $t(u, r, O);
          });
        }
        var cD = Xt(function(a, u) {
          return Zr(a) ? bu(a, u) : [];
        }), dD = Xt(function(a) {
          return Vp(Di(a, Zr));
        }), fD = Xt(function(a) {
          var u = ki(a);
          return Zr(u) && (u = r), Vp(Di(a, Zr), Ot(u, 2));
        }), pD = Xt(function(a) {
          var u = ki(a);
          return u = typeof u == "function" ? u : r, Vp(Di(a, Zr), r, u);
        }), hD = Xt(uh);
        function gD(a, u) {
          return Rb(a || [], u || [], yu);
        }
        function vD(a, u) {
          return Rb(a || [], u || [], _u);
        }
        var mD = Xt(function(a) {
          var u = a.length, _ = u > 1 ? a[u - 1] : r;
          return _ = typeof _ == "function" ? (a.pop(), _) : r, c0(a, _);
        });
        function d0(a) {
          var u = $(a);
          return u.__chain__ = !0, u;
        }
        function yD(a, u) {
          return u(a), a;
        }
        function Ld(a, u) {
          return u(a);
        }
        var bD = Xo(function(a) {
          var u = a.length, _ = u ? a[0] : 0, O = this.__wrapped__, j = function(U) {
            return Np(U, a);
          };
          return u > 1 || this.__actions__.length || !(O instanceof ir) || !Jo(_) ? this.thru(j) : (O = O.slice(_, +_ + (u ? 1 : 0)), O.__actions__.push({
            func: Ld,
            args: [j],
            thisArg: r
          }), new Ai(O, this.__chain__).thru(function(U) {
            return u && !U.length && U.push(r), U;
          }));
        });
        function wD() {
          return d0(this);
        }
        function xD() {
          return new Ai(this.value(), this.__chain__);
        }
        function _D() {
          this.__values__ === r && (this.__values__ = C0(this.value()));
          var a = this.__index__ >= this.__values__.length, u = a ? r : this.__values__[this.__index__++];
          return { done: a, value: u };
        }
        function SD() {
          return this;
        }
        function ED(a) {
          for (var u, _ = this; _ instanceof _d; ) {
            var O = i0(_);
            O.__index__ = 0, O.__values__ = r, u ? j.__wrapped__ = O : u = O;
            var j = O;
            _ = _.__wrapped__;
          }
          return j.__wrapped__ = a, u;
        }
        function CD() {
          var a = this.__wrapped__;
          if (a instanceof ir) {
            var u = a;
            return this.__actions__.length && (u = new ir(this)), u = u.reverse(), u.__actions__.push({
              func: Ld,
              args: [lh],
              thisArg: r
            }), new Ai(u, this.__chain__);
          }
          return this.thru(lh);
        }
        function TD() {
          return Ob(this.__wrapped__, this.__actions__);
        }
        var OD = Id(function(a, u, _) {
          _r.call(a, _) ? ++a[_] : Yo(a, _, 1);
        });
        function RD(a, u, _) {
          var O = Wt(a) ? hi : yR;
          return _ && Gn(a, u, _) && (u = r), O(a, Ot(u, 3));
        }
        function ID(a, u) {
          var _ = Wt(a) ? Di : cb;
          return _(a, Ot(u, 3));
        }
        var DD = zb(o0), PD = zb(a0);
        function MD(a, u) {
          return On(zd(a, u), 1);
        }
        function AD(a, u) {
          return On(zd(a, u), ce);
        }
        function ND(a, u, _) {
          return _ = _ === r ? 1 : Vt(_), On(zd(a, u), _);
        }
        function f0(a, u) {
          var _ = Wt(a) ? $n : Ea;
          return _(a, Ot(u, 3));
        }
        function p0(a, u) {
          var _ = Wt(a) ? rd : ub;
          return _(a, Ot(u, 3));
        }
        var jD = Id(function(a, u, _) {
          _r.call(a, _) ? a[_].push(u) : Yo(a, _, [u]);
        });
        function kD(a, u, _, O) {
          a = ri(a) ? a : sl(a), _ = _ && !O ? Vt(_) : 0;
          var j = a.length;
          return _ < 0 && (_ = pn(j + _, 0)), $d(a) ? _ <= j && a.indexOf(u, _) > -1 : !!j && wo(a, u, _) > -1;
        }
        var LD = Xt(function(a, u, _) {
          var O = -1, j = typeof u == "function", U = ri(a) ? ue(a.length) : [];
          return Ea(a, function(te) {
            U[++O] = j ? $t(u, te, _) : wu(te, u, _);
          }), U;
        }), zD = Id(function(a, u, _) {
          Yo(a, _, u);
        });
        function zd(a, u) {
          var _ = Wt(a) ? Jt : vb;
          return _(a, Ot(u, 3));
        }
        function BD(a, u, _, O) {
          return a == null ? [] : (Wt(u) || (u = u == null ? [] : [u]), _ = O ? r : _, Wt(_) || (_ = _ == null ? [] : [_]), wb(a, u, _));
        }
        var FD = Id(function(a, u, _) {
          a[_ ? 0 : 1].push(u);
        }, function() {
          return [[], []];
        });
        function WD(a, u, _) {
          var O = Wt(a) ? xa : ds, j = arguments.length < 3;
          return O(a, Ot(u, 4), _, j, Ea);
        }
        function HD(a, u, _) {
          var O = Wt(a) ? nd : ds, j = arguments.length < 3;
          return O(a, Ot(u, 4), _, j, ub);
        }
        function $D(a, u) {
          var _ = Wt(a) ? Di : cb;
          return _(a, Wd(Ot(u, 3)));
        }
        function UD(a) {
          var u = Wt(a) ? ob : kR;
          return u(a);
        }
        function GD(a, u, _) {
          (_ ? Gn(a, u, _) : u === r) ? u = 1 : u = Vt(u);
          var O = Wt(a) ? pR : LR;
          return O(a, u);
        }
        function qD(a) {
          var u = Wt(a) ? hR : BR;
          return u(a);
        }
        function VD(a) {
          if (a == null)
            return 0;
          if (ri(a))
            return $d(a) ? E(a) : a.length;
          var u = Bn(a);
          return u == rt || u == It ? a.size : Fp(a).length;
        }
        function YD(a, u, _) {
          var O = Wt(a) ? ou : FR;
          return _ && Gn(a, u, _) && (u = r), O(a, Ot(u, 3));
        }
        var KD = Xt(function(a, u) {
          if (a == null)
            return [];
          var _ = u.length;
          return _ > 1 && Gn(a, u[0], u[1]) ? u = [] : _ > 2 && Gn(u[0], u[1], u[2]) && (u = [u[0]]), wb(a, On(u, 1), []);
        }), Bd = IO || function() {
          return Vr.Date.now();
        };
        function XD(a, u) {
          if (typeof u != "function")
            throw new Mi(s);
          return a = Vt(a), function() {
            if (--a < 1)
              return u.apply(this, arguments);
          };
        }
        function h0(a, u, _) {
          return u = _ ? r : u, u = a && u == null ? a.length : u, Ko(a, K, r, r, r, r, u);
        }
        function g0(a, u) {
          var _;
          if (typeof u != "function")
            throw new Mi(s);
          return a = Vt(a), function() {
            return --a > 0 && (_ = u.apply(this, arguments)), a <= 1 && (u = r), _;
          };
        }
        var ch = Xt(function(a, u, _) {
          var O = w;
          if (_.length) {
            var j = _o(_, ol(ch));
            O |= z;
          }
          return Ko(a, O, u, _, j);
        }), v0 = Xt(function(a, u, _) {
          var O = w | C;
          if (_.length) {
            var j = _o(_, ol(v0));
            O |= z;
          }
          return Ko(u, O, a, _, j);
        });
        function m0(a, u, _) {
          u = _ ? r : u;
          var O = Ko(a, L, r, r, r, r, r, u);
          return O.placeholder = m0.placeholder, O;
        }
        function y0(a, u, _) {
          u = _ ? r : u;
          var O = Ko(a, W, r, r, r, r, r, u);
          return O.placeholder = y0.placeholder, O;
        }
        function b0(a, u, _) {
          var O, j, U, te, se, we, Ge = 0, qe = !1, Je = !1, st = !0;
          if (typeof a != "function")
            throw new Mi(s);
          u = Li(u) || 0, $r(_) && (qe = !!_.leading, Je = "maxWait" in _, U = Je ? pn(Li(_.maxWait) || 0, u) : U, st = "trailing" in _ ? !!_.trailing : st);
          function wt(Qr) {
            var so = O, ea = j;
            return O = j = r, Ge = Qr, te = a.apply(ea, so), te;
          }
          function Dt(Qr) {
            return Ge = Qr, se = Cu(tr, u), qe ? wt(Qr) : te;
          }
          function Yt(Qr) {
            var so = Qr - we, ea = Qr - Ge, z0 = u - so;
            return Je ? zn(z0, U - ea) : z0;
          }
          function Pt(Qr) {
            var so = Qr - we, ea = Qr - Ge;
            return we === r || so >= u || so < 0 || Je && ea >= U;
          }
          function tr() {
            var Qr = Bd();
            if (Pt(Qr))
              return ar(Qr);
            se = Cu(tr, Yt(Qr));
          }
          function ar(Qr) {
            return se = r, st && O ? wt(Qr) : (O = j = r, te);
          }
          function mi() {
            se !== r && Ib(se), Ge = 0, O = we = j = se = r;
          }
          function qn() {
            return se === r ? te : ar(Bd());
          }
          function yi() {
            var Qr = Bd(), so = Pt(Qr);
            if (O = arguments, j = this, we = Qr, so) {
              if (se === r)
                return Dt(we);
              if (Je)
                return Ib(se), se = Cu(tr, u), wt(we);
            }
            return se === r && (se = Cu(tr, u)), te;
          }
          return yi.cancel = mi, yi.flush = qn, yi;
        }
        var JD = Xt(function(a, u) {
          return lb(a, 1, u);
        }), ZD = Xt(function(a, u, _) {
          return lb(a, Li(u) || 0, _);
        });
        function QD(a) {
          return Ko(a, ee);
        }
        function Fd(a, u) {
          if (typeof a != "function" || u != null && typeof u != "function")
            throw new Mi(s);
          var _ = function() {
            var O = arguments, j = u ? u.apply(this, O) : O[0], U = _.cache;
            if (U.has(j))
              return U.get(j);
            var te = a.apply(this, O);
            return _.cache = U.set(j, te) || U, te;
          };
          return _.cache = new (Fd.Cache || Vo)(), _;
        }
        Fd.Cache = Vo;
        function Wd(a) {
          if (typeof a != "function")
            throw new Mi(s);
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return !a.call(this);
              case 1:
                return !a.call(this, u[0]);
              case 2:
                return !a.call(this, u[0], u[1]);
              case 3:
                return !a.call(this, u[0], u[1], u[2]);
            }
            return !a.apply(this, u);
          };
        }
        function eP(a) {
          return g0(2, a);
        }
        var tP = WR(function(a, u) {
          u = u.length == 1 && Wt(u[0]) ? Jt(u[0], Ln(Ot())) : Jt(On(u, 1), Ln(Ot()));
          var _ = u.length;
          return Xt(function(O) {
            for (var j = -1, U = zn(O.length, _); ++j < U; )
              O[j] = u[j].call(this, O[j]);
            return $t(a, this, O);
          });
        }), dh = Xt(function(a, u) {
          var _ = _o(u, ol(dh));
          return Ko(a, z, r, u, _);
        }), w0 = Xt(function(a, u) {
          var _ = _o(u, ol(w0));
          return Ko(a, B, r, u, _);
        }), rP = Xo(function(a, u) {
          return Ko(a, Z, r, r, r, u);
        });
        function nP(a, u) {
          if (typeof a != "function")
            throw new Mi(s);
          return u = u === r ? u : Vt(u), Xt(a, u);
        }
        function iP(a, u) {
          if (typeof a != "function")
            throw new Mi(s);
          return u = u == null ? 0 : pn(Vt(u), 0), Xt(function(_) {
            var O = _[u], j = Oa(_, 0, u);
            return O && Ir(j, O), $t(a, this, j);
          });
        }
        function oP(a, u, _) {
          var O = !0, j = !0;
          if (typeof a != "function")
            throw new Mi(s);
          return $r(_) && (O = "leading" in _ ? !!_.leading : O, j = "trailing" in _ ? !!_.trailing : j), b0(a, u, {
            leading: O,
            maxWait: u,
            trailing: j
          });
        }
        function aP(a) {
          return h0(a, 1);
        }
        function sP(a, u) {
          return dh(Kp(u), a);
        }
        function lP() {
          if (!arguments.length)
            return [];
          var a = arguments[0];
          return Wt(a) ? a : [a];
        }
        function uP(a) {
          return Ni(a, b);
        }
        function cP(a, u) {
          return u = typeof u == "function" ? u : r, Ni(a, b, u);
        }
        function dP(a) {
          return Ni(a, g | b);
        }
        function fP(a, u) {
          return u = typeof u == "function" ? u : r, Ni(a, g | b, u);
        }
        function pP(a, u) {
          return u == null || sb(a, u, xn(u));
        }
        function ao(a, u) {
          return a === u || a !== a && u !== u;
        }
        var hP = Ad(Lp), gP = Ad(function(a, u) {
          return a >= u;
        }), ws = pb(/* @__PURE__ */ function() {
          return arguments;
        }()) ? pb : function(a) {
          return Kr(a) && _r.call(a, "callee") && !Qy.call(a, "callee");
        }, Wt = ue.isArray, vP = Gs ? Ln(Gs) : ER;
        function ri(a) {
          return a != null && Hd(a.length) && !Zo(a);
        }
        function Zr(a) {
          return Kr(a) && ri(a);
        }
        function mP(a) {
          return a === !0 || a === !1 || Kr(a) && Un(a) == X;
        }
        var Ra = PO || _h, yP = wa ? Ln(wa) : CR;
        function bP(a) {
          return Kr(a) && a.nodeType === 1 && !Tu(a);
        }
        function wP(a) {
          if (a == null)
            return !0;
          if (ri(a) && (Wt(a) || typeof a == "string" || typeof a.splice == "function" || Ra(a) || al(a) || ws(a)))
            return !a.length;
          var u = Bn(a);
          if (u == rt || u == It)
            return !a.size;
          if (Eu(a))
            return !Fp(a).length;
          for (var _ in a)
            if (_r.call(a, _))
              return !1;
          return !0;
        }
        function xP(a, u) {
          return xu(a, u);
        }
        function _P(a, u, _) {
          _ = typeof _ == "function" ? _ : r;
          var O = _ ? _(a, u) : r;
          return O === r ? xu(a, u, r, _) : !!O;
        }
        function fh(a) {
          if (!Kr(a))
            return !1;
          var u = Un(a);
          return u == xe || u == Ie || typeof a.message == "string" && typeof a.name == "string" && !Tu(a);
        }
        function SP(a) {
          return typeof a == "number" && tb(a);
        }
        function Zo(a) {
          if (!$r(a))
            return !1;
          var u = Un(a);
          return u == Pe || u == ae || u == Ce || u == Bt;
        }
        function x0(a) {
          return typeof a == "number" && a == Vt(a);
        }
        function Hd(a) {
          return typeof a == "number" && a > -1 && a % 1 == 0 && a <= Fe;
        }
        function $r(a) {
          var u = typeof a;
          return a != null && (u == "object" || u == "function");
        }
        function Kr(a) {
          return a != null && typeof a == "object";
        }
        var _0 = Ri ? Ln(Ri) : OR;
        function EP(a, u) {
          return a === u || Bp(a, u, rh(u));
        }
        function CP(a, u, _) {
          return _ = typeof _ == "function" ? _ : r, Bp(a, u, rh(u), _);
        }
        function TP(a) {
          return S0(a) && a != +a;
        }
        function OP(a) {
          if (cI(a))
            throw new ot(o);
          return hb(a);
        }
        function RP(a) {
          return a === null;
        }
        function IP(a) {
          return a == null;
        }
        function S0(a) {
          return typeof a == "number" || Kr(a) && Un(a) == Ze;
        }
        function Tu(a) {
          if (!Kr(a) || Un(a) != mt)
            return !1;
          var u = gd(a);
          if (u === null)
            return !0;
          var _ = _r.call(u, "constructor") && u.constructor;
          return typeof _ == "function" && _ instanceof _ && dd.call(_) == CO;
        }
        var ph = Ii ? Ln(Ii) : RR;
        function DP(a) {
          return x0(a) && a >= -Fe && a <= Fe;
        }
        var E0 = us ? Ln(us) : IR;
        function $d(a) {
          return typeof a == "string" || !Wt(a) && Kr(a) && Un(a) == sr;
        }
        function vi(a) {
          return typeof a == "symbol" || Kr(a) && Un(a) == et;
        }
        var al = Go ? Ln(Go) : DR;
        function PP(a) {
          return a === r;
        }
        function MP(a) {
          return Kr(a) && Bn(a) == Qt;
        }
        function AP(a) {
          return Kr(a) && Un(a) == pr;
        }
        var NP = Ad(Wp), jP = Ad(function(a, u) {
          return a <= u;
        });
        function C0(a) {
          if (!a)
            return [];
          if (ri(a))
            return $d(a) ? R(a) : ti(a);
          if (pu && a[pu])
            return sd(a[pu]());
          var u = Bn(a), _ = u == rt ? du : u == It ? Zs : sl;
          return _(a);
        }
        function Qo(a) {
          if (!a)
            return a === 0 ? a : 0;
          if (a = Li(a), a === ce || a === -ce) {
            var u = a < 0 ? -1 : 1;
            return u * le;
          }
          return a === a ? a : 0;
        }
        function Vt(a) {
          var u = Qo(a), _ = u % 1;
          return u === u ? _ ? u - _ : u : 0;
        }
        function T0(a) {
          return a ? vs(Vt(a), 0, re) : 0;
        }
        function Li(a) {
          if (typeof a == "number")
            return a;
          if (vi(a))
            return J;
          if ($r(a)) {
            var u = typeof a.valueOf == "function" ? a.valueOf() : a;
            a = $r(u) ? u + "" : u;
          }
          if (typeof a != "string")
            return a === 0 ? a : +a;
          a = uu(a);
          var _ = Tt.test(a);
          return _ || da.test(a) ? to(a.slice(2), _ ? 2 : 8) : qr.test(a) ? J : +a;
        }
        function O0(a) {
          return Eo(a, ni(a));
        }
        function kP(a) {
          return a ? vs(Vt(a), -Fe, Fe) : a === 0 ? a : 0;
        }
        function mr(a) {
          return a == null ? "" : gi(a);
        }
        var LP = nl(function(a, u) {
          if (Eu(u) || ri(u)) {
            Eo(u, xn(u), a);
            return;
          }
          for (var _ in u)
            _r.call(u, _) && yu(a, _, u[_]);
        }), R0 = nl(function(a, u) {
          Eo(u, ni(u), a);
        }), Ud = nl(function(a, u, _, O) {
          Eo(u, ni(u), a, O);
        }), zP = nl(function(a, u, _, O) {
          Eo(u, xn(u), a, O);
        }), BP = Xo(Np);
        function FP(a, u) {
          var _ = rl(a);
          return u == null ? _ : ab(_, u);
        }
        var WP = Xt(function(a, u) {
          a = Zt(a);
          var _ = -1, O = u.length, j = O > 2 ? u[2] : r;
          for (j && Gn(u[0], u[1], j) && (O = 1); ++_ < O; )
            for (var U = u[_], te = ni(U), se = -1, we = te.length; ++se < we; ) {
              var Ge = te[se], qe = a[Ge];
              (qe === r || ao(qe, Qs[Ge]) && !_r.call(a, Ge)) && (a[Ge] = U[Ge]);
            }
          return a;
        }), HP = Xt(function(a) {
          return a.push(r, Gb), $t(I0, r, a);
        });
        function $P(a, u) {
          return su(a, Ot(u, 3), So);
        }
        function UP(a, u) {
          return su(a, Ot(u, 3), kp);
        }
        function GP(a, u) {
          return a == null ? a : jp(a, Ot(u, 3), ni);
        }
        function qP(a, u) {
          return a == null ? a : db(a, Ot(u, 3), ni);
        }
        function VP(a, u) {
          return a && So(a, Ot(u, 3));
        }
        function YP(a, u) {
          return a && kp(a, Ot(u, 3));
        }
        function KP(a) {
          return a == null ? [] : Cd(a, xn(a));
        }
        function XP(a) {
          return a == null ? [] : Cd(a, ni(a));
        }
        function hh(a, u, _) {
          var O = a == null ? r : ms(a, u);
          return O === r ? _ : O;
        }
        function JP(a, u) {
          return a != null && Yb(a, u, wR);
        }
        function gh(a, u) {
          return a != null && Yb(a, u, xR);
        }
        var ZP = Fb(function(a, u, _) {
          u != null && typeof u.toString != "function" && (u = fd.call(u)), a[u] = _;
        }, mh(ii)), QP = Fb(function(a, u, _) {
          u != null && typeof u.toString != "function" && (u = fd.call(u)), _r.call(a, u) ? a[u].push(_) : a[u] = [_];
        }, Ot), eM = Xt(wu);
        function xn(a) {
          return ri(a) ? ib(a) : Fp(a);
        }
        function ni(a) {
          return ri(a) ? ib(a, !0) : PR(a);
        }
        function tM(a, u) {
          var _ = {};
          return u = Ot(u, 3), So(a, function(O, j, U) {
            Yo(_, u(O, j, U), O);
          }), _;
        }
        function rM(a, u) {
          var _ = {};
          return u = Ot(u, 3), So(a, function(O, j, U) {
            Yo(_, j, u(O, j, U));
          }), _;
        }
        var nM = nl(function(a, u, _) {
          Td(a, u, _);
        }), I0 = nl(function(a, u, _, O) {
          Td(a, u, _, O);
        }), iM = Xo(function(a, u) {
          var _ = {};
          if (a == null)
            return _;
          var O = !1;
          u = Jt(u, function(U) {
            return U = Ta(U, a), O || (O = U.length > 1), U;
          }), Eo(a, eh(a), _), O && (_ = Ni(_, g | S | b, ZR));
          for (var j = u.length; j--; )
            qp(_, u[j]);
          return _;
        });
        function oM(a, u) {
          return D0(a, Wd(Ot(u)));
        }
        var aM = Xo(function(a, u) {
          return a == null ? {} : AR(a, u);
        });
        function D0(a, u) {
          if (a == null)
            return {};
          var _ = Jt(eh(a), function(O) {
            return [O];
          });
          return u = Ot(u), xb(a, _, function(O, j) {
            return u(O, j[0]);
          });
        }
        function sM(a, u, _) {
          u = Ta(u, a);
          var O = -1, j = u.length;
          for (j || (j = 1, a = r); ++O < j; ) {
            var U = a == null ? r : a[Co(u[O])];
            U === r && (O = j, U = _), a = Zo(U) ? U.call(a) : U;
          }
          return a;
        }
        function lM(a, u, _) {
          return a == null ? a : _u(a, u, _);
        }
        function uM(a, u, _, O) {
          return O = typeof O == "function" ? O : r, a == null ? a : _u(a, u, _, O);
        }
        var P0 = $b(xn), M0 = $b(ni);
        function cM(a, u, _) {
          var O = Wt(a), j = O || Ra(a) || al(a);
          if (u = Ot(u, 4), _ == null) {
            var U = a && a.constructor;
            j ? _ = O ? new U() : [] : $r(a) ? _ = Zo(U) ? rl(gd(a)) : {} : _ = {};
          }
          return (j ? $n : So)(a, function(te, se, we) {
            return u(_, te, se, we);
          }), _;
        }
        function dM(a, u) {
          return a == null ? !0 : qp(a, u);
        }
        function fM(a, u, _) {
          return a == null ? a : Tb(a, u, Kp(_));
        }
        function pM(a, u, _, O) {
          return O = typeof O == "function" ? O : r, a == null ? a : Tb(a, u, Kp(_), O);
        }
        function sl(a) {
          return a == null ? [] : xo(a, xn(a));
        }
        function hM(a) {
          return a == null ? [] : xo(a, ni(a));
        }
        function gM(a, u, _) {
          return _ === r && (_ = u, u = r), _ !== r && (_ = Li(_), _ = _ === _ ? _ : 0), u !== r && (u = Li(u), u = u === u ? u : 0), vs(Li(a), u, _);
        }
        function vM(a, u, _) {
          return u = Qo(u), _ === r ? (_ = u, u = 0) : _ = Qo(_), a = Li(a), _R(a, u, _);
        }
        function mM(a, u, _) {
          if (_ && typeof _ != "boolean" && Gn(a, u, _) && (u = _ = r), _ === r && (typeof u == "boolean" ? (_ = u, u = r) : typeof a == "boolean" && (_ = a, a = r)), a === r && u === r ? (a = 0, u = 1) : (a = Qo(a), u === r ? (u = a, a = 0) : u = Qo(u)), a > u) {
            var O = a;
            a = u, u = O;
          }
          if (_ || a % 1 || u % 1) {
            var j = rb();
            return zn(a + j * (u - a + bo("1e-" + ((j + "").length - 1))), u);
          }
          return $p(a, u);
        }
        var yM = il(function(a, u, _) {
          return u = u.toLowerCase(), a + (_ ? A0(u) : u);
        });
        function A0(a) {
          return vh(mr(a).toLowerCase());
        }
        function N0(a) {
          return a = mr(a), a && a.replace(Zi, wn).replace(tt, "");
        }
        function bM(a, u, _) {
          a = mr(a), u = gi(u);
          var O = a.length;
          _ = _ === r ? O : vs(Vt(_), 0, O);
          var j = _;
          return _ -= u.length, _ >= 0 && a.slice(_, j) == u;
        }
        function wM(a) {
          return a = mr(a), a && di.test(a) ? a.replace(vn, Js) : a;
        }
        function xM(a) {
          return a = mr(a), a && lt.test(a) ? a.replace(Qe, "\\$&") : a;
        }
        var _M = il(function(a, u, _) {
          return a + (_ ? "-" : "") + u.toLowerCase();
        }), SM = il(function(a, u, _) {
          return a + (_ ? " " : "") + u.toLowerCase();
        }), EM = Lb("toLowerCase");
        function CM(a, u, _) {
          a = mr(a), u = Vt(u);
          var O = u ? E(a) : 0;
          if (!u || O >= u)
            return a;
          var j = (u - O) / 2;
          return Md(bd(j), _) + a + Md(yd(j), _);
        }
        function TM(a, u, _) {
          a = mr(a), u = Vt(u);
          var O = u ? E(a) : 0;
          return u && O < u ? a + Md(u - O, _) : a;
        }
        function OM(a, u, _) {
          a = mr(a), u = Vt(u);
          var O = u ? E(a) : 0;
          return u && O < u ? Md(u - O, _) + a : a;
        }
        function RM(a, u, _) {
          return _ || u == null ? u = 0 : u && (u = +u), jO(mr(a).replace(_t, ""), u || 0);
        }
        function IM(a, u, _) {
          return (_ ? Gn(a, u, _) : u === r) ? u = 1 : u = Vt(u), Up(mr(a), u);
        }
        function DM() {
          var a = arguments, u = mr(a[0]);
          return a.length < 3 ? u : u.replace(a[1], a[2]);
        }
        var PM = il(function(a, u, _) {
          return a + (_ ? "_" : "") + u.toLowerCase();
        });
        function MM(a, u, _) {
          return _ && typeof _ != "number" && Gn(a, u, _) && (u = _ = r), _ = _ === r ? re : _ >>> 0, _ ? (a = mr(a), a && (typeof u == "string" || u != null && !ph(u)) && (u = gi(u), !u && io(a)) ? Oa(R(a), 0, _) : a.split(u, _)) : [];
        }
        var AM = il(function(a, u, _) {
          return a + (_ ? " " : "") + vh(u);
        });
        function NM(a, u, _) {
          return a = mr(a), _ = _ == null ? 0 : vs(Vt(_), 0, a.length), u = gi(u), a.slice(_, _ + u.length) == u;
        }
        function jM(a, u, _) {
          var O = $.templateSettings;
          _ && Gn(a, u, _) && (u = r), a = mr(a), u = Ud({}, u, O, Ub);
          var j = Ud({}, u.imports, O.imports, Ub), U = xn(j), te = xo(j, U), se, we, Ge = 0, qe = u.interpolate || kn, Je = "__p += '", st = _a(
            (u.escape || kn).source + "|" + qe.source + "|" + (qe === Oi ? fn : kn).source + "|" + (u.evaluate || kn).source + "|$",
            "g"
          ), wt = "//# sourceURL=" + (_r.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++er + "]") + `
`;
          a.replace(st, function(Pt, tr, ar, mi, qn, yi) {
            return ar || (ar = mi), Je += a.slice(Ge, yi).replace(mo, Op), tr && (se = !0, Je += `' +
__e(` + tr + `) +
'`), qn && (we = !0, Je += `';
` + qn + `;
__p += '`), ar && (Je += `' +
((__t = (` + ar + `)) == null ? '' : __t) +
'`), Ge = yi + Pt.length, Pt;
          }), Je += `';
`;
          var Dt = _r.call(u, "variable") && u.variable;
          if (!Dt)
            Je = `with (obj) {
` + Je + `
}
`;
          else if (Rr.test(Dt))
            throw new ot(l);
          Je = (we ? Je.replace(Xi, "") : Je).replace(Ti, "$1").replace(Gr, "$1;"), Je = "function(" + (Dt || "obj") + `) {
` + (Dt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (se ? ", __e = _.escape" : "") + (we ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Je + `return __p
}`;
          var Yt = k0(function() {
            return St(U, wt + "return " + Je).apply(r, te);
          });
          if (Yt.source = Je, fh(Yt))
            throw Yt;
          return Yt;
        }
        function kM(a) {
          return mr(a).toLowerCase();
        }
        function LM(a) {
          return mr(a).toUpperCase();
        }
        function zM(a, u, _) {
          if (a = mr(a), a && (_ || u === r))
            return uu(a);
          if (!a || !(u = gi(u)))
            return a;
          var O = R(a), j = R(u), U = cu(O, j), te = Xs(O, j) + 1;
          return Oa(O, U, te).join("");
        }
        function BM(a, u, _) {
          if (a = mr(a), a && (_ || u === r))
            return a.slice(0, A(a) + 1);
          if (!a || !(u = gi(u)))
            return a;
          var O = R(a), j = Xs(O, R(u)) + 1;
          return Oa(O, 0, j).join("");
        }
        function FM(a, u, _) {
          if (a = mr(a), a && (_ || u === r))
            return a.replace(_t, "");
          if (!a || !(u = gi(u)))
            return a;
          var O = R(a), j = cu(O, R(u));
          return Oa(O, j).join("");
        }
        function WM(a, u) {
          var _ = he, O = _e;
          if ($r(u)) {
            var j = "separator" in u ? u.separator : j;
            _ = "length" in u ? Vt(u.length) : _, O = "omission" in u ? gi(u.omission) : O;
          }
          a = mr(a);
          var U = a.length;
          if (io(a)) {
            var te = R(a);
            U = te.length;
          }
          if (_ >= U)
            return a;
          var se = _ - E(O);
          if (se < 1)
            return O;
          var we = te ? Oa(te, 0, se).join("") : a.slice(0, se);
          if (j === r)
            return we + O;
          if (te && (se += we.length - se), ph(j)) {
            if (a.slice(se).search(j)) {
              var Ge, qe = we;
              for (j.global || (j = _a(j.source, mr(nn.exec(j)) + "g")), j.lastIndex = 0; Ge = j.exec(qe); )
                var Je = Ge.index;
              we = we.slice(0, Je === r ? se : Je);
            }
          } else if (a.indexOf(gi(j), se) != se) {
            var st = we.lastIndexOf(j);
            st > -1 && (we = we.slice(0, st));
          }
          return we + O;
        }
        function HM(a) {
          return a = mr(a), a && Ji.test(a) ? a.replace(jn, k) : a;
        }
        var $M = il(function(a, u, _) {
          return a + (_ ? " " : "") + u.toUpperCase();
        }), vh = Lb("toUpperCase");
        function j0(a, u, _) {
          return a = mr(a), u = _ ? r : u, u === r ? ad(a) ? me(a) : au(a) : a.match(u) || [];
        }
        var k0 = Xt(function(a, u) {
          try {
            return $t(a, r, u);
          } catch (_) {
            return fh(_) ? _ : new ot(_);
          }
        }), UM = Xo(function(a, u) {
          return $n(u, function(_) {
            _ = Co(_), Yo(a, _, ch(a[_], a));
          }), a;
        });
        function GM(a) {
          var u = a == null ? 0 : a.length, _ = Ot();
          return a = u ? Jt(a, function(O) {
            if (typeof O[1] != "function")
              throw new Mi(s);
            return [_(O[0]), O[1]];
          }) : [], Xt(function(O) {
            for (var j = -1; ++j < u; ) {
              var U = a[j];
              if ($t(U[0], this, O))
                return $t(U[1], this, O);
            }
          });
        }
        function qM(a) {
          return mR(Ni(a, g));
        }
        function mh(a) {
          return function() {
            return a;
          };
        }
        function VM(a, u) {
          return a == null || a !== a ? u : a;
        }
        var YM = Bb(), KM = Bb(!0);
        function ii(a) {
          return a;
        }
        function yh(a) {
          return gb(typeof a == "function" ? a : Ni(a, g));
        }
        function XM(a) {
          return mb(Ni(a, g));
        }
        function JM(a, u) {
          return yb(a, Ni(u, g));
        }
        var ZM = Xt(function(a, u) {
          return function(_) {
            return wu(_, a, u);
          };
        }), QM = Xt(function(a, u) {
          return function(_) {
            return wu(a, _, u);
          };
        });
        function bh(a, u, _) {
          var O = xn(u), j = Cd(u, O);
          _ == null && !($r(u) && (j.length || !O.length)) && (_ = u, u = a, a = this, j = Cd(u, xn(u)));
          var U = !($r(_) && "chain" in _) || !!_.chain, te = Zo(a);
          return $n(j, function(se) {
            var we = u[se];
            a[se] = we, te && (a.prototype[se] = function() {
              var Ge = this.__chain__;
              if (U || Ge) {
                var qe = a(this.__wrapped__), Je = qe.__actions__ = ti(this.__actions__);
                return Je.push({ func: we, args: arguments, thisArg: a }), qe.__chain__ = Ge, qe;
              }
              return we.apply(a, Ir([this.value()], arguments));
            });
          }), a;
        }
        function eA() {
          return Vr._ === this && (Vr._ = TO), this;
        }
        function wh() {
        }
        function tA(a) {
          return a = Vt(a), Xt(function(u) {
            return bb(u, a);
          });
        }
        var rA = Jp(Jt), nA = Jp(hi), iA = Jp(ou);
        function L0(a) {
          return ih(a) ? ei(Co(a)) : NR(a);
        }
        function oA(a) {
          return function(u) {
            return a == null ? r : ms(a, u);
          };
        }
        var aA = Wb(), sA = Wb(!0);
        function xh() {
          return [];
        }
        function _h() {
          return !1;
        }
        function lA() {
          return {};
        }
        function uA() {
          return "";
        }
        function cA() {
          return !0;
        }
        function dA(a, u) {
          if (a = Vt(a), a < 1 || a > Fe)
            return [];
          var _ = re, O = zn(a, re);
          u = Ot(u), a -= re;
          for (var j = fs(O, u); ++_ < a; )
            u(_);
          return j;
        }
        function fA(a) {
          return Wt(a) ? Jt(a, Co) : vi(a) ? [a] : ti(n0(mr(a)));
        }
        function pA(a) {
          var u = ++EO;
          return mr(a) + u;
        }
        var hA = Pd(function(a, u) {
          return a + u;
        }, 0), gA = Zp("ceil"), vA = Pd(function(a, u) {
          return a / u;
        }, 1), mA = Zp("floor");
        function yA(a) {
          return a && a.length ? Ed(a, ii, Lp) : r;
        }
        function bA(a, u) {
          return a && a.length ? Ed(a, Ot(u, 2), Lp) : r;
        }
        function wA(a) {
          return Vs(a, ii);
        }
        function xA(a, u) {
          return Vs(a, Ot(u, 2));
        }
        function _A(a) {
          return a && a.length ? Ed(a, ii, Wp) : r;
        }
        function SA(a, u) {
          return a && a.length ? Ed(a, Ot(u, 2), Wp) : r;
        }
        var EA = Pd(function(a, u) {
          return a * u;
        }, 1), CA = Zp("round"), TA = Pd(function(a, u) {
          return a - u;
        }, 0);
        function OA(a) {
          return a && a.length ? Ks(a, ii) : 0;
        }
        function RA(a, u) {
          return a && a.length ? Ks(a, Ot(u, 2)) : 0;
        }
        return $.after = XD, $.ary = h0, $.assign = LP, $.assignIn = R0, $.assignInWith = Ud, $.assignWith = zP, $.at = BP, $.before = g0, $.bind = ch, $.bindAll = UM, $.bindKey = v0, $.castArray = lP, $.chain = d0, $.chunk = mI, $.compact = yI, $.concat = bI, $.cond = GM, $.conforms = qM, $.constant = mh, $.countBy = OD, $.create = FP, $.curry = m0, $.curryRight = y0, $.debounce = b0, $.defaults = WP, $.defaultsDeep = HP, $.defer = JD, $.delay = ZD, $.difference = wI, $.differenceBy = xI, $.differenceWith = _I, $.drop = SI, $.dropRight = EI, $.dropRightWhile = CI, $.dropWhile = TI, $.fill = OI, $.filter = ID, $.flatMap = MD, $.flatMapDeep = AD, $.flatMapDepth = ND, $.flatten = s0, $.flattenDeep = RI, $.flattenDepth = II, $.flip = QD, $.flow = YM, $.flowRight = KM, $.fromPairs = DI, $.functions = KP, $.functionsIn = XP, $.groupBy = jD, $.initial = MI, $.intersection = AI, $.intersectionBy = NI, $.intersectionWith = jI, $.invert = ZP, $.invertBy = QP, $.invokeMap = LD, $.iteratee = yh, $.keyBy = zD, $.keys = xn, $.keysIn = ni, $.map = zd, $.mapKeys = tM, $.mapValues = rM, $.matches = XM, $.matchesProperty = JM, $.memoize = Fd, $.merge = nM, $.mergeWith = I0, $.method = ZM, $.methodOf = QM, $.mixin = bh, $.negate = Wd, $.nthArg = tA, $.omit = iM, $.omitBy = oM, $.once = eP, $.orderBy = BD, $.over = rA, $.overArgs = tP, $.overEvery = nA, $.overSome = iA, $.partial = dh, $.partialRight = w0, $.partition = FD, $.pick = aM, $.pickBy = D0, $.property = L0, $.propertyOf = oA, $.pull = BI, $.pullAll = u0, $.pullAllBy = FI, $.pullAllWith = WI, $.pullAt = HI, $.range = aA, $.rangeRight = sA, $.rearg = rP, $.reject = $D, $.remove = $I, $.rest = nP, $.reverse = lh, $.sampleSize = GD, $.set = lM, $.setWith = uM, $.shuffle = qD, $.slice = UI, $.sortBy = KD, $.sortedUniq = JI, $.sortedUniqBy = ZI, $.split = MM, $.spread = iP, $.tail = QI, $.take = eD, $.takeRight = tD, $.takeRightWhile = rD, $.takeWhile = nD, $.tap = yD, $.throttle = oP, $.thru = Ld, $.toArray = C0, $.toPairs = P0, $.toPairsIn = M0, $.toPath = fA, $.toPlainObject = O0, $.transform = cM, $.unary = aP, $.union = iD, $.unionBy = oD, $.unionWith = aD, $.uniq = sD, $.uniqBy = lD, $.uniqWith = uD, $.unset = dM, $.unzip = uh, $.unzipWith = c0, $.update = fM, $.updateWith = pM, $.values = sl, $.valuesIn = hM, $.without = cD, $.words = j0, $.wrap = sP, $.xor = dD, $.xorBy = fD, $.xorWith = pD, $.zip = hD, $.zipObject = gD, $.zipObjectDeep = vD, $.zipWith = mD, $.entries = P0, $.entriesIn = M0, $.extend = R0, $.extendWith = Ud, bh($, $), $.add = hA, $.attempt = k0, $.camelCase = yM, $.capitalize = A0, $.ceil = gA, $.clamp = gM, $.clone = uP, $.cloneDeep = dP, $.cloneDeepWith = fP, $.cloneWith = cP, $.conformsTo = pP, $.deburr = N0, $.defaultTo = VM, $.divide = vA, $.endsWith = bM, $.eq = ao, $.escape = wM, $.escapeRegExp = xM, $.every = RD, $.find = DD, $.findIndex = o0, $.findKey = $P, $.findLast = PD, $.findLastIndex = a0, $.findLastKey = UP, $.floor = mA, $.forEach = f0, $.forEachRight = p0, $.forIn = GP, $.forInRight = qP, $.forOwn = VP, $.forOwnRight = YP, $.get = hh, $.gt = hP, $.gte = gP, $.has = JP, $.hasIn = gh, $.head = l0, $.identity = ii, $.includes = kD, $.indexOf = PI, $.inRange = vM, $.invoke = eM, $.isArguments = ws, $.isArray = Wt, $.isArrayBuffer = vP, $.isArrayLike = ri, $.isArrayLikeObject = Zr, $.isBoolean = mP, $.isBuffer = Ra, $.isDate = yP, $.isElement = bP, $.isEmpty = wP, $.isEqual = xP, $.isEqualWith = _P, $.isError = fh, $.isFinite = SP, $.isFunction = Zo, $.isInteger = x0, $.isLength = Hd, $.isMap = _0, $.isMatch = EP, $.isMatchWith = CP, $.isNaN = TP, $.isNative = OP, $.isNil = IP, $.isNull = RP, $.isNumber = S0, $.isObject = $r, $.isObjectLike = Kr, $.isPlainObject = Tu, $.isRegExp = ph, $.isSafeInteger = DP, $.isSet = E0, $.isString = $d, $.isSymbol = vi, $.isTypedArray = al, $.isUndefined = PP, $.isWeakMap = MP, $.isWeakSet = AP, $.join = kI, $.kebabCase = _M, $.last = ki, $.lastIndexOf = LI, $.lowerCase = SM, $.lowerFirst = EM, $.lt = NP, $.lte = jP, $.max = yA, $.maxBy = bA, $.mean = wA, $.meanBy = xA, $.min = _A, $.minBy = SA, $.stubArray = xh, $.stubFalse = _h, $.stubObject = lA, $.stubString = uA, $.stubTrue = cA, $.multiply = EA, $.nth = zI, $.noConflict = eA, $.noop = wh, $.now = Bd, $.pad = CM, $.padEnd = TM, $.padStart = OM, $.parseInt = RM, $.random = mM, $.reduce = WD, $.reduceRight = HD, $.repeat = IM, $.replace = DM, $.result = sM, $.round = CA, $.runInContext = G, $.sample = UD, $.size = VD, $.snakeCase = PM, $.some = YD, $.sortedIndex = GI, $.sortedIndexBy = qI, $.sortedIndexOf = VI, $.sortedLastIndex = YI, $.sortedLastIndexBy = KI, $.sortedLastIndexOf = XI, $.startCase = AM, $.startsWith = NM, $.subtract = TA, $.sum = OA, $.sumBy = RA, $.template = jM, $.times = dA, $.toFinite = Qo, $.toInteger = Vt, $.toLength = T0, $.toLower = kM, $.toNumber = Li, $.toSafeInteger = kP, $.toString = mr, $.toUpper = LM, $.trim = zM, $.trimEnd = BM, $.trimStart = FM, $.truncate = WM, $.unescape = HM, $.uniqueId = pA, $.upperCase = $M, $.upperFirst = vh, $.each = f0, $.eachRight = p0, $.first = l0, bh($, function() {
          var a = {};
          return So($, function(u, _) {
            _r.call($.prototype, _) || (a[_] = u);
          }), a;
        }(), { chain: !1 }), $.VERSION = n, $n(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(a) {
          $[a].placeholder = $;
        }), $n(["drop", "take"], function(a, u) {
          ir.prototype[a] = function(_) {
            _ = _ === r ? 1 : pn(Vt(_), 0);
            var O = this.__filtered__ && !u ? new ir(this) : this.clone();
            return O.__filtered__ ? O.__takeCount__ = zn(_, O.__takeCount__) : O.__views__.push({
              size: zn(_, re),
              type: a + (O.__dir__ < 0 ? "Right" : "")
            }), O;
          }, ir.prototype[a + "Right"] = function(_) {
            return this.reverse()[a](_).reverse();
          };
        }), $n(["filter", "map", "takeWhile"], function(a, u) {
          var _ = u + 1, O = _ == Oe || _ == de;
          ir.prototype[a] = function(j) {
            var U = this.clone();
            return U.__iteratees__.push({
              iteratee: Ot(j, 3),
              type: _
            }), U.__filtered__ = U.__filtered__ || O, U;
          };
        }), $n(["head", "last"], function(a, u) {
          var _ = "take" + (u ? "Right" : "");
          ir.prototype[a] = function() {
            return this[_](1).value()[0];
          };
        }), $n(["initial", "tail"], function(a, u) {
          var _ = "drop" + (u ? "" : "Right");
          ir.prototype[a] = function() {
            return this.__filtered__ ? new ir(this) : this[_](1);
          };
        }), ir.prototype.compact = function() {
          return this.filter(ii);
        }, ir.prototype.find = function(a) {
          return this.filter(a).head();
        }, ir.prototype.findLast = function(a) {
          return this.reverse().find(a);
        }, ir.prototype.invokeMap = Xt(function(a, u) {
          return typeof a == "function" ? new ir(this) : this.map(function(_) {
            return wu(_, a, u);
          });
        }), ir.prototype.reject = function(a) {
          return this.filter(Wd(Ot(a)));
        }, ir.prototype.slice = function(a, u) {
          a = Vt(a);
          var _ = this;
          return _.__filtered__ && (a > 0 || u < 0) ? new ir(_) : (a < 0 ? _ = _.takeRight(-a) : a && (_ = _.drop(a)), u !== r && (u = Vt(u), _ = u < 0 ? _.dropRight(-u) : _.take(u - a)), _);
        }, ir.prototype.takeRightWhile = function(a) {
          return this.reverse().takeWhile(a).reverse();
        }, ir.prototype.toArray = function() {
          return this.take(re);
        }, So(ir.prototype, function(a, u) {
          var _ = /^(?:filter|find|map|reject)|While$/.test(u), O = /^(?:head|last)$/.test(u), j = $[O ? "take" + (u == "last" ? "Right" : "") : u], U = O || /^find/.test(u);
          j && ($.prototype[u] = function() {
            var te = this.__wrapped__, se = O ? [1] : arguments, we = te instanceof ir, Ge = se[0], qe = we || Wt(te), Je = function(tr) {
              var ar = j.apply($, Ir([tr], se));
              return O && st ? ar[0] : ar;
            };
            qe && _ && typeof Ge == "function" && Ge.length != 1 && (we = qe = !1);
            var st = this.__chain__, wt = !!this.__actions__.length, Dt = U && !st, Yt = we && !wt;
            if (!U && qe) {
              te = Yt ? te : new ir(this);
              var Pt = a.apply(te, se);
              return Pt.__actions__.push({ func: Ld, args: [Je], thisArg: r }), new Ai(Pt, st);
            }
            return Dt && Yt ? a.apply(this, se) : (Pt = this.thru(Je), Dt ? O ? Pt.value()[0] : Pt.value() : Pt);
          });
        }), $n(["pop", "push", "shift", "sort", "splice", "unshift"], function(a) {
          var u = ud[a], _ = /^(?:push|sort|unshift)$/.test(a) ? "tap" : "thru", O = /^(?:pop|shift)$/.test(a);
          $.prototype[a] = function() {
            var j = arguments;
            if (O && !this.__chain__) {
              var U = this.value();
              return u.apply(Wt(U) ? U : [], j);
            }
            return this[_](function(te) {
              return u.apply(Wt(te) ? te : [], j);
            });
          };
        }), So(ir.prototype, function(a, u) {
          var _ = $[u];
          if (_) {
            var O = _.name + "";
            _r.call(tl, O) || (tl[O] = []), tl[O].push({ name: u, func: _ });
          }
        }), tl[Dd(r, C).name] = [{
          name: "wrapper",
          func: r
        }], ir.prototype.clone = HO, ir.prototype.reverse = $O, ir.prototype.value = UO, $.prototype.at = bD, $.prototype.chain = wD, $.prototype.commit = xD, $.prototype.next = _D, $.prototype.plant = ED, $.prototype.reverse = CD, $.prototype.toJSON = $.prototype.valueOf = $.prototype.value = TD, $.prototype.first = $.prototype.head, pu && ($.prototype[pu] = SD), $;
      }, ze = Le();
      Hn ? ((Hn.exports = ze)._ = ze, yt._ = ze) : Vr._ = ze;
    }).call(dz);
  }(tc, tc.exports)), tc.exports;
}
var li = fz();
const pz = /* @__PURE__ */ jr(li), hz = Rt(() => ({
  wrapper: {
    position: "relative"
  },
  textField: {
    width: "100%"
  },
  arrowIconStandard: {
    position: "absolute",
    right: -3,
    top: 10
  },
  crossIconStandard: {
    position: "absolute",
    right: -1,
    top: 10
  },
  arrowIconOutlined: {
    position: "absolute",
    right: 5,
    top: "50%",
    transform: "translateY(-50%)"
  },
  crossIconOutlined: {
    position: "absolute",
    right: 7,
    top: "50%",
    transform: "translateY(-50%)"
  }
})), gz = ({
  className: e,
  disabled: t,
  fetchList: r,
  label: n,
  mandatoryInput: i,
  onChange: o,
  value: s,
  variant: l = "standard",
  TextFieldProps: c,
  startingIcon: f,
  sx: h
}) => {
  const g = bt(null), [S, b] = Xe(void 0), [p, v] = Xe(!1), [w, C] = Xe(void 0), [M, L] = Xe(!1), [W, z] = Xe(-1), [B, K] = Xe(""), Z = hz(), ee = Wc(B, 500), he = p && !t && !!(!i || ee), _e = Kt(
    (ye) => {
      const { value: de = "" } = (ye == null ? void 0 : ye.target) || {};
      K(de), !p && v(!0);
    },
    [p]
  ), Te = Kt(() => {
    _e(), o == null || o(void 0), v(!1);
  }, [_e, o]), fe = Kt(
    (ye, de = w, ce) => {
      if (de != null && de.length) {
        const Fe = de.map((J) => ({
          ...J,
          selected: (ye == null ? void 0 : ye.id) === J.id
        })), le = ye ? { ...ye, selected: !0 } : void 0;
        C(Fe), !ce && (o == null || o(le));
      }
    },
    [w, o]
  ), Oe = Kt(
    (ye) => {
      var de;
      if (w != null && w.length) {
        const Fe = w.findIndex((re) => re.selected), le = Fe !== -1, J = le ? Fe : 0;
        switch (ye.key) {
          case "ArrowDown": {
            const re = li.findIndex(
              w,
              (Ae, Re) => (!le || Re !== J) && !Ae.disabled,
              J
            );
            if (!p && re !== -1) {
              v(!0);
              break;
            }
            const be = Fe === w.length - 1, Me = w.map((Ae, Re) => ({
              ...Ae,
              selected: be && !Re || re === Re
            }));
            C(Me), z(be ? 0 : re);
            break;
          }
          case "ArrowUp": {
            const re = li.findLastIndex(
              w,
              (Re, Ee) => Ee !== J && !Re.disabled,
              J
            );
            if (!p && re !== -1) {
              v(!0);
              break;
            }
            const be = w.length - 1, Me = re === -1, Ae = w.map((Re, Ee) => ({
              ...Re,
              selected: Me && be === Ee || re === Ee
            }));
            C(Ae), z(Me ? be : re);
            break;
          }
          case "Enter": {
            le && (fe(w[Fe]), v(!1));
            break;
          }
          case "Tab": {
            const re = w.findIndex((be) => be.id === (s == null ? void 0 : s.id)) || 0;
            (de = ye.target) != null && de.value.length ? le && fe(s) : Te(), z(re), v(!1);
            break;
          }
        }
      }
    },
    [p, Te, fe, w, s]
  );
  return pt(() => {
    he && r && (b(void 0), L(!0), r(ee).then((ye) => {
      fe(s, ye, !0);
    }).catch(b).finally(() => {
      L(!1);
    }));
  }, [he, ee, r]), pt(() => {
    K(typeof (s == null ? void 0 : s.label) == "string" ? s.label : "");
  }, [s]), /* @__PURE__ */ y.jsxs(
    zt,
    {
      className: nt(Z.wrapper, e),
      "data-testid": "auto-complete-container",
      ref: g,
      sx: h,
      children: [
        /* @__PURE__ */ y.jsx(
          ln,
          {
            className: Z.textField,
            disabled: t,
            label: n,
            onChange: _e,
            onFocus: () => v(!0),
            onKeyDown: Oe,
            value: B,
            variant: l,
            ...c,
            InputProps: f && {
              startAdornment: /* @__PURE__ */ y.jsx(hE, { position: "start", children: f })
            }
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "div",
          {
            onFocus: (ye) => {
              ye.stopPropagation();
            },
            children: [
              !i && !B && /* @__PURE__ */ y.jsx(
                fr,
                {
                  classes: {
                    root: nt(
                      l === "standard" && Z.arrowIconStandard,
                      (l === "outlined" || l === "filled") && Z.arrowIconOutlined
                    )
                  },
                  disabled: t,
                  size: "small",
                  onClick: () => {
                    v((ye) => !ye);
                  },
                  children: he ? /* @__PURE__ */ y.jsx(ym, {}) : /* @__PURE__ */ y.jsx(Lc, {})
                }
              ),
              B && /* @__PURE__ */ y.jsx(
                fr,
                {
                  classes: {
                    root: nt(
                      l === "standard" && Z.crossIconStandard,
                      (l === "outlined" || l === "filled") && Z.crossIconOutlined
                    )
                  },
                  disabled: t,
                  onClick: Te,
                  size: "small",
                  children: /* @__PURE__ */ y.jsx(gc, { fontSize: "small" })
                }
              ),
              /* @__PURE__ */ y.jsx(
                Wm,
                {
                  anchorRef: g,
                  error: S,
                  list: w,
                  loading: M,
                  onClose: () => {
                    fe(s), v(!1);
                  },
                  onSelect: (ye) => {
                    fe(ye), v(!1);
                  },
                  open: he,
                  scrollToItem: W
                }
              )
            ]
          }
        )
      ]
    }
  );
}, vz = Rt((e) => ({
  innerWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(1.5)
  },
  wrapper: {
    alignItems: "end",
    bottom: 0,
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: ({ isWindowScroll: t }) => t ? e.spacing(2) : 0,
    marginRight: ({ isWindowScroll: t }) => t ? e.spacing(2) : e.spacing(4),
    marginTop: ({ isWindowScroll: t, wrapperHeight: r }) => t ? 0 : `-${r}px`,
    pointerEvents: "none",
    position: ({ isWindowScroll: t }) => t ? "fixed" : "sticky",
    right: 0,
    "& > div": {
      pointerEvents: "all"
    }
  },
  button: {
    backgroundColor: e.palette.grey[200],
    borderRadius: e.shape.borderRadius,
    opacity: ".35",
    pointerEvents: "none",
    transition: "opacity .25s"
  },
  bottomIsShown: {
    opacity: "1",
    pointerEvents: "initial"
  },
  topIsShown: {
    opacity: "1",
    pointerEvents: "initial"
  }
})), Nw = 150, jw = 0, Lh = (e) => "scrollY" in e, BJ = ({
  className: e,
  elementToScrollRef: t,
  bottom: r = {},
  top: n = {}
}) => {
  var v;
  const i = kt(
    () => ({
      icon: /* @__PURE__ */ y.jsx(pN, { fontSize: "inherit" }),
      isActive: (r == null ? void 0 : r.isActive) || !!r,
      isAnimate: !0,
      offset: Nw,
      scrollTo: jw,
      ...r
    }),
    [r]
  ), o = kt(
    () => ({
      icon: /* @__PURE__ */ y.jsx(hN, { fontSize: "inherit" }),
      isActive: (n == null ? void 0 : n.isActive) || !!n,
      isAnimate: !0,
      offset: Nw,
      scrollTo: jw,
      ...n
    }),
    [n]
  ), s = bt(null), l = (t == null ? void 0 : t.current) || window, c = vz({
    isWindowScroll: !(t != null && t.current),
    wrapperHeight: ((v = s == null ? void 0 : s.current) == null ? void 0 : v.clientHeight) || 0
  }), [f, h] = Xe({
    bottom: !0,
    top: !1
  }), g = Kt(() => {
    const w = Lh(l) ? document.documentElement.scrollHeight - l.innerHeight - i.scrollTo : l.scrollHeight - l.clientHeight - i.scrollTo;
    l.scrollTo({
      left: 0,
      behavior: i.isAnimate ? "smooth" : "auto",
      top: w
    });
  }, [l, i.isAnimate, i.scrollTo]), S = Kt(() => {
    const w = o.scrollTo;
    l.scrollTo({
      left: 0,
      behavior: o.isAnimate ? "smooth" : "auto",
      top: w
    });
  }, [l, o.isAnimate, o.scrollTo]), b = Kt(() => {
    const w = Lh(l) ? l.scrollY : l.scrollTop, C = Lh(l) ? document.documentElement.scrollHeight - l.innerHeight - w : l.scrollHeight - l.clientHeight - w, M = C >= i.offset && C > i.scrollTo, L = w >= o.offset && w > o.scrollTo;
    h({
      bottom: M,
      top: L
    });
  }, [
    l,
    i.offset,
    i.scrollTo,
    o.offset,
    o.scrollTo
  ]), p = pz.debounce(b, 200);
  return pt(() => (l && (i.isActive || o.isActive) ? l == null || l.addEventListener("scroll", p) : l == null || l.removeEventListener("scroll", p), () => {
    l == null || l.removeEventListener("scroll", p);
  }), [
    l,
    i.isActive,
    p,
    o.isActive
  ]), !o.isActive && !i.isActive ? /* @__PURE__ */ y.jsx(fE, {}) : /* @__PURE__ */ y.jsx("div", { className: c.wrapper, children: /* @__PURE__ */ y.jsxs(
    "div",
    {
      className: nt(c.innerWrapper, e),
      ref: s,
      children: [
        o.isActive && /* @__PURE__ */ y.jsx(
          fr,
          {
            "data-testid": "back-to-top",
            disableFocusRipple: !0,
            className: nt(
              c.button,
              { [c.topIsShown]: f.top },
              o.className
            ),
            onClick: S,
            children: o.icon
          }
        ),
        i.isActive && /* @__PURE__ */ y.jsx(
          fr,
          {
            "data-testid": "back-to-bottom",
            disableFocusRipple: !0,
            className: nt(
              c.button,
              { [c.bottomIsShown]: f.bottom },
              i.className
            ),
            onClick: g,
            children: i.icon
          }
        )
      ]
    }
  ) });
}, mz = Rt((e) => ({
  buttonRoot: {
    paddingLeft: e.spacing(2),
    paddingRight: e.spacing(2),
    flexShrink: 0
  },
  buttonLabel: ({ dark: t }) => ({
    textTransform: "none",
    fontSize: 20,
    color: t ? e.palette.common.black : e.palette.common.white
  }),
  menuItem: {
    fontSize: 20,
    height: 51,
    paddingLeft: e.spacing(4),
    paddingRight: e.spacing(4)
  },
  defaultLabel: {
    opacity: 0.5
  },
  buttonIcon: ({ dark: t }) => ({
    opacity: t ? 0.54 : 0.7,
    marginRight: e.spacing(1),
    display: "flex",
    alignItems: "center"
  }),
  menuItemIcon: {
    minWidth: 0,
    marginRight: e.spacing(2)
  }
})), Hm = Ac(void 0), FJ = () => {
  const e = qi(Hm);
  if (!e)
    throw new Error("You need to wrap MenuDisplay inside MenuProvider");
  const { menuOpen: t, menuAnchorEl: r, menuContent: n, menuProps: i, closeMenu: o } = e;
  return /* @__PURE__ */ y.jsx(
    zA,
    {
      ...i || {},
      open: t,
      anchorEl: r,
      onClose: o,
      children: n
    }
  );
}, WJ = ({
  children: e,
  ...t
}) => {
  const [r, n] = Xe(!1), [i, o] = Xe(null), [s, l] = Xe(null), [c, f] = Xe({}), h = (S, b, p) => {
    o(S), l(b), f(p || {}), n(!0);
  }, g = () => {
    n(!1), setTimeout(() => {
      o(null), l(null);
    }, 200);
  };
  return /* @__PURE__ */ y.jsx(
    Hm.Provider,
    {
      value: {
        openMenu: h,
        closeMenu: g,
        menuOpen: r,
        menuAnchorEl: i,
        menuContent: s,
        menuProps: { ...t, ...c }
      },
      children: e
    }
  );
}, Xl = () => {
  const e = qi(Hm);
  if (!e)
    throw new Error("You need to wrap useMenu inside MenuProvider");
  const { openMenu: t, closeMenu: r } = e;
  return { openMenu: t, closeMenu: r };
}, HJ = ({
  items: e,
  onItemSelect: t,
  defaultLabel: r,
  dark: n
}) => {
  const i = mz({ dark: n }), { openMenu: o, closeMenu: s } = Xl(), l = e.find(({ selected: c }) => c);
  return /* @__PURE__ */ y.jsx(
    Fr,
    {
      classes: { root: i.buttonRoot, text: i.buttonLabel },
      size: "large",
      startIcon: (l == null ? void 0 : l.icon) && /* @__PURE__ */ y.jsx(
        "div",
        {
          className: i.buttonIcon,
          style: {
            color: l == null ? void 0 : l.color,
            opacity: l != null && l.color ? 0.7 : void 0
          },
          children: l == null ? void 0 : l.icon
        }
      ),
      endIcon: /* @__PURE__ */ y.jsx(Lc, { fontSize: "large" }),
      onClick: (c) => {
        o(
          c.currentTarget,
          e.map((f, h) => /* @__PURE__ */ y.jsxs(
            la,
            {
              classes: { root: i.menuItem },
              style: { color: f.color },
              selected: f.selected,
              disabled: f.disabled,
              onClick: () => {
                s(), t && t(f);
              },
              children: [
                f.icon && /* @__PURE__ */ y.jsx(
                  Va,
                  {
                    classes: { root: i.menuItemIcon },
                    style: {
                      color: f.color,
                      opacity: f.color ? 0.7 : void 0
                    },
                    children: f.icon
                  }
                ),
                f.label
              ]
            },
            f.id || `menu-item-${h}`
          ))
        );
      },
      children: l != null && l.label ? /* @__PURE__ */ y.jsx("span", { style: { color: l == null ? void 0 : l.color }, children: l == null ? void 0 : l.label }) : /* @__PURE__ */ y.jsx("span", { className: i.defaultLabel, children: r || "-" })
    }
  );
}, yz = {
  700: "#ffa000"
};
function Fl(e) {
  "@babel/helpers - typeof";
  return Fl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fl(e);
}
function Mr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Mt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Nt(e) {
  Mt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Fl(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function xC(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Mr(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function bz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Mr(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var i = r.getDate(), o = new Date(r.getTime());
  o.setMonth(r.getMonth() + n + 1, 0);
  var s = o.getDate();
  return i >= s ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), i), r);
}
function Cl(e, t) {
  if (Mt(2, arguments), !t || Fl(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var r = t.years ? Mr(t.years) : 0, n = t.months ? Mr(t.months) : 0, i = t.weeks ? Mr(t.weeks) : 0, o = t.days ? Mr(t.days) : 0, s = t.hours ? Mr(t.hours) : 0, l = t.minutes ? Mr(t.minutes) : 0, c = t.seconds ? Mr(t.seconds) : 0, f = Nt(e), h = n || r ? bz(f, n + r * 12) : f, g = o || i ? xC(h, o + i * 7) : h, S = l + s * 60, b = c + S * 60, p = b * 1e3, v = new Date(g.getTime() + p);
  return v;
}
function wz(e) {
  return Mt(1, arguments), Nt(e).getDay() === 0;
}
function xz(e, t) {
  Mt(2, arguments);
  var r = Nt(e).getTime(), n = Mr(t);
  return new Date(r + n);
}
var _z = {};
function Ws() {
  return _z;
}
function kw(e, t) {
  var r, n, i, o, s, l, c, f;
  Mt(1, arguments);
  var h = Ws(), g = Mr((r = (n = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : h.weekStartsOn) !== null && n !== void 0 ? n : (c = h.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var S = Nt(e), b = S.getDay(), p = (b < g ? 7 : 0) + b - g;
  return S.setDate(S.getDate() - p), S.setHours(0, 0, 0, 0), S;
}
function pv(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Of(e) {
  Mt(1, arguments);
  var t = Nt(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Sz = 864e5;
function Ez(e, t) {
  Mt(2, arguments);
  var r = Of(e), n = Of(t), i = r.getTime() - pv(r), o = n.getTime() - pv(n);
  return Math.round((i - o) / Sz);
}
function Ml(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t), i = r.getTime() - n.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
var Cz = 6e4, Tz = 36e5;
function Oz(e, t) {
  Mt(2, arguments);
  var r = Of(e), n = Of(t);
  return r.getTime() === n.getTime();
}
function Rz(e) {
  return Mt(1, arguments), e instanceof Date || Fl(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function hv(e) {
  if (Mt(1, arguments), !Rz(e) && typeof e != "number")
    return !1;
  var t = Nt(e);
  return !isNaN(Number(t));
}
function Iz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t), i = r.getFullYear() - n.getFullYear(), o = r.getMonth() - n.getMonth();
  return i * 12 + o;
}
function Dz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t);
  return r.getFullYear() - n.getFullYear();
}
function Lw(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function Pz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t), i = Lw(r, n), o = Math.abs(Ez(r, n));
  r.setDate(r.getDate() - i * o);
  var s = +(Lw(r, n) === -i), l = i * (o - s);
  return l === 0 ? 0 : l;
}
function $m(e, t) {
  return Mt(2, arguments), Nt(e).getTime() - Nt(t).getTime();
}
var Mz = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, Az = "trunc";
function Um(e) {
  return Mz[Az];
}
function Nz(e, t, r) {
  Mt(2, arguments);
  var n = $m(e, t) / Tz;
  return Um()(n);
}
function jz(e, t, r) {
  Mt(2, arguments);
  var n = $m(e, t) / Cz;
  return Um()(n);
}
function kz(e) {
  Mt(1, arguments);
  var t = Nt(e);
  return t.setHours(23, 59, 59, 999), t;
}
function Lz(e) {
  Mt(1, arguments);
  var t = Nt(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function _C(e) {
  Mt(1, arguments);
  var t = Nt(e);
  return kz(t).getTime() === Lz(t).getTime();
}
function zz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t), i = Ml(r, n), o = Math.abs(Iz(r, n)), s;
  if (o < 1)
    s = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - i * o);
    var l = Ml(r, n) === -i;
    _C(Nt(e)) && o === 1 && Ml(e, n) === 1 && (l = !1), s = i * (o - Number(l));
  }
  return s === 0 ? 0 : s;
}
function Bz(e, t, r) {
  Mt(2, arguments);
  var n = $m(e, t) / 1e3;
  return Um()(n);
}
function Fz(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t), i = Ml(r, n), o = Math.abs(Dz(r, n));
  r.setFullYear(1584), n.setFullYear(1584);
  var s = Ml(r, n) === -i, l = i * (o - Number(s));
  return l === 0 ? 0 : l;
}
function zw(e) {
  Mt(1, arguments);
  var t = Nt(e);
  return t.setSeconds(0, 0), t;
}
function Wz(e, t) {
  Mt(2, arguments);
  var r = Mr(t);
  return xz(e, -r);
}
var Hz = 864e5;
function $z(e) {
  Mt(1, arguments);
  var t = Nt(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / Hz) + 1;
}
function Rf(e) {
  Mt(1, arguments);
  var t = 1, r = Nt(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function SC(e) {
  Mt(1, arguments);
  var t = Nt(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = Rf(n), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var s = Rf(o);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= s.getTime() ? r : r - 1;
}
function Uz(e) {
  Mt(1, arguments);
  var t = SC(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Rf(r);
  return n;
}
var Gz = 6048e5;
function qz(e) {
  Mt(1, arguments);
  var t = Nt(e), r = Rf(t).getTime() - Uz(t).getTime();
  return Math.round(r / Gz) + 1;
}
function If(e, t) {
  var r, n, i, o, s, l, c, f;
  Mt(1, arguments);
  var h = Ws(), g = Mr((r = (n = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : h.weekStartsOn) !== null && n !== void 0 ? n : (c = h.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var S = Nt(e), b = S.getUTCDay(), p = (b < g ? 7 : 0) + b - g;
  return S.setUTCDate(S.getUTCDate() - p), S.setUTCHours(0, 0, 0, 0), S;
}
function EC(e, t) {
  var r, n, i, o, s, l, c, f;
  Mt(1, arguments);
  var h = Nt(e), g = h.getUTCFullYear(), S = Ws(), b = Mr((r = (n = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : S.firstWeekContainsDate) !== null && n !== void 0 ? n : (c = S.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(b >= 1 && b <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(g + 1, 0, b), p.setUTCHours(0, 0, 0, 0);
  var v = If(p, t), w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(g, 0, b), w.setUTCHours(0, 0, 0, 0);
  var C = If(w, t);
  return h.getTime() >= v.getTime() ? g + 1 : h.getTime() >= C.getTime() ? g : g - 1;
}
function Vz(e, t) {
  var r, n, i, o, s, l, c, f;
  Mt(1, arguments);
  var h = Ws(), g = Mr((r = (n = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && n !== void 0 ? n : (c = h.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), S = EC(e, t), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(S, 0, g), b.setUTCHours(0, 0, 0, 0);
  var p = If(b, t);
  return p;
}
var Yz = 6048e5;
function Kz(e, t) {
  Mt(1, arguments);
  var r = Nt(e), n = If(r, t).getTime() - Vz(r, t).getTime();
  return Math.round(n / Yz) + 1;
}
function Sr(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Ia = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
    return Sr(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : Sr(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return Sr(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return Sr(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return Sr(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return Sr(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return Sr(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, i = t.getUTCMilliseconds(), o = Math.floor(i * Math.pow(10, n - 3));
    return Sr(o, r.length);
  }
}, hl = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Xz = {
  // Era
  G: function(t, r, n) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(i, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var i = t.getUTCFullYear(), o = i > 0 ? i : 1 - i;
      return n.ordinalNumber(o, {
        unit: "year"
      });
    }
    return Ia.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, i) {
    var o = EC(t, i), s = o > 0 ? o : 1 - o;
    if (r === "YY") {
      var l = s % 100;
      return Sr(l, 2);
    }
    return r === "Yo" ? n.ordinalNumber(s, {
      unit: "year"
    }) : Sr(s, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = SC(t);
    return Sr(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return Sr(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Sr(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Sr(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Ia.M(t, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var i = t.getUTCMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Sr(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, i) {
    var o = Kz(t, i);
    return r === "wo" ? n.ordinalNumber(o, {
      unit: "week"
    }) : Sr(o, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var i = qz(t);
    return r === "Io" ? n.ordinalNumber(i, {
      unit: "week"
    }) : Sr(i, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ia.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var i = $z(t);
    return r === "Do" ? n.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : Sr(i, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var i = t.getUTCDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, i) {
    var o = t.getUTCDay(), s = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return Sr(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, i) {
    var o = t.getUTCDay(), s = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return Sr(s, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var i = t.getUTCDay(), o = i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Sr(o, r.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var i = t.getUTCHours(), o = i / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var i = t.getUTCHours(), o;
    switch (i === 12 ? o = hl.noon : i === 0 ? o = hl.midnight : o = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var i = t.getUTCHours(), o;
    switch (i >= 17 ? o = hl.evening : i >= 12 ? o = hl.afternoon : i >= 4 ? o = hl.morning : o = hl.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Ia.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ia.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var i = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : Sr(i, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), r === "ko" ? n.ordinalNumber(i, {
      unit: "hour"
    }) : Sr(i, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ia.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ia.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Ia.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, i) {
    var o = i._originalDate || t, s = o.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return Fw(s);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Es(s);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Es(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, i) {
    var o = i._originalDate || t, s = o.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return Fw(s);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Es(s);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Es(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, i) {
    var o = i._originalDate || t, s = o.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bw(s, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Es(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, i) {
    var o = i._originalDate || t, s = o.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bw(s, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Es(s, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, i) {
    var o = i._originalDate || t, s = Math.floor(o.getTime() / 1e3);
    return Sr(s, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, i) {
    var o = i._originalDate || t, s = o.getTime();
    return Sr(s, r.length);
  }
};
function Bw(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), o = n % 60;
  if (o === 0)
    return r + String(i);
  var s = t;
  return r + String(i) + s + Sr(o, 2);
}
function Fw(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + Sr(Math.abs(e) / 60, 2);
  }
  return Es(e, t);
}
function Es(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), o = Sr(Math.floor(i / 60), 2), s = Sr(i % 60, 2);
  return n + o + r + s;
}
var Ww = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, CC = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, Jz = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], i = n[1], o = n[2];
  if (!o)
    return Ww(t, r);
  var s;
  switch (i) {
    case "P":
      s = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = r.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", Ww(i, r)).replace("{{time}}", CC(o, r));
}, Zz = {
  p: CC,
  P: Jz
}, Qz = ["D", "DD"], eB = ["YY", "YYYY"];
function tB(e) {
  return Qz.indexOf(e) !== -1;
}
function rB(e) {
  return eB.indexOf(e) !== -1;
}
function Hw(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var nB = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, iB = function(t, r, n) {
  var i, o = nB[t];
  return typeof o == "string" ? i = o : r === 1 ? i = o.one : i = o.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Al(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var oB = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, aB = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, sB = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lB = {
  date: Al({
    formats: oB,
    defaultWidth: "full"
  }),
  time: Al({
    formats: aB,
    defaultWidth: "full"
  }),
  dateTime: Al({
    formats: sB,
    defaultWidth: "full"
  })
}, uB = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, cB = function(t, r, n, i) {
  return uB[t];
};
function Io(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      i = e.formattingValues[s] || e.formattingValues[o];
    } else {
      var l = e.defaultWidth, c = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[c] || e.values[l];
    }
    var f = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[f];
  };
}
var dB = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fB = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, pB = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, hB = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, gB = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, vB = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, mB = function(t, r) {
  var n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, yB = {
  ordinalNumber: mB,
  era: Io({
    values: dB,
    defaultWidth: "wide"
  }),
  quarter: Io({
    values: fB,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Io({
    values: pB,
    defaultWidth: "wide"
  }),
  day: Io({
    values: hB,
    defaultWidth: "wide"
  }),
  dayPeriod: Io({
    values: gB,
    defaultWidth: "wide",
    formattingValues: vB,
    defaultFormattingWidth: "wide"
  })
};
function Do(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var s = o[0], l = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(l) ? wB(l, function(g) {
      return g.test(s);
    }) : bB(l, function(g) {
      return g.test(s);
    }), f;
    f = e.valueCallback ? e.valueCallback(c) : c, f = r.valueCallback ? r.valueCallback(f) : f;
    var h = t.slice(s.length);
    return {
      value: f,
      rest: h
    };
  };
}
function bB(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function wB(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function TC(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var i = n[0], o = t.match(e.parsePattern);
    if (!o) return null;
    var s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = r.valueCallback ? r.valueCallback(s) : s;
    var l = t.slice(i.length);
    return {
      value: s,
      rest: l
    };
  };
}
var xB = /^(\d+)(th|st|nd|rd)?/i, _B = /\d+/i, SB = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, EB = {
  any: [/^b/i, /^(a|c)/i]
}, CB = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, TB = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, OB = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, RB = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, IB = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, DB = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, PB = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, MB = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, AB = {
  ordinalNumber: TC({
    matchPattern: xB,
    parsePattern: _B,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Do({
    matchPatterns: SB,
    defaultMatchWidth: "wide",
    parsePatterns: EB,
    defaultParseWidth: "any"
  }),
  quarter: Do({
    matchPatterns: CB,
    defaultMatchWidth: "wide",
    parsePatterns: TB,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Do({
    matchPatterns: OB,
    defaultMatchWidth: "wide",
    parsePatterns: RB,
    defaultParseWidth: "any"
  }),
  day: Do({
    matchPatterns: IB,
    defaultMatchWidth: "wide",
    parsePatterns: DB,
    defaultParseWidth: "any"
  }),
  dayPeriod: Do({
    matchPatterns: PB,
    defaultMatchWidth: "any",
    parsePatterns: MB,
    defaultParseWidth: "any"
  })
}, OC = {
  code: "en-US",
  formatDistance: iB,
  formatLong: lB,
  formatRelative: cB,
  localize: yB,
  match: AB,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, NB = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jB = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, kB = /^'([^]*?)'?$/, LB = /''/g, zB = /[a-zA-Z]/;
function _c(e, t, r) {
  var n, i, o, s, l, c, f, h, g, S, b, p, v, w, C, M, L, W;
  Mt(2, arguments);
  var z = String(t), B = Ws(), K = (n = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : B.locale) !== null && n !== void 0 ? n : OC, Z = Mr((o = (s = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (f = r.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && l !== void 0 ? l : B.firstWeekContainsDate) !== null && s !== void 0 ? s : (g = B.locale) === null || g === void 0 || (S = g.options) === null || S === void 0 ? void 0 : S.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(Z >= 1 && Z <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ee = Mr((b = (p = (v = (w = r == null ? void 0 : r.weekStartsOn) !== null && w !== void 0 ? w : r == null || (C = r.locale) === null || C === void 0 || (M = C.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && v !== void 0 ? v : B.weekStartsOn) !== null && p !== void 0 ? p : (L = B.locale) === null || L === void 0 || (W = L.options) === null || W === void 0 ? void 0 : W.weekStartsOn) !== null && b !== void 0 ? b : 0);
  if (!(ee >= 0 && ee <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!K.localize)
    throw new RangeError("locale must contain localize property");
  if (!K.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var he = Nt(e);
  if (!hv(he))
    throw new RangeError("Invalid time value");
  var _e = pv(he), Te = Wz(he, _e), fe = {
    firstWeekContainsDate: Z,
    weekStartsOn: ee,
    locale: K,
    _originalDate: he
  }, Oe = z.match(jB).map(function(ye) {
    var de = ye[0];
    if (de === "p" || de === "P") {
      var ce = Zz[de];
      return ce(ye, K.formatLong);
    }
    return ye;
  }).join("").match(NB).map(function(ye) {
    if (ye === "''")
      return "'";
    var de = ye[0];
    if (de === "'")
      return BB(ye);
    var ce = Xz[de];
    if (ce)
      return !(r != null && r.useAdditionalWeekYearTokens) && rB(ye) && Hw(ye, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && tB(ye) && Hw(ye, t, String(e)), ce(Te, ye, K.localize, fe);
    if (de.match(zB))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + de + "`");
    return ye;
  }).join("");
  return Oe;
}
function BB(e) {
  var t = e.match(kB);
  return t ? t[1].replace(LB, "'") : e;
}
var FB = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
function WB(e, t) {
  var r, n, i, o, s;
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  var l = Ws(), c = (r = (n = void 0) !== null && n !== void 0 ? n : l.locale) !== null && r !== void 0 ? r : OC, f = (i = void 0) !== null && i !== void 0 ? i : FB, h = (o = void 0) !== null && o !== void 0 ? o : !1, g = (s = void 0) !== null && s !== void 0 ? s : " ";
  if (!c.formatDistance)
    return "";
  var S = f.reduce(function(b, p) {
    var v = "x".concat(p.replace(/(^.)/, function(C) {
      return C.toUpperCase();
    })), w = e[p];
    return typeof w == "number" && (h || e[p]) ? b.concat(c.formatDistance(v, w)) : b;
  }, []).join(g);
  return S;
}
function HB(e) {
  Mt(1, arguments);
  var t = Nt(e), r = t.getFullYear(), n = t.getMonth(), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(r, n + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function $B(e) {
  Mt(1, arguments);
  var t = Nt(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function UB(e) {
  Mt(1, arguments);
  var t = Nt(e.start), r = Nt(e.end);
  if (isNaN(t.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(r.getTime())) throw new RangeError("End Date is invalid");
  var n = {};
  n.years = Math.abs(Fz(r, t));
  var i = Ml(r, t), o = Cl(t, {
    years: i * n.years
  });
  n.months = Math.abs(zz(r, o));
  var s = Cl(o, {
    months: i * n.months
  });
  n.days = Math.abs(Pz(r, s));
  var l = Cl(s, {
    days: i * n.days
  });
  n.hours = Math.abs(Nz(r, l));
  var c = Cl(l, {
    hours: i * n.hours
  });
  n.minutes = Math.abs(jz(r, c));
  var f = Cl(c, {
    minutes: i * n.minutes
  });
  return n.seconds = Math.abs(Bz(r, f)), n;
}
function GB(e) {
  return Mt(1, arguments), Nt(e).getDate() === 1;
}
function qB(e) {
  return Mt(1, arguments), Nt(e).getDay() === 1;
}
function $w(e, t, r) {
  Mt(2, arguments);
  var n = kw(e, r), i = kw(t, r);
  return n.getTime() === i.getTime();
}
function VB(e, t) {
  Mt(2, arguments);
  var r = zw(e), n = zw(t);
  return r.getTime() === n.getTime();
}
function Uw(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Nt(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function Gw(e) {
  return Mt(1, arguments), Oz(e, Date.now());
}
function YB(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Mr(t), i = r.getFullYear(), o = r.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(i, n, 15), s.setHours(0, 0, 0, 0);
  var l = HB(s);
  return r.setMonth(n, Math.min(o, l)), r;
}
function KB(e, t) {
  if (Mt(2, arguments), Fl(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var r = Nt(e);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = YB(r, t.month)), t.date != null && r.setDate(Mr(t.date)), t.hours != null && r.setHours(Mr(t.hours)), t.minutes != null && r.setMinutes(Mr(t.minutes)), t.seconds != null && r.setSeconds(Mr(t.seconds)), t.milliseconds != null && r.setMilliseconds(Mr(t.milliseconds)), r);
}
function XB(e, t) {
  Mt(2, arguments);
  var r = Nt(e), n = Mr(t);
  return r.setDate(n), r;
}
function qw(e, t, r) {
  var n, i, o, s, l, c, f, h;
  Mt(2, arguments);
  var g = Ws(), S = Mr((n = (i = (o = (s = r == null ? void 0 : r.weekStartsOn) !== null && s !== void 0 ? s : r == null || (l = r.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && o !== void 0 ? o : g.weekStartsOn) !== null && i !== void 0 ? i : (f = g.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var b = Nt(e), p = Mr(t), v = b.getDay(), w = p % 7, C = (w + 7) % 7, M = 7 - S, L = p < 0 || p > 6 ? p - (v + M) % 7 : (C + M) % 7 - (v + M) % 7;
  return xC(b, L);
}
var JB = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, ZB = function(t, r, n) {
  var i, o = JB[t];
  return typeof o == "string" ? i = o : r === 1 ? i = o.one : i = o.other.replace("{{count}}", String(r)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + i : "il y a " + i : i;
}, QB = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, eF = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, tF = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rF = {
  date: Al({
    formats: QB,
    defaultWidth: "full"
  }),
  time: Al({
    formats: eF,
    defaultWidth: "full"
  }),
  dateTime: Al({
    formats: tF,
    defaultWidth: "full"
  })
}, nF = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, iF = function(t, r, n, i) {
  return nF[t];
}, oF = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, aF = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, sF = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, lF = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, uF = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, cF = function(t, r) {
  var n = Number(t), i = r == null ? void 0 : r.unit;
  if (n === 0) return "0";
  var o = ["year", "week", "hour", "minute", "second"], s;
  return n === 1 ? s = i && o.includes(i) ? "ère" : "er" : s = "ème", n + s;
}, dF = {
  ordinalNumber: cF,
  era: Io({
    values: oF,
    defaultWidth: "wide"
  }),
  quarter: Io({
    values: aF,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Io({
    values: sF,
    defaultWidth: "wide"
  }),
  day: Io({
    values: lF,
    defaultWidth: "wide"
  }),
  dayPeriod: Io({
    values: uF,
    defaultWidth: "wide"
  })
}, fF = /^(\d+)(ième|ère|ème|er|e)?/i, pF = /\d+/i, hF = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, gF = {
  any: [/^av/i, /^ap/i]
}, vF = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, mF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, bF = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, wF = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, xF = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, _F = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, SF = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, EF = {
  ordinalNumber: TC({
    matchPattern: fF,
    parsePattern: pF,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: Do({
    matchPatterns: hF,
    defaultMatchWidth: "wide",
    parsePatterns: gF,
    defaultParseWidth: "any"
  }),
  quarter: Do({
    matchPatterns: vF,
    defaultMatchWidth: "wide",
    parsePatterns: mF,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Do({
    matchPatterns: yF,
    defaultMatchWidth: "wide",
    parsePatterns: bF,
    defaultParseWidth: "any"
  }),
  day: Do({
    matchPatterns: wF,
    defaultMatchWidth: "wide",
    parsePatterns: xF,
    defaultParseWidth: "any"
  }),
  dayPeriod: Do({
    matchPatterns: _F,
    defaultMatchWidth: "any",
    parsePatterns: SF,
    defaultParseWidth: "any"
  })
}, Df = {
  code: "fr",
  formatDistance: ZB,
  formatLong: rF,
  formatRelative: iF,
  localize: dF,
  match: EF,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Gm = Ac(void 0), $J = ({
  children: e,
  disableClose: t,
  ...r
}) => {
  const [n, i] = Xe(null), [o, s] = Xe({}), l = bt({});
  l.current = o;
  const c = Kt((h, g) => {
    i(h), s(g || {});
  }, []), f = Kt(() => {
    var h, g, S;
    (h = r.onClose) == null || h.call(r), (S = (g = l.current).onClose) == null || S.call(g), s({}), i(null);
  }, [r]);
  return /* @__PURE__ */ y.jsx(
    Gm.Provider,
    {
      value: {
        openDialog: c,
        closeDialog: f,
        dialogProps: { ...r, ...o },
        setDialogProps: s,
        dialogContent: n
      },
      children: e
    }
  );
}, UJ = () => {
  const e = qi(Gm);
  if (!e)
    throw new Error("You need to wrap DialogDisplay inside DialogProvider");
  const { closeDialog: t, dialogProps: r, dialogContent: n } = e, { disableClose: i, ...o } = r;
  return /* @__PURE__ */ y.jsx(
    jc,
    {
      ...o || {},
      open: !!n,
      onClose: (s, l) => {
        (!i || l !== "backdropClick" && l !== "escapeKeyDown") && t();
      },
      children: n
    }
  );
}, Jl = () => {
  const e = qi(Gm);
  if (!e)
    throw new Error("You need to wrap useDialog inside DialogProvider");
  const { openDialog: t, closeDialog: r, setDialogProps: n } = e;
  return { openDialog: t, closeDialog: r, setDialogProps: n };
};
var jo = /* @__PURE__ */ ((e) => (e.error = "error", e.info = "info", e.success = "success", e))(jo || {}), Du = {}, Vw;
function CF() {
  if (Vw) return Du;
  Vw = 1;
  var e = Vi();
  Object.defineProperty(Du, "__esModule", {
    value: !0
  }), Du.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
  }), "Error");
  return Du.default = n, Du;
}
var TF = /* @__PURE__ */ CF();
const OF = /* @__PURE__ */ jr(TF);
var Pu = {}, Yw;
function RF() {
  if (Yw) return Pu;
  Yw = 1;
  var e = Vi();
  Object.defineProperty(Pu, "__esModule", {
    value: !0
  }), Pu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  }), "Info");
  return Pu.default = n, Pu;
}
var IF = /* @__PURE__ */ RF();
const DF = /* @__PURE__ */ jr(IF);
var Mu = {}, Kw;
function PF() {
  if (Kw) return Mu;
  Kw = 1;
  var e = Vi();
  Object.defineProperty(Mu, "__esModule", {
    value: !0
  }), Mu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  }), "Warning");
  return Mu.default = n, Mu;
}
var MF = /* @__PURE__ */ PF();
const AF = /* @__PURE__ */ jr(MF);
var zh = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
var Xw;
function NF() {
  return Xw || (Xw = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = [], i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          if (o) {
            var s = typeof o;
            if (s === "string" || s === "number")
              n.push(o);
            else if (Array.isArray(o)) {
              if (o.length) {
                var l = r.apply(null, o);
                l && n.push(l);
              }
            } else if (s === "object")
              if (o.toString === Object.prototype.toString)
                for (var c in o)
                  t.call(o, c) && o[c] && n.push(c);
              else
                n.push(o.toString());
          }
        }
        return n.join(" ");
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(zh)), zh.exports;
}
var jF = NF();
const gv = /* @__PURE__ */ jr(jF), cp = dt.createContext(void 0), kF = {
  success: bC,
  warning: AF,
  error: OF,
  info: DF
}, LF = Rt((e) => ({
  success: {
    backgroundColor: e.palette.primary.main
  },
  error: {
    backgroundColor: e.palette.error.dark
  },
  info: {
    backgroundColor: e.palette.secondary.light,
    color: e.palette.secondary.dark
  },
  warning: {
    backgroundColor: yz[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: e.spacing(1)
  },
  message: {
    width: 400,
    display: "flex"
  }
}));
function zF(e) {
  return /* @__PURE__ */ y.jsx(gE, { ...e, direction: "right" });
}
const GJ = () => {
  const e = LF(), t = qi(cp);
  return t ? /* @__PURE__ */ y.jsx("div", { children: t.notificationStack.map(
    (r, n) => {
      const i = kF[r.type];
      let o = 32;
      return t.notificationStack[n - 1] && (o = t.notificationStack[n - 1].height + 42), /* @__PURE__ */ y.jsx(
        fm,
        {
          ref: (s) => {
            s && t.setHeight(s, r.key);
          },
          "data-testid": "notification-wrapper",
          open: r.open,
          TransitionComponent: zF,
          TransitionProps: {
            onExited: () => {
              t.exitedNotification(r.key);
            }
          },
          autoHideDuration: r.autoHideDuration || r.autoHideDuration === !1 ? void 0 : 5e3,
          onClick: () => {
            t.removeNotification(r.key);
          },
          onClose: (s, l) => {
            l !== "clickaway" && t.removeNotification(r.key);
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          style: { marginBottom: o },
          children: /* @__PURE__ */ y.jsx(
            pm,
            {
              className: gv(e[r.type]),
              message: /* @__PURE__ */ y.jsxs("span", { className: e.message, children: [
                /* @__PURE__ */ y.jsx(
                  i,
                  {
                    className: gv(e.icon, e.iconVariant)
                  }
                ),
                r.message
              ] }),
              action: r.action || void 0
            }
          )
        },
        r.key
      );
    }
  ) }) : null;
}, Zl = () => {
  const e = qi(cp);
  if (!e)
    throw new Error(
      "You need to wrap useNotification inside NotificationProvider"
    );
  return e;
};
cp.Consumer;
function Tl(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
function Wa(e) {
  return function t(r) {
    return arguments.length === 0 || Tl(r) ? t : e.apply(this, arguments);
  };
}
function Gc(e) {
  return function t(r, n) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return Tl(r) ? t : Wa(function(i) {
          return e(r, i);
        });
      default:
        return Tl(r) && Tl(n) ? t : Tl(r) ? Wa(function(i) {
          return e(i, n);
        }) : Tl(n) ? Wa(function(i) {
          return e(r, i);
        }) : e(r, n);
    }
  };
}
function BF(e, t) {
  switch (e) {
    case 0:
      return function() {
        return t.apply(this, arguments);
      };
    case 1:
      return function(r) {
        return t.apply(this, arguments);
      };
    case 2:
      return function(r, n) {
        return t.apply(this, arguments);
      };
    case 3:
      return function(r, n, i) {
        return t.apply(this, arguments);
      };
    case 4:
      return function(r, n, i, o) {
        return t.apply(this, arguments);
      };
    case 5:
      return function(r, n, i, o, s) {
        return t.apply(this, arguments);
      };
    case 6:
      return function(r, n, i, o, s, l) {
        return t.apply(this, arguments);
      };
    case 7:
      return function(r, n, i, o, s, l, c) {
        return t.apply(this, arguments);
      };
    case 8:
      return function(r, n, i, o, s, l, c, f) {
        return t.apply(this, arguments);
      };
    case 9:
      return function(r, n, i, o, s, l, c, f, h) {
        return t.apply(this, arguments);
      };
    case 10:
      return function(r, n, i, o, s, l, c, f, h, g) {
        return t.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
const RC = Array.isArray || function(t) {
  return t != null && t.length >= 0 && Object.prototype.toString.call(t) === "[object Array]";
};
function FF(e) {
  return e != null && typeof e["@@transducer/step"] == "function";
}
function WF(e, t, r) {
  return function() {
    if (arguments.length === 0)
      return r();
    var n = Array.prototype.slice.call(arguments, 0), i = n.pop();
    if (!RC(i)) {
      for (var o = 0; o < e.length; ) {
        if (typeof i[e[o]] == "function")
          return i[e[o]].apply(i, n);
        o += 1;
      }
      if (FF(i)) {
        var s = t.apply(null, n);
        return s(i);
      }
    }
    return r.apply(this, arguments);
  };
}
const Jw = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(e) {
    return this.xf["@@transducer/result"](e);
  }
};
function HF(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
var $F = /* @__PURE__ */ Wa(function(t) {
  return RC(t) ? !0 : !t || typeof t != "object" || HF(t) ? !1 : t.nodeType === 1 ? !!t.length : t.length === 0 ? !0 : t.length > 0 ? t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1) : !1;
}), UF = /* @__PURE__ */ function() {
  function e(t) {
    this.f = t;
  }
  return e.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, e.prototype["@@transducer/result"] = function(t) {
    return t;
  }, e.prototype["@@transducer/step"] = function(t, r) {
    return this.f(t, r);
  }, e;
}();
function GF(e) {
  return new UF(e);
}
var qF = /* @__PURE__ */ Gc(function(t, r) {
  return BF(t.length, function() {
    return t.apply(r, arguments);
  });
});
function VF(e, t, r) {
  for (var n = 0, i = r.length; n < i; ) {
    if (t = e["@@transducer/step"](t, r[n]), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    n += 1;
  }
  return e["@@transducer/result"](t);
}
function Zw(e, t, r) {
  for (var n = r.next(); !n.done; ) {
    if (t = e["@@transducer/step"](t, n.value), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    n = r.next();
  }
  return e["@@transducer/result"](t);
}
function Qw(e, t, r, n) {
  return e["@@transducer/result"](r[n](qF(e["@@transducer/step"], e), t));
}
var ex = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function YF(e, t, r) {
  if (typeof e == "function" && (e = GF(e)), $F(r))
    return VF(e, t, r);
  if (typeof r["fantasy-land/reduce"] == "function")
    return Qw(e, t, r, "fantasy-land/reduce");
  if (r[ex] != null)
    return Zw(e, t, r[ex]());
  if (typeof r.next == "function")
    return Zw(e, t, r);
  if (typeof r.reduce == "function")
    return Qw(e, t, r, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}
function vv(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var tx = Object.prototype.toString, KF = /* @__PURE__ */ function() {
  return tx.call(arguments) === "[object Arguments]" ? function(t) {
    return tx.call(t) === "[object Arguments]";
  } : function(t) {
    return vv("callee", t);
  };
}(), XF = !/* @__PURE__ */ { toString: null }.propertyIsEnumerable("toString"), rx = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], nx = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), JF = function(t, r) {
  for (var n = 0; n < t.length; ) {
    if (t[n] === r)
      return !0;
    n += 1;
  }
  return !1;
}, ZF = /* @__PURE__ */ Wa(typeof Object.keys == "function" && !nx ? function(t) {
  return Object(t) !== t ? [] : Object.keys(t);
} : function(t) {
  if (Object(t) !== t)
    return [];
  var r, n, i = [], o = nx && KF(t);
  for (r in t)
    vv(r, t) && (!o || r !== "length") && (i[i.length] = r);
  if (XF)
    for (n = rx.length - 1; n >= 0; )
      r = rx[n], vv(r, t) && !JF(i, r) && (i[i.length] = r), n -= 1;
  return i;
}), ho = /* @__PURE__ */ Gc(function(t, r) {
  for (var n = r, i = 0; i < t.length; ) {
    if (n == null)
      return;
    n = n[t[i]], i += 1;
  }
  return n;
});
function QF(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function eW(e, t) {
  for (var r = 0, n = t.length, i = []; r < n; )
    e(t[r]) && (i[i.length] = t[r]), r += 1;
  return i;
}
function tW(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
var rW = /* @__PURE__ */ function() {
  function e(t, r) {
    this.xf = r, this.f = t;
  }
  return e.prototype["@@transducer/init"] = Jw.init, e.prototype["@@transducer/result"] = Jw.result, e.prototype["@@transducer/step"] = function(t, r) {
    return this.f(r) ? this.xf["@@transducer/step"](t, r) : t;
  }, e;
}(), nW = /* @__PURE__ */ Gc(function(t, r) {
  return new rW(t, r);
}), iW = /* @__PURE__ */ Gc(/* @__PURE__ */ WF(["filter"], nW, function(e, t) {
  return tW(t) ? YF(function(r, n) {
    return e(t[n]) && (r[n] = t[n]), r;
  }, {}, ZF(t)) : (
    // else
    eW(e, t)
  );
})), oW = /* @__PURE__ */ Gc(function(t, r) {
  return iW(QF(t), r);
}), Au = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`, aW = "​", sW = typeof String.prototype.trim == "function", lW = /* @__PURE__ */ Wa(!sW || /* @__PURE__ */ Au.trim() || !/* @__PURE__ */ aW.trim() ? function(t) {
  var r = new RegExp("^[" + Au + "][" + Au + "]*"), n = new RegExp("[" + Au + "][" + Au + "]*$");
  return t.replace(r, "").replace(n, "");
} : function(t) {
  return t.trim();
}), Jd, uW = new Uint8Array(16);
function cW() {
  if (!Jd && (Jd = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Jd))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Jd(uW);
}
const dW = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function fW(e) {
  return typeof e == "string" && dW.test(e);
}
var Rn = [];
for (var Bh = 0; Bh < 256; ++Bh)
  Rn.push((Bh + 256).toString(16).substr(1));
function pW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Rn[e[t + 0]] + Rn[e[t + 1]] + Rn[e[t + 2]] + Rn[e[t + 3]] + "-" + Rn[e[t + 4]] + Rn[e[t + 5]] + "-" + Rn[e[t + 6]] + Rn[e[t + 7]] + "-" + Rn[e[t + 8]] + Rn[e[t + 9]] + "-" + Rn[e[t + 10]] + Rn[e[t + 11]] + Rn[e[t + 12]] + Rn[e[t + 13]] + Rn[e[t + 14]] + Rn[e[t + 15]]).toLowerCase();
  if (!fW(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Pf(e, t, r) {
  e = e || {};
  var n = e.random || (e.rng || cW)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, pW(n);
}
const qJ = ({ children: e }) => {
  const [t, r] = Xe([]), n = (l) => {
    const c = t.length;
    if (c >= 2)
      for (let h = 0; h < c - 1; h++)
        o(t[h].key);
    const f = Pf();
    return r((h) => [
      ...h,
      { ...l, key: f, open: !0 }
    ]), f;
  }, i = (l) => {
    r(
      (c) => oW(({ key: f }) => f === l, c)
    );
  }, o = (l) => {
    const c = t.map((f) => f.key === l ? { ...f, open: !1 } : f);
    r(c);
  }, s = (l, c) => {
    let f = !1;
    const h = t.map((g) => g.key === c && !g.height ? (f = !0, { ...g, height: l.clientHeight }) : g);
    f && r(h);
  };
  return /* @__PURE__ */ y.jsx(
    cp.Provider,
    {
      value: {
        notificationStack: t,
        pushNotification: n,
        removeNotification: o,
        exitedNotification: i,
        setHeight: s
      },
      children: e
    }
  );
};
var hW = 5, gW = function(e, t) {
  return Promise.resolve(e.amountStarted < t.length);
}, vW = { maxInProgress: hW, failFast: !1, nextCheck: gW, ignoreIsFunctionCheck: !1 };
function mW(e, t) {
  return new Promise(function(r, n) {
    var i = Object.assign({}, vW, t), o = { amountDone: 0, amountStarted: 0, amountResolved: 0, amountRejected: 0, amountNextCheckFalsey: 0, rejectedIndexes: [], resolvedIndexes: [], nextCheckFalseyIndexes: [], taskResults: [] };
    if (e.length === 0) return r(o);
    for (var s = !1, l = 0, c = function() {
      if (s !== !0) {
        if (o.amountDone++, typeof i.progressCallback == "function" && i.progressCallback(o), o.amountDone === e.length) return r(o);
        l < e.length && f(l++);
      }
    }, f = function(g) {
      i.nextCheck(o, e).then(function(S) {
        S === !0 ? function(b) {
          if (o.amountStarted++, typeof e[b] == "function") e[b]().then(function(p) {
            o.taskResults[b] = p, o.resolvedIndexes.push(b), o.amountResolved++, c();
          }, function(p) {
            if (o.taskResults[b] = p, o.rejectedIndexes.push(b), o.amountRejected++, i.failFast === !0) return s = !0, n(o);
            c();
          });
          else {
            if (i.ignoreIsFunctionCheck !== !0) return s = !0, n(new Error("tasks[" + b + "]: " + e[b] + ", is supposed to be of type function"));
            o.taskResults[b] = e[b], o.resolvedIndexes.push(b), o.amountResolved++, c();
          }
        }(g) : (o.amountNextCheckFalsey++, o.nextCheckFalseyIndexes.push(g), c());
      }, n);
    }, h = 0; h < Math.min(i.maxInProgress, e.length); h++) f(l++);
  });
}
function yW(e, t) {
  return new Promise(function(r, n) {
    mW(e, t).then(function(i) {
      r(i.taskResults);
    }, function(i) {
      i instanceof Error ? n(i) : n(i.taskResults[i.rejectedIndexes[0]]);
    });
  });
}
function bW(e, t) {
  return yW(e, Object.assign({}, { failFast: !0 }, t));
}
const wW = async (e, t, r, n) => {
  if (!e.length) return [];
  let i;
  i = t({
    message: `${n} : 0 / ${e.length}`,
    type: jo.success,
    autoHideDuration: !1
  });
  try {
    return await bW(e, {
      maxInProgress: 3,
      progressCallback: ({ amountDone: o, amountRejected: s }) => {
        r(i), i = t({
          message: `${n} : ${o} / ${e.length}${s ? ` (dont ${s} en echec)` : ""}`,
          type: jo.success,
          autoHideDuration: o < e.length ? !1 : void 0
        });
      }
    });
  } catch (o) {
    throw r(i), o;
  }
}, xW = Rt((e) => ({
  content: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginRight: e.spacing(4),
    marginBottom: 12,
    fontSize: 50,
    color: e.palette.grey[500]
  }
})), _W = (e, t) => {
  const { lockedBy: r } = e;
  if (!r || !r.email) return;
  const n = (s) => s.trim().replace(/\r/g, "%20").replace(/\n/g, "%0A"), i = n(`
Bonjour,

Ce mail est généré automatiquement. Il vous est adressé car je souhaite accéder à l'édition d'une page que vous avez verrouillée.

Pourriez-vous libérer l'édition de cette page en cliquant sur ce lien ?
${t}

Cordialement
`), o = n("Demande d'accès à une page vérrouillée");
  window.open(
    `https://mail.google.com/mail/u/0/?fs=1&to=${r.email}&tf=cm&body=${i}&su=${o}`
  );
}, SW = ({
  lockStatus: e,
  unlockLink: t,
  onNavigateBack: r,
  disableLockForV0: n
}) => {
  const i = xW(), { closeDialog: o } = Jl();
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Gl, { children: n ? "En cours de modification par un autre utilisateur" : "Accès verrouillé" }),
    /* @__PURE__ */ y.jsxs(Ao, { className: i.content, children: [
      n ? /* @__PURE__ */ y.jsx(tp, { className: i.icon }) : /* @__PURE__ */ y.jsx(wE, { className: i.icon }),
      /* @__PURE__ */ y.jsxs(za, { children: [
        "Une personne est déjà en train de modifier cette page,",
        " ",
        n ? "vous risquez d'écraser ses modifications" : "vous ne pouvez pas l'éditer pour le moment. Revenez plus tard ou contactez-la",
        "."
      ] })
    ] }),
    (e == null ? void 0 : e.lockedBy) && /* @__PURE__ */ y.jsx(Ao, { children: /* @__PURE__ */ y.jsx(Nc, { disablePadding: !0, children: /* @__PURE__ */ y.jsxs(Qf, { children: [
      /* @__PURE__ */ y.jsx(BA, { children: /* @__PURE__ */ y.jsx(kc, { src: e.lockedBy.avatarUrl || void 0 }) }),
      /* @__PURE__ */ y.jsx(
        Ya,
        {
          primary: e.lockedBy.name,
          secondary: !!e.lockedAt && `Dernière activité le ${_c(
            new Date(e.lockedAt),
            "dd/MM/yyyy à HH:mm"
          )}`
        }
      ),
      e.lockedBy.email && t && !n && /* @__PURE__ */ y.jsx(FA, { children: /* @__PURE__ */ y.jsx(Nr, { title: "Notifier par mail", children: /* @__PURE__ */ y.jsx(
        fr,
        {
          onClick: () => _W(e, t),
          children: /* @__PURE__ */ y.jsx(gN, {})
        }
      ) }) })
    ] }) }) }),
    /* @__PURE__ */ y.jsxs(ep, { children: [
      r && /* @__PURE__ */ y.jsx(
        Fr,
        {
          onClick: (s) => {
            o(), r == null || r(s);
          },
          color: "primary",
          children: "Retour à la liste"
        }
      ),
      n ? /* @__PURE__ */ y.jsx(Fr, { onClick: o, color: "primary", variant: "contained", children: "OK" }) : /* @__PURE__ */ y.jsx(
        Fr,
        {
          onClick: () => location.reload(),
          color: "primary",
          variant: "contained",
          children: "Actualiser"
        }
      )
    ] })
  ] });
}, EW = Rt((e) => ({
  content: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginRight: e.spacing(4),
    marginBottom: 12,
    fontSize: 50,
    color: e.palette.grey[500]
  },
  timerWrapper: {
    display: "flex",
    alignItems: "center"
  },
  timer: {
    fontSize: 20,
    color: e.palette.primary.main,
    margin: e.spacing(0, 1)
  },
  paragraph: {
    marginBottom: 0
  }
})), Fh = 1e3, CW = ({
  timerStart: e,
  lockTimeout: t,
  onNavigateBack: r,
  disableLockForV0: n
}) => {
  const i = EW(), [o, s] = Xe(e), { closeDialog: l } = Jl();
  return op(() => {
    const c = setInterval(() => {
      s(
        (f) => f - Fh >= 0 ? f - Fh : 0
      );
    }, Fh);
    return () => clearInterval(c);
  }), /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Gl, { children: "Période d'inactivité" }),
    /* @__PURE__ */ y.jsxs(Ao, { className: i.content, children: [
      /* @__PURE__ */ y.jsx(vN, { className: i.icon }),
      /* @__PURE__ */ y.jsx("div", { children: o ? /* @__PURE__ */ y.jsxs(za, { children: [
        "Sans action de votre part, cette page ne sera plus",
        " ",
        n ? "en cours de modification" : "vérrouillée",
        " ",
        "dans",
        /* @__PURE__ */ y.jsx("span", { className: i.timer, children: Math.round(o / 1e3) }),
        "secondes."
      ] }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsxs(za, { className: i.paragraph, children: [
          "En raison d'une période d'inactivité de",
          " ",
          WB(
            UB({
              start: 0,
              end: t
            })
          ),
          ", cette page n'est plus",
          " ",
          n ? "en cours d'édition" : "verrouillée",
          "."
        ] }),
        /* @__PURE__ */ y.jsxs(za, { children: [
          "Vous pouvez",
          " ",
          n ? "continuer de la modifier" : "la verrouiller à nouveau",
          " ",
          "si personne d'autre n'est déjà en train de la modifier."
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ y.jsxs(ep, { children: [
      r && /* @__PURE__ */ y.jsx(
        Fr,
        {
          onClick: (c) => {
            l(), r == null || r(c);
          },
          color: "primary",
          children: "Retour à la liste"
        }
      ),
      /* @__PURE__ */ y.jsx(Fr, { onClick: l, color: "primary", variant: "contained", children: "Rester sur la page" })
    ] })
  ] });
}, TW = 6e4, gl = 3e4, ix = 6e4, OW = 1e3, { now: To } = Date, VJ = ({
  lockStatus: e,
  // if null or undefined (when loading the page for example), concurrential access is disabled
  unlockTimeout: t,
  // cannot be inferior to 'unlockTimeoutConfigOnServer'
  onLock: r,
  unlockLink: n,
  currentUser: i,
  onNavigateBack: o,
  clearUnsavedWork: s,
  unlockTimeoutConfigOnServer: l = 3e5,
  // 5min (should be = to server config)
  disableLockForV0: c
}) => {
  var ee;
  const [f, h] = Xe(!1), { pushNotification: g } = Zl(), { openDialog: S } = Jl(), [b, p] = Xe(0), [v, w] = Xe(To()), [C, M] = Xe(!1), [L, W] = Xe(!0), z = kt(
    () => (
      // 'unlockTimer' cannot be inferior to 'unlockTimeoutConfigOnServer'
      t > l ? t : l
    ),
    [t, l]
  ), B = kt(
    () => Math.max(
      gl,
      l - TW
    ),
    [l]
  );
  pt(() => {
    var he;
    e != null && e.lockedAt && i && ((he = e.lockedBy) == null ? void 0 : he.id) === (i == null ? void 0 : i.id) && !b && (p(new Date(e.lockedAt).getTime()), W(!1));
  }, [
    i,
    b,
    e == null ? void 0 : e.lockedAt,
    (ee = e == null ? void 0 : e.lockedBy) == null ? void 0 : ee.id
  ]), pt(() => {
    !f && (e != null && e.lockedBy) && (e == null ? void 0 : e.lockedBy.id) !== (i == null ? void 0 : i.id) && (!c || !C) && (h(!0), M(!0), S(
      /* @__PURE__ */ y.jsx(
        SW,
        {
          lockStatus: e,
          unlockLink: n,
          onNavigateBack: o,
          disableLockForV0: c
        }
      ),
      {
        disableClose: !c,
        onClose: () => h(!1)
      }
    ), s == null || s());
  }, [
    s,
    i == null ? void 0 : i.id,
    c,
    f,
    e,
    C,
    o,
    S,
    n
  ]);
  const K = Kt(async () => {
    p(To());
    try {
      await r(L);
    } catch (he) {
      g({
        message: he.message,
        type: jo.error
      });
    }
    W(!1);
  }, [L, r, g]), Z = Kt(() => {
    !f && To() - v >= OW && w(To());
  }, [f, v]);
  pt(() => (addEventListener("mousemove", Z), addEventListener("mousedown", Z), addEventListener("scroll", Z), addEventListener("touchstart", Z), addEventListener("keydown", Z), () => {
    removeEventListener("mousemove", Z), removeEventListener("mousedown", Z), removeEventListener("scroll", Z), removeEventListener("touchstart", Z), removeEventListener("keydown", Z);
  }), [Z]), pt(() => {
    let he, _e;
    if (e && (!e.lockedBy || e.lockedBy.id === (i == null ? void 0 : i.id))) {
      const Te = To() - v, fe = To() - b, Oe = z - Te, ye = Oe - ix;
      he = setTimeout(
        () => {
          h(!0), S(
            /* @__PURE__ */ y.jsx(
              CW,
              {
                lockTimeout: z,
                timerStart: Math.min(ix, Oe),
                onNavigateBack: o,
                disableLockForV0: c
              }
            ),
            {
              onClose: () => {
                h(!1), w(To());
              }
            }
          );
        },
        ye > 0 ? ye : 0
      );
      let de = B - fe;
      de < 0 && (de = 0);
      const ce = z - l, Fe = ce < gl / 2 ? gl / 2 - ce : 0;
      // Check if the next refresh will fall into the 5 min of our example
      To() + de >= v + ce + Fe && (de = ce + Fe - Te, To() + de < b + gl && (de = gl - fe, To() + de > v + ce + gl / 2 && (de = -1))), de >= 0 && (_e = setTimeout(
        () => K(),
        de
      ));
    }
    return () => {
      clearTimeout(he), clearTimeout(_e);
    };
  }, [
    i == null ? void 0 : i.id,
    c,
    b,
    v,
    B,
    e,
    o,
    S,
    K,
    l,
    z
  ]);
}, RW = Rt((e) => ({
  lockedButton: {
    backgroundColor: e.palette.common.white,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 6,
    borderRadius: 30
  },
  lockedIcon: {
    marginRight: 0,
    color: e.palette.common.black
  }
})), IC = ({
  lockedBy: e,
  className: t,
  onClick: r,
  disableLockForV0: n,
  size: i = "medium"
}) => {
  const o = RW(), s = kt(() => {
    if (i === "small")
      return { width: 24, height: 24 };
    if (i === "large")
      return { width: 56, height: 56 };
  }, [i]);
  return /* @__PURE__ */ y.jsx("div", { className: t, children: /* @__PURE__ */ y.jsx(
    Nr,
    {
      title: `${n ? "En cours de modification" : "Vérrouillé"}${e ? ` par ${e.name}` : ""}`,
      children: /* @__PURE__ */ y.jsx(
        Fr,
        {
          variant: "contained",
          classes: {
            root: o.lockedButton,
            startIcon: o.lockedIcon
          },
          startIcon: n ? /* @__PURE__ */ y.jsx(tp, { fontSize: i }) : /* @__PURE__ */ y.jsx(wE, { fontSize: i }),
          endIcon: /* @__PURE__ */ y.jsx(kc, { src: (e == null ? void 0 : e.avatarUrl) || void 0, sx: s }),
          onClick: r,
          size: i
        }
      )
    }
  ) });
}, IW = Rt(() => ({
  wrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  image: ({ fitting: e }) => ({
    objectFit: e,
    width: "100%",
    height: "100%"
  }),
  imgIcon: {
    opacity: 0.5
  },
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
})), DW = tj({
  key: "failedSources",
  default: []
}), qc = ({
  className: e,
  fallbacks: t = [],
  image: r,
  loaderSize: n = 30,
  src: i,
  style: o,
  timeout: s,
  fitting: l = "cover",
  sx: c
}) => {
  const f = zE(), h = IW({ fitting: l }), [g, S] = rj(DW), b = kt(
    () => [{ src: i, timeout: s }, ...t].filter(
      ({ src: W }) => W && !g.includes(W)
    ),
    [g, t, i, s]
  ), p = kt(() => {
    var W;
    return ((W = b[0]) == null ? void 0 : W.src) || void 0;
  }, [b]), [v, w] = Xe(p), [C, M] = Xe(!0), L = r || /* @__PURE__ */ y.jsx(mN, { className: h.imgIcon, style: { fontSize: n * 2 } });
  return pt(() => {
    w(p), M(!0), b.reduce(
      (W, { src: z, timeout: B }, K, Z) => W.catch(() => {
        var ee;
        if (K > 0) {
          w(void 0);
          const he = (ee = Z[K - 1]) == null ? void 0 : ee.src;
          he && S((_e) => [..._e, he]);
        }
        return Sm(z, B).then((he) => he.src);
      }),
      Promise.reject()
    ).then((W) => {
      f() && w(W);
    }).catch(() => {
      f() && w(void 0);
    }).finally(() => {
      f() && M(!1);
    });
  }, [i]), /* @__PURE__ */ y.jsxs(zt, { className: nt(h.wrapper, e), style: o, sx: c, children: [
    C && /* @__PURE__ */ y.jsx("div", { className: h.center, children: /* @__PURE__ */ y.jsx(un, { size: n }) }),
    v ? /* @__PURE__ */ y.jsx("img", { className: h.image, src: v, draggable: !1 }) : !C && /* @__PURE__ */ y.jsx("div", { className: h.center, children: L })
  ] });
}, PW = "Sans titre", MW = "Terminer l'édition", AW = "Créé le", NW = "Modifié le", jW = "Push(s) effectué(s) :";
function qm(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function oa() {
  return oa = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oa.apply(this, arguments);
}
function ct() {
  return ct = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ct.apply(this, arguments);
}
var ox = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Vc = (typeof window > "u" ? "undefined" : ox(window)) === "object" && (typeof document > "u" ? "undefined" : ox(document)) === "object" && document.nodeType === 9, kW = process.env.NODE_ENV === "production";
function Ki(e, t) {
  if (!kW) {
    var r = "Warning: " + t;
    typeof console < "u" && console.warn(r);
    try {
      throw Error(r);
    } catch {
    }
  }
}
function LW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function DC(e, t, r) {
  return t && LW(e.prototype, t), e;
}
function mv(e, t) {
  return mv = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, mv(e, t);
}
function Ql(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, mv(e, t);
}
function yv(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zs(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var zW = {}.constructor;
function bv(e) {
  if (e == null || typeof e != "object") return e;
  if (Array.isArray(e)) return e.map(bv);
  if (e.constructor !== zW) return e;
  var t = {};
  for (var r in e)
    t[r] = bv(e[r]);
  return t;
}
function Vm(e, t, r) {
  e === void 0 && (e = "unnamed");
  var n = r.jss, i = bv(t), o = n.plugins.onCreateRule(e, i, r);
  return o || (e[0] === "@" && process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] Unknown rule " + e), null);
}
var ax = function(t, r) {
  for (var n = "", i = 0; i < t.length && t[i] !== "!important"; i++)
    n && (n += r), n += t[i];
  return n;
}, ks = function(t, r) {
  if (r === void 0 && (r = !1), !Array.isArray(t)) return t;
  var n = "";
  if (Array.isArray(t[0]))
    for (var i = 0; i < t.length && t[i] !== "!important"; i++)
      n && (n += ", "), n += ax(t[i], " ");
  else n = ax(t, ", ");
  return !r && t[t.length - 1] === "!important" && (n += " !important"), n;
};
function eu(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Nu(e, t) {
  for (var r = "", n = 0; n < t; n++)
    r += "  ";
  return r + e;
}
function Sc(e, t, r) {
  r === void 0 && (r = {});
  var n = "";
  if (!t) return n;
  var i = r, o = i.indent, s = o === void 0 ? 0 : o, l = t.fallbacks;
  r.format === !1 && (s = -1 / 0);
  var c = eu(r), f = c.linebreak, h = c.space;
  if (e && s++, l)
    if (Array.isArray(l))
      for (var g = 0; g < l.length; g++) {
        var S = l[g];
        for (var b in S) {
          var p = S[b];
          p != null && (n && (n += f), n += Nu(b + ":" + h + ks(p) + ";", s));
        }
      }
    else
      for (var v in l) {
        var w = l[v];
        w != null && (n && (n += f), n += Nu(v + ":" + h + ks(w) + ";", s));
      }
  for (var C in t) {
    var M = t[C];
    M != null && C !== "fallbacks" && (n && (n += f), n += Nu(C + ":" + h + ks(M) + ";", s));
  }
  return !n && !r.allowEmpty || !e ? n : (s--, n && (n = "" + f + n + f), Nu("" + e + h + "{" + n, s) + Nu("}", s));
}
var BW = /([[\].#*$><+~=|^:(),"'`\s])/g, sx = typeof CSS < "u" && CSS.escape, Ym = function(e) {
  return sx ? sx(e) : e.replace(BW, "\\$1");
}, PC = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "style", this.isProcessed = !1;
    var o = i.sheet, s = i.Renderer;
    this.key = r, this.options = i, this.style = n, o ? this.renderer = o.renderer : s && (this.renderer = new s());
  }
  var t = e.prototype;
  return t.prop = function(n, i, o) {
    if (i === void 0) return this.style[n];
    var s = o ? o.force : !1;
    if (!s && this.style[n] === i) return this;
    var l = i;
    (!o || o.process !== !1) && (l = this.options.jss.plugins.onChangeValue(i, n, this));
    var c = l == null || l === !1, f = n in this.style;
    if (c && !f && !s) return this;
    var h = c && f;
    if (h ? delete this.style[n] : this.style[n] = l, this.renderable && this.renderer)
      return h ? this.renderer.removeProperty(this.renderable, n) : this.renderer.setProperty(this.renderable, n, l), this;
    var g = this.options.sheet;
    return g && g.attached && process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), wv = /* @__PURE__ */ function(e) {
  Ql(t, e);
  function t(n, i, o) {
    var s;
    s = e.call(this, n, i, o) || this;
    var l = o.selector, c = o.scoped, f = o.sheet, h = o.generateId;
    return l ? s.selectorText = l : c !== !1 && (s.id = h(yv(yv(s)), f), s.selectorText = "." + Ym(s.id)), s;
  }
  var r = t.prototype;
  return r.applyTo = function(i) {
    var o = this.renderer;
    if (o) {
      var s = this.toJSON();
      for (var l in s)
        o.setProperty(i, l, s[l]);
    }
    return this;
  }, r.toJSON = function() {
    var i = {};
    for (var o in this.style) {
      var s = this.style[o];
      typeof s != "object" ? i[o] = s : Array.isArray(s) && (i[o] = ks(s));
    }
    return i;
  }, r.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, l = s ? ct({}, i, {
      allowEmpty: !0
    }) : i;
    return Sc(this.selectorText, this.style, l);
  }, DC(t, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var o = this.renderer, s = this.renderable;
        if (!(!s || !o)) {
          var l = o.setSelector(s, i);
          l || o.replaceRule(s, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(PC), FW = {
  onCreateRule: function(t, r, n) {
    return t[0] === "@" || n.parent && n.parent.type === "keyframes" ? null : new wv(t, r, n);
  }
}, Wh = {
  indent: 1,
  children: !0
}, WW = /@([\w-]+)/, HW = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = r;
    var o = r.match(WW);
    this.at = o ? o[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new dp(ct({}, i, {
      parent: this
    }));
    for (var s in n)
      this.rules.add(s, n[s]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(n) {
    return this.rules.get(n);
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.addRule = function(n, i, o) {
    var s = this.rules.add(n, i, o);
    return s ? (this.options.jss.plugins.onProcessRule(s), s) : null;
  }, t.toString = function(n) {
    n === void 0 && (n = Wh);
    var i = eu(n), o = i.linebreak;
    if (n.indent == null && (n.indent = Wh.indent), n.children == null && (n.children = Wh.children), n.children === !1)
      return this.query + " {}";
    var s = this.rules.toString(n);
    return s ? this.query + " {" + o + s + o + "}" : "";
  }, e;
}(), $W = /@media|@supports\s+/, UW = {
  onCreateRule: function(t, r, n) {
    return $W.test(t) ? new HW(t, r, n) : null;
  }
}, Hh = {
  indent: 1,
  children: !0
}, GW = /@keyframes\s+([\w-]+)/, xv = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var o = r.match(GW);
    o && o[1] ? this.name = o[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] Bad keyframes name " + r)), this.key = this.type + "-" + this.name, this.options = i;
    var s = i.scoped, l = i.sheet, c = i.generateId;
    this.id = s === !1 ? this.name : Ym(c(this, l)), this.rules = new dp(ct({}, i, {
      parent: this
    }));
    for (var f in n)
      this.rules.add(f, n[f], ct({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var t = e.prototype;
  return t.toString = function(n) {
    n === void 0 && (n = Hh);
    var i = eu(n), o = i.linebreak;
    if (n.indent == null && (n.indent = Hh.indent), n.children == null && (n.children = Hh.children), n.children === !1)
      return this.at + " " + this.id + " {}";
    var s = this.rules.toString(n);
    return s && (s = "" + o + s + o), this.at + " " + this.id + " {" + s + "}";
  }, e;
}(), qW = /@keyframes\s+/, VW = /\$([\w-]+)/g, _v = function(t, r) {
  return typeof t == "string" ? t.replace(VW, function(n, i) {
    return i in r ? r[i] : (process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] Referenced keyframes rule "' + i + '" is not defined.'), n);
  }) : t;
}, lx = function(t, r, n) {
  var i = t[r], o = _v(i, n);
  o !== i && (t[r] = o);
}, YW = {
  onCreateRule: function(t, r, n) {
    return typeof t == "string" && qW.test(t) ? new xv(t, r, n) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, r, n) {
    return r.type !== "style" || !n || ("animation-name" in t && lx(t, "animation-name", n.keyframes), "animation" in t && lx(t, "animation", n.keyframes)), t;
  },
  onChangeValue: function(t, r, n) {
    var i = n.options.sheet;
    if (!i)
      return t;
    switch (r) {
      case "animation":
        return _v(t, i.keyframes);
      case "animation-name":
        return _v(t, i.keyframes);
      default:
        return t;
    }
  }
}, KW = /* @__PURE__ */ function(e) {
  Ql(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, l = s ? ct({}, i, {
      allowEmpty: !0
    }) : i;
    return Sc(this.key, this.style, l);
  }, t;
}(PC), XW = {
  onCreateRule: function(t, r, n) {
    return n.parent && n.parent.type === "keyframes" ? new KW(t, r, n) : null;
  }
}, JW = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = r, this.style = n, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    var i = eu(n), o = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var s = "", l = 0; l < this.style.length; l++)
        s += Sc(this.at, this.style[l]), this.style[l + 1] && (s += o);
      return s;
    }
    return Sc(this.at, this.style, n);
  }, e;
}(), ZW = /@font-face/, QW = {
  onCreateRule: function(t, r, n) {
    return ZW.test(t) ? new JW(t, r, n) : null;
  }
}, e5 = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = r, this.style = n, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    return Sc(this.key, this.style, n);
  }, e;
}(), t5 = {
  onCreateRule: function(t, r, n) {
    return t === "@viewport" || t === "@-ms-viewport" ? new e5(t, r, n) : null;
  }
}, r5 = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "simple", this.isProcessed = !1, this.key = r, this.value = n, this.options = i;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    if (Array.isArray(this.value)) {
      for (var i = "", o = 0; o < this.value.length; o++)
        i += this.key + " " + this.value[o] + ";", this.value[o + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), n5 = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, i5 = {
  onCreateRule: function(t, r, n) {
    return t in n5 ? new r5(t, r, n) : null;
  }
}, ux = [FW, UW, YW, XW, QW, t5, i5], o5 = {
  process: !0
}, cx = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, dp = /* @__PURE__ */ function() {
  function e(r) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = r, this.classes = r.classes, this.keyframes = r.keyframes;
  }
  var t = e.prototype;
  return t.add = function(n, i, o) {
    var s = this.options, l = s.parent, c = s.sheet, f = s.jss, h = s.Renderer, g = s.generateId, S = s.scoped, b = ct({
      classes: this.classes,
      parent: l,
      sheet: c,
      jss: f,
      Renderer: h,
      generateId: g,
      scoped: S,
      name: n,
      keyframes: this.keyframes,
      selector: void 0
    }, o), p = n;
    n in this.raw && (p = n + "-d" + this.counter++), this.raw[p] = i, p in this.classes && (b.selector = "." + Ym(this.classes[p]));
    var v = Vm(p, i, b);
    if (!v) return null;
    this.register(v);
    var w = b.index === void 0 ? this.index.length : b.index;
    return this.index.splice(w, 0, v), v;
  }, t.get = function(n) {
    return this.map[n];
  }, t.remove = function(n) {
    this.unregister(n), delete this.raw[n.key], this.index.splice(this.index.indexOf(n), 1);
  }, t.indexOf = function(n) {
    return this.index.indexOf(n);
  }, t.process = function() {
    var n = this.options.jss.plugins;
    this.index.slice(0).forEach(n.onProcessRule, n);
  }, t.register = function(n) {
    this.map[n.key] = n, n instanceof wv ? (this.map[n.selector] = n, n.id && (this.classes[n.key] = n.id)) : n instanceof xv && this.keyframes && (this.keyframes[n.name] = n.id);
  }, t.unregister = function(n) {
    delete this.map[n.key], n instanceof wv ? (delete this.map[n.selector], delete this.classes[n.key]) : n instanceof xv && delete this.keyframes[n.name];
  }, t.update = function() {
    var n, i, o;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (n = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], n = null), n)
      this.updateOne(this.map[n], i, o);
    else
      for (var s = 0; s < this.index.length; s++)
        this.updateOne(this.index[s], i, o);
  }, t.updateOne = function(n, i, o) {
    o === void 0 && (o = o5);
    var s = this.options, l = s.jss.plugins, c = s.sheet;
    if (n.rules instanceof e) {
      n.rules.update(i, o);
      return;
    }
    var f = n.style;
    if (l.onUpdate(i, n, c, o), o.process && f && f !== n.style) {
      l.onProcessStyle(n.style, n, c);
      for (var h in n.style) {
        var g = n.style[h], S = f[h];
        g !== S && n.prop(h, g, cx);
      }
      for (var b in f) {
        var p = n.style[b], v = f[b];
        p == null && p !== v && n.prop(b, null, cx);
      }
    }
  }, t.toString = function(n) {
    for (var i = "", o = this.options.sheet, s = o ? o.options.link : !1, l = eu(n), c = l.linebreak, f = 0; f < this.index.length; f++) {
      var h = this.index[f], g = h.toString(n);
      !g && !s || (i && (i += c), i += g);
    }
    return i;
  }, e;
}(), MC = /* @__PURE__ */ function() {
  function e(r, n) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = ct({}, n, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), n.Renderer && (this.renderer = new n.Renderer(this)), this.rules = new dp(this.options);
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(n, i, o) {
    var s = this.queue;
    this.attached && !s && (this.queue = []);
    var l = this.rules.add(n, i, o);
    return l ? (this.options.jss.plugins.onProcessRule(l), this.attached ? (this.deployed && (s ? s.push(l) : (this.insertRule(l), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), l) : (this.deployed = !1, l)) : null;
  }, t.insertRule = function(n) {
    this.renderer && this.renderer.insertRule(n);
  }, t.addRules = function(n, i) {
    var o = [];
    for (var s in n) {
      var l = this.addRule(s, n[s], i);
      l && o.push(l);
    }
    return o;
  }, t.getRule = function(n) {
    return this.rules.get(n);
  }, t.deleteRule = function(n) {
    var i = typeof n == "object" ? n : this.rules.get(n);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var n;
    return (n = this.rules).update.apply(n, arguments), this;
  }, t.updateOne = function(n, i, o) {
    return this.rules.updateOne(n, i, o), this;
  }, t.toString = function(n) {
    return this.rules.toString(n);
  }, e;
}(), a5 = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = e.prototype;
  return t.onCreateRule = function(n, i, o) {
    for (var s = 0; s < this.registry.onCreateRule.length; s++) {
      var l = this.registry.onCreateRule[s](n, i, o);
      if (l) return l;
    }
    return null;
  }, t.onProcessRule = function(n) {
    if (!n.isProcessed) {
      for (var i = n.options.sheet, o = 0; o < this.registry.onProcessRule.length; o++)
        this.registry.onProcessRule[o](n, i);
      n.style && this.onProcessStyle(n.style, n, i), n.isProcessed = !0;
    }
  }, t.onProcessStyle = function(n, i, o) {
    for (var s = 0; s < this.registry.onProcessStyle.length; s++)
      i.style = this.registry.onProcessStyle[s](i.style, i, o);
  }, t.onProcessSheet = function(n) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](n);
  }, t.onUpdate = function(n, i, o, s) {
    for (var l = 0; l < this.registry.onUpdate.length; l++)
      this.registry.onUpdate[l](n, i, o, s);
  }, t.onChangeValue = function(n, i, o) {
    for (var s = n, l = 0; l < this.registry.onChangeValue.length; l++)
      s = this.registry.onChangeValue[l](s, i, o);
    return s;
  }, t.use = function(n, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var o = this.plugins[i.queue];
    o.indexOf(n) === -1 && (o.push(n), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(s, l) {
      for (var c in l)
        c in s ? s[c].push(l[c]) : process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] Unknown hook "' + c + '".');
      return s;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), s5 = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var t = e.prototype;
  return t.add = function(n) {
    var i = this.registry, o = n.options.index;
    if (i.indexOf(n) === -1) {
      if (i.length === 0 || o >= this.index) {
        i.push(n);
        return;
      }
      for (var s = 0; s < i.length; s++)
        if (i[s].options.index > o) {
          i.splice(s, 0, n);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(n) {
    var i = this.registry.indexOf(n);
    this.registry.splice(i, 1);
  }, t.toString = function(n) {
    for (var i = n === void 0 ? {} : n, o = i.attached, s = zs(i, ["attached"]), l = eu(s), c = l.linebreak, f = "", h = 0; h < this.registry.length; h++) {
      var g = this.registry[h];
      o != null && g.attached !== o || (f && (f += c), f += g.toString(s));
    }
    return f;
  }, DC(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), uc = new s5(), Sv = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Ev = "2f1acc6c3a606b082e5eef5e54414ffb";
Sv[Ev] == null && (Sv[Ev] = 0);
var dx = Sv[Ev]++, l5 = 1e10, fx = function(t) {
  t === void 0 && (t = {});
  var r = 0, n = function(o, s) {
    r += 1, r > l5 && process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] You might have a memory leak. Rule counter is at " + r + ".");
    var l = "", c = "";
    return s && (s.options.classNamePrefix && (c = s.options.classNamePrefix), s.options.jss.id != null && (l = String(s.options.jss.id))), t.minify ? "" + (c || "c") + dx + l + r : c + o.key + "-" + dx + (l ? "-" + l : "") + "-" + r;
  };
  return n;
}, AC = function(t) {
  var r;
  return function() {
    return r || (r = t()), r;
  };
}, u5 = function(t, r) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(r) : t.style.getPropertyValue(r);
  } catch {
    return "";
  }
}, c5 = function(t, r, n) {
  try {
    var i = n;
    if (Array.isArray(n) && (i = ks(n, !0), n[n.length - 1] === "!important"))
      return t.style.setProperty(r, i, "important"), !0;
    t.attributeStyleMap ? t.attributeStyleMap.set(r, i) : t.style.setProperty(r, i);
  } catch {
    return !1;
  }
  return !0;
}, d5 = function(t, r) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(r) : t.style.removeProperty(r);
  } catch (n) {
    process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] DOMException "' + n.message + '" was thrown. Tried to remove property "' + r + '".');
  }
}, f5 = function(t, r) {
  return t.selectorText = r, t.selectorText === r;
}, NC = AC(function() {
  return document.querySelector("head");
});
function p5(e, t) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    if (n.attached && n.options.index > t.index && n.options.insertionPoint === t.insertionPoint)
      return n;
  }
  return null;
}
function h5(e, t) {
  for (var r = e.length - 1; r >= 0; r--) {
    var n = e[r];
    if (n.attached && n.options.insertionPoint === t.insertionPoint)
      return n;
  }
  return null;
}
function g5(e) {
  for (var t = NC(), r = 0; r < t.childNodes.length; r++) {
    var n = t.childNodes[r];
    if (n.nodeType === 8 && n.nodeValue.trim() === e)
      return n;
  }
  return null;
}
function v5(e) {
  var t = uc.registry;
  if (t.length > 0) {
    var r = p5(t, e);
    if (r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element
      };
    if (r = h5(t, e), r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element.nextSibling
      };
  }
  var n = e.insertionPoint;
  if (n && typeof n == "string") {
    var i = g5(n);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
    process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] Insertion point "' + n + '" not found.');
  }
  return !1;
}
function m5(e, t) {
  var r = t.insertionPoint, n = v5(t);
  if (n !== !1 && n.parent) {
    n.parent.insertBefore(e, n.node);
    return;
  }
  if (r && typeof r.nodeType == "number") {
    var i = r, o = i.parentNode;
    o ? o.insertBefore(e, i.nextSibling) : process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  NC().appendChild(e);
}
var y5 = AC(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), px = function(t, r, n) {
  try {
    "insertRule" in t ? t.insertRule(r, n) : "appendRule" in t && t.appendRule(r);
  } catch (i) {
    return process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] " + i.message), !1;
  }
  return t.cssRules[n];
}, hx = function(t, r) {
  var n = t.cssRules.length;
  return r === void 0 || r > n ? n : r;
}, b5 = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, w5 = /* @__PURE__ */ function() {
  function e(r) {
    this.getPropertyValue = u5, this.setProperty = c5, this.removeProperty = d5, this.setSelector = f5, this.hasInsertedRules = !1, this.cssRules = [], r && uc.add(r), this.sheet = r;
    var n = this.sheet ? this.sheet.options : {}, i = n.media, o = n.meta, s = n.element;
    this.element = s || b5(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), o && this.element.setAttribute("data-meta", o);
    var l = y5();
    l && this.element.setAttribute("nonce", l);
  }
  var t = e.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      m5(this.element, this.sheet.options);
      var n = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && n && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var n = this.element.parentNode;
      n && n.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var n = this.sheet;
    if (n) {
      if (n.options.link) {
        this.insertRules(n.rules);
        return;
      }
      this.element.textContent = `
` + n.toString() + `
`;
    }
  }, t.insertRules = function(n, i) {
    for (var o = 0; o < n.index.length; o++)
      this.insertRule(n.index[o], o, i);
  }, t.insertRule = function(n, i, o) {
    if (o === void 0 && (o = this.element.sheet), n.rules) {
      var s = n, l = o;
      if (n.type === "conditional" || n.type === "keyframes") {
        var c = hx(o, i);
        if (l = px(o, s.toString({
          children: !1
        }), c), l === !1)
          return !1;
        this.refCssRule(n, c, l);
      }
      return this.insertRules(s.rules, l), l;
    }
    var f = n.toString();
    if (!f) return !1;
    var h = hx(o, i), g = px(o, f, h);
    return g === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(n, h, g), g);
  }, t.refCssRule = function(n, i, o) {
    n.renderable = o, n.options.parent instanceof MC && (this.cssRules[i] = o);
  }, t.deleteRule = function(n) {
    var i = this.element.sheet, o = this.indexOf(n);
    return o === -1 ? !1 : (i.deleteRule(o), this.cssRules.splice(o, 1), !0);
  }, t.indexOf = function(n) {
    return this.cssRules.indexOf(n);
  }, t.replaceRule = function(n, i) {
    var o = this.indexOf(n);
    return o === -1 ? !1 : (this.element.sheet.deleteRule(o), this.cssRules.splice(o, 1), this.insertRule(i, o));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), x5 = 0, _5 = /* @__PURE__ */ function() {
  function e(r) {
    this.id = x5++, this.version = "10.8.2", this.plugins = new a5(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: fx,
      Renderer: Vc ? w5 : null,
      plugins: []
    }, this.generateId = fx({
      minify: !1
    });
    for (var n = 0; n < ux.length; n++)
      this.plugins.use(ux[n], {
        queue: "internal"
      });
    this.setup(r);
  }
  var t = e.prototype;
  return t.setup = function(n) {
    return n === void 0 && (n = {}), n.createGenerateId && (this.options.createGenerateId = n.createGenerateId), n.id && (this.options.id = ct({}, this.options.id, n.id)), (n.createGenerateId || n.id) && (this.generateId = this.options.createGenerateId(this.options.id)), n.insertionPoint != null && (this.options.insertionPoint = n.insertionPoint), "Renderer" in n && (this.options.Renderer = n.Renderer), n.plugins && this.use.apply(this, n.plugins), this;
  }, t.createStyleSheet = function(n, i) {
    i === void 0 && (i = {});
    var o = i, s = o.index;
    typeof s != "number" && (s = uc.index === 0 ? 0 : uc.index + 1);
    var l = new MC(n, ct({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: s
    }));
    return this.plugins.onProcessSheet(l), l;
  }, t.removeStyleSheet = function(n) {
    return n.detach(), uc.remove(n), this;
  }, t.createRule = function(n, i, o) {
    if (i === void 0 && (i = {}), o === void 0 && (o = {}), typeof n == "object")
      return this.createRule(void 0, n, i);
    var s = ct({}, o, {
      name: n,
      jss: this,
      Renderer: this.options.Renderer
    });
    s.generateId || (s.generateId = this.generateId), s.classes || (s.classes = {}), s.keyframes || (s.keyframes = {});
    var l = Vm(n, i, s);
    return l && this.plugins.onProcessRule(l), l;
  }, t.use = function() {
    for (var n = this, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return o.forEach(function(l) {
      n.plugins.use(l);
    }), this;
  }, e;
}(), Km = function(t) {
  return new _5(t);
}, Xm = typeof CSS == "object" && CSS != null && "number" in CSS;
function jC(e) {
  var t = null;
  for (var r in e) {
    var n = e[r], i = typeof n;
    if (i === "function")
      t || (t = {}), t[r] = n;
    else if (i === "object" && n !== null && !Array.isArray(n)) {
      var o = jC(n);
      o && (t || (t = {}), t[r] = o);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
Km();
function kC(e = {}) {
  const {
    baseClasses: t,
    newClasses: r,
    Component: n
  } = e;
  if (!r)
    return t;
  const i = oa({}, t);
  return process.env.NODE_ENV !== "production" && typeof r == "string" ? (console.error([`MUI: The value \`${r}\` provided to the classes prop of ${ff(n)} is incorrect.`, "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(r).forEach((o) => {
    process.env.NODE_ENV !== "production" && (!t[o] && r[o] && console.error([`MUI: The key \`${o}\` provided to the classes prop is not implemented in ${ff(n)}.`, `You can only override one of the following: ${Object.keys(t).join(",")}.`].join(`
`)), r[o] && typeof r[o] != "string" && console.error([`MUI: The key \`${o}\` provided to the classes prop is not valid for ${ff(n)}.`, `You need to provide a non empty string instead of: ${r[o]}.`].join(`
`))), r[o] && (i[o] = `${t[o]} ${r[o]}`);
  }), i);
}
const Il = {
  set: (e, t, r, n) => {
    let i = e.get(t);
    i || (i = /* @__PURE__ */ new Map(), e.set(t, i)), i.set(r, n);
  },
  get: (e, t, r) => {
    const n = e.get(t);
    return n ? n.get(r) : void 0;
  },
  delete: (e, t, r) => {
    e.get(t).delete(r);
  }
}, S5 = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function E5(e = {}) {
  const {
    disableGlobal: t = !1,
    productionPrefix: r = "jss",
    seed: n = ""
  } = e, i = n === "" ? "" : `${n}-`;
  let o = 0;
  const s = () => (o += 1, process.env.NODE_ENV !== "production" && o >= 1e10 && console.warn(["MUI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), o);
  return (l, c) => {
    const f = c.options.name;
    if (f && f.indexOf("Mui") === 0 && !c.options.link && !t) {
      if (S5.indexOf(l.key) !== -1)
        return `Mui-${l.key}`;
      const g = `${i}${f}-${l.key}`;
      return !c.options.theme[u2] || n !== "" ? g : `${g}-${s()}`;
    }
    if (process.env.NODE_ENV === "production")
      return `${i}${r}${s()}`;
    const h = `${l.key}-${s()}`;
    return c.options.classNamePrefix ? `${i}${c.options.classNamePrefix}-${h}` : `${i}${h}`;
  };
}
var LC = Date.now(), $h = "fnValues" + LC, Uh = "fnStyle" + ++LC, C5 = function() {
  return {
    onCreateRule: function(r, n, i) {
      if (typeof n != "function") return null;
      var o = Vm(r, {}, i);
      return o[Uh] = n, o;
    },
    onProcessStyle: function(r, n) {
      if ($h in n || Uh in n) return r;
      var i = {};
      for (var o in r) {
        var s = r[o];
        typeof s == "function" && (delete r[o], i[o] = s);
      }
      return n[$h] = i, r;
    },
    onUpdate: function(r, n, i, o) {
      var s = n, l = s[Uh];
      if (l && (s.style = l(r) || {}, process.env.NODE_ENV === "development")) {
        for (var c in s.style)
          if (typeof s.style[c] == "function") {
            process.env.NODE_ENV !== "production" && Ki(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var f = s[$h];
      if (f)
        for (var h in f)
          s.prop(h, f[h](r), o);
    }
  };
}, Ha = "@global", Cv = "@global ", T5 = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "global", this.at = Ha, this.isProcessed = !1, this.key = r, this.options = i, this.rules = new dp(ct({}, i, {
      parent: this
    }));
    for (var o in n)
      this.rules.add(o, n[o]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(n) {
    return this.rules.get(n);
  }, t.addRule = function(n, i, o) {
    var s = this.rules.add(n, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.toString = function() {
    return this.rules.toString();
  }, e;
}(), O5 = /* @__PURE__ */ function() {
  function e(r, n, i) {
    this.type = "global", this.at = Ha, this.isProcessed = !1, this.key = r, this.options = i;
    var o = r.substr(Cv.length);
    this.rule = i.jss.createRule(o, n, ct({}, i, {
      parent: this
    }));
  }
  var t = e.prototype;
  return t.toString = function(n) {
    return this.rule ? this.rule.toString(n) : "";
  }, e;
}(), R5 = /\s*,\s*/g;
function zC(e, t) {
  for (var r = e.split(R5), n = "", i = 0; i < r.length; i++)
    n += t + " " + r[i].trim(), r[i + 1] && (n += ", ");
  return n;
}
function I5(e, t) {
  var r = e.options, n = e.style, i = n ? n[Ha] : null;
  if (i) {
    for (var o in i)
      t.addRule(o, i[o], ct({}, r, {
        selector: zC(o, e.selector)
      }));
    delete n[Ha];
  }
}
function D5(e, t) {
  var r = e.options, n = e.style;
  for (var i in n)
    if (!(i[0] !== "@" || i.substr(0, Ha.length) !== Ha)) {
      var o = zC(i.substr(Ha.length), e.selector);
      t.addRule(o, n[i], ct({}, r, {
        selector: o
      })), delete n[i];
    }
}
function P5() {
  function e(r, n, i) {
    if (!r) return null;
    if (r === Ha)
      return new T5(r, n, i);
    if (r[0] === "@" && r.substr(0, Cv.length) === Cv)
      return new O5(r, n, i);
    var o = i.parent;
    return o && (o.type === "global" || o.options.parent && o.options.parent.type === "global") && (i.scoped = !1), i.scoped === !1 && (i.selector = r), null;
  }
  function t(r, n) {
    r.type !== "style" || !n || (I5(r, n), D5(r, n));
  }
  return {
    onCreateRule: e,
    onProcessRule: t
  };
}
var gx = /\s*,\s*/g, M5 = /&/g, A5 = /\$([\w-]+)/g;
function N5() {
  function e(i, o) {
    return function(s, l) {
      var c = i.getRule(l) || o && o.getRule(l);
      return c ? c.selector : (process.env.NODE_ENV !== "production" && Ki(!1, '[JSS] Could not find the referenced rule "' + l + '" in "' + (i.options.meta || i.toString()) + '".'), l);
    };
  }
  function t(i, o) {
    for (var s = o.split(gx), l = i.split(gx), c = "", f = 0; f < s.length; f++)
      for (var h = s[f], g = 0; g < l.length; g++) {
        var S = l[g];
        c && (c += ", "), c += S.indexOf("&") !== -1 ? S.replace(M5, h) : h + " " + S;
      }
    return c;
  }
  function r(i, o, s) {
    if (s) return ct({}, s, {
      index: s.index + 1
    });
    var l = i.options.nestingLevel;
    l = l === void 0 ? 1 : l + 1;
    var c = ct({}, i.options, {
      nestingLevel: l,
      index: o.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete c.name, c;
  }
  function n(i, o, s) {
    if (o.type !== "style") return i;
    var l = o, c = l.options.parent, f, h;
    for (var g in i) {
      var S = g.indexOf("&") !== -1, b = g[0] === "@";
      if (!(!S && !b)) {
        if (f = r(l, c, f), S) {
          var p = t(g, l.selector);
          h || (h = e(c, s)), p = p.replace(A5, h), c.addRule(p, i[g], ct({}, f, {
            selector: p
          }));
        } else b && c.addRule(g, {}, f).addRule(l.key, i[g], {
          selector: l.selector
        });
        delete i[g];
      }
    }
    return i;
  }
  return {
    onProcessStyle: n
  };
}
var j5 = /[A-Z]/g, k5 = /^ms-/, Gh = {};
function L5(e) {
  return "-" + e.toLowerCase();
}
function BC(e) {
  if (Gh.hasOwnProperty(e))
    return Gh[e];
  var t = e.replace(j5, L5);
  return Gh[e] = k5.test(t) ? "-" + t : t;
}
function Mf(e) {
  var t = {};
  for (var r in e) {
    var n = r.indexOf("--") === 0 ? r : BC(r);
    t[n] = e[r];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(Mf) : t.fallbacks = Mf(e.fallbacks)), t;
}
function z5() {
  function e(r) {
    if (Array.isArray(r)) {
      for (var n = 0; n < r.length; n++)
        r[n] = Mf(r[n]);
      return r;
    }
    return Mf(r);
  }
  function t(r, n, i) {
    if (n.indexOf("--") === 0)
      return r;
    var o = BC(n);
    return n === o ? r : (i.prop(o, r), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: t
  };
}
var Ue = Xm && CSS ? CSS.px : "px", Zd = Xm && CSS ? CSS.ms : "ms", vl = Xm && CSS ? CSS.percent : "%", B5 = {
  // Animation properties
  "animation-delay": Zd,
  "animation-duration": Zd,
  // Background properties
  "background-position": Ue,
  "background-position-x": Ue,
  "background-position-y": Ue,
  "background-size": Ue,
  // Border Properties
  border: Ue,
  "border-bottom": Ue,
  "border-bottom-left-radius": Ue,
  "border-bottom-right-radius": Ue,
  "border-bottom-width": Ue,
  "border-left": Ue,
  "border-left-width": Ue,
  "border-radius": Ue,
  "border-right": Ue,
  "border-right-width": Ue,
  "border-top": Ue,
  "border-top-left-radius": Ue,
  "border-top-right-radius": Ue,
  "border-top-width": Ue,
  "border-width": Ue,
  "border-block": Ue,
  "border-block-end": Ue,
  "border-block-end-width": Ue,
  "border-block-start": Ue,
  "border-block-start-width": Ue,
  "border-block-width": Ue,
  "border-inline": Ue,
  "border-inline-end": Ue,
  "border-inline-end-width": Ue,
  "border-inline-start": Ue,
  "border-inline-start-width": Ue,
  "border-inline-width": Ue,
  "border-start-start-radius": Ue,
  "border-start-end-radius": Ue,
  "border-end-start-radius": Ue,
  "border-end-end-radius": Ue,
  // Margin properties
  margin: Ue,
  "margin-bottom": Ue,
  "margin-left": Ue,
  "margin-right": Ue,
  "margin-top": Ue,
  "margin-block": Ue,
  "margin-block-end": Ue,
  "margin-block-start": Ue,
  "margin-inline": Ue,
  "margin-inline-end": Ue,
  "margin-inline-start": Ue,
  // Padding properties
  padding: Ue,
  "padding-bottom": Ue,
  "padding-left": Ue,
  "padding-right": Ue,
  "padding-top": Ue,
  "padding-block": Ue,
  "padding-block-end": Ue,
  "padding-block-start": Ue,
  "padding-inline": Ue,
  "padding-inline-end": Ue,
  "padding-inline-start": Ue,
  // Mask properties
  "mask-position-x": Ue,
  "mask-position-y": Ue,
  "mask-size": Ue,
  // Width and height properties
  height: Ue,
  width: Ue,
  "min-height": Ue,
  "max-height": Ue,
  "min-width": Ue,
  "max-width": Ue,
  // Position properties
  bottom: Ue,
  left: Ue,
  top: Ue,
  right: Ue,
  inset: Ue,
  "inset-block": Ue,
  "inset-block-end": Ue,
  "inset-block-start": Ue,
  "inset-inline": Ue,
  "inset-inline-end": Ue,
  "inset-inline-start": Ue,
  // Shadow properties
  "box-shadow": Ue,
  "text-shadow": Ue,
  // Column properties
  "column-gap": Ue,
  "column-rule": Ue,
  "column-rule-width": Ue,
  "column-width": Ue,
  // Font and text properties
  "font-size": Ue,
  "font-size-delta": Ue,
  "letter-spacing": Ue,
  "text-decoration-thickness": Ue,
  "text-indent": Ue,
  "text-stroke": Ue,
  "text-stroke-width": Ue,
  "word-spacing": Ue,
  // Motion properties
  motion: Ue,
  "motion-offset": Ue,
  // Outline properties
  outline: Ue,
  "outline-offset": Ue,
  "outline-width": Ue,
  // Perspective properties
  perspective: Ue,
  "perspective-origin-x": vl,
  "perspective-origin-y": vl,
  // Transform properties
  "transform-origin": vl,
  "transform-origin-x": vl,
  "transform-origin-y": vl,
  "transform-origin-z": vl,
  // Transition properties
  "transition-delay": Zd,
  "transition-duration": Zd,
  // Alignment properties
  "vertical-align": Ue,
  "flex-basis": Ue,
  // Some random properties
  "shape-margin": Ue,
  size: Ue,
  gap: Ue,
  // Grid properties
  grid: Ue,
  "grid-gap": Ue,
  "row-gap": Ue,
  "grid-row-gap": Ue,
  "grid-column-gap": Ue,
  "grid-template-rows": Ue,
  "grid-template-columns": Ue,
  "grid-auto-rows": Ue,
  "grid-auto-columns": Ue,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": Ue,
  "box-shadow-y": Ue,
  "box-shadow-blur": Ue,
  "box-shadow-spread": Ue,
  "font-line-height": Ue,
  "text-shadow-x": Ue,
  "text-shadow-y": Ue,
  "text-shadow-blur": Ue
};
function FC(e) {
  var t = /(-[a-z])/g, r = function(s) {
    return s[1].toUpperCase();
  }, n = {};
  for (var i in e)
    n[i] = e[i], n[i.replace(t, r)] = e[i];
  return n;
}
var F5 = FC(B5);
function cc(e, t, r) {
  if (t == null) return t;
  if (Array.isArray(t))
    for (var n = 0; n < t.length; n++)
      t[n] = cc(e, t[n], r);
  else if (typeof t == "object")
    if (e === "fallbacks")
      for (var i in t)
        t[i] = cc(i, t[i], r);
    else
      for (var o in t)
        t[o] = cc(e + "-" + o, t[o], r);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var s = r[e] || F5[e];
    return s && !(t === 0 && s === Ue) ? typeof s == "function" ? s(t).toString() : "" + t + s : t.toString();
  }
  return t;
}
function W5(e) {
  e === void 0 && (e = {});
  var t = FC(e);
  function r(i, o) {
    if (o.type !== "style") return i;
    for (var s in i)
      i[s] = cc(s, i[s], t);
    return i;
  }
  function n(i, o) {
    return cc(o, i, t);
  }
  return {
    onProcessStyle: r,
    onChangeValue: n
  };
}
function Tv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function H5(e) {
  if (Array.isArray(e)) return Tv(e);
}
function $5(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function U5(e, t) {
  if (e) {
    if (typeof e == "string") return Tv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Tv(e, t);
  }
}
function G5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q5(e) {
  return H5(e) || $5(e) || U5(e) || G5();
}
var rc = "", Ov = "", WC = "", HC = "", V5 = Vc && "ontouchstart" in document.documentElement;
if (Vc) {
  var qh = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, Y5 = document.createElement("p"), Vh = Y5.style, K5 = "Transform";
  for (var Yh in qh)
    if (Yh + K5 in Vh) {
      rc = Yh, Ov = qh[Yh];
      break;
    }
  rc === "Webkit" && "msHyphens" in Vh && (rc = "ms", Ov = qh.ms, HC = "edge"), rc === "Webkit" && "-apple-trailing-word" in Vh && (WC = "apple");
}
var Ut = {
  js: rc,
  css: Ov,
  vendor: WC,
  browser: HC,
  isTouch: V5
};
function X5(e) {
  return e[1] === "-" || Ut.js === "ms" ? e : "@" + Ut.css + "keyframes" + e.substr(10);
}
var J5 = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : Ut.js === "ms" ? "-webkit-" + t : Ut.css + t;
  }
}, Z5 = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : Ut.js === "Webkit" ? Ut.css + "print-" + t : t;
  }
}, Q5 = /[-\s]+(.)?/g;
function eH(e, t) {
  return t ? t.toUpperCase() : "";
}
function Jm(e) {
  return e.replace(Q5, eH);
}
function Xa(e) {
  return Jm("-" + e);
}
var tH = {
  noPrefill: ["mask"],
  supportedProperty: function(t, r) {
    if (!/^mask/.test(t)) return !1;
    if (Ut.js === "Webkit") {
      var n = "mask-image";
      if (Jm(n) in r)
        return t;
      if (Ut.js + Xa(n) in r)
        return Ut.css + t;
    }
    return t;
  }
}, rH = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : Ut.vendor === "apple" && !Ut.isTouch ? Ut.css + t : t;
  }
}, nH = {
  noPrefill: ["transform"],
  supportedProperty: function(t, r, n) {
    return t !== "transform" ? !1 : n.transform ? t : Ut.css + t;
  }
}, iH = {
  noPrefill: ["transition"],
  supportedProperty: function(t, r, n) {
    return t !== "transition" ? !1 : n.transition ? t : Ut.css + t;
  }
}, oH = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : Ut.js === "Webkit" || Ut.js === "ms" && Ut.browser !== "edge" ? Ut.css + t : t;
  }
}, aH = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : Ut.js === "Moz" || Ut.js === "ms" || Ut.vendor === "apple" ? Ut.css + t : t;
  }
}, sH = {
  supportedProperty: function(t, r) {
    if (!/^break-/.test(t)) return !1;
    if (Ut.js === "Webkit") {
      var n = "WebkitColumn" + Xa(t);
      return n in r ? Ut.css + "column-" + t : !1;
    }
    if (Ut.js === "Moz") {
      var i = "page" + Xa(t);
      return i in r ? "page-" + t : !1;
    }
    return !1;
  }
}, lH = {
  supportedProperty: function(t, r) {
    if (!/^(border|margin|padding)-inline/.test(t)) return !1;
    if (Ut.js === "Moz") return t;
    var n = t.replace("-inline", "");
    return Ut.js + Xa(n) in r ? Ut.css + n : !1;
  }
}, uH = {
  supportedProperty: function(t, r) {
    return Jm(t) in r ? t : !1;
  }
}, cH = {
  supportedProperty: function(t, r) {
    var n = Xa(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : Ut.js + n in r ? Ut.css + t : Ut.js !== "Webkit" && "Webkit" + n in r ? "-webkit-" + t : !1;
  }
}, dH = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : Ut.js === "ms" ? "" + Ut.css + t : t;
  }
}, fH = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : Ut.js === "ms" ? Ut.css + "scroll-chaining" : t;
  }
}, pH = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, hH = {
  supportedProperty: function(t, r) {
    var n = pH[t];
    return n && Ut.js + Xa(n) in r ? Ut.css + n : !1;
  }
}, $C = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, gH = Object.keys($C), vH = function(t) {
  return Ut.css + t;
}, mH = {
  supportedProperty: function(t, r, n) {
    var i = n.multiple;
    if (gH.indexOf(t) > -1) {
      var o = $C[t];
      if (!Array.isArray(o))
        return Ut.js + Xa(o) in r ? Ut.css + o : !1;
      if (!i) return !1;
      for (var s = 0; s < o.length; s++)
        if (!(Ut.js + Xa(o[0]) in r))
          return !1;
      return o.map(vH);
    }
    return !1;
  }
}, UC = [J5, Z5, tH, rH, nH, iH, oH, aH, sH, lH, uH, cH, dH, fH, hH, mH], vx = UC.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), yH = UC.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, t) {
  return e.push.apply(e, q5(t.noPrefill)), e;
}, []), nc, Ds = {};
if (Vc) {
  nc = document.createElement("p");
  var Kh = window.getComputedStyle(document.documentElement, "");
  for (var Xh in Kh)
    isNaN(Xh) || (Ds[Kh[Xh]] = Kh[Xh]);
  yH.forEach(function(e) {
    return delete Ds[e];
  });
}
function Rv(e, t) {
  if (t === void 0 && (t = {}), !nc) return e;
  if (process.env.NODE_ENV !== "benchmark" && Ds[e] != null)
    return Ds[e];
  (e === "transition" || e === "transform") && (t[e] = e in nc.style);
  for (var r = 0; r < vx.length && (Ds[e] = vx[r](e, nc.style, t), !Ds[e]); r++)
    ;
  try {
    nc.style[e] = "";
  } catch {
    return !1;
  }
  return Ds[e];
}
var ml = {}, bH = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, wH = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, Ma;
function xH(e, t, r) {
  if (t === "var") return "var";
  if (t === "all") return "all";
  if (r === "all") return ", all";
  var n = t ? Rv(t) : ", " + Rv(r);
  return n || t || r;
}
Vc && (Ma = document.createElement("p"));
function mx(e, t) {
  var r = t;
  if (!Ma || e === "content") return t;
  if (typeof r != "string" || !isNaN(parseInt(r, 10)))
    return r;
  var n = e + r;
  if (process.env.NODE_ENV !== "benchmark" && ml[n] != null)
    return ml[n];
  try {
    Ma.style[e] = r;
  } catch {
    return ml[n] = !1, !1;
  }
  if (bH[e])
    r = r.replace(wH, xH);
  else if (Ma.style[e] === "" && (r = Ut.css + r, r === "-ms-flex" && (Ma.style[e] = "-ms-flexbox"), Ma.style[e] = r, Ma.style[e] === ""))
    return ml[n] = !1, !1;
  return Ma.style[e] = "", ml[n] = r, ml[n];
}
function _H() {
  function e(i) {
    if (i.type === "keyframes") {
      var o = i;
      o.at = X5(o.at);
    }
  }
  function t(i) {
    for (var o in i) {
      var s = i[o];
      if (o === "fallbacks" && Array.isArray(s)) {
        i[o] = s.map(t);
        continue;
      }
      var l = !1, c = Rv(o);
      c && c !== o && (l = !0);
      var f = !1, h = mx(c, ks(s));
      h && h !== s && (f = !0), (l || f) && (l && delete i[o], i[c || o] = h || s);
    }
    return i;
  }
  function r(i, o) {
    return o.type !== "style" ? i : t(i);
  }
  function n(i, o) {
    return mx(o, ks(i)) || i;
  }
  return {
    onProcessRule: e,
    onProcessStyle: r,
    onChangeValue: n
  };
}
function SH() {
  var e = function(r, n) {
    return r.length === n.length ? r > n ? 1 : -1 : r.length - n.length;
  };
  return {
    onProcessStyle: function(r, n) {
      if (n.type !== "style") return r;
      for (var i = {}, o = Object.keys(r).sort(e), s = 0; s < o.length; s++)
        i[o[s]] = r[o[s]];
      return i;
    }
  };
}
function GC() {
  return {
    plugins: [
      C5(),
      P5(),
      N5(),
      z5(),
      W5(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : _H(),
      SH()
    ]
  };
}
const EH = ["children", "injectFirst", "disableGeneration"], CH = Km(GC()), TH = E5(), OH = /* @__PURE__ */ new Map(), RH = {
  disableGeneration: !1,
  generateClassName: TH,
  jss: CH,
  sheetsCache: null,
  sheetsManager: OH,
  sheetsRegistry: null
}, Af = /* @__PURE__ */ Be.createContext(RH);
process.env.NODE_ENV !== "production" && (Af.displayName = "StylesContext");
let Qd;
function Iv(e) {
  const {
    children: t,
    injectFirst: r = !1,
    disableGeneration: n = !1
  } = e, i = qm(e, EH), o = Be.useContext(Af), s = oa({}, o, {
    disableGeneration: n
  }, i);
  if (process.env.NODE_ENV !== "production" && typeof window > "u" && !s.sheetsManager && console.error("MUI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && s.jss.options.insertionPoint && r && console.error("MUI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && r && i.jss && console.error("MUI: You cannot use the jss and injectFirst props at the same time."), !s.jss.options.insertionPoint && r && typeof window < "u") {
    if (!Qd) {
      const l = document.head;
      Qd = document.createComment("mui-inject-first"), l.insertBefore(Qd, l.firstChild);
    }
    s.jss = Km({
      plugins: GC().plugins,
      insertionPoint: Qd
    });
  }
  return /* @__PURE__ */ y.jsx(Af.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Iv.propTypes = {
  /**
   * Your component tree.
   */
  children: D.node,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: D.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: D.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: D.bool,
  /**
   * JSS's instance.
   */
  jss: D.object,
  /**
   * @ignore
   */
  serverGenerateClassName: D.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: D.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: D.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: D.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Iv.propTypes = Tm(Iv.propTypes));
let Jh = -1e9;
function IH() {
  return Jh += 1, process.env.NODE_ENV !== "production" && Jh >= 0 && console.warn(["MUI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), Jh;
}
const DH = ["variant"];
function yx(e) {
  return e.length === 0;
}
function PH(e) {
  const {
    variant: t
  } = e, r = qm(e, DH);
  let n = t || "";
  return Object.keys(r).sort().forEach((i) => {
    i === "color" ? n += yx(n) ? e[i] : Wr(e[i]) : n += `${yx(n) ? i : Wr(i)}${Wr(e[i].toString())}`;
  }), n;
}
const qC = {};
function MH(e) {
  const t = typeof e == "function";
  return process.env.NODE_ENV !== "production" && typeof e != "object" && !t && console.error(["MUI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: (r, n) => {
      let i;
      try {
        i = t ? e(r) : e;
      } catch (c) {
        throw process.env.NODE_ENV !== "production" && t === !0 && r === qC && console.error(["MUI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), c;
      }
      if (!n || !r.components || !r.components[n] || !r.components[n].styleOverrides && !r.components[n].variants)
        return i;
      const o = r.components[n].styleOverrides || {}, s = r.components[n].variants || [], l = oa({}, i);
      return Object.keys(o).forEach((c) => {
        process.env.NODE_ENV !== "production" && (l[c] || console.warn(["MUI: You are trying to override a style that does not exist.", `Fix the \`${c}\` key of \`theme.components.${n}.styleOverrides\`.`, "", `If you intentionally wanted to add a new key, please use the theme.components[${n}].variants option.`].join(`
`))), l[c] = po(l[c] || {}, o[c]);
      }), s.forEach((c) => {
        const f = PH(c.props);
        l[f] = po(l[f] || {}, c.style);
      }), l;
    },
    options: {}
  };
}
const AH = ["name", "classNamePrefix", "Component", "defaultTheme"];
function NH({
  state: e,
  stylesOptions: t
}, r, n) {
  if (t.disableGeneration)
    return r || {};
  e.cacheClasses || (e.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  let i = !1;
  return e.classes !== e.cacheClasses.lastJSS && (e.cacheClasses.lastJSS = e.classes, i = !0), r !== e.cacheClasses.lastProp && (e.cacheClasses.lastProp = r, i = !0), i && (e.cacheClasses.value = kC({
    baseClasses: e.cacheClasses.lastJSS,
    newClasses: r,
    Component: n
  })), e.cacheClasses.value;
}
function jH({
  state: e,
  theme: t,
  stylesOptions: r,
  stylesCreator: n,
  name: i
}, o) {
  if (r.disableGeneration)
    return;
  let s = Il.get(r.sheetsManager, n, t);
  s || (s = {
    refs: 0,
    staticSheet: null,
    dynamicStyles: null
  }, Il.set(r.sheetsManager, n, t, s));
  const l = oa({}, n.options, r, {
    theme: t,
    flip: typeof r.flip == "boolean" ? r.flip : t.direction === "rtl"
  });
  l.generateId = l.serverGenerateClassName || l.generateClassName;
  const c = r.sheetsRegistry;
  if (s.refs === 0) {
    let f;
    r.sheetsCache && (f = Il.get(r.sheetsCache, n, t));
    const h = n.create(t, i);
    f || (f = r.jss.createStyleSheet(h, oa({
      link: !1
    }, l)), f.attach(), r.sheetsCache && Il.set(r.sheetsCache, n, t, f)), c && c.add(f), s.staticSheet = f, s.dynamicStyles = jC(h);
  }
  if (s.dynamicStyles) {
    const f = r.jss.createStyleSheet(s.dynamicStyles, oa({
      link: !0
    }, l));
    f.update(o), f.attach(), e.dynamicSheet = f, e.classes = kC({
      baseClasses: s.staticSheet.classes,
      newClasses: f.classes
    }), c && c.add(f);
  } else
    e.classes = s.staticSheet.classes;
  s.refs += 1;
}
function kH({
  state: e
}, t) {
  e.dynamicSheet && e.dynamicSheet.update(t);
}
function LH({
  state: e,
  theme: t,
  stylesOptions: r,
  stylesCreator: n
}) {
  if (r.disableGeneration)
    return;
  const i = Il.get(r.sheetsManager, n, t);
  i.refs -= 1;
  const o = r.sheetsRegistry;
  i.refs === 0 && (Il.delete(r.sheetsManager, n, t), r.jss.removeStyleSheet(i.staticSheet), o && o.remove(i.staticSheet)), e.dynamicSheet && (r.jss.removeStyleSheet(e.dynamicSheet), o && o.remove(e.dynamicSheet));
}
function zH(e, t) {
  const r = Be.useRef([]);
  let n;
  const i = Be.useMemo(() => ({}), t);
  r.current !== i && (r.current = i, n = e()), Be.useEffect(
    () => () => {
      n && n();
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function fp(e, t = {}) {
  const {
    // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name: r,
    // Help with debuggability.
    classNamePrefix: n,
    Component: i,
    defaultTheme: o = qC
  } = t, s = qm(t, AH), l = MH(e), c = r || n || "makeStyles";
  return l.options = {
    index: IH(),
    name: r,
    meta: c,
    classNamePrefix: c
  }, (h = {}) => {
    const g = gC() || o, S = oa({}, Be.useContext(Af), s), b = Be.useRef(), p = Be.useRef();
    zH(() => {
      const w = {
        name: r,
        state: {},
        stylesCreator: l,
        stylesOptions: S,
        theme: g
      };
      return jH(w, h), p.current = !1, b.current = w, () => {
        LH(w);
      };
    }, [g, l]), Be.useEffect(() => {
      p.current && kH(b.current, h), p.current = !0;
    });
    const v = NH(b.current, h.classes, i);
    return process.env.NODE_ENV !== "production" && Be.useDebugValue(v), process.env.NODE_ENV !== "production" && r && ["MuiAvatar", "MuiBadge", "MuiButton", "MuiButtonGroup", "MuiChip", "MuiDivider", "MuiFab", "MuiPaper", "MuiToolbar", "MuiTypography", "MuiAlert", "MuiPagination", "MuiPaginationItem", "MuiSkeleton", "MuiTimelineDot"].indexOf(r) >= 0 && h.variant && !v[h.variant] && console.error([`MUI: You are using a variant value \`${h.variant}\` for which you didn't define styles.`, "Please create a new variant matcher in your theme for this variant. To learn more about matchers visit https://mui.com/r/custom-component-variants."].join(`
`)), v;
  };
}
const yl = 142, bl = 85, BH = fp((e) => ({
  empty: {
    color: e.palette.grey[500]
  },
  imageFallback: {
    color: e.palette.grey[300],
    fontSize: "4rem"
  },
  lockButton: ({ size: t }) => ({
    marginLeft: t === bi.LARGE ? e.spacing(2) : e.spacing(1),
    zIndex: 1,
    "& > button": {
      backgroundColor: e.palette.primary.main,
      boxShadow: "none",
      color: e.palette.common.white,
      "&:hover": {
        boxShadow: "none"
      },
      "& svg": {
        fill: e.palette.common.white
      }
    }
  }),
  mainTitle: {
    "@supports (-webkit-line-clamp: 2)": {
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": 1,
      display: "-webkit-box",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  media: {
    backgroundColor: e.palette.grey[200],
    flex: "1 auto",
    height: ({ size: t }) => t === bi.LARGE ? yl : bl,
    overflow: "hidden",
    width: "100%"
  },
  brandkey: {
    position: "absolute",
    color: "white",
    backgroundColor: an(e.palette.common.black, 0.6),
    top: 5,
    left: 5,
    margin: e.spacing(1, 0, 0, 1),
    padding: e.spacing(0, 0.5, 0, 0.5),
    zIndex: 1,
    borderRadius: 2
  },
  innerWrapper: () => ({
    backgroundColor: e.palette.common.white,
    display: "flex",
    position: "relative",
    zIndex: 1,
    maxWidth: "100%",
    transition: e.transitions.create("all", {
      duration: e.transitions.duration.enteringScreen
    })
  }),
  status: {
    marginTop: e.spacing(3.25),
    width: "fit-content"
  },
  topTitle: {
    color: e.palette.grey[500],
    marginBottom: e.spacing(0.5),
    fontSize: ({ size: t }) => t !== bi.LARGE ? e.typography.caption.fontSize : "inherit"
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: e.spacing(0.25)
  },
  wrapper: ({ size: t }) => ({
    backgroundColor: e.palette.common.white,
    border: t === bi.LARGE ? "none" : `solid 1px ${e.palette.grey[300]}`,
    boxShadow: "none",
    height: t === bi.LARGE ? yl : bl,
    position: "relative",
    transition: e.transitions.create("all", {
      duration: e.transitions.duration.leavingScreen
    })
  }),
  wrapperCenter: ({ size: t }) => ({
    height: t === bi.LARGE ? yl : bl,
    flex: "1 auto",
    padding: t === bi.LARGE ? e.spacing(1.5, 1.5, 1.5, 3) : e.spacing(1, 1, 1, 2),
    "& > h2": {
      color: e.palette.grey[800],
      fontWeight: 500,
      fontSize: t === bi.LARGE ? 20 : 16
    }
  }),
  wrapperLeftSide: ({ size: t }) => ({
    maxWidth: t !== bi.LARGE ? bl * 1.5 : yl * 2,
    minWidth: t !== bi.LARGE ? bl * 1.5 : yl * 2,
    minHeight: t === bi.LARGE ? yl : bl,
    position: "relative"
  }),
  wrapperActionsIcons: {
    alignItems: "center",
    color: e.palette.grey[400],
    display: "flex",
    position: "absolute",
    right: e.spacing(1.75),
    top: e.spacing(1),
    "& span": {
      alignItems: "center",
      display: "flex",
      "& > p": {
        color: e.palette.grey[500],
        fontSize: ".85rem",
        marginLeft: e.spacing(0.5),
        paddingRight: e.spacing(0.85)
      },
      "& svg": {
        fontSize: "1.75rem"
      }
    }
  },
  eventTitle: {
    fontWeight: 500,
    color: "#2e7d32",
    position: "absolute",
    bottom: e.spacing(1.5)
  },
  categoryTitle: {
    fontWeight: 500,
    color: "#4a90e2",
    position: "absolute",
    bottom: e.spacing(3.5)
  },
  wrapperRightSide: ({ size: t }) => ({
    alignItems: t === bi.LARGE ? "flex-end" : "center",
    display: "flex",
    padding: e.spacing(2, 2, 2, 0)
  }),
  paidArticle: {
    backgroundColor: "rgb(243, 167, 18)",
    color: e.palette.common.white,
    borderRadius: 2,
    fontSize: ".85rem",
    padding: e.spacing(0, 0.4),
    margin: e.spacing(0, 1, 0, 0)
  }
}));
var bi = /* @__PURE__ */ ((e) => (e.LARGE = "LARGE", e.MEDIUM = "MEDIUM", e.SMALL = "SMALL", e))(bi || {});
const YJ = ({
  ActionsIcons: e,
  ActionsMenu: t,
  Icons: r,
  children: n,
  createdAt: i,
  id: o,
  media: s,
  onCardClick: l,
  lockedBy: c,
  isLocked: f,
  updateLocker: h,
  size: g = "LARGE",
  title: S,
  topTitle: b,
  updatedAt: p,
  brandKey: v,
  eventTitle: w,
  categoryTitle: C,
  dataTestId: M,
  isPaidArticle: L,
  statusTitle: W,
  hasPush: z,
  pushCount: B,
  titleOverflow: K
}) => {
  const { openMenu: Z, closeMenu: ee } = Xl(), [he, _e] = Xe(!1), Te = BH({ isCardOver: he, size: g }), fe = kt(() => {
    if (b)
      return b;
    let Oe = i ? `${AW} ${_c(new Date(i), "dd/MM/yyyy à HH:mm", {
      locale: Df
    })}` : null;
    const ye = p ? `${NW} ${_c(new Date(p), "dd/MM/yyyy à HH:mm", {
      locale: Df
    })}` : null, de = !(Oe != null && Oe.length) && !(ye != null && ye.length);
    return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      Oe ? Oe += ye ? " - " : "" : "",
      ye ?? "",
      de ? "" : "."
    ] });
  }, [i, p, b]);
  return /* @__PURE__ */ y.jsx(
    Bo,
    {
      className: Te.wrapper,
      onClick: l == null ? void 0 : l(o),
      onMouseLeave: () => {
        _e(!1);
      },
      onMouseOver: () => {
        _e(!0);
      },
      variant: "outlined",
      ...M && { "data-testid": M },
      children: /* @__PURE__ */ y.jsxs("div", { className: Te.innerWrapper, children: [
        /* @__PURE__ */ y.jsxs("div", { className: Te.wrapperLeftSide, children: [
          /* @__PURE__ */ y.jsx(Lt, { className: Te.brandkey, children: v }),
          /* @__PURE__ */ y.jsx(
            qc,
            {
              className: Te.media,
              image: /* @__PURE__ */ y.jsx(yN, { className: Te.imageFallback }),
              loaderSize: 35,
              src: s,
              timeout: 3e3
            }
          )
        ] }),
        /* @__PURE__ */ y.jsxs("div", { className: Te.wrapperCenter, children: [
          /* @__PURE__ */ y.jsxs("div", { className: Te.titleWrapper, children: [
            L && /* @__PURE__ */ y.jsx("div", { className: Te.paidArticle, children: "★" }),
            /* @__PURE__ */ y.jsxs(Lt, { className: Te.topTitle, variant: "body2", children: [
              fe,
              !!z && " | "
            ] }),
            !!z && /* @__PURE__ */ y.jsx(Nr, { title: `${jW} ${B || 0}`, children: /* @__PURE__ */ y.jsx(bN, { fontSize: "small", sx: { color: mC[500] } }) })
          ] }),
          /* @__PURE__ */ y.jsx(
            Lt,
            {
              variant: "h5",
              component: "h2",
              className: nt(!K && Te.mainTitle),
              children: S || /* @__PURE__ */ y.jsx("em", { className: Te.empty, children: PW })
            }
          ),
          W && /* @__PURE__ */ y.jsx(
            Qa,
            {
              className: Te.status,
              label: W,
              variant: "outlined",
              size: "small"
            }
          ),
          /* @__PURE__ */ y.jsxs("div", { className: Te.wrapperActionsIcons, children: [
            e,
            " ",
            n || t
          ] }),
          /* @__PURE__ */ y.jsxs(zt, { children: [
            w && /* @__PURE__ */ y.jsx(Lt, { className: Te.eventTitle, variant: "caption", children: w }),
            /* @__PURE__ */ y.jsx("br", {}),
            C && /* @__PURE__ */ y.jsx(Lt, { className: Te.categoryTitle, variant: "caption", children: C })
          ] })
        ] }),
        /* @__PURE__ */ y.jsxs("div", { className: Te.wrapperRightSide, children: [
          r,
          c && /* @__PURE__ */ y.jsx(
            IC,
            {
              className: Te.lockButton,
              disableLockForV0: !0,
              lockedBy: c,
              onClick: (Oe) => {
                Oe.preventDefault(), f && Z(
                  Oe.currentTarget,
                  /* @__PURE__ */ y.jsx(
                    la,
                    {
                      onClick: () => {
                        h == null || h(o, null), ee();
                      },
                      children: MW
                    }
                  )
                );
              },
              size: "small"
            }
          )
        ] })
      ] })
    }
  );
}, FH = Rt((e) => ({
  chipList: {
    display: "flex",
    flexWrap: "wrap"
  },
  chipRoot: {
    maxWidth: "100%",
    marginBottom: e.spacing(1),
    marginRight: e.spacing(1)
  },
  chipLabel: {
    display: "block",
    textOverflow: "ellipsis",
    overflow: "hidden",
    userSelect: "auto"
  }
})), KJ = ({
  items: e,
  onClick: t,
  onDelete: r,
  clickable: n,
  defaultAvatar: i,
  color: o,
  className: s
}) => {
  const l = FH(), c = (f) => {
    const h = f.avatarUrl ? /* @__PURE__ */ y.jsx(
      kc,
      {
        alt: f.label,
        src: f.avatarUrl,
        imgProps: {
          onError: (g) => g.target.remove()
        }
      }
    ) : i;
    return /* @__PURE__ */ y.jsx(
      Qa,
      {
        label: f.label,
        classes: {
          root: l.chipRoot,
          label: l.chipLabel
        },
        onDelete: r && (() => r(f)),
        onClick: t && (() => t(f)),
        clickable: n,
        avatar: h,
        color: o
      },
      f.id
    );
  };
  return /* @__PURE__ */ y.jsx("div", { className: nt(l.chipList, s), children: e.map((f) => f.tooltip ? /* @__PURE__ */ y.jsx(Nr, { title: f.tooltip, children: c(f) }, f.id) : c(f)) });
};
function WH(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function bx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bx(Object(r), !0).forEach(function(n) {
      WH(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oi(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var xx = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), _x = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Sx = {
  INIT: "@@redux/INIT" + _x(),
  REPLACE: "@@redux/REPLACE" + _x()
};
function HH(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Cs(e) {
  var t = typeof e;
  if (process.env.NODE_ENV !== "production") {
    let r = function(s) {
      if (s === void 0) return "undefined";
      if (s === null) return "null";
      var l = typeof s;
      switch (l) {
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
          return l;
      }
      if (Array.isArray(s)) return "array";
      if (o(s)) return "date";
      if (i(s)) return "error";
      var c = n(s);
      switch (c) {
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
          return c;
      }
      return l.slice(8, -1).toLowerCase().replace(/\s/g, "");
    }, n = function(s) {
      return typeof s.constructor == "function" ? s.constructor.name : null;
    }, i = function(s) {
      return s instanceof Error || typeof s.message == "string" && s.constructor && typeof s.constructor.stackTraceLimit == "number";
    }, o = function(s) {
      return s instanceof Date ? !0 : typeof s.toDateString == "function" && typeof s.getDate == "function" && typeof s.setDate == "function";
    };
    t = r(e);
  }
  return t;
}
function VC(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? oi(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oi(1) : "Expected the enhancer to be a function. Instead, received: '" + Cs(r) + "'");
    return r(VC)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? oi(2) : "Expected the root reducer to be a function. Instead, received: '" + Cs(e) + "'");
  var i = e, o = t, s = [], l = s, c = !1;
  function f() {
    l === s && (l = s.slice());
  }
  function h() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oi(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function g(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oi(4) : "Expected the listener to be a function. Instead, received: '" + Cs(v) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oi(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var w = !0;
    return f(), l.push(v), function() {
      if (w) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? oi(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        w = !1, f();
        var M = l.indexOf(v);
        l.splice(M, 1), s = null;
      }
    };
  }
  function S(v) {
    if (!HH(v))
      throw new Error(process.env.NODE_ENV === "production" ? oi(7) : "Actions must be plain objects. Instead, the actual type was: '" + Cs(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oi(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oi(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, o = i(o, v);
    } finally {
      c = !1;
    }
    for (var w = s = l, C = 0; C < w.length; C++) {
      var M = w[C];
      M();
    }
    return v;
  }
  function b(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oi(10) : "Expected the nextReducer to be a function. Instead, received: '" + Cs(v));
    i = v, S({
      type: Sx.REPLACE
    });
  }
  function p() {
    var v, w = g;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(M) {
        if (typeof M != "object" || M === null)
          throw new Error(process.env.NODE_ENV === "production" ? oi(11) : "Expected the observer to be an object. Instead, received: '" + Cs(M) + "'");
        function L() {
          M.next && M.next(h());
        }
        L();
        var W = w(L);
        return {
          unsubscribe: W
        };
      }
    }, v[xx] = function() {
      return this;
    }, v;
  }
  return S({
    type: Sx.INIT
  }), n = {
    dispatch: S,
    subscribe: g,
    getState: h,
    replaceReducer: b
  }, n[xx] = p, n;
}
function $H(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Ex(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function Cx(e, t) {
  if (typeof e == "function")
    return Ex(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? oi(16) : "bindActionCreators expected an object or a function, but instead received: '" + Cs(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var i = e[n];
    typeof i == "function" && (r[n] = Ex(i, t));
  }
  return r;
}
function YC() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
function UH() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var i = n.apply(void 0, arguments), o = function() {
        throw new Error(process.env.NODE_ENV === "production" ? oi(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, s = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, l = t.map(function(c) {
        return c(s);
      });
      return o = YC.apply(void 0, l)(i.dispatch), wx(wx({}, i), {}, {
        dispatch: o
      });
    };
  };
}
function Tx() {
}
process.env.NODE_ENV !== "production" && typeof Tx.name == "string" && Tx.name !== "isCrushed" && $H('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
var Zm = /* @__PURE__ */ dt.createContext(null);
process.env.NODE_ENV !== "production" && (Zm.displayName = "ReactRedux");
function GH(e) {
  e();
}
var KC = GH, qH = function(t) {
  return KC = t;
}, VH = function() {
  return KC;
}, Ox = {
  notify: function() {
  }
};
function YH() {
  var e = VH(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var i = t; i; )
          i.callback(), i = i.next;
      });
    },
    get: function() {
      for (var i = [], o = t; o; )
        i.push(o), o = o.next;
      return i;
    },
    subscribe: function(i) {
      var o = !0, s = r = {
        callback: i,
        next: null,
        prev: r
      };
      return s.prev ? s.prev.next = s : t = s, function() {
        !o || t === null || (o = !1, s.next ? s.next.prev = s.prev : r = s.prev, s.prev ? s.prev.next = s.next : t = s.next);
      };
    }
  };
}
var XC = /* @__PURE__ */ function() {
  function e(r, n) {
    this.store = r, this.parentSub = n, this.unsubscribe = null, this.listeners = Ox, this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }
  var t = e.prototype;
  return t.addNestedSub = function(n) {
    return this.trySubscribe(), this.listeners.subscribe(n);
  }, t.notifyNestedSubs = function() {
    this.listeners.notify();
  }, t.handleChangeWrapper = function() {
    this.onStateChange && this.onStateChange();
  }, t.isSubscribed = function() {
    return !!this.unsubscribe;
  }, t.trySubscribe = function() {
    this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper), this.listeners = YH());
  }, t.tryUnsubscribe = function() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = Ox);
  }, e;
}(), JC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? um : pt;
function ZC(e) {
  var t = e.store, r = e.context, n = e.children, i = kt(function() {
    var l = new XC(t);
    return l.onStateChange = l.notifyNestedSubs, {
      store: t,
      subscription: l
    };
  }, [t]), o = kt(function() {
    return t.getState();
  }, [t]);
  JC(function() {
    var l = i.subscription;
    return l.trySubscribe(), o !== t.getState() && l.notifyNestedSubs(), function() {
      l.tryUnsubscribe(), l.onStateChange = null;
    };
  }, [i, o]);
  var s = r || Zm;
  return /* @__PURE__ */ dt.createElement(s.Provider, {
    value: i
  }, n);
}
process.env.NODE_ENV !== "production" && (ZC.propTypes = {
  store: D.shape({
    subscribe: D.func.isRequired,
    dispatch: D.func.isRequired,
    getState: D.func.isRequired
  }),
  context: D.object,
  children: D.any
});
var Zh, Rx;
function KH() {
  if (Rx) return Zh;
  Rx = 1;
  var e = Yl(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = n, o[e.Memo] = i;
  function s(p) {
    return e.isMemo(p) ? i : o[p.$$typeof] || t;
  }
  var l = Object.defineProperty, c = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, h = Object.getOwnPropertyDescriptor, g = Object.getPrototypeOf, S = Object.prototype;
  function b(p, v, w) {
    if (typeof v != "string") {
      if (S) {
        var C = g(v);
        C && C !== S && b(p, C, w);
      }
      var M = c(v);
      f && (M = M.concat(f(v)));
      for (var L = s(p), W = s(v), z = 0; z < M.length; ++z) {
        var B = M[z];
        if (!r[B] && !(w && w[B]) && !(W && W[B]) && !(L && L[B])) {
          var K = h(v, B);
          try {
            l(p, B, K);
          } catch {
          }
        }
      }
    }
    return p;
  }
  return Zh = b, Zh;
}
var XH = KH();
const Ix = /* @__PURE__ */ jr(XH);
var Dx = Yl(), JH = [], ZH = [null, null], QH = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function e4(e, t) {
  var r = e[1];
  return [t.payload, r + 1];
}
function Px(e, t, r) {
  JC(function() {
    return e.apply(void 0, t);
  }, r);
}
function t4(e, t, r, n, i, o, s) {
  e.current = n, t.current = i, r.current = !1, o.current && (o.current = null, s());
}
function r4(e, t, r, n, i, o, s, l, c, f) {
  if (e) {
    var h = !1, g = null, S = function() {
      if (!h) {
        var v = t.getState(), w, C;
        try {
          w = n(v, i.current);
        } catch (M) {
          C = M, g = M;
        }
        C || (g = null), w === o.current ? s.current || c() : (o.current = w, l.current = w, s.current = !0, f({
          type: "STORE_UPDATED",
          payload: {
            error: C
          }
        }));
      }
    };
    r.onStateChange = S, r.trySubscribe(), S();
    var b = function() {
      if (h = !0, r.tryUnsubscribe(), r.onStateChange = null, g)
        throw g;
    };
    return b;
  }
}
var n4 = function() {
  return [null, 0];
};
function i4(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.getDisplayName, i = n === void 0 ? function(B) {
    return "ConnectAdvanced(" + B + ")";
  } : n, o = r.methodName, s = o === void 0 ? "connectAdvanced" : o, l = r.renderCountProp, c = l === void 0 ? void 0 : l, f = r.shouldHandleStateChanges, h = f === void 0 ? !0 : f, g = r.storeKey, S = g === void 0 ? "store" : g, b = r.withRef, p = b === void 0 ? !1 : b, v = r.forwardRef, w = v === void 0 ? !1 : v, C = r.context, M = C === void 0 ? Zm : C, L = zs(r, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
  if (process.env.NODE_ENV !== "production") {
    if (c !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (p)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var W = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (S !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + W);
  }
  var z = M;
  return function(K) {
    if (process.env.NODE_ENV !== "production" && !Dx.isValidElementType(K))
      throw new Error("You must pass a component to the function returned by " + (s + ". Instead received " + QH(K)));
    var Z = K.displayName || K.name || "Component", ee = i(Z), he = ct({}, L, {
      getDisplayName: i,
      methodName: s,
      renderCountProp: c,
      shouldHandleStateChanges: h,
      storeKey: S,
      displayName: ee,
      wrappedComponentName: Z,
      WrappedComponent: K
    }), _e = L.pure;
    function Te(ce) {
      return e(ce.dispatch, he);
    }
    var fe = _e ? kt : function(ce) {
      return ce();
    };
    function Oe(ce) {
      var Fe = kt(function() {
        var et = ce.reactReduxForwardedRef, at = zs(ce, ["reactReduxForwardedRef"]);
        return [ce.context, et, at];
      }, [ce]), le = Fe[0], J = Fe[1], re = Fe[2], be = kt(function() {
        return le && le.Consumer && Dx.isContextConsumer(/* @__PURE__ */ dt.createElement(le.Consumer, null)) ? le : z;
      }, [le, z]), Me = qi(be), Ae = !!ce.store && !!ce.store.getState && !!ce.store.dispatch, Re = !!Me && !!Me.store;
      if (process.env.NODE_ENV !== "production" && !Ae && !Re)
        throw new Error('Could not find "store" in the context of ' + ('"' + ee + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + ee + " in connect options."));
      var Ee = Ae ? ce.store : Me.store, Ce = kt(function() {
        return Te(Ee);
      }, [Ee]), X = kt(function() {
        if (!h) return ZH;
        var et = new XC(Ee, Ae ? null : Me.subscription), at = et.notifyNestedSubs.bind(et);
        return [et, at];
      }, [Ee, Ae, Me]), ie = X[0], Ie = X[1], xe = kt(function() {
        return Ae ? Me : ct({}, Me, {
          subscription: ie
        });
      }, [Ae, Me, ie]), Pe = cm(e4, JH, n4), ae = Pe[0], rt = ae[0], Ze = Pe[1];
      if (rt && rt.error)
        throw rt.error;
      var ht = bt(), mt = bt(re), At = bt(), Bt = bt(!1), Gt = fe(function() {
        return At.current && re === mt.current ? At.current : Ce(Ee.getState(), re);
      }, [Ee, rt, re]);
      Px(t4, [mt, ht, Bt, re, Gt, At, Ie]), Px(r4, [h, Ee, ie, Ce, mt, ht, Bt, At, Ie, Ze], [Ee, ie, Ce]);
      var It = kt(function() {
        return /* @__PURE__ */ dt.createElement(K, ct({}, Gt, {
          ref: J
        }));
      }, [J, K, Gt]), sr = kt(function() {
        return h ? /* @__PURE__ */ dt.createElement(be.Provider, {
          value: xe
        }, It) : It;
      }, [be, It, xe]);
      return sr;
    }
    var ye = _e ? dt.memo(Oe) : Oe;
    if (ye.WrappedComponent = K, ye.displayName = Oe.displayName = ee, w) {
      var de = dt.forwardRef(function(Fe, le) {
        return /* @__PURE__ */ dt.createElement(ye, ct({}, Fe, {
          reactReduxForwardedRef: le
        }));
      });
      return de.displayName = ee, de.WrappedComponent = K, Ix(de, K);
    }
    return Ix(ye, K);
  };
}
function Mx(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Qh(e, t) {
  if (Mx(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length) return !1;
  for (var i = 0; i < r.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, r[i]) || !Mx(e[r[i]], t[r[i]]))
      return !1;
  return !0;
}
function o4(e, t) {
  var r = {}, n = function(s) {
    var l = e[s];
    typeof l == "function" && (r[s] = function() {
      return t(l.apply(void 0, arguments));
    });
  };
  for (var i in e)
    n(i);
  return r;
}
function a4(e) {
  if (typeof e != "object" || e === null) return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null) return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
function QC(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function e1(e, t, r) {
  a4(e) || QC(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function Qm(e) {
  return function(r, n) {
    var i = e(r, n);
    function o() {
      return i;
    }
    return o.dependsOnOwnProps = !1, o;
  };
}
function Ax(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function t1(e, t) {
  return function(n, i) {
    var o = i.displayName, s = function(c, f) {
      return s.dependsOnOwnProps ? s.mapToProps(c, f) : s.mapToProps(c);
    };
    return s.dependsOnOwnProps = !0, s.mapToProps = function(c, f) {
      s.mapToProps = e, s.dependsOnOwnProps = Ax(e);
      var h = s(c, f);
      return typeof h == "function" && (s.mapToProps = h, s.dependsOnOwnProps = Ax(h), h = s(c, f)), process.env.NODE_ENV !== "production" && e1(h, o, t), h;
    }, s;
  };
}
function s4(e) {
  return typeof e == "function" ? t1(e, "mapDispatchToProps") : void 0;
}
function l4(e) {
  return e ? void 0 : Qm(function(t) {
    return {
      dispatch: t
    };
  });
}
function u4(e) {
  return e && typeof e == "object" ? Qm(function(t) {
    return o4(e, t);
  }) : void 0;
}
const c4 = [s4, l4, u4];
function d4(e) {
  return typeof e == "function" ? t1(e, "mapStateToProps") : void 0;
}
function f4(e) {
  return e ? void 0 : Qm(function() {
    return {};
  });
}
const p4 = [d4, f4];
function h4(e, t, r) {
  return ct({}, r, e, t);
}
function g4(e) {
  return function(r, n) {
    var i = n.displayName, o = n.pure, s = n.areMergedPropsEqual, l = !1, c;
    return function(h, g, S) {
      var b = e(h, g, S);
      return l ? (!o || !s(b, c)) && (c = b) : (l = !0, c = b, process.env.NODE_ENV !== "production" && e1(c, i, "mergeProps")), c;
    };
  };
}
function v4(e) {
  return typeof e == "function" ? g4(e) : void 0;
}
function m4(e) {
  return e ? void 0 : function() {
    return h4;
  };
}
const y4 = [v4, m4];
function eg(e, t, r) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || QC("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps."));
  else throw new Error("Unexpected value for " + t + " in " + r + ".");
}
function b4(e, t, r, n) {
  eg(e, "mapStateToProps", n), eg(t, "mapDispatchToProps", n), eg(r, "mergeProps", n);
}
function w4(e, t, r, n) {
  return function(o, s) {
    return r(e(o, s), t(n, s), s);
  };
}
function x4(e, t, r, n, i) {
  var o = i.areStatesEqual, s = i.areOwnPropsEqual, l = i.areStatePropsEqual, c = !1, f, h, g, S, b;
  function p(L, W) {
    return f = L, h = W, g = e(f, h), S = t(n, h), b = r(g, S, h), c = !0, b;
  }
  function v() {
    return g = e(f, h), t.dependsOnOwnProps && (S = t(n, h)), b = r(g, S, h), b;
  }
  function w() {
    return e.dependsOnOwnProps && (g = e(f, h)), t.dependsOnOwnProps && (S = t(n, h)), b = r(g, S, h), b;
  }
  function C() {
    var L = e(f, h), W = !l(L, g);
    return g = L, W && (b = r(g, S, h)), b;
  }
  function M(L, W) {
    var z = !s(W, h), B = !o(L, f);
    return f = L, h = W, z && B ? v() : z ? w() : B ? C() : b;
  }
  return function(W, z) {
    return c ? M(W, z) : p(W, z);
  };
}
function _4(e, t) {
  var r = t.initMapStateToProps, n = t.initMapDispatchToProps, i = t.initMergeProps, o = zs(t, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]), s = r(e, o), l = n(e, o), c = i(e, o);
  process.env.NODE_ENV !== "production" && b4(s, l, c, o.displayName);
  var f = o.pure ? x4 : w4;
  return f(s, l, c, e, o);
}
function tg(e, t, r) {
  for (var n = t.length - 1; n >= 0; n--) {
    var i = t[n](e);
    if (i) return i;
  }
  return function(o, s) {
    throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + s.wrappedComponentName + ".");
  };
}
function S4(e, t) {
  return e === t;
}
function E4(e) {
  var t = e === void 0 ? {} : e, r = t.connectHOC, n = r === void 0 ? i4 : r, i = t.mapStateToPropsFactories, o = i === void 0 ? p4 : i, s = t.mapDispatchToPropsFactories, l = s === void 0 ? c4 : s, c = t.mergePropsFactories, f = c === void 0 ? y4 : c, h = t.selectorFactory, g = h === void 0 ? _4 : h;
  return function(b, p, v, w) {
    w === void 0 && (w = {});
    var C = w, M = C.pure, L = M === void 0 ? !0 : M, W = C.areStatesEqual, z = W === void 0 ? S4 : W, B = C.areOwnPropsEqual, K = B === void 0 ? Qh : B, Z = C.areStatePropsEqual, ee = Z === void 0 ? Qh : Z, he = C.areMergedPropsEqual, _e = he === void 0 ? Qh : he, Te = zs(C, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]), fe = tg(b, o, "mapStateToProps"), Oe = tg(p, l, "mapDispatchToProps"), ye = tg(v, f, "mergeProps");
    return n(g, ct({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(ce) {
        return "Connect(" + ce + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!b,
      // passed through to selectorFactory
      initMapStateToProps: fe,
      initMapDispatchToProps: Oe,
      initMergeProps: ye,
      pure: L,
      areStatesEqual: z,
      areOwnPropsEqual: K,
      areStatePropsEqual: ee,
      areMergedPropsEqual: _e
    }, Te));
  };
}
const r1 = /* @__PURE__ */ E4();
qH(QN);
function C4(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function n1(e, t) {
  var r = Xe(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = bt(!0), i = bt(r), o = n.current || !!(t && i.current.inputs && C4(t, i.current.inputs)), s = o ? i.current : {
    inputs: t,
    result: e()
  };
  return pt(function() {
    n.current = !1, i.current = s;
  }, [s]), s.result;
}
function T4(e, t) {
  return n1(function() {
    return e;
  }, t);
}
var dr = n1, Et = T4, O4 = process.env.NODE_ENV === "production", Nx = "Invariant failed";
function jx(e, t) {
  throw O4 ? new Error(Nx) : new Error(Nx + ": " + (t || ""));
}
var fo = function(t) {
  var r = t.top, n = t.right, i = t.bottom, o = t.left, s = n - o, l = i - r, c = {
    top: r,
    right: n,
    bottom: i,
    left: o,
    width: s,
    height: l,
    x: o,
    y: r,
    center: {
      x: (n + o) / 2,
      y: (i + r) / 2
    }
  };
  return c;
}, ey = function(t, r) {
  return {
    top: t.top - r.top,
    left: t.left - r.left,
    bottom: t.bottom + r.bottom,
    right: t.right + r.right
  };
}, kx = function(t, r) {
  return {
    top: t.top + r.top,
    left: t.left + r.left,
    bottom: t.bottom - r.bottom,
    right: t.right - r.right
  };
}, R4 = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, rg = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, ty = function(t) {
  var r = t.borderBox, n = t.margin, i = n === void 0 ? rg : n, o = t.border, s = o === void 0 ? rg : o, l = t.padding, c = l === void 0 ? rg : l, f = fo(ey(r, i)), h = fo(kx(r, s)), g = fo(kx(h, c));
  return {
    marginBox: f,
    borderBox: fo(r),
    paddingBox: h,
    contentBox: g,
    margin: i,
    border: s,
    padding: c
  };
}, zi = function(t) {
  var r = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var i = Number(r);
  return isNaN(i) && (process.env.NODE_ENV !== "production" ? jx(!1, "Could not parse value [raw: " + t + ", without suffix: " + r + "]") : jx()), i;
}, I4 = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, Nf = function(t, r) {
  var n = t.borderBox, i = t.border, o = t.margin, s = t.padding, l = R4(n, r);
  return ty({
    borderBox: l,
    border: i,
    margin: o,
    padding: s
  });
}, jf = function(t, r) {
  return r === void 0 && (r = I4()), Nf(t, r);
}, i1 = function(t, r) {
  var n = {
    top: zi(r.marginTop),
    right: zi(r.marginRight),
    bottom: zi(r.marginBottom),
    left: zi(r.marginLeft)
  }, i = {
    top: zi(r.paddingTop),
    right: zi(r.paddingRight),
    bottom: zi(r.paddingBottom),
    left: zi(r.paddingLeft)
  }, o = {
    top: zi(r.borderTopWidth),
    right: zi(r.borderRightWidth),
    bottom: zi(r.borderBottomWidth),
    left: zi(r.borderLeftWidth)
  };
  return ty({
    borderBox: t,
    margin: n,
    padding: i,
    border: o
  });
}, o1 = function(t) {
  var r = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return i1(r, n);
}, Lx = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function D4(e, t) {
  return !!(e === t || Lx(e) && Lx(t));
}
function P4(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!D4(e[r], t[r]))
      return !1;
  return !0;
}
function En(e, t) {
  t === void 0 && (t = P4);
  var r, n = [], i, o = !1;
  function s() {
    for (var l = [], c = 0; c < arguments.length; c++)
      l[c] = arguments[c];
    return o && r === this && t(l, n) || (i = e.apply(this, l), o = !0, r = this, n = l), i;
  }
  return s;
}
var Ec = function(t) {
  var r = [], n = null, i = function() {
    for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
      l[c] = arguments[c];
    r = l, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, r);
    }));
  };
  return i.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, i;
}, M4 = process.env.NODE_ENV === "production", A4 = /[ \t]{2,}/g, N4 = /^[ \t]*/gm, zx = function(t) {
  return t.replace(A4, " ").replace(N4, "").trim();
}, j4 = function(t) {
  return zx(`
  %creact-beautiful-dnd

  %c` + zx(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, k4 = function(t) {
  return [j4(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, L4 = "__react-beautiful-dnd-disable-dev-warnings";
function a1(e, t) {
  var r;
  M4 || typeof window < "u" && window[L4] || (r = console)[e].apply(r, k4(t));
}
var Ar = a1.bind(null, "warn"), Dv = a1.bind(null, "error");
function $a() {
}
function z4(e, t) {
  return ct({}, e, {}, t);
}
function $i(e, t, r) {
  var n = t.map(function(i) {
    var o = z4(r, i.options);
    return e.addEventListener(i.eventName, i.fn, o), function() {
      e.removeEventListener(i.eventName, i.fn, o);
    };
  });
  return function() {
    n.forEach(function(o) {
      o();
    });
  };
}
var B4 = process.env.NODE_ENV === "production", Bx = "Invariant failed";
function Cc(e) {
  this.message = e;
}
Cc.prototype.toString = function() {
  return this.message;
};
function pe(e, t) {
  throw B4 ? new Cc(Bx) : new Cc(Bx + ": " + (t || ""));
}
var F4 = function(e) {
  Ql(t, e);
  function t() {
    for (var n, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(o)) || this, n.callbacks = null, n.unbind = $a, n.onWindowError = function(l) {
      var c = n.getCallbacks();
      c.isDragging() && (c.tryAbort(), process.env.NODE_ENV !== "production" && Ar(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var f = l.error;
      f instanceof Cc && (l.preventDefault(), process.env.NODE_ENV !== "production" && Dv(f.message));
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(l) {
      n.callbacks = l;
    }, n;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.unbind = $i(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, r.componentDidCatch = function(i) {
    if (i instanceof Cc) {
      process.env.NODE_ENV !== "production" && Dv(i.message), this.setState({});
      return;
    }
    throw i;
  }, r.componentWillUnmount = function() {
    this.unbind();
  }, r.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(dt.Component), W4 = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, kf = function(t) {
  return t + 1;
}, H4 = function(t) {
  return `
  You have lifted an item in position ` + kf(t.source.index) + `
`;
}, s1 = function(t, r) {
  var n = t.droppableId === r.droppableId, i = kf(t.index), o = kf(r.index);
  return n ? `
      You have moved the item from position ` + i + `
      to position ` + o + `
    ` : `
    You have moved the item from position ` + i + `
    in list ` + t.droppableId + `
    to list ` + r.droppableId + `
    in position ` + o + `
  `;
}, l1 = function(t, r, n) {
  var i = r.droppableId === n.droppableId;
  return i ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + r.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, $4 = function(t) {
  var r = t.destination;
  if (r)
    return s1(t.source, r);
  var n = t.combine;
  return n ? l1(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, Fx = function(t) {
  return `
  The item has returned to its starting position
  of ` + kf(t.index) + `
`;
}, U4 = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + Fx(t.source) + `
    `;
  var r = t.destination, n = t.combine;
  return r ? `
      You have dropped the item.
      ` + s1(t.source, r) + `
    ` : n ? `
      You have dropped the item.
      ` + l1(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + Fx(t.source) + `
  `;
}, hf = {
  dragHandleUsageInstructions: W4,
  onDragStart: H4,
  onDragUpdate: $4,
  onDragEnd: U4
}, Cn = {
  x: 0,
  y: 0
}, Pn = function(t, r) {
  return {
    x: t.x + r.x,
    y: t.y + r.y
  };
}, _i = function(t, r) {
  return {
    x: t.x - r.x,
    y: t.y - r.y
  };
}, Ua = function(t, r) {
  return t.x === r.x && t.y === r.y;
}, tu = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, Bs = function(t, r, n) {
  var i;
  return n === void 0 && (n = 0), i = {}, i[t] = r, i[t === "x" ? "y" : "x"] = n, i;
}, Tc = function(t, r) {
  return Math.sqrt(Math.pow(r.x - t.x, 2) + Math.pow(r.y - t.y, 2));
}, Wx = function(t, r) {
  return Math.min.apply(Math, r.map(function(n) {
    return Tc(t, n);
  }));
}, u1 = function(t) {
  return function(r) {
    return {
      x: t(r.x),
      y: t(r.y)
    };
  };
}, G4 = function(e, t) {
  var r = fo({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return r.width <= 0 || r.height <= 0 ? null : r;
}, Yc = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, Hx = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, q4 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, V4 = function(t, r) {
  return r ? Yc(t, r.scroll.diff.displacement) : t;
}, Y4 = function(t, r, n) {
  if (n && n.increasedBy) {
    var i;
    return ct({}, t, (i = {}, i[r.end] = t[r.end] + n.increasedBy[r.line], i));
  }
  return t;
}, K4 = function(t, r) {
  return r && r.shouldClipSubject ? G4(r.pageMarginBox, t) : fo(t);
}, Wl = function(e) {
  var t = e.page, r = e.withPlaceholder, n = e.axis, i = e.frame, o = V4(t.marginBox, i), s = Y4(o, n, r), l = K4(s, i);
  return {
    page: t,
    withPlaceholder: r,
    active: l
  };
}, ry = function(e, t) {
  e.frame || (process.env.NODE_ENV, pe());
  var r = e.frame, n = _i(t, r.scroll.initial), i = tu(n), o = ct({}, r, {
    scroll: {
      initial: r.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: i
      },
      max: r.scroll.max
    }
  }), s = Wl({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: o
  }), l = ct({}, e, {
    frame: o,
    subject: s
  });
  return l;
};
function X4(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function Lf(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function ny(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function os(e, t) {
  if (e.find)
    return e.find(t);
  var r = ny(e, t);
  if (r !== -1)
    return e[r];
}
function c1(e) {
  return Array.prototype.slice.call(e);
}
var d1 = En(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), f1 = En(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), pp = En(function(e) {
  return Lf(e);
}), J4 = En(function(e) {
  return Lf(e);
}), Hs = En(function(e, t) {
  var r = J4(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, i) {
    return n.descriptor.index - i.descriptor.index;
  });
  return r;
});
function iy(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function hp(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var gp = En(function(e, t) {
  return t.filter(function(r) {
    return r.descriptor.id !== e.descriptor.id;
  });
}), Z4 = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, i = e.insideDestination, o = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var s = iy(o);
  if (!s)
    return null;
  function l(v) {
    var w = {
      type: "COMBINE",
      combine: {
        draggableId: v,
        droppableId: n.descriptor.id
      }
    };
    return ct({}, o, {
      at: w
    });
  }
  var c = o.displaced.all, f = c.length ? c[0] : null;
  if (t)
    return f ? l(f) : null;
  var h = gp(r, i);
  if (!f) {
    if (!h.length)
      return null;
    var g = h[h.length - 1];
    return l(g.descriptor.id);
  }
  var S = ny(h, function(v) {
    return v.descriptor.id === f;
  });
  S === -1 && (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find displaced item in set") : pe());
  var b = S - 1;
  if (b < 0)
    return null;
  var p = h[b];
  return l(p.descriptor.id);
}, ru = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, p1 = {
  point: Cn,
  value: 0
}, Oc = {
  invisible: {},
  visible: {},
  all: []
}, Q4 = {
  displaced: Oc,
  displacedBy: p1,
  at: null
}, Ui = function(e, t) {
  return function(r) {
    return e <= r && r <= t;
  };
}, h1 = function(e) {
  var t = Ui(e.top, e.bottom), r = Ui(e.left, e.right);
  return function(n) {
    var i = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    if (i)
      return !0;
    var o = t(n.top) || t(n.bottom), s = r(n.left) || r(n.right), l = o && s;
    if (l)
      return !0;
    var c = n.top < e.top && n.bottom > e.bottom, f = n.left < e.left && n.right > e.right, h = c && f;
    if (h)
      return !0;
    var g = c && s || f && o;
    return g;
  };
}, e$ = function(e) {
  var t = Ui(e.top, e.bottom), r = Ui(e.left, e.right);
  return function(n) {
    var i = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    return i;
  };
}, oy = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, g1 = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, t$ = function(e) {
  return function(t) {
    var r = Ui(t.top, t.bottom), n = Ui(t.left, t.right);
    return function(i) {
      return e === oy ? r(i.top) && r(i.bottom) : n(i.left) && n(i.right);
    };
  };
}, r$ = function(t, r) {
  var n = r.frame ? r.frame.scroll.diff.displacement : Cn;
  return Yc(t, n);
}, n$ = function(t, r, n) {
  return r.subject.active ? n(r.subject.active)(t) : !1;
}, i$ = function(t, r, n) {
  return n(r)(t);
}, ay = function(t) {
  var r = t.target, n = t.destination, i = t.viewport, o = t.withDroppableDisplacement, s = t.isVisibleThroughFrameFn, l = o ? r$(r, n) : r;
  return n$(l, n, s) && i$(l, i, s);
}, o$ = function(t) {
  return ay(ct({}, t, {
    isVisibleThroughFrameFn: h1
  }));
}, v1 = function(t) {
  return ay(ct({}, t, {
    isVisibleThroughFrameFn: e$
  }));
}, a$ = function(t) {
  return ay(ct({}, t, {
    isVisibleThroughFrameFn: t$(t.destination.axis)
  }));
}, s$ = function(t, r, n) {
  if (typeof n == "boolean")
    return n;
  if (!r)
    return !0;
  var i = r.invisible, o = r.visible;
  if (i[t])
    return !1;
  var s = o[t];
  return s ? s.shouldAnimate : !0;
};
function l$(e, t) {
  var r = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return fo(ey(r, n));
}
function Rc(e) {
  var t = e.afterDragging, r = e.destination, n = e.displacedBy, i = e.viewport, o = e.forceShouldAnimate, s = e.last;
  return t.reduce(function(c, f) {
    var h = l$(f, n), g = f.descriptor.id;
    c.all.push(g);
    var S = o$({
      target: h,
      destination: r,
      viewport: i,
      withDroppableDisplacement: !0
    });
    if (!S)
      return c.invisible[f.descriptor.id] = !0, c;
    var b = s$(g, s, o), p = {
      draggableId: g,
      shouldAnimate: b
    };
    return c.visible[g] = p, c;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function u$(e, t) {
  if (!e.length)
    return 0;
  var r = e[e.length - 1].descriptor.index;
  return t.inHomeList ? r : r + 1;
}
function $x(e) {
  var t = e.insideDestination, r = e.inHomeList, n = e.displacedBy, i = e.destination, o = u$(t, {
    inHomeList: r
  });
  return {
    displaced: Oc,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: i.descriptor.id,
        index: o
      }
    }
  };
}
function zf(e) {
  var t = e.draggable, r = e.insideDestination, n = e.destination, i = e.viewport, o = e.displacedBy, s = e.last, l = e.index, c = e.forceShouldAnimate, f = ru(t, n);
  if (l == null)
    return $x({
      insideDestination: r,
      inHomeList: f,
      displacedBy: o,
      destination: n
    });
  var h = os(r, function(v) {
    return v.descriptor.index === l;
  });
  if (!h)
    return $x({
      insideDestination: r,
      inHomeList: f,
      displacedBy: o,
      destination: n
    });
  var g = gp(t, r), S = r.indexOf(h), b = g.slice(S), p = Rc({
    afterDragging: b,
    destination: n,
    displacedBy: o,
    last: s,
    viewport: i.frame,
    forceShouldAnimate: c
  });
  return {
    displaced: p,
    displacedBy: o,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: l
      }
    }
  };
}
function Ja(e, t) {
  return !!t.effected[e];
}
var c$ = function(e) {
  var t = e.isMovingForward, r = e.destination, n = e.draggables, i = e.combine, o = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var s = i.draggableId, l = n[s], c = l.descriptor.index, f = Ja(s, o);
  return f ? t ? c : c - 1 : t ? c + 1 : c;
}, d$ = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.insideDestination, i = e.location;
  if (!n.length)
    return null;
  var o = i.index, s = t ? o + 1 : o - 1, l = n[0].descriptor.index, c = n[n.length - 1].descriptor.index, f = r ? c : c + 1;
  return s < l || s > f ? null : s;
}, f$ = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.draggable, i = e.draggables, o = e.destination, s = e.insideDestination, l = e.previousImpact, c = e.viewport, f = e.afterCritical, h = l.at;
  if (h || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot move in direction without previous impact location") : pe()), h.type === "REORDER") {
    var g = d$({
      isMovingForward: t,
      isInHomeList: r,
      location: h.destination,
      insideDestination: s
    });
    return g == null ? null : zf({
      draggable: n,
      insideDestination: s,
      destination: o,
      viewport: c,
      last: l.displaced,
      displacedBy: l.displacedBy,
      index: g
    });
  }
  var S = c$({
    isMovingForward: t,
    destination: o,
    displaced: l.displaced,
    draggables: i,
    combine: h.combine,
    afterCritical: f
  });
  return S == null ? null : zf({
    draggable: n,
    insideDestination: s,
    destination: o,
    viewport: c,
    last: l.displaced,
    displacedBy: l.displacedBy,
    index: S
  });
}, p$ = function(e) {
  var t = e.displaced, r = e.afterCritical, n = e.combineWith, i = e.displacedBy, o = !!(t.visible[n] || t.invisible[n]);
  return Ja(n, r) ? o ? Cn : tu(i.point) : o ? i.point : Cn;
}, h$ = function(e) {
  var t = e.afterCritical, r = e.impact, n = e.draggables, i = hp(r);
  i || (process.env.NODE_ENV, pe());
  var o = i.draggableId, s = n[o].page.borderBox.center, l = p$({
    displaced: r.displaced,
    afterCritical: t,
    combineWith: o,
    displacedBy: r.displacedBy
  });
  return Pn(s, l);
}, m1 = function(t, r) {
  return r.margin[t.start] + r.borderBox[t.size] / 2;
}, g$ = function(t, r) {
  return r.margin[t.end] + r.borderBox[t.size] / 2;
}, sy = function(t, r, n) {
  return r[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, Ux = function(t) {
  var r = t.axis, n = t.moveRelativeTo, i = t.isMoving;
  return Bs(r.line, n.marginBox[r.end] + m1(r, i), sy(r, n.marginBox, i));
}, Gx = function(t) {
  var r = t.axis, n = t.moveRelativeTo, i = t.isMoving;
  return Bs(r.line, n.marginBox[r.start] - g$(r, i), sy(r, n.marginBox, i));
}, v$ = function(t) {
  var r = t.axis, n = t.moveInto, i = t.isMoving;
  return Bs(r.line, n.contentBox[r.start] + m1(r, i), sy(r, n.contentBox, i));
}, m$ = function(e) {
  var t = e.impact, r = e.draggable, n = e.draggables, i = e.droppable, o = e.afterCritical, s = Hs(i.descriptor.id, n), l = r.page, c = i.axis;
  if (!s.length)
    return v$({
      axis: c,
      moveInto: i.page,
      isMoving: l
    });
  var f = t.displaced, h = t.displacedBy, g = f.all[0];
  if (g) {
    var S = n[g];
    if (Ja(g, o))
      return Gx({
        axis: c,
        moveRelativeTo: S.page,
        isMoving: l
      });
    var b = Nf(S.page, h.point);
    return Gx({
      axis: c,
      moveRelativeTo: b,
      isMoving: l
    });
  }
  var p = s[s.length - 1];
  if (p.descriptor.id === r.descriptor.id)
    return l.borderBox.center;
  if (Ja(p.descriptor.id, o)) {
    var v = Nf(p.page, tu(o.displacedBy.point));
    return Ux({
      axis: c,
      moveRelativeTo: v,
      isMoving: l
    });
  }
  return Ux({
    axis: c,
    moveRelativeTo: p.page,
    isMoving: l
  });
}, Pv = function(e, t) {
  var r = e.frame;
  return r ? Pn(t, r.scroll.diff.displacement) : t;
}, y$ = function(t) {
  var r = t.impact, n = t.draggable, i = t.droppable, o = t.draggables, s = t.afterCritical, l = n.page.borderBox.center, c = r.at;
  return !i || !c ? l : c.type === "REORDER" ? m$({
    impact: r,
    draggable: n,
    draggables: o,
    droppable: i,
    afterCritical: s
  }) : h$({
    impact: r,
    draggables: o,
    afterCritical: s
  });
}, vp = function(e) {
  var t = y$(e), r = e.droppable, n = r ? Pv(r, t) : t;
  return n;
}, y1 = function(e, t) {
  var r = _i(t, e.scroll.initial), n = tu(r), i = fo({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), o = {
    frame: i,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: r,
        displacement: n
      }
    }
  };
  return o;
};
function qx(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
function b$(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r].visible[e];
    if (n)
      return n;
  }
  return null;
}
var w$ = function(e) {
  var t = e.impact, r = e.viewport, n = e.destination, i = e.draggables, o = e.maxScrollChange, s = y1(r, Pn(r.scroll.current, o)), l = n.frame ? ry(n, Pn(n.frame.scroll.current, o)) : n, c = t.displaced, f = Rc({
    afterDragging: qx(c.all, i),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: s.frame,
    last: c,
    forceShouldAnimate: !1
  }), h = Rc({
    afterDragging: qx(c.all, i),
    destination: l,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    last: c,
    forceShouldAnimate: !1
  }), g = {}, S = {}, b = [c, f, h];
  c.all.forEach(function(v) {
    var w = b$(v, b);
    if (w) {
      S[v] = w;
      return;
    }
    g[v] = !0;
  });
  var p = ct({}, t, {
    displaced: {
      all: c.all,
      invisible: g,
      visible: S
    }
  });
  return p;
}, x$ = function(e, t) {
  return Pn(e.scroll.diff.displacement, t);
}, ly = function(e) {
  var t = e.pageBorderBoxCenter, r = e.draggable, n = e.viewport, i = x$(n, t), o = _i(i, r.page.borderBox.center);
  return Pn(r.client.borderBox.center, o);
}, b1 = function(e) {
  var t = e.draggable, r = e.destination, n = e.newPageBorderBoxCenter, i = e.viewport, o = e.withDroppableDisplacement, s = e.onlyOnMainAxis, l = s === void 0 ? !1 : s, c = _i(n, t.page.borderBox.center), f = Yc(t.page.borderBox, c), h = {
    target: f,
    destination: r,
    withDroppableDisplacement: o,
    viewport: i
  };
  return l ? a$(h) : v1(h);
}, _$ = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, i = e.draggables, o = e.previousImpact, s = e.viewport, l = e.previousPageBorderBoxCenter, c = e.previousClientSelection, f = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var h = Hs(n.descriptor.id, i), g = ru(r, n), S = Z4({
    isMovingForward: t,
    draggable: r,
    destination: n,
    insideDestination: h,
    previousImpact: o
  }) || f$({
    isMovingForward: t,
    isInHomeList: g,
    draggable: r,
    draggables: i,
    destination: n,
    insideDestination: h,
    previousImpact: o,
    viewport: s,
    afterCritical: f
  });
  if (!S)
    return null;
  var b = vp({
    impact: S,
    draggable: r,
    droppable: n,
    draggables: i,
    afterCritical: f
  }), p = b1({
    draggable: r,
    destination: n,
    newPageBorderBoxCenter: b,
    viewport: s.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (p) {
    var v = ly({
      pageBorderBoxCenter: b,
      draggable: r,
      viewport: s
    });
    return {
      clientSelection: v,
      impact: S,
      scrollJumpRequest: null
    };
  }
  var w = _i(b, l), C = w$({
    impact: S,
    viewport: s,
    destination: n,
    draggables: i,
    maxScrollChange: w
  });
  return {
    clientSelection: c,
    impact: C,
    scrollJumpRequest: w
  };
}, Vn = function(t) {
  var r = t.subject.active;
  return r || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot get clipped area from droppable") : pe()), r;
}, S$ = function(e) {
  var t = e.isMovingForward, r = e.pageBorderBoxCenter, n = e.source, i = e.droppables, o = e.viewport, s = n.subject.active;
  if (!s)
    return null;
  var l = n.axis, c = Ui(s[l.start], s[l.end]), f = pp(i).filter(function(g) {
    return g !== n;
  }).filter(function(g) {
    return g.isEnabled;
  }).filter(function(g) {
    return !!g.subject.active;
  }).filter(function(g) {
    return h1(o.frame)(Vn(g));
  }).filter(function(g) {
    var S = Vn(g);
    return t ? s[l.crossAxisEnd] < S[l.crossAxisEnd] : S[l.crossAxisStart] < s[l.crossAxisStart];
  }).filter(function(g) {
    var S = Vn(g), b = Ui(S[l.start], S[l.end]);
    return c(S[l.start]) || c(S[l.end]) || b(s[l.start]) || b(s[l.end]);
  }).sort(function(g, S) {
    var b = Vn(g)[l.crossAxisStart], p = Vn(S)[l.crossAxisStart];
    return t ? b - p : p - b;
  }).filter(function(g, S, b) {
    return Vn(g)[l.crossAxisStart] === Vn(b[0])[l.crossAxisStart];
  });
  if (!f.length)
    return null;
  if (f.length === 1)
    return f[0];
  var h = f.filter(function(g) {
    var S = Ui(Vn(g)[l.start], Vn(g)[l.end]);
    return S(r[l.line]);
  });
  return h.length === 1 ? h[0] : h.length > 1 ? h.sort(function(g, S) {
    return Vn(g)[l.start] - Vn(S)[l.start];
  })[0] : f.sort(function(g, S) {
    var b = Wx(r, Hx(Vn(g))), p = Wx(r, Hx(Vn(S)));
    return b !== p ? b - p : Vn(g)[l.start] - Vn(S)[l.start];
  })[0];
}, Vx = function(t, r) {
  var n = t.page.borderBox.center;
  return Ja(t.descriptor.id, r) ? _i(n, r.displacedBy.point) : n;
}, E$ = function(t, r) {
  var n = t.page.borderBox;
  return Ja(t.descriptor.id, r) ? Yc(n, tu(r.displacedBy.point)) : n;
}, C$ = function(e) {
  var t = e.pageBorderBoxCenter, r = e.viewport, n = e.destination, i = e.insideDestination, o = e.afterCritical, s = i.filter(function(l) {
    return v1({
      target: E$(l, o),
      destination: n,
      viewport: r.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(l, c) {
    var f = Tc(t, Pv(n, Vx(l, o))), h = Tc(t, Pv(n, Vx(c, o)));
    return f < h ? -1 : h < f ? 1 : l.descriptor.index - c.descriptor.index;
  });
  return s[0] || null;
}, Kc = En(function(t, r) {
  var n = r[t.line];
  return {
    value: n,
    point: Bs(t.line, n)
  };
}), T$ = function(t, r, n) {
  var i = t.axis;
  if (t.descriptor.mode === "virtual")
    return Bs(i.line, r[i.line]);
  var o = t.subject.page.contentBox[i.size], s = Hs(t.descriptor.id, n), l = s.reduce(function(h, g) {
    return h + g.client.marginBox[i.size];
  }, 0), c = l + r[i.line], f = c - o;
  return f <= 0 ? null : Bs(i.line, f);
}, w1 = function(t, r) {
  return ct({}, t, {
    scroll: ct({}, t.scroll, {
      max: r
    })
  });
}, x1 = function(t, r, n) {
  var i = t.frame;
  ru(r, t) && (process.env.NODE_ENV !== "production" ? pe(!1, "Should not add placeholder space to home list") : pe()), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot add placeholder size to a subject when it already has one") : pe());
  var o = Kc(t.axis, r.displaceBy).point, s = T$(t, o, n), l = {
    placeholderSize: o,
    increasedBy: s,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!i) {
    var c = Wl({
      page: t.subject.page,
      withPlaceholder: l,
      axis: t.axis,
      frame: t.frame
    });
    return ct({}, t, {
      subject: c
    });
  }
  var f = s ? Pn(i.scroll.max, s) : i.scroll.max, h = w1(i, f), g = Wl({
    page: t.subject.page,
    withPlaceholder: l,
    axis: t.axis,
    frame: h
  });
  return ct({}, t, {
    subject: g,
    frame: h
  });
}, O$ = function(t) {
  var r = t.subject.withPlaceholder;
  r || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot remove placeholder form subject when there was none") : pe());
  var n = t.frame;
  if (!n) {
    var i = Wl({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return ct({}, t, {
      subject: i
    });
  }
  var o = r.oldFrameMaxScroll;
  o || (process.env.NODE_ENV !== "production" ? pe(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : pe());
  var s = w1(n, o), l = Wl({
    page: t.subject.page,
    axis: t.axis,
    frame: s,
    withPlaceholder: null
  });
  return ct({}, t, {
    subject: l,
    frame: s
  });
}, R$ = function(e) {
  var t = e.previousPageBorderBoxCenter, r = e.moveRelativeTo, n = e.insideDestination, i = e.draggable, o = e.draggables, s = e.destination, l = e.viewport, c = e.afterCritical;
  if (!r) {
    if (n.length)
      return null;
    var f = {
      displaced: Oc,
      displacedBy: p1,
      at: {
        type: "REORDER",
        destination: {
          droppableId: s.descriptor.id,
          index: 0
        }
      }
    }, h = vp({
      impact: f,
      draggable: i,
      droppable: s,
      draggables: o,
      afterCritical: c
    }), g = ru(i, s) ? s : x1(s, i, o), S = b1({
      draggable: i,
      destination: g,
      newPageBorderBoxCenter: h,
      viewport: l.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return S ? f : null;
  }
  var b = t[s.axis.line] <= r.page.borderBox.center[s.axis.line], p = function() {
    var w = r.descriptor.index;
    return r.descriptor.id === i.descriptor.id || b ? w : w + 1;
  }(), v = Kc(s.axis, i.displaceBy);
  return zf({
    draggable: i,
    insideDestination: n,
    destination: s,
    viewport: l,
    displacedBy: v,
    last: Oc,
    index: p
  });
}, I$ = function(e) {
  var t = e.isMovingForward, r = e.previousPageBorderBoxCenter, n = e.draggable, i = e.isOver, o = e.draggables, s = e.droppables, l = e.viewport, c = e.afterCritical, f = S$({
    isMovingForward: t,
    pageBorderBoxCenter: r,
    source: i,
    droppables: s,
    viewport: l
  });
  if (!f)
    return null;
  var h = Hs(f.descriptor.id, o), g = C$({
    pageBorderBoxCenter: r,
    viewport: l,
    destination: f,
    insideDestination: h,
    afterCritical: c
  }), S = R$({
    previousPageBorderBoxCenter: r,
    destination: f,
    draggable: n,
    draggables: o,
    moveRelativeTo: g,
    insideDestination: h,
    viewport: l,
    afterCritical: c
  });
  if (!S)
    return null;
  var b = vp({
    impact: S,
    draggable: n,
    droppable: f,
    draggables: o,
    afterCritical: c
  }), p = ly({
    pageBorderBoxCenter: b,
    draggable: n,
    viewport: l
  });
  return {
    clientSelection: p,
    impact: S,
    scrollJumpRequest: null
  };
}, Si = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, D$ = function(t, r) {
  var n = Si(t);
  return n ? r[n] : null;
}, P$ = function(e) {
  var t = e.state, r = e.type, n = D$(t.impact, t.dimensions.droppables), i = !!n, o = t.dimensions.droppables[t.critical.droppable.id], s = n || o, l = s.axis.direction, c = l === "vertical" && (r === "MOVE_UP" || r === "MOVE_DOWN") || l === "horizontal" && (r === "MOVE_LEFT" || r === "MOVE_RIGHT");
  if (c && !i)
    return null;
  var f = r === "MOVE_DOWN" || r === "MOVE_RIGHT", h = t.dimensions.draggables[t.critical.draggable.id], g = t.current.page.borderBoxCenter, S = t.dimensions, b = S.draggables, p = S.droppables;
  return c ? _$({
    isMovingForward: f,
    previousPageBorderBoxCenter: g,
    draggable: h,
    destination: s,
    draggables: b,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : I$({
    isMovingForward: f,
    previousPageBorderBoxCenter: g,
    draggable: h,
    isOver: s,
    draggables: b,
    droppables: p,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function Ts(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function _1(e) {
  var t = Ui(e.top, e.bottom), r = Ui(e.left, e.right);
  return function(i) {
    return t(i.y) && r(i.x);
  };
}
function M$(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function A$(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.candidates, i = r.page.borderBox.center, o = n.map(function(s) {
    var l = s.axis, c = Bs(s.axis.line, t.center[l.line], s.page.borderBox.center[l.crossAxisLine]);
    return {
      id: s.descriptor.id,
      distance: Tc(i, c)
    };
  }).sort(function(s, l) {
    return l.distance - s.distance;
  });
  return o[0] ? o[0].id : null;
}
function N$(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.droppables, i = pp(n).filter(function(o) {
    if (!o.isEnabled)
      return !1;
    var s = o.subject.active;
    if (!s || !M$(t, s))
      return !1;
    if (_1(s)(t.center))
      return !0;
    var l = o.axis, c = s.center[l.crossAxisLine], f = t[l.crossAxisStart], h = t[l.crossAxisEnd], g = Ui(s[l.crossAxisStart], s[l.crossAxisEnd]), S = g(f), b = g(h);
    return !S && !b ? !0 : S ? f < c : h > c;
  });
  return i.length ? i.length === 1 ? i[0].descriptor.id : A$({
    pageBorderBox: t,
    draggable: r,
    candidates: i
  }) : null;
}
var S1 = function(t, r) {
  return fo(Yc(t, r));
}, j$ = function(e, t) {
  var r = e.frame;
  return r ? S1(t, r.scroll.diff.value) : t;
};
function E1(e) {
  var t = e.displaced, r = e.id;
  return !!(t.visible[r] || t.invisible[r]);
}
function k$(e) {
  var t = e.draggable, r = e.closest, n = e.inHomeList;
  return r ? n && r.descriptor.index > t.descriptor.index ? r.descriptor.index - 1 : r.descriptor.index : null;
}
var L$ = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, r = e.draggable, n = e.destination, i = e.insideDestination, o = e.last, s = e.viewport, l = e.afterCritical, c = n.axis, f = Kc(n.axis, r.displaceBy), h = f.value, g = t[c.start], S = t[c.end], b = gp(r, i), p = os(b, function(w) {
    var C = w.descriptor.id, M = w.page.borderBox.center[c.line], L = Ja(C, l), W = E1({
      displaced: o,
      id: C
    });
    return L ? W ? S <= M : g < M - h : W ? S <= M + h : g < M;
  }), v = k$({
    draggable: r,
    closest: p,
    inHomeList: ru(r, n)
  });
  return zf({
    draggable: r,
    insideDestination: i,
    destination: n,
    viewport: s,
    last: o,
    displacedBy: f,
    index: v
  });
}, z$ = 4, B$ = function(e) {
  var t = e.draggable, r = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, i = e.destination, o = e.insideDestination, s = e.afterCritical;
  if (!i.isCombineEnabled)
    return null;
  var l = i.axis, c = Kc(i.axis, t.displaceBy), f = c.value, h = r[l.start], g = r[l.end], S = gp(t, o), b = os(S, function(v) {
    var w = v.descriptor.id, C = v.page.borderBox, M = C[l.size], L = M / z$, W = Ja(w, s), z = E1({
      displaced: n.displaced,
      id: w
    });
    return W ? z ? g > C[l.start] + L && g < C[l.end] - L : h > C[l.start] - f + L && h < C[l.end] - f - L : z ? g > C[l.start] + f + L && g < C[l.end] + f - L : h > C[l.start] + L && h < C[l.end] - L;
  });
  if (!b)
    return null;
  var p = {
    displacedBy: c,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: b.descriptor.id,
        droppableId: i.descriptor.id
      }
    }
  };
  return p;
}, C1 = function(e) {
  var t = e.pageOffset, r = e.draggable, n = e.draggables, i = e.droppables, o = e.previousImpact, s = e.viewport, l = e.afterCritical, c = S1(r.page.borderBox, t), f = N$({
    pageBorderBox: c,
    draggable: r,
    droppables: i
  });
  if (!f)
    return Q4;
  var h = i[f], g = Hs(h.descriptor.id, n), S = j$(h, c);
  return B$({
    pageBorderBoxWithDroppableScroll: S,
    draggable: r,
    previousImpact: o,
    destination: h,
    insideDestination: g,
    afterCritical: l
  }) || L$({
    pageBorderBoxWithDroppableScroll: S,
    draggable: r,
    destination: h,
    insideDestination: g,
    last: o.displaced,
    viewport: s,
    afterCritical: l
  });
}, uy = function(e, t) {
  var r;
  return ct({}, e, (r = {}, r[t.descriptor.id] = t, r));
}, F$ = function(t) {
  var r = t.previousImpact, n = t.impact, i = t.droppables, o = Si(r), s = Si(n);
  if (!o || o === s)
    return i;
  var l = i[o];
  if (!l.subject.withPlaceholder)
    return i;
  var c = O$(l);
  return uy(i, c);
}, W$ = function(e) {
  var t = e.draggable, r = e.draggables, n = e.droppables, i = e.previousImpact, o = e.impact, s = F$({
    previousImpact: i,
    impact: o,
    droppables: n
  }), l = Si(o);
  if (!l)
    return s;
  var c = n[l];
  if (ru(t, c) || c.subject.withPlaceholder)
    return s;
  var f = x1(c, t, r);
  return uy(s, f);
}, dc = function(e) {
  var t = e.state, r = e.clientSelection, n = e.dimensions, i = e.viewport, o = e.impact, s = e.scrollJumpRequest, l = i || t.viewport, c = n || t.dimensions, f = r || t.current.client.selection, h = _i(f, t.initial.client.selection), g = {
    offset: h,
    selection: f,
    borderBoxCenter: Pn(t.initial.client.borderBoxCenter, h)
  }, S = {
    selection: Pn(g.selection, l.scroll.current),
    borderBoxCenter: Pn(g.borderBoxCenter, l.scroll.current),
    offset: Pn(g.offset, l.scroll.diff.value)
  }, b = {
    client: g,
    page: S
  };
  if (t.phase === "COLLECTING")
    return ct({
      phase: "COLLECTING"
    }, t, {
      dimensions: c,
      viewport: l,
      current: b
    });
  var p = c.draggables[t.critical.draggable.id], v = o || C1({
    pageOffset: S.offset,
    draggable: p,
    draggables: c.draggables,
    droppables: c.droppables,
    previousImpact: t.impact,
    viewport: l,
    afterCritical: t.afterCritical
  }), w = W$({
    draggable: p,
    impact: v,
    previousImpact: t.impact,
    draggables: c.draggables,
    droppables: c.droppables
  }), C = ct({}, t, {
    current: b,
    dimensions: {
      draggables: c.draggables,
      droppables: w
    },
    impact: v,
    viewport: l,
    scrollJumpRequest: s || null,
    forceShouldAnimate: s ? !1 : null
  });
  return C;
};
function H$(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
var T1 = function(e) {
  var t = e.impact, r = e.viewport, n = e.draggables, i = e.destination, o = e.forceShouldAnimate, s = t.displaced, l = H$(s.all, n), c = Rc({
    afterDragging: l,
    destination: i,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    forceShouldAnimate: o,
    last: s
  });
  return ct({}, t, {
    displaced: c
  });
}, O1 = function(e) {
  var t = e.impact, r = e.draggable, n = e.droppable, i = e.draggables, o = e.viewport, s = e.afterCritical, l = vp({
    impact: t,
    draggable: r,
    draggables: i,
    droppable: n,
    afterCritical: s
  });
  return ly({
    pageBorderBoxCenter: l,
    draggable: r,
    viewport: o
  });
}, R1 = function(e) {
  var t = e.state, r = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, pe());
  var i = t.impact, o = n || t.viewport, s = r || t.dimensions, l = s.draggables, c = s.droppables, f = l[t.critical.draggable.id], h = Si(i);
  h || (process.env.NODE_ENV !== "production" ? pe(!1, "Must be over a destination in SNAP movement mode") : pe());
  var g = c[h], S = T1({
    impact: i,
    viewport: o,
    destination: g,
    draggables: l
  }), b = O1({
    impact: S,
    draggable: f,
    droppable: g,
    draggables: l,
    viewport: o,
    afterCritical: t.afterCritical
  });
  return dc({
    impact: S,
    clientSelection: b,
    state: t,
    dimensions: s,
    viewport: o
  });
}, $$ = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, I1 = function(e) {
  var t = e.draggable, r = e.home, n = e.draggables, i = e.viewport, o = Kc(r.axis, t.displaceBy), s = Hs(r.descriptor.id, n), l = s.indexOf(t);
  l === -1 && (process.env.NODE_ENV !== "production" ? pe(!1, "Expected draggable to be inside home list") : pe());
  var c = s.slice(l + 1), f = c.reduce(function(b, p) {
    return b[p.descriptor.id] = !0, b;
  }, {}), h = {
    inVirtualList: r.descriptor.mode === "virtual",
    displacedBy: o,
    effected: f
  }, g = Rc({
    afterDragging: c,
    destination: r,
    displacedBy: o,
    last: null,
    viewport: i.frame,
    forceShouldAnimate: !1
  }), S = {
    displaced: g,
    displacedBy: o,
    at: {
      type: "REORDER",
      destination: $$(t.descriptor)
    }
  };
  return {
    impact: S,
    afterCritical: h
  };
}, U$ = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: uy(e.droppables, t)
  };
}, Xc = function(t) {
  process.env.NODE_ENV;
}, Jc = function(t) {
  process.env.NODE_ENV;
}, G$ = function(e) {
  var t = e.draggable, r = e.offset, n = e.initialWindowScroll, i = Nf(t.client, r), o = jf(i, n), s = ct({}, t, {
    placeholder: ct({}, t.placeholder, {
      client: i
    }),
    client: i,
    page: o
  });
  return s;
}, q$ = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? pe(!1, "Expected Droppable to have a frame") : pe()), t;
}, V$ = function(e) {
  var t = e.additions, r = e.updatedDroppables, n = e.viewport, i = n.scroll.diff.value;
  return t.map(function(o) {
    var s = o.descriptor.droppableId, l = r[s], c = q$(l), f = c.scroll.diff.value, h = Pn(i, f), g = G$({
      draggable: o,
      offset: h,
      initialWindowScroll: n.scroll.initial
    });
    return g;
  });
}, Y$ = function(e) {
  var t = e.state, r = e.published;
  Xc();
  var n = r.modified.map(function(L) {
    var W = t.dimensions.droppables[L.droppableId], z = ry(W, L.scroll);
    return z;
  }), i = ct({}, t.dimensions.droppables, {}, d1(n)), o = f1(V$({
    additions: r.additions,
    updatedDroppables: i,
    viewport: t.viewport
  })), s = ct({}, t.dimensions.draggables, {}, o);
  r.removals.forEach(function(L) {
    delete s[L];
  });
  var l = {
    droppables: i,
    draggables: s
  }, c = Si(t.impact), f = c ? l.droppables[c] : null, h = l.draggables[t.critical.draggable.id], g = l.droppables[t.critical.droppable.id], S = I1({
    draggable: h,
    home: g,
    draggables: s,
    viewport: t.viewport
  }), b = S.impact, p = S.afterCritical, v = f && f.isCombineEnabled ? t.impact : b, w = C1({
    pageOffset: t.current.page.offset,
    draggable: l.draggables[t.critical.draggable.id],
    draggables: l.draggables,
    droppables: l.droppables,
    previousImpact: v,
    viewport: t.viewport,
    afterCritical: p
  });
  Jc();
  var C = ct({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: w,
    onLiftImpact: b,
    dimensions: l,
    afterCritical: p,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return C;
  var M = ct({
    phase: "DROP_PENDING"
  }, C, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return M;
}, Mv = function(t) {
  return t.movementMode === "SNAP";
}, ng = function(t, r, n) {
  var i = U$(t.dimensions, r);
  return !Mv(t) || n ? dc({
    state: t,
    dimensions: i
  }) : R1({
    state: t,
    dimensions: i
  });
};
function ig(e) {
  return e.isDragging && e.movementMode === "SNAP" ? ct({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var Yx = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, K$ = function(e, t) {
  if (e === void 0 && (e = Yx), t.type === "FLUSH")
    return ct({}, Yx, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? pe(!1, "INITIAL_PUBLISH must come after a IDLE phase") : pe());
    var r = t.payload, n = r.critical, i = r.clientSelection, o = r.viewport, s = r.dimensions, l = r.movementMode, c = s.draggables[n.draggable.id], f = s.droppables[n.droppable.id], h = {
      selection: i,
      borderBoxCenter: c.client.borderBox.center,
      offset: Cn
    }, g = {
      client: h,
      page: {
        selection: Pn(h.selection, o.scroll.initial),
        borderBoxCenter: Pn(h.selection, o.scroll.initial),
        offset: Pn(h.selection, o.scroll.diff.value)
      }
    }, S = pp(s.droppables).every(function(xe) {
      return !xe.isFixedOnPage;
    }), b = I1({
      draggable: c,
      home: f,
      draggables: s.draggables,
      viewport: o
    }), p = b.impact, v = b.afterCritical, w = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: l,
      dimensions: s,
      initial: g,
      current: g,
      isWindowScrollAllowed: S,
      impact: p,
      afterCritical: v,
      onLiftImpact: p,
      viewport: o,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return w;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Collection cannot start from phase " + e.phase) : pe());
    var C = ct({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return C;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? pe(!1, "Unexpected " + t.type + " received in phase " + e.phase) : pe()), Y$({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ts(e) || (process.env.NODE_ENV !== "production" ? pe(!1, t.type + " not permitted in phase " + e.phase) : pe());
    var M = t.payload.client;
    return Ua(M, e.current.client.selection) ? e : dc({
      state: e,
      clientSelection: M,
      impact: Mv(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return ig(e);
    Ts(e) || (process.env.NODE_ENV !== "production" ? pe(!1, t.type + " not permitted in phase " + e.phase) : pe());
    var L = t.payload, W = L.id, z = L.newScroll, B = e.dimensions.droppables[W];
    if (!B)
      return e;
    var K = ry(B, z);
    return ng(e, K, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ts(e) || (process.env.NODE_ENV !== "production" ? pe(!1, "Attempting to move in an unsupported phase " + e.phase) : pe());
    var Z = t.payload, ee = Z.id, he = Z.isEnabled, _e = e.dimensions.droppables[ee];
    _e || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find Droppable[id: " + ee + "] to toggle its enabled state") : pe()), _e.isEnabled === he && (process.env.NODE_ENV !== "production" ? pe(!1, "Trying to set droppable isEnabled to " + String(he) + `
      but it is already ` + String(_e.isEnabled)) : pe());
    var Te = ct({}, _e, {
      isEnabled: he
    });
    return ng(e, Te, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Ts(e) || (process.env.NODE_ENV !== "production" ? pe(!1, "Attempting to move in an unsupported phase " + e.phase) : pe());
    var fe = t.payload, Oe = fe.id, ye = fe.isCombineEnabled, de = e.dimensions.droppables[Oe];
    de || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find Droppable[id: " + Oe + "] to toggle its isCombineEnabled state") : pe()), de.isCombineEnabled === ye && (process.env.NODE_ENV !== "production" ? pe(!1, "Trying to set droppable isCombineEnabled to " + String(ye) + `
      but it is already ` + String(de.isCombineEnabled)) : pe());
    var ce = ct({}, de, {
      isCombineEnabled: ye
    });
    return ng(e, ce, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    Ts(e) || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot move by window in phase " + e.phase) : pe()), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? pe(!1, "Window scrolling is currently not supported for fixed lists") : pe());
    var Fe = t.payload.newScroll;
    if (Ua(e.viewport.scroll.current, Fe))
      return ig(e);
    var le = y1(e.viewport, Fe);
    return Mv(e) ? R1({
      state: e,
      viewport: le
    }) : dc({
      state: e,
      viewport: le
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!Ts(e))
      return e;
    var J = t.payload.maxScroll;
    if (Ua(J, e.viewport.scroll.max))
      return e;
    var re = ct({}, e.viewport, {
      scroll: ct({}, e.viewport.scroll, {
        max: J
      })
    });
    return ct({
      phase: "DRAGGING"
    }, e, {
      viewport: re
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? pe(!1, t.type + " received while not in DRAGGING phase") : pe());
    var be = P$({
      state: e,
      type: t.type
    });
    return be ? dc({
      state: e,
      impact: be.impact,
      clientSelection: be.clientSelection,
      scrollJumpRequest: be.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var Me = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : pe());
    var Ae = ct({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: Me
    });
    return Ae;
  }
  if (t.type === "DROP_ANIMATE") {
    var Re = t.payload, Ee = Re.completed, Ce = Re.dropDuration, X = Re.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot animate drop from phase " + e.phase) : pe());
    var ie = {
      phase: "DROP_ANIMATING",
      completed: Ee,
      dropDuration: Ce,
      newHomeClientOffset: X,
      dimensions: e.dimensions
    };
    return ie;
  }
  if (t.type === "DROP_COMPLETE") {
    var Ie = t.payload.completed;
    return {
      phase: "IDLE",
      completed: Ie,
      shouldFlush: !1
    };
  }
  return e;
}, X$ = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, J$ = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, Z$ = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, Q$ = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, eU = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, tU = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, rU = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, nU = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, D1 = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, iU = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, oU = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, aU = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, sU = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, lU = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, uU = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, cy = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, cU = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, dy = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, P1 = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, dU = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, M1 = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function fU(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(l) {
      return l.descriptor.index;
    }), r = {}, n = 1; n < t.length; n++) {
      var i = t[n], o = t[n - 1];
      i !== o + 1 && (r[i] = !0);
    }
    if (Object.keys(r).length) {
      var s = t.map(function(l) {
        var c = !!r[l];
        return c ? "[🔥" + l + "]" : "" + l;
      }).join(", ");
      process.env.NODE_ENV !== "production" && Ar(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + s + `
  `);
    }
  }
}
function pU(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = Hs(e.droppable.id, t.draggables);
    fU(r);
  }
}
var hU = function(e) {
  return function(t) {
    var r = t.getState, n = t.dispatch;
    return function(i) {
      return function(o) {
        if (o.type !== "LIFT") {
          i(o);
          return;
        }
        var s = o.payload, l = s.id, c = s.clientSelection, f = s.movementMode, h = r();
        h.phase === "DROP_ANIMATING" && n(dy({
          completed: h.completed
        })), r().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? pe(!1, "Unexpected phase to start a drag") : pe()), n(cy()), n(X$({
          draggableId: l,
          movementMode: f
        }));
        var g = {
          shouldPublishImmediately: f === "SNAP"
        }, S = {
          draggableId: l,
          scrollOptions: g
        }, b = e.startPublishing(S), p = b.critical, v = b.dimensions, w = b.viewport;
        pU(p, v), n(Z$({
          critical: p,
          dimensions: v,
          clientSelection: c,
          movementMode: f,
          viewport: w
        }));
      };
    };
  };
}, gU = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        r.type === "INITIAL_PUBLISH" && e.dragging(), r.type === "DROP_ANIMATE" && e.dropping(r.payload.completed.result.reason), (r.type === "FLUSH" || r.type === "DROP_COMPLETE") && e.resting(), t(r);
      };
    };
  };
}, fy = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, Ic = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, py = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, xs = py.outOfTheWay + "s " + fy.outOfTheWay, fc = {
  fluid: "opacity " + xs,
  snap: "transform " + xs + ", opacity " + xs,
  drop: function(t) {
    var r = t + "s " + fy.drop;
    return "transform " + r + ", opacity " + r;
  },
  outOfTheWay: "transform " + xs,
  placeholder: "height " + xs + ", width " + xs + ", margin " + xs
}, Kx = function(t) {
  return Ua(t, Cn) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, Av = {
  moveTo: Kx,
  drop: function(t, r) {
    var n = Kx(t);
    return n ? r ? n + " scale(" + Ic.scale.drop + ")" : n : null;
  }
}, Nv = py.minDropTime, A1 = py.maxDropTime, vU = A1 - Nv, Xx = 1500, mU = 0.6, yU = function(e) {
  var t = e.current, r = e.destination, n = e.reason, i = Tc(t, r);
  if (i <= 0)
    return Nv;
  if (i >= Xx)
    return A1;
  var o = i / Xx, s = Nv + vU * o, l = n === "CANCEL" ? s * mU : s;
  return Number(l.toFixed(2));
}, bU = function(e) {
  var t = e.impact, r = e.draggable, n = e.dimensions, i = e.viewport, o = e.afterCritical, s = n.draggables, l = n.droppables, c = Si(t), f = c ? l[c] : null, h = l[r.descriptor.droppableId], g = O1({
    impact: t,
    draggable: r,
    draggables: s,
    afterCritical: o,
    droppable: f || h,
    viewport: i
  }), S = _i(g, r.client.borderBox.center);
  return S;
}, wU = function(e) {
  var t = e.draggables, r = e.reason, n = e.lastImpact, i = e.home, o = e.viewport, s = e.onLiftImpact;
  if (!n.at || r !== "DROP") {
    var l = T1({
      draggables: t,
      impact: s,
      destination: i,
      viewport: o,
      forceShouldAnimate: !0
    });
    return {
      impact: l,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var c = ct({}, n, {
    displaced: Oc
  });
  return {
    impact: c,
    didDropInsideDroppable: !0
  };
}, xU = function(e) {
  var t = e.getState, r = e.dispatch;
  return function(n) {
    return function(i) {
      if (i.type !== "DROP") {
        n(i);
        return;
      }
      var o = t(), s = i.payload.reason;
      if (o.phase === "COLLECTING") {
        r(dU({
          reason: s
        }));
        return;
      }
      if (o.phase !== "IDLE") {
        var l = o.phase === "DROP_PENDING" && o.isWaiting;
        l && (process.env.NODE_ENV !== "production" ? pe(!1, "A DROP action occurred while DROP_PENDING and still waiting") : pe()), o.phase === "DRAGGING" || o.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot drop in phase: " + o.phase) : pe());
        var c = o.critical, f = o.dimensions, h = f.draggables[o.critical.draggable.id], g = wU({
          reason: s,
          lastImpact: o.impact,
          afterCritical: o.afterCritical,
          onLiftImpact: o.onLiftImpact,
          home: o.dimensions.droppables[o.critical.droppable.id],
          viewport: o.viewport,
          draggables: o.dimensions.draggables
        }), S = g.impact, b = g.didDropInsideDroppable, p = b ? iy(S) : null, v = b ? hp(S) : null, w = {
          index: c.draggable.index,
          droppableId: c.droppable.id
        }, C = {
          draggableId: h.descriptor.id,
          type: h.descriptor.type,
          source: w,
          reason: s,
          mode: o.movementMode,
          destination: p,
          combine: v
        }, M = bU({
          impact: S,
          draggable: h,
          dimensions: f,
          viewport: o.viewport,
          afterCritical: o.afterCritical
        }), L = {
          critical: o.critical,
          afterCritical: o.afterCritical,
          result: C,
          impact: S
        }, W = !Ua(o.current.client.offset, M) || !!C.combine;
        if (!W) {
          r(dy({
            completed: L
          }));
          return;
        }
        var z = yU({
          current: o.current.client.offset,
          destination: M,
          reason: s
        }), B = {
          newHomeClientOffset: M,
          dropDuration: z,
          completed: L
        };
        r(cU(B));
      }
    };
  };
}, N1 = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function _U(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(r) {
      r.target !== window && r.target !== window.document || e();
    }
  };
}
function SU(e) {
  var t = e.onWindowScroll;
  function r() {
    t(N1());
  }
  var n = Ec(r), i = _U(n), o = $a;
  function s() {
    return o !== $a;
  }
  function l() {
    s() && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot start scroll listener when already active") : pe()), o = $i(window, [i]);
  }
  function c() {
    s() || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot stop scroll listener when not active") : pe()), n.cancel(), o(), o = $a;
  }
  return {
    start: l,
    stop: c,
    isActive: s
  };
}
var EU = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, CU = function(e) {
  var t = SU({
    onWindowScroll: function(n) {
      e.dispatch(iU({
        newScroll: n
      }));
    }
  });
  return function(r) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && EU(n) && t.stop(), r(n);
    };
  };
}, TU = function(e) {
  var t = !1, r = !1, n = setTimeout(function() {
    r = !0;
  }), i = function(s) {
    if (t) {
      process.env.NODE_ENV !== "production" && Ar("Announcement already made. Not making a second announcement");
      return;
    }
    if (r) {
      process.env.NODE_ENV !== "production" && Ar(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(s), clearTimeout(n);
  };
  return i.wasCalled = function() {
    return t;
  }, i;
}, OU = function() {
  var e = [], t = function(o) {
    var s = ny(e, function(f) {
      return f.timerId === o;
    });
    s === -1 && (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find timer") : pe());
    var l = e.splice(s, 1), c = l[0];
    c.callback();
  }, r = function(o) {
    var s = setTimeout(function() {
      return t(s);
    }), l = {
      timerId: s,
      callback: o
    };
    e.push(l);
  }, n = function() {
    if (e.length) {
      var o = [].concat(e);
      e.length = 0, o.forEach(function(s) {
        clearTimeout(s.timerId), s.callback();
      });
    }
  };
  return {
    add: r,
    flush: n
  };
}, RU = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.droppableId === r.droppableId && t.index === r.index;
}, IU = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.draggableId === r.draggableId && t.droppableId === r.droppableId;
}, DU = function(t, r) {
  if (t === r)
    return !0;
  var n = t.draggable.id === r.draggable.id && t.draggable.droppableId === r.draggable.droppableId && t.draggable.type === r.draggable.type && t.draggable.index === r.draggable.index, i = t.droppable.id === r.droppable.id && t.droppable.type === r.droppable.type;
  return n && i;
}, ju = function(t, r) {
  Xc(), r(), Jc();
}, ef = function(t, r) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: r
  };
}, og = function(t, r, n, i) {
  if (!t) {
    n(i(r));
    return;
  }
  var o = TU(n), s = {
    announce: o
  };
  t(r, s), o.wasCalled() || n(i(r));
}, PU = function(e, t) {
  var r = OU(), n = null, i = function(S, b) {
    n && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : pe()), ju("onBeforeCapture", function() {
      var p = e().onBeforeCapture;
      if (p) {
        var v = {
          draggableId: S,
          mode: b
        };
        p(v);
      }
    });
  }, o = function(S, b) {
    n && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : pe()), ju("onBeforeDragStart", function() {
      var p = e().onBeforeDragStart;
      p && p(ef(S, b));
    });
  }, s = function(S, b) {
    n && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : pe());
    var p = ef(S, b);
    n = {
      mode: b,
      lastCritical: S,
      lastLocation: p.source,
      lastCombine: null
    }, r.add(function() {
      ju("onDragStart", function() {
        return og(e().onDragStart, p, t, hf.onDragStart);
      });
    });
  }, l = function(S, b) {
    var p = iy(b), v = hp(b);
    n || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fire onDragMove when onDragStart has not been called") : pe());
    var w = !DU(S, n.lastCritical);
    w && (n.lastCritical = S);
    var C = !RU(n.lastLocation, p);
    C && (n.lastLocation = p);
    var M = !IU(n.lastCombine, v);
    if (M && (n.lastCombine = v), !(!w && !C && !M)) {
      var L = ct({}, ef(S, n.mode), {
        combine: v,
        destination: p
      });
      r.add(function() {
        ju("onDragUpdate", function() {
          return og(e().onDragUpdate, L, t, hf.onDragUpdate);
        });
      });
    }
  }, c = function() {
    n || (process.env.NODE_ENV !== "production" ? pe(!1, "Can only flush responders while dragging") : pe()), r.flush();
  }, f = function(S) {
    n || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : pe()), n = null, ju("onDragEnd", function() {
      return og(e().onDragEnd, S, t, hf.onDragEnd);
    });
  }, h = function() {
    if (n) {
      var S = ct({}, ef(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      f(S);
    }
  };
  return {
    beforeCapture: i,
    beforeStart: o,
    start: s,
    update: l,
    flush: c,
    drop: f,
    abort: h
  };
}, MU = function(e, t) {
  var r = PU(e, t);
  return function(n) {
    return function(i) {
      return function(o) {
        if (o.type === "BEFORE_INITIAL_CAPTURE") {
          r.beforeCapture(o.payload.draggableId, o.payload.movementMode);
          return;
        }
        if (o.type === "INITIAL_PUBLISH") {
          var s = o.payload.critical;
          r.beforeStart(s, o.payload.movementMode), i(o), r.start(s, o.payload.movementMode);
          return;
        }
        if (o.type === "DROP_COMPLETE") {
          var l = o.payload.completed.result;
          r.flush(), i(o), r.drop(l);
          return;
        }
        if (i(o), o.type === "FLUSH") {
          r.abort();
          return;
        }
        var c = n.getState();
        c.phase === "DRAGGING" && r.update(c.critical, c.impact);
      };
    };
  };
}, AU = function(e) {
  return function(t) {
    return function(r) {
      if (r.type !== "DROP_ANIMATION_FINISHED") {
        t(r);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot finish a drop animating when no drop is occurring") : pe()), e.dispatch(dy({
        completed: n.completed
      }));
    };
  };
}, NU = function(e) {
  var t = null, r = null;
  function n() {
    r && (cancelAnimationFrame(r), r = null), t && (t(), t = null);
  }
  return function(i) {
    return function(o) {
      if ((o.type === "FLUSH" || o.type === "DROP_COMPLETE" || o.type === "DROP_ANIMATION_FINISHED") && n(), i(o), o.type === "DROP_ANIMATE") {
        var s = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var c = e.getState();
            c.phase === "DROP_ANIMATING" && e.dispatch(M1());
          }
        };
        r = requestAnimationFrame(function() {
          r = null, t = $i(window, [s]);
        });
      }
    };
  };
}, jU = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        (r.type === "DROP_COMPLETE" || r.type === "FLUSH" || r.type === "DROP_ANIMATE") && e.stopPublishing(), t(r);
      };
    };
  };
}, kU = function(e) {
  var t = !1;
  return function() {
    return function(r) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), r(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (r(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var i = n.payload.completed.result;
            i.combine && e.tryShiftRecord(i.draggableId, i.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, LU = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, zU = function(e) {
  return function(t) {
    return function(r) {
      return function(n) {
        if (LU(n)) {
          e.stop(), r(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          r(n);
          var i = t.getState();
          i.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : pe()), e.start(i);
          return;
        }
        r(n), e.scroll(t.getState());
      };
    };
  };
}, BU = function(e) {
  return function(t) {
    return function(r) {
      if (t(r), r.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(P1({
          reason: n.reason
        })));
      }
    };
  };
}, FU = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : YC, WU = function(e) {
  var t = e.dimensionMarshal, r = e.focusMarshal, n = e.styleMarshal, i = e.getResponders, o = e.announce, s = e.autoScroller;
  return VC(K$, FU(UH(gU(n), jU(t), hU(t), xU, AU, NU, BU, zU(s), CU, kU(r), MU(i, o))));
}, ag = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function HU(e) {
  var t = e.registry, r = e.callbacks, n = ag(), i = null, o = function() {
    i || (r.collectionStarting(), i = requestAnimationFrame(function() {
      i = null, Xc();
      var h = n, g = h.additions, S = h.removals, b = h.modified, p = Object.keys(g).map(function(C) {
        return t.draggable.getById(C).getDimension(Cn);
      }).sort(function(C, M) {
        return C.descriptor.index - M.descriptor.index;
      }), v = Object.keys(b).map(function(C) {
        var M = t.droppable.getById(C), L = M.callbacks.getScrollWhileDragging();
        return {
          droppableId: C,
          scroll: L
        };
      }), w = {
        additions: p,
        removals: Object.keys(S),
        modified: v
      };
      n = ag(), Jc(), r.publish(w);
    }));
  }, s = function(h) {
    var g = h.descriptor.id;
    n.additions[g] = h, n.modified[h.descriptor.droppableId] = !0, n.removals[g] && delete n.removals[g], o();
  }, l = function(h) {
    var g = h.descriptor;
    n.removals[g.id] = !0, n.modified[g.droppableId] = !0, n.additions[g.id] && delete n.additions[g.id], o();
  }, c = function() {
    i && (cancelAnimationFrame(i), i = null, n = ag());
  };
  return {
    add: s,
    remove: l,
    stop: c
  };
}
var j1 = function(e) {
  var t = e.scrollHeight, r = e.scrollWidth, n = e.height, i = e.width, o = _i({
    x: r,
    y: t
  }, {
    x: i,
    y: n
  }), s = {
    x: Math.max(0, o.x),
    y: Math.max(0, o.y)
  };
  return s;
}, k1 = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find document.documentElement") : pe()), e;
}, L1 = function() {
  var e = k1(), t = j1({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, $U = function() {
  var e = N1(), t = L1(), r = e.y, n = e.x, i = k1(), o = i.clientWidth, s = i.clientHeight, l = n + o, c = r + s, f = fo({
    top: r,
    left: n,
    right: l,
    bottom: c
  }), h = {
    frame: f,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Cn,
        displacement: Cn
      }
    }
  };
  return h;
}, UU = function(e) {
  var t = e.critical, r = e.scrollOptions, n = e.registry;
  Xc();
  var i = $U(), o = i.scroll.current, s = t.droppable, l = n.droppable.getAllByType(s.type).map(function(g) {
    return g.callbacks.getDimensionAndWatchScroll(o, r);
  }), c = n.draggable.getAllByType(t.draggable.type).map(function(g) {
    return g.getDimension(o);
  }), f = {
    draggables: f1(c),
    droppables: d1(l)
  };
  Jc();
  var h = {
    dimensions: f,
    critical: t,
    viewport: i
  };
  return h;
};
function Jx(e, t, r) {
  if (r.descriptor.id === t.id || r.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(r.descriptor.droppableId);
  return n.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && Ar(`
      You are attempting to add or remove a Draggable [id: ` + r.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var GU = function(e, t) {
  var r = null, n = HU({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), i = function(b, p) {
    e.droppable.exists(b) || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot update is enabled flag of Droppable " + b + " as it is not registered") : pe()), r && t.updateDroppableIsEnabled({
      id: b,
      isEnabled: p
    });
  }, o = function(b, p) {
    r && (e.droppable.exists(b) || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot update isCombineEnabled flag of Droppable " + b + " as it is not registered") : pe()), t.updateDroppableIsCombineEnabled({
      id: b,
      isCombineEnabled: p
    }));
  }, s = function(b, p) {
    r && (e.droppable.exists(b) || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot update the scroll on Droppable " + b + " as it is not registered") : pe()), t.updateDroppableScroll({
      id: b,
      newScroll: p
    }));
  }, l = function(b, p) {
    r && e.droppable.getById(b).callbacks.scroll(p);
  }, c = function() {
    if (r) {
      n.stop();
      var b = r.critical.droppable;
      e.droppable.getAllByType(b.type).forEach(function(p) {
        return p.callbacks.dragStopped();
      }), r.unsubscribe(), r = null;
    }
  }, f = function(b) {
    r || (process.env.NODE_ENV !== "production" ? pe(!1, "Should only be subscribed when a collection is occurring") : pe());
    var p = r.critical.draggable;
    b.type === "ADDITION" && Jx(e, p, b.value) && n.add(b.value), b.type === "REMOVAL" && Jx(e, p, b.value) && n.remove(b.value);
  }, h = function(b) {
    r && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot start capturing critical dimensions as there is already a collection") : pe());
    var p = e.draggable.getById(b.draggableId), v = e.droppable.getById(p.descriptor.droppableId), w = {
      draggable: p.descriptor,
      droppable: v.descriptor
    }, C = e.subscribe(f);
    return r = {
      critical: w,
      unsubscribe: C
    }, UU({
      critical: w,
      registry: e,
      scrollOptions: b.scrollOptions
    });
  }, g = {
    updateDroppableIsEnabled: i,
    updateDroppableIsCombineEnabled: o,
    scrollDroppable: l,
    updateDroppableScroll: s,
    startPublishing: h,
    stopPublishing: c
  };
  return g;
}, z1 = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, qU = function(e) {
  window.scrollBy(e.x, e.y);
}, VU = En(function(e) {
  return pp(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), YU = function(t, r) {
  var n = os(VU(r), function(i) {
    return i.frame || (process.env.NODE_ENV !== "production" ? pe(!1, "Invalid result") : pe()), _1(i.frame.pageMarginBox)(t);
  });
  return n;
}, KU = function(e) {
  var t = e.center, r = e.destination, n = e.droppables;
  if (r) {
    var i = n[r];
    return i.frame ? i : null;
  }
  var o = YU(t, n);
  return o;
}, Ga = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, XU = function(e, t) {
  var r = e[t.size] * Ga.startFromPercentage, n = e[t.size] * Ga.maxScrollAtPercentage, i = {
    startScrollingFrom: r,
    maxScrollValueAt: n
  };
  return i;
}, B1 = function(e) {
  var t = e.startOfRange, r = e.endOfRange, n = e.current, i = r - t;
  if (i === 0)
    return process.env.NODE_ENV !== "production" && Ar(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var o = n - t, s = o / i;
  return s;
}, hy = 1, JU = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return Ga.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return hy;
  var r = B1({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - r, i = Ga.maxPixelScroll * Ga.ease(n);
  return Math.ceil(i);
}, Zx = Ga.durationDampening.accelerateAt, Qx = Ga.durationDampening.stopDampeningAt, ZU = function(e, t) {
  var r = t, n = Qx, i = Date.now(), o = i - r;
  if (o >= Qx)
    return e;
  if (o < Zx)
    return hy;
  var s = B1({
    startOfRange: Zx,
    endOfRange: n,
    current: o
  }), l = e * Ga.ease(s);
  return Math.ceil(l);
}, e_ = function(e) {
  var t = e.distanceToEdge, r = e.thresholds, n = e.dragStartTime, i = e.shouldUseTimeDampening, o = JU(t, r);
  return o === 0 ? 0 : i ? Math.max(ZU(o, n), hy) : o;
}, t_ = function(e) {
  var t = e.container, r = e.distanceToEdges, n = e.dragStartTime, i = e.axis, o = e.shouldUseTimeDampening, s = XU(t, i), l = r[i.end] < r[i.start];
  return l ? e_({
    distanceToEdge: r[i.end],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: o
  }) : -1 * e_({
    distanceToEdge: r[i.start],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: o
  });
}, QU = function(e) {
  var t = e.container, r = e.subject, n = e.proposedScroll, i = r.height > t.height, o = r.width > t.width;
  return !o && !i ? n : o && i ? null : {
    x: o ? 0 : n.x,
    y: i ? 0 : n.y
  };
}, e3 = u1(function(e) {
  return e === 0 ? 0 : e;
}), F1 = function(e) {
  var t = e.dragStartTime, r = e.container, n = e.subject, i = e.center, o = e.shouldUseTimeDampening, s = {
    top: i.y - r.top,
    right: r.right - i.x,
    bottom: r.bottom - i.y,
    left: i.x - r.left
  }, l = t_({
    container: r,
    distanceToEdges: s,
    dragStartTime: t,
    axis: oy,
    shouldUseTimeDampening: o
  }), c = t_({
    container: r,
    distanceToEdges: s,
    dragStartTime: t,
    axis: g1,
    shouldUseTimeDampening: o
  }), f = e3({
    x: c,
    y: l
  });
  if (Ua(f, Cn))
    return null;
  var h = QU({
    container: r,
    subject: n,
    proposedScroll: f
  });
  return h ? Ua(h, Cn) ? null : h : null;
}, t3 = u1(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), gy = /* @__PURE__ */ function() {
  var e = function(r, n) {
    return r < 0 ? r : r > n ? r - n : 0;
  };
  return function(t) {
    var r = t.current, n = t.max, i = t.change, o = Pn(r, i), s = {
      x: e(o.x, n.x),
      y: e(o.y, n.y)
    };
    return Ua(s, Cn) ? null : s;
  };
}(), W1 = function(t) {
  var r = t.max, n = t.current, i = t.change, o = {
    x: Math.max(n.x, r.x),
    y: Math.max(n.y, r.y)
  }, s = t3(i), l = gy({
    max: o,
    current: n,
    change: s
  });
  return !l || s.x !== 0 && l.x === 0 || s.y !== 0 && l.y === 0;
}, vy = function(t, r) {
  return W1({
    current: t.scroll.current,
    max: t.scroll.max,
    change: r
  });
}, r3 = function(t, r) {
  if (!vy(t, r))
    return null;
  var n = t.scroll.max, i = t.scroll.current;
  return gy({
    current: i,
    max: n,
    change: r
  });
}, my = function(t, r) {
  var n = t.frame;
  return n ? W1({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  }) : !1;
}, n3 = function(t, r) {
  var n = t.frame;
  return !n || !my(t, r) ? null : gy({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  });
}, i3 = function(e) {
  var t = e.viewport, r = e.subject, n = e.center, i = e.dragStartTime, o = e.shouldUseTimeDampening, s = F1({
    dragStartTime: i,
    container: t.frame,
    subject: r,
    center: n,
    shouldUseTimeDampening: o
  });
  return s && vy(t, s) ? s : null;
}, o3 = function(e) {
  var t = e.droppable, r = e.subject, n = e.center, i = e.dragStartTime, o = e.shouldUseTimeDampening, s = t.frame;
  if (!s)
    return null;
  var l = F1({
    dragStartTime: i,
    container: s.pageMarginBox,
    subject: r,
    center: n,
    shouldUseTimeDampening: o
  });
  return l && my(t, l) ? l : null;
}, r_ = function(e) {
  var t = e.state, r = e.dragStartTime, n = e.shouldUseTimeDampening, i = e.scrollWindow, o = e.scrollDroppable, s = t.current.page.borderBoxCenter, l = t.dimensions.draggables[t.critical.draggable.id], c = l.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var f = t.viewport, h = i3({
      dragStartTime: r,
      viewport: f,
      subject: c,
      center: s,
      shouldUseTimeDampening: n
    });
    if (h) {
      i(h);
      return;
    }
  }
  var g = KU({
    center: s,
    destination: Si(t.impact),
    droppables: t.dimensions.droppables
  });
  if (g) {
    var S = o3({
      dragStartTime: r,
      droppable: g,
      subject: c,
      center: s,
      shouldUseTimeDampening: n
    });
    S && o(g.descriptor.id, S);
  }
}, a3 = function(e) {
  var t = e.scrollWindow, r = e.scrollDroppable, n = Ec(t), i = Ec(r), o = null, s = function(h) {
    o || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot fluid scroll if not dragging") : pe());
    var g = o, S = g.shouldUseTimeDampening, b = g.dragStartTime;
    r_({
      state: h,
      scrollWindow: n,
      scrollDroppable: i,
      dragStartTime: b,
      shouldUseTimeDampening: S
    });
  }, l = function(h) {
    Xc(), o && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot start auto scrolling when already started") : pe());
    var g = Date.now(), S = !1, b = function() {
      S = !0;
    };
    r_({
      state: h,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: b,
      scrollDroppable: b
    }), o = {
      dragStartTime: g,
      shouldUseTimeDampening: S
    }, Jc(), S && s(h);
  }, c = function() {
    o && (n.cancel(), i.cancel(), o = null);
  };
  return {
    start: l,
    stop: c,
    scroll: s
  };
}, s3 = function(e) {
  var t = e.move, r = e.scrollDroppable, n = e.scrollWindow, i = function(f, h) {
    var g = Pn(f.current.client.selection, h);
    t({
      client: g
    });
  }, o = function(f, h) {
    if (!my(f, h))
      return h;
    var g = n3(f, h);
    if (!g)
      return r(f.descriptor.id, h), null;
    var S = _i(h, g);
    r(f.descriptor.id, S);
    var b = _i(h, S);
    return b;
  }, s = function(f, h, g) {
    if (!f || !vy(h, g))
      return g;
    var S = r3(h, g);
    if (!S)
      return n(g), null;
    var b = _i(g, S);
    n(b);
    var p = _i(g, b);
    return p;
  }, l = function(f) {
    var h = f.scrollJumpRequest;
    if (h) {
      var g = Si(f.impact);
      g || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot perform a jump scroll when there is no destination") : pe());
      var S = o(f.dimensions.droppables[g], h);
      if (S) {
        var b = f.viewport, p = s(f.isWindowScrollAllowed, b, S);
        p && i(f, p);
      }
    }
  };
  return l;
}, l3 = function(e) {
  var t = e.scrollDroppable, r = e.scrollWindow, n = e.move, i = a3({
    scrollWindow: r,
    scrollDroppable: t
  }), o = s3({
    move: n,
    scrollWindow: r,
    scrollDroppable: t
  }), s = function(f) {
    if (f.phase === "DRAGGING") {
      if (f.movementMode === "FLUID") {
        i.scroll(f);
        return;
      }
      f.scrollJumpRequest && o(f);
    }
  }, l = {
    scroll: s,
    start: i.start,
    stop: i.stop
  };
  return l;
}, Hl = "data-rbd", $l = function() {
  var e = Hl + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), jv = function() {
  var e = Hl + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), u3 = function() {
  var e = Hl + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), n_ = {
  contextId: Hl + "-scroll-container-context-id"
}, c3 = function(t) {
  return function(r) {
    return "[" + r + '="' + t + '"]';
  };
}, ku = function(t, r) {
  return t.map(function(n) {
    var i = n.styles[r];
    return i ? n.selector + " { " + i + " }" : "";
  }).join(" ");
}, d3 = "pointer-events: none;", f3 = function(e) {
  var t = c3(e), r = function() {
    var l = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t($l.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: l,
        dragging: d3,
        dropAnimating: l
      }
    };
  }(), n = function() {
    var l = `
      transition: ` + fc.outOfTheWay + `;
    `;
    return {
      selector: t(jv.contextId),
      styles: {
        dragging: l,
        dropAnimating: l,
        userCancel: l
      }
    };
  }(), i = {
    selector: t(u3.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, o = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, s = [n, r, i, o];
  return {
    always: ku(s, "always"),
    resting: ku(s, "resting"),
    dragging: ku(s, "dragging"),
    dropAnimating: ku(s, "dropAnimating"),
    userCancel: ku(s, "userCancel")
  };
}, Ei = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? um : pt, sg = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find the head to append a style to") : pe()), t;
}, i_ = function(t) {
  var r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.type = "text/css", r;
};
function p3(e, t) {
  var r = dr(function() {
    return f3(e);
  }, [e]), n = bt(null), i = bt(null), o = Et(En(function(g) {
    var S = i.current;
    S || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot set dynamic style element if it is not set") : pe()), S.textContent = g;
  }), []), s = Et(function(g) {
    var S = n.current;
    S || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot set dynamic style element if it is not set") : pe()), S.textContent = g;
  }, []);
  Ei(function() {
    !n.current && !i.current || (process.env.NODE_ENV !== "production" ? pe(!1, "style elements already mounted") : pe());
    var g = i_(t), S = i_(t);
    return n.current = g, i.current = S, g.setAttribute(Hl + "-always", e), S.setAttribute(Hl + "-dynamic", e), sg().appendChild(g), sg().appendChild(S), s(r.always), o(r.resting), function() {
      var b = function(v) {
        var w = v.current;
        w || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot unmount ref as it is not set") : pe()), sg().removeChild(w), v.current = null;
      };
      b(n), b(i);
    };
  }, [t, s, o, r.always, r.resting, e]);
  var l = Et(function() {
    return o(r.dragging);
  }, [o, r.dragging]), c = Et(function(g) {
    if (g === "DROP") {
      o(r.dropAnimating);
      return;
    }
    o(r.userCancel);
  }, [o, r.dropAnimating, r.userCancel]), f = Et(function() {
    i.current && o(r.resting);
  }, [o, r.resting]), h = dr(function() {
    return {
      dragging: l,
      dropping: c,
      resting: f
    };
  }, [l, c, f]);
  return h;
}
var H1 = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function Zc(e) {
  return e instanceof H1(e).HTMLElement;
}
function $1(e, t) {
  var r = "[" + $l.contextId + '="' + e + '"]', n = c1(document.querySelectorAll(r));
  if (!n.length)
    return process.env.NODE_ENV !== "production" && Ar('Unable to find any drag handles in the context "' + e + '"'), null;
  var i = os(n, function(o) {
    return o.getAttribute($l.draggableId) === t;
  });
  return i ? Zc(i) ? i : (process.env.NODE_ENV !== "production" && Ar("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && Ar('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function h3(e) {
  var t = bt({}), r = bt(null), n = bt(null), i = bt(!1), o = Et(function(S, b) {
    var p = {
      id: S,
      focus: b
    };
    return t.current[S] = p, function() {
      var w = t.current, C = w[S];
      C !== p && delete w[S];
    };
  }, []), s = Et(function(S) {
    var b = $1(e, S);
    b && b !== document.activeElement && b.focus();
  }, [e]), l = Et(function(S, b) {
    r.current === S && (r.current = b);
  }, []), c = Et(function() {
    n.current || i.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var S = r.current;
      S && s(S);
    }));
  }, [s]), f = Et(function(S) {
    r.current = null;
    var b = document.activeElement;
    b && b.getAttribute($l.draggableId) === S && (r.current = S);
  }, []);
  Ei(function() {
    return i.current = !0, function() {
      i.current = !1;
      var S = n.current;
      S && cancelAnimationFrame(S);
    };
  }, []);
  var h = dr(function() {
    return {
      register: o,
      tryRecordFocus: f,
      tryRestoreFocusRecorded: c,
      tryShiftRecord: l
    };
  }, [o, f, c, l]);
  return h;
}
function g3() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function r(g) {
    return t.push(g), function() {
      var b = t.indexOf(g);
      b !== -1 && t.splice(b, 1);
    };
  }
  function n(g) {
    t.length && t.forEach(function(S) {
      return S(g);
    });
  }
  function i(g) {
    return e.draggables[g] || null;
  }
  function o(g) {
    var S = i(g);
    return S || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find draggable entry with id [" + g + "]") : pe()), S;
  }
  var s = {
    register: function(S) {
      e.draggables[S.descriptor.id] = S, n({
        type: "ADDITION",
        value: S
      });
    },
    update: function(S, b) {
      var p = e.draggables[b.descriptor.id];
      p && p.uniqueId === S.uniqueId && (delete e.draggables[b.descriptor.id], e.draggables[S.descriptor.id] = S);
    },
    unregister: function(S) {
      var b = S.descriptor.id, p = i(b);
      p && S.uniqueId === p.uniqueId && (delete e.draggables[b], n({
        type: "REMOVAL",
        value: S
      }));
    },
    getById: o,
    findById: i,
    exists: function(S) {
      return !!i(S);
    },
    getAllByType: function(S) {
      return Lf(e.draggables).filter(function(b) {
        return b.descriptor.type === S;
      });
    }
  };
  function l(g) {
    return e.droppables[g] || null;
  }
  function c(g) {
    var S = l(g);
    return S || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find droppable entry with id [" + g + "]") : pe()), S;
  }
  var f = {
    register: function(S) {
      e.droppables[S.descriptor.id] = S;
    },
    unregister: function(S) {
      var b = l(S.descriptor.id);
      b && S.uniqueId === b.uniqueId && delete e.droppables[S.descriptor.id];
    },
    getById: c,
    findById: l,
    exists: function(S) {
      return !!l(S);
    },
    getAllByType: function(S) {
      return Lf(e.droppables).filter(function(b) {
        return b.descriptor.type === S;
      });
    }
  };
  function h() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: s,
    droppable: f,
    subscribe: r,
    clean: h
  };
}
function v3() {
  var e = dr(g3, []);
  return pt(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var yy = dt.createContext(null), Dc = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot find document.body") : pe()), e;
}, m3 = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, y3 = function(t) {
  return "rbd-announcement-" + t;
};
function b3(e) {
  var t = dr(function() {
    return y3(e);
  }, [e]), r = bt(null);
  pt(function() {
    var o = document.createElement("div");
    return r.current = o, o.id = t, o.setAttribute("aria-live", "assertive"), o.setAttribute("aria-atomic", "true"), ct(o.style, m3), Dc().appendChild(o), function() {
      setTimeout(function() {
        var c = Dc();
        c.contains(o) && c.removeChild(o), o === r.current && (r.current = null);
      });
    };
  }, [t]);
  var n = Et(function(i) {
    var o = r.current;
    if (o) {
      o.textContent = i;
      return;
    }
    process.env.NODE_ENV !== "production" && Ar(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + i + `"
    `);
  }, []);
  return n;
}
var w3 = 0, x3 = {
  separator: "::"
};
function by(e, t) {
  return t === void 0 && (t = x3), dr(function() {
    return "" + e + t.separator + w3++;
  }, [t.separator, e]);
}
function _3(e) {
  var t = e.contextId, r = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + r;
}
function S3(e) {
  var t = e.contextId, r = e.text, n = by("hidden-text", {
    separator: "-"
  }), i = dr(function() {
    return _3({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return pt(function() {
    var s = document.createElement("div");
    return s.id = i, s.textContent = r, s.style.display = "none", Dc().appendChild(s), function() {
      var c = Dc();
      c.contains(s) && c.removeChild(s);
    };
  }, [i, r]), i;
}
var mp = dt.createContext(null), E3 = {
  react: "^16.8.5 || ^17.0.0",
  "react-dom": "^16.8.5 || ^17.0.0"
}, C3 = /(\d+)\.(\d+)\.(\d+)/, o_ = function(t) {
  var r = C3.exec(t);
  r == null && (process.env.NODE_ENV !== "production" ? pe(!1, "Unable to parse React version " + t) : pe());
  var n = Number(r[1]), i = Number(r[2]), o = Number(r[3]);
  return {
    major: n,
    minor: i,
    patch: o,
    raw: t
  };
}, T3 = function(t, r) {
  return r.major > t.major ? !0 : r.major < t.major ? !1 : r.minor > t.minor ? !0 : r.minor < t.minor ? !1 : r.patch >= t.patch;
}, O3 = function(e, t) {
  var r = o_(e), n = o_(t);
  T3(r, n) || process.env.NODE_ENV !== "production" && Ar(`
    React version: [` + n.raw + `]
    does not satisfy expected peer dependency version: [` + r.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, lg = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, R3 = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && Ar(`
      No <!doctype html> found.

      ` + lg + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && Ar(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + lg + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && Ar(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + lg + `
    `);
};
function wy(e) {
  process.env.NODE_ENV !== "production" && e();
}
function Qc(e, t) {
  wy(function() {
    pt(function() {
      try {
        e();
      } catch (r) {
        Dv(`
          A setup problem was encountered.

          > ` + r.message + `
        `);
      }
    }, t);
  });
}
function I3() {
  Qc(function() {
    O3(E3.react, dt.version), R3(document);
  }, []);
}
function xy(e) {
  var t = bt(e);
  return pt(function() {
    t.current = e;
  }), t;
}
function D3() {
  var e = null;
  function t() {
    return !!e;
  }
  function r(s) {
    return s === e;
  }
  function n(s) {
    e && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot claim lock as it is already claimed") : pe());
    var l = {
      abandon: s
    };
    return e = l, l;
  }
  function i() {
    e || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot release lock when there is no lock") : pe()), e = null;
  }
  function o() {
    e && (e.abandon(), i());
  }
  return {
    isClaimed: t,
    isActive: r,
    claim: n,
    release: i,
    tryAbandon: o
  };
}
var P3 = 9, M3 = 13, _y = 27, U1 = 32, A3 = 33, N3 = 34, j3 = 35, k3 = 36, L3 = 37, z3 = 38, B3 = 39, F3 = 40, tf, W3 = (tf = {}, tf[M3] = !0, tf[P3] = !0, tf), G1 = function(e) {
  W3[e.keyCode] && e.preventDefault();
}, yp = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], r = os(t, function(n) {
    return "on" + n in document;
  });
  return r || e;
}(), q1 = 0, a_ = 5;
function H3(e, t) {
  return Math.abs(t.x - e.x) >= a_ || Math.abs(t.y - e.y) >= a_;
}
var s_ = {
  type: "IDLE"
};
function $3(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase, i = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(s) {
      var l = s.button, c = s.clientX, f = s.clientY;
      if (l === q1) {
        var h = {
          x: c,
          y: f
        }, g = n();
        if (g.type === "DRAGGING") {
          s.preventDefault(), g.actions.move(h);
          return;
        }
        g.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot be IDLE") : pe());
        var S = g.point;
        if (H3(S, h)) {
          s.preventDefault();
          var b = g.actions.fluidLift(h);
          i({
            type: "DRAGGING",
            actions: b
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(s) {
      var l = n();
      if (l.type !== "DRAGGING") {
        t();
        return;
      }
      s.preventDefault(), l.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "mousedown",
    fn: function(s) {
      n().type === "DRAGGING" && s.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(s) {
      var l = n();
      if (l.type === "PENDING") {
        t();
        return;
      }
      if (s.keyCode === _y) {
        s.preventDefault(), t();
        return;
      }
      G1(s);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(s) {
      var l = n();
      if (l.type === "IDLE" && (process.env.NODE_ENV !== "production" ? pe(!1, "Unexpected phase") : pe()), l.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      s.preventDefault();
    }
  }, {
    eventName: yp,
    fn: t
  }];
}
function U3(e) {
  var t = bt(s_), r = bt($a), n = dr(function() {
    return {
      eventName: "mousedown",
      fn: function(g) {
        if (!g.defaultPrevented && g.button === q1 && !(g.ctrlKey || g.metaKey || g.shiftKey || g.altKey)) {
          var S = e.findClosestDraggableId(g);
          if (S) {
            var b = e.tryGetLock(S, s, {
              sourceEvent: g
            });
            if (b) {
              g.preventDefault();
              var p = {
                x: g.clientX,
                y: g.clientY
              };
              r.current(), f(b, p);
            }
          }
        }
      }
    };
  }, [e]), i = dr(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(g) {
        if (!g.defaultPrevented) {
          var S = e.findClosestDraggableId(g);
          if (S) {
            var b = e.findOptionsForDraggable(S);
            b && (b.shouldRespectForcePress || e.canGetLock(S) && g.preventDefault());
          }
        }
      }
    };
  }, [e]), o = Et(function() {
    var g = {
      passive: !1,
      capture: !0
    };
    r.current = $i(window, [i, n], g);
  }, [i, n]), s = Et(function() {
    var h = t.current;
    h.type !== "IDLE" && (t.current = s_, r.current(), o());
  }, [o]), l = Et(function() {
    var h = t.current;
    s(), h.type === "DRAGGING" && h.actions.cancel({
      shouldBlockNextClick: !0
    }), h.type === "PENDING" && h.actions.abort();
  }, [s]), c = Et(function() {
    var g = {
      capture: !0,
      passive: !1
    }, S = $3({
      cancel: l,
      completed: s,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(p) {
        t.current = p;
      }
    });
    r.current = $i(window, S, g);
  }, [l, s]), f = Et(function(g, S) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? pe(!1, "Expected to move from IDLE to PENDING drag") : pe()), t.current = {
      type: "PENDING",
      point: S,
      actions: g
    }, c();
  }, [c]);
  Ei(function() {
    return o(), function() {
      r.current();
    };
  }, [o]);
}
var wl;
function G3() {
}
var q3 = (wl = {}, wl[N3] = !0, wl[A3] = !0, wl[k3] = !0, wl[j3] = !0, wl);
function V3(e, t) {
  function r() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(o) {
      if (o.keyCode === _y) {
        o.preventDefault(), r();
        return;
      }
      if (o.keyCode === U1) {
        o.preventDefault(), n();
        return;
      }
      if (o.keyCode === F3) {
        o.preventDefault(), e.moveDown();
        return;
      }
      if (o.keyCode === z3) {
        o.preventDefault(), e.moveUp();
        return;
      }
      if (o.keyCode === B3) {
        o.preventDefault(), e.moveRight();
        return;
      }
      if (o.keyCode === L3) {
        o.preventDefault(), e.moveLeft();
        return;
      }
      if (q3[o.keyCode]) {
        o.preventDefault();
        return;
      }
      G1(o);
    }
  }, {
    eventName: "mousedown",
    fn: r
  }, {
    eventName: "mouseup",
    fn: r
  }, {
    eventName: "click",
    fn: r
  }, {
    eventName: "touchstart",
    fn: r
  }, {
    eventName: "resize",
    fn: r
  }, {
    eventName: "wheel",
    fn: r,
    options: {
      passive: !0
    }
  }, {
    eventName: yp,
    fn: r
  }];
}
function Y3(e) {
  var t = bt(G3), r = dr(function() {
    return {
      eventName: "keydown",
      fn: function(o) {
        if (o.defaultPrevented || o.keyCode !== U1)
          return;
        var s = e.findClosestDraggableId(o);
        if (!s)
          return;
        var l = e.tryGetLock(s, h, {
          sourceEvent: o
        });
        if (!l)
          return;
        o.preventDefault();
        var c = !0, f = l.snapLift();
        t.current();
        function h() {
          c || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot stop capturing a keyboard drag when not capturing") : pe()), c = !1, t.current(), n();
        }
        t.current = $i(window, V3(f, h), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = Et(function() {
    var o = {
      passive: !1,
      capture: !0
    };
    t.current = $i(window, [r], o);
  }, [r]);
  Ei(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var ug = {
  type: "IDLE"
}, K3 = 120, X3 = 0.15;
function J3(e) {
  var t = e.cancel, r = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(i) {
      i.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(i) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      i.keyCode === _y && i.preventDefault(), t();
    }
  }, {
    eventName: yp,
    fn: t
  }];
}
function Z3(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      s.hasMoved = !0;
      var l = o.touches[0], c = l.clientX, f = l.clientY, h = {
        x: c,
        y: f
      };
      o.preventDefault(), s.actions.move(h);
    }
  }, {
    eventName: "touchend",
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "touchcancel",
    fn: function(o) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(o) {
      var s = n();
      s.type === "IDLE" && (process.env.NODE_ENV, pe());
      var l = o.touches[0];
      if (l) {
        var c = l.force >= X3;
        if (c) {
          var f = s.actions.shouldRespectForcePress();
          if (s.type === "PENDING") {
            f && t();
            return;
          }
          if (f) {
            if (s.hasMoved) {
              o.preventDefault();
              return;
            }
            t();
            return;
          }
          o.preventDefault();
        }
      }
    }
  }, {
    eventName: yp,
    fn: t
  }];
}
function Q3(e) {
  var t = bt(ug), r = bt($a), n = Et(function() {
    return t.current;
  }, []), i = Et(function(b) {
    t.current = b;
  }, []), o = dr(function() {
    return {
      eventName: "touchstart",
      fn: function(b) {
        if (!b.defaultPrevented) {
          var p = e.findClosestDraggableId(b);
          if (p) {
            var v = e.tryGetLock(p, l, {
              sourceEvent: b
            });
            if (v) {
              var w = b.touches[0], C = w.clientX, M = w.clientY, L = {
                x: C,
                y: M
              };
              r.current(), g(v, L);
            }
          }
        }
      }
    };
  }, [e]), s = Et(function() {
    var b = {
      capture: !0,
      passive: !1
    };
    r.current = $i(window, [o], b);
  }, [o]), l = Et(function() {
    var S = t.current;
    S.type !== "IDLE" && (S.type === "PENDING" && clearTimeout(S.longPressTimerId), i(ug), r.current(), s());
  }, [s, i]), c = Et(function() {
    var S = t.current;
    l(), S.type === "DRAGGING" && S.actions.cancel({
      shouldBlockNextClick: !0
    }), S.type === "PENDING" && S.actions.abort();
  }, [l]), f = Et(function() {
    var b = {
      capture: !0,
      passive: !1
    }, p = {
      cancel: c,
      completed: l,
      getPhase: n
    }, v = $i(window, Z3(p), b), w = $i(window, J3(p), b);
    r.current = function() {
      v(), w();
    };
  }, [c, n, l]), h = Et(function() {
    var b = n();
    b.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot start dragging from phase " + b.type) : pe());
    var p = b.actions.fluidLift(b.point);
    i({
      type: "DRAGGING",
      actions: p,
      hasMoved: !1
    });
  }, [n, i]), g = Et(function(b, p) {
    n().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? pe(!1, "Expected to move from IDLE to PENDING drag") : pe());
    var v = setTimeout(h, K3);
    i({
      type: "PENDING",
      point: p,
      actions: b,
      longPressTimerId: v
    }), f();
  }, [f, n, i, h]);
  Ei(function() {
    return s(), function() {
      r.current();
      var p = n();
      p.type === "PENDING" && (clearTimeout(p.longPressTimerId), i(ug));
    };
  }, [n, s, i]), Ei(function() {
    var b = $i(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return b;
  }, []);
}
function eG(e) {
  wy(function() {
    var t = xy(e);
    Qc(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot change the amount of sensor hooks after mounting") : pe(!1));
    });
  });
}
var tG = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function V1(e, t) {
  if (t == null)
    return !1;
  var r = !!tG[t.tagName.toLowerCase()];
  if (r)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : V1(e, t.parentElement);
}
function rG(e, t) {
  var r = t.target;
  return Zc(r) ? V1(e, r) : !1;
}
var nG = function(e) {
  return fo(e.getBoundingClientRect()).center;
};
function iG(e) {
  return e instanceof H1(e).Element;
}
var oG = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], r = os(t, function(n) {
    return n in Element.prototype;
  });
  return r || e;
}();
function Y1(e, t) {
  return e == null ? null : e[oG](t) ? e : Y1(e.parentElement, t);
}
function aG(e, t) {
  return e.closest ? e.closest(t) : Y1(e, t);
}
function sG(e) {
  return "[" + $l.contextId + '="' + e + '"]';
}
function lG(e, t) {
  var r = t.target;
  if (!iG(r))
    return process.env.NODE_ENV !== "production" && Ar("event.target must be a Element"), null;
  var n = sG(e), i = aG(r, n);
  return i ? Zc(i) ? i : (process.env.NODE_ENV !== "production" && Ar("drag handle must be a HTMLElement"), null) : null;
}
function uG(e, t) {
  var r = lG(e, t);
  return r ? r.getAttribute($l.draggableId) : null;
}
function cG(e, t) {
  var r = "[" + jv.contextId + '="' + e + '"]', n = c1(document.querySelectorAll(r)), i = os(n, function(o) {
    return o.getAttribute(jv.id) === t;
  });
  return i ? Zc(i) ? i : (process.env.NODE_ENV !== "production" && Ar("Draggable element is not a HTMLElement"), null) : null;
}
function dG(e) {
  e.preventDefault();
}
function rf(e) {
  var t = e.expected, r = e.phase, n = e.isLockActive, i = e.shouldWarn;
  return n() ? t !== r ? (i && process.env.NODE_ENV !== "production" && Ar(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + r + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (i && process.env.NODE_ENV !== "production" && Ar(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function K1(e) {
  var t = e.lockAPI, r = e.store, n = e.registry, i = e.draggableId;
  if (t.isClaimed())
    return !1;
  var o = n.draggable.findById(i);
  return o ? !(!o.options.isEnabled || !z1(r.getState(), i)) : (process.env.NODE_ENV !== "production" && Ar("Unable to find draggable with id: " + i), !1);
}
function fG(e) {
  var t = e.lockAPI, r = e.contextId, n = e.store, i = e.registry, o = e.draggableId, s = e.forceSensorStop, l = e.sourceEvent, c = K1({
    lockAPI: t,
    store: n,
    registry: i,
    draggableId: o
  });
  if (!c)
    return null;
  var f = i.draggable.getById(o), h = cG(r, f.descriptor.id);
  if (!h)
    return process.env.NODE_ENV !== "production" && Ar("Unable to find draggable element with id: " + o), null;
  if (l && !f.options.canDragInteractiveElements && rG(h, l))
    return null;
  var g = t.claim(s || $a), S = "PRE_DRAG";
  function b() {
    return f.options.shouldRespectForcePress;
  }
  function p() {
    return t.isActive(g);
  }
  function v(B, K) {
    rf({
      expected: B,
      phase: S,
      isLockActive: p,
      shouldWarn: !0
    }) && n.dispatch(K());
  }
  var w = v.bind(null, "DRAGGING");
  function C(B) {
    function K() {
      t.release(), S = "COMPLETED";
    }
    S !== "PRE_DRAG" && (K(), S !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot lift in phase " + S) : pe())), n.dispatch(J$(B.liftActionArgs)), S = "DRAGGING";
    function Z(ee, he) {
      if (he === void 0 && (he = {
        shouldBlockNextClick: !1
      }), B.cleanup(), he.shouldBlockNextClick) {
        var _e = $i(window, [{
          eventName: "click",
          fn: dG,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(_e);
      }
      K(), n.dispatch(P1({
        reason: ee
      }));
    }
    return ct({
      isActive: function() {
        return rf({
          expected: "DRAGGING",
          phase: S,
          isLockActive: p,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: b,
      drop: function(he) {
        return Z("DROP", he);
      },
      cancel: function(he) {
        return Z("CANCEL", he);
      }
    }, B.actions);
  }
  function M(B) {
    var K = Ec(function(ee) {
      w(function() {
        return D1({
          client: ee
        });
      });
    }), Z = C({
      liftActionArgs: {
        id: o,
        clientSelection: B,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return K.cancel();
      },
      actions: {
        move: K
      }
    });
    return ct({}, Z, {
      move: K
    });
  }
  function L() {
    var B = {
      moveUp: function() {
        return w(aU);
      },
      moveRight: function() {
        return w(lU);
      },
      moveDown: function() {
        return w(sU);
      },
      moveLeft: function() {
        return w(uU);
      }
    };
    return C({
      liftActionArgs: {
        id: o,
        clientSelection: nG(h),
        movementMode: "SNAP"
      },
      cleanup: $a,
      actions: B
    });
  }
  function W() {
    var B = rf({
      expected: "PRE_DRAG",
      phase: S,
      isLockActive: p,
      shouldWarn: !0
    });
    B && t.release();
  }
  var z = {
    isActive: function() {
      return rf({
        expected: "PRE_DRAG",
        phase: S,
        isLockActive: p,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: b,
    fluidLift: M,
    snapLift: L,
    abort: W
  };
  return z;
}
var pG = [U3, Y3, Q3];
function hG(e) {
  var t = e.contextId, r = e.store, n = e.registry, i = e.customSensors, o = e.enableDefaultSensors, s = [].concat(o ? pG : [], i || []), l = Xe(function() {
    return D3();
  })[0], c = Et(function(M, L) {
    M.isDragging && !L.isDragging && l.tryAbandon();
  }, [l]);
  Ei(function() {
    var M = r.getState(), L = r.subscribe(function() {
      var W = r.getState();
      c(M, W), M = W;
    });
    return L;
  }, [l, r, c]), Ei(function() {
    return l.tryAbandon;
  }, [l.tryAbandon]);
  var f = Et(function(C) {
    return K1({
      lockAPI: l,
      registry: n,
      store: r,
      draggableId: C
    });
  }, [l, n, r]), h = Et(function(C, M, L) {
    return fG({
      lockAPI: l,
      registry: n,
      contextId: t,
      store: r,
      draggableId: C,
      forceSensorStop: M,
      sourceEvent: L && L.sourceEvent ? L.sourceEvent : null
    });
  }, [t, l, n, r]), g = Et(function(C) {
    return uG(t, C);
  }, [t]), S = Et(function(C) {
    var M = n.draggable.findById(C);
    return M ? M.options : null;
  }, [n.draggable]), b = Et(function() {
    l.isClaimed() && (l.tryAbandon(), r.getState().phase !== "IDLE" && r.dispatch(cy()));
  }, [l, r]), p = Et(l.isClaimed, [l]), v = dr(function() {
    return {
      canGetLock: f,
      tryGetLock: h,
      findClosestDraggableId: g,
      findOptionsForDraggable: S,
      tryReleaseLock: b,
      isLockClaimed: p
    };
  }, [f, h, g, S, b, p]);
  eG(s);
  for (var w = 0; w < s.length; w++)
    s[w](v);
}
var gG = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function Lu(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find store from lazy ref") : pe()), e.current;
}
function vG(e) {
  var t = e.contextId, r = e.setCallbacks, n = e.sensors, i = e.nonce, o = e.dragHandleUsageInstructions, s = bt(null);
  I3();
  var l = xy(e), c = Et(function() {
    return gG(l.current);
  }, [l]), f = b3(t), h = S3({
    contextId: t,
    text: o
  }), g = p3(t, i), S = Et(function(ee) {
    Lu(s).dispatch(ee);
  }, []), b = dr(function() {
    return Cx({
      publishWhileDragging: Q$,
      updateDroppableScroll: tU,
      updateDroppableIsEnabled: rU,
      updateDroppableIsCombineEnabled: nU,
      collectionStarting: eU
    }, S);
  }, [S]), p = v3(), v = dr(function() {
    return GU(p, b);
  }, [p, b]), w = dr(function() {
    return l3(ct({
      scrollWindow: qU,
      scrollDroppable: v.scrollDroppable
    }, Cx({
      move: D1
    }, S)));
  }, [v.scrollDroppable, S]), C = h3(t), M = dr(function() {
    return WU({
      announce: f,
      autoScroller: w,
      dimensionMarshal: v,
      focusMarshal: C,
      getResponders: c,
      styleMarshal: g
    });
  }, [f, w, v, C, c, g]);
  process.env.NODE_ENV !== "production" && s.current && s.current !== M && process.env.NODE_ENV !== "production" && Ar("unexpected store change"), s.current = M;
  var L = Et(function() {
    var ee = Lu(s), he = ee.getState();
    he.phase !== "IDLE" && ee.dispatch(cy());
  }, []), W = Et(function() {
    var ee = Lu(s).getState();
    return ee.isDragging || ee.phase === "DROP_ANIMATING";
  }, []), z = dr(function() {
    return {
      isDragging: W,
      tryAbort: L
    };
  }, [W, L]);
  r(z);
  var B = Et(function(ee) {
    return z1(Lu(s).getState(), ee);
  }, []), K = Et(function() {
    return Ts(Lu(s).getState());
  }, []), Z = dr(function() {
    return {
      marshal: v,
      focus: C,
      contextId: t,
      canLift: B,
      isMovementAllowed: K,
      dragHandleUsageInstructionsId: h,
      registry: p
    };
  }, [t, v, h, C, B, K, p]);
  return hG({
    contextId: t,
    store: M,
    registry: p,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), pt(function() {
    return L;
  }, [L]), dt.createElement(mp.Provider, {
    value: Z
  }, dt.createElement(ZC, {
    context: yy,
    store: M
  }, e.children));
}
var mG = 0;
function yG() {
  return dr(function() {
    return "" + mG++;
  }, []);
}
function X1(e) {
  var t = yG(), r = e.dragHandleUsageInstructions || hf.dragHandleUsageInstructions;
  return dt.createElement(F4, null, function(n) {
    return dt.createElement(vG, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: r,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var Sy = function(t) {
  return function(r) {
    return t === r;
  };
}, bG = Sy("scroll"), wG = Sy("auto"), xG = Sy("visible"), l_ = function(t, r) {
  return r(t.overflowX) || r(t.overflowY);
}, _G = function(t, r) {
  return r(t.overflowX) && r(t.overflowY);
}, J1 = function(t) {
  var r = window.getComputedStyle(t), n = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return l_(n, bG) || l_(n, wG);
}, SG = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = Dc(), r = document.documentElement;
  if (r || (process.env.NODE_ENV, pe()), !J1(t))
    return !1;
  var n = window.getComputedStyle(r), i = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return _G(i, xG) || process.env.NODE_ENV !== "production" && Ar(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Z1 = function e(t) {
  return t == null ? null : t === document.body ? SG() ? t : null : t === document.documentElement ? null : J1(t) ? t : e(t.parentElement);
}, EG = function(e) {
  if (e) {
    var t = Z1(e.parentElement);
    t && process.env.NODE_ENV !== "production" && Ar(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, kv = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, CG = function e(t) {
  if (!t)
    return !1;
  var r = window.getComputedStyle(t);
  return r.position === "fixed" ? !0 : e(t.parentElement);
}, TG = function(e) {
  var t = Z1(e), r = CG(e);
  return {
    closestScrollable: t,
    isFixedOnPage: r
  };
}, OG = function(e) {
  var t = e.descriptor, r = e.isEnabled, n = e.isCombineEnabled, i = e.isFixedOnPage, o = e.direction, s = e.client, l = e.page, c = e.closest, f = function() {
    if (!c)
      return null;
    var b = c.scrollSize, p = c.client, v = j1({
      scrollHeight: b.scrollHeight,
      scrollWidth: b.scrollWidth,
      height: p.paddingBox.height,
      width: p.paddingBox.width
    });
    return {
      pageMarginBox: c.page.marginBox,
      frameClient: p,
      scrollSize: b,
      shouldClipSubject: c.shouldClipSubject,
      scroll: {
        initial: c.scroll,
        current: c.scroll,
        max: v,
        diff: {
          value: Cn,
          displacement: Cn
        }
      }
    };
  }(), h = o === "vertical" ? oy : g1, g = Wl({
    page: l,
    withPlaceholder: null,
    axis: h,
    frame: f
  }), S = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: i,
    axis: h,
    isEnabled: r,
    client: s,
    page: l,
    frame: f,
    subject: g
  };
  return S;
}, RG = function(t, r) {
  var n = o1(t);
  if (!r || t !== r)
    return n;
  var i = n.paddingBox.top - r.scrollTop, o = n.paddingBox.left - r.scrollLeft, s = i + r.scrollHeight, l = o + r.scrollWidth, c = {
    top: i,
    right: l,
    bottom: s,
    left: o
  }, f = ey(c, n.border), h = ty({
    borderBox: f,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return h;
}, IG = function(e) {
  var t = e.ref, r = e.descriptor, n = e.env, i = e.windowScroll, o = e.direction, s = e.isDropDisabled, l = e.isCombineEnabled, c = e.shouldClipSubject, f = n.closestScrollable, h = RG(t, f), g = jf(h, i), S = function() {
    if (!f)
      return null;
    var p = o1(f), v = {
      scrollHeight: f.scrollHeight,
      scrollWidth: f.scrollWidth
    };
    return {
      client: p,
      page: jf(p, i),
      scroll: kv(f),
      scrollSize: v,
      shouldClipSubject: c
    };
  }(), b = OG({
    descriptor: r,
    isEnabled: !s,
    isCombineEnabled: l,
    isFixedOnPage: n.isFixedOnPage,
    direction: o,
    client: h,
    page: g,
    closest: S
  });
  return b;
}, DG = {
  passive: !1
}, PG = {
  passive: !0
}, u_ = function(e) {
  return e.shouldPublishImmediately ? DG : PG;
};
function Bf(e) {
  var t = qi(e);
  return t || (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find required context") : pe()), t;
}
var nf = function(t) {
  return t && t.env.closestScrollable || null;
};
function MG(e) {
  var t = bt(null), r = Bf(mp), n = by("droppable"), i = r.registry, o = r.marshal, s = xy(e), l = dr(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), c = bt(l), f = dr(function() {
    return En(function(W, z) {
      t.current || (process.env.NODE_ENV !== "production" ? pe(!1, "Can only update scroll when dragging") : pe());
      var B = {
        x: W,
        y: z
      };
      o.updateDroppableScroll(l.id, B);
    });
  }, [l.id, o]), h = Et(function() {
    var W = t.current;
    return !W || !W.env.closestScrollable ? Cn : kv(W.env.closestScrollable);
  }, []), g = Et(function() {
    var W = h();
    f(W.x, W.y);
  }, [h, f]), S = dr(function() {
    return Ec(g);
  }, [g]), b = Et(function() {
    var W = t.current, z = nf(W);
    W && z || (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find scroll options while scrolling") : pe());
    var B = W.scrollOptions;
    if (B.shouldPublishImmediately) {
      g();
      return;
    }
    S();
  }, [S, g]), p = Et(function(W, z) {
    t.current && (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot collect a droppable while a drag is occurring") : pe());
    var B = s.current, K = B.getDroppableRef();
    K || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot collect without a droppable ref") : pe());
    var Z = TG(K), ee = {
      ref: K,
      descriptor: l,
      env: Z,
      scrollOptions: z
    };
    t.current = ee;
    var he = IG({
      ref: K,
      descriptor: l,
      env: Z,
      windowScroll: W,
      direction: B.direction,
      isDropDisabled: B.isDropDisabled,
      isCombineEnabled: B.isCombineEnabled,
      shouldClipSubject: !B.ignoreContainerClipping
    }), _e = Z.closestScrollable;
    return _e && (_e.setAttribute(n_.contextId, r.contextId), _e.addEventListener("scroll", b, u_(ee.scrollOptions)), process.env.NODE_ENV !== "production" && EG(_e)), he;
  }, [r.contextId, l, b, s]), v = Et(function() {
    var W = t.current, z = nf(W);
    return W && z || (process.env.NODE_ENV !== "production" ? pe(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : pe()), kv(z);
  }, []), w = Et(function() {
    var W = t.current;
    W || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot stop drag when no active drag") : pe());
    var z = nf(W);
    t.current = null, z && (S.cancel(), z.removeAttribute(n_.contextId), z.removeEventListener("scroll", b, u_(W.scrollOptions)));
  }, [b, S]), C = Et(function(W) {
    var z = t.current;
    z || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot scroll when there is no drag") : pe());
    var B = nf(z);
    B || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot scroll a droppable with no closest scrollable") : pe()), B.scrollTop += W.y, B.scrollLeft += W.x;
  }, []), M = dr(function() {
    return {
      getDimensionAndWatchScroll: p,
      getScrollWhileDragging: v,
      dragStopped: w,
      scroll: C
    };
  }, [w, p, v, C]), L = dr(function() {
    return {
      uniqueId: n,
      descriptor: l,
      callbacks: M
    };
  }, [M, l, n]);
  Ei(function() {
    return c.current = L.descriptor, i.droppable.register(L), function() {
      t.current && (process.env.NODE_ENV !== "production" && Ar("Unsupported: changing the droppableId or type of a Droppable during a drag"), w()), i.droppable.unregister(L);
    };
  }, [M, l, w, L, o, i.droppable]), Ei(function() {
    t.current && o.updateDroppableIsEnabled(c.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, o]), Ei(function() {
    t.current && o.updateDroppableIsCombineEnabled(c.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, o]);
}
function cg() {
}
var c_ = {
  width: 0,
  height: 0,
  margin: q4
}, AG = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, i = t.animate;
  return r || i === "close" ? c_ : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, NG = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, i = t.animate, o = AG({
    isAnimatingOpenOnMount: r,
    placeholder: n,
    animate: i
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: o.width,
    height: o.height,
    marginTop: o.margin.top,
    marginRight: o.margin.right,
    marginBottom: o.margin.bottom,
    marginLeft: o.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: i !== "none" ? fc.placeholder : null
  };
};
function jG(e) {
  var t = bt(null), r = Et(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, i = e.onTransitionEnd, o = e.onClose, s = e.contextId, l = Xe(e.animate === "open"), c = l[0], f = l[1];
  pt(function() {
    return c ? n !== "open" ? (r(), f(!1), cg) : t.current ? cg : (t.current = setTimeout(function() {
      t.current = null, f(!1);
    }), r) : cg;
  }, [n, c, r]);
  var h = Et(function(S) {
    S.propertyName === "height" && (i(), n === "close" && o());
  }, [n, o, i]), g = NG({
    isAnimatingOpenOnMount: c,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return dt.createElement(e.placeholder.tagName, {
    style: g,
    "data-rbd-placeholder-context-id": s,
    onTransitionEnd: h,
    ref: e.innerRef
  });
}
var kG = dt.memo(jG), Ey = dt.createContext(null);
function Q1(e) {
  e && Zc(e) || (process.env.NODE_ENV !== "production" ? pe(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : pe());
}
function dg(e) {
  return typeof e == "boolean";
}
function fg(e, t) {
  t.forEach(function(r) {
    return r(e);
  });
}
var LG = [function(t) {
  var r = t.props;
  r.droppableId || (process.env.NODE_ENV !== "production" ? pe(!1, "A Droppable requires a droppableId prop") : pe()), typeof r.droppableId != "string" && (process.env.NODE_ENV !== "production" ? pe(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof r.droppableId + "]") : pe());
}, function(t) {
  var r = t.props;
  dg(r.isDropDisabled) || (process.env.NODE_ENV !== "production" ? pe(!1, "isDropDisabled must be a boolean") : pe()), dg(r.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? pe(!1, "isCombineEnabled must be a boolean") : pe()), dg(r.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? pe(!1, "ignoreContainerClipping must be a boolean") : pe());
}, function(t) {
  var r = t.getDroppableRef;
  Q1(r());
}], zG = [function(t) {
  var r = t.props, n = t.getPlaceholderRef;
  if (r.placeholder) {
    var i = n();
    i || process.env.NODE_ENV !== "production" && Ar(`
      Droppable setup issue [droppableId: "` + r.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], BG = [function(t) {
  var r = t.props;
  r.renderClone || (process.env.NODE_ENV !== "production" ? pe(!1, "Must provide a clone render function (renderClone) for virtual lists") : pe());
}, function(t) {
  var r = t.getPlaceholderRef;
  r() && (process.env.NODE_ENV !== "production" ? pe(!1, "Expected virtual list to not have a placeholder") : pe());
}];
function FG(e) {
  Qc(function() {
    fg(e, LG), e.props.mode === "standard" && fg(e, zG), e.props.mode === "virtual" && fg(e, BG);
  });
}
var WG = function(e) {
  Ql(t, e);
  function t() {
    for (var n, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(o)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(i, o) {
    return i.shouldAnimate ? i.on ? {
      isVisible: !0,
      data: i.on,
      animate: "open"
    } : o.isVisible ? {
      isVisible: !0,
      data: o.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!i.on,
      data: i.on,
      animate: "none"
    };
  };
  var r = t.prototype;
  return r.render = function() {
    if (!this.state.isVisible)
      return null;
    var i = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(i);
  }, t;
}(dt.PureComponent), d_ = {
  dragging: 5e3,
  dropAnimating: 4500
}, HG = function(t, r) {
  return r ? fc.drop(r.duration) : t ? fc.snap : fc.fluid;
}, $G = function(t, r) {
  return t ? r ? Ic.opacity.drop : Ic.opacity.combining : null;
}, UG = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function GG(e) {
  var t = e.dimension, r = t.client, n = e.offset, i = e.combineWith, o = e.dropping, s = !!i, l = UG(e), c = !!o, f = c ? Av.drop(n, s) : Av.moveTo(n), h = {
    position: "fixed",
    top: r.marginBox.top,
    left: r.marginBox.left,
    boxSizing: "border-box",
    width: r.borderBox.width,
    height: r.borderBox.height,
    transition: HG(l, o),
    transform: f,
    opacity: $G(s, c),
    zIndex: c ? d_.dropAnimating : d_.dragging,
    pointerEvents: "none"
  };
  return h;
}
function qG(e) {
  return {
    transform: Av.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function VG(e) {
  return e.type === "DRAGGING" ? GG(e) : qG(e);
}
function YG(e, t, r) {
  r === void 0 && (r = Cn);
  var n = window.getComputedStyle(t), i = t.getBoundingClientRect(), o = i1(i, n), s = jf(o, r), l = {
    client: o,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, c = {
    x: o.marginBox.width,
    y: o.marginBox.height
  }, f = {
    descriptor: e,
    placeholder: l,
    displaceBy: c,
    client: o,
    page: s
  };
  return f;
}
function KG(e) {
  var t = by("draggable"), r = e.descriptor, n = e.registry, i = e.getDraggableRef, o = e.canDragInteractiveElements, s = e.shouldRespectForcePress, l = e.isEnabled, c = dr(function() {
    return {
      canDragInteractiveElements: o,
      shouldRespectForcePress: s,
      isEnabled: l
    };
  }, [o, l, s]), f = Et(function(b) {
    var p = i();
    return p || (process.env.NODE_ENV !== "production" ? pe(!1, "Cannot get dimension when no ref is set") : pe()), YG(r, p, b);
  }, [r, i]), h = dr(function() {
    return {
      uniqueId: t,
      descriptor: r,
      options: c,
      getDimension: f
    };
  }, [r, f, c, t]), g = bt(h), S = bt(!0);
  Ei(function() {
    return n.draggable.register(g.current), function() {
      return n.draggable.unregister(g.current);
    };
  }, [n.draggable]), Ei(function() {
    if (S.current) {
      S.current = !1;
      return;
    }
    var b = g.current;
    g.current = h, n.draggable.update(h, b);
  }, [h, n.draggable]);
}
function XG(e, t, r) {
  Qc(function() {
    function n(o) {
      return "Draggable[id: " + o + "]: ";
    }
    var i = e.draggableId;
    i || (process.env.NODE_ENV !== "production" ? pe(!1, "Draggable requires a draggableId") : pe(!1)), typeof i != "string" && (process.env.NODE_ENV !== "production" ? pe(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof i + "] (value: " + i + ")") : pe(!1)), X4(e.index) || (process.env.NODE_ENV !== "production" ? pe(!1, n(i) + " requires an integer index prop") : pe(!1)), e.mapped.type !== "DRAGGING" && (Q1(r()), e.isEnabled && ($1(t, i) || (process.env.NODE_ENV !== "production" ? pe(!1, n(i) + " Unable to find drag handle") : pe(!1))));
  });
}
function JG(e) {
  wy(function() {
    var t = bt(e);
    Qc(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? pe(!1, "Draggable isClone prop value changed during component life") : pe(!1));
    }, [e]);
  });
}
function ZG(e) {
  e.preventDefault();
}
function QG(e) {
  var t = bt(null), r = Et(function(ee) {
    t.current = ee;
  }, []), n = Et(function() {
    return t.current;
  }, []), i = Bf(mp), o = i.contextId, s = i.dragHandleUsageInstructionsId, l = i.registry, c = Bf(Ey), f = c.type, h = c.droppableId, g = dr(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: f,
      droppableId: h
    };
  }, [e.draggableId, e.index, f, h]), S = e.children, b = e.draggableId, p = e.isEnabled, v = e.shouldRespectForcePress, w = e.canDragInteractiveElements, C = e.isClone, M = e.mapped, L = e.dropAnimationFinished;
  if (XG(e, o, n), JG(C), !C) {
    var W = dr(function() {
      return {
        descriptor: g,
        registry: l,
        getDraggableRef: n,
        canDragInteractiveElements: w,
        shouldRespectForcePress: v,
        isEnabled: p
      };
    }, [g, l, n, w, v, p]);
    KG(W);
  }
  var z = dr(function() {
    return p ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": s,
      "data-rbd-drag-handle-draggable-id": b,
      "data-rbd-drag-handle-context-id": o,
      draggable: !1,
      onDragStart: ZG
    } : null;
  }, [o, s, b, p]), B = Et(function(ee) {
    M.type === "DRAGGING" && M.dropping && ee.propertyName === "transform" && L();
  }, [L, M]), K = dr(function() {
    var ee = VG(M), he = M.type === "DRAGGING" && M.dropping ? B : null, _e = {
      innerRef: r,
      draggableProps: {
        "data-rbd-draggable-context-id": o,
        "data-rbd-draggable-id": b,
        style: ee,
        onTransitionEnd: he
      },
      dragHandleProps: z
    };
    return _e;
  }, [o, z, b, M, B, r]), Z = dr(function() {
    return {
      draggableId: g.id,
      type: g.type,
      source: {
        index: g.index,
        droppableId: g.droppableId
      }
    };
  }, [g.droppableId, g.id, g.index, g.type]);
  return S(K, M.snapshot, Z);
}
var eT = function(e, t) {
  return e === t;
}, tT = function(e) {
  var t = e.combine, r = e.destination;
  return r ? r.droppableId : t ? t.droppableId : null;
}, e6 = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, t6 = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function r6() {
  var e = En(function(i, o) {
    return {
      x: i,
      y: o
    };
  }), t = En(function(i, o, s, l, c) {
    return {
      isDragging: !0,
      isClone: o,
      isDropAnimating: !!c,
      dropAnimation: c,
      mode: i,
      draggingOver: s,
      combineWith: l,
      combineTargetFor: null
    };
  }), r = En(function(i, o, s, l, c, f, h) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: c,
        combineWith: f,
        mode: o,
        offset: i,
        dimension: s,
        forceShouldAnimate: h,
        snapshot: t(o, l, c, f, null)
      }
    };
  }), n = function(o, s) {
    if (o.isDragging) {
      if (o.critical.draggable.id !== s.draggableId)
        return null;
      var l = o.current.client.offset, c = o.dimensions.draggables[s.draggableId], f = Si(o.impact), h = t6(o.impact), g = o.forceShouldAnimate;
      return r(e(l.x, l.y), o.movementMode, c, s.isClone, f, h, g);
    }
    if (o.phase === "DROP_ANIMATING") {
      var S = o.completed;
      if (S.result.draggableId !== s.draggableId)
        return null;
      var b = s.isClone, p = o.dimensions.draggables[s.draggableId], v = S.result, w = v.mode, C = tT(v), M = e6(v), L = o.dropDuration, W = {
        duration: L,
        curve: fy.drop,
        moveTo: o.newHomeClientOffset,
        opacity: M ? Ic.opacity.drop : null,
        scale: M ? Ic.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: o.newHomeClientOffset,
          dimension: p,
          dropping: W,
          draggingOver: C,
          combineWith: M,
          mode: w,
          forceShouldAnimate: null,
          snapshot: t(w, b, C, M, W)
        }
      };
    }
    return null;
  };
  return n;
}
function rT(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var n6 = {
  mapped: {
    type: "SECONDARY",
    offset: Cn,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: rT(null)
  }
};
function i6() {
  var e = En(function(s, l) {
    return {
      x: s,
      y: l
    };
  }), t = En(rT), r = En(function(s, l, c) {
    return l === void 0 && (l = null), {
      mapped: {
        type: "SECONDARY",
        offset: s,
        combineTargetFor: l,
        shouldAnimateDisplacement: c,
        snapshot: t(l)
      }
    };
  }), n = function(l) {
    return l ? r(Cn, l, !0) : null;
  }, i = function(l, c, f, h) {
    var g = f.displaced.visible[l], S = !!(h.inVirtualList && h.effected[l]), b = hp(f), p = b && b.draggableId === l ? c : null;
    if (!g) {
      if (!S)
        return n(p);
      if (f.displaced.invisible[l])
        return null;
      var v = tu(h.displacedBy.point), w = e(v.x, v.y);
      return r(w, p, !0);
    }
    if (S)
      return n(p);
    var C = f.displacedBy.point, M = e(C.x, C.y);
    return r(M, p, g.shouldAnimate);
  }, o = function(l, c) {
    if (l.isDragging)
      return l.critical.draggable.id === c.draggableId ? null : i(c.draggableId, l.critical.draggable.id, l.impact, l.afterCritical);
    if (l.phase === "DROP_ANIMATING") {
      var f = l.completed;
      return f.result.draggableId === c.draggableId ? null : i(c.draggableId, f.result.draggableId, f.impact, f.afterCritical);
    }
    return null;
  };
  return o;
}
var o6 = function() {
  var t = r6(), r = i6(), n = function(o, s) {
    return t(o, s) || r(o, s) || n6;
  };
  return n;
}, a6 = {
  dropAnimationFinished: M1
}, s6 = r1(o6, a6, null, {
  context: yy,
  pure: !0,
  areStatePropsEqual: eT
})(QG);
function nT(e) {
  var t = Bf(Ey), r = t.isUsingCloneFor;
  return r === e.draggableId && !e.isClone ? null : dt.createElement(s6, e);
}
function Cy(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, r = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return dt.createElement(nT, ct({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: r,
    shouldRespectForcePress: n
  }));
}
function l6(e) {
  var t = qi(mp);
  t || (process.env.NODE_ENV !== "production" ? pe(!1, "Could not find app context") : pe());
  var r = t.contextId, n = t.isMovementAllowed, i = bt(null), o = bt(null), s = e.children, l = e.droppableId, c = e.type, f = e.mode, h = e.direction, g = e.ignoreContainerClipping, S = e.isDropDisabled, b = e.isCombineEnabled, p = e.snapshot, v = e.useClone, w = e.updateViewportMaxScroll, C = e.getContainerForClone, M = Et(function() {
    return i.current;
  }, []), L = Et(function(Te) {
    i.current = Te;
  }, []), W = Et(function() {
    return o.current;
  }, []), z = Et(function(Te) {
    o.current = Te;
  }, []);
  FG({
    props: e,
    getDroppableRef: M,
    getPlaceholderRef: W
  });
  var B = Et(function() {
    n() && w({
      maxScroll: L1()
    });
  }, [n, w]);
  MG({
    droppableId: l,
    type: c,
    mode: f,
    direction: h,
    isDropDisabled: S,
    isCombineEnabled: b,
    ignoreContainerClipping: g,
    getDroppableRef: M
  });
  var K = dt.createElement(WG, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(Te) {
    var fe = Te.onClose, Oe = Te.data, ye = Te.animate;
    return dt.createElement(kG, {
      placeholder: Oe,
      onClose: fe,
      innerRef: z,
      animate: ye,
      contextId: r,
      onTransitionEnd: B
    });
  }), Z = dr(function() {
    return {
      innerRef: L,
      placeholder: K,
      droppableProps: {
        "data-rbd-droppable-id": l,
        "data-rbd-droppable-context-id": r
      }
    };
  }, [r, l, K, L]), ee = v ? v.dragging.draggableId : null, he = dr(function() {
    return {
      droppableId: l,
      type: c,
      isUsingCloneFor: ee
    };
  }, [l, ee, c]);
  function _e() {
    if (!v)
      return null;
    var Te = v.dragging, fe = v.render, Oe = dt.createElement(nT, {
      draggableId: Te.draggableId,
      index: Te.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(ye, de) {
      return fe(ye, de, Te);
    });
    return ac.createPortal(Oe, C());
  }
  return dt.createElement(Ey.Provider, {
    value: he
  }, s(Z, p), _e());
}
var pg = function(t, r) {
  return t === r.droppable.type;
}, f_ = function(t, r) {
  return r.draggables[t.draggable.id];
}, u6 = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, r = ct({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = En(function(s) {
    return {
      draggableId: s.id,
      type: s.type,
      source: {
        index: s.index,
        droppableId: s.droppableId
      }
    };
  }), i = En(function(s, l, c, f, h, g) {
    var S = h.descriptor.id, b = h.descriptor.droppableId === s;
    if (b) {
      var p = g ? {
        render: g,
        dragging: n(h.descriptor)
      } : null, v = {
        isDraggingOver: c,
        draggingOverWith: c ? S : null,
        draggingFromThisWith: S,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: h.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: v,
        useClone: p
      };
    }
    if (!l)
      return r;
    if (!f)
      return t;
    var w = {
      isDraggingOver: c,
      draggingOverWith: S,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: h.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: w,
      useClone: null
    };
  }), o = function(l, c) {
    var f = c.droppableId, h = c.type, g = !c.isDropDisabled, S = c.renderClone;
    if (l.isDragging) {
      var b = l.critical;
      if (!pg(h, b))
        return r;
      var p = f_(b, l.dimensions), v = Si(l.impact) === f;
      return i(f, g, v, v, p, S);
    }
    if (l.phase === "DROP_ANIMATING") {
      var w = l.completed;
      if (!pg(h, w.critical))
        return r;
      var C = f_(w.critical, l.dimensions);
      return i(f, g, tT(w.result) === f, Si(w.impact) === f, C, S);
    }
    if (l.phase === "IDLE" && l.completed && !l.shouldFlush) {
      var M = l.completed;
      if (!pg(h, M.critical))
        return r;
      var L = Si(M.impact) === f, W = !!(M.impact.at && M.impact.at.type === "COMBINE"), z = M.critical.droppable.id === f;
      return L ? W ? t : r : z ? t : r;
    }
    return r;
  };
  return o;
}, c6 = {
  updateViewportMaxScroll: oU
};
function d6() {
  return document.body || (process.env.NODE_ENV !== "production" ? pe(!1, "document.body is not ready") : pe()), document.body;
}
var f6 = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: d6
}, bp = r1(u6, c6, null, {
  context: yy,
  pure: !0,
  areStatePropsEqual: eT
})(l6);
bp.defaultProps = f6;
const p6 = Rt((e) => ({
  wrapper: {
    position: "relative"
  },
  textField: {
    cursor: "auto",
    width: "100%"
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    position: "relative"
  },
  inputWrapperOutlined: {
    padding: 10
  },
  inputWrapperFilled: {
    padding: "23px 8px 10px"
  },
  chip: {
    margin: e.spacing(0.5, 1, 0.5, 0),
    overflow: "hidden"
  },
  chipsInput: {
    backgroundColor: "transparent",
    color: e.palette.mode === "dark" ? e.palette.common.white : void 0,
    outline: "none",
    border: 0,
    padding: "6px 0 7px",
    flexGrow: 1,
    fontSize: 16,
    flexBasis: e.spacing(6),
    "&::placeholder": {
      color: e.palette.mode === "light" ? e.palette.grey[600] : void 0
    }
  },
  chipsInputOutlined: {
    padding: "8.5px 4px",
    "&::placeholder": {
      color: e.palette.mode === "dark" ? e.palette.primary.main : void 0
    }
  },
  chipsInputFilled: {
    padding: "4px 4px 0",
    "&::placeholder": {
      color: e.palette.mode === "dark" ? e.palette.primary.main : void 0
    }
  },
  arrowIconStandard: {
    position: "absolute",
    right: -3,
    bottom: 1
  },
  arrowIconOutlined: {
    position: "absolute",
    right: 5,
    top: "50%",
    transform: "translateY(-50%)"
  }
})), h6 = Kf(
  ({
    inputRef: e,
    disabled: t,
    classes: r,
    variant: n,
    cColor: i,
    cValue: o,
    cOnChange: s,
    autocompleteList: l,
    loading: c,
    error: f,
    maxLength: h,
    cOnChipClick: g,
    cOnReorder: S,
    ...b
  }, p) => /* @__PURE__ */ y.jsxs(
    "div",
    {
      ref: p,
      className: nt(
        r.inputWrapper,
        n === "outlined" && r.inputWrapperOutlined,
        n === "filled" && r.inputWrapperFilled
      ),
      children: [
        /* @__PURE__ */ y.jsx(
          X1,
          {
            onDragEnd: (v) => {
              const { source: w, destination: C } = v;
              C && (S == null || S(w.index, C.index));
            },
            children: /* @__PURE__ */ y.jsx(bp, { droppableId: "droppable", direction: "horizontal", children: (v) => /* @__PURE__ */ y.jsxs(
              zt,
              {
                sx: {
                  flexWrap: "wrap",
                  display: "flex"
                },
                ref: v.innerRef,
                ...v.droppableProps,
                children: [
                  o == null ? void 0 : o.map((w, C) => /* @__PURE__ */ y.jsx(
                    Cy,
                    {
                      draggableId: w.id,
                      index: C,
                      isDragDisabled: !S,
                      children: (M) => /* @__PURE__ */ y.jsx(
                        zt,
                        {
                          ref: M.innerRef,
                          ...M.draggableProps,
                          ...M.dragHandleProps,
                          style: {
                            userSelect: "none",
                            ...M.draggableProps.style
                          },
                          children: /* @__PURE__ */ y.jsx(
                            Qa,
                            {
                              color: w.color ? "primary" : i,
                              style: {
                                ...w.color ? { backgroundColor: w.color } : {}
                              },
                              label: w.label,
                              onClick: g && (() => g(w, C)),
                              onDelete: s && (() => s(
                                o.filter(
                                  ({ id: L }) => L !== w.id
                                )
                              )),
                              className: r.chip,
                              disabled: t || w.disabled
                            },
                            w.id
                          )
                        }
                      )
                    },
                    w.id
                  )),
                  v.placeholder
                ]
              }
            ) })
          }
        ),
        (!h || !o || o.length < h) && /* @__PURE__ */ y.jsx(
          "input",
          {
            ...b,
            ref: e,
            disabled: t,
            className: nt(
              r.chipsInput,
              n === "outlined" && r.chipsInputOutlined,
              n === "filled" && r.chipsInputFilled
            )
          }
        )
      ]
    }
  )
), XJ = ({
  value: e = [],
  onChange: t,
  inputRef: r,
  label: n,
  className: i,
  color: o,
  disabled: s,
  variant: l = "standard",
  autocomplete: c,
  maxLength: f,
  onChipClick: h,
  TextFieldProps: g,
  showLevelIcons: S,
  startingIcon: b,
  onReorder: p,
  sx: v
}) => {
  const w = p6(), [C, M] = Xe(""), [L, W] = Xe(!1), z = !L && !C && !(e != null && e.length), [B, K] = Xe(void 0), [Z, ee] = Xe(!1), [he, _e] = Xe(void 0), Te = Wc(C, 500), fe = bt(null), Oe = !!c && L && !s && !!(!c.mandatoryInput || Te);
  pt(() => {
    Oe && c && (_e(void 0), ee(!0), c.fetchList(Te).then((ce) => {
      K(ce);
    }).catch(_e).finally(() => ee(!1)));
  }, [c, Te, Oe]);
  const ye = () => {
    C && !e.find((ce) => ce.label === C) && t && t([...e || [], { id: Pf(), label: C }]), M("");
  }, de = (ce) => {
    if (e.find(({ id: Fe }) => Fe === ce.id))
      t == null || t(e.filter(({ id: Fe }) => Fe !== ce.id));
    else {
      let Fe = [ce];
      if (c != null && c.selectChildren && B) {
        const le = (B == null ? void 0 : B.findIndex(({ id: J }) => J === ce.id)) || 0;
        for (const J of B.slice(le + 1))
          if (J != null && J.level && J.level > (ce.level || 0))
            e.find(({ id: re }) => re === (J == null ? void 0 : J.id)) || (Fe = [...Fe, J]);
          else
            break;
      }
      t == null || t([...e || [], ...Fe]);
    }
    C && (M(""), W(!1));
  };
  return /* @__PURE__ */ y.jsxs(
    zt,
    {
      className: nt(w.wrapper, i),
      ref: fe,
      onFocus: (ce) => ce.stopPropagation(),
      sx: v,
      children: [
        /* @__PURE__ */ y.jsx(
          ln,
          {
            className: w.textField,
            variant: l,
            label: n,
            disabled: s,
            placeholder: !z && e.length ? "Ajouter" : void 0,
            value: C,
            onKeyDown: (ce) => {
              ce.key === "Enter" && C && !c && (ce.stopPropagation(), ye());
            },
            onChange: (ce) => M(ce.target.value),
            onFocus: () => W(!0),
            onBlur: () => {
              c || ye();
            },
            helperText: C && L && !c ? "Appuyez sur Entrer pour ajouter" : void 0,
            ...g,
            InputProps: {
              inputComponent: h6,
              inputProps: {
                inputRef: r,
                classes: w,
                variant: l,
                cColor: o,
                cValue: e,
                cOnChange: t,
                autocompleteList: B,
                loading: Z,
                error: he,
                maxLength: f,
                cOnChipClick: h,
                cOnReorder: p
              },
              ...g == null ? void 0 : g.InputProps,
              ...b && {
                startAdornment: /* @__PURE__ */ y.jsx(hE, { position: "start", children: b })
              }
            },
            InputLabelProps: {
              shrink: e.length ? !0 : void 0,
              ...g == null ? void 0 : g.InputLabelProps
            }
          }
        ),
        c && !c.mandatoryInput && !C && /* @__PURE__ */ y.jsx(
          fr,
          {
            classes: {
              root: nt(
                l === "standard" && w.arrowIconStandard,
                (l === "outlined" || l === "filled") && w.arrowIconOutlined
              )
            },
            "data-testid": "chips-icon-button",
            size: "small",
            onClick: () => W((ce) => !ce),
            disabled: s,
            children: Oe ? /* @__PURE__ */ y.jsx(ym, {}) : /* @__PURE__ */ y.jsx(Lc, {})
          }
        ),
        /* @__PURE__ */ y.jsx(
          Wm,
          {
            showLevelIcons: S,
            open: Oe,
            anchorRef: fe,
            list: B == null ? void 0 : B.map((ce) => ({
              ...ce,
              selected: !!e.find(({ id: Fe }) => Fe === ce.id)
            })),
            loading: Z,
            error: he,
            onSelect: de,
            onClose: () => {
              W(!1), M("");
            }
          }
        )
      ]
    }
  );
}, Ty = 450;
var iT = /* @__PURE__ */ ((e) => (e.UPLOADING = "uploading", e.DONE = "done", e.INTERRUPTED = "interrupted", e.AWAITING = "awaiting", e))(iT || {}), ui = /* @__PURE__ */ ((e) => (e.PMD_IMAGE_TYPE = "pmd_bone_image", e.BRIGHTCOVE_TYPE = "brightcove", e.YOUTUBE_TYPE = "youtube", e.PLURIMEDIA_TYPE = "plurimedia", e.DAILYMOTION_TYPE = "dailymotion", e.SLIDESHOW_TYPE = "pmd_slideshow", e.AFFILIATION_TYPE = "ceriseaffiliation", e.PODCAST_TYPE = "Prisma Media Player", e))(ui || {});
const g6 = Rt(() => ({
  container: {
    textAlign: "center",
    margin: 5,
    padding: 10,
    backgroundColor: "#f9f9f9",
    borderRadius: 10
  }
})), JJ = ({
  name: e,
  value: t = 0,
  state: r,
  interruptProgress: n
}) => {
  const i = g6(), [o, s] = Xe(!1);
  return /* @__PURE__ */ y.jsxs("div", { className: i.container, children: [
    e && /* @__PURE__ */ y.jsx(
      Lt,
      {
        variant: "h6",
        color: r === iT.INTERRUPTED ? "error" : "textPrimary",
        align: "center",
        children: e
      }
    ),
    /* @__PURE__ */ y.jsx(zt, { children: /* @__PURE__ */ y.jsxs(zt, { position: "relative", display: "inline-flex", children: [
      /* @__PURE__ */ y.jsx(un, { variant: "indeterminate", value: t, size: 52 }),
      /* @__PURE__ */ y.jsx(
        zt,
        {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          onMouseEnter: () => s(!0),
          onMouseLeave: () => s(!1),
          children: o ? /* @__PURE__ */ y.jsx(
            fr,
            {
              "aria-label": "delete",
              onClick: () => n(e || ""),
              children: /* @__PURE__ */ y.jsx(ql, {})
            }
          ) : /* @__PURE__ */ y.jsx(
            Lt,
            {
              variant: "caption",
              component: "div",
              color: "textSecondary",
              children: `${t}%`
            }
          )
        }
      )
    ] }) })
  ] });
}, v6 = Rt((e) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#131717"
  },
  title: {
    marginLeft: e.spacing(2),
    flex: 1
  },
  content: {
    backgroundColor: e.palette.common.black,
    color: e.palette.common.white,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative"
  },
  image: {
    maxWidth: "100%"
  },
  dimensions: {
    position: "absolute",
    top: 15,
    left: "50%",
    transform: "translateX(-50%)",
    padding: 12
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  bottomButtons: {
    position: "absolute",
    bottom: 15,
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center"
  },
  aspectRatio: {
    position: "absolute",
    top: 15,
    left: 15
  }
}));
/*!
 * Cropper.js v1.6.1
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:44:19.860Z
 */
function p_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oT(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p_(Object(r), !0).forEach(function(n) {
      b6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lv(e) {
  "@babel/helpers - typeof";
  return Lv = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lv(e);
}
function m6(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function h_(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sT(n.key), n);
  }
}
function y6(e, t, r) {
  return t && h_(e.prototype, t), r && h_(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function b6(e, t, r) {
  return t = sT(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function aT(e) {
  return w6(e) || x6(e) || _6(e) || S6();
}
function w6(e) {
  if (Array.isArray(e)) return zv(e);
}
function x6(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _6(e, t) {
  if (e) {
    if (typeof e == "string") return zv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return zv(e, t);
  }
}
function zv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function S6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function E6(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function sT(e) {
  var t = E6(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var wp = typeof window < "u" && typeof window.document < "u", ko = wp ? window : {}, Oy = wp && ko.document.documentElement ? "ontouchstart" in ko.document.documentElement : !1, Ry = wp ? "PointerEvent" in ko : !1, zr = "cropper", Iy = "all", lT = "crop", uT = "move", cT = "zoom", _s = "e", Ss = "w", xl = "s", Da = "n", zu = "ne", Bu = "nw", Fu = "se", Wu = "sw", Bv = "".concat(zr, "-crop"), g_ = "".concat(zr, "-disabled"), si = "".concat(zr, "-hidden"), v_ = "".concat(zr, "-hide"), C6 = "".concat(zr, "-invisible"), Ff = "".concat(zr, "-modal"), Fv = "".concat(zr, "-move"), Pc = "".concat(zr, "Action"), of = "".concat(zr, "Preview"), Dy = "crop", dT = "move", fT = "none", Wv = "crop", Hv = "cropend", $v = "cropmove", Uv = "cropstart", m_ = "dblclick", T6 = Oy ? "touchstart" : "mousedown", O6 = Oy ? "touchmove" : "mousemove", R6 = Oy ? "touchend touchcancel" : "mouseup", y_ = Ry ? "pointerdown" : T6, b_ = Ry ? "pointermove" : O6, w_ = Ry ? "pointerup pointercancel" : R6, x_ = "ready", __ = "resize", S_ = "wheel", Gv = "zoom", E_ = "image/jpeg", I6 = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, D6 = /^data:/, P6 = /^data:image\/jpeg;base64,/, M6 = /^img|canvas$/i, pT = 200, hT = 100, C_ = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Dy,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: pT,
  minContainerHeight: hT,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, A6 = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', N6 = Number.isNaN || ko.isNaN;
function or(e) {
  return typeof e == "number" && !N6(e);
}
var T_ = function(t) {
  return t > 0 && t < 1 / 0;
};
function hg(e) {
  return typeof e > "u";
}
function Fs(e) {
  return Lv(e) === "object" && e !== null;
}
var j6 = Object.prototype.hasOwnProperty;
function Dl(e) {
  if (!Fs(e))
    return !1;
  try {
    var t = e.constructor, r = t.prototype;
    return t && r && j6.call(r, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function ai(e) {
  return typeof e == "function";
}
var k6 = Array.prototype.slice;
function gT(e) {
  return Array.from ? Array.from(e) : k6.call(e);
}
function sn(e, t) {
  return e && ai(t) && (Array.isArray(e) || or(e.length) ? gT(e).forEach(function(r, n) {
    t.call(e, r, n, e);
  }) : Fs(e) && Object.keys(e).forEach(function(r) {
    t.call(e, e[r], r, e);
  })), e;
}
var Br = Object.assign || function(t) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
    n[i - 1] = arguments[i];
  return Fs(t) && n.length > 0 && n.forEach(function(o) {
    Fs(o) && Object.keys(o).forEach(function(s) {
      t[s] = o[s];
    });
  }), t;
}, L6 = /\.\d*(?:0|9){12}\d*$/;
function Nl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return L6.test(e) ? Math.round(e * t) / t : e;
}
var z6 = /^width|height|left|top|marginLeft|marginTop$/;
function ja(e, t) {
  var r = e.style;
  sn(t, function(n, i) {
    z6.test(i) && or(n) && (n = "".concat(n, "px")), r[i] = n;
  });
}
function B6(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function Sn(e, t) {
  if (t) {
    if (or(e.length)) {
      sn(e, function(n) {
        Sn(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var r = e.className.trim();
    r ? r.indexOf(t) < 0 && (e.className = "".concat(r, " ").concat(t)) : e.className = t;
  }
}
function Mo(e, t) {
  if (t) {
    if (or(e.length)) {
      sn(e, function(r) {
        Mo(r, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function Pl(e, t, r) {
  if (t) {
    if (or(e.length)) {
      sn(e, function(n) {
        Pl(n, t, r);
      });
      return;
    }
    r ? Sn(e, t) : Mo(e, t);
  }
}
var F6 = /([a-z\d])([A-Z])/g;
function Py(e) {
  return e.replace(F6, "$1-$2").toLowerCase();
}
function qv(e, t) {
  return Fs(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(Py(t)));
}
function Mc(e, t, r) {
  Fs(r) ? e[t] = r : e.dataset ? e.dataset[t] = r : e.setAttribute("data-".concat(Py(t)), r);
}
function W6(e, t) {
  if (Fs(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(Py(t)));
}
var vT = /\s\s*/, mT = function() {
  var e = !1;
  if (wp) {
    var t = !1, r = function() {
    }, n = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(o) {
        t = o;
      }
    });
    ko.addEventListener("test", r, n), ko.removeEventListener("test", r, n);
  }
  return e;
}();
function lo(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = r;
  t.trim().split(vT).forEach(function(o) {
    if (!mT) {
      var s = e.listeners;
      s && s[o] && s[o][r] && (i = s[o][r], delete s[o][r], Object.keys(s[o]).length === 0 && delete s[o], Object.keys(s).length === 0 && delete e.listeners);
    }
    e.removeEventListener(o, i, n);
  });
}
function Bi(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = r;
  t.trim().split(vT).forEach(function(o) {
    if (n.once && !mT) {
      var s = e.listeners, l = s === void 0 ? {} : s;
      i = function() {
        delete l[o][r], e.removeEventListener(o, i, n);
        for (var f = arguments.length, h = new Array(f), g = 0; g < f; g++)
          h[g] = arguments[g];
        r.apply(e, h);
      }, l[o] || (l[o] = {}), l[o][r] && e.removeEventListener(o, l[o][r], n), l[o][r] = i, e.listeners = l;
    }
    e.addEventListener(o, i, n);
  });
}
function jl(e, t, r) {
  var n;
  return ai(Event) && ai(CustomEvent) ? n = new CustomEvent(t, {
    detail: r,
    bubbles: !0,
    cancelable: !0
  }) : (n = document.createEvent("CustomEvent"), n.initCustomEvent(t, !0, !0, r)), e.dispatchEvent(n);
}
function yT(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var gg = ko.location, H6 = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function O_(e) {
  var t = e.match(H6);
  return t !== null && (t[1] !== gg.protocol || t[2] !== gg.hostname || t[3] !== gg.port);
}
function R_(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function pc(e) {
  var t = e.rotate, r = e.scaleX, n = e.scaleY, i = e.translateX, o = e.translateY, s = [];
  or(i) && i !== 0 && s.push("translateX(".concat(i, "px)")), or(o) && o !== 0 && s.push("translateY(".concat(o, "px)")), or(t) && t !== 0 && s.push("rotate(".concat(t, "deg)")), or(r) && r !== 1 && s.push("scaleX(".concat(r, ")")), or(n) && n !== 1 && s.push("scaleY(".concat(n, ")"));
  var l = s.length ? s.join(" ") : "none";
  return {
    WebkitTransform: l,
    msTransform: l,
    transform: l
  };
}
function $6(e) {
  var t = oT({}, e), r = 0;
  return sn(e, function(n, i) {
    delete t[i], sn(t, function(o) {
      var s = Math.abs(n.startX - o.startX), l = Math.abs(n.startY - o.startY), c = Math.abs(n.endX - o.endX), f = Math.abs(n.endY - o.endY), h = Math.sqrt(s * s + l * l), g = Math.sqrt(c * c + f * f), S = (g - h) / h;
      Math.abs(S) > Math.abs(r) && (r = S);
    });
  }), r;
}
function af(e, t) {
  var r = e.pageX, n = e.pageY, i = {
    endX: r,
    endY: n
  };
  return t ? i : oT({
    startX: r,
    startY: n
  }, i);
}
function U6(e) {
  var t = 0, r = 0, n = 0;
  return sn(e, function(i) {
    var o = i.startX, s = i.startY;
    t += o, r += s, n += 1;
  }), t /= n, r /= n, {
    pageX: t,
    pageY: r
  };
}
function ka(e) {
  var t = e.aspectRatio, r = e.height, n = e.width, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", o = T_(n), s = T_(r);
  if (o && s) {
    var l = r * t;
    i === "contain" && l > n || i === "cover" && l < n ? r = n / t : n = r * t;
  } else o ? r = n / t : s && (n = r * t);
  return {
    width: n,
    height: r
  };
}
function G6(e) {
  var t = e.width, r = e.height, n = e.degree;
  if (n = Math.abs(n) % 180, n === 90)
    return {
      width: r,
      height: t
    };
  var i = n % 90 * Math.PI / 180, o = Math.sin(i), s = Math.cos(i), l = t * s + r * o, c = t * o + r * s;
  return n > 90 ? {
    width: c,
    height: l
  } : {
    width: l,
    height: c
  };
}
function q6(e, t, r, n) {
  var i = t.aspectRatio, o = t.naturalWidth, s = t.naturalHeight, l = t.rotate, c = l === void 0 ? 0 : l, f = t.scaleX, h = f === void 0 ? 1 : f, g = t.scaleY, S = g === void 0 ? 1 : g, b = r.aspectRatio, p = r.naturalWidth, v = r.naturalHeight, w = n.fillColor, C = w === void 0 ? "transparent" : w, M = n.imageSmoothingEnabled, L = M === void 0 ? !0 : M, W = n.imageSmoothingQuality, z = W === void 0 ? "low" : W, B = n.maxWidth, K = B === void 0 ? 1 / 0 : B, Z = n.maxHeight, ee = Z === void 0 ? 1 / 0 : Z, he = n.minWidth, _e = he === void 0 ? 0 : he, Te = n.minHeight, fe = Te === void 0 ? 0 : Te, Oe = document.createElement("canvas"), ye = Oe.getContext("2d"), de = ka({
    aspectRatio: b,
    width: K,
    height: ee
  }), ce = ka({
    aspectRatio: b,
    width: _e,
    height: fe
  }, "cover"), Fe = Math.min(de.width, Math.max(ce.width, p)), le = Math.min(de.height, Math.max(ce.height, v)), J = ka({
    aspectRatio: i,
    width: K,
    height: ee
  }), re = ka({
    aspectRatio: i,
    width: _e,
    height: fe
  }, "cover"), be = Math.min(J.width, Math.max(re.width, o)), Me = Math.min(J.height, Math.max(re.height, s)), Ae = [-be / 2, -Me / 2, be, Me];
  return Oe.width = Nl(Fe), Oe.height = Nl(le), ye.fillStyle = C, ye.fillRect(0, 0, Fe, le), ye.save(), ye.translate(Fe / 2, le / 2), ye.rotate(c * Math.PI / 180), ye.scale(h, S), ye.imageSmoothingEnabled = L, ye.imageSmoothingQuality = z, ye.drawImage.apply(ye, [e].concat(aT(Ae.map(function(Re) {
    return Math.floor(Nl(Re));
  })))), ye.restore(), Oe;
}
var bT = String.fromCharCode;
function V6(e, t, r) {
  var n = "";
  r += t;
  for (var i = t; i < r; i += 1)
    n += bT(e.getUint8(i));
  return n;
}
var Y6 = /^data:.*,/;
function K6(e) {
  var t = e.replace(Y6, ""), r = atob(t), n = new ArrayBuffer(r.length), i = new Uint8Array(n);
  return sn(i, function(o, s) {
    i[s] = r.charCodeAt(s);
  }), n;
}
function X6(e, t) {
  for (var r = [], n = 8192, i = new Uint8Array(e); i.length > 0; )
    r.push(bT.apply(null, gT(i.subarray(0, n)))), i = i.subarray(n);
  return "data:".concat(t, ";base64,").concat(btoa(r.join("")));
}
function J6(e) {
  var t = new DataView(e), r;
  try {
    var n, i, o;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var s = t.byteLength, l = 2; l + 1 < s; ) {
        if (t.getUint8(l) === 255 && t.getUint8(l + 1) === 225) {
          i = l;
          break;
        }
        l += 1;
      }
    if (i) {
      var c = i + 4, f = i + 10;
      if (V6(t, c, 4) === "Exif") {
        var h = t.getUint16(f);
        if (n = h === 18761, (n || h === 19789) && t.getUint16(f + 2, n) === 42) {
          var g = t.getUint32(f + 4, n);
          g >= 8 && (o = f + g);
        }
      }
    }
    if (o) {
      var S = t.getUint16(o, n), b, p;
      for (p = 0; p < S; p += 1)
        if (b = o + p * 12 + 2, t.getUint16(b, n) === 274) {
          b += 8, r = t.getUint16(b, n), t.setUint16(b, 1, n);
          break;
        }
    }
  } catch {
    r = 1;
  }
  return r;
}
function Z6(e) {
  var t = 0, r = 1, n = 1;
  switch (e) {
    // Flip horizontal
    case 2:
      r = -1;
      break;
    // Rotate left 180°
    case 3:
      t = -180;
      break;
    // Flip vertical
    case 4:
      n = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      t = 90, n = -1;
      break;
    // Rotate right 90°
    case 6:
      t = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      t = 90, r = -1;
      break;
    // Rotate left 90°
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: r,
    scaleY: n
  };
}
var Q6 = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var t = this.element, r = this.options, n = this.container, i = this.cropper, o = Number(r.minContainerWidth), s = Number(r.minContainerHeight);
    Sn(i, si), Mo(t, si);
    var l = {
      width: Math.max(n.offsetWidth, o >= 0 ? o : pT),
      height: Math.max(n.offsetHeight, s >= 0 ? s : hT)
    };
    this.containerData = l, ja(i, {
      width: l.width,
      height: l.height
    }), Sn(t, si), Mo(i, si);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var t = this.containerData, r = this.imageData, n = this.options.viewMode, i = Math.abs(r.rotate) % 180 === 90, o = i ? r.naturalHeight : r.naturalWidth, s = i ? r.naturalWidth : r.naturalHeight, l = o / s, c = t.width, f = t.height;
    t.height * l > t.width ? n === 3 ? c = t.height * l : f = t.width / l : n === 3 ? f = t.width / l : c = t.height * l;
    var h = {
      aspectRatio: l,
      naturalWidth: o,
      naturalHeight: s,
      width: c,
      height: f
    };
    this.canvasData = h, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), h.width = Math.min(Math.max(h.width, h.minWidth), h.maxWidth), h.height = Math.min(Math.max(h.height, h.minHeight), h.maxHeight), h.left = (t.width - h.width) / 2, h.top = (t.height - h.height) / 2, h.oldLeft = h.left, h.oldTop = h.top, this.initialCanvasData = Br({}, h);
  },
  limitCanvas: function(t, r) {
    var n = this.options, i = this.containerData, o = this.canvasData, s = this.cropBoxData, l = n.viewMode, c = o.aspectRatio, f = this.cropped && s;
    if (t) {
      var h = Number(n.minCanvasWidth) || 0, g = Number(n.minCanvasHeight) || 0;
      l > 1 ? (h = Math.max(h, i.width), g = Math.max(g, i.height), l === 3 && (g * c > h ? h = g * c : g = h / c)) : l > 0 && (h ? h = Math.max(h, f ? s.width : 0) : g ? g = Math.max(g, f ? s.height : 0) : f && (h = s.width, g = s.height, g * c > h ? h = g * c : g = h / c));
      var S = ka({
        aspectRatio: c,
        width: h,
        height: g
      });
      h = S.width, g = S.height, o.minWidth = h, o.minHeight = g, o.maxWidth = 1 / 0, o.maxHeight = 1 / 0;
    }
    if (r)
      if (l > (f ? 0 : 1)) {
        var b = i.width - o.width, p = i.height - o.height;
        o.minLeft = Math.min(0, b), o.minTop = Math.min(0, p), o.maxLeft = Math.max(0, b), o.maxTop = Math.max(0, p), f && this.limited && (o.minLeft = Math.min(s.left, s.left + (s.width - o.width)), o.minTop = Math.min(s.top, s.top + (s.height - o.height)), o.maxLeft = s.left, o.maxTop = s.top, l === 2 && (o.width >= i.width && (o.minLeft = Math.min(0, b), o.maxLeft = Math.max(0, b)), o.height >= i.height && (o.minTop = Math.min(0, p), o.maxTop = Math.max(0, p))));
      } else
        o.minLeft = -o.width, o.minTop = -o.height, o.maxLeft = i.width, o.maxTop = i.height;
  },
  renderCanvas: function(t, r) {
    var n = this.canvasData, i = this.imageData;
    if (r) {
      var o = G6({
        width: i.naturalWidth * Math.abs(i.scaleX || 1),
        height: i.naturalHeight * Math.abs(i.scaleY || 1),
        degree: i.rotate || 0
      }), s = o.width, l = o.height, c = n.width * (s / n.naturalWidth), f = n.height * (l / n.naturalHeight);
      n.left -= (c - n.width) / 2, n.top -= (f - n.height) / 2, n.width = c, n.height = f, n.aspectRatio = s / l, n.naturalWidth = s, n.naturalHeight = l, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, ja(this.canvas, Br({
      width: n.width,
      height: n.height
    }, pc({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(t), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(t) {
    var r = this.canvasData, n = this.imageData, i = n.naturalWidth * (r.width / r.naturalWidth), o = n.naturalHeight * (r.height / r.naturalHeight);
    Br(n, {
      width: i,
      height: o,
      left: (r.width - i) / 2,
      top: (r.height - o) / 2
    }), ja(this.image, Br({
      width: n.width,
      height: n.height
    }, pc(Br({
      translateX: n.left,
      translateY: n.top
    }, n)))), t && this.output();
  },
  initCropBox: function() {
    var t = this.options, r = this.canvasData, n = t.aspectRatio || t.initialAspectRatio, i = Number(t.autoCropArea) || 0.8, o = {
      width: r.width,
      height: r.height
    };
    n && (r.height * n > r.width ? o.height = o.width / n : o.width = o.height * n), this.cropBoxData = o, this.limitCropBox(!0, !0), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), o.width = Math.max(o.minWidth, o.width * i), o.height = Math.max(o.minHeight, o.height * i), o.left = r.left + (r.width - o.width) / 2, o.top = r.top + (r.height - o.height) / 2, o.oldLeft = o.left, o.oldTop = o.top, this.initialCropBoxData = Br({}, o);
  },
  limitCropBox: function(t, r) {
    var n = this.options, i = this.containerData, o = this.canvasData, s = this.cropBoxData, l = this.limited, c = n.aspectRatio;
    if (t) {
      var f = Number(n.minCropBoxWidth) || 0, h = Number(n.minCropBoxHeight) || 0, g = l ? Math.min(i.width, o.width, o.width + o.left, i.width - o.left) : i.width, S = l ? Math.min(i.height, o.height, o.height + o.top, i.height - o.top) : i.height;
      f = Math.min(f, i.width), h = Math.min(h, i.height), c && (f && h ? h * c > f ? h = f / c : f = h * c : f ? h = f / c : h && (f = h * c), S * c > g ? S = g / c : g = S * c), s.minWidth = Math.min(f, g), s.minHeight = Math.min(h, S), s.maxWidth = g, s.maxHeight = S;
    }
    r && (l ? (s.minLeft = Math.max(0, o.left), s.minTop = Math.max(0, o.top), s.maxLeft = Math.min(i.width, o.left + o.width) - s.width, s.maxTop = Math.min(i.height, o.top + o.height) - s.height) : (s.minLeft = 0, s.minTop = 0, s.maxLeft = i.width - s.width, s.maxTop = i.height - s.height));
  },
  renderCropBox: function() {
    var t = this.options, r = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, t.movable && t.cropBoxMovable && Mc(this.face, Pc, n.width >= r.width && n.height >= r.height ? uT : Iy), ja(this.cropBox, Br({
      width: n.width,
      height: n.height
    }, pc({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), jl(this.element, Wv, this.getData());
  }
}, eq = {
  initPreview: function() {
    var t = this.element, r = this.crossOrigin, n = this.options.preview, i = r ? this.crossOriginUrl : this.url, o = t.alt || "The image to preview", s = document.createElement("img");
    if (r && (s.crossOrigin = r), s.src = i, s.alt = o, this.viewBox.appendChild(s), this.viewBoxImage = s, !!n) {
      var l = n;
      typeof n == "string" ? l = t.ownerDocument.querySelectorAll(n) : n.querySelector && (l = [n]), this.previews = l, sn(l, function(c) {
        var f = document.createElement("img");
        Mc(c, of, {
          width: c.offsetWidth,
          height: c.offsetHeight,
          html: c.innerHTML
        }), r && (f.crossOrigin = r), f.src = i, f.alt = o, f.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', c.innerHTML = "", c.appendChild(f);
      });
    }
  },
  resetPreview: function() {
    sn(this.previews, function(t) {
      var r = qv(t, of);
      ja(t, {
        width: r.width,
        height: r.height
      }), t.innerHTML = r.html, W6(t, of);
    });
  },
  preview: function() {
    var t = this.imageData, r = this.canvasData, n = this.cropBoxData, i = n.width, o = n.height, s = t.width, l = t.height, c = n.left - r.left - t.left, f = n.top - r.top - t.top;
    !this.cropped || this.disabled || (ja(this.viewBoxImage, Br({
      width: s,
      height: l
    }, pc(Br({
      translateX: -c,
      translateY: -f
    }, t)))), sn(this.previews, function(h) {
      var g = qv(h, of), S = g.width, b = g.height, p = S, v = b, w = 1;
      i && (w = S / i, v = o * w), o && v > b && (w = b / o, p = i * w, v = b), ja(h, {
        width: p,
        height: v
      }), ja(h.getElementsByTagName("img")[0], Br({
        width: s * w,
        height: l * w
      }, pc(Br({
        translateX: -c * w,
        translateY: -f * w
      }, t))));
    }));
  }
}, tq = {
  bind: function() {
    var t = this.element, r = this.options, n = this.cropper;
    ai(r.cropstart) && Bi(t, Uv, r.cropstart), ai(r.cropmove) && Bi(t, $v, r.cropmove), ai(r.cropend) && Bi(t, Hv, r.cropend), ai(r.crop) && Bi(t, Wv, r.crop), ai(r.zoom) && Bi(t, Gv, r.zoom), Bi(n, y_, this.onCropStart = this.cropStart.bind(this)), r.zoomable && r.zoomOnWheel && Bi(n, S_, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && Bi(n, m_, this.onDblclick = this.dblclick.bind(this)), Bi(t.ownerDocument, b_, this.onCropMove = this.cropMove.bind(this)), Bi(t.ownerDocument, w_, this.onCropEnd = this.cropEnd.bind(this)), r.responsive && Bi(window, __, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var t = this.element, r = this.options, n = this.cropper;
    ai(r.cropstart) && lo(t, Uv, r.cropstart), ai(r.cropmove) && lo(t, $v, r.cropmove), ai(r.cropend) && lo(t, Hv, r.cropend), ai(r.crop) && lo(t, Wv, r.crop), ai(r.zoom) && lo(t, Gv, r.zoom), lo(n, y_, this.onCropStart), r.zoomable && r.zoomOnWheel && lo(n, S_, this.onWheel, {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && lo(n, m_, this.onDblclick), lo(t.ownerDocument, b_, this.onCropMove), lo(t.ownerDocument, w_, this.onCropEnd), r.responsive && lo(window, __, this.onResize);
  }
}, rq = {
  resize: function() {
    if (!this.disabled) {
      var t = this.options, r = this.container, n = this.containerData, i = r.offsetWidth / n.width, o = r.offsetHeight / n.height, s = Math.abs(i - 1) > Math.abs(o - 1) ? i : o;
      if (s !== 1) {
        var l, c;
        t.restore && (l = this.getCanvasData(), c = this.getCropBoxData()), this.render(), t.restore && (this.setCanvasData(sn(l, function(f, h) {
          l[h] = f * s;
        })), this.setCropBoxData(sn(c, function(f, h) {
          c[h] = f * s;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === fT || this.setDragMode(B6(this.dragBox, Bv) ? dT : Dy);
  },
  wheel: function(t) {
    var r = this, n = Number(this.options.wheelZoomRatio) || 0.1, i = 1;
    this.disabled || (t.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      r.wheeling = !1;
    }, 50), t.deltaY ? i = t.deltaY > 0 ? 1 : -1 : t.wheelDelta ? i = -t.wheelDelta / 120 : t.detail && (i = t.detail > 0 ? 1 : -1), this.zoom(-i * n, t)));
  },
  cropStart: function(t) {
    var r = t.buttons, n = t.button;
    if (!(this.disabled || (t.type === "mousedown" || t.type === "pointerdown" && t.pointerType === "mouse") && // No primary button (Usually the left button)
    (or(r) && r !== 1 || or(n) && n !== 0 || t.ctrlKey))) {
      var i = this.options, o = this.pointers, s;
      t.changedTouches ? sn(t.changedTouches, function(l) {
        o[l.identifier] = af(l);
      }) : o[t.pointerId || 0] = af(t), Object.keys(o).length > 1 && i.zoomable && i.zoomOnTouch ? s = cT : s = qv(t.target, Pc), I6.test(s) && jl(this.element, Uv, {
        originalEvent: t,
        action: s
      }) !== !1 && (t.preventDefault(), this.action = s, this.cropping = !1, s === lT && (this.cropping = !0, Sn(this.dragBox, Ff)));
    }
  },
  cropMove: function(t) {
    var r = this.action;
    if (!(this.disabled || !r)) {
      var n = this.pointers;
      t.preventDefault(), jl(this.element, $v, {
        originalEvent: t,
        action: r
      }) !== !1 && (t.changedTouches ? sn(t.changedTouches, function(i) {
        Br(n[i.identifier] || {}, af(i, !0));
      }) : Br(n[t.pointerId || 0] || {}, af(t, !0)), this.change(t));
    }
  },
  cropEnd: function(t) {
    if (!this.disabled) {
      var r = this.action, n = this.pointers;
      t.changedTouches ? sn(t.changedTouches, function(i) {
        delete n[i.identifier];
      }) : delete n[t.pointerId || 0], r && (t.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, Pl(this.dragBox, Ff, this.cropped && this.options.modal)), jl(this.element, Hv, {
        originalEvent: t,
        action: r
      }));
    }
  }
}, nq = {
  change: function(t) {
    var r = this.options, n = this.canvasData, i = this.containerData, o = this.cropBoxData, s = this.pointers, l = this.action, c = r.aspectRatio, f = o.left, h = o.top, g = o.width, S = o.height, b = f + g, p = h + S, v = 0, w = 0, C = i.width, M = i.height, L = !0, W;
    !c && t.shiftKey && (c = g && S ? g / S : 1), this.limited && (v = o.minLeft, w = o.minTop, C = v + Math.min(i.width, n.width, n.left + n.width), M = w + Math.min(i.height, n.height, n.top + n.height));
    var z = s[Object.keys(s)[0]], B = {
      x: z.endX - z.startX,
      y: z.endY - z.startY
    }, K = function(ee) {
      switch (ee) {
        case _s:
          b + B.x > C && (B.x = C - b);
          break;
        case Ss:
          f + B.x < v && (B.x = v - f);
          break;
        case Da:
          h + B.y < w && (B.y = w - h);
          break;
        case xl:
          p + B.y > M && (B.y = M - p);
          break;
      }
    };
    switch (l) {
      // Move crop box
      case Iy:
        f += B.x, h += B.y;
        break;
      // Resize crop box
      case _s:
        if (B.x >= 0 && (b >= C || c && (h <= w || p >= M))) {
          L = !1;
          break;
        }
        K(_s), g += B.x, g < 0 && (l = Ss, g = -g, f -= g), c && (S = g / c, h += (o.height - S) / 2);
        break;
      case Da:
        if (B.y <= 0 && (h <= w || c && (f <= v || b >= C))) {
          L = !1;
          break;
        }
        K(Da), S -= B.y, h += B.y, S < 0 && (l = xl, S = -S, h -= S), c && (g = S * c, f += (o.width - g) / 2);
        break;
      case Ss:
        if (B.x <= 0 && (f <= v || c && (h <= w || p >= M))) {
          L = !1;
          break;
        }
        K(Ss), g -= B.x, f += B.x, g < 0 && (l = _s, g = -g, f -= g), c && (S = g / c, h += (o.height - S) / 2);
        break;
      case xl:
        if (B.y >= 0 && (p >= M || c && (f <= v || b >= C))) {
          L = !1;
          break;
        }
        K(xl), S += B.y, S < 0 && (l = Da, S = -S, h -= S), c && (g = S * c, f += (o.width - g) / 2);
        break;
      case zu:
        if (c) {
          if (B.y <= 0 && (h <= w || b >= C)) {
            L = !1;
            break;
          }
          K(Da), S -= B.y, h += B.y, g = S * c;
        } else
          K(Da), K(_s), B.x >= 0 ? b < C ? g += B.x : B.y <= 0 && h <= w && (L = !1) : g += B.x, B.y <= 0 ? h > w && (S -= B.y, h += B.y) : (S -= B.y, h += B.y);
        g < 0 && S < 0 ? (l = Wu, S = -S, g = -g, h -= S, f -= g) : g < 0 ? (l = Bu, g = -g, f -= g) : S < 0 && (l = Fu, S = -S, h -= S);
        break;
      case Bu:
        if (c) {
          if (B.y <= 0 && (h <= w || f <= v)) {
            L = !1;
            break;
          }
          K(Da), S -= B.y, h += B.y, g = S * c, f += o.width - g;
        } else
          K(Da), K(Ss), B.x <= 0 ? f > v ? (g -= B.x, f += B.x) : B.y <= 0 && h <= w && (L = !1) : (g -= B.x, f += B.x), B.y <= 0 ? h > w && (S -= B.y, h += B.y) : (S -= B.y, h += B.y);
        g < 0 && S < 0 ? (l = Fu, S = -S, g = -g, h -= S, f -= g) : g < 0 ? (l = zu, g = -g, f -= g) : S < 0 && (l = Wu, S = -S, h -= S);
        break;
      case Wu:
        if (c) {
          if (B.x <= 0 && (f <= v || p >= M)) {
            L = !1;
            break;
          }
          K(Ss), g -= B.x, f += B.x, S = g / c;
        } else
          K(xl), K(Ss), B.x <= 0 ? f > v ? (g -= B.x, f += B.x) : B.y >= 0 && p >= M && (L = !1) : (g -= B.x, f += B.x), B.y >= 0 ? p < M && (S += B.y) : S += B.y;
        g < 0 && S < 0 ? (l = zu, S = -S, g = -g, h -= S, f -= g) : g < 0 ? (l = Fu, g = -g, f -= g) : S < 0 && (l = Bu, S = -S, h -= S);
        break;
      case Fu:
        if (c) {
          if (B.x >= 0 && (b >= C || p >= M)) {
            L = !1;
            break;
          }
          K(_s), g += B.x, S = g / c;
        } else
          K(xl), K(_s), B.x >= 0 ? b < C ? g += B.x : B.y >= 0 && p >= M && (L = !1) : g += B.x, B.y >= 0 ? p < M && (S += B.y) : S += B.y;
        g < 0 && S < 0 ? (l = Bu, S = -S, g = -g, h -= S, f -= g) : g < 0 ? (l = Wu, g = -g, f -= g) : S < 0 && (l = zu, S = -S, h -= S);
        break;
      // Move canvas
      case uT:
        this.move(B.x, B.y), L = !1;
        break;
      // Zoom canvas
      case cT:
        this.zoom($6(s), t), L = !1;
        break;
      // Create crop box
      case lT:
        if (!B.x || !B.y) {
          L = !1;
          break;
        }
        W = yT(this.cropper), f = z.startX - W.left, h = z.startY - W.top, g = o.minWidth, S = o.minHeight, B.x > 0 ? l = B.y > 0 ? Fu : zu : B.x < 0 && (f -= g, l = B.y > 0 ? Wu : Bu), B.y < 0 && (h -= S), this.cropped || (Mo(this.cropBox, si), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    L && (o.width = g, o.height = S, o.left = f, o.top = h, this.action = l, this.renderCropBox()), sn(s, function(Z) {
      Z.startX = Z.endX, Z.startY = Z.endY;
    });
  }
}, iq = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && Sn(this.dragBox, Ff), Mo(this.cropBox, si), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = Br({}, this.initialImageData), this.canvasData = Br({}, this.initialCanvasData), this.cropBoxData = Br({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (Br(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Mo(this.dragBox, Ff), Sn(this.cropBox, si)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && t && (this.isImg && (this.element.src = t), r ? (this.url = t, this.image.src = t, this.ready && (this.viewBoxImage.src = t, sn(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = t;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(t))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Mo(this.cropper, g_)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, Sn(this.cropper, g_)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var t = this.element;
    return t[zr] ? (t[zr] = void 0, this.isImg && this.replaced && (t.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, n = this.canvasData, i = n.left, o = n.top;
    return this.moveTo(hg(t) ? t : i + Number(t), hg(r) ? r : o + Number(r));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, n = this.canvasData, i = !1;
    return t = Number(t), r = Number(r), this.ready && !this.disabled && this.options.movable && (or(t) && (n.left = t, i = !0), or(r) && (n.top = r, i = !0), i && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(t, r) {
    var n = this.canvasData;
    return t = Number(t), t < 0 ? t = 1 / (1 - t) : t = 1 + t, this.zoomTo(n.width * t / n.naturalWidth, null, r);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(t, r, n) {
    var i = this.options, o = this.canvasData, s = o.width, l = o.height, c = o.naturalWidth, f = o.naturalHeight;
    if (t = Number(t), t >= 0 && this.ready && !this.disabled && i.zoomable) {
      var h = c * t, g = f * t;
      if (jl(this.element, Gv, {
        ratio: t,
        oldRatio: s / c,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var S = this.pointers, b = yT(this.cropper), p = S && Object.keys(S).length ? U6(S) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        o.left -= (h - s) * ((p.pageX - b.left - o.left) / s), o.top -= (g - l) * ((p.pageY - b.top - o.top) / l);
      } else Dl(r) && or(r.x) && or(r.y) ? (o.left -= (h - s) * ((r.x - o.left) / s), o.top -= (g - l) * ((r.y - o.top) / l)) : (o.left -= (h - s) / 2, o.top -= (g - l) / 2);
      o.width = h, o.height = g, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(t) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(t));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(t) {
    return t = Number(t), or(t) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = t % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(t) {
    var r = this.imageData.scaleY;
    return this.scale(t, or(r) ? r : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(t) {
    var r = this.imageData.scaleX;
    return this.scale(or(r) ? r : 1, t);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, n = this.imageData, i = !1;
    return t = Number(t), r = Number(r), this.ready && !this.disabled && this.options.scalable && (or(t) && (n.scaleX = t, i = !0), or(r) && (n.scaleY = r, i = !0), i && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = this.options, n = this.imageData, i = this.canvasData, o = this.cropBoxData, s;
    if (this.ready && this.cropped) {
      s = {
        x: o.left - i.left,
        y: o.top - i.top,
        width: o.width,
        height: o.height
      };
      var l = n.width / n.naturalWidth;
      if (sn(s, function(h, g) {
        s[g] = h / l;
      }), t) {
        var c = Math.round(s.y + s.height), f = Math.round(s.x + s.width);
        s.x = Math.round(s.x), s.y = Math.round(s.y), s.width = f - s.x, s.height = c - s.y;
      }
    } else
      s = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return r.rotatable && (s.rotate = n.rotate || 0), r.scalable && (s.scaleX = n.scaleX || 1, s.scaleY = n.scaleY || 1), s;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(t) {
    var r = this.options, n = this.imageData, i = this.canvasData, o = {};
    if (this.ready && !this.disabled && Dl(t)) {
      var s = !1;
      r.rotatable && or(t.rotate) && t.rotate !== n.rotate && (n.rotate = t.rotate, s = !0), r.scalable && (or(t.scaleX) && t.scaleX !== n.scaleX && (n.scaleX = t.scaleX, s = !0), or(t.scaleY) && t.scaleY !== n.scaleY && (n.scaleY = t.scaleY, s = !0)), s && this.renderCanvas(!0, !0);
      var l = n.width / n.naturalWidth;
      or(t.x) && (o.left = t.x * l + i.left), or(t.y) && (o.top = t.y * l + i.top), or(t.width) && (o.width = t.width * l), or(t.height) && (o.height = t.height * l), this.setCropBoxData(o);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? Br({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? Br({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var t = this.canvasData, r = {};
    return this.ready && sn(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      r[n] = t[n];
    }), r;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(t) {
    var r = this.canvasData, n = r.aspectRatio;
    return this.ready && !this.disabled && Dl(t) && (or(t.left) && (r.left = t.left), or(t.top) && (r.top = t.top), or(t.width) ? (r.width = t.width, r.height = t.width / n) : or(t.height) && (r.height = t.height, r.width = t.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var t = this.cropBoxData, r;
    return this.ready && this.cropped && (r = {
      left: t.left,
      top: t.top,
      width: t.width,
      height: t.height
    }), r || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(t) {
    var r = this.cropBoxData, n = this.options.aspectRatio, i, o;
    return this.ready && this.cropped && !this.disabled && Dl(t) && (or(t.left) && (r.left = t.left), or(t.top) && (r.top = t.top), or(t.width) && t.width !== r.width && (i = !0, r.width = t.width), or(t.height) && t.height !== r.height && (o = !0, r.height = t.height), n && (i ? r.height = r.width / n : o && (r.width = r.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var r = this.canvasData, n = q6(this.image, this.imageData, r, t);
    if (!this.cropped)
      return n;
    var i = this.getData(t.rounded), o = i.x, s = i.y, l = i.width, c = i.height, f = n.width / Math.floor(r.naturalWidth);
    f !== 1 && (o *= f, s *= f, l *= f, c *= f);
    var h = l / c, g = ka({
      aspectRatio: h,
      width: t.maxWidth || 1 / 0,
      height: t.maxHeight || 1 / 0
    }), S = ka({
      aspectRatio: h,
      width: t.minWidth || 0,
      height: t.minHeight || 0
    }, "cover"), b = ka({
      aspectRatio: h,
      width: t.width || (f !== 1 ? n.width : l),
      height: t.height || (f !== 1 ? n.height : c)
    }), p = b.width, v = b.height;
    p = Math.min(g.width, Math.max(S.width, p)), v = Math.min(g.height, Math.max(S.height, v));
    var w = document.createElement("canvas"), C = w.getContext("2d");
    w.width = Nl(p), w.height = Nl(v), C.fillStyle = t.fillColor || "transparent", C.fillRect(0, 0, p, v);
    var M = t.imageSmoothingEnabled, L = M === void 0 ? !0 : M, W = t.imageSmoothingQuality;
    C.imageSmoothingEnabled = L, W && (C.imageSmoothingQuality = W);
    var z = n.width, B = n.height, K = o, Z = s, ee, he, _e, Te, fe, Oe;
    K <= -l || K > z ? (K = 0, ee = 0, _e = 0, fe = 0) : K <= 0 ? (_e = -K, K = 0, ee = Math.min(z, l + K), fe = ee) : K <= z && (_e = 0, ee = Math.min(l, z - K), fe = ee), ee <= 0 || Z <= -c || Z > B ? (Z = 0, he = 0, Te = 0, Oe = 0) : Z <= 0 ? (Te = -Z, Z = 0, he = Math.min(B, c + Z), Oe = he) : Z <= B && (Te = 0, he = Math.min(c, B - Z), Oe = he);
    var ye = [K, Z, ee, he];
    if (fe > 0 && Oe > 0) {
      var de = p / l;
      ye.push(_e * de, Te * de, fe * de, Oe * de);
    }
    return C.drawImage.apply(C, [n].concat(aT(ye.map(function(ce) {
      return Math.floor(Nl(ce));
    })))), w;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(t) {
    var r = this.options;
    return !this.disabled && !hg(t) && (r.aspectRatio = Math.max(0, t) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(t) {
    var r = this.options, n = this.dragBox, i = this.face;
    if (this.ready && !this.disabled) {
      var o = t === Dy, s = r.movable && t === dT;
      t = o || s ? t : fT, r.dragMode = t, Mc(n, Pc, t), Pl(n, Bv, o), Pl(n, Fv, s), r.cropBoxMovable || (Mc(i, Pc, t), Pl(i, Bv, o), Pl(i, Fv, s));
    }
    return this;
  }
}, oq = ko.Cropper, wT = /* @__PURE__ */ function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (m6(this, e), !t || !M6.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = Br({}, C_, Dl(r) && r), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return y6(e, [{
    key: "init",
    value: function() {
      var r = this.element, n = r.tagName.toLowerCase(), i;
      if (!r[zr]) {
        if (r[zr] = this, n === "img") {
          if (this.isImg = !0, i = r.getAttribute("src") || "", this.originalUrl = i, !i)
            return;
          i = r.src;
        } else n === "canvas" && window.HTMLCanvasElement && (i = r.toDataURL());
        this.load(i);
      }
    }
  }, {
    key: "load",
    value: function(r) {
      var n = this;
      if (r) {
        this.url = r, this.imageData = {};
        var i = this.element, o = this.options;
        if (!o.rotatable && !o.scalable && (o.checkOrientation = !1), !o.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (D6.test(r)) {
          P6.test(r) ? this.read(K6(r)) : this.clone();
          return;
        }
        var s = new XMLHttpRequest(), l = this.clone.bind(this);
        this.reloading = !0, this.xhr = s, s.onabort = l, s.onerror = l, s.ontimeout = l, s.onprogress = function() {
          s.getResponseHeader("content-type") !== E_ && s.abort();
        }, s.onload = function() {
          n.read(s.response);
        }, s.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, o.checkCrossOrigin && O_(r) && i.crossOrigin && (r = R_(r)), s.open("GET", r, !0), s.responseType = "arraybuffer", s.withCredentials = i.crossOrigin === "use-credentials", s.send();
      }
    }
  }, {
    key: "read",
    value: function(r) {
      var n = this.options, i = this.imageData, o = J6(r), s = 0, l = 1, c = 1;
      if (o > 1) {
        this.url = X6(r, E_);
        var f = Z6(o);
        s = f.rotate, l = f.scaleX, c = f.scaleY;
      }
      n.rotatable && (i.rotate = s), n.scalable && (i.scaleX = l, i.scaleY = c), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var r = this.element, n = this.url, i = r.crossOrigin, o = n;
      this.options.checkCrossOrigin && O_(n) && (i || (i = "anonymous"), o = R_(n)), this.crossOrigin = i, this.crossOriginUrl = o;
      var s = document.createElement("img");
      i && (s.crossOrigin = i), s.src = o || n, s.alt = r.alt || "The image to crop", this.image = s, s.onload = this.start.bind(this), s.onerror = this.stop.bind(this), Sn(s, v_), r.parentNode.insertBefore(s, r.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var r = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var i = ko.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(ko.navigator.userAgent), o = function(f, h) {
        Br(r.imageData, {
          naturalWidth: f,
          naturalHeight: h,
          aspectRatio: f / h
        }), r.initialImageData = Br({}, r.imageData), r.sizing = !1, r.sized = !0, r.build();
      };
      if (n.naturalWidth && !i) {
        o(n.naturalWidth, n.naturalHeight);
        return;
      }
      var s = document.createElement("img"), l = document.body || document.documentElement;
      this.sizingImage = s, s.onload = function() {
        o(s.width, s.height), i || l.removeChild(s);
      }, s.src = n.src, i || (s.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", l.appendChild(s));
    }
  }, {
    key: "stop",
    value: function() {
      var r = this.image;
      r.onload = null, r.onerror = null, r.parentNode.removeChild(r), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var r = this.element, n = this.options, i = this.image, o = r.parentNode, s = document.createElement("div");
        s.innerHTML = A6;
        var l = s.querySelector(".".concat(zr, "-container")), c = l.querySelector(".".concat(zr, "-canvas")), f = l.querySelector(".".concat(zr, "-drag-box")), h = l.querySelector(".".concat(zr, "-crop-box")), g = h.querySelector(".".concat(zr, "-face"));
        this.container = o, this.cropper = l, this.canvas = c, this.dragBox = f, this.cropBox = h, this.viewBox = l.querySelector(".".concat(zr, "-view-box")), this.face = g, c.appendChild(i), Sn(r, si), o.insertBefore(l, r.nextSibling), Mo(i, v_), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, Sn(h, si), n.guides || Sn(h.getElementsByClassName("".concat(zr, "-dashed")), si), n.center || Sn(h.getElementsByClassName("".concat(zr, "-center")), si), n.background && Sn(l, "".concat(zr, "-bg")), n.highlight || Sn(g, C6), n.cropBoxMovable && (Sn(g, Fv), Mc(g, Pc, Iy)), n.cropBoxResizable || (Sn(h.getElementsByClassName("".concat(zr, "-line")), si), Sn(h.getElementsByClassName("".concat(zr, "-point")), si)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), ai(n.ready) && Bi(r, x_, n.ready, {
          once: !0
        }), jl(r, x_);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var r = this.cropper.parentNode;
        r && r.removeChild(this.cropper), Mo(this.element, si);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = oq, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(r) {
      Br(C_, Dl(r) && r);
    }
  }]), e;
}();
Br(wT.prototype, Q6, eq, tq, rq, nq, iq);
const aq = (e, t, r, n, i) => new wT(e, {
  aspectRatio: i,
  viewMode: 1,
  autoCropArea: 1,
  movable: !1,
  scalable: !1,
  zoomable: !1,
  rotatable: !1,
  ready() {
    t(!1);
  },
  crop(o) {
    r({
      x: Math.round(o.detail.x),
      y: Math.round(o.detail.y),
      width: Math.round(o.detail.width),
      height: Math.round(o.detail.height)
    });
  },
  data: n ? { rotate: 0, scaleX: 1, scaleY: 1, ...n } : void 0
}), sq = [
  { ratio: 0, label: "Libre" },
  { ratio: 1, label: "1:1" },
  { ratio: 16 / 9, label: "16:9" },
  { ratio: 4 / 3, label: "4:3" },
  { ratio: 3 / 2, label: "3:2" }
], xT = ({
  closeDialog: e,
  imageSrc: t,
  initialCrop: r,
  initialFocusPoint: n,
  onValidate: i,
  config: o,
  disableCrop: s
}) => {
  const l = v6({}), c = bt(null), [f, h] = Xe(!0), [g, S] = Xe(null), [b, p] = Xe(
    null
  ), [v, w] = Xe(null), C = o.ratioItems || sq, M = C.length === 1, [L, W] = Xe(
    M ? C[0].ratio : 0
  ), [z, B] = Xe(!1), K = () => {
    B(!1);
  };
  pt(() => (document.addEventListener("mouseup", K), document.addEventListener("mouseleave", K), () => {
    document.removeEventListener("mouseup", K), document.removeEventListener("mouseleave", K);
  }), []);
  const Z = v == null ? void 0 : v.getImageData(), ee = Z ? Z.width / Z.naturalWidth : 1, he = Z ? Z.height / Z.naturalHeight : 1, _e = v == null ? void 0 : v.getCanvasData();
  return pt(() => {
    if (!n || b) return;
    const { x: Te, y: fe } = n;
    !Te || !fe || p({ x: Te, y: fe });
  }, [b, n]), pt(() => {
    !g || f || p(
      (Te) => Te ? {
        x: Math.min(Math.max(Te.x, g.x), g.x + g.width),
        y: Math.min(Math.max(Te.y, g.y), g.y + g.height)
      } : {
        x: g.x + g.width / 2,
        y: g.y + g.height / 2
      }
    );
  }, [g, f]), pt(() => {
    f || !v || (s ? v == null || v.disable() : v == null || v.enable());
  }, [v, s, f]), /* @__PURE__ */ y.jsxs(vE, { theme: mE({ palette: { mode: "dark" } }), children: [
    /* @__PURE__ */ y.jsx(Ka, { position: "static", className: l.appBar, children: /* @__PURE__ */ y.jsxs(ca, { children: [
      /* @__PURE__ */ y.jsx(
        fr,
        {
          style: { color: "white" },
          edge: "start",
          onClick: e,
          "aria-label": "Back",
          children: /* @__PURE__ */ y.jsx(bm, {})
        }
      ),
      /* @__PURE__ */ y.jsx(Lt, { variant: "h6", className: l.title, children: s ? "Point de focus" : "Redimensionnement et point de focus" }),
      v && /* @__PURE__ */ y.jsx(
        Fr,
        {
          disabled: f,
          onClick: () => {
            !s && v.reset(), p(
              s && g ? {
                x: g.x + g.width / 2,
                y: g.y + g.height / 2
              } : null
            );
          },
          children: "Réinitialiser"
        }
      ),
      /* @__PURE__ */ y.jsx(
        Fr,
        {
          disabled: f,
          onClick: () => {
            g && b && (i && i({
              crop: g,
              focusPoint: {
                x: Math.round(b.x),
                y: Math.round(b.y),
                relativeX: Z ? b.x / Z.naturalWidth : 0,
                relativeY: Z ? b.y / Z.naturalHeight : 0
              }
            }), e && e());
          },
          children: "Ok"
        }
      )
    ] }) }),
    /* @__PURE__ */ y.jsxs("div", { className: l.content, children: [
      f && /* @__PURE__ */ y.jsx("div", { className: l.loader, children: /* @__PURE__ */ y.jsx(un, { color: "secondary", size: 80 }) }),
      g && !s && /* @__PURE__ */ y.jsx(Lt, { variant: "body1", className: l.dimensions, children: `${g.width} x ${g.height}` }),
      /* @__PURE__ */ y.jsxs(
        zt,
        {
          sx: {
            maxWidth: "80%",
            maxHeight: "80%",
            opacity: f ? 0 : void 0,
            position: "relative"
          },
          onMouseMove: (Te) => {
            if (z && g && v && _e) {
              const fe = Te.clientX - Te.currentTarget.offsetLeft - _e.left, Oe = Te.clientY - Te.currentTarget.offsetTop - 70 - _e.top;
              p({
                x: Math.min(
                  Math.max(fe / ee, g.x),
                  g.x + g.width
                ),
                y: Math.min(
                  Math.max(Oe / he, g.y),
                  g.y + g.height
                )
              });
            }
          },
          children: [
            /* @__PURE__ */ y.jsx(
              "img",
              {
                className: l.image,
                ref: c,
                src: t,
                alt: "Cropping",
                onLoad: () => {
                  c.current && w(
                    aq(
                      c.current,
                      h,
                      S,
                      r,
                      L
                    )
                  );
                }
              }
            ),
            b && _e && /* @__PURE__ */ y.jsx(
              wm,
              {
                sx: {
                  color: "white",
                  position: "absolute",
                  top: b.y * he - 20 + _e.top,
                  left: b.x * ee - 20 + _e.left,
                  cursor: "grab",
                  fontSize: 40,
                  stroke: "#000",
                  strokeWidth: "1px",
                  strokeLinejoin: "round"
                },
                onMouseDown: () => B(!0)
              }
            )
          ]
        }
      ),
      v && !s && /* @__PURE__ */ y.jsxs(
        ra,
        {
          variant: "outlined",
          color: "primary",
          className: l.aspectRatio,
          disabled: M,
          children: [
            /* @__PURE__ */ y.jsx(hm, { children: "Ratio" }),
            /* @__PURE__ */ y.jsx(
              gm,
              {
                value: L,
                onChange: ({ target: { value: Te } }) => {
                  W(Te), v.setAspectRatio(Te);
                },
                label: "Ratio",
                disabled: M,
                children: C.map((Te, fe) => /* @__PURE__ */ y.jsx(la, { value: Te.ratio, children: Te.label }, `ratio-${fe}`))
              }
            )
          ]
        }
      )
    ] })
  ] });
}, Lo = ({
  children: e,
  label: t,
  sx: r,
  ...n
}) => /* @__PURE__ */ y.jsxs(
  fr,
  {
    sx: {
      padding: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: 48,
      height: 48,
      ...r
    },
    ...n,
    children: [
      e,
      t && /* @__PURE__ */ y.jsx(
        Lt,
        {
          sx: { lineHeight: "12px", fontSize: 10, whiteSpace: "nowrap" },
          children: t
        }
      )
    ]
  }
), lq = 24, uq = Rt({
  button: {
    position: "relative"
  },
  invisible: {
    opacity: 0
  },
  loader: ({ size: e }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: e,
    width: e
  })
}), _T = ({
  loading: e,
  children: t,
  disabled: r,
  loaderSize: n,
  loaderColor: i,
  color: o,
  className: s,
  ...l
}) => {
  var h, g;
  const c = n || lq, f = uq({ size: c });
  return /* @__PURE__ */ y.jsxs(
    Fr,
    {
      color: o,
      disabled: r || e,
      className: nt(f.button, s),
      classes: {
        ...l.classes,
        ...e ? {
          startIcon: nt((h = l.classes) == null ? void 0 : h.startIcon, f.invisible),
          endIcon: nt((g = l.classes) == null ? void 0 : g.endIcon, f.invisible)
        } : {}
      },
      ...l,
      children: [
        /* @__PURE__ */ y.jsx("div", { className: e ? f.invisible : "", children: t }),
        e && /* @__PURE__ */ y.jsx("div", { className: f.loader, children: /* @__PURE__ */ y.jsx(
          un,
          {
            size: c,
            color: o,
            style: { color: i }
          }
        ) })
      ]
    }
  );
}, cq = Rt((e) => ({
  appBar: {
    overflowX: "hidden"
  },
  titleWrapper: {
    marginLeft: e.spacing(2),
    marginRight: "auto",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden",
    [e.breakpoints.down("sm")]: {
      marginLeft: e.spacing(1)
    }
  },
  title: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  subtitle: {
    opacity: 0.8
  },
  divider: {
    margin: e.spacing(0, 2),
    borderColor: an(e.palette.common.white, 0.2)
  },
  dividerBeforeActions: {
    marginRight: e.spacing(1)
  },
  actionsWrapper: {
    display: "flex",
    alignSelf: "stretch",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: e.spacing(1),
    [e.breakpoints.down("sm")]: {
      marginLeft: 0
    }
  },
  actionIcon: {
    marginLeft: e.spacing(1)
  },
  icon: {
    color: e.palette.common.white
  },
  iconDisabled: {
    color: `${an(e.palette.common.white, 0.3)} !important`
  },
  button: {
    backgroundColor: e.palette.common.white,
    color: e.palette.primary.main,
    "&:hover": {
      backgroundColor: WA(e.palette.common.white, 0.1)
    }
  },
  buttonDisabled: {
    backgroundColor: `${an(e.palette.common.white, 0.12)} !important`,
    color: `${an(e.palette.common.white, 0.3)} !important`
  },
  saveButton: {
    marginLeft: e.spacing(1),
    flexShrink: 0
  },
  statusButton: {
    marginLeft: e.spacing(1),
    flexShrink: 0
  },
  statusButtonMargin: {
    marginLeft: e.spacing(3),
    [e.breakpoints.down("sm")]: {
      marginLeft: e.spacing(1)
    }
  },
  badge: {
    backgroundColor: e.palette.common.white,
    color: e.palette.primary.main,
    borderColor: e.palette.primary.main,
    borderWidth: 1,
    borderStyle: "solid"
  },
  actionMenuItem: {
    overflow: "visible"
  },
  toolbar: {
    position: "fixed",
    top: 64,
    [e.breakpoints.down("sm")]: {
      top: 56
    },
    width: "100%",
    zIndex: 2
  },
  searchBar: {
    flex: 2,
    marginLeft: e.spacing(2),
    maxWidth: 800,
    width: "100%"
  }
})), dq = (e, t, r) => e ? r ? 1 : 2 : t ? r ? 2 : 3 : 5, ZJ = ({
  actions: e,
  additionalElement: t,
  className: r,
  concurrentialAccess: n,
  navigationBackDisabled: i,
  onNavigateBack: o,
  save: s,
  searchBar: l,
  subTitle: c,
  title: f,
  toolbar: h
}) => {
  var K, Z;
  const g = cq(), S = zo(), b = sa(S.breakpoints.down("sm")), p = sa(S.breakpoints.down("md")), { openMenu: v, closeMenu: w } = Xl(), C = dq(
    b,
    p,
    !!((K = n == null ? void 0 : n.lockStatus) != null && K.lockedBy)
  ), M = C - (((e == null ? void 0 : e.length) || 0) <= C ? 0 : 1), L = e == null ? void 0 : e.slice(0, M), W = e == null ? void 0 : e.slice(M), z = () => W != null && W.length ? /* @__PURE__ */ y.jsx(Nr, { title: "Afficher plus", children: /* @__PURE__ */ y.jsx(
    fr,
    {
      classes: {
        root: nt(g.icon, g.actionIcon)
      },
      onClick: (ee) => v(
        ee.currentTarget,
        W.map(
          ({ id: he, label: _e, icon: Te, onClick: fe, disabled: Oe, badge: ye }) => /* @__PURE__ */ y.jsxs(
            la,
            {
              onClick: (de) => {
                fe == null || fe(de), w();
              },
              disabled: Oe,
              className: g.actionMenuItem,
              "data-testid": `${he}-item`,
              children: [
                /* @__PURE__ */ y.jsx(Va, { children: /* @__PURE__ */ y.jsx(av, { badgeContent: ye, color: "primary", children: Te }) }),
                _e
              ]
            },
            `action-in-menu-${he}`
          )
        )
      ),
      children: /* @__PURE__ */ y.jsx(xN, {})
    }
  ) }) : null, B = () => {
    const ee = (s == null ? void 0 : s.disabled) || !!(s != null && s.requiredFields);
    return b ? /* @__PURE__ */ y.jsx(
      Lo,
      {
        label: "Sauvegarder",
        onClick: s == null ? void 0 : s.onClick,
        disabled: ee || (s == null ? void 0 : s.loading),
        classes: {
          root: nt(g.icon, g.actionIcon),
          disabled: g.iconDisabled
        },
        children: /* @__PURE__ */ y.jsx(wN, {})
      }
    ) : /* @__PURE__ */ y.jsx(
      _T,
      {
        "data-testid": "save-button",
        loaderColor: S.palette.common.white,
        variant: "contained",
        className: g.saveButton,
        classes: { root: g.button, disabled: g.buttonDisabled },
        disabled: ee,
        onClick: s == null ? void 0 : s.onClick,
        loading: s == null ? void 0 : s.loading,
        children: (s == null ? void 0 : s.actionLabel) || "Sauvegarder"
      }
    );
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Ka, { position: "fixed", className: nt(g.appBar, r), children: /* @__PURE__ */ y.jsxs(ca, { children: [
      o && /* @__PURE__ */ y.jsx(
        fr,
        {
          classes: { root: g.icon, disabled: g.iconDisabled },
          disabled: i,
          onClick: o,
          children: /* @__PURE__ */ y.jsx(bm, {})
        }
      ),
      /* @__PURE__ */ y.jsxs("div", { className: g.titleWrapper, children: [
        typeof f == "string" ? /* @__PURE__ */ y.jsx(Lt, { variant: "h6", className: g.title, children: f }) : f,
        /* @__PURE__ */ y.jsx(
          Lt,
          {
            variant: "subtitle2",
            className: nt(g.title, g.subtitle),
            children: c
          }
        )
      ] }),
      l && /* @__PURE__ */ y.jsx("div", { className: g.searchBar, children: l }),
      (n || !!(e != null && e.length)) && /* @__PURE__ */ y.jsxs("div", { className: g.actionsWrapper, children: [
        ((Z = n == null ? void 0 : n.lockStatus) == null ? void 0 : Z.lockedBy) && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          /* @__PURE__ */ y.jsx(
            IC,
            {
              lockedBy: n.lockStatus.lockedBy,
              disableLockForV0: n.disableLockForV0
            }
          ),
          !b && !!(e != null && e.length) && /* @__PURE__ */ y.jsx(
            hc,
            {
              orientation: "vertical",
              variant: "middle",
              flexItem: !0,
              className: nt(
                g.divider,
                g.dividerBeforeActions
              )
            }
          )
        ] }),
        L == null ? void 0 : L.map(
          ({ id: ee, label: he, icon: _e, onClick: Te, disabled: fe, badge: Oe }) => /* @__PURE__ */ y.jsx(
            Lo,
            {
              "data-testid": `${ee}-button`,
              label: he,
              classes: {
                root: nt(g.icon, g.actionIcon),
                disabled: g.iconDisabled
              },
              onClick: Te,
              disabled: fe,
              children: /* @__PURE__ */ y.jsx(
                av,
                {
                  badgeContent: Oe,
                  classes: { badge: g.badge },
                  children: _e
                }
              )
            },
            `action-${ee}`
          )
        ),
        !b && z()
      ] }),
      !b && (s || t) && /* @__PURE__ */ y.jsx(
        hc,
        {
          orientation: "vertical",
          variant: "fullWidth",
          flexItem: !0,
          className: g.divider
        }
      ),
      s && (s.requiredFields ? /* @__PURE__ */ y.jsx(Nr, { title: s.requiredFields, children: /* @__PURE__ */ y.jsx("div", { children: B() }) }) : B()),
      b && z(),
      t && /* @__PURE__ */ y.jsx(
        "div",
        {
          className: nt(
            g.statusButton,
            s && g.statusButtonMargin
          ),
          children: t
        }
      )
    ] }) }),
    h && /* @__PURE__ */ y.jsx("div", { className: g.toolbar, children: h })
  ] });
}, fq = fp(() => ({
  skeleton: {
    opacity: 0.5,
    transform: "scale(1)"
  }
})), I_ = ({
  height: e = 15,
  quantity: t = 1,
  spacing: r = 1,
  style: n = {},
  width: i = "100%",
  ...o
}) => {
  const s = fq();
  return /* @__PURE__ */ y.jsx(HA, { "data-testid": "skeletons-wrapper", spacing: r, ...o, children: Array.from(new Array(t)).map((l, c) => /* @__PURE__ */ y.jsx(
    $A,
    {
      className: s.skeleton,
      height: e,
      style: n,
      width: i
    },
    c
  )) });
}, pq = "Page sans titre", hq = fp((e) => ({
  brandKeyChip: {
    marginLeft: e.spacing(1),
    color: e.palette.common.white,
    position: "relative",
    top: ({ isLoading: t }) => t ? e.spacing(-0.1) : 0
  },
  subTitle: {
    display: "block",
    opacity: 0.75,
    overflow: "hidden",
    position: "relative",
    textOverflow: "ellipsis",
    top: e.spacing(-0.25),
    whiteSpace: "nowrap"
  },
  title: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  wrapper: {
    position: "relative",
    "& > div > div:last-child": {
      marginBottom: ({ isLoading: t }) => t ? e.spacing(0.7) : 0
    }
  }
})), QJ = ({
  title: e,
  brandKey: t,
  subTitle: r,
  loading: n = !1,
  defaultTitle: i = pq
}) => {
  const o = hq({
    isLoading: n
  });
  return /* @__PURE__ */ y.jsx("span", { className: o.wrapper, children: /* @__PURE__ */ y.jsxs(Dn, { container: !0, spacing: 0.5, alignItems: "center", children: [
    /* @__PURE__ */ y.jsx(Dn, { item: !0, style: { maxWidth: "70%" }, children: n ? /* @__PURE__ */ y.jsx(I_, { width: 200, height: 14 }) : /* @__PURE__ */ y.jsx(zt, { className: o.title, component: "span", children: e || /* @__PURE__ */ y.jsx("em", { children: i }) }) }),
    /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 3, children: /* @__PURE__ */ y.jsx(
      Qa,
      {
        className: o.brandKeyChip,
        label: t,
        variant: "filled",
        size: "small"
      }
    ) }),
    /* @__PURE__ */ y.jsx(Dn, { container: !0, item: !0, children: n ? /* @__PURE__ */ y.jsx(I_, { width: 350, height: 12 }) : r && /* @__PURE__ */ y.jsx(Lt, { className: o.subTitle, variant: "caption", children: r }) })
  ] }) });
}, ST = Rt((e) => ({
  rightSide: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center"
  },
  searchBar: ({ bigDisplay: t, smallDisplay: r }) => ({
    marginRight: e.spacing(t ? 6 : r ? 1 : 2),
    marginLeft: r ? 0 : e.spacing(t ? 6 : 2),
    width: "100%",
    flexGrow: 1,
    maxWidth: 800
  }),
  divider: {
    borderColor: an(e.palette.common.white, 0.2),
    margin: e.spacing(0, 2)
  },
  additionnals: ({ bigDisplay: t }) => ({
    marginRight: e.spacing(t ? 2 : 0)
  }),
  tabsAppBar: ({ smallDisplay: t }) => ({
    top: t ? 56 : 64
  }),
  tab: {
    flexGrow: 1
  }
})), gq = () => {
  const e = ST({});
  return /* @__PURE__ */ y.jsx(
    hc,
    {
      classes: { root: e.divider },
      flexItem: !0,
      orientation: "vertical",
      variant: "fullWidth"
    }
  );
}, vq = ({
  appDrawerMenu: e,
  brandMenu: t,
  searchBar: r,
  additionalElement: n,
  currentUser: i,
  disconnectUser: o,
  tabs: s,
  onTabSelect: l,
  color: c,
  className: f,
  sx: h
}) => {
  const g = zo(), S = sa(g.breakpoints.up("md")), b = sa(g.breakpoints.down("sm")), p = ST({ bigDisplay: S, smallDisplay: b }), { openMenu: v, closeMenu: w } = Xl();
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Ka, { position: "fixed", color: c, className: f, sx: h, children: /* @__PURE__ */ y.jsxs(ca, { disableGutters: b, children: [
      e,
      e && S && /* @__PURE__ */ y.jsx(gq, {}),
      !b && t,
      r && /* @__PURE__ */ y.jsx("div", { className: p.searchBar, children: r }),
      /* @__PURE__ */ y.jsxs("div", { className: p.rightSide, children: [
        n && !b && /* @__PURE__ */ y.jsx("div", { className: p.additionnals, children: n }),
        o && S && /* @__PURE__ */ y.jsx(Nr, { title: (i == null ? void 0 : i.name) || "", children: /* @__PURE__ */ y.jsx(
          fr,
          {
            onClick: (C) => v(
              C.currentTarget,
              /* @__PURE__ */ y.jsx(
                la,
                {
                  onClick: () => {
                    o(), w();
                  },
                  children: "Déconnexion"
                }
              )
            ),
            children: /* @__PURE__ */ y.jsx(kc, { src: (i == null ? void 0 : i.avatarUrl) || void 0 })
          }
        ) })
      ] })
    ] }) }),
    s && /* @__PURE__ */ y.jsx(Ka, { position: "fixed", color: "default", className: p.tabsAppBar, children: /* @__PURE__ */ y.jsx(
      UA,
      {
        value: s == null ? void 0 : s.findIndex(({ selected: C }) => C),
        onChange: (C, M) => l && l(s[M]),
        textColor: "primary",
        indicatorColor: "primary",
        centered: S,
        variant: S ? void 0 : "scrollable",
        children: s.map((C) => /* @__PURE__ */ y.jsx(
          GA,
          {
            label: C.label,
            className: p.tab,
            disabled: C.disabled
          },
          C.id
        ))
      }
    ) })
  ] });
}, mq = {
  root: {
    "margin-top": "80px",
    display: "flex",
    "flex-direction": "column",
    "align-items": "center",
    margin: "auto",
    width: "80%"
  },
  stack: {
    "& pre": {
      whiteSpace: "pre-wrap"
    }
  }
};
class yq extends PA {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, r) {
    this.props.onCatchError && this.props.onCatchError(t, r);
  }
  render() {
    var n;
    const { classes: t, onBackBtnClick: r } = this.props;
    if (this.state.hasError) {
      const i = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(
          fr,
          {
            onClick: () => {
              r ? r() : window.location.reload();
            },
            children: /* @__PURE__ */ y.jsx(bm, { style: { color: "white" } })
          }
        ),
        /* @__PURE__ */ y.jsx("p", { children: "Revenir à la page précédente" })
      ] });
      return /* @__PURE__ */ y.jsxs("div", { children: [
        /* @__PURE__ */ y.jsx(vq, { appDrawerMenu: i }),
        /* @__PURE__ */ y.jsxs("div", { className: t.root, children: [
          /* @__PURE__ */ y.jsx("h1", { children: "Vous êtes tombé sur un bug, pas de panique" }),
          /* @__PURE__ */ y.jsxs("p", { children: [
            "Une erreur est survenue, si cette erreur persiste n'hésitez pas à contacter l'équipe ONE via le chat ",
            /* @__PURE__ */ y.jsx("b", { children: "ONE-FEEDBACK" }),
            " ou en écrivant à ",
            /* @__PURE__ */ y.jsx("b", { children: "it-editing@prismamedia.com" }),
            "."
          ] }),
          /* @__PURE__ */ y.jsx("p", { children: "N'oubliez pas dans votre message de fournir le log d'erreur ci dessous tout en précisant le contexte dans lequel vous vous trouviez :" }),
          this.state.error && /* @__PURE__ */ y.jsxs("div", { className: t.stack, children: [
            /* @__PURE__ */ y.jsxs("pre", { children: [
              "URL : ",
              window.location.href
            ] }),
            /* @__PURE__ */ y.jsx("pre", { children: this.state.error.toString() }),
            /* @__PURE__ */ y.jsx("pre", { children: (n = this.state.error.stack) == null ? void 0 : n.toString() })
          ] })
        ] })
      ] });
    }
    return this.props.children;
  }
}
const eZ = TE(mq)(yq);
var sf = { exports: {} }, vg, D_;
function My() {
  if (D_) return vg;
  D_ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return vg = e, vg;
}
var mg, P_;
function ET() {
  return P_ || (P_ = 1, mg = Function.call.bind(Object.prototype.hasOwnProperty)), mg;
}
var yg, M_;
function bq() {
  if (M_) return yg;
  M_ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ My(), r = {}, n = /* @__PURE__ */ ET();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, l, c, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in o)
        if (n(o, h)) {
          var g;
          try {
            if (typeof o[h] != "function") {
              var S = Error(
                (c || "React class") + ": " + l + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            g = o[h](s, h, c, l, null, t);
          } catch (p) {
            g = p;
          }
          if (g && !(g instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in r)) {
            r[g.message] = !0;
            var b = f ? f() : "";
            e(
              "Failed " + l + " type: " + g.message + (b ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, yg = i, yg;
}
var bg, A_;
function wq() {
  if (A_) return bg;
  A_ = 1;
  var e = Yl(), t = ip(), r = /* @__PURE__ */ My(), n = /* @__PURE__ */ ET(), i = /* @__PURE__ */ bq(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return bg = function(l, c) {
    var f = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function g(J) {
      var re = J && (f && J[f] || J[h]);
      if (typeof re == "function")
        return re;
    }
    var S = "<<anonymous>>", b = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: M(),
      arrayOf: L,
      element: W(),
      elementType: z(),
      instanceOf: B,
      node: he(),
      objectOf: Z,
      oneOf: K,
      oneOfType: ee,
      shape: Te,
      exact: fe
    };
    function p(J, re) {
      return J === re ? J !== 0 || 1 / J === 1 / re : J !== J && re !== re;
    }
    function v(J, re) {
      this.message = J, this.data = re && typeof re == "object" ? re : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function w(J) {
      if (process.env.NODE_ENV !== "production")
        var re = {}, be = 0;
      function Me(Re, Ee, Ce, X, ie, Ie, xe) {
        if (X = X || S, Ie = Ie || Ce, xe !== r) {
          if (c) {
            var Pe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Pe.name = "Invariant Violation", Pe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ae = X + ":" + Ce;
            !re[ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            be < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Ie + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), re[ae] = !0, be++);
          }
        }
        return Ee[Ce] == null ? Re ? Ee[Ce] === null ? new v("The " + ie + " `" + Ie + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new v("The " + ie + " `" + Ie + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : J(Ee, Ce, X, ie, Ie);
      }
      var Ae = Me.bind(null, !1);
      return Ae.isRequired = Me.bind(null, !0), Ae;
    }
    function C(J) {
      function re(be, Me, Ae, Re, Ee, Ce) {
        var X = be[Me], ie = de(X);
        if (ie !== J) {
          var Ie = ce(X);
          return new v(
            "Invalid " + Re + " `" + Ee + "` of type " + ("`" + Ie + "` supplied to `" + Ae + "`, expected ") + ("`" + J + "`."),
            { expectedType: J }
          );
        }
        return null;
      }
      return w(re);
    }
    function M() {
      return w(s);
    }
    function L(J) {
      function re(be, Me, Ae, Re, Ee) {
        if (typeof J != "function")
          return new v("Property `" + Ee + "` of component `" + Ae + "` has invalid PropType notation inside arrayOf.");
        var Ce = be[Me];
        if (!Array.isArray(Ce)) {
          var X = de(Ce);
          return new v("Invalid " + Re + " `" + Ee + "` of type " + ("`" + X + "` supplied to `" + Ae + "`, expected an array."));
        }
        for (var ie = 0; ie < Ce.length; ie++) {
          var Ie = J(Ce, ie, Ae, Re, Ee + "[" + ie + "]", r);
          if (Ie instanceof Error)
            return Ie;
        }
        return null;
      }
      return w(re);
    }
    function W() {
      function J(re, be, Me, Ae, Re) {
        var Ee = re[be];
        if (!l(Ee)) {
          var Ce = de(Ee);
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + Ce + "` supplied to `" + Me + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(J);
    }
    function z() {
      function J(re, be, Me, Ae, Re) {
        var Ee = re[be];
        if (!e.isValidElementType(Ee)) {
          var Ce = de(Ee);
          return new v("Invalid " + Ae + " `" + Re + "` of type " + ("`" + Ce + "` supplied to `" + Me + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(J);
    }
    function B(J) {
      function re(be, Me, Ae, Re, Ee) {
        if (!(be[Me] instanceof J)) {
          var Ce = J.name || S, X = le(be[Me]);
          return new v("Invalid " + Re + " `" + Ee + "` of type " + ("`" + X + "` supplied to `" + Ae + "`, expected ") + ("instance of `" + Ce + "`."));
        }
        return null;
      }
      return w(re);
    }
    function K(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function re(be, Me, Ae, Re, Ee) {
        for (var Ce = be[Me], X = 0; X < J.length; X++)
          if (p(Ce, J[X]))
            return null;
        var ie = JSON.stringify(J, function(xe, Pe) {
          var ae = ce(Pe);
          return ae === "symbol" ? String(Pe) : Pe;
        });
        return new v("Invalid " + Re + " `" + Ee + "` of value `" + String(Ce) + "` " + ("supplied to `" + Ae + "`, expected one of " + ie + "."));
      }
      return w(re);
    }
    function Z(J) {
      function re(be, Me, Ae, Re, Ee) {
        if (typeof J != "function")
          return new v("Property `" + Ee + "` of component `" + Ae + "` has invalid PropType notation inside objectOf.");
        var Ce = be[Me], X = de(Ce);
        if (X !== "object")
          return new v("Invalid " + Re + " `" + Ee + "` of type " + ("`" + X + "` supplied to `" + Ae + "`, expected an object."));
        for (var ie in Ce)
          if (n(Ce, ie)) {
            var Ie = J(Ce, ie, Ae, Re, Ee + "." + ie, r);
            if (Ie instanceof Error)
              return Ie;
          }
        return null;
      }
      return w(re);
    }
    function ee(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var re = 0; re < J.length; re++) {
        var be = J[re];
        if (typeof be != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Fe(be) + " at index " + re + "."
          ), s;
      }
      function Me(Ae, Re, Ee, Ce, X) {
        for (var ie = [], Ie = 0; Ie < J.length; Ie++) {
          var xe = J[Ie], Pe = xe(Ae, Re, Ee, Ce, X, r);
          if (Pe == null)
            return null;
          Pe.data && n(Pe.data, "expectedType") && ie.push(Pe.data.expectedType);
        }
        var ae = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new v("Invalid " + Ce + " `" + X + "` supplied to " + ("`" + Ee + "`" + ae + "."));
      }
      return w(Me);
    }
    function he() {
      function J(re, be, Me, Ae, Re) {
        return Oe(re[be]) ? null : new v("Invalid " + Ae + " `" + Re + "` supplied to " + ("`" + Me + "`, expected a ReactNode."));
      }
      return w(J);
    }
    function _e(J, re, be, Me, Ae) {
      return new v(
        (J || "React class") + ": " + re + " type `" + be + "." + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ae + "`."
      );
    }
    function Te(J) {
      function re(be, Me, Ae, Re, Ee) {
        var Ce = be[Me], X = de(Ce);
        if (X !== "object")
          return new v("Invalid " + Re + " `" + Ee + "` of type `" + X + "` " + ("supplied to `" + Ae + "`, expected `object`."));
        for (var ie in J) {
          var Ie = J[ie];
          if (typeof Ie != "function")
            return _e(Ae, Re, Ee, ie, ce(Ie));
          var xe = Ie(Ce, ie, Ae, Re, Ee + "." + ie, r);
          if (xe)
            return xe;
        }
        return null;
      }
      return w(re);
    }
    function fe(J) {
      function re(be, Me, Ae, Re, Ee) {
        var Ce = be[Me], X = de(Ce);
        if (X !== "object")
          return new v("Invalid " + Re + " `" + Ee + "` of type `" + X + "` " + ("supplied to `" + Ae + "`, expected `object`."));
        var ie = t({}, be[Me], J);
        for (var Ie in ie) {
          var xe = J[Ie];
          if (n(J, Ie) && typeof xe != "function")
            return _e(Ae, Re, Ee, Ie, ce(xe));
          if (!xe)
            return new v(
              "Invalid " + Re + " `" + Ee + "` key `" + Ie + "` supplied to `" + Ae + "`.\nBad object: " + JSON.stringify(be[Me], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(J), null, "  ")
            );
          var Pe = xe(Ce, Ie, Ae, Re, Ee + "." + Ie, r);
          if (Pe)
            return Pe;
        }
        return null;
      }
      return w(re);
    }
    function Oe(J) {
      switch (typeof J) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !J;
        case "object":
          if (Array.isArray(J))
            return J.every(Oe);
          if (J === null || l(J))
            return !0;
          var re = g(J);
          if (re) {
            var be = re.call(J), Me;
            if (re !== J.entries) {
              for (; !(Me = be.next()).done; )
                if (!Oe(Me.value))
                  return !1;
            } else
              for (; !(Me = be.next()).done; ) {
                var Ae = Me.value;
                if (Ae && !Oe(Ae[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ye(J, re) {
      return J === "symbol" ? !0 : re ? re["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && re instanceof Symbol : !1;
    }
    function de(J) {
      var re = typeof J;
      return Array.isArray(J) ? "array" : J instanceof RegExp ? "object" : ye(re, J) ? "symbol" : re;
    }
    function ce(J) {
      if (typeof J > "u" || J === null)
        return "" + J;
      var re = de(J);
      if (re === "object") {
        if (J instanceof Date)
          return "date";
        if (J instanceof RegExp)
          return "regexp";
      }
      return re;
    }
    function Fe(J) {
      var re = ce(J);
      switch (re) {
        case "array":
        case "object":
          return "an " + re;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + re;
        default:
          return re;
      }
    }
    function le(J) {
      return !J.constructor || !J.constructor.name ? S : J.constructor.name;
    }
    return b.checkPropTypes = i, b.resetWarningCache = i.resetWarningCache, b.PropTypes = b, b;
  }, bg;
}
var wg, N_;
function xq() {
  if (N_) return wg;
  N_ = 1;
  var e = /* @__PURE__ */ My();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, wg = function() {
    function n(s, l, c, f, h, g) {
      if (g !== e) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, wg;
}
var j_;
function _q() {
  if (j_) return sf.exports;
  if (j_ = 1, process.env.NODE_ENV !== "production") {
    var e = Yl(), t = !0;
    sf.exports = /* @__PURE__ */ wq()(e.isElement, t);
  } else
    sf.exports = /* @__PURE__ */ xq()();
  return sf.exports;
}
var Sq = /* @__PURE__ */ _q();
const Pr = /* @__PURE__ */ jr(Sq);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function nu(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(s) {
      s(o);
    });
  }
  return new (r || (r = Promise))(function(o, s) {
    function l(h) {
      try {
        f(n.next(h));
      } catch (g) {
        s(g);
      }
    }
    function c(h) {
      try {
        f(n.throw(h));
      } catch (g) {
        s(g);
      }
    }
    function f(h) {
      h.done ? o(h.value) : i(h.value).then(l, c);
    }
    f((n = n.apply(e, [])).next());
  });
}
function iu(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(f) {
    return function(h) {
      return c([f, h]);
    };
  }
  function c(f) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done) return o;
      switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
        case 0:
        case 1:
          o = f;
          break;
        case 4:
          return r.label++, { value: f[1], done: !1 };
        case 5:
          r.label++, i = f[1], f = [0];
          continue;
        case 7:
          f = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            r = 0;
            continue;
          }
          if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
            r.label = f[1];
            break;
          }
          if (f[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = f;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(f);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      f = t.call(e, r);
    } catch (h) {
      f = [6, h], i = 0;
    } finally {
      n = o = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function Eq(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (l) {
    s = { error: l };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function Cq() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(Eq(arguments[t]));
  return e;
}
var Tq = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function ed(e, t) {
  var r = Oq(e);
  if (typeof r.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof t == "string" ? t : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function Oq(e) {
  var t = e.name, r = t && t.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var n = t.split(".").pop().toLowerCase(), i = Tq.get(n);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var Rq = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function Iq(e) {
  return nu(this, void 0, void 0, function() {
    return iu(this, function(t) {
      return Wf(e) && Dq(e) ? [2, Nq(e.dataTransfer, e.type)] : Pq(e) ? [2, Mq(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, Aq(e)] : [2, []];
    });
  });
}
function Dq(e) {
  return Wf(e.dataTransfer);
}
function Pq(e) {
  return Wf(e) && Wf(e.target);
}
function Wf(e) {
  return typeof e == "object" && e !== null;
}
function Mq(e) {
  return Vv(e.target.files).map(function(t) {
    return ed(t);
  });
}
function Aq(e) {
  return nu(this, void 0, void 0, function() {
    var t;
    return iu(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return t = r.sent(), [2, t.map(function(n) {
            return ed(n);
          })];
      }
    });
  });
}
function Nq(e, t) {
  return nu(this, void 0, void 0, function() {
    var r, n;
    return iu(this, function(i) {
      switch (i.label) {
        case 0:
          return e === null ? [2, []] : e.items ? (r = Vv(e.items).filter(function(o) {
            return o.kind === "file";
          }), t !== "drop" ? [2, r] : [4, Promise.all(r.map(jq))]) : [3, 2];
        case 1:
          return n = i.sent(), [2, k_(CT(n))];
        case 2:
          return [2, k_(Vv(e.files).map(function(o) {
            return ed(o);
          }))];
      }
    });
  });
}
function k_(e) {
  return e.filter(function(t) {
    return Rq.indexOf(t.name) === -1;
  });
}
function Vv(e) {
  if (e === null)
    return [];
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r];
    t.push(n);
  }
  return t;
}
function jq(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return L_(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? TT(t) : L_(e);
}
function CT(e) {
  return e.reduce(function(t, r) {
    return Cq(t, Array.isArray(r) ? CT(r) : [r]);
  }, []);
}
function L_(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject(e + " is not a File");
  var r = ed(t);
  return Promise.resolve(r);
}
function kq(e) {
  return nu(this, void 0, void 0, function() {
    return iu(this, function(t) {
      return [2, e.isDirectory ? TT(e) : Lq(e)];
    });
  });
}
function TT(e) {
  var t = e.createReader();
  return new Promise(function(r, n) {
    var i = [];
    function o() {
      var s = this;
      t.readEntries(function(l) {
        return nu(s, void 0, void 0, function() {
          var c, f, h;
          return iu(this, function(g) {
            switch (g.label) {
              case 0:
                if (l.length) return [3, 5];
                g.label = 1;
              case 1:
                return g.trys.push([1, 3, , 4]), [4, Promise.all(i)];
              case 2:
                return c = g.sent(), r(c), [3, 4];
              case 3:
                return f = g.sent(), n(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                h = Promise.all(l.map(kq)), i.push(h), o(), g.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        n(l);
      });
    }
    o();
  });
}
function Lq(e) {
  return nu(this, void 0, void 0, function() {
    return iu(this, function(t) {
      return [2, new Promise(function(r, n) {
        e.file(function(i) {
          var o = ed(i, e.fullPath);
          r(o);
        }, function(i) {
          n(i);
        });
      })];
    });
  });
}
var lf = {}, z_;
function zq() {
  return z_ || (z_ = 1, lf.__esModule = !0, lf.default = function(e, t) {
    if (e && t) {
      var r = Array.isArray(t) ? t : t.split(","), n = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
      return r.some(function(s) {
        var l = s.trim().toLowerCase();
        return l.charAt(0) === "." ? n.toLowerCase().endsWith(l) : l.endsWith("/*") ? o === l.replace(/\/.*$/, "") : i === l;
      });
    }
    return !0;
  }), lf;
}
var Bq = zq();
const Fq = /* @__PURE__ */ jr(Bq);
function B_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function F_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B_(Object(r), !0).forEach(function(n) {
      OT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function OT(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function W_(e, t) {
  return Uq(e) || $q(e, t) || Hq(e, t) || Wq();
}
function Wq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hq(e, t) {
  if (e) {
    if (typeof e == "string") return H_(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return H_(e, t);
  }
}
function H_(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function $q(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, o = !1, s, l;
    try {
      for (r = r.call(e); !(i = (s = r.next()).done) && (n.push(s.value), !(t && n.length === t)); i = !0)
        ;
    } catch (c) {
      o = !0, l = c;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (o) throw l;
      }
    }
    return n;
  }
}
function Uq(e) {
  if (Array.isArray(e)) return e;
}
var Gq = "file-invalid-type", qq = "file-too-large", Vq = "file-too-small", Yq = "too-many-files", Kq = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var r = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: Gq,
    message: "File type must be ".concat(r)
  };
}, $_ = function(t) {
  return {
    code: qq,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, U_ = function(t) {
  return {
    code: Vq,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Xq = {
  code: Yq,
  message: "Too many files"
};
function RT(e, t) {
  var r = e.type === "application/x-moz-file" || Fq(e, t);
  return [r, r ? null : Kq(t)];
}
function IT(e, t, r) {
  if (Hu(e.size))
    if (Hu(t) && Hu(r)) {
      if (e.size > r) return [!1, $_(r)];
      if (e.size < t) return [!1, U_(t)];
    } else {
      if (Hu(t) && e.size < t) return [!1, U_(t)];
      if (Hu(r) && e.size > r) return [!1, $_(r)];
    }
  return [!0, null];
}
function Hu(e) {
  return e != null;
}
function Jq(e) {
  var t = e.files, r = e.accept, n = e.minSize, i = e.maxSize, o = e.multiple, s = e.maxFiles;
  return !o && t.length > 1 || o && s >= 1 && t.length > s ? !1 : t.every(function(l) {
    var c = RT(l, r), f = W_(c, 1), h = f[0], g = IT(l, n, i), S = W_(g, 1), b = S[0];
    return h && b;
  });
}
function Hf(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function uf(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function G_(e) {
  e.preventDefault();
}
function Zq(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Qq(e) {
  return e.indexOf("Edge/") !== -1;
}
function eV() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return Zq(e) || Qq(e);
}
function Oo() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      o[s - 1] = arguments[s];
    return t.some(function(l) {
      return !Hf(n) && l && l.apply(void 0, [n].concat(o)), Hf(n);
    });
  };
}
function tV() {
  return "showOpenFilePicker" in window;
}
function rV(e) {
  return e = typeof e == "string" ? e.split(",") : e, [{
    description: "everything",
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(e) ? (
      // Accept just MIME types as per spec
      // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
      e.filter(function(t) {
        return t === "audio/*" || t === "video/*" || t === "image/*" || t === "text/*" || /\w+\/[-+.\w]+/g.test(t);
      }).reduce(function(t, r) {
        return F_(F_({}, t), {}, OT({}, r, []));
      }, {})
    ) : {}
  }];
}
function nV(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function iV(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
var oV = ["children"], aV = ["open"], sV = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], lV = ["refKey", "onChange", "onClick"];
function uV(e) {
  return fV(e) || dV(e) || DT(e) || cV();
}
function cV() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dV(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function fV(e) {
  if (Array.isArray(e)) return Yv(e);
}
function xg(e, t) {
  return gV(e) || hV(e, t) || DT(e, t) || pV();
}
function pV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DT(e, t) {
  if (e) {
    if (typeof e == "string") return Yv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yv(e, t);
  }
}
function Yv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function hV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, o = !1, s, l;
    try {
      for (r = r.call(e); !(i = (s = r.next()).done) && (n.push(s.value), !(t && n.length === t)); i = !0)
        ;
    } catch (c) {
      o = !0, l = c;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (o) throw l;
      }
    }
    return n;
  }
}
function gV(e) {
  if (Array.isArray(e)) return e;
}
function q_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ur(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? q_(Object(r), !0).forEach(function(n) {
      Kv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Kv(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $f(e, t) {
  if (e == null) return {};
  var r = vV(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function vV(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var Ay = /* @__PURE__ */ Kf(function(e, t) {
  var r = e.children, n = $f(e, oV), i = MT(n), o = i.open, s = $f(i, aV);
  return MA(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ dt.createElement(fE, null, r(Ur(Ur({}, s), {}, {
    open: o
  })));
});
Ay.displayName = "Dropzone";
var PT = {
  disabled: !1,
  getFilesFromEvent: Iq,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0
};
Ay.defaultProps = PT;
Ay.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Pr.func,
  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: Pr.oneOfType([Pr.string, Pr.arrayOf(Pr.string)]),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Pr.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Pr.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Pr.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Pr.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Pr.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Pr.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Pr.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Pr.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Pr.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Pr.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Pr.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Pr.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Pr.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Pr.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Pr.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Pr.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Pr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Pr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Pr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Pr.func,
  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: Pr.func
};
var Xv = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
function MT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Ur(Ur({}, PT), e), r = t.accept, n = t.disabled, i = t.getFilesFromEvent, o = t.maxSize, s = t.minSize, l = t.multiple, c = t.maxFiles, f = t.onDragEnter, h = t.onDragLeave, g = t.onDragOver, S = t.onDrop, b = t.onDropAccepted, p = t.onDropRejected, v = t.onFileDialogCancel, w = t.onFileDialogOpen, C = t.useFsAccessApi, M = t.preventDropOnDocument, L = t.noClick, W = t.noKeyboard, z = t.noDrag, B = t.noDragEventsBubbling, K = t.validator, Z = kt(function() {
    return typeof w == "function" ? w : V_;
  }, [w]), ee = kt(function() {
    return typeof v == "function" ? v : V_;
  }, [v]), he = bt(null), _e = bt(null), Te = cm(mV, Xv), fe = xg(Te, 2), Oe = fe[0], ye = fe[1], de = Oe.isFocused, ce = Oe.isFileDialogActive, Fe = Oe.draggedFiles, le = bt(typeof window < "u" && window.isSecureContext && C && tV()), J = function() {
    !le.current && ce && setTimeout(function() {
      if (_e.current) {
        var at = _e.current.files;
        at.length || (ye({
          type: "closeDialog"
        }), ee());
      }
    }, 300);
  };
  pt(function() {
    return window.addEventListener("focus", J, !1), function() {
      window.removeEventListener("focus", J, !1);
    };
  }, [_e, ce, ee, le]);
  var re = bt([]), be = function(at) {
    he.current && he.current.contains(at.target) || (at.preventDefault(), re.current = []);
  };
  pt(function() {
    return M && (document.addEventListener("dragover", G_, !1), document.addEventListener("drop", be, !1)), function() {
      M && (document.removeEventListener("dragover", G_), document.removeEventListener("drop", be));
    };
  }, [he, M]);
  var Me = Kt(function(et) {
    et.preventDefault(), et.persist(), ht(et), re.current = [].concat(uV(re.current), [et.target]), uf(et) && Promise.resolve(i(et)).then(function(at) {
      Hf(et) && !B || (ye({
        draggedFiles: at,
        isDragActive: !0,
        type: "setDraggedFiles"
      }), f && f(et));
    });
  }, [i, f, B]), Ae = Kt(function(et) {
    et.preventDefault(), et.persist(), ht(et);
    var at = uf(et);
    if (at && et.dataTransfer)
      try {
        et.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return at && g && g(et), !1;
  }, [g, B]), Re = Kt(function(et) {
    et.preventDefault(), et.persist(), ht(et);
    var at = re.current.filter(function(pr) {
      return he.current && he.current.contains(pr);
    }), Qt = at.indexOf(et.target);
    Qt !== -1 && at.splice(Qt, 1), re.current = at, !(at.length > 0) && (ye({
      isDragActive: !1,
      type: "setDraggedFiles",
      draggedFiles: []
    }), uf(et) && h && h(et));
  }, [he, h, B]), Ee = Kt(function(et, at) {
    var Qt = [], pr = [];
    et.forEach(function(wr) {
      var gt = RT(wr, r), hr = xg(gt, 2), Nn = hr[0], hn = hr[1], cn = IT(wr, s, o), gn = xg(cn, 2), tn = gn[0], rr = gn[1], Tn = K ? K(wr) : null;
      if (Nn && tn && !Tn)
        Qt.push(wr);
      else {
        var xr = [hn, rr];
        Tn && (xr = xr.concat(Tn)), pr.push({
          file: wr,
          errors: xr.filter(function(Xi) {
            return Xi;
          })
        });
      }
    }), (!l && Qt.length > 1 || l && c >= 1 && Qt.length > c) && (Qt.forEach(function(wr) {
      pr.push({
        file: wr,
        errors: [Xq]
      });
    }), Qt.splice(0)), ye({
      acceptedFiles: Qt,
      fileRejections: pr,
      type: "setFiles"
    }), S && S(Qt, pr, at), pr.length > 0 && p && p(pr, at), Qt.length > 0 && b && b(Qt, at);
  }, [ye, l, r, s, o, c, S, b, p, K]), Ce = Kt(function(et) {
    et.preventDefault(), et.persist(), ht(et), re.current = [], uf(et) && Promise.resolve(i(et)).then(function(at) {
      Hf(et) && !B || Ee(at, et);
    }), ye({
      type: "reset"
    });
  }, [i, Ee, B]), X = Kt(function() {
    if (le.current) {
      ye({
        type: "openDialog"
      }), Z();
      var et = {
        multiple: l,
        types: rV(r)
      };
      window.showOpenFilePicker(et).then(function(at) {
        return i(at);
      }).then(function(at) {
        Ee(at, null), ye({
          type: "closeDialog"
        });
      }).catch(function(at) {
        nV(at) ? (ee(at), ye({
          type: "closeDialog"
        })) : iV(at) && (le.current = !1, _e.current && (_e.current.value = null, _e.current.click()));
      });
      return;
    }
    _e.current && (ye({
      type: "openDialog"
    }), Z(), _e.current.value = null, _e.current.click());
  }, [ye, Z, ee, C, Ee, r, l]), ie = Kt(function(et) {
    !he.current || !he.current.isEqualNode(et.target) || (et.key === " " || et.key === "Enter" || et.keyCode === 32 || et.keyCode === 13) && (et.preventDefault(), X());
  }, [he, X]), Ie = Kt(function() {
    ye({
      type: "focus"
    });
  }, []), xe = Kt(function() {
    ye({
      type: "blur"
    });
  }, []), Pe = Kt(function() {
    L || (eV() ? setTimeout(X, 0) : X());
  }, [L, X]), ae = function(at) {
    return n ? null : at;
  }, rt = function(at) {
    return W ? null : ae(at);
  }, Ze = function(at) {
    return z ? null : ae(at);
  }, ht = function(at) {
    B && at.stopPropagation();
  }, mt = kt(function() {
    return function() {
      var et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, at = et.refKey, Qt = at === void 0 ? "ref" : at, pr = et.role, wr = et.onKeyDown, gt = et.onFocus, hr = et.onBlur, Nn = et.onClick, hn = et.onDragEnter, cn = et.onDragOver, gn = et.onDragLeave, tn = et.onDrop, rr = $f(et, sV);
      return Ur(Ur(Kv({
        onKeyDown: rt(Oo(wr, ie)),
        onFocus: rt(Oo(gt, Ie)),
        onBlur: rt(Oo(hr, xe)),
        onClick: ae(Oo(Nn, Pe)),
        onDragEnter: Ze(Oo(hn, Me)),
        onDragOver: Ze(Oo(cn, Ae)),
        onDragLeave: Ze(Oo(gn, Re)),
        onDrop: Ze(Oo(tn, Ce)),
        role: typeof pr == "string" && pr !== "" ? pr : "button"
      }, Qt, he), !n && !W ? {
        tabIndex: 0
      } : {}), rr);
    };
  }, [he, ie, Ie, xe, Pe, Me, Ae, Re, Ce, W, z, n]), At = Kt(function(et) {
    et.stopPropagation();
  }, []), Bt = kt(function() {
    return function() {
      var et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, at = et.refKey, Qt = at === void 0 ? "ref" : at, pr = et.onChange, wr = et.onClick, gt = $f(et, lV), hr = Kv({
        accept: r,
        multiple: l,
        type: "file",
        style: {
          display: "none"
        },
        onChange: ae(Oo(pr, Ce)),
        onClick: ae(Oo(wr, At)),
        autoComplete: "off",
        tabIndex: -1
      }, Qt, _e);
      return Ur(Ur({}, hr), gt);
    };
  }, [_e, r, l, Ce, n]), Gt = Fe.length, It = Gt > 0 && Jq({
    files: Fe,
    accept: r,
    minSize: s,
    maxSize: o,
    multiple: l,
    maxFiles: c
  }), sr = Gt > 0 && !It;
  return Ur(Ur({}, Oe), {}, {
    isDragAccept: It,
    isDragReject: sr,
    isFocused: de && !n,
    getRootProps: mt,
    getInputProps: Bt,
    rootRef: he,
    inputRef: _e,
    open: ae(X)
  });
}
function mV(e, t) {
  switch (t.type) {
    case "focus":
      return Ur(Ur({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Ur(Ur({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Ur(Ur({}, Xv), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Ur(Ur({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      var r = t.isDragActive, n = t.draggedFiles;
      return Ur(Ur({}, e), {}, {
        draggedFiles: n,
        isDragActive: r
      });
    case "setFiles":
      return Ur(Ur({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return Ur({}, Xv);
    default:
      return e;
  }
}
function V_() {
}
const yV = Rt((e) => ({
  wrapper: {
    position: "relative"
  },
  wrapperShowDropZone: {
    "&::after": {
      content: '""',
      position: "absolute",
      top: e.spacing(1),
      bottom: e.spacing(1),
      right: e.spacing(1),
      left: e.spacing(1),
      borderRadius: 5,
      border: `2px dashed ${e.palette.primary.main}`
    }
  },
  backdrop: {
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: an(e.palette.background.default, 0.8)
  },
  snackBar: {
    position: "absolute"
  },
  snackBarContent: {
    backgroundColor: e.palette.primary.main,
    justifyContent: "center",
    textAlign: "center"
  }
})), bV = ({
  onDrop: e,
  title: t = "Déposez le fichier ici",
  classes: r,
  className: n,
  children: i,
  style: o,
  disabled: s,
  dropzoneOptions: l,
  sx: c
}) => {
  const f = yV(), { getRootProps: h, isDragActive: g } = MT({
    onDrop: e,
    noClick: !0,
    noKeyboard: !0,
    disabled: s,
    ...l
  });
  return /* @__PURE__ */ y.jsxs(
    zt,
    {
      ...h(),
      className: nt(
        f.wrapper,
        g && f.wrapperShowDropZone,
        n
      ),
      style: o,
      sx: c,
      children: [
        i,
        g && /* @__PURE__ */ y.jsx("div", { className: f.backdrop }),
        /* @__PURE__ */ y.jsx(
          fm,
          {
            className: f.snackBar,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center"
            },
            open: g,
            children: /* @__PURE__ */ y.jsx(
              pm,
              {
                className: nt(
                  f.snackBarContent,
                  r == null ? void 0 : r.snackBarContent
                ),
                message: /* @__PURE__ */ y.jsxs(zt, { sx: { display: "flex", alignItems: "center" }, children: [
                  /* @__PURE__ */ y.jsx(xm, { sx: { mr: 1, color: "white" } }),
                  t
                ] })
              }
            )
          }
        )
      ]
    }
  );
}, Jv = (e, t) => Object.entries(e).filter(([r]) => t ? r !== "search" : !0).reduce((r, [, n]) => r + (n ? 1 : 0), 0), Y_ = (e, t) => !li.isNull(e.id) && (t == null ? void 0 : t.id) === e.id || t.label === e.label, wV = Rt((e) => ({
  popper: {
    zIndex: e.zIndex.modal
  },
  card: {
    minHeight: 50,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  contentWrapper: {
    maxHeight: "calc(100vh - 200px)",
    overflow: "auto"
  },
  actions: {
    justifyContent: "flex-end"
  },
  title: {
    padding: e.spacing(2, 3, 0)
  }
})), xV = ({
  advancedSearch: e,
  anchorRef: t,
  onClose: r,
  open: n,
  resetSearch: i,
  searchParams: o,
  setSearchParams: s,
  triggerSearch: l
}) => {
  var h;
  const c = wV(), f = (g) => (S) => {
    S instanceof Array && !S.length && (S = void 0), s((b) => ({
      ...b,
      [g]: S || void 0
    }));
  };
  return /* @__PURE__ */ y.jsx(
    Jf,
    {
      open: n,
      anchorEl: t.current,
      transition: !0,
      className: c.popper,
      style: { width: (h = t.current) == null ? void 0 : h.clientWidth },
      children: ({ TransitionProps: g, placement: S }) => /* @__PURE__ */ y.jsx(
        Zf,
        {
          ...g,
          style: {
            transformOrigin: S === "bottom" ? "center top" : "center bottom"
          },
          children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
            dm,
            {
              mouseEvent: "onMouseDown",
              touchEvent: "onTouchStart",
              onClickAway: (b) => {
                t.current.contains(b.target) || r == null || r();
              },
              children: /* @__PURE__ */ y.jsxs(
                Bo,
                {
                  classes: { root: c.card },
                  style: S !== "bottom" ? { borderTopLeftRadius: 4, borderTopRightRadius: 4 } : void 0,
                  raised: !0,
                  children: [
                    /* @__PURE__ */ y.jsx(Lt, { className: c.title, variant: "h6", children: e.title || "Recherche avancée" }),
                    /* @__PURE__ */ y.jsx("div", { className: c.contentWrapper, children: /* @__PURE__ */ y.jsx(
                      e.component,
                      {
                        searchParams: o,
                        setSearchParams: s,
                        updateSearchParam: f,
                        ...e.props
                      }
                    ) }),
                    /* @__PURE__ */ y.jsxs(vm, { classes: { root: c.actions }, children: [
                      /* @__PURE__ */ y.jsx(
                        Fr,
                        {
                          onClick: i,
                          disabled: !Jv(o, !0),
                          children: "Réinitialiser"
                        }
                      ),
                      /* @__PURE__ */ y.jsx(
                        Fr,
                        {
                          color: "primary",
                          variant: "contained",
                          onClick: () => {
                            l();
                          },
                          children: "Rechercher"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ) })
        }
      )
    }
  );
};
var Yn = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e))(Yn || {}), gf = /* @__PURE__ */ ((e) => (e[e.LEFT = 0] = "LEFT", e[e.RIGHT = 1] = "RIGHT", e))(gf || {});
const _V = Rt(
  (e) => OE({
    search: ({ isDisabled: t, variant: r, searchFocus: n, panelOpen: i }) => ({
      position: "relative",
      borderTopLeftRadius: e.shape.borderRadius,
      borderTopRightRadius: e.shape.borderRadius,
      borderBottomLeftRadius: i ? 0 : e.shape.borderRadius,
      borderBottomRightRadius: i ? 0 : e.shape.borderRadius,
      backgroundColor: n || r === Yn.SECONDARY ? e.palette.common.white : an(
        e.palette.common[r === Yn.TERTIARY ? "black" : "white"],
        r === Yn.TERTIARY ? 0.06 : 0.15
      ),
      ...!t && {
        "&:hover": {
          backgroundColor: n || r === Yn.SECONDARY ? e.palette.common.white : an(
            e.palette.common[r === Yn.TERTIARY ? "black" : "white"],
            r === Yn.TERTIARY ? 0.07 : 0.25
          )
        }
      },
      alignItems: "center",
      boxShadow: n && r !== Yn.PRIMARY ? "0 1px 1px 0 rgba(65,69,73,0.3), 0 1px 3px 1px rgba(65,69,73,0.15)" : void 0,
      color: n ? e.palette.common.black : void 0,
      display: "flex",
      padding: e.spacing(0, 1)
    }),
    inputRoot: {
      color: "inherit",
      width: "100%"
    },
    inputInput: ({ variant: t, searchFocus: r }) => ({
      padding: e.spacing(1.5, 1),
      transition: e.transitions.create("width"),
      width: "100%",
      "&::placeholder": {
        color: !r && t === Yn.PRIMARY ? e.palette.common.white : e.palette.common.black,
        opacity: 0.37
      }
    }),
    icon: ({ isDisabled: t, variant: r, searchFocus: n }) => ({
      color: !n && r === Yn.PRIMARY ? e.palette.common.white : an(e.palette.common.black, 0.54),
      ...!t && {
        "&:hover": {
          backgroundColor: !n && r === Yn.PRIMARY ? void 0 : an(e.palette.common.black, 0.04)
        }
      },
      ...t && {
        opacity: 0.6,
        pointerEvents: "none"
      }
    }),
    iconSearch: ({ isDisabled: t, variant: r, searchFocus: n }) => ({
      color: !n && r === Yn.PRIMARY ? e.palette.common.white : an(e.palette.common.black, 0.54),
      margin: e.spacing(1.5),
      ...t && {
        opacity: 0.6,
        pointerEvents: "none"
      }
    }),
    chip: ({ variant: t, searchFocus: r }) => ({
      margin: e.spacing(0, 1),
      color: !r && t === Yn.PRIMARY ? e.palette.common.white : e.palette.common.black,
      borderColor: !r && t === Yn.PRIMARY ? e.palette.common.white : void 0
    })
  })
);
let cf, _g = !1;
const SV = ({
  advancedSearch: e,
  autocomplete: t = {},
  autoFocus: r = !1,
  chipAdvancedParamLabel: n,
  className: i,
  iconPosition: o = gf.LEFT,
  isDisabled: s,
  fetchListMinValueLength: l = 1,
  onBlur: c,
  onFocus: f,
  placeholder: h,
  searchParams: g,
  setSearchParams: S,
  variant: b = Yn.PRIMARY
}) => {
  const { mode: p = ec.BASIC } = t, [v, w] = Xe(!1), [C, M] = Xe(!1), [L, W] = Xe(void 0), [z, B] = Xe(!1), [K, Z] = Xe({}), [ee, he] = Xe(void 0), [_e, Te] = Xe(!1), fe = v && !!e, Oe = Wc(K.search), ye = Ij(), de = bt(null), ce = bt(null), Fe = !!(t != null && t.fetchList && !fe && C && (_e || Oe != null && Oe.length || p === ec.MULTIPLE && !(Oe != null && Oe.length))), le = fe || z || Fe, J = Jv(K, !0), re = _V({
    isDisabled: s,
    panelOpen: Fe || fe,
    searchFocus: le,
    variant: b
  }), be = !fe && !t.fetchList, Me = ({ withLoading: Ce }) => {
    t.fetchList && (W((X) => X && void 0), Ce && Te(!0), t.fetchList(Oe || "").then(he).catch(W).finally(() => {
      Te((X) => X && !1);
    }));
  }, Ae = (Ce) => {
    var X, ie;
    p === ec.MULTIPLE ? _g || (_g = !0, (X = t == null ? void 0 : t.onSelect) == null || X.call(t, Ce), he(
      ee == null ? void 0 : ee.map((Ie) => ({
        ...Ie,
        loading: Y_(Ce, Ie)
      }))
    ), cf = setTimeout(() => {
      _g = !1, he(
        ee == null ? void 0 : ee.map((Ie) => ({
          ...Ie,
          loading: !1,
          selected: Ie.selected || Y_(Ce, Ie)
        }))
      );
    }, 500)) : ((ie = t == null ? void 0 : t.onSelect) == null || ie.call(t, Ce), M(!1), Me({ withLoading: !1 }));
  }, Re = ({ resetAll: Ce }) => {
    M(!1), S(Ce ? {} : { search: K.search }), t.suggestedTagList && he(t.suggestedTagList);
  }, Ee = () => {
    M(!1), w(!1), ye || S(K);
  };
  return pt(() => {
    Z(g);
  }, [g]), pt(() => {
    be && Ee();
  }, [Oe, be]), pt(() => {
    C && !li.isUndefined(Oe) && l <= Oe.length && Me({ withLoading: !0 });
  }, [C, Oe]), pt(
    () => () => {
      cf && clearTimeout(cf);
    },
    []
  ), /* @__PURE__ */ y.jsxs("div", { className: nt(i, re.search), ref: ce, children: [
    o === gf.LEFT && /* @__PURE__ */ y.jsx(F0, { className: re.iconSearch }),
    /* @__PURE__ */ y.jsx(
      qA,
      {
        autoFocus: r,
        classes: {
          root: re.inputRoot,
          input: re.inputInput
        },
        value: K.search || "",
        inputRef: de,
        disabled: s,
        onChange: ({ target: Ce }) => {
          Z((X) => ({
            ...X,
            search: Ce.value
          }));
        },
        onFocus: () => {
          f == null || f(), B(!0), M(!0);
        },
        onBlur: () => {
          c == null || c(), B(!1), ee != null && ee.length || (cf = setTimeout(() => {
            M(!1);
          }, 150));
        },
        onKeyDown: ({ key: Ce }) => {
          var X;
          Ce === "Enter" && (Ee(), (X = de.current) == null || X.blur());
        },
        placeholder: h
      }
    ),
    !!J && /* @__PURE__ */ y.jsx(
      Qa,
      {
        className: re.chip,
        variant: "outlined",
        label: `+ ${J} ${n || Po("critère", J)}`,
        onClick: () => {
          M(!1), w(!0);
        }
      }
    ),
    !!Jv(K) && /* @__PURE__ */ y.jsx(Nr, { title: "Effacer la recherche", children: /* @__PURE__ */ y.jsx(
      fr,
      {
        className: re.icon,
        onClick: () => {
          Re({ resetAll: !0 });
        },
        children: /* @__PURE__ */ y.jsx(gc, {})
      }
    ) }),
    o === gf.RIGHT && /* @__PURE__ */ y.jsx(F0, { className: re.iconSearch }),
    e && /* @__PURE__ */ y.jsx(Nr, { title: "Recherche avancée", children: /* @__PURE__ */ y.jsx(
      fr,
      {
        className: re.icon,
        onClick: () => {
          M(!1), w((Ce) => !Ce);
        },
        children: fe ? /* @__PURE__ */ y.jsx(ym, {}) : /* @__PURE__ */ y.jsx(Lc, {})
      }
    ) }),
    /* @__PURE__ */ y.jsx(
      Wm,
      {
        anchorRef: ce,
        disabled: t == null ? void 0 : t.disabled,
        error: L,
        loading: _e,
        list: ee,
        listHeader: t.listHeader,
        mode: p,
        onClose: () => {
          var Ce;
          (Ce = t == null ? void 0 : t.onClose) == null || Ce.call(t), w(!1), M(!1);
        },
        onSelect: Ae,
        open: Fe,
        placeholder: t == null ? void 0 : t.placeholder
      }
    ),
    e && /* @__PURE__ */ y.jsx(
      xV,
      {
        advancedSearch: e,
        anchorRef: ce,
        onClose: Ee,
        open: fe,
        resetSearch: () => {
          Re({ resetAll: !1 });
        },
        searchParams: K,
        setSearchParams: Z,
        triggerSearch: () => {
          var Ce;
          Ee(), p === ec.MULTIPLE && ((Ce = de.current) == null || Ce.focus());
        }
      }
    )
  ] });
}, vf = "NEW_FOLDER";
var Zv = /* @__PURE__ */ ((e) => (e.LOADER = "LOADER", e.MESSAGE = "MESSAGE", e))(Zv || {});
const AT = (e, t) => t.reduce((r, n) => {
  var i;
  return ((i = n.parent) == null ? void 0 : i.id) !== e ? r : [...r, n, ...AT(n.id, t)];
}, []), NT = (e, t) => {
  const r = t.find(({ id: n }) => {
    var i;
    return n === ((i = e.parent) == null ? void 0 : i.id);
  });
  return r ? [r, ...NT(r, t)] : [];
}, jT = (e, t) => {
  const r = t == null ? void 0 : t.find(({ id: i }) => {
    var o;
    return ((o = e.parent) == null ? void 0 : o.id) === i;
  }), n = r ? jT(r, t) : "";
  return `${n}${n ? " / " : ""}${e.label}`;
}, kT = (e, t, r) => {
  if (e === "LOADER" || e === "MESSAGE" || !r.includes(e.id))
    return [e];
  const i = t.filter(({ parent: o }) => (o == null ? void 0 : o.id) === e.id).reduce(
    (o, s) => [
      ...o,
      ...kT(
        { ...s, level: e.level + 1 },
        t,
        r
      )
    ],
    []
  );
  return [
    e,
    ...e.customChild ? [
      "MESSAGE"
      /* MESSAGE */
    ] : [],
    ...i,
    ...e.loading ? [
      "LOADER"
      /* LOADER */
    ] : []
  ];
}, EV = (e, t) => {
  if (!t) return e;
  const r = (n) => {
    var i;
    return (i = n.label) == null ? void 0 : i.toLowerCase().includes(t.trim().toLocaleLowerCase());
  };
  return e == null ? void 0 : e.filter((n) => {
    const i = [
      n,
      ...AT(n.id, e)
    ].some(r), o = NT(
      n,
      e
    ).some(r);
    return i || o;
  });
}, CV = (e, t) => e == null ? void 0 : e.filter(({ parent: r }) => !r).reduce(
  (r, n) => [
    ...r,
    ...kT(
      { ...n, level: 0 },
      e,
      t
    )
  ],
  []
), TV = Rt((e) => ({
  item: ({ level: t, hasChildren: r }) => ({
    paddingLeft: e.spacing(1 + t * 3 + (r ? 0 : 3)),
    paddingTop: 0,
    paddingBottom: 0
  }),
  iconWrapper: {
    marginRight: e.spacing(2),
    padding: e.spacing(0.7, 0),
    minWidth: 0
  }
})), OV = ({
  folders: e,
  folder: t,
  onSelect: r,
  selected: n,
  openedFolders: i,
  setOpenedFolders: o,
  level: s = 0,
  onPlusClicked: l,
  onEditFolder: c,
  loading: f,
  contextMenu: h,
  editingFolder: g,
  setEditingFolder: S
}) => {
  const p = !!kt(
    () => e.filter((ee) => {
      var he;
      return ((he = ee.parent) == null ? void 0 : he.id) === t.id;
    }),
    [t.id, e]
  ).length || !!t.forceOpenable, v = TV({ level: s, hasChildren: p }), w = n === t.id, C = i.includes(t.id), [M, L] = Xe(!1), W = t.id === (g == null ? void 0 : g.id), { openMenu: z } = Xl(), B = t.Icon || _N, K = (ee) => {
    ee.stopPropagation(), p && o(
      (he) => he.includes(t.id) ? he.filter((_e) => _e !== t.id) : [...he, t.id]
    );
  }, Z = !!t.label && t.label.length < 30;
  return /* @__PURE__ */ y.jsx(
    Nr,
    {
      title: t.label || "",
      disableHoverListener: Z,
      disableFocusListener: Z,
      disableTouchListener: Z,
      children: /* @__PURE__ */ y.jsxs(
        VA,
        {
          className: v.item,
          onClick: W ? void 0 : () => r(t.id),
          selected: w,
          dense: !0,
          onMouseEnter: () => L(!0),
          onMouseLeave: () => L(!1),
          onContextMenu: W || !h ? void 0 : (ee) => {
            ee.preventDefault(), z(ee.currentTarget, h);
          },
          children: [
            /* @__PURE__ */ y.jsxs(Va, { className: v.iconWrapper, children: [
              !!p && (C ? /* @__PURE__ */ y.jsx(Lc, { onClick: K }) : /* @__PURE__ */ y.jsx(SN, { onClick: K })),
              /* @__PURE__ */ y.jsx(B, {})
            ] }),
            W ? /* @__PURE__ */ y.jsx(
              ln,
              {
                autoFocus: !0,
                size: "small",
                placeholder: "Nouveau dossier",
                sx: { pr: 1 },
                inputProps: { style: { paddingTop: 5, paddingBottom: 5 } },
                value: g.label || "",
                onChange: ({ target: ee }) => S(
                  (he) => he && { ...he, label: ee.value }
                ),
                onKeyDown: (ee) => {
                  ee.key === "Enter" && g.label && (ee.preventDefault(), ee.stopPropagation(), c()), ee.key === "Escape" && (ee.preventDefault(), ee.stopPropagation(), S(void 0));
                }
              }
            ) : /* @__PURE__ */ y.jsx(
              Ya,
              {
                primaryTypographyProps: {
                  sx: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }
                },
                primary: t.label
              }
            ),
            !W && l && M && /* @__PURE__ */ y.jsx(Nr, { title: "Nouveau dossier", children: /* @__PURE__ */ y.jsx(
              fr,
              {
                onClick: (ee) => {
                  ee.stopPropagation(), l();
                },
                size: "small",
                children: /* @__PURE__ */ y.jsx(xE, {})
              }
            ) }),
            W && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
              f ? /* @__PURE__ */ y.jsx(un, { size: 20, sx: { mx: "7px" } }) : /* @__PURE__ */ y.jsx(
                Nr,
                {
                  title: g.id === vf ? "Créer" : "Renommer",
                  children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
                    fr,
                    {
                      onClick: async (ee) => {
                        ee.stopPropagation(), c();
                      },
                      size: "small",
                      disabled: !g.label,
                      children: /* @__PURE__ */ y.jsx(EN, {})
                    }
                  ) })
                }
              ),
              /* @__PURE__ */ y.jsx(Nr, { title: "Annuler", children: /* @__PURE__ */ y.jsx(
                fr,
                {
                  onClick: async (ee) => {
                    ee.stopPropagation(), S(void 0);
                  },
                  size: "small",
                  children: /* @__PURE__ */ y.jsx(ql, {})
                }
              ) })
            ] })
          ]
        }
      )
    }
  );
}, RV = Rt((e) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  error: {
    textAlign: "center",
    padding: e.spacing(0, 1),
    marginTop: e.spacing(2)
  },
  searchBar: {
    marginTop: e.spacing(1),
    flexShrink: 0
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0
  },
  listWrapper: {
    marginTop: e.spacing(1),
    flex: 1
  },
  chip: {
    overflow: "hidden"
  },
  title: {
    marginRight: e.spacing(2)
  }
})), tZ = ({
  selected: e,
  setSelected: t,
  openedFolders: r,
  setOpenedFolders: n,
  folders: i,
  loading: o,
  error: s,
  title: l,
  className: c,
  onCreateFolder: f,
  onDeleteFolder: h,
  onRenameFolder: g,
  maxLevel: S,
  searchBarVariant: b
}) => {
  const p = RV(), [v, w] = Xe(
    []
  ), [C, M] = Xe({}), [L, W] = Xe(
    void 0
  ), [z, B] = Xe(!1), { closeMenu: K } = Xl(), Z = kt(() => {
    const de = i.find((ce) => ce.id === e);
    if (de)
      return jT(de, i);
  }, [i, e]), ee = kt(
    () => EV(i, C.search),
    [i, C]
  ), he = kt(
    () => (L == null ? void 0 : L.id) === vf ? [L, ...ee || []] : ee,
    [ee, L]
  ), _e = kt(
    () => CV(he, v),
    [he, v]
  );
  pt(() => {
    r && w(r);
  }, [r]);
  const Te = (de) => {
    w(de), n == null || n(de);
  }, fe = async () => {
    if (L) {
      B(!0);
      try {
        if (L.id === vf) {
          const { label: de, parent: ce } = L, Fe = await (f == null ? void 0 : f({ label: de, parent: ce }));
          t == null || t(Fe);
        } else {
          if (!L.label) return;
          await (g == null ? void 0 : g(L, L.label));
        }
        W(void 0);
      } catch {
      }
      B(!1);
    }
  }, Oe = async (de) => {
    B(!0);
    try {
      await (h == null ? void 0 : h(de)), t == null || t((ce) => ce === de.id ? void 0 : ce);
    } catch {
    }
    B(!1);
  }, ye = (de) => {
    de && Te((ce) => [...ce, de]), t == null || t(void 0), W({
      id: vf,
      parent: de ? { id: de } : null,
      label: ""
    });
  };
  return o ? /* @__PURE__ */ y.jsx("div", { className: nt(p.loader, c), children: /* @__PURE__ */ y.jsx(un, { size: 40 }) }) : s ? /* @__PURE__ */ y.jsx(
    Lt,
    {
      color: "error",
      variant: "body2",
      className: nt(p.error, c),
      children: s.message
    }
  ) : /* @__PURE__ */ y.jsxs("div", { className: nt(p.wrapper, c), children: [
    /* @__PURE__ */ y.jsxs("div", { className: p.titleWrapper, children: [
      l && /* @__PURE__ */ y.jsx(Lt, { className: p.title, variant: "h6", children: l }),
      Z && /* @__PURE__ */ y.jsx(
        Qa,
        {
          color: "primary",
          label: Z,
          onDelete: () => t == null ? void 0 : t(void 0),
          className: p.chip
        }
      ),
      !Z && f && /* @__PURE__ */ y.jsx(
        Fr,
        {
          variant: "outlined",
          startIcon: /* @__PURE__ */ y.jsx(xE, {}),
          onClick: () => ye(),
          size: "small",
          children: "Nouveau"
        }
      )
    ] }),
    i.length >= 10 && /* @__PURE__ */ y.jsx(
      SV,
      {
        searchParams: C,
        setSearchParams: M,
        className: p.searchBar,
        variant: b
      }
    ),
    _e != null && _e.length ? /* @__PURE__ */ y.jsx(
      "div",
      {
        className: p.listWrapper,
        style: {
          minHeight: Math.min(35 * ((_e == null ? void 0 : _e.length) || 0), 200)
        },
        children: /* @__PURE__ */ y.jsx(co.AutoSizer, { children: ({ width: de, height: ce }) => /* @__PURE__ */ y.jsx(
          co.List,
          {
            width: de,
            height: ce,
            rowCount: _e.length,
            rowHeight: 35,
            rowRenderer: ({ key: Fe, index: le, style: J }) => {
              var be;
              const re = _e[le];
              return /* @__PURE__ */ y.jsx("div", { style: J, children: re === Zv.LOADER ? /* @__PURE__ */ y.jsx(
                zt,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%"
                  },
                  children: /* @__PURE__ */ y.jsx(un, { size: 20 })
                }
              ) : re === Zv.MESSAGE ? ((be = _e[le - 1]) == null ? void 0 : be.customChild) || null : /* @__PURE__ */ y.jsx(
                OV,
                {
                  folders: ee || [],
                  folder: re,
                  onSelect: (Me) => t == null ? void 0 : t(
                    (Ae) => Ae === Me ? void 0 : Me
                  ),
                  selected: e,
                  openedFolders: v,
                  setOpenedFolders: Te,
                  level: re.level,
                  onPlusClicked: f && (S === void 0 || re.level < S) ? () => ye(re.id) : void 0,
                  onEditFolder: fe,
                  loading: z,
                  editingFolder: L,
                  setEditingFolder: W,
                  contextMenu: h || g ? /* @__PURE__ */ y.jsxs(zt, { children: [
                    g && /* @__PURE__ */ y.jsxs(
                      la,
                      {
                        onClick: () => {
                          W(re), K();
                        },
                        children: [
                          /* @__PURE__ */ y.jsx(Va, { children: /* @__PURE__ */ y.jsx(tp, { fontSize: "small" }) }),
                          /* @__PURE__ */ y.jsx(Ya, { children: "Renommer" })
                        ]
                      }
                    ),
                    h && /* @__PURE__ */ y.jsxs(
                      la,
                      {
                        onClick: () => {
                          Oe(re), K();
                        },
                        children: [
                          /* @__PURE__ */ y.jsx(Va, { children: /* @__PURE__ */ y.jsx(zc, { fontSize: "small" }) }),
                          /* @__PURE__ */ y.jsx(Ya, { children: "Supprimer" })
                        ]
                      }
                    )
                  ] }) : void 0
                }
              ) }, Fe);
            }
          }
        ) })
      }
    ) : /* @__PURE__ */ y.jsx(Lt, { variant: "body2", className: p.error, children: "Aucun résultat" })
  ] });
};
function IV(e = {}) {
  const { onScriptLoadSuccess: t, onScriptLoadError: r } = e, [n, i] = Xe(!1), o = bt(t);
  o.current = t;
  const s = bt(r);
  return s.current = r, pt(() => {
    const l = document.createElement("script");
    return l.src = "https://accounts.google.com/gsi/client", l.async = !0, l.defer = !0, l.onload = () => {
      var c;
      i(!0), (c = o.current) === null || c === void 0 || c.call(o);
    }, l.onerror = () => {
      var c;
      i(!1), (c = s.current) === null || c === void 0 || c.call(s);
    }, document.body.appendChild(l), () => {
      document.body.removeChild(l);
    };
  }, []), n;
}
const LT = Ac(null);
function DV({ clientId: e, onScriptLoadSuccess: t, onScriptLoadError: r, children: n }) {
  const i = IV({
    onScriptLoadSuccess: t,
    onScriptLoadError: r
  }), o = kt(() => ({
    clientId: e,
    scriptLoadedSuccessfully: i
  }), [e, i]);
  return dt.createElement(LT.Provider, { value: o }, n);
}
function PV() {
  const e = qi(LT);
  if (!e)
    throw new Error("Google OAuth components must be used within GoogleOAuthProvider");
  return e;
}
const MV = { large: 40, medium: 32, small: 20 };
function AV({ onSuccess: e, onError: t, useOneTap: r, promptMomentNotification: n, type: i = "standard", theme: o = "outline", size: s = "large", text: l, shape: c, logo_alignment: f, width: h, locale: g, ...S }) {
  const b = bt(null), { clientId: p, scriptLoadedSuccessfully: v } = PV(), w = bt(e);
  w.current = e;
  const C = bt(t);
  C.current = t;
  const M = bt(n);
  return M.current = n, pt(() => {
    var L, W, z;
    if (v)
      return (L = window.google) === null || L === void 0 || L.accounts.id.initialize({
        client_id: p,
        callback: (B) => {
          var K;
          if (!B.clientId || !B.credential)
            return (K = C.current) === null || K === void 0 ? void 0 : K.call(C);
          w.current(B);
        },
        ...S
      }), (W = window.google) === null || W === void 0 || W.accounts.id.renderButton(b.current, {
        type: i,
        theme: o,
        size: s,
        text: l,
        shape: c,
        logo_alignment: f,
        width: h,
        locale: g
      }), r && ((z = window.google) === null || z === void 0 || z.accounts.id.prompt(M.current)), () => {
        var B;
        r && ((B = window.google) === null || B === void 0 || B.accounts.id.cancel());
      };
  }, [
    p,
    v,
    r,
    i,
    o,
    s,
    l,
    c,
    f,
    h,
    g
  ]), dt.createElement("div", { ref: b, style: { height: MV[s] } });
}
const rZ = ({ children: e }) => /* @__PURE__ */ y.jsx(DV, { clientId: "791899908137-bg2m7sgaj5lo77pldaetu60n73fs0pr5.apps.googleusercontent.com", children: e }), NV = fp(() => ({
  loader: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  fullscreen: {
    height: "100vh"
  },
  message: {
    fontSize: "1.5rem"
  }
})), jV = ({
  color: e = "primary",
  size: t = 30,
  thickness: r = 5,
  fullscreen: n = !1,
  message: i = ""
}) => {
  const o = NV();
  return /* @__PURE__ */ y.jsxs("div", { className: nt(o.loader, n && o.fullscreen), children: [
    /* @__PURE__ */ y.jsx(un, { color: e, size: t, thickness: r }),
    i && /* @__PURE__ */ y.jsx("p", { className: o.message, children: i })
  ] });
}, kV = Rt((e) => ({
  accordion: {
    boxShadow: "none"
  },
  accordionDetails: {
    borderTop: `dashed 1px ${e.palette.grey[200]}`,
    padding: e.spacing(2)
  },
  accordionRow: {
    "& > div": {
      flex: "1 auto",
      display: "flex",
      alignItems: "center",
      "& > p": {
        marginLeft: e.spacing(1.5),
        fontWeight: 500
      }
    },
    "& > p:last-child": {
      color: e.palette.grey[500],
      fontSize: e.typography.fontSize,
      marginRight: e.spacing(3)
    }
  },
  accordionDisabled: {
    pointerEvents: "none",
    "& svg": {
      opacity: 0
    }
  },
  wrapperInnerContent: {
    padding: e.spacing(2, 1),
    "& table tr": {
      "& svg": {
        marginRight: e.spacing(1),
        position: "relative",
        top: e.spacing(0.5),
        transform: "rotate(-90deg)"
      },
      "& th": {
        fontSize: "1rem",
        border: "none",
        padding: e.spacing(1),
        "&:last-child": {
          fontWeight: 500
        }
      }
    }
  },
  wrapperContent: {
    backgroundColor: e.palette.grey[200],
    maxHeight: "60vh"
  },
  wrapperHead: {
    alignItems: "center",
    display: "flex",
    gap: e.spacing(0.5),
    marginBottom: e.spacing(1.75),
    "& > svg": {
      position: "relative",
      top: "-1px"
    }
  },
  wrapperTitle: {
    zIndex: 2,
    "& h6": {
      marginLeft: e.spacing(1)
    }
  }
})), LV = (e, t, r) => {
  var n, i, o, s, l, c, f, h, g, S, b, p, v;
  if (t) {
    if (((i = (n = e == null ? void 0 : e.data) == null ? void 0 : n.tabs) == null ? void 0 : i.length) !== ((s = (o = t.data) == null ? void 0 : o.tabs) == null ? void 0 : s.length)) {
      if (((l = e.data) == null ? void 0 : l.tabs.length) < ((f = (c = t.data) == null ? void 0 : c.tabs) == null ? void 0 : f.length)) {
        const C = ((h = e.data) == null ? void 0 : h.tabs.length) - ((S = (g = t.data) == null ? void 0 : g.tabs) == null ? void 0 : S.length);
        return {
          label: "Suppression d'un ou de plusieurs section(s)",
          value: `${C} ${Po(
            "contenu",
            C
          )} ${Po("suprimé", C)}`
        };
      }
      const w = ((b = e.data) == null ? void 0 : b.tabs.length) - ((v = (p = t.data) == null ? void 0 : p.tabs) == null ? void 0 : v.length);
      return {
        label: "Ajout d'un ou de plusieurs contenu(s)",
        value: `${w} ${Po(
          "contenu",
          w
        )} ${Po("ajouté", w)}`
      };
    }
  } else return {
    label: r,
    value: _c(new Date(e.createdAt), "dd/MM/yyyy à HH:mm", {
      locale: Df
    })
  };
  return {};
}, nZ = ({
  histories: e,
  historyCount: t,
  loading: r,
  title: n = "Historique des modifications",
  historyLabel: i = "sur cet article",
  createLabel: o = "Création de l'article",
  historyInfosFn: s = LV
}) => {
  const l = kV();
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      Ka,
      {
        className: l.wrapperTitle,
        color: "inherit",
        position: "static",
        children: /* @__PURE__ */ y.jsx(ca, { children: /* @__PURE__ */ y.jsx(Lt, { variant: "h6", children: n }) })
      }
    ),
    /* @__PURE__ */ y.jsx(Ao, { className: l.wrapperContent, children: /* @__PURE__ */ y.jsx(zt, { className: l.wrapperInnerContent, children: r ? /* @__PURE__ */ y.jsx(jV, {}) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      /* @__PURE__ */ y.jsxs(zt, { className: l.wrapperHead, children: [
        /* @__PURE__ */ y.jsx(CN, { color: "primary" }),
        /* @__PURE__ */ y.jsxs(Lt, { children: [
          t,
          " ",
          Po("modification", t),
          " ",
          Po("réalisée", t),
          " ",
          i,
          "."
        ] })
      ] }),
      e.map((c, f) => {
        const { label: h, value: g } = s(
          c,
          e[f + 1],
          o
        ), S = !!(h && g);
        return /* @__PURE__ */ y.jsxs(
          YA,
          {
            classes: { root: l.accordion },
            children: [
              /* @__PURE__ */ y.jsxs(
                KA,
                {
                  expandIcon: /* @__PURE__ */ y.jsx(
                    Nr,
                    {
                      enterDelay: 350,
                      placement: "top",
                      title: "Détails",
                      children: /* @__PURE__ */ y.jsx(_m, {})
                    }
                  ),
                  classes: { content: l.accordionRow },
                  ...!S && {
                    className: l.accordionDisabled
                  },
                  children: [
                    c.user && /* @__PURE__ */ y.jsxs(zt, { children: [
                      /* @__PURE__ */ y.jsx(
                        kc,
                        {
                          sx: { width: 24, height: 24 },
                          src: c.user.avatarUrl || void 0
                        }
                      ),
                      /* @__PURE__ */ y.jsx(Lt, { children: c.user.name || c.user.id })
                    ] }),
                    /* @__PURE__ */ y.jsx(Lt, { children: _c(
                      new Date(c.updatedAt ?? c.createdAt),
                      "dd/MM/yyyy à HH:mm",
                      { locale: Df }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ y.jsx(
                XA,
                {
                  classes: { root: l.accordionDetails },
                  children: /* @__PURE__ */ y.jsx(JA, { children: /* @__PURE__ */ y.jsx(yE, { children: /* @__PURE__ */ y.jsxs(bE, { children: [
                    /* @__PURE__ */ y.jsxs(wf, { children: [
                      /* @__PURE__ */ y.jsxs(_n, { component: "th", scope: "row", children: [
                        /* @__PURE__ */ y.jsx(
                          W0,
                          {
                            color: "primary",
                            fontSize: "small"
                          }
                        ),
                        "Type de modification"
                      ] }),
                      /* @__PURE__ */ y.jsx(
                        _n,
                        {
                          align: "right",
                          component: "th",
                          scope: "row",
                          children: h
                        }
                      )
                    ] }),
                    g && /* @__PURE__ */ y.jsxs(wf, { children: [
                      /* @__PURE__ */ y.jsxs(_n, { component: "th", scope: "row", children: [
                        /* @__PURE__ */ y.jsx(
                          W0,
                          {
                            color: "primary",
                            fontSize: "small"
                          }
                        ),
                        "Nouvelle valeur"
                      ] }),
                      /* @__PURE__ */ y.jsx(
                        _n,
                        {
                          align: "right",
                          component: "th",
                          scope: "row",
                          children: g
                        }
                      )
                    ] })
                  ] }) }) })
                }
              )
            ]
          },
          c.id
        );
      })
    ] }) }) })
  ] });
}, zV = Rt((e) => ({
  toolbar: {
    flex: 1,
    justifyContent: "space-between"
  },
  icon: {
    color: e.palette.common.white
  },
  gridList: {
    height: "calc(100vh - 64px)",
    backgroundColor: "black"
  },
  gridItem: {
    height: "100%",
    border: `1px solid ${e.palette.grey[700]}`,
    "&:nth-child(n+4)": {
      borderTop: `1px solid ${e.palette.grey[700]}`
    },
    position: "relative"
  },
  gridItemHalfHeight: {
    height: "50%"
  },
  itemContent: {
    height: "100%"
  },
  itemActions: {
    position: "absolute",
    top: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    padding: e.spacing(1)
  },
  itemAction: {
    marginLeft: e.spacing(1)
  }
})), iZ = ({
  images: e,
  onClose: t,
  actionsRenderer: r
}) => {
  const n = zV(), [i, o] = Xe(void 0), [s, l] = Xe([]), c = e.filter(
    ({ id: f }) => !s.includes(f)
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Ka, { position: "relative", children: /* @__PURE__ */ y.jsxs(ca, { className: n.toolbar, children: [
      /* @__PURE__ */ y.jsx(Lt, { variant: "h6", children: "Comparer les images" }),
      /* @__PURE__ */ y.jsx(fr, { onClick: t, className: n.icon, size: "large", children: /* @__PURE__ */ y.jsx(ql, {}) })
    ] }) }),
    /* @__PURE__ */ y.jsx(Dn, { container: !0, spacing: 0, className: n.gridList, children: c.map((f, h) => /* @__PURE__ */ y.jsx(
      Dn,
      {
        item: !0,
        xs: c.length <= 2 ? 6 : 4,
        className: nt(
          n.gridItem,
          c.length > 3 && n.gridItemHalfHeight
        ),
        children: /* @__PURE__ */ y.jsxs(
          "div",
          {
            className: n.itemContent,
            onMouseOver: () => o(f.id),
            onMouseLeave: () => o((g) => g === f.id ? void 0 : g),
            children: [
              /* @__PURE__ */ y.jsx(
                qc,
                {
                  src: f.src,
                  timeout: f.timeout,
                  fallbacks: f.fallbacks,
                  fitting: "contain"
                }
              ),
              i === f.id && /* @__PURE__ */ y.jsxs("div", { className: n.itemActions, children: [
                r == null ? void 0 : r(f, h),
                c.length > 2 && /* @__PURE__ */ y.jsx(
                  Nr,
                  {
                    title: "Retirer de la comparaison",
                    className: n.itemAction,
                    children: /* @__PURE__ */ y.jsx(
                      fr,
                      {
                        className: n.icon,
                        onClick: () => l((g) => [...g, f.id]),
                        children: /* @__PURE__ */ y.jsx(TN, {})
                      }
                    )
                  }
                )
              ] })
            ]
          }
        )
      },
      f.id
    )) })
  ] });
};
var Sg, K_;
function BV() {
  if (K_) return Sg;
  K_ = 1;
  var e = "Expected a function", t = NaN, r = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, l = parseInt, c = typeof xi == "object" && xi && xi.Object === Object && xi, f = typeof self == "object" && self && self.Object === Object && self, h = c || f || Function("return this")(), g = Object.prototype, S = g.toString, b = Math.max, p = Math.min, v = function() {
    return h.Date.now();
  };
  function w(z, B, K) {
    var Z, ee, he, _e, Te, fe, Oe = 0, ye = !1, de = !1, ce = !0;
    if (typeof z != "function")
      throw new TypeError(e);
    B = W(B) || 0, C(K) && (ye = !!K.leading, de = "maxWait" in K, he = de ? b(W(K.maxWait) || 0, B) : he, ce = "trailing" in K ? !!K.trailing : ce);
    function Fe(Ce) {
      var X = Z, ie = ee;
      return Z = ee = void 0, Oe = Ce, _e = z.apply(ie, X), _e;
    }
    function le(Ce) {
      return Oe = Ce, Te = setTimeout(be, B), ye ? Fe(Ce) : _e;
    }
    function J(Ce) {
      var X = Ce - fe, ie = Ce - Oe, Ie = B - X;
      return de ? p(Ie, he - ie) : Ie;
    }
    function re(Ce) {
      var X = Ce - fe, ie = Ce - Oe;
      return fe === void 0 || X >= B || X < 0 || de && ie >= he;
    }
    function be() {
      var Ce = v();
      if (re(Ce))
        return Me(Ce);
      Te = setTimeout(be, J(Ce));
    }
    function Me(Ce) {
      return Te = void 0, ce && Z ? Fe(Ce) : (Z = ee = void 0, _e);
    }
    function Ae() {
      Te !== void 0 && clearTimeout(Te), Oe = 0, Z = fe = ee = Te = void 0;
    }
    function Re() {
      return Te === void 0 ? _e : Me(v());
    }
    function Ee() {
      var Ce = v(), X = re(Ce);
      if (Z = arguments, ee = this, fe = Ce, X) {
        if (Te === void 0)
          return le(fe);
        if (de)
          return Te = setTimeout(be, B), Fe(fe);
      }
      return Te === void 0 && (Te = setTimeout(be, B)), _e;
    }
    return Ee.cancel = Ae, Ee.flush = Re, Ee;
  }
  function C(z) {
    var B = typeof z;
    return !!z && (B == "object" || B == "function");
  }
  function M(z) {
    return !!z && typeof z == "object";
  }
  function L(z) {
    return typeof z == "symbol" || M(z) && S.call(z) == r;
  }
  function W(z) {
    if (typeof z == "number")
      return z;
    if (L(z))
      return t;
    if (C(z)) {
      var B = typeof z.valueOf == "function" ? z.valueOf() : z;
      z = C(B) ? B + "" : B;
    }
    if (typeof z != "string")
      return z === 0 ? z : +z;
    z = z.replace(n, "");
    var K = o.test(z);
    return K || s.test(z) ? l(z.slice(2), K ? 2 : 8) : i.test(z) ? t : +z;
  }
  return Sg = w, Sg;
}
var FV = BV();
const WV = /* @__PURE__ */ jr(FV);
var Eg, X_;
function HV() {
  if (X_) return Eg;
  X_ = 1;
  var e = "Expected a function", t = NaN, r = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, l = parseInt, c = typeof xi == "object" && xi && xi.Object === Object && xi, f = typeof self == "object" && self && self.Object === Object && self, h = c || f || Function("return this")(), g = Object.prototype, S = g.toString, b = Math.max, p = Math.min, v = function() {
    return h.Date.now();
  };
  function w(B, K, Z) {
    var ee, he, _e, Te, fe, Oe, ye = 0, de = !1, ce = !1, Fe = !0;
    if (typeof B != "function")
      throw new TypeError(e);
    K = z(K) || 0, M(Z) && (de = !!Z.leading, ce = "maxWait" in Z, _e = ce ? b(z(Z.maxWait) || 0, K) : _e, Fe = "trailing" in Z ? !!Z.trailing : Fe);
    function le(X) {
      var ie = ee, Ie = he;
      return ee = he = void 0, ye = X, Te = B.apply(Ie, ie), Te;
    }
    function J(X) {
      return ye = X, fe = setTimeout(Me, K), de ? le(X) : Te;
    }
    function re(X) {
      var ie = X - Oe, Ie = X - ye, xe = K - ie;
      return ce ? p(xe, _e - Ie) : xe;
    }
    function be(X) {
      var ie = X - Oe, Ie = X - ye;
      return Oe === void 0 || ie >= K || ie < 0 || ce && Ie >= _e;
    }
    function Me() {
      var X = v();
      if (be(X))
        return Ae(X);
      fe = setTimeout(Me, re(X));
    }
    function Ae(X) {
      return fe = void 0, Fe && ee ? le(X) : (ee = he = void 0, Te);
    }
    function Re() {
      fe !== void 0 && clearTimeout(fe), ye = 0, ee = Oe = he = fe = void 0;
    }
    function Ee() {
      return fe === void 0 ? Te : Ae(v());
    }
    function Ce() {
      var X = v(), ie = be(X);
      if (ee = arguments, he = this, Oe = X, ie) {
        if (fe === void 0)
          return J(Oe);
        if (ce)
          return fe = setTimeout(Me, K), le(Oe);
      }
      return fe === void 0 && (fe = setTimeout(Me, K)), Te;
    }
    return Ce.cancel = Re, Ce.flush = Ee, Ce;
  }
  function C(B, K, Z) {
    var ee = !0, he = !0;
    if (typeof B != "function")
      throw new TypeError(e);
    return M(Z) && (ee = "leading" in Z ? !!Z.leading : ee, he = "trailing" in Z ? !!Z.trailing : he), w(B, K, {
      leading: ee,
      maxWait: K,
      trailing: he
    });
  }
  function M(B) {
    var K = typeof B;
    return !!B && (K == "object" || K == "function");
  }
  function L(B) {
    return !!B && typeof B == "object";
  }
  function W(B) {
    return typeof B == "symbol" || L(B) && S.call(B) == r;
  }
  function z(B) {
    if (typeof B == "number")
      return B;
    if (W(B))
      return t;
    if (M(B)) {
      var K = typeof B.valueOf == "function" ? B.valueOf() : B;
      B = M(K) ? K + "" : K;
    }
    if (typeof B != "string")
      return B === 0 ? B : +B;
    B = B.replace(n, "");
    var Z = o.test(B);
    return Z || s.test(B) ? l(B.slice(2), Z ? 2 : 8) : i.test(B) ? t : +B;
  }
  return Eg = C, Eg;
}
var $V = HV();
const UV = /* @__PURE__ */ jr($V);
var Qv = function(e, t) {
  return Qv = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) n.hasOwnProperty(i) && (r[i] = n[i]);
  }, Qv(e, t);
};
function GV(e, t) {
  Qv(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var em = function() {
  return em = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, em.apply(this, arguments);
};
function qV(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
var zT = function(e, t, r, n) {
  switch (t) {
    case "debounce":
      return WV(e, r, n);
    case "throttle":
      return UV(e, r, n);
    default:
      return e;
  }
}, tm = function(e) {
  return typeof e == "function";
}, Aa = function() {
  return typeof window > "u";
}, J_ = function(e) {
  return e instanceof Element || e instanceof HTMLDocument;
}, BT = function(e, t, r, n) {
  return function(i) {
    var o = i.width, s = i.height;
    t(function(l) {
      return l.width === o && l.height === s || l.width === o && !n || l.height === s && !r ? l : (e && tm(e) && e(o, s), { width: o, height: s });
    });
  };
};
(function(e) {
  GV(t, e);
  function t(r) {
    var n = e.call(this, r) || this;
    n.cancelHandler = function() {
      n.resizeHandler && n.resizeHandler.cancel && (n.resizeHandler.cancel(), n.resizeHandler = null);
    }, n.attachObserver = function() {
      var f = n.props, h = f.targetRef, g = f.observerOptions;
      if (!Aa()) {
        h && h.current && (n.targetRef.current = h.current);
        var S = n.getElement();
        S && (n.observableElement && n.observableElement === S || (n.observableElement = S, n.resizeObserver.observe(S, g)));
      }
    }, n.getElement = function() {
      var f = n.props, h = f.querySelector, g = f.targetDomEl;
      if (Aa())
        return null;
      if (h)
        return document.querySelector(h);
      if (g && J_(g))
        return g;
      if (n.targetRef && J_(n.targetRef.current))
        return n.targetRef.current;
      var S = ej(n);
      if (!S)
        return null;
      var b = n.getRenderType();
      switch (b) {
        case "renderProp":
          return S;
        case "childFunction":
          return S;
        case "child":
          return S;
        case "childArray":
          return S;
        default:
          return S.parentElement;
      }
    }, n.createResizeHandler = function(f) {
      var h = n.props, g = h.handleWidth, S = g === void 0 ? !0 : g, b = h.handleHeight, p = b === void 0 ? !0 : b, v = h.onResize;
      if (!(!S && !p)) {
        var w = BT(v, n.setState.bind(n), S, p);
        f.forEach(function(C) {
          var M = C && C.contentRect || {}, L = M.width, W = M.height, z = !n.skipOnMount && !Aa();
          z && w({ width: L, height: W }), n.skipOnMount = !1;
        });
      }
    }, n.getRenderType = function() {
      var f = n.props, h = f.render, g = f.children;
      return tm(h) ? "renderProp" : tm(g) ? "childFunction" : oc(g) ? "child" : Array.isArray(g) ? "childArray" : "parent";
    };
    var i = r.skipOnMount, o = r.refreshMode, s = r.refreshRate, l = s === void 0 ? 1e3 : s, c = r.refreshOptions;
    return n.state = {
      width: void 0,
      height: void 0
    }, n.skipOnMount = i, n.targetRef = AA(), n.observableElement = null, Aa() || (n.resizeHandler = zT(n.createResizeHandler, o, l, c), n.resizeObserver = new window.ResizeObserver(n.resizeHandler)), n;
  }
  return t.prototype.componentDidMount = function() {
    this.attachObserver();
  }, t.prototype.componentDidUpdate = function() {
    this.attachObserver();
  }, t.prototype.componentWillUnmount = function() {
    Aa() || (this.resizeObserver.disconnect(), this.cancelHandler());
  }, t.prototype.render = function() {
    var r = this.props, n = r.render, i = r.children, o = r.nodeType, s = o === void 0 ? "div" : o, l = this.state, c = l.width, f = l.height, h = { width: c, height: f, targetRef: this.targetRef }, g = this.getRenderType(), S;
    switch (g) {
      case "renderProp":
        return n && n(h);
      case "childFunction":
        return S = i, S(h);
      case "child":
        if (S = i, S.type && typeof S.type == "string") {
          h.targetRef;
          var b = qV(h, ["targetRef"]);
          return Ns(S, b);
        }
        return Ns(S, h);
      case "childArray":
        return S = i, S.map(function(p) {
          return !!p && Ns(p, h);
        });
      default:
        return Be.createElement(s, null);
    }
  }, t;
})(NA);
var VV = Aa() ? pt : um;
function YV(e) {
  e === void 0 && (e = {});
  var t = e.skipOnMount, r = t === void 0 ? !1 : t, n = e.refreshMode, i = e.refreshRate, o = i === void 0 ? 1e3 : i, s = e.refreshOptions, l = e.handleWidth, c = l === void 0 ? !0 : l, f = e.handleHeight, h = f === void 0 ? !0 : f, g = e.targetRef, S = e.observerOptions, b = e.onResize, p = bt(r), v = bt(null), w = g ?? v, C = bt(), M = Xe({
    width: void 0,
    height: void 0
  }), L = M[0], W = M[1];
  return VV(function() {
    if (!Aa()) {
      var z = BT(b, W, c, h), B = function(Z) {
        !c && !h || Z.forEach(function(ee) {
          var he = ee && ee.contentRect || {}, _e = he.width, Te = he.height, fe = !p.current && !Aa();
          fe && z({ width: _e, height: Te }), p.current = !1;
        });
      };
      C.current = zT(B, n, o, s);
      var K = new window.ResizeObserver(C.current);
      return w.current && K.observe(w.current, S), function() {
        K.disconnect();
        var Z = C.current;
        Z && Z.cancel && Z.cancel();
      };
    }
  }, [n, o, s, c, h, b, S, w.current]), em({ ref: w }, L);
}
const KV = "Charger plus de résultats", XV = 155, JV = 130, FT = Rt((e) => ({
  centered: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    textAlign: "center"
  },
  errorIcon: {
    marginRight: e.spacing(2)
  },
  list: {
    outline: 0
  },
  wrapperLoadMore: {
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "center",
    paddingBottom: "20px",
    minHeight: "180px",
    paddingTop: "20px",
    "& > button": {
      marginTop: e.spacing(3)
    }
  },
  wrapper: {
    height: "100%",
    paddingTop: "10px"
  },
  heading: {
    paddingLeft: e.spacing(3),
    minHeight: "40px"
  },
  rowItem: {
    height: "100%"
  },
  headerText: () => ({
    left: `${XV}px`,
    top: `calc(${JV}px + ${e.spacing(
      4
    )})`,
    zIndex: 2,
    backgroundColor: e.palette.grey[100]
  }),
  multiMediaListHeaderTitle: {
    color: e.palette.common.black,
    fontWeight: 500,
    textTransform: "uppercase"
  }
}));
var ZV = /* @__PURE__ */ ((e) => (e.HEADING = "HEADING", e.ARTICLE = "ARTICLE", e))(ZV || {}), QV = /* @__PURE__ */ ((e) => (e.AUTO = "AUTO", e.HYBRIDE = "HYBRIDE", e.MANUAL = "MANUAL", e))(QV || {});
const e8 = ({ title: e }) => {
  const t = FT();
  return /* @__PURE__ */ y.jsx(Lt, { variant: "body2", className: t.headerText, gutterBottom: !0, children: /* @__PURE__ */ y.jsx("span", { className: t.multiMediaListHeaderTitle, children: e }) });
}, t8 = ({
  className: e,
  draggable: t,
  error: r,
  fetchMore: n,
  list: i = [],
  loading: o,
  mode: s = "AUTO",
  rowHeight: l,
  rowRenderer: c,
  threshold: f,
  hasNextPage: h = !0,
  rowCount: g
}) => {
  const S = FT(), b = dt.useRef(null), [p, v] = Xe(
    s === "AUTO" && !!n
  );
  if (pt(() => {
    var z;
    p && ((z = b.current) == null || z.resetLoadMoreRowsCache(!0));
  }, [p]), !i || !i.length || r)
    return /* @__PURE__ */ y.jsx("div", { className: S.centered, children: o ? /* @__PURE__ */ y.jsx(un, { color: "primary", size: 80 }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      r && /* @__PURE__ */ y.jsx(
        rp,
        {
          className: S.errorIcon,
          color: "primary",
          fontSize: "large"
        }
      ),
      /* @__PURE__ */ y.jsx(Lt, { variant: "h4", color: "primary", children: r ? r.message ? r.message : "Une erreur est survenue" : "Pas de résultat" })
    ] }) });
  const w = g ?? i.length + (h ? 1 : 0), C = async (z) => {
    (!p || !n ? () => Promise.resolve() : n)(z).finally(() => {
      v(
        s === "AUTO"
        /* AUTO */
      );
    });
  }, M = ({ index: z }) => z < i.length, L = ({ index: z }) => {
    var B;
    return ((B = i[z]) == null ? void 0 : B.height) ?? l;
  }, W = () => /* @__PURE__ */ y.jsx(
    co.InfiniteLoader,
    {
      ref: b,
      isRowLoaded: M,
      loadMoreRows: C,
      rowCount: w,
      threshold: f,
      children: ({ onRowsRendered: z, registerChild: B }) => /* @__PURE__ */ y.jsx(co.AutoSizer, { children: ({ width: K, height: Z }) => /* @__PURE__ */ y.jsx(
        co.List,
        {
          width: K,
          height: Z,
          onRowsRendered: z,
          ref: B,
          rowCount: w,
          rowHeight: s === "AUTO" ? l : L,
          className: nt(S.list, e),
          rowRenderer: ({ key: ee, index: he, style: _e }) => /* @__PURE__ */ y.jsx("div", { style: _e, children: M({ index: he }) ? i[he].type === "HEADING" ? /* @__PURE__ */ y.jsx("div", { className: S.heading, children: /* @__PURE__ */ y.jsx(
            e8,
            {
              title: i[he].text
            }
          ) }) : /* @__PURE__ */ y.jsx(zt, { className: S.rowItem, children: t ? /* @__PURE__ */ y.jsx(
            Cy,
            {
              draggableId: ee,
              index: he,
              isDragDisabled: t.isDragDisabled,
              children: (Te) => /* @__PURE__ */ y.jsx(
                "div",
                {
                  ref: Te.innerRef,
                  ...Te.draggableProps,
                  ...Te.dragHandleProps,
                  children: c(i[he], he)
                }
              )
            }
          ) : c(i[he], he) }, ee) : o ? /* @__PURE__ */ y.jsx(zt, { children: /* @__PURE__ */ y.jsx("div", { className: S.centered, children: /* @__PURE__ */ y.jsx(
            un,
            {
              color: "primary",
              size: Math.min(80, l / 2)
            }
          ) }) }, ee) : s !== "AUTO" && h ? /* @__PURE__ */ y.jsx("div", { className: S.wrapperLoadMore, children: /* @__PURE__ */ y.jsx(zt, { children: /* @__PURE__ */ y.jsx(
            Fr,
            {
              onClick: () => {
                v(!0);
              },
              variant: "outlined",
              children: KV
            }
          ) }) }, ee) : null })
        }
      ) })
    }
  );
  return t ? /* @__PURE__ */ y.jsx(
    bp,
    {
      ...t,
      mode: "virtual",
      renderClone: (z, B, K) => /* @__PURE__ */ y.jsx(
        "div",
        {
          ref: z.innerRef,
          ...z.draggableProps,
          ...z.dragHandleProps,
          children: c(i[K.source.index], K.source.index)
        }
      ),
      children: (z) => /* @__PURE__ */ y.jsx("div", { ref: z.innerRef, className: S.wrapper, children: W() })
    }
  ) : W();
}, r8 = Rt(() => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    width: 200
  }
})), n8 = ({
  min: e,
  max: t,
  marks: r,
  value: n,
  onChange: i,
  className: o
}) => {
  const s = r8(), l = (h, g) => i(-g), c = () => i(Math.min(n + 1, t)), f = () => i(Math.max(n - 1, e));
  return /* @__PURE__ */ y.jsxs("div", { className: nt(o, s.wrapper), children: [
    /* @__PURE__ */ y.jsx(Nr, { title: "Rétrécir", children: /* @__PURE__ */ y.jsx(fr, { onClick: c, disabled: n >= t, children: /* @__PURE__ */ y.jsx(ON, {}) }) }),
    /* @__PURE__ */ y.jsx(
      ZA,
      {
        min: -t,
        max: -e,
        marks: r,
        value: -n,
        onChange: l,
        scale: (h) => -h
      }
    ),
    /* @__PURE__ */ y.jsx(Nr, { title: "Agrandir", children: /* @__PURE__ */ y.jsx(fr, { onClick: f, disabled: n <= e, children: /* @__PURE__ */ y.jsx(RN, {}) }) })
  ] });
}, Ny = 40, i8 = Rt((e) => ({
  item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  },
  itemSelected: ({ colors: t }) => ({
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      border: `4px solid ${t == null ? void 0 : t.selected}`,
      pointerEvents: "none",
      zIndex: 1
    }
  }),
  actionArea: {
    flex: 1,
    height: 0
  },
  media: {
    backgroundColor: e.palette.mode === "light" ? e.palette.grey[200] : e.palette.grey[800]
  },
  infos: {
    flexShrink: 0,
    flexBasis: Ny,
    overflow: "hidden"
  }
})), WT = ({
  className: e,
  selected: t,
  onClick: r,
  onDoubleClick: n,
  src: i,
  timeout: o,
  fallbacks: s,
  infos: l,
  colors: c,
  sx: f
}) => {
  c = {
    selected: zo().palette.primary.main,
    ...c
  };
  const g = i8({ colors: c });
  return /* @__PURE__ */ y.jsxs(
    Bo,
    {
      className: nt(
        g.item,
        t && g.itemSelected,
        e
      ),
      sx: f,
      children: [
        /* @__PURE__ */ y.jsx(
          QA,
          {
            className: g.actionArea,
            onClick: r,
            onDoubleClick: n,
            disabled: !r && !n,
            children: /* @__PURE__ */ y.jsx(
              qc,
              {
                src: i,
                className: g.media,
                fitting: "contain",
                timeout: o,
                fallbacks: s
              }
            )
          }
        ),
        l && /* @__PURE__ */ y.jsx(vm, { className: g.infos, children: l })
      ]
    }
  );
}, o8 = 48, a8 = Rt((e) => ({
  wrapper: {
    height: "100%",
    backgroundColor: e.palette.background.default
  },
  count: {
    color: e.palette.primary.main,
    flexShrink: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginRight: e.spacing(3)
  },
  slider: {
    marginLeft: "auto"
  },
  listWrapper: ({ displayToolbar: t }) => ({
    height: `calc(100% - ${t ? o8 : 0}px)`
  }),
  row: {
    display: "flex",
    width: "100%",
    height: `calc(100% - ${e.spacing(2)})`,
    alignItems: "stretch",
    padding: e.spacing(0, 2)
  },
  item: ({ itemNumberPerRow: t }) => ({
    width: `calc(${100 / t}% - ${Sf(e, 2) * (t - 1) / t}px)`,
    marginRight: e.spacing(2),
    "&:last-child": {
      marginRight: 0
    },
    position: "relative"
  }),
  itemDragging: {
    opacity: 0.2
  },
  dropZone: {
    position: "absolute",
    top: `calc(-1 * ${e.spacing(1)})`,
    bottom: `calc(-1 * ${e.spacing(1)})`
  },
  dropZoneLeft: {
    left: `calc(-1 * ${e.spacing(1)})`,
    right: "50%"
  },
  dropZoneRight: {
    left: "50%",
    right: `calc(-1 * ${e.spacing(1)})`
  },
  dropIndicator: ({ colors: t }) => ({
    position: "absolute",
    top: 0,
    bottom: 0,
    width: 4,
    backgroundColor: t.dropIndicator,
    borderRadius: 2,
    pointerEvents: "none"
  }),
  dropIndicatorLeft: {
    left: `calc(-1 * ${e.spacing(1)} - 2px)`
  },
  dropIndicatorRight: {
    right: `calc(-1 * ${e.spacing(1)} - 2px)`
  },
  galleryItem: {
    height: "100%"
  }
})), HT = 0.9, s8 = 500, Z_ = "GALLERY_ITEMS_PER_ROW", oZ = ({
  list: e,
  loading: t,
  error: r,
  fetchMore: n,
  threshold: i,
  count: o,
  infoRenderer: s,
  onItemDoubleClick: l,
  onItemReorder: c,
  selectedItems: f,
  setSelectedItems: h,
  itemsPerRow: g = {
    default: 6,
    min: 4,
    max: 8
  },
  setItemDragging: S,
  colors: b,
  additionalElement: p
}) => {
  const v = zo();
  b = {
    dropIndicator: v.palette.primary.main,
    ...b
  };
  const [w, C] = Xe(() => en.get(Z_) ?? g.default), [M, L] = Xe(), { width: W, ref: z } = YV(), B = !r && !!(e != null && e.length), K = a8({
    itemNumberPerRow: w,
    displayToolbar: B,
    colors: b
  }), [Z, ee] = Xe(), he = bt(void 0), _e = kt(
    () => ((W || 0) - Sf(v, 2) * (w + 1)) / w * HT + Ny + Sf(v, 2),
    [W, w, v]
  ), Te = Kt(() => {
    L(void 0), S == null || S(void 0, void 0);
  }, [L, S]), fe = Kt(
    (le) => {
      if ((f == null ? void 0 : f.length) === 1 && ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(le.key)) {
        le.preventDefault();
        const J = e == null ? void 0 : e.findIndex(
          ({ id: be }) => be === f[0]
        );
        if (J === void 0) return;
        let re = J;
        switch (le.key) {
          case "ArrowRight":
            re = J + 1;
            break;
          case "ArrowLeft":
            re = J - 1;
            break;
          case "ArrowUp":
            re = (Math.floor(J / w) - 1) * w + J % w;
            break;
          case "ArrowDown":
            re = (Math.floor(J / w) + 1) * w + J % w;
            break;
        }
        e != null && e[re] && (h == null || h([e == null ? void 0 : e[re].id]));
      }
    },
    [f, e, h, w]
  );
  pt(() => (document.addEventListener("dragend", Te), () => {
    document.removeEventListener("dragend", Te);
  }), [Te]), pt(() => (he.current = window.setTimeout(() => {
    ee(f);
  }, s8), () => clearTimeout(he.current)), [f]);
  const Oe = kt(
    () => e == null ? void 0 : e.reduce((le, J, re) => {
      if (re % w === 0)
        return [...le, [J]];
      const be = [...le];
      return be[be.length - 1].push(J), be;
    }, []),
    [e, w]
  ), ye = (le, J, re) => {
    if (!(!h || !e)) {
      if (re.metaKey || re.ctrlKey) {
        if (f != null && f.includes(le)) {
          h((be) => be.filter((Me) => Me !== le));
          return;
        }
        h((be) => [...be, le]);
        return;
      }
      if (re.shiftKey) {
        const be = f ? e.findIndex(
          ({ id: Re }) => f[f.length - 1] === Re
        ) : 0, Me = be > 0 ? be : 0, Ae = e.slice(
          Math.min(Me, J),
          Math.max(Me, J) + 1
        );
        h((Re) => [
          ...Re,
          ...Ae.map(({ id: Ee }) => Ee).filter((Ee) => !Re.includes(Ee))
        ]);
        return;
      }
      if (f != null && f.includes(le)) {
        h((be) => be.length > 1 ? [le] : []);
        return;
      }
      h([le]);
    }
  }, de = (le, J) => {
    c && L((re) => {
      if (!re) return re;
      const be = (M == null ? void 0 : M.ids.map((Ae) => e == null ? void 0 : e.findIndex((Re) => Re.id === Ae)).filter(Ll)) || [], Me = (e == null ? void 0 : e.findIndex((Ae) => Ae.id === J)) || -1;
      return {
        ...re,
        hover: !(M != null && M.ids.includes(J)) && !be.includes(Me + (le === "left" ? -1 : 1)) ? {
          id: J,
          side: le
        } : void 0
      };
    });
  }, ce = () => {
    const le = M == null ? void 0 : M.hover;
    if (!le) return;
    const J = M.ids.map((be) => e == null ? void 0 : e.findIndex((Me) => Me.id === be)).filter(Ll) || [], re = (e == null ? void 0 : e.findIndex((be) => be.id === le.id)) || -1;
    !M.ids.includes(le.id) && !J.includes(re + (le.side === "left" ? -1 : 1)) && (c == null || c(
      M.ids.map((be, Me) => {
        const Ae = (e == null ? void 0 : e.findIndex((Ee) => Ee.id === be)) || -1, Re = M.ids.slice(0, Me).filter((Ee) => ((e == null ? void 0 : e.findIndex((X) => X.id === Ee)) || -1) > re);
        return {
          id: be,
          newIndex: Ae < re ? re + (le.side === "left" ? -1 : 0) : re + (le.side === "left" ? 0 : 1) + Re.length
        };
      })
    ), Te());
  }, Fe = ((e == null ? void 0 : e.length) ?? 0) < (o ?? ((e == null ? void 0 : e.length) ?? 0) + 1);
  return /* @__PURE__ */ y.jsxs("div", { className: K.wrapper, children: [
    B && /* @__PURE__ */ y.jsxs(ca, { variant: "dense", children: [
      !!o && /* @__PURE__ */ y.jsxs(Lt, { className: K.count, children: [
        o,
        " ",
        Po("image", o)
      ] }),
      p,
      /* @__PURE__ */ y.jsx(
        n8,
        {
          min: g.min,
          max: g.max,
          value: w,
          onChange: (le) => {
            C(le), en.set(Z_, le);
          },
          className: K.slider
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx(
      "div",
      {
        className: K.listWrapper,
        ref: z,
        onDrop: ce,
        onDragOver: (le) => {
          M != null && M.hover && (le.stopPropagation(), le.preventDefault());
        },
        onKeyDown: fe,
        children: /* @__PURE__ */ y.jsx(
          t8,
          {
            list: Oe,
            rowRenderer: (le, J) => /* @__PURE__ */ y.jsx("div", { className: K.row, children: le.map((re, be) => {
              var Ee, Ce, X, ie;
              const Me = f == null ? void 0 : f.includes(re.id), Ae = J * w + be, Re = M == null ? void 0 : M.ids.includes(re.id);
              return /* @__PURE__ */ y.jsxs(
                "div",
                {
                  className: nt(
                    K.item,
                    Re && K.itemDragging
                  ),
                  draggable: !!c || !!S,
                  onDragStart: (Ie) => {
                    c && L({
                      ids: f != null && f.includes(re.id) ? f : [re.id]
                    }), S == null || S(re, Ie);
                  },
                  children: [
                    /* @__PURE__ */ y.jsx(
                      WT,
                      {
                        colors: b,
                        src: re.src,
                        timeout: re.timeout,
                        fallbacks: re.fallbacks,
                        className: K.galleryItem,
                        infos: s == null ? void 0 : s(re, Ae),
                        onClick: (Ie) => ye(re.id, Ae, Ie),
                        onDoubleClick: (Ie) => {
                          l && (Z && (h == null || h(Z)), window.clearTimeout(he.current), l(re, Ae, Ie));
                        },
                        selected: Me
                      }
                    ),
                    M && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                      /* @__PURE__ */ y.jsx(
                        "div",
                        {
                          className: nt(
                            K.dropZone,
                            K.dropZoneLeft
                          ),
                          onDragEnter: () => de("left", re.id)
                        }
                      ),
                      /* @__PURE__ */ y.jsx(
                        "div",
                        {
                          className: nt(
                            K.dropZone,
                            K.dropZoneRight
                          ),
                          onDragEnter: () => de("right", re.id)
                        }
                      ),
                      ((Ee = M.hover) == null ? void 0 : Ee.id) === re.id && ((Ce = M.hover) == null ? void 0 : Ce.side) === "left" && /* @__PURE__ */ y.jsx(
                        "div",
                        {
                          className: nt(
                            K.dropIndicator,
                            K.dropIndicatorLeft
                          )
                        }
                      ),
                      ((X = M.hover) == null ? void 0 : X.id) === re.id && ((ie = M.hover) == null ? void 0 : ie.side) === "right" && /* @__PURE__ */ y.jsx(
                        "div",
                        {
                          className: nt(
                            K.dropIndicator,
                            K.dropIndicatorRight
                          )
                        }
                      )
                    ] })
                  ]
                },
                re.id
              );
            }) }),
            rowHeight: _e,
            threshold: i && Math.round(i / w),
            loading: t,
            error: r,
            hasNextPage: Fe,
            fetchMore: n ? ({ startIndex: le, stopIndex: J }) => n({
              startIndex: (le - 1) * w + (Oe ? Oe[Oe.length - 1].length : 0),
              stopIndex: J * w
            }) : void 0
          }
        )
      }
    )
  ] });
}, Q_ = 200, l8 = Rt((e) => ({
  appBar: ({ displayed: t, paddingTop: r, colors: n, smallScreen: i }) => ({
    top: (i ? 56 : 64) + r - (t ? 0 : 48),
    transition: t ? "top 0.3s" : "top 0.3s, opacity 0s 0.3s",
    backgroundColor: n.background,
    opacity: t ? 1 : 0,
    overflowX: "auto",
    zIndex: e.zIndex.appBar - 1
  }),
  icon: ({ colors: t }) => ({
    color: an(t.content || "", 0.7)
  }),
  action: ({ colors: t }) => ({
    color: t.action,
    margin: e.spacing(0, 0.5)
  }),
  actionDisabled: ({ colors: t }) => ({
    color: `${an(t.action || "", 0.3)} !important`
  }),
  text: ({ colors: t }) => ({
    margin: e.spacing(0, 2),
    color: an(t.content || "", 0.7),
    whiteSpace: "nowrap",
    overflow: "hidden",
    flexShrink: 1
  }),
  selectionWrapper: ({ paddingTop: t, colors: r }) => ({
    width: "100%",
    display: "flex",
    overflowX: "auto",
    position: "fixed",
    top: 112 + t,
    [e.breakpoints.down("sm")]: {
      top: 104 + t
    },
    zIndex: e.zIndex.drawer - 1,
    padding: e.spacing(2, 0, 2, 2),
    backgroundColor: r.background,
    borderTop: `1px solid ${an(r.divider || "", 0.3)}`
  }),
  actions: {
    marginLeft: "auto",
    display: "flex"
  },
  badge: ({ colors: t }) => ({
    backgroundColor: t.content,
    color: t.background,
    borderColor: t.background,
    borderWidth: 1,
    borderStyle: "solid"
  }),
  divider: ({ colors: t }) => ({
    backgroundColor: an(t.divider || "", 0.2),
    alignSelf: "center",
    height: 30,
    margin: e.spacing(0, 1)
  }),
  additionalElement: {
    marginLeft: e.spacing(2),
    [e.breakpoints.down("sm")]: {
      marginLeft: 0
    }
  }
})), aZ = ({
  selection: e,
  infoRenderer: t,
  onSelectionClear: r,
  onRemoveFromSelection: n,
  paddingTop: i = 0,
  actions: o,
  additionalElement: s,
  colors: l
}) => {
  const c = zo();
  l = {
    content: c.palette.text.primary,
    background: c.palette.background.default,
    divider: c.palette.common.black,
    action: c.palette.primary.main,
    ...l
  };
  const f = sa(c.breakpoints.down("sm")), h = l8({
    displayed: !!(e != null && e.length),
    paddingTop: i,
    colors: l,
    smallScreen: f
  }), [g, S] = Xe(!1);
  return pt(() => {
    e != null && e.length || S(!1);
  }, [e]), /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Ka, { position: "fixed", color: "primary", className: h.appBar, children: /* @__PURE__ */ y.jsxs(ca, { variant: "dense", children: [
      !f && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(Nr, { title: "Annuler la sélection", children: /* @__PURE__ */ y.jsx(fr, { onClick: r, className: h.icon, children: /* @__PURE__ */ y.jsx(gc, {}) }) }),
        /* @__PURE__ */ y.jsxs(
          Lt,
          {
            variant: "h6",
            color: "textPrimary",
            className: h.text,
            children: [
              e == null ? void 0 : e.length,
              " ",
              Po("image", e == null ? void 0 : e.length),
              " ",
              Po("sélectionnée", e == null ? void 0 : e.length)
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(
          Nr,
          {
            title: `${g ? "Cacher" : "Afficher"} la sélection`,
            children: /* @__PURE__ */ y.jsx(
              fr,
              {
                onClick: () => S((b) => !b),
                className: h.icon,
                children: g ? /* @__PURE__ */ y.jsx(_E, {}) : /* @__PURE__ */ y.jsx(_m, {})
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ y.jsx("div", { className: h.actions, children: o == null ? void 0 : o.map(
        (b, p) => b === "divider" ? /* @__PURE__ */ y.jsx(
          hc,
          {
            orientation: "vertical",
            flexItem: !0,
            className: h.divider
          },
          `divider-${p}`
        ) : /* @__PURE__ */ y.jsx(Nr, { title: b.label, children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
          fr,
          {
            "data-testid": `${b.id}-button`,
            classes: {
              root: h.action,
              disabled: h.actionDisabled
            },
            onClick: b.onClick,
            disabled: b.disabled,
            children: /* @__PURE__ */ y.jsx(
              av,
              {
                badgeContent: b.badge,
                classes: { badge: h.badge },
                children: b.icon
              }
            )
          }
        ) }) }, `action-${b.id}`)
      ) }),
      s && /* @__PURE__ */ y.jsx("div", { className: h.additionalElement, children: s })
    ] }) }),
    g && /* @__PURE__ */ y.jsx(Bo, { className: h.selectionWrapper, square: !0, children: e == null ? void 0 : e.map((b, p) => /* @__PURE__ */ y.jsxs(
      zt,
      {
        sx: {
          flexBasis: (Q_ - Ny) / HT,
          flexShrink: 0,
          marginRight: c.spacing(2),
          position: "relative",
          "&:hover .deleteFromSelectionButton": {
            visibility: "visible"
          }
        },
        children: [
          /* @__PURE__ */ y.jsx(
            WT,
            {
              src: b.src,
              timeout: b.timeout,
              fallbacks: b.fallbacks,
              infos: t == null ? void 0 : t(b, p),
              sx: { height: Q_ }
            }
          ),
          n && /* @__PURE__ */ y.jsx(
            fr,
            {
              sx: {
                position: "absolute",
                top: 4,
                right: 4,
                visibility: "hidden",
                bgcolor: an(c.palette.common.black, 0.5),
                color: c.palette.common.white,
                "&:hover": {
                  bgcolor: c.palette.common.black
                }
              },
              size: "small",
              className: "deleteFromSelectionButton",
              onClick: () => n(p),
              children: /* @__PURE__ */ y.jsx(gc, { fontSize: "small" })
            }
          )
        ]
      },
      b.id
    )) })
  ] });
}, jy = Rt((e) => ({
  flexContainer: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box"
  },
  table: {
    // temporary right-to-left patch, waiting for
    // https://github.com/bvaughn/react-virtualized/issues/454
    "& .ReactVirtualized__Table__headerRow": {
      flip: !1,
      paddingRight: e.direction === "rtl" ? "0px !important" : void 0
    }
  },
  tableRow: {
    cursor: "pointer"
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: e.palette.grey[200]
    }
  },
  tableHeaderCell: {
    fontWeight: 800,
    borderBottom: `2px solid ${e.palette.primary.main}`,
    borderRight: "0 !important"
  },
  tableCell: ({ noCellPadding: t }) => ({
    flex: 1,
    padding: t ? 0 : "4px 16px",
    textDecoration: "none",
    borderRight: `1px solid ${e.palette.grey[300]}`,
    overflow: "hidden",
    display: "flex",
    alignItems: "center"
  }),
  noClick: {
    cursor: "initial"
  },
  centered: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    textAlign: "center"
  },
  errorIcon: {
    marginRight: e.spacing(2)
  },
  grid: {
    outline: 0
  }
})), u8 = Rt((e) => ({
  hoverWrapper: {
    position: "absolute",
    right: e.spacing(2),
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center"
  }
})), c8 = ({
  cellData: e,
  columnIndex: t,
  rowData: r,
  columns: n,
  onRowClick: i,
  rowHeight: o,
  rowHoverRenderer: s,
  cellRender: l
}) => {
  const c = jy({
    noCellPadding: !!l
  }), f = u8(), [h, g] = Xe(!1);
  return /* @__PURE__ */ y.jsxs(
    _n,
    {
      align: n[t].alignRight ? "right" : "left",
      className: nt(
        c.tableCell,
        c.flexContainer,
        {
          [c.noClick]: !i && !r.href
        }
      ),
      component: r.href ? "a" : "div",
      style: { height: o },
      variant: "body",
      ...r.href ? { href: r.href } : {},
      onClick: (S) => {
        i == null || i(S, r);
      },
      onMouseEnter: () => g(!0),
      onMouseLeave: () => g(!1),
      children: [
        l || /* @__PURE__ */ y.jsx("span", { children: e }),
        h && s && /* @__PURE__ */ y.jsx("div", { className: f.hoverWrapper, children: s(r) })
      ]
    }
  );
}, d8 = ({
  label: e,
  columnIndex: t,
  headerHeight: r,
  columns: n
}) => {
  const i = jy({});
  return /* @__PURE__ */ y.jsx(
    _n,
    {
      component: "div",
      className: nt(
        i.tableCell,
        i.tableHeaderCell,
        i.flexContainer,
        i.noClick
      ),
      variant: "head",
      style: { height: r },
      align: n[t].alignRight ? "right" : "left",
      children: /* @__PURE__ */ y.jsx("span", { children: e })
    }
  );
}, sZ = ({
  columns: e,
  error: t,
  fetchMore: r,
  headerHeight: n = 48,
  list: i,
  loading: o,
  onRowClick: s,
  rowHoverRenderer: l,
  rowHeight: c = 48,
  style: f,
  threshold: h,
  gridStyle: g
}) => {
  const S = jy({}), b = ({ index: p }) => nt(S.tableRow, S.flexContainer, {
    [S.tableRowHover]: p !== -1 && (s || (i == null ? void 0 : i[p].href))
  });
  return !i || !i.length || t ? /* @__PURE__ */ y.jsx("div", { className: S.centered, children: o ? /* @__PURE__ */ y.jsx(un, { color: "primary", size: 80 }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    t && /* @__PURE__ */ y.jsx(
      rp,
      {
        className: S.errorIcon,
        color: "primary",
        fontSize: "large"
      }
    ),
    /* @__PURE__ */ y.jsx(Lt, { variant: "h4", color: "primary", children: t ? t.message ? t.message : "Une erreur est survenue" : "Pas de résultat" })
  ] }) }) : /* @__PURE__ */ y.jsx(
    co.InfiniteLoader,
    {
      isRowLoaded: ({ index: p }) => !!i[p],
      loadMoreRows: (p) => r ? r(p) : Promise.resolve(),
      rowCount: i.length + 1,
      threshold: h,
      children: ({ onRowsRendered: p, registerChild: v }) => /* @__PURE__ */ y.jsx(co.AutoSizer, { children: ({ height: w, width: C }) => /* @__PURE__ */ y.jsx(
        co.Table,
        {
          height: w,
          width: C,
          rowHeight: c,
          onRowsRendered: p,
          ref: v,
          gridClassName: S.grid,
          gridStyle: g,
          style: f,
          headerHeight: n,
          className: S.table,
          rowClassName: b,
          rowCount: i.length,
          rowGetter: ({ index: M }) => i[M],
          children: e.map(({ key: M, cellRenderer: L, ...W }, z) => /* @__PURE__ */ y.jsx(
            co.Column,
            {
              className: S.flexContainer,
              dataKey: M,
              headerRenderer: (B) => /* @__PURE__ */ y.jsx(
                d8,
                {
                  columns: e,
                  columnIndex: z,
                  headerHeight: n,
                  ...B
                }
              ),
              cellRenderer: (B) => /* @__PURE__ */ y.jsx(
                c8,
                {
                  columns: e,
                  onRowClick: s,
                  rowHoverRenderer: l,
                  rowHeight: c,
                  cellRender: L == null ? void 0 : L(i[B.rowIndex]),
                  ...B
                }
              ),
              ...W
            },
            M
          ))
        }
      ) })
    }
  );
}, f8 = "data:image/png;base64, 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", p8 = "data:image/png;base64, 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", h8 = Rt((e) => ({
  wrapperBackgroundImage: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    background: "url('https://one.img.pmdstatic.net/fit/http.3A.2F.2Frec2-bone-image.2Es3-website-eu-west-1.2Eamazonaws.2Ecom.2Fcap.2F2020.2F12.2F11.2F0db5a9b3-2a0b-4dbe-83e9-562cf9b5a02a.2Ejpeg/800x450/quality/100/crop-from/top/transformation.jpg')",
    backgroundSize: "cover",
    justifyContent: "center",
    alignItems: "center"
  },
  wrapperLogin: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: 40,
    backgroundColor: e.palette.common.white
  },
  accessDeniedMessage: {
    fontWeight: e.typography.fontWeightBold,
    color: e.palette.error.main,
    fontSize: 12,
    display: "flex"
  },
  svgIcon: {
    height: 50,
    marginTop: 30,
    marginBottom: 5
  },
  oneWrapper: {
    marginBottom: 30,
    fontSize: 15,
    fontWeight: 100,
    letterSpacing: 1,
    color: e.palette.common.black
  }
})), lZ = ({
  auth: e,
  homePath: t,
  loginPath: r,
  location: n,
  history: i,
  accessDenied: o = !1
}) => {
  const s = h8(), { pushNotification: l } = Zl(), c = e.isAuthenticated(), f = async (h) => {
    try {
      if (!h.credential)
        throw new Error("Erreur de connexion");
      await e.login(h.credential);
      let g = n.state && n.state.from;
      (!g || g === r || g.pathName === r) && (g = { pathName: t }), i.push(g);
    } catch (g) {
      l({
        message: g.message,
        type: jo.error
      });
    }
  };
  return pt(() => {
    e.isAuthenticated() && i.replace(t);
  }, [c, i.replace]), /* @__PURE__ */ y.jsx("div", { className: s.wrapperBackgroundImage, children: /* @__PURE__ */ y.jsxs(Bo, { className: s.wrapperLogin, children: [
    /* @__PURE__ */ y.jsx("img", { src: p8, alt: "Prisma Logo", width: 206 }),
    /* @__PURE__ */ y.jsx("img", { className: s.svgIcon, src: f8, alt: "One Logo" }),
    /* @__PURE__ */ y.jsx("div", { className: s.oneWrapper, children: "SUITE ONE" }),
    o ? /* @__PURE__ */ y.jsxs("div", { className: s.accessDeniedMessage, children: [
      "Vos droits ne sont pas encore actifs.",
      /* @__PURE__ */ y.jsx("br", {}),
      "Merci de contacter le support si cela persiste."
    ] }) : /* @__PURE__ */ y.jsx(
      AV,
      {
        onSuccess: f,
        onError: () => {
          l({
            message: "Erreur de connexion",
            type: jo.error
          });
        }
      }
    )
  ] }) });
};
function eS(e, t, r) {
  for (var n = e.text, i = e.characterMeta, o = t.length, s = r.length, l = [], c = i.slice(0, 0), f = 0, h = n.indexOf(t); h !== -1; )
    l.push(n.slice(f, h) + r), c = c.concat(
      i.slice(f, h),
      // Use the metadata of the first char we are replacing.
      g8(i.slice(h, h + 1), s)
    ), f = h + o, h = n.indexOf(t, f);
  return l.push(n.slice(f)), c = c.concat(i.slice(f)), {
    text: l.join(""),
    characterMeta: c
  };
}
function g8(e, t) {
  for (var r = e.slice(0, 0); t-- > 0; )
    r = r.concat(e);
  return r;
}
var mf = { exports: {} }, v8 = mf.exports, tS;
function $T() {
  return tS || (tS = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(v8, function() {
      var r = Array.prototype.slice;
      function n(d, E) {
        E && (d.prototype = Object.create(E.prototype)), d.prototype.constructor = d;
      }
      function i(d) {
        return c(d) ? d : ae(d);
      }
      n(o, i);
      function o(d) {
        return f(d) ? d : rt(d);
      }
      n(s, i);
      function s(d) {
        return h(d) ? d : Ze(d);
      }
      n(l, i);
      function l(d) {
        return c(d) && !g(d) ? d : ht(d);
      }
      function c(d) {
        return !!(d && d[b]);
      }
      function f(d) {
        return !!(d && d[p]);
      }
      function h(d) {
        return !!(d && d[v]);
      }
      function g(d) {
        return f(d) || h(d);
      }
      function S(d) {
        return !!(d && d[w]);
      }
      i.isIterable = c, i.isKeyed = f, i.isIndexed = h, i.isAssociative = g, i.isOrdered = S, i.Keyed = o, i.Indexed = s, i.Set = l;
      var b = "@@__IMMUTABLE_ITERABLE__@@", p = "@@__IMMUTABLE_KEYED__@@", v = "@@__IMMUTABLE_INDEXED__@@", w = "@@__IMMUTABLE_ORDERED__@@", C = "delete", M = 5, L = 1 << M, W = L - 1, z = {}, B = { value: !1 }, K = { value: !1 };
      function Z(d) {
        return d.value = !1, d;
      }
      function ee(d) {
        d && (d.value = !0);
      }
      function he() {
      }
      function _e(d, E) {
        E = E || 0;
        for (var R = Math.max(0, d.length - E), A = new Array(R), k = 0; k < R; k++)
          A[k] = d[k + E];
        return A;
      }
      function Te(d) {
        return d.size === void 0 && (d.size = d.__iterate(Oe)), d.size;
      }
      function fe(d, E) {
        if (typeof E != "number") {
          var R = E >>> 0;
          if ("" + R !== E || R === 4294967295)
            return NaN;
          E = R;
        }
        return E < 0 ? Te(d) + E : E;
      }
      function Oe() {
        return !0;
      }
      function ye(d, E, R) {
        return (d === 0 || R !== void 0 && d <= -R) && (E === void 0 || R !== void 0 && E >= R);
      }
      function de(d, E) {
        return Fe(d, E, 0);
      }
      function ce(d, E) {
        return Fe(d, E, E);
      }
      function Fe(d, E, R) {
        return d === void 0 ? R : d < 0 ? Math.max(0, E + d) : E === void 0 ? d : Math.min(E, d);
      }
      var le = 0, J = 1, re = 2, be = typeof Symbol == "function" && Symbol.iterator, Me = "@@iterator", Ae = be || Me;
      function Re(d) {
        this.next = d;
      }
      Re.prototype.toString = function() {
        return "[Iterator]";
      }, Re.KEYS = le, Re.VALUES = J, Re.ENTRIES = re, Re.prototype.inspect = Re.prototype.toSource = function() {
        return this.toString();
      }, Re.prototype[Ae] = function() {
        return this;
      };
      function Ee(d, E, R, A) {
        var k = d === 0 ? E : d === 1 ? R : [E, R];
        return A ? A.value = k : A = {
          value: k,
          done: !1
        }, A;
      }
      function Ce() {
        return { value: void 0, done: !0 };
      }
      function X(d) {
        return !!xe(d);
      }
      function ie(d) {
        return d && typeof d.next == "function";
      }
      function Ie(d) {
        var E = xe(d);
        return E && E.call(d);
      }
      function xe(d) {
        var E = d && (be && d[be] || d[Me]);
        if (typeof E == "function")
          return E;
      }
      function Pe(d) {
        return d && typeof d.length == "number";
      }
      n(ae, i);
      function ae(d) {
        return d == null ? at() : c(d) ? d.toSeq() : wr(d);
      }
      ae.of = function() {
        return ae(arguments);
      }, ae.prototype.toSeq = function() {
        return this;
      }, ae.prototype.toString = function() {
        return this.__toString("Seq {", "}");
      }, ae.prototype.cacheResult = function() {
        return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
      }, ae.prototype.__iterate = function(d, E) {
        return hr(this, d, E, !0);
      }, ae.prototype.__iterator = function(d, E) {
        return Nn(this, d, E, !0);
      }, n(rt, ae);
      function rt(d) {
        return d == null ? at().toKeyedSeq() : c(d) ? f(d) ? d.toSeq() : d.fromEntrySeq() : Qt(d);
      }
      rt.prototype.toKeyedSeq = function() {
        return this;
      }, n(Ze, ae);
      function Ze(d) {
        return d == null ? at() : c(d) ? f(d) ? d.entrySeq() : d.toIndexedSeq() : pr(d);
      }
      Ze.of = function() {
        return Ze(arguments);
      }, Ze.prototype.toIndexedSeq = function() {
        return this;
      }, Ze.prototype.toString = function() {
        return this.__toString("Seq [", "]");
      }, Ze.prototype.__iterate = function(d, E) {
        return hr(this, d, E, !1);
      }, Ze.prototype.__iterator = function(d, E) {
        return Nn(this, d, E, !1);
      }, n(ht, ae);
      function ht(d) {
        return (d == null ? at() : c(d) ? f(d) ? d.entrySeq() : d : pr(d)).toSetSeq();
      }
      ht.of = function() {
        return ht(arguments);
      }, ht.prototype.toSetSeq = function() {
        return this;
      }, ae.isSeq = sr, ae.Keyed = rt, ae.Set = ht, ae.Indexed = Ze;
      var mt = "@@__IMMUTABLE_SEQ__@@";
      ae.prototype[mt] = !0, n(At, Ze);
      function At(d) {
        this._array = d, this.size = d.length;
      }
      At.prototype.get = function(d, E) {
        return this.has(d) ? this._array[fe(this, d)] : E;
      }, At.prototype.__iterate = function(d, E) {
        for (var R = this._array, A = R.length - 1, k = 0; k <= A; k++)
          if (d(R[E ? A - k : k], k, this) === !1)
            return k + 1;
        return k;
      }, At.prototype.__iterator = function(d, E) {
        var R = this._array, A = R.length - 1, k = 0;
        return new Re(
          function() {
            return k > A ? Ce() : Ee(d, k, R[E ? A - k++ : k++]);
          }
        );
      }, n(Bt, rt);
      function Bt(d) {
        var E = Object.keys(d);
        this._object = d, this._keys = E, this.size = E.length;
      }
      Bt.prototype.get = function(d, E) {
        return E !== void 0 && !this.has(d) ? E : this._object[d];
      }, Bt.prototype.has = function(d) {
        return this._object.hasOwnProperty(d);
      }, Bt.prototype.__iterate = function(d, E) {
        for (var R = this._object, A = this._keys, k = A.length - 1, V = 0; V <= k; V++) {
          var ne = A[E ? k - V : V];
          if (d(R[ne], ne, this) === !1)
            return V + 1;
        }
        return V;
      }, Bt.prototype.__iterator = function(d, E) {
        var R = this._object, A = this._keys, k = A.length - 1, V = 0;
        return new Re(function() {
          var ne = A[E ? k - V : V];
          return V++ > k ? Ce() : Ee(d, ne, R[ne]);
        });
      }, Bt.prototype[w] = !0, n(Gt, Ze);
      function Gt(d) {
        this._iterable = d, this.size = d.length || d.size;
      }
      Gt.prototype.__iterateUncached = function(d, E) {
        if (E)
          return this.cacheResult().__iterate(d, E);
        var R = this._iterable, A = Ie(R), k = 0;
        if (ie(A))
          for (var V; !(V = A.next()).done && d(V.value, k++, this) !== !1; )
            ;
        return k;
      }, Gt.prototype.__iteratorUncached = function(d, E) {
        if (E)
          return this.cacheResult().__iterator(d, E);
        var R = this._iterable, A = Ie(R);
        if (!ie(A))
          return new Re(Ce);
        var k = 0;
        return new Re(function() {
          var V = A.next();
          return V.done ? V : Ee(d, k++, V.value);
        });
      }, n(It, Ze);
      function It(d) {
        this._iterator = d, this._iteratorCache = [];
      }
      It.prototype.__iterateUncached = function(d, E) {
        if (E)
          return this.cacheResult().__iterate(d, E);
        for (var R = this._iterator, A = this._iteratorCache, k = 0; k < A.length; )
          if (d(A[k], k++, this) === !1)
            return k;
        for (var V; !(V = R.next()).done; ) {
          var ne = V.value;
          if (A[k] = ne, d(ne, k++, this) === !1)
            break;
        }
        return k;
      }, It.prototype.__iteratorUncached = function(d, E) {
        if (E)
          return this.cacheResult().__iterator(d, E);
        var R = this._iterator, A = this._iteratorCache, k = 0;
        return new Re(function() {
          if (k >= A.length) {
            var V = R.next();
            if (V.done)
              return V;
            A[k] = V.value;
          }
          return Ee(d, k, A[k++]);
        });
      };
      function sr(d) {
        return !!(d && d[mt]);
      }
      var et;
      function at() {
        return et || (et = new At([]));
      }
      function Qt(d) {
        var E = Array.isArray(d) ? new At(d).fromEntrySeq() : ie(d) ? new It(d).fromEntrySeq() : X(d) ? new Gt(d).fromEntrySeq() : typeof d == "object" ? new Bt(d) : void 0;
        if (!E)
          throw new TypeError(
            "Expected Array or iterable object of [k, v] entries, or keyed object: " + d
          );
        return E;
      }
      function pr(d) {
        var E = gt(d);
        if (!E)
          throw new TypeError(
            "Expected Array or iterable object of values: " + d
          );
        return E;
      }
      function wr(d) {
        var E = gt(d) || typeof d == "object" && new Bt(d);
        if (!E)
          throw new TypeError(
            "Expected Array or iterable object of values, or keyed object: " + d
          );
        return E;
      }
      function gt(d) {
        return Pe(d) ? new At(d) : ie(d) ? new It(d) : X(d) ? new Gt(d) : void 0;
      }
      function hr(d, E, R, A) {
        var k = d._cache;
        if (k) {
          for (var V = k.length - 1, ne = 0; ne <= V; ne++) {
            var me = k[R ? V - ne : ne];
            if (E(me[1], A ? me[0] : ne, d) === !1)
              return ne + 1;
          }
          return ne;
        }
        return d.__iterateUncached(E, R);
      }
      function Nn(d, E, R, A) {
        var k = d._cache;
        if (k) {
          var V = k.length - 1, ne = 0;
          return new Re(function() {
            var me = k[R ? V - ne : ne];
            return ne++ > V ? Ce() : Ee(E, A ? me[0] : ne - 1, me[1]);
          });
        }
        return d.__iteratorUncached(E, R);
      }
      function hn(d, E) {
        return E ? cn(E, d, "", { "": d }) : gn(d);
      }
      function cn(d, E, R, A) {
        return Array.isArray(E) ? d.call(A, R, Ze(E).map(function(k, V) {
          return cn(d, k, V, E);
        })) : tn(E) ? d.call(A, R, rt(E).map(function(k, V) {
          return cn(d, k, V, E);
        })) : E;
      }
      function gn(d) {
        return Array.isArray(d) ? Ze(d).map(gn).toList() : tn(d) ? rt(d).map(gn).toMap() : d;
      }
      function tn(d) {
        return d && (d.constructor === Object || d.constructor === void 0);
      }
      function rr(d, E) {
        if (d === E || d !== d && E !== E)
          return !0;
        if (!d || !E)
          return !1;
        if (typeof d.valueOf == "function" && typeof E.valueOf == "function") {
          if (d = d.valueOf(), E = E.valueOf(), d === E || d !== d && E !== E)
            return !0;
          if (!d || !E)
            return !1;
        }
        return !!(typeof d.equals == "function" && typeof E.equals == "function" && d.equals(E));
      }
      function Tn(d, E) {
        if (d === E)
          return !0;
        if (!c(E) || d.size !== void 0 && E.size !== void 0 && d.size !== E.size || d.__hash !== void 0 && E.__hash !== void 0 && d.__hash !== E.__hash || f(d) !== f(E) || h(d) !== h(E) || S(d) !== S(E))
          return !1;
        if (d.size === 0 && E.size === 0)
          return !0;
        var R = !g(d);
        if (S(d)) {
          var A = d.entries();
          return E.every(function(Le, ze) {
            var G = A.next().value;
            return G && rr(G[1], Le) && (R || rr(G[0], ze));
          }) && A.next().done;
        }
        var k = !1;
        if (d.size === void 0)
          if (E.size === void 0)
            typeof d.cacheResult == "function" && d.cacheResult();
          else {
            k = !0;
            var V = d;
            d = E, E = V;
          }
        var ne = !0, me = E.__iterate(function(Le, ze) {
          if (R ? !d.has(Le) : k ? !rr(Le, d.get(ze, z)) : !rr(d.get(ze, z), Le))
            return ne = !1, !1;
        });
        return ne && d.size === me;
      }
      n(xr, Ze);
      function xr(d, E) {
        if (!(this instanceof xr))
          return new xr(d, E);
        if (this._value = d, this.size = E === void 0 ? 1 / 0 : Math.max(0, E), this.size === 0) {
          if (Xi)
            return Xi;
          Xi = this;
        }
      }
      xr.prototype.toString = function() {
        return this.size === 0 ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
      }, xr.prototype.get = function(d, E) {
        return this.has(d) ? this._value : E;
      }, xr.prototype.includes = function(d) {
        return rr(this._value, d);
      }, xr.prototype.slice = function(d, E) {
        var R = this.size;
        return ye(d, E, R) ? this : new xr(this._value, ce(E, R) - de(d, R));
      }, xr.prototype.reverse = function() {
        return this;
      }, xr.prototype.indexOf = function(d) {
        return rr(this._value, d) ? 0 : -1;
      }, xr.prototype.lastIndexOf = function(d) {
        return rr(this._value, d) ? this.size : -1;
      }, xr.prototype.__iterate = function(d, E) {
        for (var R = 0; R < this.size; R++)
          if (d(this._value, R, this) === !1)
            return R + 1;
        return R;
      }, xr.prototype.__iterator = function(d, E) {
        var R = this, A = 0;
        return new Re(
          function() {
            return A < R.size ? Ee(d, A++, R._value) : Ce();
          }
        );
      }, xr.prototype.equals = function(d) {
        return d instanceof xr ? rr(this._value, d._value) : Tn(d);
      };
      var Xi;
      function Ti(d, E) {
        if (!d) throw new Error(E);
      }
      n(Gr, Ze);
      function Gr(d, E, R) {
        if (!(this instanceof Gr))
          return new Gr(d, E, R);
        if (Ti(R !== 0, "Cannot step a Range by 0"), d = d || 0, E === void 0 && (E = 1 / 0), R = R === void 0 ? 1 : Math.abs(R), E < d && (R = -R), this._start = d, this._end = E, this._step = R, this.size = Math.max(0, Math.ceil((E - d) / R - 1) + 1), this.size === 0) {
          if (jn)
            return jn;
          jn = this;
        }
      }
      Gr.prototype.toString = function() {
        return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
      }, Gr.prototype.get = function(d, E) {
        return this.has(d) ? this._start + fe(this, d) * this._step : E;
      }, Gr.prototype.includes = function(d) {
        var E = (d - this._start) / this._step;
        return E >= 0 && E < this.size && E === Math.floor(E);
      }, Gr.prototype.slice = function(d, E) {
        return ye(d, E, this.size) ? this : (d = de(d, this.size), E = ce(E, this.size), E <= d ? new Gr(0, 0) : new Gr(this.get(d, this._end), this.get(E, this._end), this._step));
      }, Gr.prototype.indexOf = function(d) {
        var E = d - this._start;
        if (E % this._step === 0) {
          var R = E / this._step;
          if (R >= 0 && R < this.size)
            return R;
        }
        return -1;
      }, Gr.prototype.lastIndexOf = function(d) {
        return this.indexOf(d);
      }, Gr.prototype.__iterate = function(d, E) {
        for (var R = this.size - 1, A = this._step, k = E ? this._start + R * A : this._start, V = 0; V <= R; V++) {
          if (d(k, V, this) === !1)
            return V + 1;
          k += E ? -A : A;
        }
        return V;
      }, Gr.prototype.__iterator = function(d, E) {
        var R = this.size - 1, A = this._step, k = E ? this._start + R * A : this._start, V = 0;
        return new Re(function() {
          var ne = k;
          return k += E ? -A : A, V > R ? Ce() : Ee(d, V++, ne);
        });
      }, Gr.prototype.equals = function(d) {
        return d instanceof Gr ? this._start === d._start && this._end === d._end && this._step === d._step : Tn(this, d);
      };
      var jn;
      n(vn, i);
      function vn() {
        throw TypeError("Abstract");
      }
      n(Ji, vn);
      function Ji() {
      }
      n(di, vn);
      function di() {
      }
      n(dn, vn);
      function dn() {
      }
      vn.Keyed = Ji, vn.Indexed = di, vn.Set = dn;
      var fi = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(E, R) {
        E = E | 0, R = R | 0;
        var A = E & 65535, k = R & 65535;
        return A * k + ((E >>> 16) * k + A * (R >>> 16) << 16 >>> 0) | 0;
      };
      function Oi(d) {
        return d >>> 1 & 1073741824 | d & 3221225471;
      }
      function rn(d) {
        if (d === !1 || d === null || d === void 0 || typeof d.valueOf == "function" && (d = d.valueOf(), d === !1 || d === null || d === void 0))
          return 0;
        if (d === !0)
          return 1;
        var E = typeof d;
        if (E === "number") {
          var R = d | 0;
          for (R !== d && (R ^= d * 4294967295); d > 4294967295; )
            d /= 4294967295, R ^= d;
          return Oi(R);
        }
        if (E === "string")
          return d.length > Rr ? vo(d) : oe(d);
        if (typeof d.hashCode == "function")
          return d.hashCode();
        if (E === "object")
          return Qe(d);
        if (typeof d.toString == "function")
          return oe(d.toString());
        throw new Error("Value type " + E + " cannot be hashed.");
      }
      function vo(d) {
        var E = nn[d];
        return E === void 0 && (E = oe(d), fn === Cr && (fn = 0, nn = {}), fn++, nn[d] = E), E;
      }
      function oe(d) {
        for (var E = 0, R = 0; R < d.length; R++)
          E = 31 * E + d.charCodeAt(R) | 0;
        return Oi(E);
      }
      function Qe(d) {
        var E;
        if (nr && (E = Ht.get(d), E !== void 0) || (E = d[Er], E !== void 0) || !_t && (E = d.propertyIsEnumerable && d.propertyIsEnumerable[Er], E !== void 0 || (E = lr(d), E !== void 0)))
          return E;
        if (E = ++Ft, Ft & 1073741824 && (Ft = 0), nr)
          Ht.set(d, E);
        else {
          if (lt !== void 0 && lt(d) === !1)
            throw new Error("Non-extensible objects are not allowed as keys.");
          if (_t)
            Object.defineProperty(d, Er, {
              enumerable: !1,
              configurable: !1,
              writable: !1,
              value: E
            });
          else if (d.propertyIsEnumerable !== void 0 && d.propertyIsEnumerable === d.constructor.prototype.propertyIsEnumerable)
            d.propertyIsEnumerable = function() {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            }, d.propertyIsEnumerable[Er] = E;
          else if (d.nodeType !== void 0)
            d[Er] = E;
          else
            throw new Error("Unable to set a non-enumerable property on object.");
        }
        return E;
      }
      var lt = Object.isExtensible, _t = function() {
        try {
          return Object.defineProperty({}, "@", {}), !0;
        } catch {
          return !1;
        }
      }();
      function lr(d) {
        if (d && d.nodeType > 0)
          switch (d.nodeType) {
            case 1:
              return d.uniqueID;
            case 9:
              return d.documentElement && d.documentElement.uniqueID;
          }
      }
      var nr = typeof WeakMap == "function", Ht;
      nr && (Ht = /* @__PURE__ */ new WeakMap());
      var Ft = 0, Er = "__immutablehash__";
      typeof Symbol == "function" && (Er = Symbol(Er));
      var Rr = 16, Cr = 255, fn = 0, nn = {};
      function qr(d) {
        Ti(
          d !== 1 / 0,
          "Cannot perform this action with an infinite size."
        );
      }
      n(Tt, Ji);
      function Tt(d) {
        return d == null ? mn() : Wo(d) && !S(d) ? d : mn().withMutations(function(E) {
          var R = o(d);
          qr(R.size), R.forEach(function(A, k) {
            return E.set(k, A);
          });
        });
      }
      Tt.prototype.toString = function() {
        return this.__toString("Map {", "}");
      }, Tt.prototype.get = function(d, E) {
        return this._root ? this._root.get(0, void 0, d, E) : E;
      }, Tt.prototype.set = function(d, E) {
        return ha(this, d, E);
      }, Tt.prototype.setIn = function(d, E) {
        return this.updateIn(d, z, function() {
          return E;
        });
      }, Tt.prototype.remove = function(d) {
        return ha(this, d, z);
      }, Tt.prototype.deleteIn = function(d) {
        return this.updateIn(d, function() {
          return z;
        });
      }, Tt.prototype.update = function(d, E, R) {
        return arguments.length === 1 ? d(this) : this.updateIn([d], E, R);
      }, Tt.prototype.updateIn = function(d, E, R) {
        R || (R = E, E = void 0);
        var A = ss(
          this,
          qs(d),
          E,
          R
        );
        return A === z ? void 0 : A;
      }, Tt.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : mn();
      }, Tt.prototype.merge = function() {
        return Uo(this, void 0, arguments);
      }, Tt.prototype.mergeWith = function(d) {
        var E = r.call(arguments, 1);
        return Uo(this, d, E);
      }, Tt.prototype.mergeIn = function(d) {
        var E = r.call(arguments, 1);
        return this.updateIn(
          d,
          mn(),
          function(R) {
            return typeof R.merge == "function" ? R.merge.apply(R, E) : E[E.length - 1];
          }
        );
      }, Tt.prototype.mergeDeep = function() {
        return Uo(this, va, arguments);
      }, Tt.prototype.mergeDeepWith = function(d) {
        var E = r.call(arguments, 1);
        return Uo(this, Qi(d), E);
      }, Tt.prototype.mergeDeepIn = function(d) {
        var E = r.call(arguments, 1);
        return this.updateIn(
          d,
          mn(),
          function(R) {
            return typeof R.mergeDeep == "function" ? R.mergeDeep.apply(R, E) : E[E.length - 1];
          }
        );
      }, Tt.prototype.sort = function(d) {
        return He(Ri(this, d));
      }, Tt.prototype.sortBy = function(d, E) {
        return He(Ri(this, E, d));
      }, Tt.prototype.withMutations = function(d) {
        var E = this.asMutable();
        return d(E), E.wasAltered() ? E.__ensureOwner(this.__ownerID) : this;
      }, Tt.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new he());
      }, Tt.prototype.asImmutable = function() {
        return this.__ensureOwner();
      }, Tt.prototype.wasAltered = function() {
        return this.__altered;
      }, Tt.prototype.__iterator = function(d, E) {
        return new fa(this, d, E);
      }, Tt.prototype.__iterate = function(d, E) {
        var R = this, A = 0;
        return this._root && this._root.iterate(function(k) {
          return A++, d(k[1], k[0], R);
        }, E), A;
      }, Tt.prototype.__ensureOwner = function(d) {
        return d === this.__ownerID ? this : d ? $o(this.size, this._root, d, this.__hash) : (this.__ownerID = d, this.__altered = !1, this);
      };
      function Wo(d) {
        return !!(d && d[da]);
      }
      Tt.isMap = Wo;
      var da = "@@__IMMUTABLE_MAP__@@", qt = Tt.prototype;
      qt[da] = !0, qt[C] = qt.remove, qt.removeIn = qt.deleteIn;
      function Zi(d, E) {
        this.ownerID = d, this.entries = E;
      }
      Zi.prototype.get = function(d, E, R, A) {
        for (var k = this.entries, V = 0, ne = k.length; V < ne; V++)
          if (rr(R, k[V][0]))
            return k[V][1];
        return A;
      }, Zi.prototype.update = function(d, E, R, A, k, V, ne) {
        for (var me = k === z, Le = this.entries, ze = 0, G = Le.length; ze < G && !rr(A, Le[ze][0]); ze++)
          ;
        var ge = ze < G;
        if (ge ? Le[ze][1] === k : me)
          return this;
        if (ee(ne), (me || !ge) && ee(V), !(me && Le.length === 1)) {
          if (!ge && !me && Le.length >= m)
            return as(d, Le, A, k);
          var ue = d && d === this.ownerID, Ve = ue ? Le : _e(Le);
          return ge ? me ? ze === G - 1 ? Ve.pop() : Ve[ze] = Ve.pop() : Ve[ze] = [A, k] : Ve.push([A, k]), ue ? (this.entries = Ve, this) : new Zi(d, Ve);
        }
      };
      function kn(d, E, R) {
        this.ownerID = d, this.bitmap = E, this.nodes = R;
      }
      kn.prototype.get = function(d, E, R, A) {
        E === void 0 && (E = rn(R));
        var k = 1 << ((d === 0 ? E : E >>> d) & W), V = this.bitmap;
        return (V & k) === 0 ? A : this.nodes[ma(V & k - 1)].get(d + M, E, R, A);
      }, kn.prototype.update = function(d, E, R, A, k, V, ne) {
        R === void 0 && (R = rn(A));
        var me = (E === 0 ? R : R >>> E) & W, Le = 1 << me, ze = this.bitmap, G = (ze & Le) !== 0;
        if (!G && k === z)
          return this;
        var ge = ma(ze & Le - 1), ue = this.nodes, Ve = G ? ue[ge] : void 0, ot = pi(Ve, d, E + M, R, A, k, V, ne);
        if (ot === Ve)
          return this;
        if (!G && ot && ue.length >= x)
          return ga(d, ue, ze, me, ot);
        if (G && !ot && ue.length === 2 && yo(ue[ge ^ 1]))
          return ue[ge ^ 1];
        if (G && ot && ue.length === 1 && yo(ot))
          return ot;
        var St = d && d === this.ownerID, gr = G ? ot ? ze : ze ^ Le : ze | Le, Zt = G ? ot ? ya(ue, ge, ot, St) : I(ue, ge, St) : ba(ue, ge, ot, St);
        return St ? (this.bitmap = gr, this.nodes = Zt, this) : new kn(d, gr, Zt);
      };
      function mo(d, E, R) {
        this.ownerID = d, this.count = E, this.nodes = R;
      }
      mo.prototype.get = function(d, E, R, A) {
        E === void 0 && (E = rn(R));
        var k = (d === 0 ? E : E >>> d) & W, V = this.nodes[k];
        return V ? V.get(d + M, E, R, A) : A;
      }, mo.prototype.update = function(d, E, R, A, k, V, ne) {
        R === void 0 && (R = rn(A));
        var me = (E === 0 ? R : R >>> E) & W, Le = k === z, ze = this.nodes, G = ze[me];
        if (Le && !G)
          return this;
        var ge = pi(G, d, E + M, R, A, k, V, ne);
        if (ge === G)
          return this;
        var ue = this.count;
        if (!G)
          ue++;
        else if (!ge && (ue--, ue < T))
          return $s(d, ze, ue, me);
        var Ve = d && d === this.ownerID, ot = ya(ze, me, ge, Ve);
        return Ve ? (this.count = ue, this.nodes = ot, this) : new mo(d, ue, ot);
      };
      function Xn(d, E, R) {
        this.ownerID = d, this.keyHash = E, this.entries = R;
      }
      Xn.prototype.get = function(d, E, R, A) {
        for (var k = this.entries, V = 0, ne = k.length; V < ne; V++)
          if (rr(R, k[V][0]))
            return k[V][1];
        return A;
      }, Xn.prototype.update = function(d, E, R, A, k, V, ne) {
        R === void 0 && (R = rn(A));
        var me = k === z;
        if (R !== this.keyHash)
          return me ? this : (ee(ne), ee(V), Zn(this, d, E, R, [A, k]));
        for (var Le = this.entries, ze = 0, G = Le.length; ze < G && !rr(A, Le[ze][0]); ze++)
          ;
        var ge = ze < G;
        if (ge ? Le[ze][1] === k : me)
          return this;
        if (ee(ne), (me || !ge) && ee(V), me && G === 2)
          return new Jn(d, this.keyHash, Le[ze ^ 1]);
        var ue = d && d === this.ownerID, Ve = ue ? Le : _e(Le);
        return ge ? me ? ze === G - 1 ? Ve.pop() : Ve[ze] = Ve.pop() : Ve[ze] = [A, k] : Ve.push([A, k]), ue ? (this.entries = Ve, this) : new Xn(d, this.keyHash, Ve);
      };
      function Jn(d, E, R) {
        this.ownerID = d, this.keyHash = E, this.entry = R;
      }
      Jn.prototype.get = function(d, E, R, A) {
        return rr(R, this.entry[0]) ? this.entry[1] : A;
      }, Jn.prototype.update = function(d, E, R, A, k, V, ne) {
        var me = k === z, Le = rr(A, this.entry[0]);
        if (Le ? k === this.entry[1] : me)
          return this;
        if (ee(ne), me) {
          ee(V);
          return;
        }
        return Le ? d && d === this.ownerID ? (this.entry[1] = k, this) : new Jn(d, this.keyHash, [A, k]) : (ee(V), Zn(this, d, E, rn(A), [A, k]));
      }, Zi.prototype.iterate = Xn.prototype.iterate = function(d, E) {
        for (var R = this.entries, A = 0, k = R.length - 1; A <= k; A++)
          if (d(R[E ? k - A : A]) === !1)
            return !1;
      }, kn.prototype.iterate = mo.prototype.iterate = function(d, E) {
        for (var R = this.nodes, A = 0, k = R.length - 1; A <= k; A++) {
          var V = R[E ? k - A : A];
          if (V && V.iterate(d, E) === !1)
            return !1;
        }
      }, Jn.prototype.iterate = function(d, E) {
        return d(this.entry);
      }, n(fa, Re);
      function fa(d, E, R) {
        this._type = E, this._reverse = R, this._stack = d._root && Ho(d._root);
      }
      fa.prototype.next = function() {
        for (var d = this._type, E = this._stack; E; ) {
          var R = E.node, A = E.index++, k;
          if (R.entry) {
            if (A === 0)
              return Jr(d, R.entry);
          } else if (R.entries) {
            if (k = R.entries.length - 1, A <= k)
              return Jr(d, R.entries[this._reverse ? k - A : A]);
          } else if (k = R.nodes.length - 1, A <= k) {
            var V = R.nodes[this._reverse ? k - A : A];
            if (V) {
              if (V.entry)
                return Jr(d, V.entry);
              E = this._stack = Ho(V, E);
            }
            continue;
          }
          E = this._stack = this._stack.__prev;
        }
        return Ce();
      };
      function Jr(d, E) {
        return Ee(d, E[0], E[1]);
      }
      function Ho(d, E) {
        return {
          node: d,
          index: 0,
          __prev: E
        };
      }
      function $o(d, E, R, A) {
        var k = Object.create(qt);
        return k.size = d, k._root = E, k.__ownerID = R, k.__hash = A, k.__altered = !1, k;
      }
      var pa;
      function mn() {
        return pa || (pa = $o(0));
      }
      function ha(d, E, R) {
        var A, k;
        if (d._root) {
          var V = Z(B), ne = Z(K);
          if (A = pi(d._root, d.__ownerID, 0, void 0, E, R, V, ne), !ne.value)
            return d;
          k = d.size + (V.value ? R === z ? -1 : 1 : 0);
        } else {
          if (R === z)
            return d;
          k = 1, A = new Zi(d.__ownerID, [[E, R]]);
        }
        return d.__ownerID ? (d.size = k, d._root = A, d.__hash = void 0, d.__altered = !0, d) : A ? $o(k, A) : mn();
      }
      function pi(d, E, R, A, k, V, ne, me) {
        return d ? d.update(E, R, A, k, V, ne, me) : V === z ? d : (ee(me), ee(ne), new Jn(E, A, [k, V]));
      }
      function yo(d) {
        return d.constructor === Jn || d.constructor === Xn;
      }
      function Zn(d, E, R, A, k) {
        if (d.keyHash === A)
          return new Xn(E, A, [d.entry, k]);
        var V = (R === 0 ? d.keyHash : d.keyHash >>> R) & W, ne = (R === 0 ? A : A >>> R) & W, me, Le = V === ne ? [Zn(d, E, R + M, A, k)] : (me = new Jn(E, A, k), V < ne ? [d, me] : [me, d]);
        return new kn(E, 1 << V | 1 << ne, Le);
      }
      function as(d, E, R, A) {
        d || (d = new he());
        for (var k = new Jn(d, rn(R), [R, A]), V = 0; V < E.length; V++) {
          var ne = E[V];
          k = k.update(d, 0, void 0, ne[0], ne[1]);
        }
        return k;
      }
      function $s(d, E, R, A) {
        for (var k = 0, V = 0, ne = new Array(R), me = 0, Le = 1, ze = E.length; me < ze; me++, Le <<= 1) {
          var G = E[me];
          G !== void 0 && me !== A && (k |= Le, ne[V++] = G);
        }
        return new kn(d, k, ne);
      }
      function ga(d, E, R, A, k) {
        for (var V = 0, ne = new Array(L), me = 0; R !== 0; me++, R >>>= 1)
          ne[me] = R & 1 ? E[V++] : void 0;
        return ne[A] = k, new mo(d, V + 1, ne);
      }
      function Uo(d, E, R) {
        for (var A = [], k = 0; k < R.length; k++) {
          var V = R[k], ne = o(V);
          c(V) || (ne = ne.map(function(me) {
            return hn(me);
          })), A.push(ne);
        }
        return eo(d, E, A);
      }
      function va(d, E, R) {
        return d && d.mergeDeep && c(E) ? d.mergeDeep(E) : rr(d, E) ? d : E;
      }
      function Qi(d) {
        return function(E, R, A) {
          if (E && E.mergeDeepWith && c(R))
            return E.mergeDeepWith(d, R);
          var k = d(E, R, A);
          return rr(E, k) ? E : k;
        };
      }
      function eo(d, E, R) {
        return R = R.filter(function(A) {
          return A.size !== 0;
        }), R.length === 0 ? d : d.size === 0 && !d.__ownerID && R.length === 1 ? d.constructor(R[0]) : d.withMutations(function(A) {
          for (var k = E ? function(ne, me) {
            A.update(
              me,
              z,
              function(Le) {
                return Le === z ? ne : E(Le, ne, me);
              }
            );
          } : function(ne, me) {
            A.set(me, ne);
          }, V = 0; V < R.length; V++)
            R[V].forEach(k);
        });
      }
      function ss(d, E, R, A) {
        var k = d === z, V = E.next();
        if (V.done) {
          var ne = k ? R : d, me = A(ne);
          return me === ne ? d : me;
        }
        Ti(
          k || d && d.set,
          "invalid keyPath"
        );
        var Le = V.value, ze = k ? z : d.get(Le, z), G = ss(
          ze,
          E,
          R,
          A
        );
        return G === ze ? d : G === z ? d.remove(Le) : (k ? mn() : d).set(Le, G);
      }
      function ma(d) {
        return d = d - (d >> 1 & 1431655765), d = (d & 858993459) + (d >> 2 & 858993459), d = d + (d >> 4) & 252645135, d = d + (d >> 8), d = d + (d >> 16), d & 127;
      }
      function ya(d, E, R, A) {
        var k = A ? d : _e(d);
        return k[E] = R, k;
      }
      function ba(d, E, R, A) {
        var k = d.length + 1;
        if (A && E + 1 === k)
          return d[E] = R, d;
        for (var V = new Array(k), ne = 0, me = 0; me < k; me++)
          me === E ? (V[me] = R, ne = -1) : V[me] = d[me + ne];
        return V;
      }
      function I(d, E, R) {
        var A = d.length - 1;
        if (R && E === A)
          return d.pop(), d;
        for (var k = new Array(A), V = 0, ne = 0; ne < A; ne++)
          ne === E && (V = 1), k[ne] = d[ne + V];
        return k;
      }
      var m = L / 4, x = L / 2, T = L / 4;
      n(P, di);
      function P(d) {
        var E = We();
        if (d == null)
          return E;
        if (F(d))
          return d;
        var R = s(d), A = R.size;
        return A === 0 ? E : (qr(A), A > 0 && A < L ? ve(0, A, M, null, new Y(R.toArray())) : E.withMutations(function(k) {
          k.setSize(A), R.forEach(function(V, ne) {
            return k.set(ne, V);
          });
        }));
      }
      P.of = function() {
        return this(arguments);
      }, P.prototype.toString = function() {
        return this.__toString("List [", "]");
      }, P.prototype.get = function(d, E) {
        if (d = fe(this, d), d >= 0 && d < this.size) {
          d += this._origin;
          var R = Ye(this, d);
          return R && R.array[d & W];
        }
        return E;
      }, P.prototype.set = function(d, E) {
        return De(this, d, E);
      }, P.prototype.remove = function(d) {
        return this.has(d) ? d === 0 ? this.shift() : d === this.size - 1 ? this.pop() : this.splice(d, 1) : this;
      }, P.prototype.insert = function(d, E) {
        return this.splice(d, 0, E);
      }, P.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = M, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : We();
      }, P.prototype.push = function() {
        var d = arguments, E = this.size;
        return this.withMutations(function(R) {
          Ke(R, 0, E + d.length);
          for (var A = 0; A < d.length; A++)
            R.set(E + A, d[A]);
        });
      }, P.prototype.pop = function() {
        return Ke(this, 0, -1);
      }, P.prototype.unshift = function() {
        var d = arguments;
        return this.withMutations(function(E) {
          Ke(E, -d.length);
          for (var R = 0; R < d.length; R++)
            E.set(R, d[R]);
        });
      }, P.prototype.shift = function() {
        return Ke(this, 1);
      }, P.prototype.merge = function() {
        return tt(this, void 0, arguments);
      }, P.prototype.mergeWith = function(d) {
        var E = r.call(arguments, 1);
        return tt(this, d, E);
      }, P.prototype.mergeDeep = function() {
        return tt(this, va, arguments);
      }, P.prototype.mergeDeepWith = function(d) {
        var E = r.call(arguments, 1);
        return tt(this, Qi(d), E);
      }, P.prototype.setSize = function(d) {
        return Ke(this, 0, d);
      }, P.prototype.slice = function(d, E) {
        var R = this.size;
        return ye(d, E, R) ? this : Ke(
          this,
          de(d, R),
          ce(E, R)
        );
      }, P.prototype.__iterator = function(d, E) {
        var R = 0, A = Q(this, E);
        return new Re(function() {
          var k = A();
          return k === q ? Ce() : Ee(d, R++, k);
        });
      }, P.prototype.__iterate = function(d, E) {
        for (var R = 0, A = Q(this, E), k; (k = A()) !== q && d(k, R++, this) !== !1; )
          ;
        return R;
      }, P.prototype.__ensureOwner = function(d) {
        return d === this.__ownerID ? this : d ? ve(this._origin, this._capacity, this._level, this._root, this._tail, d, this.__hash) : (this.__ownerID = d, this);
      };
      function F(d) {
        return !!(d && d[N]);
      }
      P.isList = F;
      var N = "@@__IMMUTABLE_LIST__@@", H = P.prototype;
      H[N] = !0, H[C] = H.remove, H.setIn = qt.setIn, H.deleteIn = H.removeIn = qt.removeIn, H.update = qt.update, H.updateIn = qt.updateIn, H.mergeIn = qt.mergeIn, H.mergeDeepIn = qt.mergeDeepIn, H.withMutations = qt.withMutations, H.asMutable = qt.asMutable, H.asImmutable = qt.asImmutable, H.wasAltered = qt.wasAltered;
      function Y(d, E) {
        this.array = d, this.ownerID = E;
      }
      Y.prototype.removeBefore = function(d, E, R) {
        if (R === E ? 1 << E : this.array.length === 0)
          return this;
        var A = R >>> E & W;
        if (A >= this.array.length)
          return new Y([], d);
        var k = A === 0, V;
        if (E > 0) {
          var ne = this.array[A];
          if (V = ne && ne.removeBefore(d, E - M, R), V === ne && k)
            return this;
        }
        if (k && !V)
          return this;
        var me = $e(this, d);
        if (!k)
          for (var Le = 0; Le < A; Le++)
            me.array[Le] = void 0;
        return V && (me.array[A] = V), me;
      }, Y.prototype.removeAfter = function(d, E, R) {
        if (R === (E ? 1 << E : 0) || this.array.length === 0)
          return this;
        var A = R - 1 >>> E & W;
        if (A >= this.array.length)
          return this;
        var k;
        if (E > 0) {
          var V = this.array[A];
          if (k = V && V.removeAfter(d, E - M, R), k === V && A === this.array.length - 1)
            return this;
        }
        var ne = $e(this, d);
        return ne.array.splice(A + 1), k && (ne.array[A] = k), ne;
      };
      var q = {};
      function Q(d, E) {
        var R = d._origin, A = d._capacity, k = je(A), V = d._tail;
        return ne(d._root, d._level, 0);
        function ne(ze, G, ge) {
          return G === 0 ? me(ze, ge) : Le(ze, G, ge);
        }
        function me(ze, G) {
          var ge = G === k ? V && V.array : ze && ze.array, ue = G > R ? 0 : R - G, Ve = A - G;
          return Ve > L && (Ve = L), function() {
            if (ue === Ve)
              return q;
            var ot = E ? --Ve : ue++;
            return ge && ge[ot];
          };
        }
        function Le(ze, G, ge) {
          var ue, Ve = ze && ze.array, ot = ge > R ? 0 : R - ge >> G, St = (A - ge >> G) + 1;
          return St > L && (St = L), function() {
            do {
              if (ue) {
                var gr = ue();
                if (gr !== q)
                  return gr;
                ue = null;
              }
              if (ot === St)
                return q;
              var Zt = E ? --St : ot++;
              ue = ne(
                Ve && Ve[Zt],
                G - M,
                ge + (Zt << G)
              );
            } while (!0);
          };
        }
      }
      function ve(d, E, R, A, k, V, ne) {
        var me = Object.create(H);
        return me.size = E - d, me._origin = d, me._capacity = E, me._level = R, me._root = A, me._tail = k, me.__ownerID = V, me.__hash = ne, me.__altered = !1, me;
      }
      var Se;
      function We() {
        return Se || (Se = ve(0, 0, M));
      }
      function De(d, E, R) {
        if (E = fe(d, E), E !== E)
          return d;
        if (E >= d.size || E < 0)
          return d.withMutations(function(ne) {
            E < 0 ? Ke(ne, E).set(0, R) : Ke(ne, 0, E + 1).set(E, R);
          });
        E += d._origin;
        var A = d._tail, k = d._root, V = Z(K);
        return E >= je(d._capacity) ? A = Ne(A, d.__ownerID, 0, E, R, V) : k = Ne(k, d.__ownerID, d._level, E, R, V), V.value ? d.__ownerID ? (d._root = k, d._tail = A, d.__hash = void 0, d.__altered = !0, d) : ve(d._origin, d._capacity, d._level, k, A) : d;
      }
      function Ne(d, E, R, A, k, V) {
        var ne = A >>> R & W, me = d && ne < d.array.length;
        if (!me && k === void 0)
          return d;
        var Le;
        if (R > 0) {
          var ze = d && d.array[ne], G = Ne(ze, E, R - M, A, k, V);
          return G === ze ? d : (Le = $e(d, E), Le.array[ne] = G, Le);
        }
        return me && d.array[ne] === k ? d : (ee(V), Le = $e(d, E), k === void 0 && ne === Le.array.length - 1 ? Le.array.pop() : Le.array[ne] = k, Le);
      }
      function $e(d, E) {
        return E && d && E === d.ownerID ? d : new Y(d ? d.array.slice() : [], E);
      }
      function Ye(d, E) {
        if (E >= je(d._capacity))
          return d._tail;
        if (E < 1 << d._level + M) {
          for (var R = d._root, A = d._level; R && A > 0; )
            R = R.array[E >>> A & W], A -= M;
          return R;
        }
      }
      function Ke(d, E, R) {
        E !== void 0 && (E = E | 0), R !== void 0 && (R = R | 0);
        var A = d.__ownerID || new he(), k = d._origin, V = d._capacity, ne = k + E, me = R === void 0 ? V : R < 0 ? V + R : k + R;
        if (ne === k && me === V)
          return d;
        if (ne >= me)
          return d.clear();
        for (var Le = d._level, ze = d._root, G = 0; ne + G < 0; )
          ze = new Y(ze && ze.array.length ? [void 0, ze] : [], A), Le += M, G += 1 << Le;
        G && (ne += G, k += G, me += G, V += G);
        for (var ge = je(V), ue = je(me); ue >= 1 << Le + M; )
          ze = new Y(ze && ze.array.length ? [ze] : [], A), Le += M;
        var Ve = d._tail, ot = ue < ge ? Ye(d, me - 1) : ue > ge ? new Y([], A) : Ve;
        if (Ve && ue > ge && ne < V && Ve.array.length) {
          ze = $e(ze, A);
          for (var St = ze, gr = Le; gr > M; gr -= M) {
            var Zt = ge >>> gr & W;
            St = St.array[Zt] = $e(St.array[Zt], A);
          }
          St.array[ge >>> M & W] = Ve;
        }
        if (me < V && (ot = ot && ot.removeAfter(A, 0, me)), ne >= ue)
          ne -= ue, me -= ue, Le = M, ze = null, ot = ot && ot.removeBefore(A, 0, ne);
        else if (ne > k || ue < ge) {
          for (G = 0; ze; ) {
            var _a = ne >>> Le & W;
            if (_a !== ue >>> Le & W)
              break;
            _a && (G += (1 << Le) * _a), Le -= M, ze = ze.array[_a];
          }
          ze && ne > k && (ze = ze.removeBefore(A, Le, ne - G)), ze && ue < ge && (ze = ze.removeAfter(A, Le, ue - G)), G && (ne -= G, me -= G);
        }
        return d.__ownerID ? (d.size = me - ne, d._origin = ne, d._capacity = me, d._level = Le, d._root = ze, d._tail = ot, d.__hash = void 0, d.__altered = !0, d) : ve(ne, me, Le, ze, ot);
      }
      function tt(d, E, R) {
        for (var A = [], k = 0, V = 0; V < R.length; V++) {
          var ne = R[V], me = s(ne);
          me.size > k && (k = me.size), c(ne) || (me = me.map(function(Le) {
            return hn(Le);
          })), A.push(me);
        }
        return k > d.size && (d = d.setSize(k)), eo(d, E, A);
      }
      function je(d) {
        return d < L ? 0 : d - 1 >>> M << M;
      }
      n(He, Tt);
      function He(d) {
        return d == null ? er() : ke(d) ? d : er().withMutations(function(E) {
          var R = o(d);
          qr(R.size), R.forEach(function(A, k) {
            return E.set(k, A);
          });
        });
      }
      He.of = function() {
        return this(arguments);
      }, He.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
      }, He.prototype.get = function(d, E) {
        var R = this._map.get(d);
        return R !== void 0 ? this._list.get(R)[1] : E;
      }, He.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : er();
      }, He.prototype.set = function(d, E) {
        return xt(this, d, E);
      }, He.prototype.remove = function(d) {
        return xt(this, d, z);
      }, He.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
      }, He.prototype.__iterate = function(d, E) {
        var R = this;
        return this._list.__iterate(
          function(A) {
            return A && d(A[1], A[0], R);
          },
          E
        );
      }, He.prototype.__iterator = function(d, E) {
        return this._list.fromEntrySeq().__iterator(d, E);
      }, He.prototype.__ensureOwner = function(d) {
        if (d === this.__ownerID)
          return this;
        var E = this._map.__ensureOwner(d), R = this._list.__ensureOwner(d);
        return d ? ut(E, R, d, this.__hash) : (this.__ownerID = d, this._map = E, this._list = R, this);
      };
      function ke(d) {
        return Wo(d) && S(d);
      }
      He.isOrderedMap = ke, He.prototype[w] = !0, He.prototype[C] = He.prototype.remove;
      function ut(d, E, R, A) {
        var k = Object.create(He.prototype);
        return k.size = d ? d.size : 0, k._map = d, k._list = E, k.__ownerID = R, k.__hash = A, k;
      }
      var Ct;
      function er() {
        return Ct || (Ct = ut(mn(), We()));
      }
      function xt(d, E, R) {
        var A = d._map, k = d._list, V = A.get(E), ne = V !== void 0, me, Le;
        if (R === z) {
          if (!ne)
            return d;
          k.size >= L && k.size >= A.size * 2 ? (Le = k.filter(function(ze, G) {
            return ze !== void 0 && V !== G;
          }), me = Le.toKeyedSeq().map(function(ze) {
            return ze[0];
          }).flip().toMap(), d.__ownerID && (me.__ownerID = Le.__ownerID = d.__ownerID)) : (me = A.remove(E), Le = V === k.size - 1 ? k.pop() : k.set(V, void 0));
        } else if (ne) {
          if (R === k.get(V)[1])
            return d;
          me = A, Le = k.set(V, [E, R]);
        } else
          me = A.set(E, k.size), Le = k.set(k.size, [E, R]);
        return d.__ownerID ? (d.size = me.size, d._map = me, d._list = Le, d.__hash = void 0, d) : ut(me, Le);
      }
      n(ft, rt);
      function ft(d, E) {
        this._iter = d, this._useKeys = E, this.size = d.size;
      }
      ft.prototype.get = function(d, E) {
        return this._iter.get(d, E);
      }, ft.prototype.has = function(d) {
        return this._iter.has(d);
      }, ft.prototype.valueSeq = function() {
        return this._iter.valueSeq();
      }, ft.prototype.reverse = function() {
        var d = this, E = to(this, !0);
        return this._useKeys || (E.valueSeq = function() {
          return d._iter.toSeq().reverse();
        }), E;
      }, ft.prototype.map = function(d, E) {
        var R = this, A = bo(this, d, E);
        return this._useKeys || (A.valueSeq = function() {
          return R._iter.toSeq().map(d, E);
        }), A;
      }, ft.prototype.__iterate = function(d, E) {
        var R = this, A;
        return this._iter.__iterate(
          this._useKeys ? function(k, V) {
            return d(k, V, R);
          } : (A = E ? $n(this) : 0, function(k) {
            return d(k, E ? --A : A++, R);
          }),
          E
        );
      }, ft.prototype.__iterator = function(d, E) {
        if (this._useKeys)
          return this._iter.__iterator(d, E);
        var R = this._iter.__iterator(J, E), A = E ? $n(this) : 0;
        return new Re(function() {
          var k = R.next();
          return k.done ? k : Ee(d, E ? --A : A++, k.value, k);
        });
      }, ft.prototype[w] = !0, n(vr, Ze);
      function vr(d) {
        this._iter = d, this.size = d.size;
      }
      vr.prototype.includes = function(d) {
        return this._iter.includes(d);
      }, vr.prototype.__iterate = function(d, E) {
        var R = this, A = 0;
        return this._iter.__iterate(function(k) {
          return d(k, A++, R);
        }, E);
      }, vr.prototype.__iterator = function(d, E) {
        var R = this._iter.__iterator(J, E), A = 0;
        return new Re(function() {
          var k = R.next();
          return k.done ? k : Ee(d, A++, k.value, k);
        });
      }, n(ur, ht);
      function ur(d) {
        this._iter = d, this.size = d.size;
      }
      ur.prototype.has = function(d) {
        return this._iter.includes(d);
      }, ur.prototype.__iterate = function(d, E) {
        var R = this;
        return this._iter.__iterate(function(A) {
          return d(A, A, R);
        }, E);
      }, ur.prototype.__iterator = function(d, E) {
        var R = this._iter.__iterator(J, E);
        return new Re(function() {
          var A = R.next();
          return A.done ? A : Ee(d, A.value, A.value, A);
        });
      }, n(kr, rt);
      function kr(d) {
        this._iter = d, this.size = d.size;
      }
      kr.prototype.entrySeq = function() {
        return this._iter.toSeq();
      }, kr.prototype.__iterate = function(d, E) {
        var R = this;
        return this._iter.__iterate(function(A) {
          if (A) {
            td(A);
            var k = c(A);
            return d(
              k ? A.get(1) : A[1],
              k ? A.get(0) : A[0],
              R
            );
          }
        }, E);
      }, kr.prototype.__iterator = function(d, E) {
        var R = this._iter.__iterator(J, E);
        return new Re(function() {
          for (; ; ) {
            var A = R.next();
            if (A.done)
              return A;
            var k = A.value;
            if (k) {
              td(k);
              var V = c(k);
              return Ee(
                d,
                V ? k.get(0) : k[0],
                V ? k.get(1) : k[1],
                A
              );
            }
          }
        });
      }, vr.prototype.cacheResult = ft.prototype.cacheResult = ur.prototype.cacheResult = kr.prototype.cacheResult = Di;
      function yn(d) {
        var E = hi(d);
        return E._iter = d, E.size = d.size, E.flip = function() {
          return d;
        }, E.reverse = function() {
          var R = d.reverse.apply(this);
          return R.flip = function() {
            return d.reverse();
          }, R;
        }, E.has = function(R) {
          return d.includes(R);
        }, E.includes = function(R) {
          return d.has(R);
        }, E.cacheResult = Di, E.__iterateUncached = function(R, A) {
          var k = this;
          return d.__iterate(function(V, ne) {
            return R(ne, V, k) !== !1;
          }, A);
        }, E.__iteratorUncached = function(R, A) {
          if (R === re) {
            var k = d.__iterator(R, A);
            return new Re(function() {
              var V = k.next();
              if (!V.done) {
                var ne = V.value[0];
                V.value[0] = V.value[1], V.value[1] = ne;
              }
              return V;
            });
          }
          return d.__iterator(
            R === J ? le : J,
            A
          );
        }, E;
      }
      function bo(d, E, R) {
        var A = hi(d);
        return A.size = d.size, A.has = function(k) {
          return d.has(k);
        }, A.get = function(k, V) {
          var ne = d.get(k, z);
          return ne === z ? V : E.call(R, ne, k, d);
        }, A.__iterateUncached = function(k, V) {
          var ne = this;
          return d.__iterate(
            function(me, Le, ze) {
              return k(E.call(R, me, Le, ze), Le, ne) !== !1;
            },
            V
          );
        }, A.__iteratorUncached = function(k, V) {
          var ne = d.__iterator(re, V);
          return new Re(function() {
            var me = ne.next();
            if (me.done)
              return me;
            var Le = me.value, ze = Le[0];
            return Ee(
              k,
              ze,
              E.call(R, Le[1], ze, d),
              me
            );
          });
        }, A;
      }
      function to(d, E) {
        var R = hi(d);
        return R._iter = d, R.size = d.size, R.reverse = function() {
          return d;
        }, d.flip && (R.flip = function() {
          var A = yn(d);
          return A.reverse = function() {
            return d.flip();
          }, A;
        }), R.get = function(A, k) {
          return d.get(E ? A : -1 - A, k);
        }, R.has = function(A) {
          return d.has(E ? A : -1 - A);
        }, R.includes = function(A) {
          return d.includes(A);
        }, R.cacheResult = Di, R.__iterate = function(A, k) {
          var V = this;
          return d.__iterate(function(ne, me) {
            return A(ne, me, V);
          }, !k);
        }, R.__iterator = function(A, k) {
          return d.__iterator(A, !k);
        }, R;
      }
      function ls(d, E, R, A) {
        var k = hi(d);
        return A && (k.has = function(V) {
          var ne = d.get(V, z);
          return ne !== z && !!E.call(R, ne, V, d);
        }, k.get = function(V, ne) {
          var me = d.get(V, z);
          return me !== z && E.call(R, me, V, d) ? me : ne;
        }), k.__iterateUncached = function(V, ne) {
          var me = this, Le = 0;
          return d.__iterate(function(ze, G, ge) {
            if (E.call(R, ze, G, ge))
              return Le++, V(ze, A ? G : Le - 1, me);
          }, ne), Le;
        }, k.__iteratorUncached = function(V, ne) {
          var me = d.__iterator(re, ne), Le = 0;
          return new Re(function() {
            for (; ; ) {
              var ze = me.next();
              if (ze.done)
                return ze;
              var G = ze.value, ge = G[0], ue = G[1];
              if (E.call(R, ue, ge, d))
                return Ee(V, A ? ge : Le++, ue, ze);
            }
          });
        }, k;
      }
      function Us(d, E, R) {
        var A = Tt().asMutable();
        return d.__iterate(function(k, V) {
          A.update(
            E.call(R, k, V, d),
            0,
            function(ne) {
              return ne + 1;
            }
          );
        }), A.asImmutable();
      }
      function Vr(d, E, R) {
        var A = f(d), k = (S(d) ? He() : Tt()).asMutable();
        d.__iterate(function(ne, me) {
          k.update(
            E.call(R, ne, me, d),
            function(Le) {
              return Le = Le || [], Le.push(A ? [me, ne] : ne), Le;
            }
          );
        });
        var V = rd(d);
        return k.map(function(ne) {
          return $t(d, V(ne));
        });
      }
      function yt(d, E, R, A) {
        var k = d.size;
        if (E !== void 0 && (E = E | 0), R !== void 0 && (R = R | 0), ye(E, R, k))
          return d;
        var V = de(E, k), ne = ce(R, k);
        if (V !== V || ne !== ne)
          return yt(d.toSeq().cacheResult(), E, R, A);
        var me = ne - V, Le;
        me === me && (Le = me < 0 ? 0 : me);
        var ze = hi(d);
        return ze.size = Le === 0 ? Le : d.size && Le || void 0, !A && sr(d) && Le >= 0 && (ze.get = function(G, ge) {
          return G = fe(this, G), G >= 0 && G < Le ? d.get(G + V, ge) : ge;
        }), ze.__iterateUncached = function(G, ge) {
          var ue = this;
          if (Le === 0)
            return 0;
          if (ge)
            return this.cacheResult().__iterate(G, ge);
          var Ve = 0, ot = !0, St = 0;
          return d.__iterate(function(gr, Zt) {
            if (!(ot && (ot = Ve++ < V)))
              return St++, G(gr, A ? Zt : St - 1, ue) !== !1 && St !== Le;
          }), St;
        }, ze.__iteratorUncached = function(G, ge) {
          if (Le !== 0 && ge)
            return this.cacheResult().__iterator(G, ge);
          var ue = Le !== 0 && d.__iterator(G, ge), Ve = 0, ot = 0;
          return new Re(function() {
            for (; Ve++ < V; )
              ue.next();
            if (++ot > Le)
              return Ce();
            var St = ue.next();
            return A || G === J ? St : G === le ? Ee(G, ot - 1, void 0, St) : Ee(G, ot - 1, St.value[1], St);
          });
        }, ze;
      }
      function Hn(d, E, R) {
        var A = hi(d);
        return A.__iterateUncached = function(k, V) {
          var ne = this;
          if (V)
            return this.cacheResult().__iterate(k, V);
          var me = 0;
          return d.__iterate(
            function(Le, ze, G) {
              return E.call(R, Le, ze, G) && ++me && k(Le, ze, ne);
            }
          ), me;
        }, A.__iteratorUncached = function(k, V) {
          var ne = this;
          if (V)
            return this.cacheResult().__iterator(k, V);
          var me = d.__iterator(re, V), Le = !0;
          return new Re(function() {
            if (!Le)
              return Ce();
            var ze = me.next();
            if (ze.done)
              return ze;
            var G = ze.value, ge = G[0], ue = G[1];
            return E.call(R, ue, ge, ne) ? k === re ? ze : Ee(k, ge, ue, ze) : (Le = !1, Ce());
          });
        }, A;
      }
      function Qn(d, E, R, A) {
        var k = hi(d);
        return k.__iterateUncached = function(V, ne) {
          var me = this;
          if (ne)
            return this.cacheResult().__iterate(V, ne);
          var Le = !0, ze = 0;
          return d.__iterate(function(G, ge, ue) {
            if (!(Le && (Le = E.call(R, G, ge, ue))))
              return ze++, V(G, A ? ge : ze - 1, me);
          }), ze;
        }, k.__iteratorUncached = function(V, ne) {
          var me = this;
          if (ne)
            return this.cacheResult().__iterator(V, ne);
          var Le = d.__iterator(re, ne), ze = !0, G = 0;
          return new Re(function() {
            var ge, ue, Ve;
            do {
              if (ge = Le.next(), ge.done)
                return A || V === J ? ge : V === le ? Ee(V, G++, void 0, ge) : Ee(V, G++, ge.value[1], ge);
              var ot = ge.value;
              ue = ot[0], Ve = ot[1], ze && (ze = E.call(R, Ve, ue, me));
            } while (ze);
            return V === re ? ge : Ee(V, ue, Ve, ge);
          });
        }, k;
      }
      function ro(d, E) {
        var R = f(d), A = [d].concat(E).map(function(ne) {
          return c(ne) ? R && (ne = o(ne)) : ne = R ? Qt(ne) : pr(Array.isArray(ne) ? ne : [ne]), ne;
        }).filter(function(ne) {
          return ne.size !== 0;
        });
        if (A.length === 0)
          return d;
        if (A.length === 1) {
          var k = A[0];
          if (k === d || R && f(k) || h(d) && h(k))
            return k;
        }
        var V = new At(A);
        return R ? V = V.toKeyedSeq() : h(d) || (V = V.toSetSeq()), V = V.flatten(!0), V.size = A.reduce(
          function(ne, me) {
            if (ne !== void 0) {
              var Le = me.size;
              if (Le !== void 0)
                return ne + Le;
            }
          },
          0
        ), V;
      }
      function on(d, E, R) {
        var A = hi(d);
        return A.__iterateUncached = function(k, V) {
          var ne = 0, me = !1;
          function Le(ze, G) {
            var ge = this;
            ze.__iterate(function(ue, Ve) {
              return (!E || G < E) && c(ue) ? Le(ue, G + 1) : k(ue, R ? Ve : ne++, ge) === !1 && (me = !0), !me;
            }, V);
          }
          return Le(d, 0), ne;
        }, A.__iteratorUncached = function(k, V) {
          var ne = d.__iterator(k, V), me = [], Le = 0;
          return new Re(function() {
            for (; ne; ) {
              var ze = ne.next();
              if (ze.done !== !1) {
                ne = me.pop();
                continue;
              }
              var G = ze.value;
              if (k === re && (G = G[1]), (!E || me.length < E) && c(G))
                me.push(ne), ne = G.__iterator(k, V);
              else
                return R ? ze : Ee(k, Le++, G, ze);
            }
            return Ce();
          });
        }, A;
      }
      function Gs(d, E, R) {
        var A = rd(d);
        return d.toSeq().map(
          function(k, V) {
            return A(E.call(R, k, V, d));
          }
        ).flatten(!0);
      }
      function wa(d, E) {
        var R = hi(d);
        return R.size = d.size && d.size * 2 - 1, R.__iterateUncached = function(A, k) {
          var V = this, ne = 0;
          return d.__iterate(
            function(me, Le) {
              return (!ne || A(E, ne++, V) !== !1) && A(me, ne++, V) !== !1;
            },
            k
          ), ne;
        }, R.__iteratorUncached = function(A, k) {
          var V = d.__iterator(J, k), ne = 0, me;
          return new Re(function() {
            return (!me || ne % 2) && (me = V.next(), me.done) ? me : ne % 2 ? Ee(A, ne++, E) : Ee(A, ne++, me.value, me);
          });
        }, R;
      }
      function Ri(d, E, R) {
        E || (E = cs);
        var A = f(d), k = 0, V = d.toSeq().map(
          function(ne, me) {
            return [me, ne, k++, R ? R(ne, me, d) : ne];
          }
        ).toArray();
        return V.sort(function(ne, me) {
          return E(ne[3], me[3]) || ne[2] - me[2];
        }).forEach(
          A ? function(ne, me) {
            V[me].length = 2;
          } : function(ne, me) {
            V[me] = ne[1];
          }
        ), A ? rt(V) : h(d) ? Ze(V) : ht(V);
      }
      function Ii(d, E, R) {
        if (E || (E = cs), R) {
          var A = d.toSeq().map(function(k, V) {
            return [k, R(k, V, d)];
          }).reduce(function(k, V) {
            return us(E, k[1], V[1]) ? V : k;
          });
          return A && A[0];
        } else
          return d.reduce(function(k, V) {
            return us(E, k, V) ? V : k;
          });
      }
      function us(d, E, R) {
        var A = d(R, E);
        return A === 0 && R !== E && (R == null || R !== R) || A > 0;
      }
      function Go(d, E, R) {
        var A = hi(d);
        return A.size = new At(R).map(function(k) {
          return k.size;
        }).min(), A.__iterate = function(k, V) {
          for (var ne = this.__iterator(J, V), me, Le = 0; !(me = ne.next()).done && k(me.value, Le++, this) !== !1; )
            ;
          return Le;
        }, A.__iteratorUncached = function(k, V) {
          var ne = R.map(
            function(ze) {
              return ze = i(ze), Ie(V ? ze.reverse() : ze);
            }
          ), me = 0, Le = !1;
          return new Re(function() {
            var ze;
            return Le || (ze = ne.map(function(G) {
              return G.next();
            }), Le = ze.some(function(G) {
              return G.done;
            })), Le ? Ce() : Ee(
              k,
              me++,
              E.apply(null, ze.map(function(G) {
                return G.value;
              }))
            );
          });
        }, A;
      }
      function $t(d, E) {
        return sr(d) ? E : d.constructor(E);
      }
      function td(d) {
        if (d !== Object(d))
          throw new TypeError("Expected [K, V] tuple: " + d);
      }
      function $n(d) {
        return qr(d.size), Te(d);
      }
      function rd(d) {
        return f(d) ? o : h(d) ? s : l;
      }
      function hi(d) {
        return Object.create(
          (f(d) ? rt : h(d) ? Ze : ht).prototype
        );
      }
      function Di() {
        return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : ae.prototype.cacheResult.call(this);
      }
      function cs(d, E) {
        return d > E ? 1 : d < E ? -1 : 0;
      }
      function qs(d) {
        var E = Ie(d);
        if (!E) {
          if (!Pe(d))
            throw new TypeError("Expected iterable or array-like: " + d);
          E = Ie(i(d));
        }
        return E;
      }
      n(Jt, Ji);
      function Jt(d, E) {
        var R, A = function(ne) {
          if (ne instanceof A)
            return ne;
          if (!(this instanceof A))
            return new A(ne);
          if (!R) {
            R = !0;
            var me = Object.keys(d);
            ou(k, me), k.size = me.length, k._name = E, k._keys = me, k._defaultValues = d;
          }
          this._map = Tt(ne);
        }, k = A.prototype = Object.create(Ir);
        return k.constructor = A, A;
      }
      Jt.prototype.toString = function() {
        return this.__toString(nd(this) + " {", "}");
      }, Jt.prototype.has = function(d) {
        return this._defaultValues.hasOwnProperty(d);
      }, Jt.prototype.get = function(d, E) {
        if (!this.has(d))
          return E;
        var R = this._defaultValues[d];
        return this._map ? this._map.get(d, R) : R;
      }, Jt.prototype.clear = function() {
        if (this.__ownerID)
          return this._map && this._map.clear(), this;
        var d = this.constructor;
        return d._empty || (d._empty = xa(this, mn()));
      }, Jt.prototype.set = function(d, E) {
        if (!this.has(d))
          throw new Error('Cannot set unknown key "' + d + '" on ' + nd(this));
        var R = this._map && this._map.set(d, E);
        return this.__ownerID || R === this._map ? this : xa(this, R);
      }, Jt.prototype.remove = function(d) {
        if (!this.has(d))
          return this;
        var E = this._map && this._map.remove(d);
        return this.__ownerID || E === this._map ? this : xa(this, E);
      }, Jt.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, Jt.prototype.__iterator = function(d, E) {
        var R = this;
        return o(this._defaultValues).map(function(A, k) {
          return R.get(k);
        }).__iterator(d, E);
      }, Jt.prototype.__iterate = function(d, E) {
        var R = this;
        return o(this._defaultValues).map(function(A, k) {
          return R.get(k);
        }).__iterate(d, E);
      }, Jt.prototype.__ensureOwner = function(d) {
        if (d === this.__ownerID)
          return this;
        var E = this._map && this._map.__ensureOwner(d);
        return d ? xa(this, E, d) : (this.__ownerID = d, this._map = E, this);
      };
      var Ir = Jt.prototype;
      Ir[C] = Ir.remove, Ir.deleteIn = Ir.removeIn = qt.removeIn, Ir.merge = qt.merge, Ir.mergeWith = qt.mergeWith, Ir.mergeIn = qt.mergeIn, Ir.mergeDeep = qt.mergeDeep, Ir.mergeDeepWith = qt.mergeDeepWith, Ir.mergeDeepIn = qt.mergeDeepIn, Ir.setIn = qt.setIn, Ir.update = qt.update, Ir.updateIn = qt.updateIn, Ir.withMutations = qt.withMutations, Ir.asMutable = qt.asMutable, Ir.asImmutable = qt.asImmutable;
      function xa(d, E, R) {
        var A = Object.create(Object.getPrototypeOf(d));
        return A._map = E, A.__ownerID = R, A;
      }
      function nd(d) {
        return d._name || d.constructor.name || "Record";
      }
      function ou(d, E) {
        try {
          E.forEach(Tp.bind(void 0, d));
        } catch {
        }
      }
      function Tp(d, E) {
        Object.defineProperty(d, E, {
          get: function() {
            return this.get(E);
          },
          set: function(R) {
            Ti(this.__ownerID, "Cannot set on an immutable record."), this.set(E, R);
          }
        });
      }
      n(Dr, dn);
      function Dr(d) {
        return d == null ? Vs() : au(d) && !S(d) ? d : Vs().withMutations(function(E) {
          var R = l(d);
          qr(R.size), R.forEach(function(A) {
            return E.add(A);
          });
        });
      }
      Dr.of = function() {
        return this(arguments);
      }, Dr.fromKeys = function(d) {
        return this(o(d).keySeq());
      }, Dr.prototype.toString = function() {
        return this.__toString("Set {", "}");
      }, Dr.prototype.has = function(d) {
        return this._map.has(d);
      }, Dr.prototype.add = function(d) {
        return wo(this, this._map.set(d, !0));
      }, Dr.prototype.remove = function(d) {
        return wo(this, this._map.remove(d));
      }, Dr.prototype.clear = function() {
        return wo(this, this._map.clear());
      }, Dr.prototype.union = function() {
        var d = r.call(arguments, 0);
        return d = d.filter(function(E) {
          return E.size !== 0;
        }), d.length === 0 ? this : this.size === 0 && !this.__ownerID && d.length === 1 ? this.constructor(d[0]) : this.withMutations(function(E) {
          for (var R = 0; R < d.length; R++)
            l(d[R]).forEach(function(A) {
              return E.add(A);
            });
        });
      }, Dr.prototype.intersect = function() {
        var d = r.call(arguments, 0);
        if (d.length === 0)
          return this;
        d = d.map(function(R) {
          return l(R);
        });
        var E = this;
        return this.withMutations(function(R) {
          E.forEach(function(A) {
            d.every(function(k) {
              return k.includes(A);
            }) || R.remove(A);
          });
        });
      }, Dr.prototype.subtract = function() {
        var d = r.call(arguments, 0);
        if (d.length === 0)
          return this;
        d = d.map(function(R) {
          return l(R);
        });
        var E = this;
        return this.withMutations(function(R) {
          E.forEach(function(A) {
            d.some(function(k) {
              return k.includes(A);
            }) && R.remove(A);
          });
        });
      }, Dr.prototype.merge = function() {
        return this.union.apply(this, arguments);
      }, Dr.prototype.mergeWith = function(d) {
        var E = r.call(arguments, 1);
        return this.union.apply(this, E);
      }, Dr.prototype.sort = function(d) {
        return ei(Ri(this, d));
      }, Dr.prototype.sortBy = function(d, E) {
        return ei(Ri(this, E, d));
      }, Dr.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, Dr.prototype.__iterate = function(d, E) {
        var R = this;
        return this._map.__iterate(function(A, k) {
          return d(k, k, R);
        }, E);
      }, Dr.prototype.__iterator = function(d, E) {
        return this._map.map(function(R, A) {
          return A;
        }).__iterator(d, E);
      }, Dr.prototype.__ensureOwner = function(d) {
        if (d === this.__ownerID)
          return this;
        var E = this._map.__ensureOwner(d);
        return d ? this.__make(E, d) : (this.__ownerID = d, this._map = E, this);
      };
      function au(d) {
        return !!(d && d[su]);
      }
      Dr.isSet = au;
      var su = "@@__IMMUTABLE_SET__@@", bn = Dr.prototype;
      bn[su] = !0, bn[C] = bn.remove, bn.mergeDeep = bn.merge, bn.mergeDeepWith = bn.mergeWith, bn.withMutations = qt.withMutations, bn.asMutable = qt.asMutable, bn.asImmutable = qt.asImmutable, bn.__empty = Vs, bn.__make = id;
      function wo(d, E) {
        return d.__ownerID ? (d.size = E.size, d._map = E, d) : E === d._map ? d : E.size === 0 ? d.__empty() : d.__make(E);
      }
      function id(d, E) {
        var R = Object.create(bn);
        return R.size = d ? d.size : 0, R._map = d, R.__ownerID = E, R;
      }
      var lu;
      function Vs() {
        return lu || (lu = id(mn()));
      }
      n(ei, Dr);
      function ei(d) {
        return d == null ? fs() : Ys(d) ? d : fs().withMutations(function(E) {
          var R = l(d);
          qr(R.size), R.forEach(function(A) {
            return E.add(A);
          });
        });
      }
      ei.of = function() {
        return this(arguments);
      }, ei.fromKeys = function(d) {
        return this(o(d).keySeq());
      }, ei.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
      };
      function Ys(d) {
        return au(d) && S(d);
      }
      ei.isOrderedSet = Ys;
      var ds = ei.prototype;
      ds[w] = !0, ds.__empty = fs, ds.__make = od;
      function od(d, E) {
        var R = Object.create(ds);
        return R.size = d ? d.size : 0, R._map = d, R.__ownerID = E, R;
      }
      var Ks;
      function fs() {
        return Ks || (Ks = od(er()));
      }
      n(Yr, di);
      function Yr(d) {
        return d == null ? Xs() : uu(d) ? d : Xs().unshiftAll(d);
      }
      Yr.of = function() {
        return this(arguments);
      }, Yr.prototype.toString = function() {
        return this.__toString("Stack [", "]");
      }, Yr.prototype.get = function(d, E) {
        var R = this._head;
        for (d = fe(this, d); R && d--; )
          R = R.next;
        return R ? R.value : E;
      }, Yr.prototype.peek = function() {
        return this._head && this._head.value;
      }, Yr.prototype.push = function() {
        if (arguments.length === 0)
          return this;
        for (var d = this.size + arguments.length, E = this._head, R = arguments.length - 1; R >= 0; R--)
          E = {
            value: arguments[R],
            next: E
          };
        return this.__ownerID ? (this.size = d, this._head = E, this.__hash = void 0, this.__altered = !0, this) : no(d, E);
      }, Yr.prototype.pushAll = function(d) {
        if (d = s(d), d.size === 0)
          return this;
        qr(d.size);
        var E = this.size, R = this._head;
        return d.reverse().forEach(function(A) {
          E++, R = {
            value: A,
            next: R
          };
        }), this.__ownerID ? (this.size = E, this._head = R, this.__hash = void 0, this.__altered = !0, this) : no(E, R);
      }, Yr.prototype.pop = function() {
        return this.slice(1);
      }, Yr.prototype.unshift = function() {
        return this.push.apply(this, arguments);
      }, Yr.prototype.unshiftAll = function(d) {
        return this.pushAll(d);
      }, Yr.prototype.shift = function() {
        return this.pop.apply(this, arguments);
      }, Yr.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Xs();
      }, Yr.prototype.slice = function(d, E) {
        if (ye(d, E, this.size))
          return this;
        var R = de(d, this.size), A = ce(E, this.size);
        if (A !== this.size)
          return di.prototype.slice.call(this, d, E);
        for (var k = this.size - R, V = this._head; R--; )
          V = V.next;
        return this.__ownerID ? (this.size = k, this._head = V, this.__hash = void 0, this.__altered = !0, this) : no(k, V);
      }, Yr.prototype.__ensureOwner = function(d) {
        return d === this.__ownerID ? this : d ? no(this.size, this._head, d, this.__hash) : (this.__ownerID = d, this.__altered = !1, this);
      }, Yr.prototype.__iterate = function(d, E) {
        if (E)
          return this.reverse().__iterate(d);
        for (var R = 0, A = this._head; A && d(A.value, R++, this) !== !1; )
          A = A.next;
        return R;
      }, Yr.prototype.__iterator = function(d, E) {
        if (E)
          return this.reverse().__iterator(d);
        var R = 0, A = this._head;
        return new Re(function() {
          if (A) {
            var k = A.value;
            return A = A.next, Ee(d, R++, k);
          }
          return Ce();
        });
      };
      function uu(d) {
        return !!(d && d[Ln]);
      }
      Yr.isStack = uu;
      var Ln = "@@__IMMUTABLE_STACK__@@", xo = Yr.prototype;
      xo[Ln] = !0, xo.withMutations = qt.withMutations, xo.asMutable = qt.asMutable, xo.asImmutable = qt.asImmutable, xo.wasAltered = qt.wasAltered;
      function no(d, E, R, A) {
        var k = Object.create(xo);
        return k.size = d, k._head = E, k.__ownerID = R, k.__hash = A, k.__altered = !1, k;
      }
      var cu;
      function Xs() {
        return cu || (cu = no(0));
      }
      function Pi(d, E) {
        var R = function(A) {
          d.prototype[A] = E[A];
        };
        return Object.keys(E).forEach(R), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(E).forEach(R), d;
      }
      i.Iterator = Re, Pi(i, {
        // ### Conversion to other types
        toArray: function() {
          qr(this.size);
          var d = new Array(this.size || 0);
          return this.valueSeq().__iterate(function(E, R) {
            d[R] = E;
          }), d;
        },
        toIndexedSeq: function() {
          return new vr(this);
        },
        toJS: function() {
          return this.toSeq().map(
            function(d) {
              return d && typeof d.toJS == "function" ? d.toJS() : d;
            }
          ).__toJS();
        },
        toJSON: function() {
          return this.toSeq().map(
            function(d) {
              return d && typeof d.toJSON == "function" ? d.toJSON() : d;
            }
          ).__toJS();
        },
        toKeyedSeq: function() {
          return new ft(this, !0);
        },
        toMap: function() {
          return Tt(this.toKeyedSeq());
        },
        toObject: function() {
          qr(this.size);
          var d = {};
          return this.__iterate(function(E, R) {
            d[R] = E;
          }), d;
        },
        toOrderedMap: function() {
          return He(this.toKeyedSeq());
        },
        toOrderedSet: function() {
          return ei(f(this) ? this.valueSeq() : this);
        },
        toSet: function() {
          return Dr(f(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
          return new ur(this);
        },
        toSeq: function() {
          return h(this) ? this.toIndexedSeq() : f(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
          return Yr(f(this) ? this.valueSeq() : this);
        },
        toList: function() {
          return P(f(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
          return "[Iterable]";
        },
        __toString: function(d, E) {
          return this.size === 0 ? d + E : d + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + E;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
          var d = r.call(arguments, 0);
          return $t(this, ro(this, d));
        },
        includes: function(d) {
          return this.some(function(E) {
            return rr(E, d);
          });
        },
        entries: function() {
          return this.__iterator(re);
        },
        every: function(d, E) {
          qr(this.size);
          var R = !0;
          return this.__iterate(function(A, k, V) {
            if (!d.call(E, A, k, V))
              return R = !1, !1;
          }), R;
        },
        filter: function(d, E) {
          return $t(this, ls(this, d, E, !0));
        },
        find: function(d, E, R) {
          var A = this.findEntry(d, E);
          return A ? A[1] : R;
        },
        findEntry: function(d, E) {
          var R;
          return this.__iterate(function(A, k, V) {
            if (d.call(E, A, k, V))
              return R = [k, A], !1;
          }), R;
        },
        findLastEntry: function(d, E) {
          return this.toSeq().reverse().findEntry(d, E);
        },
        forEach: function(d, E) {
          return qr(this.size), this.__iterate(E ? d.bind(E) : d);
        },
        join: function(d) {
          qr(this.size), d = d !== void 0 ? "" + d : ",";
          var E = "", R = !0;
          return this.__iterate(function(A) {
            R ? R = !1 : E += d, E += A != null ? A.toString() : "";
          }), E;
        },
        keys: function() {
          return this.__iterator(le);
        },
        map: function(d, E) {
          return $t(this, bo(this, d, E));
        },
        reduce: function(d, E, R) {
          qr(this.size);
          var A, k;
          return arguments.length < 2 ? k = !0 : A = E, this.__iterate(function(V, ne, me) {
            k ? (k = !1, A = V) : A = d.call(R, A, V, ne, me);
          }), A;
        },
        reduceRight: function(d, E, R) {
          var A = this.toKeyedSeq().reverse();
          return A.reduce.apply(A, arguments);
        },
        reverse: function() {
          return $t(this, to(this, !0));
        },
        slice: function(d, E) {
          return $t(this, yt(this, d, E, !0));
        },
        some: function(d, E) {
          return !this.every(io(d), E);
        },
        sort: function(d) {
          return $t(this, Ri(this, d));
        },
        values: function() {
          return this.__iterator(J);
        },
        // ### More sequential methods
        butLast: function() {
          return this.slice(0, -1);
        },
        isEmpty: function() {
          return this.size !== void 0 ? this.size === 0 : !this.some(function() {
            return !0;
          });
        },
        count: function(d, E) {
          return Te(
            d ? this.toSeq().filter(d, E) : this
          );
        },
        countBy: function(d, E) {
          return Us(this, d, E);
        },
        equals: function(d) {
          return Tn(this, d);
        },
        entrySeq: function() {
          var d = this;
          if (d._cache)
            return new At(d._cache);
          var E = d.toSeq().map(Rp).toIndexedSeq();
          return E.fromEntrySeq = function() {
            return d.toSeq();
          }, E;
        },
        filterNot: function(d, E) {
          return this.filter(io(d), E);
        },
        findLast: function(d, E, R) {
          return this.toKeyedSeq().reverse().find(d, E, R);
        },
        first: function() {
          return this.find(Oe);
        },
        flatMap: function(d, E) {
          return $t(this, Gs(this, d, E));
        },
        flatten: function(d) {
          return $t(this, on(this, d, !0));
        },
        fromEntrySeq: function() {
          return new kr(this);
        },
        get: function(d, E) {
          return this.find(function(R, A) {
            return rr(A, d);
          }, void 0, E);
        },
        getIn: function(d, E) {
          for (var R = this, A = qs(d), k; !(k = A.next()).done; ) {
            var V = k.value;
            if (R = R && R.get ? R.get(V, z) : z, R === z)
              return E;
          }
          return R;
        },
        groupBy: function(d, E) {
          return Vr(this, d, E);
        },
        has: function(d) {
          return this.get(d, z) !== z;
        },
        hasIn: function(d) {
          return this.getIn(d, z) !== z;
        },
        isSubset: function(d) {
          return d = typeof d.includes == "function" ? d : i(d), this.every(function(E) {
            return d.includes(E);
          });
        },
        isSuperset: function(d) {
          return d = typeof d.isSubset == "function" ? d : i(d), d.isSubset(this);
        },
        keySeq: function() {
          return this.toSeq().map(Op).toIndexedSeq();
        },
        last: function() {
          return this.toSeq().reverse().first();
        },
        max: function(d) {
          return Ii(this, d);
        },
        maxBy: function(d, E) {
          return Ii(this, E, d);
        },
        min: function(d) {
          return Ii(this, d ? ad(d) : fu);
        },
        minBy: function(d, E) {
          return Ii(this, E ? ad(E) : fu, d);
        },
        rest: function() {
          return this.slice(1);
        },
        skip: function(d) {
          return this.slice(Math.max(0, d));
        },
        skipLast: function(d) {
          return $t(this, this.toSeq().reverse().skip(d).reverse());
        },
        skipWhile: function(d, E) {
          return $t(this, Qn(this, d, E, !0));
        },
        skipUntil: function(d, E) {
          return this.skipWhile(io(d), E);
        },
        sortBy: function(d, E) {
          return $t(this, Ri(this, E, d));
        },
        take: function(d) {
          return this.slice(0, Math.max(0, d));
        },
        takeLast: function(d) {
          return $t(this, this.toSeq().reverse().take(d).reverse());
        },
        takeWhile: function(d, E) {
          return $t(this, Hn(this, d, E));
        },
        takeUntil: function(d, E) {
          return this.takeWhile(io(d), E);
        },
        valueSeq: function() {
          return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
          return this.__hash || (this.__hash = _o(this));
        }
        // ### Internal
        // abstract __iterate(fn, reverse)
        // abstract __iterator(type, reverse)
      });
      var wn = i.prototype;
      wn[b] = !0, wn[Ae] = wn.values, wn.__toJS = wn.toArray, wn.__toStringMapper = sd, wn.inspect = wn.toSource = function() {
        return this.toString();
      }, wn.chain = wn.flatMap, wn.contains = wn.includes, function() {
        try {
          Object.defineProperty(wn, "length", {
            get: function() {
              if (!i.noLengthWarning) {
                var d;
                try {
                  throw new Error();
                } catch (E) {
                  d = E.stack;
                }
                if (d.indexOf("_wrapObject") === -1)
                  return console && console.warn && console.warn(
                    "iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + d
                  ), this.size;
              }
            }
          });
        } catch {
        }
      }(), Pi(o, {
        // ### More sequential methods
        flip: function() {
          return $t(this, yn(this));
        },
        findKey: function(d, E) {
          var R = this.findEntry(d, E);
          return R && R[0];
        },
        findLastKey: function(d, E) {
          return this.toSeq().reverse().findKey(d, E);
        },
        keyOf: function(d) {
          return this.findKey(function(E) {
            return rr(E, d);
          });
        },
        lastKeyOf: function(d) {
          return this.findLastKey(function(E) {
            return rr(E, d);
          });
        },
        mapEntries: function(d, E) {
          var R = this, A = 0;
          return $t(
            this,
            this.toSeq().map(
              function(k, V) {
                return d.call(E, [V, k], A++, R);
              }
            ).fromEntrySeq()
          );
        },
        mapKeys: function(d, E) {
          var R = this;
          return $t(
            this,
            this.toSeq().flip().map(
              function(A, k) {
                return d.call(E, A, k, R);
              }
            ).flip()
          );
        }
      });
      var Js = o.prototype;
      Js[p] = !0, Js[Ae] = wn.entries, Js.__toJS = wn.toObject, Js.__toStringMapper = function(d, E) {
        return JSON.stringify(E) + ": " + sd(d);
      }, Pi(s, {
        // ### Conversion to other types
        toKeyedSeq: function() {
          return new ft(this, !1);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(d, E) {
          return $t(this, ls(this, d, E, !1));
        },
        findIndex: function(d, E) {
          var R = this.findEntry(d, E);
          return R ? R[0] : -1;
        },
        indexOf: function(d) {
          var E = this.toKeyedSeq().keyOf(d);
          return E === void 0 ? -1 : E;
        },
        lastIndexOf: function(d) {
          var E = this.toKeyedSeq().reverse().keyOf(d);
          return E === void 0 ? -1 : E;
        },
        reverse: function() {
          return $t(this, to(this, !1));
        },
        slice: function(d, E) {
          return $t(this, yt(this, d, E, !1));
        },
        splice: function(d, E) {
          var R = arguments.length;
          if (E = Math.max(E | 0, 0), R === 0 || R === 2 && !E)
            return this;
          d = de(d, d < 0 ? this.count() : this.size);
          var A = this.slice(0, d);
          return $t(
            this,
            R === 1 ? A : A.concat(_e(arguments, 2), this.slice(d + E))
          );
        },
        // ### More collection methods
        findLastIndex: function(d, E) {
          var R = this.toKeyedSeq().findLastKey(d, E);
          return R === void 0 ? -1 : R;
        },
        first: function() {
          return this.get(0);
        },
        flatten: function(d) {
          return $t(this, on(this, d, !1));
        },
        get: function(d, E) {
          return d = fe(this, d), d < 0 || this.size === 1 / 0 || this.size !== void 0 && d > this.size ? E : this.find(function(R, A) {
            return A === d;
          }, void 0, E);
        },
        has: function(d) {
          return d = fe(this, d), d >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || d < this.size : this.indexOf(d) !== -1);
        },
        interpose: function(d) {
          return $t(this, wa(this, d));
        },
        interleave: function() {
          var d = [this].concat(_e(arguments)), E = Go(this.toSeq(), Ze.of, d), R = E.flatten(!0);
          return E.size && (R.size = E.size * d.length), $t(this, R);
        },
        last: function() {
          return this.get(-1);
        },
        skipWhile: function(d, E) {
          return $t(this, Qn(this, d, E, !1));
        },
        zip: function() {
          var d = [this].concat(_e(arguments));
          return $t(this, Go(this, du, d));
        },
        zipWith: function(d) {
          var E = _e(arguments);
          return E[0] = this, $t(this, Go(this, d, E));
        }
      }), s.prototype[v] = !0, s.prototype[w] = !0, Pi(l, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(d, E) {
          return this.has(d) ? d : E;
        },
        includes: function(d) {
          return this.has(d);
        },
        // ### More sequential methods
        keySeq: function() {
          return this.valueSeq();
        }
      }), l.prototype.has = wn.includes, Pi(rt, o.prototype), Pi(Ze, s.prototype), Pi(ht, l.prototype), Pi(Ji, o.prototype), Pi(di, s.prototype), Pi(dn, l.prototype);
      function Op(d, E) {
        return E;
      }
      function Rp(d, E) {
        return [E, d];
      }
      function io(d) {
        return function() {
          return !d.apply(this, arguments);
        };
      }
      function ad(d) {
        return function() {
          return -d.apply(this, arguments);
        };
      }
      function sd(d) {
        return typeof d == "string" ? JSON.stringify(d) : d;
      }
      function du() {
        return _e(arguments);
      }
      function fu(d, E) {
        return d < E ? 1 : d > E ? -1 : 0;
      }
      function _o(d) {
        if (d.size === 1 / 0)
          return 0;
        var E = S(d), R = f(d), A = E ? 1 : 0, k = d.__iterate(
          R ? E ? function(V, ne) {
            A = 31 * A + ld(rn(V), rn(ne)) | 0;
          } : function(V, ne) {
            A = A + ld(rn(V), rn(ne)) | 0;
          } : E ? function(V) {
            A = 31 * A + rn(V) | 0;
          } : function(V) {
            A = A + rn(V) | 0;
          }
        );
        return Zs(k, A);
      }
      function Zs(d, E) {
        return E = fi(E, 3432918353), E = fi(E << 15 | E >>> -15, 461845907), E = fi(E << 13 | E >>> -13, 5), E = (E + 3864292196 | 0) ^ d, E = fi(E ^ E >>> 16, 2246822507), E = fi(E ^ E >>> 13, 3266489909), E = Oi(E ^ E >>> 16), E;
      }
      function ld(d, E) {
        return d ^ E + 2654435769 + (d << 6) + (d >> 2) | 0;
      }
      var Ip = {
        Iterable: i,
        Seq: ae,
        Collection: vn,
        Map: Tt,
        OrderedMap: He,
        List: P,
        Stack: Yr,
        Set: Dr,
        OrderedSet: ei,
        Record: Jt,
        Range: Gr,
        Repeat: xr,
        is: rr,
        fromJS: hn
      };
      return Ip;
    });
  }(mf)), mf.exports;
}
var aa = $T(), In = {
  // This is used to represent a normal text block (paragraph).
  UNSTYLED: "unstyled",
  HEADER_ONE: "header-one",
  HEADER_TWO: "header-two",
  HEADER_THREE: "header-three",
  HEADER_FOUR: "header-four",
  HEADER_FIVE: "header-five",
  HEADER_SIX: "header-six",
  UNORDERED_LIST_ITEM: "unordered-list-item",
  ORDERED_LIST_ITEM: "ordered-list-item",
  BLOCKQUOTE: "blockquote",
  CODE: "code-block",
  ATOMIC: "atomic"
}, rS = {
  LINK: "LINK",
  IMAGE: "IMAGE"
}, $u = {
  BOLD: "BOLD",
  CODE: "CODE",
  ITALIC: "ITALIC",
  STRIKETHROUGH: "STRIKETHROUGH",
  UNDERLINE: "UNDERLINE"
};
new aa.OrderedSet();
var m8 = 1, y8 = 3, b8 = {
  a: 1,
  abbr: 1,
  area: 1,
  audio: 1,
  b: 1,
  bdi: 1,
  bdo: 1,
  br: 1,
  button: 1,
  canvas: 1,
  cite: 1,
  code: 1,
  command: 1,
  datalist: 1,
  del: 1,
  dfn: 1,
  em: 1,
  embed: 1,
  i: 1,
  iframe: 1,
  img: 1,
  input: 1,
  ins: 1,
  kbd: 1,
  keygen: 1,
  label: 1,
  map: 1,
  mark: 1,
  meter: 1,
  noscript: 1,
  object: 1,
  output: 1,
  progress: 1,
  q: 1,
  ruby: 1,
  s: 1,
  samp: 1,
  script: 1,
  select: 1,
  small: 1,
  span: 1,
  strong: 1,
  sub: 1,
  sup: 1,
  textarea: 1,
  time: 1,
  u: 1,
  var: 1,
  video: 1,
  wbr: 1,
  acronym: 1,
  applet: 1,
  basefont: 1,
  big: 1,
  font: 1,
  isindex: 1,
  strike: 1,
  style: 1,
  tt: 1
}, w8 = {
  area: 1,
  base: 1,
  br: 1,
  col: 1,
  colgroup: 1,
  command: 1,
  dl: 1,
  embed: 1,
  head: 1,
  hgroup: 1,
  hr: 1,
  iframe: 1,
  img: 1,
  input: 1,
  keygen: 1,
  link: 1,
  meta: 1,
  ol: 1,
  optgroup: 1,
  option: 1,
  param: 1,
  script: 1,
  select: 1,
  source: 1,
  style: 1,
  table: 1,
  tbody: 1,
  textarea: 1,
  tfoot: 1,
  thead: 1,
  title: 1,
  tr: 1,
  track: 1,
  ul: 1,
  wbr: 1,
  basefont: 1,
  dialog: 1,
  dir: 1,
  isindex: 1
}, x8 = {
  img: 1
};
function yf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yf = function(r) {
    return typeof r;
  } : yf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, yf(e);
}
function nS(e, t) {
  var r = Object.keys(e);
  return Object.getOwnPropertySymbols && r.push.apply(r, Object.getOwnPropertySymbols(e)), t && (r = r.filter(function(n) {
    return Object.getOwnPropertyDescriptor(e, n).enumerable;
  })), r;
}
function _8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nS(r, !0).forEach(function(n) {
      Os(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nS(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function S8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function C8(e, t, r) {
  return t && E8(e.prototype, t), e;
}
function Os(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var T8 = /^data:/i, O8 = aa.OrderedSet(), R8 = null, I8 = new IE({
  key: DE(),
  text: "",
  type: In.UNSTYLED,
  characterList: aa.List(),
  depth: 0
}), D8 = /(\r\n|\r|\n)/g, La = "\r", P8 = "​", M8 = /^data-([a-z0-9-]+)$/, iS = {
  a: {
    href: "url",
    rel: "rel",
    target: "target",
    title: "title"
  },
  img: {
    src: "src",
    alt: "alt",
    width: "width",
    height: "height"
  }
}, oS = function(t, r) {
  var n = {};
  if (iS.hasOwnProperty(t))
    for (var i = iS[t], o = 0; o < r.attributes.length; o++) {
      var s = r.attributes[o], l = s.name, c = s.value;
      if (typeof c == "string") {
        var f = c;
        if (i.hasOwnProperty(l)) {
          var h = i[l];
          n[h] = f;
        } else M8.test(l) && (n[l] = f);
      }
    }
  return n;
}, aS = {
  a: function(t, r, n) {
    var i = oS(r, n);
    if ($8(i.url))
      return t.createEntity(rS.LINK, i);
  },
  img: function(t, r, n) {
    var i = oS(r, n);
    if (i.src != null)
      return t.createEntity(rS.IMAGE, i);
  }
}, A8 = /* @__PURE__ */ function() {
  function e() {
    var t = this, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    S8(this, e), Os(this, "contentStateForEntities", void 0), Os(this, "blockStack", void 0), Os(this, "blockList", void 0), Os(this, "depth", void 0), Os(this, "options", void 0), Os(this, "inlineCreators", {
      Style: function(n) {
        function i(o) {
          return n.apply(this, arguments);
        }
        return i.toString = function() {
          return n.toString();
        }, i;
      }(function(n) {
        return {
          type: "STYLE",
          style: n
        };
      }),
      Entity: function(i, o) {
        var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "MUTABLE";
        return {
          type: "ENTITY",
          entityKey: t.createEntity(i, H8(o), s)
        };
      }
    }), this.options = r, this.contentStateForEntities = U0.createFromBlockArray([]), this.blockStack = [], this.blockList = [], this.depth = 0;
  }
  return C8(e, [{
    key: "process",
    value: function(r) {
      this.processBlockElement(r);
      var n = [];
      return this.blockList.forEach(function(i) {
        var o = B8(i.textFragments), s = o.text, l = o.characterMeta, c = !1;
        if (s === La && (c = !0, s = ""), i.tagName === "pre") {
          var f = N8(s, l);
          s = f.text, l = f.characterMeta;
        } else {
          var h = L8(s, l);
          s = h.text, l = h.characterMeta;
        }
        s = s.split(La).join(`
`), (s.length || c) && n.push(new IE({
          key: DE(),
          text: s,
          type: i.type,
          characterList: l.toList(),
          depth: i.depth,
          data: i.data ? aa.Map(i.data) : aa.Map()
        }));
      }), n.length || (n = [I8]), U0.createFromBlockArray(n, this.contentStateForEntities.getEntityMap());
    }
  }, {
    key: "getBlockTypeFromTagName",
    value: function(r) {
      var n = this.options.blockTypes;
      if (n && n[r])
        return n[r];
      switch (r) {
        case "li": {
          var i = this.blockStack.slice(-1)[0];
          return i.tagName === "ol" ? In.ORDERED_LIST_ITEM : In.UNORDERED_LIST_ITEM;
        }
        case "blockquote":
          return In.BLOCKQUOTE;
        case "h1":
          return In.HEADER_ONE;
        case "h2":
          return In.HEADER_TWO;
        case "h3":
          return In.HEADER_THREE;
        case "h4":
          return In.HEADER_FOUR;
        case "h5":
          return In.HEADER_FIVE;
        case "h6":
          return In.HEADER_SIX;
        case "pre":
          return In.CODE;
        case "figure":
          return In.ATOMIC;
        default:
          return In.UNSTYLED;
      }
    }
  }, {
    key: "processBlockElement",
    value: function(r) {
      if (r) {
        var n = this.options.customBlockFn, i = r.nodeName.toLowerCase(), o, s;
        if (n) {
          var l = n(r);
          l != null && (o = l.type, s = l.data);
        }
        var c = !0;
        if (o == null && (c = !1, o = this.getBlockTypeFromTagName(i)), o === In.CODE) {
          var f = r.getAttribute("data-language");
          f && (s = _8({}, s, {
            language: f
          }));
        }
        var h = z8(o), g = !w8.hasOwnProperty(i);
        if (!c && !W8(o)) {
          var S = this.blockStack.slice(-1)[0];
          S && (o = S.type);
        }
        var b = {
          tagName: i,
          textFragments: [],
          type: o,
          styleStack: [O8],
          entityStack: [R8],
          depth: h ? this.depth : 0,
          data: s
        };
        g && (this.blockList.push(b), h && (this.depth += 1)), this.blockStack.push(b), r.childNodes != null && Array.from(r.childNodes).forEach(this.processNode, this), this.blockStack.pop(), g && h && (this.depth -= 1);
      }
    }
  }, {
    key: "processInlineElement",
    value: function(r) {
      var n = r.nodeName.toLowerCase();
      if (n === "br") {
        this.processText(La);
        return;
      }
      var i = this.blockStack.slice(-1)[0], o = i.styleStack.slice(-1)[0], s = i.entityStack.slice(-1)[0], l = this.options.customInlineFn, c = l ? l(r, this.inlineCreators) : null;
      if (c != null)
        switch (c.type) {
          case "STYLE": {
            o = o.add(c.style);
            break;
          }
          case "ENTITY": {
            s = c.entityKey;
            break;
          }
        }
      else
        o = F8(o, n, this.options.elementStyles), aS.hasOwnProperty(n) && (s = aS[n](this, n, r) || s);
      i.styleStack.push(o), i.entityStack.push(s), r.childNodes != null && Array.from(r.childNodes).forEach(this.processNode, this), x8.hasOwnProperty(n) && this.processText(" "), i.entityStack.pop(), i.styleStack.pop();
    }
  }, {
    key: "processTextNode",
    value: function(r) {
      var n = r.nodeValue;
      n = n.replace(D8, `
`), n = n.split(P8).join(La), this.processText(n);
    }
  }, {
    key: "processText",
    value: function(r) {
      var n = this.blockStack.slice(-1)[0], i = n.styleStack.slice(-1)[0], o = n.entityStack.slice(-1)[0], s = ij.create({
        style: i,
        entity: o
      }), l = aa.Repeat(s, r.length);
      n.textFragments.push({
        text: r,
        characterMeta: l
      });
    }
  }, {
    key: "processNode",
    value: function(r) {
      if (r.nodeType === m8) {
        var n = r, i = n.nodeName.toLowerCase();
        b8.hasOwnProperty(i) ? this.processInlineElement(n) : this.processBlockElement(n);
      } else r.nodeType === y8 && this.processTextNode(r);
    }
  }, {
    key: "createEntity",
    value: function(r, n) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "MUTABLE";
      return this.contentStateForEntities = this.contentStateForEntities.createEntity(r, i, n), this.contentStateForEntities.getLastCreatedEntityKey();
    }
  }]), e;
}();
function N8(e, t) {
  return e.charAt(0) === `
` && (e = e.slice(1), t = t.slice(1)), {
    text: e,
    characterMeta: t
  };
}
function j8(e, t) {
  for (; e.charAt(0) === " "; )
    e = e.slice(1), t = t.slice(1);
  return {
    text: e,
    characterMeta: t
  };
}
function k8(e, t) {
  for (; e.slice(-1) === " "; )
    e = e.slice(0, -1), t = t.slice(0, -1);
  return {
    text: e,
    characterMeta: t
  };
}
function L8(e, t) {
  e = e.replace(/[ \t\n]/g, " ");
  var r = j8(e, t);
  e = r.text, t = r.characterMeta;
  var n = k8(e, t);
  e = n.text, t = n.characterMeta;
  for (var i = e.length; i--; )
    e.charAt(i) === " " && e.charAt(i - 1) === " " && (e = e.slice(0, i) + e.slice(i + 1), t = t.slice(0, i).concat(t.slice(i + 1)));
  var o = eS({
    text: e,
    characterMeta: t
  }, La + " ", La);
  e = o.text, t = o.characterMeta;
  var s = eS({
    text: e,
    characterMeta: t
  }, " " + La, La);
  return e = s.text, t = s.characterMeta, {
    text: e,
    characterMeta: t
  };
}
function z8(e) {
  switch (e) {
    case In.UNORDERED_LIST_ITEM:
    case In.ORDERED_LIST_ITEM:
      return !0;
    default:
      return !1;
  }
}
function B8(e) {
  var t = "", r = aa.Seq();
  return e.forEach(function(n) {
    t = t + n.text, r = r.concat(n.characterMeta);
  }), {
    text: t,
    characterMeta: r
  };
}
function F8(e, t, r) {
  switch (t) {
    case "b":
    case "strong":
      return e.add($u.BOLD);
    case "i":
    case "em":
      return e.add($u.ITALIC);
    case "u":
    case "ins":
      return e.add($u.UNDERLINE);
    case "code":
      return e.add($u.CODE);
    case "s":
    case "del":
      return e.add($u.STRIKETHROUGH);
    default:
      return r && r[t] ? e.add(r[t]) : e;
  }
}
function W8(e) {
  return e !== In.UNSTYLED;
}
function H8(e) {
  var t = {};
  if (e !== null && yf(e) === "object" && !Array.isArray(e))
    for (var r = e, n = 0, i = Object.keys(r); n < i.length; n++) {
      var o = i[n], s = r[o];
      typeof s == "string" && (t[o] = s);
    }
  return t;
}
function $8(e) {
  return !(e == null || e.match(T8));
}
function U8(e, t) {
  return new A8(t).process(e);
}
function G8(e) {
  var t;
  if (typeof DOMParser < "u") {
    var r = new DOMParser();
    t = r.parseFromString(e, "text/html");
  } else
    t = document.implementation.createHTMLDocument(""), t.documentElement && (t.documentElement.innerHTML = e);
  return t.body || t.createElement("body");
}
function q8(e, t) {
  if (e == null) return {};
  var r = V8(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function V8(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var Y8 = {};
function K8(e, t) {
  var r = Y8, n = r.parser, i = q8(r, ["parser"]);
  n == null && (n = G8);
  var o = n(e);
  return U8(o, i);
}
const X8 = (e) => {
  try {
    return JSON.parse(e || "");
  } catch {
    return null;
  }
}, J8 = (e) => {
  try {
    return JSON.parse(e || "").blocks.reduce(
      (r, { text: n }, i, o) => `${r}${n}${i === o.length - 1 ? "" : `
`}`,
      ""
    );
  } catch {
    return null;
  }
}, uZ = function(e) {
  return e ? kl(e).getCurrentContent().hasText() : !1;
}, rm = (e) => e.getCurrentContent().hasText() ? JSON.stringify(JSON.parse(AE(e))) : "", UT = async (e) => {
  let t;
  if (typeof navigator.clipboard.read != "function")
    throw new Error("Navigateur incompatible avec cette fonctionnalité");
  try {
    const [i] = await navigator.clipboard.read(), o = await i.getType("text/html");
    t = await new Response(o).text();
  } catch {
    console.error(
      "Erreur lors de la lecture du press-papiers, merci de vérifier les autorisations, chrome://settings/content/clipboard"
    );
  }
  if (!t)
    return e;
  const r = K8(t), n = np.replaceWithFragment(
    e.getCurrentContent(),
    e.getSelection(),
    r.getBlockMap()
  );
  return Fc.push(e, n, "insert-fragment");
}, Z8 = Rt((e) => ({
  counter: {
    display: "block",
    textAlign: "right",
    color: e.palette.grey[600],
    marginTop: e.spacing(1),
    transition: "opacity 0.3s"
  },
  counterHidden: {
    opacity: 0
  }
})), Q8 = ({ content: e, type: t }) => {
  const r = Z8(), n = t === "Draft" ? J8(e) : e;
  return /* @__PURE__ */ y.jsx(
    Lt,
    {
      className: nt(r.counter, !n && r.counterHidden),
      variant: "caption",
      component: "span",
      children: Cj(n)
    }
  );
};
var Cg = { exports: {} }, sS;
function eY() {
  return sS || (sS = 1, function(e, t) {
    (function(r, n) {
      e.exports = n(nj, $T());
    })(window, function(r, n) {
      return s = {}, i.m = o = [function(l, c) {
        l.exports = r;
      }, function(l, c) {
        l.exports = n;
      }, function(l, c, f) {
        l.exports = f(3);
      }, function(l, c, f) {
        f.r(c);
        var h = f(0), g = f(1);
        function S(X) {
          var ie = X.getSelection(), Ie = X.getCurrentContent(), xe = ie.getStartKey(), Pe = ie.getEndKey(), ae = Ie.getBlockMap();
          return ae.toSeq().skipUntil(function(rt, Ze) {
            return Ze === xe;
          }).takeUntil(function(rt, Ze) {
            return Ze === Pe;
          }).concat([[Pe, ae.get(Pe)]]);
        }
        function b(X) {
          return S(X).toList();
        }
        function p(X) {
          if (X) return b(X).get(0);
        }
        function v(X) {
          if (X) {
            var ie = p(X), Ie = X.getCurrentContent().getBlockMap().toSeq().toList(), xe = 0;
            if (Ie.forEach(function(Pe, ae) {
              Pe.get("key") === ie.get("key") && (xe = ae - 1);
            }), -1 < xe) return Ie.get(xe);
          }
        }
        function w(X) {
          return X ? X.getCurrentContent().getBlockMap().toList() : new g.List();
        }
        function C(X) {
          var ie = b(X);
          if (!ie.some(function(Ie) {
            return Ie.type !== ie.get(0).type;
          })) return ie.get(0).type;
        }
        function M(X) {
          var ie = h.RichUtils.tryToRemoveBlockStyle(X);
          return ie ? h.EditorState.push(X, ie, "change-block-type") : X;
        }
        function L(X) {
          var ie = "", Ie = X.getSelection(), xe = Ie.getAnchorOffset(), Pe = Ie.getFocusOffset(), ae = b(X);
          if (0 < ae.size) {
            if (Ie.getIsBackward()) {
              var rt = xe;
              xe = Pe, Pe = rt;
            }
            for (var Ze = 0; Ze < ae.size; Ze += 1) {
              var ht = Ze === 0 ? xe : 0, mt = Ze === ae.size - 1 ? Pe : ae.get(Ze).getText().length;
              ie += ae.get(Ze).getText().slice(ht, mt);
            }
          }
          return ie;
        }
        function W(X) {
          var ie = X.getCurrentContent(), Ie = X.getSelection(), xe = h.Modifier.removeRange(ie, Ie, "forward"), Pe = xe.getSelectionAfter(), ae = xe.getBlockForKey(Pe.getStartKey());
          return xe = h.Modifier.insertText(xe, Pe, `
`, ae.getInlineStyleAt(Pe.getStartOffset()), null), h.EditorState.push(X, xe, "insert-fragment");
        }
        function z(X) {
          var ie = h.Modifier.splitBlock(X.getCurrentContent(), X.getSelection());
          return M(h.EditorState.push(X, ie, "split-block"));
        }
        function B(X) {
          var ie = X.getCurrentContent().getBlockMap().toList(), Ie = X.getSelection().merge({ anchorKey: ie.first().get("key"), anchorOffset: 0, focusKey: ie.last().get("key"), focusOffset: ie.last().getLength() }), xe = h.Modifier.removeRange(X.getCurrentContent(), Ie, "forward");
          return h.EditorState.push(X, xe, "remove-range");
        }
        function K(X, ie) {
          var Ie = h.Modifier.setBlockData(X.getCurrentContent(), X.getSelection(), ie);
          return h.EditorState.push(X, Ie, "change-block-data");
        }
        function Z(X) {
          var ie = new g.Map({}), Ie = b(X);
          if (Ie && 0 < Ie.size) for (var xe = function(ae) {
            var rt = Ie.get(ae).getData();
            if (!rt || rt.size === 0) return ie = ie.clear(), "break";
            if (ae === 0) ie = rt;
            else if (ie.forEach(function(Ze, ht) {
              rt.get(ht) && rt.get(ht) === Ze || (ie = ie.delete(ht));
            }), ie.size === 0) return ie = ie.clear(), "break";
          }, Pe = 0; Pe < Ie.size && xe(Pe) !== "break"; Pe += 1)
            ;
          return ie;
        }
        var ee = Object(g.Map)({ code: { element: "pre" } }), he = h.DefaultDraftBlockRenderMap.merge(ee);
        function _e(X) {
          if (X) {
            var ie = X.getType();
            return ie === "unordered-list-item" || ie === "ordered-list-item";
          }
          return !1;
        }
        function Te(X, ie, Ie) {
          var xe, Pe = X.getSelection();
          xe = Pe.getIsBackward() ? Pe.getFocusKey() : Pe.getAnchorKey();
          var ae = X.getCurrentContent(), rt = ae.getBlockForKey(xe), Ze = rt.getType();
          if (Ze !== "unordered-list-item" && Ze !== "ordered-list-item") return X;
          var ht = ae.getBlockBefore(xe);
          if (!ht || ht.getType() !== Ze) return X;
          var mt = rt.getDepth();
          if (ie === 1 && mt === Ie) return X;
          var At, Bt, Gt, It, sr, et, at, Qt = Math.min(ht.getDepth() + 1, Ie), pr = (Bt = ie, Gt = Qt, It = (At = X).getSelection(), sr = At.getCurrentContent(), et = sr.getBlockMap(), at = S(At).map(function(wr) {
            var gt = wr.getDepth() + Bt;
            return gt = Math.max(0, Math.min(gt, Gt)), wr.set("depth", gt);
          }), et = et.merge(at), sr.merge({ blockMap: et, selectionBefore: It, selectionAfter: It }));
          return h.EditorState.push(X, pr, "adjust-depth");
        }
        function fe(X, ie) {
          var Ie;
          return (Ie = ie).which === 13 && (Ie.getModifierState("Shift") || Ie.getModifierState("Alt") || Ie.getModifierState("Control")) ? X.getSelection().isCollapsed() ? h.RichUtils.insertSoftNewline(X) : W(X) : function(xe) {
            var Pe = xe.getSelection();
            if (Pe.isCollapsed()) {
              var ae = xe.getCurrentContent(), rt = Pe.getStartKey(), Ze = ae.getBlockForKey(rt);
              if (!_e(Ze) && Ze.getType() !== "unstyled" && Ze.getLength() === Pe.getStartOffset()) return z(xe);
              if (_e(Ze) && Ze.getLength() === 0) {
                var ht = Ze.getDepth();
                if (ht === 0) return M(xe);
                if (0 < ht) return Te(xe, -1, ht);
              }
            }
          }(X);
        }
        function Oe(X, ie) {
          var Ie = Object.keys(X);
          if (Object.getOwnPropertySymbols) {
            var xe = Object.getOwnPropertySymbols(X);
            ie && (xe = xe.filter(function(Pe) {
              return Object.getOwnPropertyDescriptor(X, Pe).enumerable;
            })), Ie.push.apply(Ie, xe);
          }
          return Ie;
        }
        function ye(X, ie, Ie) {
          return ie in X ? Object.defineProperty(X, ie, { value: Ie, enumerable: !0, configurable: !0, writable: !0 }) : X[ie] = Ie, X;
        }
        function de(X) {
          return (de = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
            return typeof ie;
          } : function(ie) {
            return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
          })(X);
        }
        function ce(X) {
          var ie = X.getSelection();
          if (ie.isCollapsed()) {
            var Ie = {}, xe = X.getCurrentInlineStyle().toList().toJS();
            if (xe) return ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "CODE", "SUPERSCRIPT", "SUBSCRIPT"].forEach(function(ht) {
              Ie[ht] = 0 <= xe.indexOf(ht);
            }), Ie;
          }
          var Pe = ie.getStartOffset(), ae = ie.getEndOffset(), rt = b(X);
          if (0 < rt.size) {
            var Ze = function() {
              for (var ht = { BOLD: !0, ITALIC: !0, UNDERLINE: !0, STRIKETHROUGH: !0, CODE: !0, SUPERSCRIPT: !0, SUBSCRIPT: !0 }, mt = 0; mt < rt.size; mt += 1) {
                var At = mt === 0 ? Pe : 0, Bt = mt === rt.size - 1 ? ae : rt.get(mt).getText().length;
                At === Bt && At === 0 ? (At = 1, Bt = 2) : At === Bt && --At;
                for (var Gt = function(sr) {
                  var et = rt.get(mt).getInlineStyleAt(sr);
                  ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "CODE", "SUPERSCRIPT", "SUBSCRIPT"].forEach(function(at) {
                    ht[at] = ht[at] && et.get(at) === at;
                  });
                }, It = At; It < Bt; It += 1) Gt(It);
              }
              return { v: ht };
            }();
            if (de(Ze) === "object") return Ze.v;
          }
          return {};
        }
        function Fe(X) {
          var ie, Ie = X.getSelection(), xe = Ie.getStartOffset(), Pe = Ie.getEndOffset();
          xe === Pe && xe === 0 ? Pe = 1 : xe === Pe && --xe;
          for (var ae = p(X), rt = xe; rt < Pe; rt += 1) {
            var Ze = ae.getEntityAt(rt);
            if (!Ze) {
              ie = void 0;
              break;
            }
            if (rt === xe) ie = Ze;
            else if (ie !== Ze) {
              ie = void 0;
              break;
            }
          }
          return ie;
        }
        function le(X, ie) {
          var Ie, xe = p(X);
          return xe.findEntityRanges(function(Pe) {
            return Pe.get("entity") === ie;
          }, function(Pe, ae) {
            Ie = { start: Pe, end: ae, text: xe.get("text").slice(Pe, ae) };
          }), Ie;
        }
        function J(X, ie, Ie) {
          be[X]["".concat(X.toLowerCase(), "-").concat(Ie)] = ye({}, "".concat(ie), Ie);
        }
        function re() {
          return function(X) {
            for (var ie = 1; ie < arguments.length; ie++) {
              var Ie = arguments[ie] != null ? arguments[ie] : {};
              ie % 2 ? Oe(Object(Ie), !0).forEach(function(xe) {
                ye(X, xe, Ie[xe]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(X, Object.getOwnPropertyDescriptors(Ie)) : Oe(Object(Ie)).forEach(function(xe) {
                Object.defineProperty(X, xe, Object.getOwnPropertyDescriptor(Ie, xe));
              });
            }
            return X;
          }({}, be.color, {}, be.bgcolor, {}, be.fontSize, {}, be.fontFamily, { CODE: be.CODE, SUPERSCRIPT: be.SUPERSCRIPT, SUBSCRIPT: be.SUBSCRIPT });
        }
        var be = { color: {}, bgcolor: {}, fontSize: {}, fontFamily: {}, CODE: { fontFamily: "monospace", wordWrap: "break-word", background: "#f1f1f1", borderRadius: 3, padding: "1px 3px" }, SUPERSCRIPT: { fontSize: 11, position: "relative", top: -8, display: "inline-flex" }, SUBSCRIPT: { fontSize: 11, position: "relative", bottom: -8, display: "inline-flex" } };
        function Me(X, ie, Ie) {
          var xe = X.getSelection(), Pe = Object.keys(be[ie]).reduce(function(ht, mt) {
            return h.Modifier.removeInlineStyle(ht, xe, mt);
          }, X.getCurrentContent()), ae = h.EditorState.push(X, Pe, "changeinline-style"), rt = X.getCurrentInlineStyle();
          if (xe.isCollapsed() && (ae = rt.reduce(function(ht, mt) {
            return h.RichUtils.toggleInlineStyle(ht, mt);
          }, ae)), ie === "SUPERSCRIPT" || ie == "SUBSCRIPT") rt.has(Ie) || (ae = h.RichUtils.toggleInlineStyle(ae, Ie));
          else {
            var Ze = ie === "bgcolor" ? "backgroundColor" : ie;
            rt.has("".concat(Ze, "-").concat(Ie)) || (ae = h.RichUtils.toggleInlineStyle(ae, "".concat(ie.toLowerCase(), "-").concat(Ie)), J(ie, Ze, Ie));
          }
          return ae;
        }
        function Ae(X) {
          X && X.getCurrentContent().getBlockMap().map(function(ie) {
            return ie.get("characterList");
          }).toList().flatten().forEach(function(ie) {
            ie && ie.indexOf("color-") === 0 ? J("color", "color", ie.substr(6)) : ie && ie.indexOf("bgcolor-") === 0 ? J("bgcolor", "backgroundColor", ie.substr(8)) : ie && ie.indexOf("fontsize-") === 0 ? J("fontSize", "fontSize", +ie.substr(9)) : ie && ie.indexOf("fontfamily-") === 0 && J("fontFamily", "fontFamily", ie.substr(11));
          });
        }
        function Re(X, ie, Ie) {
          var xe = X.getInlineStyleAt(Ie).toList().filter(function(Pe) {
            return Pe.startsWith(ie.toLowerCase());
          });
          if (xe && 0 < xe.size) return xe.get(0);
        }
        function Ee(X, ie) {
          if (X && ie && 0 < ie.length) {
            var Ie = function() {
              var xe = X.getSelection(), Pe = {};
              if (xe.isCollapsed()) return ie.forEach(function(At) {
                Pe[At] = function(Bt, Gt) {
                  var It = Bt.getCurrentInlineStyle().toList().filter(function(sr) {
                    return sr.startsWith(Gt.toLowerCase());
                  });
                  if (It && 0 < It.size) return It.get(0);
                }(X, At);
              }), { v: Pe };
              var ae = xe.getStartOffset(), rt = xe.getEndOffset(), Ze = b(X);
              if (0 < Ze.size) {
                for (var ht = function(At) {
                  var Bt = At === 0 ? ae : 0, Gt = At === Ze.size - 1 ? rt : Ze.get(At).getText().length;
                  Bt === Gt && Bt === 0 ? (Bt = 1, Gt = 2) : Bt === Gt && --Bt;
                  for (var It = function(et) {
                    et === Bt ? ie.forEach(function(at) {
                      Pe[at] = Re(Ze.get(At), at, et);
                    }) : ie.forEach(function(at) {
                      Pe[at] && Pe[at] !== Re(Ze.get(At), at, et) && (Pe[at] = void 0);
                    });
                  }, sr = Bt; sr < Gt; sr += 1) It(sr);
                }, mt = 0; mt < Ze.size; mt += 1) ht(mt);
                return { v: Pe };
              }
            }();
            if (de(Ie) === "object") return Ie.v;
          }
          return {};
        }
        function Ce(X) {
          var ie = X.getCurrentInlineStyle(), Ie = X.getCurrentContent();
          return ie.forEach(function(xe) {
            Ie = h.Modifier.removeInlineStyle(Ie, X.getSelection(), xe);
          }), h.EditorState.push(X, Ie, "change-inline-style");
        }
        f.d(c, "isListBlock", function() {
          return _e;
        }), f.d(c, "changeDepth", function() {
          return Te;
        }), f.d(c, "handleNewLine", function() {
          return fe;
        }), f.d(c, "getEntityRange", function() {
          return le;
        }), f.d(c, "getCustomStyleMap", function() {
          return re;
        }), f.d(c, "toggleCustomInlineStyle", function() {
          return Me;
        }), f.d(c, "getSelectionEntity", function() {
          return Fe;
        }), f.d(c, "extractInlineStyle", function() {
          return Ae;
        }), f.d(c, "removeAllInlineStyles", function() {
          return Ce;
        }), f.d(c, "getSelectionInlineStyle", function() {
          return ce;
        }), f.d(c, "getSelectionCustomInlineStyle", function() {
          return Ee;
        }), f.d(c, "getSelectedBlocksMap", function() {
          return S;
        }), f.d(c, "getSelectedBlocksList", function() {
          return b;
        }), f.d(c, "getSelectedBlock", function() {
          return p;
        }), f.d(c, "getBlockBeforeSelectedBlock", function() {
          return v;
        }), f.d(c, "getAllBlocks", function() {
          return w;
        }), f.d(c, "getSelectedBlocksType", function() {
          return C;
        }), f.d(c, "removeSelectedBlocksStyle", function() {
          return M;
        }), f.d(c, "getSelectionText", function() {
          return L;
        }), f.d(c, "addLineBreakRemovingSelection", function() {
          return W;
        }), f.d(c, "insertNewUnstyledBlock", function() {
          return z;
        }), f.d(c, "clearEditorContent", function() {
          return B;
        }), f.d(c, "setBlockData", function() {
          return K;
        }), f.d(c, "getSelectedBlocksMetadata", function() {
          return Z;
        }), f.d(c, "blockRenderMap", function() {
          return he;
        });
      }], i.c = s, i.d = function(l, c, f) {
        i.o(l, c) || Object.defineProperty(l, c, { enumerable: !0, get: f });
      }, i.r = function(l) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
      }, i.t = function(l, c) {
        if (1 & c && (l = i(l)), 8 & c || 4 & c && typeof l == "object" && l && l.__esModule) return l;
        var f = /* @__PURE__ */ Object.create(null);
        if (i.r(f), Object.defineProperty(f, "default", { enumerable: !0, value: l }), 2 & c && typeof l != "string") for (var h in l) i.d(f, h, (function(g) {
          return l[g];
        }).bind(null, h));
        return f;
      }, i.n = function(l) {
        var c = l && l.__esModule ? function() {
          return l.default;
        } : function() {
          return l;
        };
        return i.d(c, "a", c), c;
      }, i.o = function(l, c) {
        return Object.prototype.hasOwnProperty.call(l, c);
      }, i.p = "", i(i.s = 2);
      function i(l) {
        if (s[l]) return s[l].exports;
        var c = s[l] = { i: l, l: !1, exports: {} };
        return o[l].call(c.exports, c, c.exports, i), c.l = !0, c.exports;
      }
      var o, s;
    });
  }(Cg)), Cg.exports;
}
var tY = eY(), Tg = {}, Og = {}, Rg = {}, lS;
function rY() {
  return lS || (lS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("title", null, "Bold"), t.default.createElement("path", {
            d: "M15.6 11.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 7.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Rg)), Rg;
}
var Ig = {}, uS;
function nY() {
  return uS || (uS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M10 5v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V5z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Ig)), Ig;
}
var Dg = {}, cS;
function iY() {
  return cS || (cS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7zM2 17h3.002v2H2v-2zm0-6h3.002v2H2v-2zm0-6h3.002v2H2V5z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Dg)), Dg;
}
var Pg = {}, dS;
function oY() {
  return dS || (dS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M4 17v.5H3v1h1v.5H2v1h3v-4H2v1h2zM3 8h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Pg)), Pg;
}
var Mg = {}, fS;
function aY() {
  return fS || (fS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M5 5v3h5v11h3V8h5V5z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Mg)), Mg;
}
var Ag = {}, pS;
function sY() {
  return pS || (pS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M6 17h3l2-4V7H5v6h3l-2 4zm8 0h3l2-4V7h-6v6h3l-2 4z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Ag)), Ag;
}
var Ng = {}, hS;
function lY() {
  return hS || (hS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("path", {
            d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Ng)), Ng;
}
var jg = {}, gS;
function uY() {
  return gS || (gS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M11 6h2v12h-2z"
          }), t.default.createElement("path", {
            d: "M18 11v2H6v-2z"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(jg)), jg;
}
var kg = {}, vS;
function cY() {
  return vS || (vS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("path", {
            d: "M18.222 6H5.778C4.8 6 4 6.6 4 7.333v9.334C4 17.4 4.8 18 5.778 18h12.444C19.2 18 20 17.4 20 16.667V7.333C20 6.6 19.2 6 18.222 6zm-4.084 4l-3 4.51L9 11.503 6 16h12l-3.862-6z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(kg)), kg;
}
var Lg = {}, mS;
function dY() {
  return mS || (mS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("path", {
            fill: "currentColor",
            d: "M10 9v6l5-3-5-3zm8.222-3H5.778C4.8 6 4 6.6 4 7.333v9.334C4 17.4 4.8 18 5.778 18h12.444C19.2 18 20 17.4 20 16.667V7.333C20 6.6 19.2 6 18.222 6z",
            fillRule: "evenodd"
          }));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Lg)), Lg;
}
var zg = {}, yS;
function fY() {
  return yS || (yS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("path", {
            fill: "none",
            d: "M-1-1h26v26H-1z"
          }), t.default.createElement("g", {
            fillRule: "evenodd",
            fill: "none"
          }, t.default.createElement("path", {
            fill: "currentColor",
            d: "M3.125 17.375v3.75h3.75l11.06-11.06-3.75-3.75-11.06 11.06zm17.71-10.21a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
          }), t.default.createElement("path", {
            d: "M.125.125h24v24h-24v-24z"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(zg)), zg;
}
var Bg = {}, bS;
function pY() {
  return bS || (bS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0z"
          }), t.default.createElement("path", {
            d: "M7 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H7v10zM18 5h-3l-1-1h-4L9 5H6v2h12V5z",
            fill: "currentColor"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Bg)), Bg;
}
var Fg = {}, wS;
function hY() {
  return wS || (wS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0V0zm0 0h24v24H0V0z"
          }), t.default.createElement("path", {
            d: "M16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8zm8 4h2v1h-2v-1zM6 3h2v1H6V3zm14 13h1v2h-1v-2zM3 6h1v2H3V6z",
            fill: "currentColor"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Fg)), Fg;
}
var Wg = {}, xS;
function gY() {
  return xS || (xS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("title", null, "Artboard 1"), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0z"
          }), t.default.createElement("path", {
            d: "M3 21h18v-3H3v3zM21.842 8H2.158C1.52 8 1 8.45 1 9v6c0 .55.521 1 1.158 1h19.684C22.48 16 23 15.55 23 15V9c0-.55-.521-1-1.158-1zM3 3v3h18V3H3z",
            fill: "currentColor"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Wg)), Wg;
}
var Hg = {}, _S;
function vY() {
  return _S || (_S = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("title", null, "Artboard 1"), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0z"
          }), t.default.createElement("path", {
            d: "M3 21h18v-3H3v3zM20.053 8H3.947C3.427 8 3 8.45 3 9v6c0 .55.426 1 .947 1h16.106c.52 0 .947-.45.947-1V9c0-.55-.426-1-.947-1zM3 3v3h18V3H3z",
            fill: "currentColor"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Hg)), Hg;
}
var $g = {}, SS;
function mY() {
  return SS || (SS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("title", null, "Artboard 1"), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0z"
          }), t.default.createElement("path", {
            d: "M12 17h9v-2h-9v2zm-9 4h18v-2H3v2zM3 3v2h18V3H3zm9 6h9V7h-9v2zm0 4h9v-2h-9v2zM3 7.995C3 7.445 3.438 7 4.003 7h4.994C9.551 7 10 7.456 10 7.995v8.01c0 .55-.438.995-1.003.995H4.003A1.006 1.006 0 0 1 3 16.005v-8.01z",
            fill: "currentColor"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }($g)), $g;
}
var Ug = {}, ES;
function yY() {
  return ES || (ES = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M0 0h24v24H0z"
          }), t.default.createElement("path", {
            fill: "currentColor",
            d: "M8 10l4 4 4-4z"
          })));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Ug)), Ug;
}
var Gg = {}, CS;
function bY() {
  return CS || (CS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function n(v) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(C) {
        return typeof C;
      } : n = function(C) {
        return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
      }, n(v);
    }
    function i() {
      return i = Object.assign || function(v) {
        for (var w = 1; w < arguments.length; w++) {
          var C = arguments[w];
          for (var M in C)
            Object.prototype.hasOwnProperty.call(C, M) && (v[M] = C[M]);
        }
        return v;
      }, i.apply(this, arguments);
    }
    function o(v, w, C) {
      return w in v ? Object.defineProperty(v, w, { value: C, enumerable: !0, configurable: !0, writable: !0 }) : v[w] = C, v;
    }
    function s(v, w) {
      if (!(v instanceof w))
        throw new TypeError("Cannot call a class as a function");
    }
    function l(v, w) {
      for (var C = 0; C < w.length; C++) {
        var M = w[C];
        M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(v, M.key, M);
      }
    }
    function c(v, w, C) {
      return w && l(v.prototype, w), v;
    }
    function f(v, w) {
      return w && (n(w) === "object" || typeof w == "function") ? w : h(v);
    }
    function h(v) {
      if (v === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return v;
    }
    function g(v) {
      return g = Object.setPrototypeOf ? Object.getPrototypeOf : function(C) {
        return C.__proto__ || Object.getPrototypeOf(C);
      }, g(v);
    }
    function S(v, w) {
      if (typeof w != "function" && w !== null)
        throw new TypeError("Super expression must either be null or a function");
      v.prototype = Object.create(w && w.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), w && b(v, w);
    }
    function b(v, w) {
      return b = Object.setPrototypeOf || function(M, L) {
        return M.__proto__ = L, M;
      }, b(v, w);
    }
    var p = /* @__PURE__ */ function(v) {
      S(w, v);
      function w() {
        return s(this, w), f(this, g(w).apply(this, arguments));
      }
      return c(w, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("path", o({
            fill: "currentColor",
            d: "M0 0h24v24H0z"
          }, "fill", "none")), t.default.createElement("path", {
            fill: "currentColor",
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          }));
        }
      }]), w;
    }(t.default.Component);
    e.default = p;
  }(Gg)), Gg;
}
var qg = {}, TS;
function wY() {
  return TS || (TS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M15.027 11l.974.972V11z"
          }), t.default.createElement("path", {
            d: "M22 12c0-2.754-2.24-5-5-5h-4v2h4c1.71-.095 3.1 1.3 3 3 .1 1.121-.484 2.087-1 3l1 1a5 5 0 0 0 2-4M7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2H7c-1.71.1-3.1-1.291-3-3-.1-1.71 1.29-3.1 3-3h3L8 7H7zM13 15.099v1.9h4c.37 0 .729-.046 1.076-.123l-1.777-1.777H13z"
          }), t.default.createElement("path", {
            d: "M8 11v2h8v-2z"
          }), t.default.createElement("path", {
            d: "M4.269 3l-1.27 1.27 12.658 12.657-.117-.107L19.73 21l1.269-1.27z"
          })));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(qg)), qg;
}
var Vg = {}, OS;
function xY() {
  return OS || (OS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function n(b) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(v) {
        return typeof v;
      } : n = function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, n(b);
    }
    function i(b, p) {
      if (!(b instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(b, p) {
      for (var v = 0; v < p.length; v++) {
        var w = p[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
      }
    }
    function s(b, p, v) {
      return p && o(b.prototype, p), b;
    }
    function l(b, p) {
      return p && (n(p) === "object" || typeof p == "function") ? p : c(b);
    }
    function c(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function f(b) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, f(b);
    }
    function h(b, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(p && p.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), p && g(b, p);
    }
    function g(b, p) {
      return g = Object.setPrototypeOf || function(w, C) {
        return w.__proto__ = C, w;
      }, g(b, p);
    }
    var S = /* @__PURE__ */ function(b) {
      h(p, b);
      function p() {
        return i(this, p), l(this, f(p).apply(this, arguments));
      }
      return s(p, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, t.default.createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
          }, t.default.createElement("path", {
            d: "M16.95 5.636l1.414 1.414L7.05 18.364 5.636 16.95z"
          }), t.default.createElement("path", {
            d: "M16.95 18.364l1.414-1.414L7.05 5.636 5.636 7.05z"
          })));
        }
      }]), p;
    }(t.default.Component);
    e.default = S;
  }(Vg)), Vg;
}
var Yg = {}, RS;
function _Y() {
  return RS || (RS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = r(dt);
    function r(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function n(p) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(w) {
        return typeof w;
      } : n = function(w) {
        return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
      }, n(p);
    }
    function i() {
      return i = Object.assign || function(p) {
        for (var v = 1; v < arguments.length; v++) {
          var w = arguments[v];
          for (var C in w)
            Object.prototype.hasOwnProperty.call(w, C) && (p[C] = w[C]);
        }
        return p;
      }, i.apply(this, arguments);
    }
    function o(p, v) {
      if (!(p instanceof v))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(p, v) {
      for (var w = 0; w < v.length; w++) {
        var C = v[w];
        C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(p, C.key, C);
      }
    }
    function l(p, v, w) {
      return v && s(p.prototype, v), p;
    }
    function c(p, v) {
      return v && (n(v) === "object" || typeof v == "function") ? v : f(p);
    }
    function f(p) {
      if (p === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    function h(p) {
      return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
        return w.__proto__ || Object.getPrototypeOf(w);
      }, h(p);
    }
    function g(p, v) {
      if (typeof v != "function" && v !== null)
        throw new TypeError("Super expression must either be null or a function");
      p.prototype = Object.create(v && v.prototype, { constructor: { value: p, writable: !0, configurable: !0 } }), v && S(p, v);
    }
    function S(p, v) {
      return S = Object.setPrototypeOf || function(C, M) {
        return C.__proto__ = M, C;
      }, S(p, v);
    }
    var b = /* @__PURE__ */ function(p) {
      g(v, p);
      function v() {
        return o(this, v), c(this, h(v).apply(this, arguments));
      }
      return l(v, [{
        key: "render",
        value: function() {
          return t.default.createElement("svg", i({}, this.props, {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }), t.default.createElement("path", {
            d: "M6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
            fill: "currentColor",
            fillRule: "evenodd"
          }));
        }
      }]), v;
    }(t.default.Component);
    e.default = b;
  }(Yg)), Yg;
}
var IS;
function SY() {
  return IS || (IS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = B(rY()), r = B(nY()), n = B(iY()), i = B(oY()), o = B(aY()), s = B(sY()), l = B(lY()), c = B(uY()), f = B(cY()), h = B(dY()), g = B(fY()), S = B(pY()), b = B(hY()), p = B(gY()), v = B(vY()), w = B(mY()), C = B(yY()), M = B(bY()), L = B(wY()), W = B(xY()), z = B(_Y());
    function B(ee) {
      return ee && ee.__esModule ? ee : { default: ee };
    }
    var K = {
      BoldIcon: t.default,
      ItalicIcon: r.default,
      ULIcon: n.default,
      OLIcon: i.default,
      H2Icon: o.default,
      BlockQuoteIcon: s.default,
      LinkIcon: l.default,
      CrossIcon: c.default,
      ImageIcon: f.default,
      VideoIcon: h.default,
      EditIcon: g.default,
      DeleteIcon: S.default,
      CropIcon: b.default,
      MediaBigIcon: p.default,
      MediaMediumIcon: v.default,
      MediaSmallIcon: w.default,
      DropdownArrow: C.default,
      ErrorIcon: M.default,
      UnlinkIcon: L.default,
      CloseIcon: W.default,
      MoreIcon: z.default
    }, Z = K;
    e.default = Z;
  }(Og)), Og;
}
var DS;
function EY() {
  return DS || (DS = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = o(dt), r = n(SY());
    function n(C) {
      return C && C.__esModule ? C : { default: C };
    }
    function i() {
      if (typeof WeakMap != "function") return null;
      var C = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return C;
      }, C;
    }
    function o(C) {
      if (C && C.__esModule)
        return C;
      if (C === null || s(C) !== "object" && typeof C != "function")
        return { default: C };
      var M = i();
      if (M && M.has(C))
        return M.get(C);
      var L = {}, W = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var z in C)
        if (Object.prototype.hasOwnProperty.call(C, z)) {
          var B = W ? Object.getOwnPropertyDescriptor(C, z) : null;
          B && (B.get || B.set) ? Object.defineProperty(L, z, B) : L[z] = C[z];
        }
      return L.default = C, M && M.set(C, L), L;
    }
    function s(C) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(L) {
        return typeof L;
      } : s = function(L) {
        return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
      }, s(C);
    }
    function l(C, M) {
      if (!(C instanceof M))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(C, M) {
      for (var L = 0; L < M.length; L++) {
        var W = M[L];
        W.enumerable = W.enumerable || !1, W.configurable = !0, "value" in W && (W.writable = !0), Object.defineProperty(C, W.key, W);
      }
    }
    function f(C, M, L) {
      return M && c(C.prototype, M), C;
    }
    function h(C, M) {
      return M && (s(M) === "object" || typeof M == "function") ? M : g(C);
    }
    function g(C) {
      if (C === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return C;
    }
    function S(C) {
      return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
        return L.__proto__ || Object.getPrototypeOf(L);
      }, S(C);
    }
    function b(C, M) {
      if (typeof M != "function" && M !== null)
        throw new TypeError("Super expression must either be null or a function");
      C.prototype = Object.create(M && M.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), M && p(C, M);
    }
    function p(C, M) {
      return p = Object.setPrototypeOf || function(W, z) {
        return W.__proto__ = z, W;
      }, p(C, M);
    }
    var v = /* @__PURE__ */ function(C) {
      b(M, C);
      function M(L) {
        var W, z;
        return l(this, M), z = h(this, S(M).call(this, L)), z.state = {
          url: L && L.url || ""
        }, z.onLinkChange = (W = z).onLinkChange.bind(W), z.onLinkKeyDown = (W = z).onLinkKeyDown.bind(W), z;
      }
      return f(M, [{
        key: "setLink",
        value: function(W) {
          var z = this.state.url;
          !z.startsWith("http://") && !z.startsWith("https://") && (z = "http://".concat(z));
          var B = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/gi, K = new RegExp(B), Z = this.props.i18n;
          if (!z.match(K)) {
            var ee = Z["Invalid Link"];
            this.props.setError(ee), this.textInput.focus();
            return;
          }
          this.props.setEntity({
            url: z
          }), this.reset(), W.target.blur();
        }
      }, {
        key: "reset",
        value: function() {
          this.setState({
            url: ""
          }), this.props.cancelEntity();
        }
      }, {
        key: "onLinkChange",
        value: function(W) {
          W.stopPropagation();
          var z = W.target.value;
          z === "" && this.props.cancelError(), this.setState({
            url: z
          });
        }
      }, {
        key: "onLinkKeyDown",
        value: function(W) {
          W.key == "Enter" ? (W.preventDefault(), this.setLink(W)) : W.key == "Escape" && (W.preventDefault(), this.reset());
        }
      }, {
        key: "componentDidMount",
        value: function() {
          this.textInput.focus();
        }
      }, {
        key: "render",
        value: function() {
          var W = this, z = this.props.i18n, B = z["Type the link and press enter"];
          return t.default.createElement("div", {
            style: {
              whiteSpace: "nowrap"
            }
          }, t.default.createElement("input", {
            ref: function(Z) {
              W.textInput = Z;
            },
            type: "text",
            className: "toolbar__input",
            onChange: this.onLinkChange,
            value: this.state.url,
            onKeyDown: this.onLinkKeyDown,
            placeholder: B
          }), t.default.createElement("span", {
            className: "toolbar__item",
            style: {
              verticalAlign: "bottom"
            }
          }, t.default.createElement("button", {
            onClick: this.props.removeEntity,
            type: "button",
            className: "toolbar__button toolbar__input-button"
          }, this.props.entity ? t.default.createElement(r.default.UnlinkIcon, null) : t.default.createElement(r.default.CloseIcon, null))));
        }
      }]), M;
    }(t.Component), w = v;
    e.default = w;
  }(Tg)), Tg;
}
var CY = EY();
const TY = /* @__PURE__ */ jr(CY), OY = () => OE({
  wrapper: {
    padding: 20
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20
  },
  textInput: {
    width: 250
  },
  clearButton: {
    marginLeft: 10
  },
  actionsWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: -10,
    marginBottom: -5
  },
  checkboxLabel: {
    color: "white",
    fontSize: 14
  },
  applyButton: {
    marginLeft: "auto"
  }
});
function RY(e) {
  return e.replace(/(\?r=([^&]*))|(&r=([^&]*))/, "").replace(/\?$/, "");
}
class IY extends TY {
  constructor(r) {
    super(r);
    cr(this, "setLink", async () => {
      const { nofollow: r, selectionText: n, sponsored: i } = this.state;
      let { url: o } = this.state;
      const { editorState: s, onChange: l } = this.props, c = o.match(/mailto:([^?]*)/gm);
      if (o = c ? o : pj(o), o = RY(o), !o.match(
        // https://stackoverflow.com/a/17773849/9722950
        // accept mirror websites
        /(https?:\/\/(?:www\.|(?!www)|(?!www2))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www|\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
      ) && !c) {
        this.props.setError("Lien mal formé."), this.textInput.focus();
        return;
      } else if (o.match(
        /(bone|one-web)\.prismamedia\.com\/.*\/(article|video)\/edit\/(.*)/
      )) {
        this.props.setError("Les liens vers One-Web sont interdits."), this.textInput.focus();
        return;
      }
      if (this.props.setEntity({ url: o, nofollow: r, sponsored: i }), n) {
        const f = np.replaceText(
          s.getCurrentContent(),
          s.getSelection(),
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          n,
          s.getCurrentInlineStyle(),
          s.getCurrentContent().getLastCreatedEntityKey()
        );
        l(Fc.push(s, f, "insert-fragment"));
      }
      this.reset();
    });
    cr(this, "toggleCheckboxFollow", () => {
      this.setState(({ nofollow: r }) => ({ nofollow: !r }));
    });
    cr(this, "toggleCheckboxSponsored", () => {
      this.setState(({ sponsored: r }) => ({ sponsored: !r }));
    });
    this.state = {
      ...this.state,
      nofollow: r.nofollow || !1,
      sponsored: r.sponsored || !1,
      selectionText: tY.getSelectionText(r.editorState)
    };
  }
  reset() {
    this.setState({ url: "", nofollow: !1, sponsored: !1 }), this.props.cancelEntity();
  }
  onLinkChange(r) {
    r.stopPropagation();
    const n = r.target.value;
    n === "" && this.props.cancelError(), this.setState({ url: n });
  }
  onLinkKeyDown(r) {
    r.key == "Enter" ? (r.preventDefault(), this.setLink()) : r.key == "Escape" && (r.preventDefault(), this.reset());
  }
  render() {
    const { classes: r } = this.props;
    return /* @__PURE__ */ y.jsx(vE, { theme: mE({ palette: { mode: "dark" } }), children: /* @__PURE__ */ y.jsxs("div", { className: r.wrapper, children: [
      /* @__PURE__ */ y.jsx("div", { className: r.inputWrapper, children: /* @__PURE__ */ y.jsx(
        ln,
        {
          label: "Texte",
          size: "small",
          className: r.textInput,
          value: this.state.selectionText,
          onChange: (n) => this.setState({ selectionText: n.target.value })
        }
      ) }),
      /* @__PURE__ */ y.jsxs("div", { className: r.inputWrapper, children: [
        /* @__PURE__ */ y.jsx(
          ln,
          {
            autoFocus: !0,
            label: "Lien",
            size: "small",
            className: r.textInput,
            ref: (n) => {
              this.textInput = n;
            },
            onChange: this.onLinkChange,
            value: this.state.url,
            onKeyDown: this.onLinkKeyDown
          }
        ),
        /* @__PURE__ */ y.jsx(
          fr,
          {
            size: "small",
            className: r.clearButton,
            onClick: this.props.removeEntity,
            children: this.props.entity ? /* @__PURE__ */ y.jsx(IN, {}) : /* @__PURE__ */ y.jsx(gc, {})
          }
        )
      ] }),
      /* @__PURE__ */ y.jsxs("div", { className: r.actionsWrapper, children: [
        /* @__PURE__ */ y.jsx(
          js,
          {
            classes: { label: r.checkboxLabel },
            control: /* @__PURE__ */ y.jsx(
              Ba,
              {
                checked: this.state.nofollow,
                onChange: this.toggleCheckboxFollow,
                color: "primary"
              }
            ),
            label: "No follow"
          }
        ),
        /* @__PURE__ */ y.jsx(
          js,
          {
            classes: { label: r.checkboxLabel },
            control: /* @__PURE__ */ y.jsx(
              Ba,
              {
                checked: this.state.sponsored,
                onChange: this.toggleCheckboxSponsored,
                color: "primary"
              }
            ),
            label: "Sponsored"
          }
        ),
        /* @__PURE__ */ y.jsx(
          Fr,
          {
            size: "small",
            variant: "contained",
            color: "primary",
            className: r.applyButton,
            onClick: this.setLink,
            children: "Appliquer"
          }
        )
      ] })
    ] }) });
  }
}
const DY = TE(OY, { withTheme: !0 })(
  IY
);
function PY(e, t) {
  e.stopPropagation(), e.metaKey && window.open(t);
}
const MY = ({
  contentState: e,
  entityKey: t,
  children: r
}) => {
  const { url: n, nofollow: i } = e.getEntity(t).getData(), o = { rel: i || void 0 };
  return /* @__PURE__ */ y.jsx(
    "a",
    {
      className: "editor__link",
      href: n,
      title: n,
      ...o,
      onClick: (s) => PY(s, n),
      children: r
    }
  );
}, AY = () => /* @__PURE__ */ y.jsx(EE, { style: { color: "white" } }), NY = () => /* @__PURE__ */ y.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ y.jsx("path", { d: "m0 0h24v24h-24z", fill: "currentColor", fillRule: "evenodd" }),
      /* @__PURE__ */ y.jsx("path", { d: "m9 7h2v10h-2v-4h-4v4h-2v-10h2v4h4zm8 8c.51-.41.6-.62 1.06-1.05.437-.4.848-.828 1.23-1.28.334-.39.62-.82.85-1.28.2-.39.305-.822.31-1.26.005-.44-.087-.878-.27-1.28-.177-.385-.437-.726-.76-1-.346-.283-.743-.497-1.17-.63-.485-.153-.99-.227-1.5-.22-.36 0-.717.033-1.07.1-.343.06-.678.158-1 .29-.304.13-.593.295-.86.49-.287.21-.56.437-.82.68l1.24 1.22c.308-.268.643-.502 1-.7.35-.2.747-.304 1.15-.3.455-.03.906.106 1.27.38.31.278.477.684.45 1.1-.014.396-.14.78-.36 1.11-.285.453-.62.872-1 1.25-.44.43-.98.92-1.59 1.43s-1.41 1.06-2.16 1.65v1.3h8v-2z" })
    ]
  }
), jY = () => /* @__PURE__ */ y.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ y.jsx("path", { d: "m0 0h24v24h-24z", fill: "currentColor", fillRule: "evenodd" }),
      /* @__PURE__ */ y.jsx("path", { d: "m14.11 14.218c.355.287.75.523 1.17.7.434.18.9.273 1.37.27.484.017.965-.086 1.4-.3.333-.146.55-.476.55-.84.003-.203-.05-.403-.15-.58-.123-.19-.3-.34-.51-.43-.32-.137-.655-.228-1-.27-.503-.073-1.012-.106-1.52-.1v-1.57c.742.052 1.485-.07 2.17-.36.37-.164.615-.525.63-.93.026-.318-.12-.627-.38-.81-.34-.203-.734-.3-1.13-.28-.395.013-.784.108-1.14.28-.375.167-.73.375-1.06.62l-1.22-1.39c.5-.377 1.053-.68 1.64-.9.608-.224 1.252-.336 1.9-.33.525-.007 1.05.05 1.56.17.43.1.84.277 1.21.52.325.21.595.495.79.83.19.342.287.73.28 1.12.01.48-.177.943-.52 1.28-.417.39-.916.685-1.46.86v.06c.61.14 1.175.425 1.65.83.437.382.68.94.66 1.52.005.42-.113.835-.34 1.19-.23.357-.538.657-.9.88-.408.253-.853.44-1.32.55-.514.128-1.04.192-1.57.19-.786.02-1.57-.106-2.31-.37-.59-.214-1.126-.556-1.57-1zm-5.11-3.218h-4v-4h-2v10h2v-4h4v4h2v-10h-2z" })
    ]
  }
), kY = () => /* @__PURE__ */ y.jsx("div", { title: "Gras", children: /* @__PURE__ */ y.jsx(ua.BoldIcon, {}) }), LY = () => /* @__PURE__ */ y.jsx("div", { title: "Italique", children: /* @__PURE__ */ y.jsx(ua.ItalicIcon, {}) }), zY = () => /* @__PURE__ */ y.jsx("div", { title: "Lien externe", children: /* @__PURE__ */ y.jsx(ua.LinkIcon, {}) }), cZ = () => /* @__PURE__ */ y.jsx("div", { title: "Supression lien people", children: /* @__PURE__ */ y.jsx(ua.UnlinkIcon, {}) }), BY = () => /* @__PURE__ */ y.jsx("div", { title: "Barré", children: /* @__PURE__ */ y.jsx(DN, {}) }), dZ = () => /* @__PURE__ */ y.jsx("div", { title: "Lien dans l'article", children: /* @__PURE__ */ y.jsx(AY, {}) }), FY = () => /* @__PURE__ */ y.jsx("div", { title: "Intertitre", children: /* @__PURE__ */ y.jsx(NY, {}) }), WY = () => /* @__PURE__ */ y.jsx("div", { title: "Intertitre", children: /* @__PURE__ */ y.jsx(jY, {}) }), HY = () => /* @__PURE__ */ y.jsx("div", { title: "Liste à puces", children: /* @__PURE__ */ y.jsx(ua.ULIcon, {}) }), $Y = () => /* @__PURE__ */ y.jsx("div", { title: "Liste numérotée", children: /* @__PURE__ */ y.jsx(ua.OLIcon, {}) }), UY = () => /* @__PURE__ */ y.jsx("div", { title: "Citation", children: /* @__PURE__ */ y.jsx(ua.BlockQuoteIcon, {}) }), fZ = () => /* @__PURE__ */ y.jsx("div", { title: "Copier le sommaire", children: /* @__PURE__ */ y.jsx(PN, {}) }), GY = () => /* @__PURE__ */ y.jsx("div", { title: "Coller", children: /* @__PURE__ */ y.jsx(SE, {}) });
var Fi = /* @__PURE__ */ ((e) => (e.block = "block", e.custom = "custom", e.entity = "entity", e.inline = "inline", e.separator = "separator", e))(Fi || {}), Wi = /* @__PURE__ */ ((e) => (e.BOLD = "BOLD", e.ITALIC = "ITALIC", e.STRIKETHROUGH = "STRIKETHROUGH", e.LINK = "LINK", e.TITLE = "header-two", e.HEADLINE = "header-three", e.UNORDERED_LIST = "unordered-list-item", e.ORDERED_LIST = "ordered-list-item", e.BLOCKQUOTE = "blockquote", e.PASTE = "PASTE", e))(Wi || {});
const pZ = {
  SEPARATOR: {
    action: {
      type: Fi.separator
    }
  },
  BOLD: {
    action: {
      type: Fi.inline,
      label: "B",
      style: Wi.BOLD,
      icon: kY
    }
  },
  ITALIC: {
    action: {
      type: Fi.inline,
      label: "I",
      style: Wi.ITALIC,
      icon: LY
    }
  },
  STRIKETHROUGH: {
    action: {
      type: Fi.inline,
      label: "STRIKETHROUGH",
      style: Wi.STRIKETHROUGH,
      icon: BY
    }
  },
  LINK: {
    action: {
      type: Fi.entity,
      label: "Link",
      style: Wi.LINK,
      entity: "LINK",
      icon: zY
    },
    entity: {
      LINK: DY
    },
    decorator: {
      strategy: oj("LINK"),
      component: MY
    }
  },
  TITLE: {
    action: {
      type: Fi.block,
      label: "H2",
      style: Wi.TITLE,
      icon: FY
    }
  },
  HEADLINE: {
    action: {
      type: Fi.block,
      label: "H3",
      style: Wi.HEADLINE,
      icon: WY
    }
  },
  LIST: {
    action: {
      type: Fi.block,
      label: "UL",
      style: Wi.UNORDERED_LIST,
      icon: HY
    }
  },
  ORDERED_LIST: {
    action: {
      type: Fi.block,
      label: "OL",
      style: Wi.ORDERED_LIST,
      icon: $Y
    }
  },
  BLOCKQUOTE: {
    action: {
      type: Fi.block,
      label: "QT",
      style: Wi.BLOCKQUOTE,
      icon: UY
    }
  },
  PASTE: {
    action: {
      type: Fi.custom,
      label: "Paste",
      icon: GY,
      style: Wi.PASTE,
      action: async (e, t) => {
        const r = await UT(e);
        t(r);
      }
    }
  }
}, ky = (e) => e.reduce(
  (t, { action: r, decorator: n, entity: i }) => ({
    actions: [...t.actions, r],
    decorators: [...t.decorators, ...n ? [n] : []],
    entities: { ...t.entities, ...i || {} }
  }),
  { actions: [], entities: {}, decorators: [] }
), qY = (e) => {
  const r = e.editorState.getSelection().getAnchorKey(), i = e.editorState.getCurrentContent().getBlockForKey(r), o = i.text === "" && i.type === "unstyled", s = e.readOnly || !o, l = { ...e, readOnly: s };
  return /* @__PURE__ */ y.jsx(aj, { ...l });
}, VY = Rt(() => ({
  wrapper: {
    padding: "1.5px 0 2.5px",
    width: "100%"
  },
  wrapperOutlined: {
    padding: "14px 14px"
  },
  wrapperFilled: {
    padding: "22.5px 12px 5.5px"
  }
})), YY = Kf(
  ({
    classes: e,
    editorConfig: t,
    editorState: r,
    handleDraftChange: n,
    handlePastedText: i,
    plugins: o,
    variant: s,
    disabled: l
  }, c) => /* @__PURE__ */ y.jsx(
    "div",
    {
      ref: c,
      className: nt(
        e.wrapper,
        s === "outlined" && e.wrapperOutlined,
        s === "filled" && e.wrapperFilled
      ),
      children: /* @__PURE__ */ y.jsx(
        NE,
        {
          editorState: r,
          onChange: n,
          entityInputs: t.entities,
          actions: t.actions,
          softNewLines: !0,
          spellCheck: !0,
          sidebarRendererFn: o ? qY : () => null,
          handlePastedText: i,
          readOnly: l,
          ...o && { plugins: o }
        }
      )
    }
  )
), hZ = ({
  actions: e = [],
  onChange: t,
  onClick: r,
  onSelection: n,
  plugins: i,
  value: o,
  shrink: s,
  ...l
}) => {
  const c = ky(e), f = new PE(c.decorators), [h, g] = Xe(!0), [S, b] = Xe(
    kl(null)
  ), p = rm(S), v = Wc(S, 500), w = kt(
    () => i == null ? void 0 : i.map((M) => {
      var L;
      return {
        ...M,
        props: { actions: ((L = M == null ? void 0 : M.props) == null ? void 0 : L.actions) || e }
      };
    }),
    [e, i]
  ), C = (M) => {
    const L = S.getCurrentContent(), W = M.getCurrentContent();
    L === W && (n == null || n(M)), b(M);
  };
  return pt(() => {
    o !== p && b(
      kl(o ? X8(o) : null, f)
    ), g(!1);
  }, [o]), pt(() => {
    h || t == null || t(rm(v));
  }, [v]), /* @__PURE__ */ y.jsx(
    GT,
    {
      actions: e,
      editorState: S,
      onChange: C,
      onClick: r,
      plugins: w,
      shrink: s,
      ...l
    }
  );
}, GT = ({
  actions: e = [],
  className: t,
  disabled: r,
  editorConfig: n,
  errors: i,
  handlePastedText: o,
  inputProps: s = {},
  label: l,
  onChange: c,
  onClick: f,
  plugins: h,
  required: g,
  editorState: S,
  variant: b = "standard",
  wordCounter: p,
  shrink: v
}) => {
  const w = VY(), C = rm(S);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      ln,
      {
        className: t,
        disabled: r,
        multiline: !0,
        label: l,
        required: g,
        value: C,
        variant: b,
        onClick: f,
        InputLabelProps: {
          shrink: v ?? !!C.length
        },
        InputProps: {
          ...s,
          inputComponent: YY,
          inputProps: {
            classes: w,
            editorConfig: n || ky(e),
            editorState: S,
            handleDraftChange: c,
            handlePastedText: o,
            plugins: h,
            variant: b,
            disabled: r
          }
        },
        ...(i == null ? void 0 : i.isTouched) && {
          error: i.hasError,
          helperText: i.errorMessages[i.errors[0]]
        }
      }
    ),
    p && /* @__PURE__ */ y.jsx(Q8, { content: C, type: "Draft" })
  ] });
}, qT = async (e) => new Promise((t) => setTimeout(() => t(), e)), KY = ({
  html: e,
  width: t = "100%",
  minHeight: r = 400
}) => {
  const [n, i] = Xe(!1), o = bt(null), s = Kt(async () => {
    if (!o.current || !o.current.contentWindow)
      return;
    const c = Math.max(
      r,
      o.current.contentWindow.document.body.offsetHeight
    );
    o.current.height = `${c}px`, i(!1);
  }, [r]), l = Kt(
    (c) => {
      i(!0);
      const f = `
      <html>
        <body style="margin:0;padding:0">
          ${c}
        </body>
      </html>
    `;
      if (!o.current)
        return;
      const h = o.current;
      h.contentWindow && (h.addEventListener("load", async () => {
        s(), await qT(200), s();
        const g = {
          attributes: !0,
          attributeOldValue: !1,
          characterData: !0,
          characterDataOldValue: !1,
          childList: !0,
          subtree: !0
        }, S = new MutationObserver(s);
        o.current && o.current.contentWindow && S.observe(
          o.current.contentWindow.document.body,
          g
        );
      }), h.contentWindow.document.open("text/html", "replace"), h.contentWindow.document.write(f), h.contentWindow.document.close());
    },
    [s]
  );
  return pt(() => {
    l(e);
  }, [e]), /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    n && /* @__PURE__ */ y.jsx(
      zt,
      {
        sx: {
          width: t,
          height: `${r}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: /* @__PURE__ */ y.jsx(un, { size: 100 })
      }
    ),
    /* @__PURE__ */ y.jsx(
      "iframe",
      {
        title: "iframe",
        style: n ? { display: "none" } : {},
        ref: o,
        src: "about:blank",
        width: t,
        height: `${r}px`,
        scrolling: "no",
        frameBorder: "0"
      }
    )
  ] });
};
var Kg, PS;
function XY() {
  if (PS) return Kg;
  PS = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString;
  return Kg = function(n, i, o) {
    if (t.call(i) !== "[object Function]")
      throw new TypeError("iterator must be a function");
    var s = n.length;
    if (s === +s)
      for (var l = 0; l < s; l++)
        i.call(o, n[l], l, n);
    else
      for (var c in n)
        e.call(n, c) && i.call(o, n[c], c, n);
  }, Kg;
}
var Xg, MS;
function JY() {
  if (MS) return Xg;
  MS = 1;
  var e = XY();
  Xg = t;
  function t(r, n, i) {
    if (arguments.length === 3)
      return t.set(r, n, i);
    if (arguments.length === 2)
      return t.get(r, n);
    var o = t.bind(t, r);
    for (var s in t)
      t.hasOwnProperty(s) && (o[s] = t[s].bind(o, r));
    return o;
  }
  return t.get = function(n, i) {
    for (var o = Array.isArray(i) ? i : t.parse(i), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!(typeof n == "object" && l in n))
        throw new Error("Invalid reference token: " + l);
      n = n[l];
    }
    return n;
  }, t.set = function(n, i, o) {
    var s = Array.isArray(i) ? i : t.parse(i), l = s[0];
    if (s.length === 0)
      throw Error("Can not set the root object");
    for (var c = 0; c < s.length - 1; ++c) {
      var f = s[c];
      f === "__proto__" || f === "constructor" || f === "prototype" || (f === "-" && Array.isArray(n) && (f = n.length), l = s[c + 1], f in n || (l.match(/^(\d+|-)$/) ? n[f] = [] : n[f] = {}), n = n[f]);
    }
    return l === "-" && Array.isArray(n) && (l = n.length), n[l] = o, this;
  }, t.remove = function(r, n) {
    var i = Array.isArray(n) ? n : t.parse(n), o = i[i.length - 1];
    if (o === void 0)
      throw new Error('Invalid JSON pointer for remove: "' + n + '"');
    var s = t.get(r, i.slice(0, -1));
    if (Array.isArray(s)) {
      var l = +o;
      if (o === "" && isNaN(l))
        throw new Error('Invalid array index: "' + o + '"');
      Array.prototype.splice.call(s, l, 1);
    } else
      delete s[o];
  }, t.dict = function(n, i) {
    var o = {};
    return t.walk(n, function(s, l) {
      o[l] = s;
    }, i), o;
  }, t.walk = function(n, i, o) {
    var s = [];
    o = o || function(l) {
      var c = Object.prototype.toString.call(l);
      return c === "[object Object]" || c === "[object Array]";
    }, function l(c) {
      e(c, function(f, h) {
        s.push(String(h)), o(f) ? l(f) : i(f, t.compile(s)), s.pop();
      });
    }(n);
  }, t.has = function(n, i) {
    try {
      t.get(n, i);
    } catch {
      return !1;
    }
    return !0;
  }, t.escape = function(n) {
    return n.toString().replace(/~/g, "~0").replace(/\//g, "~1");
  }, t.unescape = function(n) {
    return n.replace(/~1/g, "/").replace(/~0/g, "~");
  }, t.parse = function(n) {
    if (n === "")
      return [];
    if (n.charAt(0) !== "/")
      throw new Error("Invalid JSON pointer: " + n);
    return n.substring(1).split(/\//).map(t.unescape);
  }, t.compile = function(n) {
    return n.length === 0 ? "" : "/" + n.map(t.escape).join("/");
  }, Xg;
}
var ZY = JY();
const AS = /* @__PURE__ */ jr(ZY), Uf = new sj({
  protocol: "https",
  // 'http', 'https', false (false means "protocol-relative")
  domain: "one.img.pmdstatic.net",
  defaultParameters: { quality: 80 },
  defaultFormat: "jpg"
  // 'jpg', 'gif', 'png'
}), QY = (e) => {
  if (e)
    return { "crop-zone": `${e.x},${e.y}-${e.width}x${e.height}` };
}, NS = "https://bone.prismamedia.com/assets/images/placeholder.png", e7 = "Brightcove", t7 = "Dailymotion", r7 = "PMD_Slideshow", jS = {
  APP_PATH: "/links/app/0/html",
  DEFAULT_PATH: "/html",
  IMAGE_PATH: "/links/image/0/href",
  THUMBNAIL_PATH: "/links/thumbnail/0/href",
  ICON_PATH: "/links/icon/0/href",
  UNKNOWN: "/links/file/0/href"
}, VT = (e) => {
  const { fileName: t, meta: r, ...n } = e, { credit: i, ...o } = r;
  return {
    caption: null,
    credit: i,
    focusPoint: { x: null, y: null, relativeX: null, relativeY: null },
    format: null,
    iframely: {
      ...n,
      ...o && { meta: o }
    },
    key: null,
    rel: null,
    target: null,
    ...t && { originalName: t }
  };
};
var n7 = /* @__PURE__ */ ((e) => (e.Image = "Image", e.Video = "Video", e))(n7 || {});
const Gf = (e) => {
  var t, r;
  return ((r = (t = e.iframely) == null ? void 0 : t.meta) == null ? void 0 : r.canonical) || "";
}, i7 = (e) => {
  var t;
  return go(e) ? (t = e.iframely) == null ? void 0 : t.meta : !1;
}, Za = (e) => {
  var t, r;
  return (((r = (t = e.iframely) == null ? void 0 : t.meta) == null ? void 0 : r.site) || "").toLowerCase();
}, o7 = (e) => Za(e) === "ART19" || Za(e) === "art19" || im(e) === "Prisma Media Player", go = (e) => {
  var t, r, n;
  return Za(e) === ui.PMD_IMAGE_TYPE || !!((n = (r = (t = e == null ? void 0 : e.iframely) == null ? void 0 : t.meta) == null ? void 0 : r.canonical) != null && n.match(/(jp(e)?g|png|bmp|gif)$/));
}, Ly = (e) => Za(e) === ui.SLIDESHOW_TYPE, nm = (e) => Za(e) === ui.DAILYMOTION_TYPE, a7 = (e) => Za(e) === ui.BRIGHTCOVE_TYPE, gZ = (e) => Za(e) === ui.AFFILIATION_TYPE, Ul = (e) => {
  var r, n;
  if (!e)
    return NS;
  const t = i7(e);
  if (t && t.url)
    return t.url;
  if ((r = e.iframely) != null && r.links) {
    const o = [].concat(...Object.values((n = e.iframely) == null ? void 0 : n.links)).filter(Ll).find(
      ({ type: s, href: l, rel: c }) => !!((c != null && c.includes("image") || c != null && c.includes("thumbnail") || g7(s)) && l)
    );
    if (o != null && o.href)
      return o.href;
  }
  return NS;
}, YT = (e) => {
  const t = [jS.APP_PATH, jS.DEFAULT_PATH], { iframely: r } = e, n = t.find((i) => AS.has(r, i));
  return n ? AS.get(r, n) : "";
}, xp = (e) => {
  let t;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      console.error(
        "[parseMedias]: Unable to parse as JSON the following string : ",
        e
      );
    }
  else
    t = e;
  return t ?? void 0;
}, zy = (e, t) => {
  if (e)
    return Array.isArray(e) && e[0] ? t === "Video" ? h7(e) || e[0] : l7(e) || e[0] : e;
}, vZ = (e) => {
  var i, o;
  const t = xp(e);
  if (!t || Array.isArray(t) && !t.length)
    return {
      media: void 0,
      mediaForDisplay: void 0
    };
  const r = zy(t) || t, n = (o = (i = r.iframely) == null ? void 0 : i.meta) == null ? void 0 : o.url;
  return n ? {
    media: r,
    mediaForDisplay: Uf.fit({
      height: 150,
      origin: n,
      width: 350
    })
  } : {
    media: void 0,
    mediaForDisplay: void 0
  };
}, mZ = (e) => {
  const t = xp(e);
  if (!t)
    return;
  let r = zy(t);
  r || (r = t);
  const n = ho(
    ["iframely", "links", "thumbnail", "0", "href"],
    r
  );
  return n || ho(["iframely", "links", "image", "0", "href"], r);
}, im = (e) => {
  var t, r;
  return ((r = (t = e.iframely) == null ? void 0 : t.meta) == null ? void 0 : r.site) || "";
}, s7 = (e, t) => Array.isArray(t) ? t.map((r) => r.toLowerCase()).includes(im(e).toLowerCase()) : im(e).toLowerCase() === t.toLowerCase(), l7 = (e) => e ? e.find((t) => go(t)) : !1, u7 = (e) => {
  var t;
  return go(e) ? !!ho(["credit"], e) || !!((t = e.iframely) != null && t.meta && ho(["iframely", "meta", "credit"], e)) : !0;
}, yZ = (e) => (e || []).reduce((r, n) => r && u7(n), !0), c7 = (e) => !!(e && ho(["format"], e)), bZ = (e) => !!(e != null && e.every(c7)), d7 = (e) => {
  var t;
  return !!(e.credit && ho(["credit"], e)) || !!((t = e.iframely) != null && t.meta && ho(["iframely", "meta", "credit"], e));
}, wZ = (e) => !!(e != null && e.every(d7)), f7 = (e) => {
  var t;
  return !!(e.source && ho(["source"], e)) || !!((t = e.iframely) != null && t.meta && ho(["iframely", "meta", "source"], e));
}, xZ = (e) => !!(e != null && e.every(f7)), p7 = (e) => {
  if (!e.iframely)
    throw new Error("isVideo only accept Media type");
  return s7(e, [
    ui.YOUTUBE_TYPE,
    ui.DAILYMOTION_TYPE,
    ui.PLURIMEDIA_TYPE
  ]);
}, h7 = (e) => e ? e.find(p7) : !1, g7 = (e) => {
  const t = /^image/, r = /icon/;
  return e && t.test(e) && !r.test(e);
}, _Z = (e) => {
  const t = xp(e);
  if (!t)
    return;
  const r = zy(
    t,
    "Video"
    /* Video */
  );
  return r ? ho(["iframely", "links", "thumbnail", "0", "href"], r) : ho(["iframely", "links", "thumbnail", "0", "href"], t);
}, SZ = (e) => {
  const t = xp(e), r = t == null ? void 0 : t.map((n) => {
    var i, o;
    return (o = (i = n.iframely) == null ? void 0 : i.meta) == null ? void 0 : o.site;
  });
  if (!(!r || !r.length))
    return r.filter((n) => n === t7 || n === r7 || n === e7);
}, v7 = ({
  media: e,
  width: t,
  height: r,
  fit: n
}) => {
  var g, S;
  const { iframely: i, crop: o, focusPoint: s } = e, l = Ul(e), c = o ? o.height : (g = i == null ? void 0 : i.meta) == null ? void 0 : g.height, f = o ? o.width : (S = i == null ? void 0 : i.meta) == null ? void 0 : S.width, h = {
    width: Math.round(t || f),
    height: Math.round(r || c),
    origin: l,
    parameters: {
      ...QY(o),
      ...s != null && s.relativeX && s.relativeY ? {
        "focus-point": `${Math.round(
          f * s.relativeX
        )},${Math.round(c * s.relativeY)}`
      } : {}
    }
  };
  return n ? Uf.fit(h) : Uf.pad(h);
}, KT = ({
  media: e,
  forceImage: t,
  fit: r,
  minHeight: n
}) => {
  const i = bt(null), [o, s] = Xe(0);
  pt(() => {
    const c = i.current;
    if (!c) return;
    const f = new ResizeObserver((h) => {
      const { width: g } = h[0].contentRect;
      s(g);
    });
    return f.observe(c), () => {
      f.unobserve(c);
    };
  }, []);
  const l = kt(
    () => o ? v7({
      media: e,
      width: o,
      height: n,
      fit: r
    }) : void 0,
    [r, n, e, o]
  );
  return /* @__PURE__ */ y.jsx(zt, { ref: i, children: t || go(e) ? /* @__PURE__ */ y.jsx(qc, { src: l, loaderSize: n / 4, sx: { minHeight: n } }) : /* @__PURE__ */ y.jsx(KY, { html: YT(e), minHeight: n }) });
};
var Jg, kS;
function m7() {
  return kS || (kS = 1, Jg = function(e, t, r, n) {
    var i = typeof n < "u" ? [n, e] : [e], o = new Blob(i, { type: r || "application/octet-stream" });
    if (typeof window.navigator.msSaveBlob < "u")
      window.navigator.msSaveBlob(o, t);
    else {
      var s = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(o) : window.webkitURL.createObjectURL(o), l = document.createElement("a");
      l.style.display = "none", l.href = s, l.setAttribute("download", t), typeof l.download > "u" && l.setAttribute("target", "_blank"), document.body.appendChild(l), l.click(), setTimeout(function() {
        document.body.removeChild(l), window.URL.revokeObjectURL(s);
      }, 200);
    }
  }), Jg;
}
var y7 = m7();
const XT = /* @__PURE__ */ jr(y7), b7 = ({
  media: e,
  onCropAndFocusPointChange: t,
  onDelete: r,
  disableCrop: n,
  additionnalMediaActions: i
}) => {
  const o = go(e), { openDialog: s, closeDialog: l } = Jl(), { pushNotification: c } = Zl(), f = async () => {
    var h, g, S, b;
    try {
      const v = await (await fetch(Ul(e))).blob(), w = (g = (h = e.iframely) == null ? void 0 : h.meta) == null ? void 0 : g.originalName, C = (b = (S = e.iframely) == null ? void 0 : S.meta) == null ? void 0 : b.extension, M = w ? `${w}${w.endsWith(C || "jpeg") ? "" : `.${C || "jpeg"}`}` : "sans-titre.jpg";
      return XT(v, M);
    } catch (p) {
      p instanceof Error && c({
        message: p.message,
        type: jo.error
      });
    }
  };
  return /* @__PURE__ */ y.jsxs(
    zt,
    {
      sx: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        top: 5,
        right: 5
      },
      children: [
        r && /* @__PURE__ */ y.jsx(Nr, { title: "Supprimer", children: /* @__PURE__ */ y.jsx(
          uo,
          {
            size: "small",
            color: "primary",
            sx: { mb: "5px" },
            onClick: r,
            children: /* @__PURE__ */ y.jsx(zc, {})
          }
        ) }),
        o && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          t && /* @__PURE__ */ y.jsx(
            Nr,
            {
              title: n ? "Point de focus" : "Redimensionnement et point de focus",
              children: /* @__PURE__ */ y.jsx(
                uo,
                {
                  size: "small",
                  color: "primary",
                  sx: { mb: "5px" },
                  onClick: () => {
                    var h, g, S, b;
                    s(
                      /* @__PURE__ */ y.jsx(
                        xT,
                        {
                          closeDialog: l,
                          imageSrc: Ul(e),
                          initialCrop: e.crop,
                          initialFocusPoint: e.focusPoint,
                          onValidate: t,
                          config: {
                            height: (g = (h = e.iframely) == null ? void 0 : h.meta) == null ? void 0 : g.height,
                            width: (b = (S = e.iframely) == null ? void 0 : S.meta) == null ? void 0 : b.width
                          },
                          disableCrop: n
                        }
                      ),
                      { fullScreen: !0 }
                    );
                  },
                  children: /* @__PURE__ */ y.jsx(wm, {})
                }
              )
            }
          ),
          /* @__PURE__ */ y.jsx(Nr, { title: "Télécharger", children: /* @__PURE__ */ y.jsx(
            uo,
            {
              size: "small",
              color: "primary",
              sx: { mb: "5px" },
              onClick: f,
              children: /* @__PURE__ */ y.jsx(CE, {})
            }
          ) })
        ] }),
        Ly(e) && /* @__PURE__ */ y.jsx(Nr, { title: "Voir le diaporama", children: /* @__PURE__ */ y.jsx(
          uo,
          {
            size: "small",
            color: "primary",
            sx: { mb: "5px" },
            href: Gf(e),
            target: "_blank",
            children: /* @__PURE__ */ y.jsx(MN, {})
          }
        ) }),
        i
      ]
    }
  );
}, JT = ({
  media: e,
  onMediaDelete: t,
  onCropAndFocusPointChange: r,
  additionnalMediaActions: n,
  mediaFields: i,
  mediaHeight: o = Ty,
  disableCrop: s
}) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsxs(zt, { sx: { position: "relative" }, children: [
    /* @__PURE__ */ y.jsx(KT, { media: e, minHeight: o, fit: !0 }),
    /* @__PURE__ */ y.jsx(
      b7,
      {
        media: e,
        onCropAndFocusPointChange: r,
        onDelete: t,
        additionnalMediaActions: n,
        disableCrop: s
      }
    )
  ] }),
  i && /* @__PURE__ */ y.jsx(zt, { sx: { px: 2, py: 3, display: "flex", flexDirection: "column" }, children: i })
] }), w7 = Xf(
  ({ media: e, mediaHasError: t, onClick: r, selected: n }) => {
    const i = zo();
    let o = "Média";
    return go(e) ? o = "Image" : a7(e) ? o = "Brightcove" : Ly(e) ? o = "Diaporama" : nm(e) ? o = "Dailymotion" : o7(e) && (o = "Podcast"), /* @__PURE__ */ y.jsxs(
      zt,
      {
        sx: {
          display: "inline-block",
          height: "50px",
          ml: 2,
          position: "relative",
          width: "100px"
        },
        children: [
          /* @__PURE__ */ y.jsxs(
            Bo,
            {
              sx: { overflow: "hidden", width: 100, height: 50 },
              onClick: r,
              raised: n,
              children: [
                /* @__PURE__ */ y.jsx(KT, { media: e, forceImage: !0, fit: !0, minHeight: 50 }),
                /* @__PURE__ */ y.jsxs(
                  Lt,
                  {
                    sx: {
                      backgroundColor: an(i.palette.common.black, 0.5),
                      borderBottomLeftRadius: i.shape.borderRadius,
                      borderBottomRightRadius: i.shape.borderRadius,
                      bottom: 0,
                      color: an(i.palette.common.white, n ? 1 : 0.8),
                      left: 0,
                      padding: i.spacing(0.5, 1),
                      position: "absolute",
                      right: 0,
                      textAlign: "center",
                      fontWeight: n ? "bold" : void 0
                    },
                    variant: "caption",
                    children: [
                      o,
                      e.format && `/ ${e.format}`
                    ]
                  }
                )
              ]
            }
          ),
          t && /* @__PURE__ */ y.jsx(
            rp,
            {
              color: "error",
              fontSize: "small",
              sx: {
                backgroundColor: i.palette.common.white,
                borderRadius: "50%",
                bottom: 0,
                position: "absolute",
                right: "-7px",
                top: "-6px",
                zIndex: 5
              }
            }
          )
        ]
      }
    );
  }
), x7 = ({
  medias: e,
  mediaWithErrorIndexes: t,
  onMediaReorder: r,
  selectedMediaIndex: n,
  setSelectedMediaIndex: i
}) => /* @__PURE__ */ y.jsx(
  X1,
  {
    onDragEnd: (o) => {
      const { source: s, destination: l } = o;
      l && (r == null || r(s.index, l.index), i == null || i(l.index));
    },
    children: /* @__PURE__ */ y.jsx(bp, { droppableId: "droppable", direction: "horizontal", children: (o) => /* @__PURE__ */ y.jsxs(
      zt,
      {
        sx: {
          maxWidth: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          display: "flex",
          py: 1
        },
        ref: o.innerRef,
        ...o.droppableProps,
        children: [
          e.map((s, l) => /* @__PURE__ */ y.jsx(
            Cy,
            {
              draggableId: Gf(s),
              index: l,
              isDragDisabled: !r,
              children: (c) => /* @__PURE__ */ y.jsx(
                zt,
                {
                  ref: c.innerRef,
                  ...c.draggableProps,
                  ...c.dragHandleProps,
                  style: {
                    userSelect: "none",
                    ...c.draggableProps.style
                  },
                  children: /* @__PURE__ */ y.jsx(
                    w7,
                    {
                      media: s,
                      onClick: () => i == null ? void 0 : i(l),
                      selected: l === n,
                      mediaHasError: t.includes(l)
                    },
                    l
                  )
                }
              )
            },
            `${Gf(s)}-${l}`
          )),
          o.placeholder
        ]
      }
    ) })
  }
), EZ = ({
  medias: e,
  mediaWithErrorIndexes: t,
  onMediaReorder: r,
  onMediaDelete: n,
  onCropAndFocusPointChange: i,
  selectedMediaIndex: o,
  setSelectedMediaIndex: s,
  loading: l,
  sx: c,
  title: f = "Ajouter des médias",
  mediaUploaders: h,
  additionnalMediaActions: g,
  mediaFields: S,
  mediaHeight: b = Ty,
  disableCrop: p,
  onUploadFiles: v,
  loader: w
}) => {
  const C = zo(), M = e == null ? void 0 : e[o], L = bt(null);
  return pt(() => {
    !M && o > 0 && (s == null || s(0));
  }, [M, o, s]), /* @__PURE__ */ y.jsxs(Bo, { sx: c, children: [
    /* @__PURE__ */ y.jsxs(ca, { sx: { justifyContent: "space-between" }, children: [
      /* @__PURE__ */ y.jsx(
        Lt,
        {
          sx: { color: C.palette.grey[700], fontSize: "1.25rem" },
          children: f
        }
      ),
      /* @__PURE__ */ y.jsxs(zt, { sx: { display: "flex", ml: 2 }, children: [
        v && /* @__PURE__ */ y.jsx(
          Lo,
          {
            label: "Importer",
            "data-testid": "multimedia-upload-btn",
            onClick: () => {
              var W;
              return (W = L.current) == null ? void 0 : W.click();
            },
            children: /* @__PURE__ */ y.jsx(xm, {})
          }
        ),
        h
      ] })
    ] }),
    /* @__PURE__ */ y.jsxs(bV, { disabled: !v, onDrop: v, children: [
      (e == null ? void 0 : e.length) > 1 && /* @__PURE__ */ y.jsx(
        x7,
        {
          medias: e,
          mediaWithErrorIndexes: t || [],
          onMediaReorder: r,
          selectedMediaIndex: o,
          setSelectedMediaIndex: s
        }
      ),
      l ? w || /* @__PURE__ */ y.jsx(
        zt,
        {
          sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: b
          },
          children: /* @__PURE__ */ y.jsx(un, { size: 100 })
        }
      ) : M ? /* @__PURE__ */ y.jsx(
        JT,
        {
          media: M,
          onCropAndFocusPointChange: i ? (W) => i == null ? void 0 : i(W, o) : void 0,
          onMediaDelete: n ? () => {
            n == null || n(o);
          } : void 0,
          additionnalMediaActions: g,
          disableCrop: p,
          mediaHeight: b,
          mediaFields: S
        }
      ) : v && /* @__PURE__ */ y.jsx(
        eN,
        {
          sx: { height: 250, width: "100%", p: 1 },
          onClick: () => {
            var W;
            return (W = L.current) == null ? void 0 : W.click();
          },
          children: /* @__PURE__ */ y.jsx(
            zt,
            {
              sx: {
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `2px dashed ${C.palette.grey[400]}`,
                borderRadius: 2
              },
              children: /* @__PURE__ */ y.jsx(Lt, { variant: "body2", color: "GrayText", children: "Déposez des médias ici en faisant un glisser/déposer" })
            }
          )
        }
      ),
      v && /* @__PURE__ */ y.jsx(
        zt,
        {
          component: "input",
          type: "file",
          ref: L,
          multiple: !0,
          sx: { display: "none" },
          onChange: (W) => W.target.files && v(Array.from(W.target.files))
        }
      )
    ] })
  ] });
}, _7 = Rt((e) => ({
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    color: e.palette.grey[400]
  },
  mediaIcon: {
    display: "flex",
    margin: e.spacing(0.5, 0.8)
  },
  mediaIconCount: {
    marginRight: e.spacing(0.5)
  }
})), S7 = (e) => e != null && e.length ? e.reduce((t, r) => {
  let n = "Other", i = AN;
  switch (Za(r)) {
    case ui.PMD_IMAGE_TYPE:
      n = "Image", i = kN;
      break;
    case ui.SLIDESHOW_TYPE:
      n = "Slideshow", i = jN;
      break;
    case ui.BRIGHTCOVE_TYPE:
    case ui.DAILYMOTION_TYPE:
    case ui.YOUTUBE_TYPE:
      n = "Video", i = NN;
      break;
  }
  const o = t.findIndex((s) => s.type === n);
  if (o > -1) {
    const s = [...t];
    return s[o] = { ...s[o], count: (s[o].count || 0) + 1 }, s;
  }
  return [...t, { type: n, Icon: i, count: 1 }];
}, []) : [], CZ = ({
  medias: e,
  className: t,
  additionnalIcons: r,
  sx: n
}) => {
  const i = _7();
  return /* @__PURE__ */ y.jsx(zt, { className: nt(i.wrapper, t), sx: n, children: [...r || [], ...S7(e)].map(
    ({ count: o, Icon: s }, l) => /* @__PURE__ */ y.jsxs("div", { className: i.mediaIcon, children: [
      o !== void 0 && /* @__PURE__ */ y.jsx(Lt, { className: i.mediaIconCount, children: o }),
      /* @__PURE__ */ y.jsx(s, {})
    ] }, `mediaIcon${l}`)
  ) });
}, TZ = ({
  placeholder: e,
  rawDraft: t,
  onChange: r,
  actions: n,
  entityInputs: i,
  readOnly: o,
  decorators: s,
  plugins: l,
  shouldDisplayToolbarFn: c,
  handlePastedText: f,
  sidebarRendererFn: h = () => null,
  softNewLines: g = !1
}) => {
  const [S, b] = Xe(
    kl(t, s)
  );
  return pt(() => {
    const p = window.setTimeout(() => {
      r(S);
    }, 500);
    return () => {
      window.clearTimeout(p);
    };
  }, [S, r]), pt(() => {
    b(kl(t, s));
  }, [s, t]), /* @__PURE__ */ y.jsx(
    NE,
    {
      editorState: S,
      onChange: b,
      placeholder: e,
      entityInputs: i || {},
      readOnly: o,
      sidebarRendererFn: h,
      shouldDisplayToolbarFn: c,
      actions: n,
      plugins: l,
      softNewLines: g,
      spellCheck: !0,
      handlePastedText: f
    }
  );
}, OZ = (e) => ({ contentState: t, children: r, entityKey: n }) => {
  const { url: i } = t.getEntity(n).getData();
  return /* @__PURE__ */ y.jsx("a", { className: "editor__link", href: i, title: i, style: e, children: r });
}, E7 = (e) => e.getCurrentContent().getBlockMap().filter((t) => t ? t.getType() === Wi.TITLE : !1).map((t) => ({
  url: t && `#${t.getKey()}`,
  title: t && t.getText(),
  key: t && t.getKey()
})), RZ = (e) => {
  const t = E7(e.editorState).valueSeq(), r = (n) => {
    const i = n.target.value;
    e.setEntity({ url: i });
  };
  return pt(() => {
    var s;
    const n = document.querySelector(".toolbar__wrapper"), i = n == null ? void 0 : n.cloneNode(!0);
    i && ((s = n == null ? void 0 : n.parentNode) == null || s.replaceChild(i, n));
    const o = document.querySelector(".toolbar__input");
    o == null || o.addEventListener("change", r), o == null || o.setAttribute("value", e.url);
  }, []), /* @__PURE__ */ y.jsxs(
    "div",
    {
      style: { whiteSpace: "nowrap", display: "flex", alignItems: "center" },
      children: [
        /* @__PURE__ */ y.jsxs(
          "select",
          {
            className: "toolbar__input",
            onChange: r,
            value: e.url,
            children: [
              /* @__PURE__ */ y.jsx("option", { children: "Choisissez un titre à lier" }),
              t.map(({ key: n, url: i, title: o }) => /* @__PURE__ */ y.jsx("option", { value: i, children: o }, n))
            ]
          }
        ),
        /* @__PURE__ */ y.jsx("span", { className: "toolbar__item", children: /* @__PURE__ */ y.jsx(
          "button",
          {
            onClick: e.removeEntity,
            type: "button",
            className: "toolbar__button toolbar__input-button",
            children: e.entity ? /* @__PURE__ */ y.jsx(ua.UnlinkIcon, {}) : /* @__PURE__ */ y.jsx(ua.CloseIcon, {})
          }
        ) })
      ]
    }
  );
}, By = "button", C7 = ({ initialForm: e }) => ({ editorState: t, onChange: r }) => {
  const n = (i) => {
    i.preventDefault();
    const o = {
      ...e,
      type: By
    };
    r(Vl(t, o));
  };
  return /* @__PURE__ */ y.jsx(Lo, { label: "Bouton", onClick: n, children: /* @__PURE__ */ y.jsx(LN, {}) });
}, Fy = ({
  label: e,
  options: t,
  value: r,
  onChange: n,
  SelectProps: i,
  InputLabelProps: o,
  ...s
}) => /* @__PURE__ */ y.jsxs(ra, { ...s, children: [
  /* @__PURE__ */ y.jsx(hm, { id: "select-label", ...o, children: e }),
  /* @__PURE__ */ y.jsx(
    gm,
    {
      labelId: "select-label",
      label: e,
      value: r || "",
      onChange: (l) => n == null ? void 0 : n(
        l,
        String(l.target.value)
      ),
      ...i,
      children: t.map((l, c) => /* @__PURE__ */ y.jsx(
        la,
        {
          value: l.value,
          ...l.MenuItemProps,
          children: l.label
        },
        `select-item-${c}`
      ))
    }
  )
] }), LS = (e) => ({
  rendering: e.rendering,
  renderingOptions: e.renderingOptions,
  buttonLabel: e.buttonLabel,
  tagId: e.tagId,
  url: e.url,
  noFollow: e.noFollow,
  newTab: e.newTab,
  sponsored: e.sponsored
}), T7 = ({ blockProps: e, container: { onChange: t, props: r } }, n) => {
  const o = r.blockProps.getEditorState().getCurrentContent(), s = new ME({
    anchorKey: r.block.getKey(),
    anchorOffset: 0,
    focusKey: r.block.getKey(),
    focusOffset: r.block.getLength()
  }), l = aa.Map({
    ...n,
    type: By
  }), c = np.setBlockData(
    o,
    s,
    l
  ), f = Fc.push(
    e.editorState,
    c,
    "change-block-data"
  );
  return t(f), f;
}, O7 = (e) => {
  const [t, r] = Xe(
    LS(e.data)
  ), n = dt.useMemo(
    () => ({
      handleFieldChange: (i, o) => {
        const s = li.cloneDeep(t), l = [i];
        li.set(s, l, o), T7(e, s), r(() => LS(s));
      },
      handleFrameRemove: () => {
        e.blockProps.setReadOnly(!1), e.container.remove();
      }
    }),
    [t, e]
  );
  return { c2cPluginData: t, handlers: n };
}, R7 = () => Xf((e) => {
  const { c2cPluginData: t, handlers: r } = O7(e);
  return /* @__PURE__ */ y.jsxs(
    mm,
    {
      sx: {
        backgroundColor: (n) => n.palette.common.white,
        borderRadius: (n) => n.shape.borderRadius
      },
      children: [
        /* @__PURE__ */ y.jsxs(
          zt,
          {
            sx: {
              alignItems: "center",
              backgroundColor: (n) => n.palette.grey[100],
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: (n) => n.spacing(2, 3, 2, 4)
            },
            children: [
              /* @__PURE__ */ y.jsx(Lt, { variant: "h5", children: "Bouton" }),
              /* @__PURE__ */ y.jsx(
                uo,
                {
                  color: "primary",
                  onClick: r.handleFrameRemove,
                  size: "small",
                  children: /* @__PURE__ */ y.jsx(zc, {})
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(
          zt,
          {
            sx: {
              padding: (n) => n.spacing(5, 4, 2),
              "& .megadraft-block": {
                padding: 0
              }
            },
            children: /* @__PURE__ */ y.jsxs(Dn, { container: !0, spacing: 4, children: [
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 4, children: /* @__PURE__ */ y.jsx(
                ra,
                {
                  sx: {
                    width: "100%"
                  },
                  children: /* @__PURE__ */ y.jsx(
                    Fy,
                    {
                      label: "Rendu",
                      onChange: (n, i) => {
                        r.handleFieldChange("rendering", i);
                      },
                      options: t.renderingOptions,
                      value: t.rendering
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 8, children: /* @__PURE__ */ y.jsx(
                ra,
                {
                  sx: {
                    width: "100%"
                  },
                  children: /* @__PURE__ */ y.jsx(
                    ln,
                    {
                      fullWidth: !0,
                      name: "buttonLabel",
                      label: "Libellé du bouton",
                      onChange: (n) => {
                        r.handleFieldChange(
                          "buttonLabel",
                          n.target.value
                        );
                      },
                      value: t.buttonLabel,
                      variant: "standard"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 12, children: /* @__PURE__ */ y.jsx(
                ra,
                {
                  sx: {
                    width: "100%"
                  },
                  children: /* @__PURE__ */ y.jsx(
                    ln,
                    {
                      fullWidth: !0,
                      name: "tagId",
                      label: "Tag Id",
                      onChange: (n) => {
                        r.handleFieldChange("tagId", n.target.value);
                      },
                      value: t.tagId,
                      variant: "standard"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 12, children: /* @__PURE__ */ y.jsx(
                ra,
                {
                  sx: {
                    width: "100%"
                  },
                  children: /* @__PURE__ */ y.jsx(
                    ln,
                    {
                      fullWidth: !0,
                      name: "url",
                      label: "Url",
                      onChange: (n) => {
                        r.handleFieldChange("url", n.target.value);
                      },
                      value: t.url,
                      variant: "standard"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 4, children: /* @__PURE__ */ y.jsx(
                js,
                {
                  sx: {
                    width: "100%"
                  },
                  label: "No follow",
                  control: /* @__PURE__ */ y.jsx(
                    Ba,
                    {
                      color: "primary",
                      onChange: (n) => {
                        r.handleFieldChange(
                          "noFollow",
                          n.target.checked
                        );
                      },
                      checked: t.noFollow
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 4, children: /* @__PURE__ */ y.jsx(
                js,
                {
                  sx: {
                    width: "100%"
                  },
                  label: "Nouvel onglet",
                  control: /* @__PURE__ */ y.jsx(
                    Ba,
                    {
                      color: "primary",
                      onChange: (n) => {
                        r.handleFieldChange(
                          "newTab",
                          n.target.checked
                        );
                      },
                      checked: t.newTab
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 4, children: /* @__PURE__ */ y.jsx(
                js,
                {
                  sx: {
                    width: "100%"
                  },
                  label: "Sponsored",
                  control: /* @__PURE__ */ y.jsx(
                    Ba,
                    {
                      color: "primary",
                      onChange: (n) => {
                        r.handleFieldChange(
                          "sponsored",
                          n.target.checked
                        );
                      },
                      checked: t.sponsored
                    }
                  )
                }
              ) })
            ] })
          }
        )
      ]
    }
  );
}), IZ = ({ initialForm: e }) => ({
  blockComponent: R7(),
  buttonComponent: C7({ initialForm: e }),
  type: By
}), I7 = Rt((e) => ({
  title: {
    marginLeft: e.spacing(2),
    flex: 1
  },
  centered: {
    justifyContent: "center"
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden"
  },
  itemContainer: {
    height: 168,
    padding: e.spacing(1)
  },
  itemContent: {
    display: "flex",
    position: "relative",
    height: "100%",
    border: "1px solid #ccc",
    borderRadius: "3px",
    alignItems: "center",
    justifyContent: "center"
  },
  credit: {
    position: "absolute",
    margin: "0 auto",
    bottom: 0,
    padding: 5
  },
  gridList: {
    width: "100%",
    overflow: "hidden scroll"
  },
  imageFallback: {
    maxWidth: "100%",
    maxHeight: "100%"
  },
  priceLevel: {
    position: "absolute",
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "0 5px",
    top: 15,
    right: 15
  }
})), D7 = 200, P7 = (e) => ({ editorState: t, onChange: r }) => {
  const { saveFoto: n, fotowebUrl: i, loadTopicSubjectFoto: o, topicSubjectId: s } = e, [l, c] = Xe(!1), [f, h] = Xe([]), [g, S] = Xe(!1), b = I7({});
  pt(() => {
    l && s && (async (C) => {
      S(!0);
      const M = await o(C);
      M && h(M), S(!1);
    })(s);
  }, [l, s, o]);
  const p = (w) => {
    const C = w.previews.filter((z) => {
      if ((z == null ? void 0 : z.size) === D7)
        return z;
    }), M = i + C[0].href, { credit: L, prismaPriceLevel: W } = w;
    return /* @__PURE__ */ y.jsxs("div", { className: b.itemContainer, children: [
      /* @__PURE__ */ y.jsx(Lt, { className: b.priceLevel, children: W }),
      /* @__PURE__ */ y.jsx("div", { className: b.itemContent, children: /* @__PURE__ */ y.jsx("img", { src: M, className: b.imageFallback }) }),
      /* @__PURE__ */ y.jsx("div", { className: b.credit, children: /* @__PURE__ */ y.jsx(Lt, { children: L }) })
    ] });
  }, v = async (w, C) => {
    w.preventDefault(), c(!1), S(!0);
    const M = await n(C), L = { type: "media", ...VT(M) };
    r(Vl(t, L)), S(!1);
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs(jc, { open: l, onClose: () => c(!1), maxWidth: "lg", children: [
      /* @__PURE__ */ y.jsx(Ka, { position: "relative", color: "inherit", children: /* @__PURE__ */ y.jsxs(ca, { children: [
        /* @__PURE__ */ y.jsx(
          Lt,
          {
            variant: "h6",
            color: "inherit",
            className: b.title,
            children: "Insertion d'une image de ONE-Story"
          }
        ),
        /* @__PURE__ */ y.jsx(
          fr,
          {
            edge: "start",
            color: "inherit",
            onClick: () => {
              c(!1);
            },
            "aria-label": "Close",
            children: /* @__PURE__ */ y.jsx(ql, {})
          }
        )
      ] }) }),
      /* @__PURE__ */ y.jsxs(Ao, { children: [
        /* @__PURE__ */ y.jsx(za, { children: "Photos sélectionnées" }),
        g ? /* @__PURE__ */ y.jsx("div", { className: b.centered, children: /* @__PURE__ */ y.jsx(un, { color: "primary", size: 80 }) }) : /* @__PURE__ */ y.jsx("div", { className: b.root, children: /* @__PURE__ */ y.jsx(
          tN,
          {
            rowHeight: 160,
            className: b.gridList,
            cols: 3,
            children: f.map((w, C) => /* @__PURE__ */ y.jsx(
              rN,
              {
                cols: 1,
                onClick: (M) => v(M, w),
                style: { height: "auto", padding: 8 },
                children: p(w)
              },
              C
            ))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ y.jsx(Lo, { label: "ONE-Story", onClick: () => c(!0), children: /* @__PURE__ */ y.jsx(zN, {}) })
  ] });
};
var Zg, zS;
function M7() {
  return zS || (zS = 1, Zg = function e(t, r) {
    if (t === r) return !0;
    if (t && r && typeof t == "object" && typeof r == "object") {
      if (t.constructor !== r.constructor) return !1;
      var n, i, o;
      if (Array.isArray(t)) {
        if (n = t.length, n != r.length) return !1;
        for (i = n; i-- !== 0; )
          if (!e(t[i], r[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
      if (o = Object.keys(t), n = o.length, n !== Object.keys(r).length) return !1;
      for (i = n; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(r, o[i])) return !1;
      for (i = n; i-- !== 0; ) {
        var s = o[i];
        if (!(s === "_owner" && t.$$typeof) && !e(t[s], r[s]))
          return !1;
      }
      return !0;
    }
    return t !== t && r !== r;
  }), Zg;
}
var A7 = M7();
const N7 = /* @__PURE__ */ jr(A7);
var j7 = function(e) {
  return e !== Object(e);
}, k7 = function(e, t, r) {
  process.env.NODE_ENV !== "production" && ((!(t instanceof Array) || !t.length) && console.warn("`useCustomCompareEffect` should not be used with no dependencies. Use React.useEffect instead."), t.every(j7) && console.warn("`useCustomCompareEffect` should not be used with dependencies that are all primitive values. Use React.useEffect instead."), typeof r != "function" && console.warn("`useCustomCompareEffect` should be used with depsEqual callback for comparing deps list"));
  var n = bt(void 0);
  (!n.current || !r(t, n.current)) && (n.current = t), pt(e, n.current);
}, L7 = function(e) {
  return e !== Object(e);
}, z7 = function(e, t) {
  process.env.NODE_ENV !== "production" && ((!(t instanceof Array) || !t.length) && console.warn("`useDeepCompareEffect` should not be used with no dependencies. Use React.useEffect instead."), t.every(L7) && console.warn("`useDeepCompareEffect` should not be used with dependencies that are all primitive values. Use React.useEffect instead.")), k7(e, t, N7);
};
const B7 = (e, t, r) => {
  const n = new RegExp(t, "i");
  let i = !!e.match(n);
  return i && e.includes(r) && (i = e.split(r).map(lW).some((o) => o.match(n))), i;
}, F7 = (e = [], t) => {
  const r = [":", "/", "|"];
  return e.reduce(
    (n, { imageSources: i = [], sources: o = [] }) => [
      ...n,
      // ImageSources is replaced by Sources in new api
      ...i == null ? void 0 : i.map((s) => s.title),
      ...o == null ? void 0 : o.map((s) => s.title)
    ],
    []
  ).find(
    (n) => t && n && r.some(
      (i) => B7(t, n, i)
    )
  );
}, W7 = ({
  errors: e,
  fetchSources: t,
  onSourceChange: r,
  oneMedia: n,
  required: i
}) => {
  var g;
  const o = kt(() => {
    var b;
    const S = n.source || ((b = n.iframely.meta) == null ? void 0 : b.source);
    return S ? { id: Pf(), label: S } : void 0;
  }, [(g = n.iframely.meta) == null ? void 0 : g.source, n.source]), [s, l] = Xe(o), [c, f] = Xe(!1), h = (S) => t(S).then(
    (b = []) => b.reduce(
      (p, { id: v, title: w, imageSources: C = [], sources: M = [] }) => [
        ...p,
        { id: v, label: w, disabled: !0 },
        // ImageSources is replaced by Sources in new api
        ...C == null ? void 0 : C.map(({ id: L, title: W }) => ({
          id: L,
          label: W,
          level: 1
        })),
        ...M.map(({ id: L, title: W }) => ({
          id: L,
          label: W,
          level: 1
        }))
      ],
      []
    )
  );
  return z7(() => {
    l(o);
    const S = n.credit || n.iframely.meta.credit;
    !o && !s && S && !c && t("").then((b) => {
      const p = F7(b, S);
      p && (l({ id: Pf(), label: p }), r(p, { isPristine: !0 }));
    }).catch(() => {
    });
  }, [n]), /* @__PURE__ */ y.jsx(
    gz,
    {
      fetchList: h,
      label: "Source",
      onChange: (S) => {
        f(!0), l(S), r(S == null ? void 0 : S.label, { isPristine: !1 });
      },
      TextFieldProps: {
        required: i,
        ...i && e.isTouched && {
          error: e.hasError,
          helperText: e.errorMessages[e.errors[0]]
        }
      },
      value: s
    }
  );
}, H7 = Rt((e) => ({
  caption: {
    marginBottom: e.spacing(3)
  },
  mediaContainer: {
    flexDirection: "row",
    display: "flex"
  },
  imageLink: {
    flex: 1
  },
  checkboxContainer: {
    marginLeft: e.spacing(2)
  },
  formControl: {
    marginBottom: e.spacing(3),
    width: "100%"
  }
}));
var ta = /* @__PURE__ */ ((e) => (e.patternRule = "patternRule", e.requiredRule = "requiredRule", e))(ta || {});
const BS = (e) => {
  var t, r, n, i;
  return {
    ...e,
    caption: (e == null ? void 0 : e.caption) || "",
    format: (e == null ? void 0 : e.format) || "",
    href: (e == null ? void 0 : e.href) || "",
    credit: Ll(e == null ? void 0 : e.credit) ? e.credit : ((r = (t = e == null ? void 0 : e.iframely) == null ? void 0 : t.meta) == null ? void 0 : r.credit) || "",
    source: Ll(e == null ? void 0 : e.source) ? e.source : ((i = (n = e == null ? void 0 : e.iframely) == null ? void 0 : n.meta) == null ? void 0 : i.source) || ""
  };
}, Qg = (e) => {
  var c, f, h, g, S, b, p, v, w, C, M, L, W, z, B;
  const { isPristine: t = !0 } = (e == null ? void 0 : e.opts) || {}, r = !e.fieldName, n = go(e.media), i = !!((c = e == null ? void 0 : e.opts) != null && c.withHref), o = !!((f = e == null ? void 0 : e.opts) != null && f.formats), s = (h = e == null ? void 0 : e.opts) == null ? void 0 : h.fieldsRequired;
  let l = {
    ...(e == null ? void 0 : e.errors) || (e == null ? void 0 : e.media.errors) || wj
  };
  if (i && (r || e.fieldName === "href")) {
    const K = !!((g = e == null ? void 0 : e.media.href) != null && g.length) && !Rj(e.media.href), Z = [
      ...K && [ta.patternRule] || []
    ];
    l = {
      ...l,
      link: {
        errorMessages: {
          [ta.patternRule]: 'Le format du champ "href" du média est invalide'
        },
        errors: Z,
        hasError: K,
        isTouched: !t || l.link.isTouched || !r
      }
    };
  }
  if (s) {
    if (o && (r || e.fieldName === "format") && ((S = e == null ? void 0 : e.opts) != null && S.requiredFormats)) {
      const K = !((b = e == null ? void 0 : e.media.format) != null && b.length), Z = [
        ...K && [ta.requiredRule] || []
      ];
      l = {
        ...l,
        format: {
          errors: Z,
          errorMessages: {
            [ta.requiredRule]: 'Le champ "format" du média est requis'
          },
          hasError: K,
          isTouched: !t || l.format.isTouched || !r
        }
      };
    }
    if (n) {
      if (r || e.fieldName === "credit") {
        const K = typeof ((p = e == null ? void 0 : e.media) == null ? void 0 : p.credit) < "u" ? !e.media.credit.length : !((M = (C = (w = (v = e == null ? void 0 : e.media) == null ? void 0 : v.iframely) == null ? void 0 : w.meta) == null ? void 0 : C.credit) != null && M.length), Z = [
          ...K && [ta.requiredRule] || []
        ];
        l = {
          ...l,
          credit: {
            errors: Z,
            errorMessages: {
              [ta.requiredRule]: 'Le champ "credit" du média est requis'
            },
            hasError: K,
            isTouched: !t || l.credit.isTouched || !r
          }
        };
      }
      if (r || e.fieldName === "source") {
        const K = Ll(e == null ? void 0 : e.media.source) ? !e.media.source.length : !((B = (z = (W = (L = e == null ? void 0 : e.media) == null ? void 0 : L.iframely) == null ? void 0 : W.meta) == null ? void 0 : z.source) != null && B.length), Z = [
          ...K && [ta.requiredRule] || []
        ];
        l = {
          ...l,
          source: {
            errors: Z,
            errorMessages: {
              [ta.requiredRule]: 'Le champ "source" du média est requis'
            },
            hasError: K,
            isTouched: !t || l.source.isTouched || !r
          }
        };
      }
    }
  }
  return l;
}, $7 = (e, t) => {
  const [r, n] = Xe(BS(e)), [i, o] = Xe(
    Qg({ media: r, opts: t })
  ), s = Kt(
    (c, f) => {
      const h = {
        ...c,
        iframely: {
          ...c.iframely,
          meta: {
            ...c.iframely.meta || {},
            credit: c.credit
          }
        },
        ...t.withErrors && { errors: f }
      };
      t.updateMedia(h);
    },
    [t]
  ), l = dt.useMemo(
    () => ({
      handleFormValidation: (c, f, h) => {
        const g = Qg({
          errors: i,
          fieldName: c,
          media: f,
          opts: { ...t, ...h }
        });
        s(f, g), o(g);
      },
      handleFieldChange: (c) => (f, h) => {
        const g = li.get(r, c), S = li.isObject(f) ? f.target.value : f;
        if (g !== S) {
          const b = li.cloneDeep(r), p = li.last(c) || "";
          li.set(b, c, S), l.handleFormValidation(p, b, h), n(b);
        }
      }
    }),
    [r, i, t, s]
  );
  return pt(() => {
    const c = BS(e);
    if (n(c), t.fieldsRequired) {
      const f = (c == null ? void 0 : c.errors) || Qg({ media: c, opts: t });
      o(f), t.withErrors && s(c, f);
    }
  }, [e.iframely.meta.canonical, e.iframely.meta.date]), {
    errors: i,
    form: r,
    handlers: l
  };
}, ZT = ({
  fetchSources: e,
  fieldsRequired: t = !1,
  formats: r,
  media: n,
  withHref: i,
  requiredFormats: o,
  ...s
}) => {
  const l = H7(), c = kt(() => go(n), [n]), {
    errors: f,
    form: h,
    handlers: { handleFieldChange: g }
  } = $7(n, {
    fieldsRequired: t,
    formats: r,
    withHref: i,
    ...s
  });
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    i && c && /* @__PURE__ */ y.jsxs("div", { className: l.mediaContainer, children: [
      /* @__PURE__ */ y.jsx(
        ln,
        {
          className: gv(l.caption, l.imageLink),
          "data-testid": "multimedia-link",
          label: "Lien",
          name: "imageLink",
          onChange: g(["href"]),
          value: h.href || "",
          variant: "standard",
          ...f.link.isTouched && {
            error: f.link.hasError,
            helperText: f.link.errorMessages[f.link.errors[0]]
          }
        }
      ),
      /* @__PURE__ */ y.jsx(
        js,
        {
          className: l.checkboxContainer,
          control: /* @__PURE__ */ y.jsx(
            Ba,
            {
              checked: !!h.target,
              color: "primary",
              disabled: !h.href,
              name: "target",
              onChange: (S, b) => {
                g(["rel"])(b ? "nofollow" : null), g(["target"])(b ? "_blank" : null);
              }
            }
          ),
          label: "Nouvel onglet"
        }
      )
    ] }),
    c && /* @__PURE__ */ y.jsx(
      ln,
      {
        className: l.caption,
        "data-testid": "multimedia-credit",
        disabled: !go(h),
        fullWidth: !0,
        label: "Crédit",
        name: "imageCredit",
        onChange: g(["credit"]),
        required: t,
        value: h.credit || "",
        variant: "standard",
        ...t && f.credit.isTouched && {
          error: f.credit.hasError,
          helperText: f.credit.errorMessages[f.credit.errors[0]]
        }
      }
    ),
    /* @__PURE__ */ y.jsx(
      ln,
      {
        className: l.caption,
        "data-testid": "multimedia-legend",
        fullWidth: !0,
        label: "Légende",
        name: "imageLegend",
        onChange: g(["caption"]),
        value: h.caption || "",
        variant: "standard"
      }
    ),
    r && /* @__PURE__ */ y.jsxs(ra, { className: l.formControl, children: [
      /* @__PURE__ */ y.jsxs(hm, { id: "format-select", htmlFor: "format", children: [
        "Format ",
        o ? " *" : ""
      ] }),
      /* @__PURE__ */ y.jsx(
        gm,
        {
          inputProps: { id: "format", name: "format" },
          fullWidth: !0,
          label: `Format ${o ? " *" : ""}`,
          labelId: "format-select",
          onChange: (S) => g(["format"])(S),
          value: h.format || "",
          ...o && f.format.isTouched && {
            error: f.format.hasError
          },
          children: r == null ? void 0 : r.map((S) => /* @__PURE__ */ y.jsx(
            la,
            {
              "data-testid": "multimedia-format-item",
              value: S.value,
              children: S.label
            },
            S.value
          ))
        }
      ),
      t && f.format.isTouched && /* @__PURE__ */ y.jsx(nN, { children: f.format.errorMessages[f.format.errors[0]] })
    ] }),
    c && (e ? /* @__PURE__ */ y.jsx(
      W7,
      {
        errors: f.source,
        fetchSources: e,
        onSourceChange: g(["source"]),
        oneMedia: h,
        required: t
      }
    ) : /* @__PURE__ */ y.jsx(
      ln,
      {
        fullWidth: !0,
        label: "Source",
        name: "sourceLegend",
        onChange: g(["source"]),
        required: t,
        value: h.source || "",
        ...t && f.source.isTouched && {
          error: f.source.hasError,
          helperText: f.source.errorMessages[f.source.errors[0]]
        },
        variant: "standard"
      }
    ))
  ] });
}, _p = Xf((e) => {
  var f;
  const { data: t, container: r, blockProps: n } = e, { disableCrop: i, fetchSources: o, fieldsRequired: s } = ((f = n.plugin) == null ? void 0 : f.options) || {};
  if (!t)
    return null;
  const l = ({
    crop: h,
    focusPoint: g
  }) => {
    r.updateData({ ...t, crop: h, focusPoint: g });
  }, c = () => {
    r.remove(), n.setReadOnly(!1);
  };
  return /* @__PURE__ */ y.jsx(mm, { sx: { maxWidth: "800px" }, children: /* @__PURE__ */ y.jsx(
    JT,
    {
      media: t,
      onCropAndFocusPointChange: l,
      onMediaDelete: c,
      disableCrop: i,
      mediaFields: /* @__PURE__ */ y.jsx(
        ZT,
        {
          media: t,
          updateMedia: r.updateData,
          fetchSources: o,
          fieldsRequired: s,
          withHref: !0
        }
      )
    }
  ) });
}), DZ = (e) => ({
  type: "fotoweb",
  buttonComponent: P7(e),
  blockComponent: _p
});
var Ro = /* @__PURE__ */ ((e) => (e.DEFAULT = "DEFAULT", e.SOURCE = "SOURCE", e.SUMMARY = "SUMMARY", e.NOTICE = "NOTICE", e.DEONTOLOGY = "DEONTOLOGY", e.REBOUND_TEXT = "REBOUND_TEXT", e.BULLET_POINT = "BULLET_POINT", e))(Ro || {});
const Wy = "aside", QT = "Encadré", U7 = "Contenu de l'encadré", FS = "Titre de l'encadré", G7 = "Type d'encadré", q7 = (e) => {
  switch (e) {
    case Ro.SUMMARY:
      return "Sommaire";
    case Ro.SOURCE:
      return "Source";
    case Ro.NOTICE:
      return "Avis";
    case Ro.DEONTOLOGY:
      return "Déontologie";
    case Ro.REBOUND_TEXT:
      return "Rebond + texte";
    case Ro.BULLET_POINT:
      return "Bullet point";
    default:
      return "Classique";
  }
}, V7 = (e) => ({
  id: e,
  value: e,
  label: q7(e)
}), Y7 = (e) => e.map(V7), eO = {
  frameDraft: null,
  frameTitle: "",
  frameType: Ro.DEFAULT,
  frameOptions: [Ro.DEFAULT, Ro.SUMMARY]
}, K7 = Rt((e) => ({
  formControl: {
    marginBottom: e.spacing(4),
    width: "100%"
  },
  innerWrapper: {
    padding: e.spacing(5, 4, 2),
    "& .megadraft-block": {
      padding: 0
    }
  },
  wrapper: {
    backgroundColor: e.palette.common.white,
    borderRadius: e.shape.borderRadius
  },
  wrapperMaterialDraft: {
    width: "100%"
  },
  wrapperTitle: {
    alignItems: "center",
    backgroundColor: e.palette.grey[100],
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: e.spacing(2, 3, 2, 4)
  }
})), WS = (e) => ({
  frameDraft: e.frameDraft,
  frameTitle: e.frameTitle,
  frameType: e.frameType
}), X7 = ({ blockProps: e, container: { onChange: t, props: r } }, n) => {
  const o = r.blockProps.getEditorState().getCurrentContent(), s = new ME({
    anchorKey: r.block.getKey(),
    anchorOffset: 0,
    focusKey: r.block.getKey(),
    focusOffset: r.block.getLength()
  }), l = aa.Map({
    ...n,
    type: Wy
  }), c = np.setBlockData(
    o,
    s,
    l
  ), f = Fc.push(
    e.editorState,
    c,
    "change-block-data"
  );
  return t(f), f;
}, J7 = (e) => {
  var l, c;
  const { decorators: t } = kt(
    () => {
      var f, h;
      return ky(((h = (f = e.blockProps.plugin) == null ? void 0 : f.props) == null ? void 0 : h.actions) || []);
    },
    [(c = (l = e.blockProps.plugin) == null ? void 0 : l.props) == null ? void 0 : c.actions]
  ), [r, n] = Xe(
    WS(e.data)
  ), [i, o] = Xe(
    kl(
      r.frameDraft || null,
      new PE(t)
    )
  ), s = dt.useMemo(
    () => ({
      handleDraftChange: (f) => {
        o(f), s.handleFieldChange(
          "frameDraft",
          JSON.parse(AE(f))
        );
      },
      handleFieldChange: (f, h) => {
        const g = li.cloneDeep(r), S = [f];
        li.set(g, S, h), X7(e, g), n(() => WS(g));
      },
      handleFrameRemove: () => {
        e.blockProps.setReadOnly(!1), e.container.remove();
      }
    }),
    [r, e]
  );
  return { framePluginData: r, frameEditorState: i, handlers: s };
}, Z7 = ({
  frameOptions: e,
  plugins: t
}) => Xf((r) => {
  var f, h;
  const { framePluginData: n, frameEditorState: i, handlers: o } = J7(r), s = kt(
    () => {
      var g, S;
      return ((S = (g = r.blockProps.plugin) == null ? void 0 : g.props) == null ? void 0 : S.actions) || [];
    },
    [(h = (f = r.blockProps.plugin) == null ? void 0 : f.props) == null ? void 0 : h.actions]
  ), l = K7(), c = Y7(
    e || eO.frameOptions
  );
  return /* @__PURE__ */ y.jsxs(mm, { className: l.wrapper, children: [
    /* @__PURE__ */ y.jsxs(zt, { className: l.wrapperTitle, children: [
      /* @__PURE__ */ y.jsx(Lt, { variant: "h5", children: QT }),
      /* @__PURE__ */ y.jsx(
        uo,
        {
          color: "primary",
          onClick: o.handleFrameRemove,
          size: "small",
          children: /* @__PURE__ */ y.jsx(zc, {})
        }
      )
    ] }),
    /* @__PURE__ */ y.jsxs(zt, { className: l.innerWrapper, children: [
      /* @__PURE__ */ y.jsxs(Dn, { container: !0, spacing: 4, children: [
        /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 3, children: /* @__PURE__ */ y.jsx(ra, { className: l.formControl, children: /* @__PURE__ */ y.jsx(
          Fy,
          {
            label: G7,
            onChange: (g, S) => {
              o.handleFieldChange("frameType", S);
            },
            options: c,
            value: n.frameType
          }
        ) }) }),
        /* @__PURE__ */ y.jsx(Dn, { item: !0, xs: 9, children: /* @__PURE__ */ y.jsx(ra, { className: l.formControl, children: /* @__PURE__ */ y.jsx(
          ln,
          {
            fullWidth: !0,
            name: FS,
            label: FS,
            onChange: (g) => {
              o.handleFieldChange(
                "frameTitle",
                g.target.value
              );
            },
            value: n.frameTitle,
            variant: "standard"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ y.jsx(
        GT,
        {
          actions: s,
          className: l.wrapperMaterialDraft,
          editorState: i,
          label: U7,
          onChange: (g) => {
            o.handleDraftChange(g);
          },
          wordCounter: !0,
          plugins: t
        }
      )
    ] })
  ] });
}), Q7 = ({ defaultOption: e }) => ({ editorState: t, onChange: r }) => {
  const n = (i) => {
    i.preventDefault();
    const o = {
      ...eO,
      frameType: e,
      type: Wy
    };
    r(Vl(t, o));
  };
  return /* @__PURE__ */ y.jsx(Lo, { label: QT, onClick: n, children: /* @__PURE__ */ y.jsx(BN, {}) });
}, PZ = ({
  frameOptions: e,
  defaultOption: t,
  plugins: r
}) => ({
  blockComponent: Z7({ frameOptions: e, plugins: r }),
  buttonComponent: Q7({ defaultOption: t }),
  type: Wy,
  options: {
    displayOptions: [],
    defaultDisplay: null
  }
}), e9 = ({ uploadImage: e }) => ({ editorState: t, onChange: r }) => {
  const n = bt(null), { pushNotification: i, removeNotification: o } = Zl(), s = async (c) => {
    const { files: f } = c.target;
    if (f != null && f.length)
      try {
        const h = [() => e(f[0])], [g] = await wW(
          h,
          i,
          o,
          "Importation"
        ), S = {
          type: "image",
          ...g
        };
        r(Vl(t, S));
      } catch (h) {
        i({
          message: h == null ? void 0 : h.message,
          type: jo.error
        });
      }
  }, l = (c) => {
    c.preventDefault(), n.current && n.current.click();
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      "input",
      {
        "data-testid": "megadraft-image-plugin-file-input",
        multiple: !1,
        onChange: s,
        ref: n,
        required: !0,
        style: { display: "none" },
        type: "file"
      }
    ),
    /* @__PURE__ */ y.jsx(
      Lo,
      {
        "data-testid": "megadraft-image-plugin-btn",
        label: "Importer",
        onClick: l,
        children: /* @__PURE__ */ y.jsx(xm, {})
      }
    )
  ] });
}, MZ = (e) => ({
  type: "image",
  buttonComponent: e9(e),
  blockComponent: _p,
  options: {
    fetchSources: e.fetchSources,
    fieldsRequired: !0
  }
}), t9 = "Les url's Cerise ne sont pas autorisées", r9 = "Collez l'URL d'un média et appuyez sur Entrer", n9 = Rt({
  content: {
    position: "relative"
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) scale(2)",
    transformOrigin: "center center"
  },
  medias: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 16
  },
  mediaIcon: {
    margin: "0 10px"
  }
}), i9 = ({
  title: e = "Média externe",
  validateInputUrl: t,
  showFooterIcons: r = !0,
  fetcher: n,
  forbiddenURLMediaList: i = [],
  onMediaLoaded: o
}) => {
  const s = n9(), [l, c] = Xe(!1), [f, h] = Xe(""), [g, S] = Xe(""), b = Kt(
    (v) => {
      S(v.target.value);
    },
    []
  ), p = Kt(
    async (v) => {
      if (v.key !== "Enter")
        return;
      if (v.preventDefault(), !!i.find(
        (C) => g.includes(C)
      )) {
        h(t9);
        return;
      }
      c(!0), h("");
      try {
        t == null || t(g);
        const C = await n(g);
        o(VT(C));
      } catch (C) {
        C instanceof Error && h(C.message);
      }
      c(!1);
    },
    [n, i, o, g, t]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Gl, { children: e }),
    /* @__PURE__ */ y.jsxs(Ao, { className: s.content, children: [
      /* @__PURE__ */ y.jsx(
        ln,
        {
          autoFocus: !0,
          disabled: l,
          fullWidth: !0,
          onChange: b,
          onKeyUp: p,
          placeholder: r9,
          value: g,
          variant: "standard"
        }
      ),
      f && /* @__PURE__ */ y.jsx(za, { color: "error", children: f }),
      r && /* @__PURE__ */ y.jsxs(za, { className: s.medias, children: [
        /* @__PURE__ */ y.jsx(FN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(WN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(HN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx($N, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(UN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(GN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(qN, { className: s.mediaIcon }),
        /* @__PURE__ */ y.jsx(VN, { className: s.mediaIcon })
      ] }),
      l && /* @__PURE__ */ y.jsx(un, { className: s.loader })
    ] })
  ] });
}, tO = ({
  ButtonIcon: e = YN,
  buttonLabel: t = "Lien",
  dialogTitle: r,
  forbiddenURLMediaList: n,
  handleEmbed: i,
  showDialogFooterIcons: o,
  validateInputUrl: s
}) => ({ editorState: l, onChange: c }) => {
  const [f, h] = Xe(!1);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      jc,
      {
        fullWidth: !0,
        open: f,
        onClose: () => {
          h(!1);
        },
        children: /* @__PURE__ */ y.jsx(
          i9,
          {
            fetcher: i,
            onMediaLoaded: (g) => {
              const S = { type: "media", ...g };
              c(Vl(l, S)), h(!1);
            },
            title: r,
            showFooterIcons: o,
            forbiddenURLMediaList: n,
            validateInputUrl: s
          }
        )
      }
    ),
    /* @__PURE__ */ y.jsx(
      Lo,
      {
        "data-testid": "megadraft-media-button-plugin",
        label: t,
        onClick: () => h(!0),
        children: /* @__PURE__ */ y.jsx(e, {})
      }
    )
  ] });
}, AZ = (e) => ({
  type: "media",
  buttonComponent: tO(e),
  blockComponent: _p
}), NZ = (e, t) => ({
  type: e,
  buttonComponent: tO(t),
  blockComponent: _p
});
var Uu = {}, HS;
function o9() {
  if (HS) return Uu;
  HS = 1;
  var e = Vi();
  Object.defineProperty(Uu, "__esModule", {
    value: !0
  }), Uu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "m9.4 10.5 4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
  }), "Camera");
  return Uu.default = n, Uu;
}
var a9 = /* @__PURE__ */ o9();
const s9 = /* @__PURE__ */ jr(a9), l9 = ({
  html: e,
  width: t = "100%",
  minHeight: r = 400
}) => {
  const [n, i] = Xe(!1), o = bt(null), s = Kt(async () => {
    if (!o.current || !o.current.contentWindow)
      return;
    const c = Math.max(
      r,
      o.current.contentWindow.document.body.offsetHeight
    );
    o.current.height = `${c}px`, i(!1);
  }, [r]), l = Kt(
    (c) => {
      i(!0);
      const f = `
      <html>
        <body style="margin:0;padding:0">
          ${c}
        </body>
      </html>
    `;
      if (!o.current)
        return;
      const h = o.current;
      h.contentWindow && (h.addEventListener("load", async () => {
        s(), await qT(200), s();
        const g = {
          attributes: !0,
          attributeOldValue: !1,
          characterData: !0,
          characterDataOldValue: !1,
          childList: !0,
          subtree: !0
        }, S = new MutationObserver(s);
        o.current && o.current.contentWindow && S.observe(
          o.current.contentWindow.document.body,
          g
        );
      }), h.contentWindow.document.open("text/html", "replace"), h.contentWindow.document.write(f), h.contentWindow.document.close());
    },
    [s]
  );
  return pt(() => {
    l(e);
  }, [e]), /* @__PURE__ */ y.jsxs("div", { children: [
    n && /* @__PURE__ */ y.jsx(
      "div",
      {
        style: {
          width: t,
          height: `${r}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "solid black 1px"
        },
        children: /* @__PURE__ */ y.jsx(un, { size: 100, thickness: 6 })
      }
    ),
    /* @__PURE__ */ y.jsx(
      "iframe",
      {
        title: "iframe",
        style: n ? { display: "none" } : {},
        ref: o,
        src: "about:blank",
        width: t,
        height: `${r}px`,
        scrolling: "no",
        frameBorder: "0"
      }
    )
  ] });
}, u9 = Rt((e) => ({
  hovered: {
    position: "absolute",
    top: "210px",
    left: "295px",
    borderColor: "white",
    borderRadius: "5px",
    borderWidth: "1px",
    borderStyle: "solid"
  },
  "hovered:hover": {
    backgroundColor: "rgb(211, 47, 47)"
  },
  leftIcon: {
    marginRight: e.spacing(1)
  },
  button: {
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    margin: e.spacing(1)
  }
})), c9 = ({ media: e, ...t }) => {
  const r = u9();
  return /* @__PURE__ */ y.jsxs("div", { children: [
    /* @__PURE__ */ y.jsx(l9, { html: YT(e), ...t }),
    Ly(e) && /* @__PURE__ */ y.jsx("div", { className: r.hovered, children: /* @__PURE__ */ y.jsxs(
      Fr,
      {
        color: "primary",
        variant: "contained",
        className: r.button,
        onClick: () => window.open(Gf(e)),
        children: [
          /* @__PURE__ */ y.jsx(s9, { className: r.leftIcon }),
          " voir le diaporama"
        ]
      }
    ) })
  ] });
}, d9 = ({
  media: e,
  width: t,
  height: r,
  customStyle: n,
  forceWidth: i,
  forceHeight: o,
  cropForm: s = "top"
}) => {
  let l = { "crop-from": s };
  e.focusPoint && e.focusPoint.relativeX && e.focusPoint.relativeY && (l = {
    "focus-point": `${e.iframely.meta.width * e.focusPoint.relativeX},${e.iframely.meta.height * e.focusPoint.relativeY}`
  });
  const c = Ul(e);
  return /* @__PURE__ */ y.jsx(
    qc,
    {
      src: c && r && t ? Uf.fit({
        origin: c,
        width: t,
        height: r,
        parameters: l
      }) : "",
      style: {
        height: o || r,
        width: i || t,
        ...n
      },
      loaderSize: (o || r) / 4
    }
  );
}, f9 = Rt({
  mediaWrapper: {
    position: "relative"
  },
  mediaActions: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    top: 5,
    right: 5
  },
  mediaAction: { marginBottom: 5 },
  fieldsContainer: { padding: "0 24px" }
}), p9 = ({
  disableCrop: e,
  customStyle: t,
  forceHeight: r,
  forceImage: n,
  forceWidth: i,
  height: o,
  media: s,
  onDelete: l,
  onReload: c,
  onView: f,
  updateMedia: h,
  visible: g,
  width: S
}) => {
  const b = f9(), { openDialog: p, closeDialog: v } = Jl(), [w, C] = Xe(!1), { pushNotification: M } = Zl(), L = n === !0 || !s || go(s), W = L ? /* @__PURE__ */ y.jsx(
    d9,
    {
      media: s,
      height: o,
      width: S,
      forceHeight: r,
      forceWidth: i,
      customStyle: t
    }
  ) : /* @__PURE__ */ y.jsx(c9, { media: s, minHeight: o }), z = async () => {
    try {
      const K = await (await fetch(Ul(s))).blob(), { originalName: Z, extension: ee } = s.iframely.meta, he = Z ? `${Z}${Z.endsWith(ee || "jpeg") ? "" : `.${ee || "jpeg"}`}` : "sans-titre.jpg";
      return XT(K, he);
    } catch (B) {
      B instanceof Error && M({
        message: B.message,
        type: jo.error
      });
    }
    C(!1);
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    W,
    /* @__PURE__ */ y.jsxs("div", { className: b.mediaActions, children: [
      l && /* @__PURE__ */ y.jsx(
        uo,
        {
          size: "small",
          color: "primary",
          className: b.mediaAction,
          onClick: l,
          children: /* @__PURE__ */ y.jsx(zc, {})
        }
      ),
      !L && nm(s) && c && /* @__PURE__ */ y.jsx(
        uo,
        {
          size: "small",
          color: "default",
          variant: "circular",
          className: b.mediaAction,
          onClick: c,
          children: /* @__PURE__ */ y.jsx(KN, {})
        }
      ),
      !L && nm(s) && f && /* @__PURE__ */ y.jsx(
        uo,
        {
          size: "small",
          color: "default",
          variant: "circular",
          className: b.mediaAction,
          onClick: f,
          children: /* @__PURE__ */ y.jsx(XN, {})
        }
      ),
      L && g && /* @__PURE__ */ y.jsx(
        uo,
        {
          size: "small",
          color: "primary",
          className: b.mediaAction,
          onClick: () => {
            p(
              /* @__PURE__ */ y.jsx(
                xT,
                {
                  closeDialog: v,
                  imageSrc: Ul(s),
                  initialCrop: s.crop,
                  initialFocusPoint: s.focusPoint,
                  onValidate: ({ crop: B, focusPoint: K }) => {
                    h({ ...s, crop: B, focusPoint: K });
                  },
                  config: {
                    height: s.iframely.meta.height,
                    width: s.iframely.meta.width
                  },
                  disableCrop: e
                }
              ),
              { fullScreen: !0 }
            );
          },
          children: /* @__PURE__ */ y.jsx(wm, {})
        }
      ),
      L && g && go(s) && /* @__PURE__ */ y.jsx(
        uo,
        {
          size: "small",
          color: "primary",
          className: b.mediaAction,
          onClick: z,
          disabled: w,
          children: /* @__PURE__ */ y.jsx(CE, {})
        }
      )
    ] })
  ] });
}, h9 = Rt((e) => ({
  caption: {
    backgroundColor: e.palette.common.white,
    padding: e.spacing(2)
  }
})), g9 = 800, jZ = ({
  disableCrop: e,
  disableFields: t = !1,
  height: r = Ty,
  media: n,
  onDelete: i,
  onReload: o,
  onView: s,
  updateMedia: l,
  width: c = g9,
  ...f
}) => {
  const h = h9();
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      p9,
      {
        disableCrop: e,
        customStyle: { maxWidth: "100%" },
        height: r,
        media: n,
        onDelete: i,
        onReload: o,
        onView: s,
        updateMedia: l,
        visible: !0,
        width: c
      }
    ),
    !t && /* @__PURE__ */ y.jsx("figcaption", { "data-testid": "mediaBlock", className: h.caption, children: /* @__PURE__ */ y.jsx(
      ZT,
      {
        media: n,
        updateMedia: l,
        ...f
      }
    ) })
  ] });
}, v9 = ({
  editorState: e,
  onChange: t
}) => {
  const [r, n] = Xe(!1), [i, o] = Xe(""), s = (l) => {
    l.keyCode === 13 && (l.preventDefault(), t(Vl(e, { type: "pageBreak", title: i })), n(!1));
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs(jc, { open: r, onClose: () => n(!1), fullWidth: !0, children: [
      /* @__PURE__ */ y.jsx(Gl, { children: "Entrer le titre de votre saut de page" }),
      /* @__PURE__ */ y.jsx(Ao, { children: /* @__PURE__ */ y.jsx(
        ln,
        {
          variant: "standard",
          name: "inputValue",
          fullWidth: !0,
          onKeyUp: s,
          autoFocus: !0,
          onChange: (l) => o(l.target.value)
        }
      ) })
    ] }),
    /* @__PURE__ */ y.jsx(Lo, { label: "Saut", onClick: () => n(!0), children: /* @__PURE__ */ y.jsx(EE, {}) })
  ] });
}, m9 = ({
  data: e,
  container: t
}) => {
  const r = (n) => {
    const i = { ...e };
    i.title = n.target.value, t.updateData(i);
  };
  return /* @__PURE__ */ y.jsx(zt, { display: "flex", alignItems: "flex-end", children: /* @__PURE__ */ y.jsx(
    ln,
    {
      variant: "standard",
      label: "Titre page",
      value: e.title,
      onChange: r,
      fullWidth: !0,
      InputLabelProps: {
        shrink: !0
      },
      name: "pageTitle"
    }
  ) });
}, kZ = {
  type: "pageBreak",
  buttonComponent: v9,
  blockComponent: m9
}, y9 = "paste-plugin", b9 = "Coller", w9 = () => ({ editorState: e, onChange: t }) => {
  const r = async () => {
    const n = await UT(e);
    t(Fc.moveFocusToEnd(n));
  };
  return /* @__PURE__ */ y.jsx(Lo, { label: b9, onClick: r, children: /* @__PURE__ */ y.jsx(SE, {}) });
}, LZ = () => ({
  buttonComponent: w9(),
  type: y9
}), x9 = (e) => !!(e != null && e.errors && (e != null && e.iframely)), _9 = ({
  data: e,
  type: t
}) => !!(t === "atomic" && e && x9(e)), zZ = (e) => e.filter(_9).map(({ data: t }) => t.errors), S9 = Rt((e) => ({
  wrapper: {
    minHeight: 56
  },
  multipleWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between"
  },
  multipleLabel: {
    color: e.palette.primary.main
  }
})), BZ = ({
  fieldRenderer: e,
  label: t,
  multipleValues: r,
  onEditClick: n,
  className: i
}) => {
  const o = S9(), s = bt(null);
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      className: nt(
        i,
        o.wrapper,
        r && o.multipleWrapper
      ),
      children: r ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(Lt, { variant: "caption", className: o.multipleLabel, children: t }),
        /* @__PURE__ */ y.jsx(
          Fr,
          {
            endIcon: /* @__PURE__ */ y.jsx(tp, {}),
            color: "primary",
            size: "small",
            variant: "outlined",
            onClick: (l) => {
              n == null || n(l), setTimeout(() => {
                var c;
                (c = s.current) == null || c.focus();
              });
            },
            children: "Valeurs multiples"
          }
        )
      ] }) : e(s)
    }
  );
}, E9 = Rt((e) => ({
  label: {
    color: "rgba(0, 0, 0, 0.38)"
  },
  defaultValue: {
    color: e.palette.text.disabled
  }
})), FZ = ({
  label: e,
  value: t,
  className: r,
  defaultValue: n = "-",
  sx: i
}) => {
  const o = E9();
  return /* @__PURE__ */ y.jsxs(zt, { className: r, sx: i, children: [
    /* @__PURE__ */ y.jsx(Lt, { variant: "caption", className: o.label, children: e }),
    /* @__PURE__ */ y.jsx(Lt, { className: nt(!t && o.defaultValue), children: t || n })
  ] });
}, _l = 18, C9 = Rt((e) => ({
  pageWrapper: ({
    paddingTop: t,
    drawerWidth: r,
    smallScreen: n,
    leftDrawerOpen: i,
    rightDrawerOpen: o,
    leftDrawer: s,
    rightDrawer: l
  }) => ({
    marginLeft: s && !n ? i ? r : _l : 0,
    marginRight: l && !n ? o ? r : _l : 0,
    marginTop: t,
    transition: "margin-left 0.3s, margin-right 0.3s, margin-top 0.3s, padding-top 0.3s",
    height: `calc(100vh - ${t}px)`,
    overflowY: "auto",
    overflowX: "hidden",
    position: "relative"
  }),
  contentWrapper: ({ smallScreen: t, fullWidth: r }) => ({
    maxWidth: r ? void 0 : 800 + Sf(e, 4) * 2,
    margin: r ? void 0 : "0 auto",
    padding: r ? void 0 : `${e.spacing(t ? 2 : 4)} ${e.spacing(
      t ? 2 : 4
    )}`,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  }),
  drawer: ({ fullWidthRight: t, paddingTop: r, drawerWidth: n, smallScreen: i }) => ({
    width: n,
    top: i ? 0 : r,
    height: `calc(100vh - ${i ? 0 : r}px)`,
    padding: `${e.spacing(i ? 2 : 4)} ${e.spacing(
      t ? 0 : 3
    )}`,
    transition: "left 0.3s, right 0.3s, top 0.3s, height 0.3s !important",
    zIndex: e.zIndex.appBar - 2
  }),
  leftDrawer: ({ drawerWidth: t, leftDrawerOpen: r, smallScreen: n }) => ({
    left: r || n ? void 0 : -t + _l,
    overflow: r ? void 0 : "hidden"
  }),
  rightDrawer: ({ drawerWidth: t, rightDrawerOpen: r, smallScreen: n }) => ({
    right: r || n ? void 0 : -t + _l,
    overflow: r ? void 0 : "hidden"
  }),
  drawerButton: ({ paddingTop: t }) => ({
    position: "fixed",
    backgroundColor: e.palette.background.paper,
    border: `1px solid ${e.palette.divider}`,
    top: `calc(50vh + ${t / 2}px)`,
    transform: "translateY(-50%)",
    transition: "top 0.3s, left 0.3s, right 0.3s",
    zIndex: e.zIndex.appBar - 2,
    "&:hover": {
      backgroundColor: e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[800]
    }
  }),
  leftDrawerButton: ({ drawerWidth: t, leftDrawerOpen: r, smallScreen: n }) => ({
    left: n ? -25 : r ? t - _l : 0,
    padding: n ? "12px 2px 12px 22px" : void 0
  }),
  rightDrawerButton: ({ drawerWidth: t, rightDrawerOpen: r, smallScreen: n }) => ({
    right: n ? -25 : r ? t - _l : 0,
    padding: n ? "12px 22px 12px 2px" : void 0
  }),
  centered: ({ paddingTop: t }) => ({
    position: "absolute",
    top: `calc(50vh + ${t / 2}px)`,
    transition: "top 0.3s",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center"
  }),
  errorIcon: {
    marginRight: e.spacing(2)
  }
})), ev = "PAGE_LEFT_DRAWER_OPEN", tv = "PAGE_RIGHT_DRAWER_OPEN", WZ = Kf(
  ({
    children: e,
    leftDrawer: t,
    rightDrawer: r,
    paddingTop: n = 0,
    drawerWidth: i = 316,
    fullWidth: o,
    fullWidthRight: s,
    className: l,
    loading: c,
    error: f,
    classes: h,
    refs: g,
    sx: S
  }, b) => {
    const p = zo(), v = sa(p.breakpoints.down("sm")), [w, C] = Xe(!1), [M, L] = Xe(!1), W = C9({
      paddingTop: (v ? 56 : 64) + n,
      drawerWidth: i,
      fullWidth: o,
      fullWidthRight: s,
      leftDrawerOpen: w,
      rightDrawerOpen: M,
      leftDrawer: t,
      rightDrawer: r,
      smallScreen: v
    });
    return pt(() => {
      const z = en.get(ev);
      C(
        z !== void 0 ? z : !v
      );
      const B = en.get(
        tv
      );
      L(
        B !== void 0 ? B : !v
      );
    }, [v]), c || f ? /* @__PURE__ */ y.jsx("div", { className: W.centered, children: c ? /* @__PURE__ */ y.jsx(un, { size: 80 }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      f && /* @__PURE__ */ y.jsx(
        rp,
        {
          className: W.errorIcon,
          color: "primary",
          fontSize: "large"
        }
      ),
      /* @__PURE__ */ y.jsx(Lt, { variant: "h4", color: "primary", children: (f == null ? void 0 : f.message) || "Une erreur est survenue" })
    ] }) }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      !!t && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(
          ov,
          {
            anchor: "left",
            classes: {
              paper: nt(
                W.drawer,
                W.leftDrawer,
                h == null ? void 0 : h.leftDrawer
              )
            },
            onClose: () => {
              C(!1), en.set(ev, !1);
            },
            open: v ? w : !0,
            variant: v ? "temporary" : "persistent",
            children: t
          }
        ),
        /* @__PURE__ */ y.jsx(
          fr,
          {
            ref: g == null ? void 0 : g.leftButton,
            size: v ? "medium" : "small",
            className: nt(W.drawerButton, W.leftDrawerButton),
            onClick: () => {
              C((z) => (en.set(ev, !z), !z));
            },
            children: w ? /* @__PURE__ */ y.jsx(H0, {}) : /* @__PURE__ */ y.jsx($0, {})
          }
        )
      ] }),
      /* @__PURE__ */ y.jsx("div", { className: W.pageWrapper, ref: b, children: /* @__PURE__ */ y.jsx(zt, { className: nt(W.contentWrapper, l), sx: S, children: e }) }),
      !!r && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(
          ov,
          {
            anchor: "right",
            classes: {
              paper: nt(
                W.drawer,
                W.rightDrawer,
                h == null ? void 0 : h.rightDrawer
              )
            },
            onClose: () => {
              L(!1), en.set(tv, !1);
            },
            open: v ? M : !0,
            variant: v ? "temporary" : "persistent",
            children: r
          }
        ),
        /* @__PURE__ */ y.jsx(
          fr,
          {
            ref: g == null ? void 0 : g.rightButton,
            size: v ? "medium" : "small",
            className: nt(W.drawerButton, W.rightDrawerButton),
            onClick: () => {
              L((z) => (en.set(tv, !z), !z));
            },
            children: M ? /* @__PURE__ */ y.jsx($0, {}) : /* @__PURE__ */ y.jsx(H0, {})
          }
        )
      ] })
    ] });
  }
), HZ = ({ value: e, onChange: t, sx: r }) => {
  const n = [
    {
      label: "Aucune",
      value: "NONE"
      /* NONE */
    },
    {
      label: "Aujourd'hui",
      value: "TODAY"
      /* TODAY */
    },
    {
      label: "Cette semaine",
      value: "THIS_WEEK"
      /* THIS_WEEK */
    },
    {
      label: "Ce mois-ci",
      value: "THIS_MONTH"
      /* THIS_MONTH */
    },
    {
      label: "Personnalisée",
      value: "CUSTOM"
      /* CUSTOM */
    }
  ], i = kt(() => !e.startDate && !e.endDate ? "NONE" : !e.startDate || !e.endDate ? "CUSTOM" : Gw(e.startDate) && Gw(e.endDate) ? "TODAY" : qB(e.startDate) && $w(e.startDate, /* @__PURE__ */ new Date(), { weekStartsOn: 1 }) && wz(e.endDate) && $w(e.endDate, /* @__PURE__ */ new Date(), { weekStartsOn: 1 }) ? "THIS_WEEK" : GB(e.startDate) && Uw(e.startDate, /* @__PURE__ */ new Date()) && _C(e.endDate) && Uw(e.endDate, /* @__PURE__ */ new Date()) ? "THIS_MONTH" : "CUSTOM", [e.endDate, e.startDate]), o = (s) => {
    switch (s) {
      case "TODAY":
        t == null || t({
          startDate: /* @__PURE__ */ new Date(),
          endDate: /* @__PURE__ */ new Date()
        });
        break;
      case "THIS_WEEK":
        t == null || t({
          startDate: qw(/* @__PURE__ */ new Date(), 1, { weekStartsOn: 1 }),
          endDate: qw(/* @__PURE__ */ new Date(), 0, { weekStartsOn: 1 })
        });
        break;
      case "THIS_MONTH":
        t == null || t({
          startDate: XB(/* @__PURE__ */ new Date(), 1),
          endDate: $B(/* @__PURE__ */ new Date())
        });
        break;
      default:
        t == null || t({
          startDate: void 0,
          endDate: void 0
        });
        break;
    }
  };
  return /* @__PURE__ */ y.jsxs(zt, { sx: r, children: [
    /* @__PURE__ */ y.jsx(
      Fy,
      {
        label: "Période",
        value: i,
        onChange: (s, l) => o(l),
        options: n.filter(
          (s) => s.value !== "CUSTOM" || i === "CUSTOM"
          /* CUSTOM */
        ),
        sx: { width: "100%" }
      }
    ),
    /* @__PURE__ */ y.jsx(
      lj,
      {
        value: [e.startDate || null, e.endDate || null],
        onChange: ([s, l]) => {
          t == null || t({
            startDate: s && hv(s) ? s : void 0,
            endDate: l && hv(l) ? l : void 0
          });
        },
        renderInput: (s, l) => {
          var c, f, h, g;
          return /* @__PURE__ */ y.jsx(
            ln,
            {
              ...s,
              sx: { mt: 2 },
              fullWidth: !0,
              label: "Dates",
              inputProps: {
                ...s.inputProps,
                value: (c = s.inputProps) != null && c.value || (f = l.inputProps) != null && f.value ? `${((h = s.inputProps) == null ? void 0 : h.value) || "jj/mm/aaaa"} - ${((g = l.inputProps) == null ? void 0 : g.value) || "jj/mm/aaaa"}` : "",
                placeholder: "jj/mm/aaaa - jj/mm/aaaa"
              }
            }
          );
        },
        calendars: 1
      }
    )
  ] });
}, T9 = Rt((e) => ({
  chipList: {
    width: 325
  },
  chip: {
    margin: e.spacing(0.5)
  }
})), $Z = ({
  closeDialog: e,
  schedule: t,
  presetDates: r
}) => {
  const n = T9(), [i, o] = Xe(!1), [s, l] = Xe(
    KB(Cl(/* @__PURE__ */ new Date(), { days: 1 }), { hours: 8, minutes: 0 })
  ), { pushNotification: c } = Zl(), f = (h, g, S) => /* @__PURE__ */ y.jsx(
    Qa,
    {
      className: n.chip,
      label: g,
      onClick: () => l(S),
      color: VB(S, s) ? "primary" : void 0,
      variant: "outlined"
    },
    `presetDate-${h}`
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      uj,
      {
        disablePast: !0,
        toolbarTitle: null,
        ampm: !1,
        value: s,
        onChange: (h) => {
          h && l(h);
        },
        renderInput: (h) => /* @__PURE__ */ y.jsx(ln, { ...h })
      }
    ),
    r && /* @__PURE__ */ y.jsx(Ao, { className: n.chipList, children: r.map(({ label: h, date: g }, S) => f(S, h, g)) }),
    /* @__PURE__ */ y.jsxs(ep, { children: [
      /* @__PURE__ */ y.jsx(Fr, { onClick: e, color: "primary", children: "Annuler" }),
      /* @__PURE__ */ y.jsx(
        _T,
        {
          loading: i,
          onClick: async () => {
            o(!0);
            try {
              await (t == null ? void 0 : t(s)), e == null || e();
            } catch (h) {
              c({
                message: h.message,
                type: jo.error
              });
            }
            o(!1);
          },
          color: "primary",
          autoFocus: !0,
          variant: "contained",
          children: "Programmer"
        }
      )
    ] })
  ] });
}, UZ = ({
  checked: e,
  label: t,
  className: r,
  onChange: n
}) => /* @__PURE__ */ y.jsx(
  js,
  {
    className: r,
    label: t || "",
    control: /* @__PURE__ */ y.jsx(
      Ba,
      {
        color: "primary",
        checked: e,
        onChange: ({ target: { checked: i } }) => {
          n == null || n(i);
        }
      }
    )
  }
);
var rv = { exports: {} }, $S;
function O9() {
  return $S || ($S = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function i(c, f, h) {
      this.fn = c, this.context = f, this.once = h || !1;
    }
    function o(c, f, h, g, S) {
      if (typeof h != "function")
        throw new TypeError("The listener must be a function");
      var b = new i(h, g || c, S), p = r ? r + f : f;
      return c._events[p] ? c._events[p].fn ? c._events[p] = [c._events[p], b] : c._events[p].push(b) : (c._events[p] = b, c._eventsCount++), c;
    }
    function s(c, f) {
      --c._eventsCount === 0 ? c._events = new n() : delete c._events[f];
    }
    function l() {
      this._events = new n(), this._eventsCount = 0;
    }
    l.prototype.eventNames = function() {
      var f = [], h, g;
      if (this._eventsCount === 0) return f;
      for (g in h = this._events)
        t.call(h, g) && f.push(r ? g.slice(1) : g);
      return Object.getOwnPropertySymbols ? f.concat(Object.getOwnPropertySymbols(h)) : f;
    }, l.prototype.listeners = function(f) {
      var h = r ? r + f : f, g = this._events[h];
      if (!g) return [];
      if (g.fn) return [g.fn];
      for (var S = 0, b = g.length, p = new Array(b); S < b; S++)
        p[S] = g[S].fn;
      return p;
    }, l.prototype.listenerCount = function(f) {
      var h = r ? r + f : f, g = this._events[h];
      return g ? g.fn ? 1 : g.length : 0;
    }, l.prototype.emit = function(f, h, g, S, b, p) {
      var v = r ? r + f : f;
      if (!this._events[v]) return !1;
      var w = this._events[v], C = arguments.length, M, L;
      if (w.fn) {
        switch (w.once && this.removeListener(f, w.fn, void 0, !0), C) {
          case 1:
            return w.fn.call(w.context), !0;
          case 2:
            return w.fn.call(w.context, h), !0;
          case 3:
            return w.fn.call(w.context, h, g), !0;
          case 4:
            return w.fn.call(w.context, h, g, S), !0;
          case 5:
            return w.fn.call(w.context, h, g, S, b), !0;
          case 6:
            return w.fn.call(w.context, h, g, S, b, p), !0;
        }
        for (L = 1, M = new Array(C - 1); L < C; L++)
          M[L - 1] = arguments[L];
        w.fn.apply(w.context, M);
      } else {
        var W = w.length, z;
        for (L = 0; L < W; L++)
          switch (w[L].once && this.removeListener(f, w[L].fn, void 0, !0), C) {
            case 1:
              w[L].fn.call(w[L].context);
              break;
            case 2:
              w[L].fn.call(w[L].context, h);
              break;
            case 3:
              w[L].fn.call(w[L].context, h, g);
              break;
            case 4:
              w[L].fn.call(w[L].context, h, g, S);
              break;
            default:
              if (!M) for (z = 1, M = new Array(C - 1); z < C; z++)
                M[z - 1] = arguments[z];
              w[L].fn.apply(w[L].context, M);
          }
      }
      return !0;
    }, l.prototype.on = function(f, h, g) {
      return o(this, f, h, g, !1);
    }, l.prototype.once = function(f, h, g) {
      return o(this, f, h, g, !0);
    }, l.prototype.removeListener = function(f, h, g, S) {
      var b = r ? r + f : f;
      if (!this._events[b]) return this;
      if (!h)
        return s(this, b), this;
      var p = this._events[b];
      if (p.fn)
        p.fn === h && (!S || p.once) && (!g || p.context === g) && s(this, b);
      else {
        for (var v = 0, w = [], C = p.length; v < C; v++)
          (p[v].fn !== h || S && !p[v].once || g && p[v].context !== g) && w.push(p[v]);
        w.length ? this._events[b] = w.length === 1 ? w[0] : w : s(this, b);
      }
      return this;
    }, l.prototype.removeAllListeners = function(f) {
      var h;
      return f ? (h = r ? r + f : f, this._events[h] && s(this, h)) : (this._events = new n(), this._eventsCount = 0), this;
    }, l.prototype.off = l.prototype.removeListener, l.prototype.addListener = l.prototype.on, l.prefixed = r, l.EventEmitter = l, e.exports = l;
  }(rv)), rv.exports;
}
var R9 = O9();
const rO = /* @__PURE__ */ jr(R9), I9 = {
  multiplier: 2,
  maxBackoff: 6e4,
  maxAttempts: 5,
  minBackoff: 1e3
};
async function D9(e, t, r) {
  const n = {
    ...I9,
    ...t
  };
  if (n.maxBackoff >= 0 && n.minBackoff > n.maxBackoff)
    throw new RangeError("minBackoff is greater than maxBackoff");
  let i = n.minBackoff, o;
  for (let s = 0; s < n.maxAttempts; s++)
    try {
      return r == null || r(s + 1), await e();
    } catch (l) {
      await new Promise((c) => setTimeout(c, i)), i *= n.multiplier, i = Math.max(i, n.minBackoff), n.maxBackoff >= 0 && (i = Math.min(i, n.maxBackoff)), o = l;
    }
  throw o;
}
var wi = /* @__PURE__ */ ((e) => (e.PENDING = "PENDING", e.RUNNING = "RUNNING", e.FINISED = "FINISHED", e.FAILED = "FAILED", e.STOPED = "STOPED", e))(wi || {}), qf = /* @__PURE__ */ ((e) => (e.Progress = "progress", e.Retry = "retry", e.StatusChange = "status-change", e.ALL = "all", e))(qf || {});
class GZ extends rO {
  constructor(r, n) {
    super();
    cr(this, "title", "");
    cr(this, "options");
    cr(this, "status", "PENDING");
    cr(this, "throttleTimer");
    cr(this, "progress", 0);
    cr(this, "duration", 0);
    // ms
    cr(this, "durationTimer");
    // set any to type conflict between setInterval and clearInterval
    cr(this, "attemptCount", 0);
    cr(this, "progressMessage", nv(this));
    cr(this, "err");
    this.title = r, this.options = {
      ...n
    }, this.innerEmit(
      "status-change",
      "PENDING"
      /* PENDING */
    );
  }
  async start() {
    if (this.status !== "RUNNING") {
      this.startDurationTimer();
      try {
        this.setProgress(0), this.setStatus(
          "RUNNING"
          /* RUNNING */
        ), this.options.retryOptions ? await D9(
          () => this.options.run(this.setProgress.bind(this)),
          this.options.retryOptions,
          (r) => {
            this.attemptCount = r, this.innerEmit("retry", r);
          }
        ) : (this.attemptCount = 1, await this.options.run(this.setProgress.bind(this))), this.setProgress(100), this.setStatus(
          "FINISHED"
          /* FINISED */
        );
      } catch (r) {
        this.err = r, this.status !== "STOPED" && this.setStatus(
          "FAILED"
          /* FAILED */
        );
      }
      this.stopDurationTimer();
    }
  }
  async stop() {
    this.isInTerminalState || (this.options.stop && await this.options.stop(), this.stopDurationTimer(), this.setStatus(
      "STOPED"
      /* STOPED */
    ));
  }
  get Error() {
    return this.err;
  }
  get Status() {
    return this.status;
  }
  get Progress() {
    return this.progress;
  }
  get ProgressForDispaly() {
    return `${Math.round(this.Progress)}%`;
  }
  get ProgressMessage() {
    return this.progressMessage;
  }
  get isStoppable() {
    return this.options.stop;
  }
  get isInTerminalState() {
    return [
      "FAILED",
      "FINISHED",
      "STOPED"
      /* STOPED */
    ].includes(
      this.Status
    );
  }
  get Duration() {
    return this.duration;
  }
  get DurationForDisplay() {
    return P9(this.duration);
  }
  get AttemptCount() {
    return this.attemptCount;
  }
  get RetryCountForDispaly() {
    var r;
    return this.AttemptCount > 1 ? `${this.AttemptCount}/${(r = this.options.retryOptions) == null ? void 0 : r.maxAttempts}` : "";
  }
  startDurationTimer() {
    const r = Date.now();
    this.durationTimer = setInterval(() => {
      this.duration = Date.now() - r;
    }, 1e3);
  }
  stopDurationTimer() {
    this.durationTimer && clearInterval(this.durationTimer);
  }
  setStatus(r) {
    this.status = r, this.progressMessage = nv(this), this.innerEmit("status-change", r);
  }
  setProgress(r, n) {
    this.isInTerminalState || (this.throttleTimer && clearTimeout(this.throttleTimer), setTimeout(() => {
      this.progress = r, this.progressMessage = nv(this, n), this.innerEmit("progress", r);
    }, 100));
  }
  innerEmit(r, ...n) {
    this.emit(r, ...n), r !== "all" && this.emit("all", this, r, ...n);
  }
}
const nv = (e, t) => {
  if (t)
    return t;
  switch (e.Status) {
    case "PENDING":
      return "en attente de traitement...";
    case "RUNNING":
      return "encours de traitement...";
    case "STOPED":
      return "tâche arrêtée";
    case "FINISHED":
      return "tâche terminée";
    case "FAILED":
      return `tâche échoué: ${e.Error}`;
    default:
      throw Error(`missing ${e.Status} case`);
  }
}, P9 = (e) => {
  let t = e / 1e3;
  const r = Math.floor(t / 31536e3), n = Math.floor((t %= 31536e3) / 86400), i = Math.floor((t %= 86400) / 3600), o = Math.floor((t %= 3600) / 60), s = t % 60;
  if (n || i || s || o) {
    let l = "";
    return l += r ? `${r}y` : "", l += n ? `${n}d` : "", l += i ? `${i}h` : "", l += o ? `${o}m` : "", l += `${Number.parseFloat(s.toString()).toFixed(0)}s`, l;
  }
  return "< 1s";
};
var nO = /* @__PURE__ */ ((e) => (e[e.IDLE = 0] = "IDLE", e[e.RUNNING = 1] = "RUNNING", e[e.PAUSED = 2] = "PAUSED", e))(nO || {}), iO = /* @__PURE__ */ ((e) => (e.Progress = "progress", e.StatusChange = "status-change", e.RegisterTask = "register-task", e.UnregisterTask = "unregister-task", e.TaskStatusChange = "task-status-change", e.TaskProgress = "task-progress", e))(iO || {});
const M9 = {
  delay: 100,
  // 0.1s
  maxConcurency: 3
}, A9 = {
  [wi.PENDING]: 0,
  [wi.FAILED]: 0,
  [wi.FINISED]: 0,
  [wi.RUNNING]: 0,
  [wi.STOPED]: 0,
  PROCESSED: 0,
  TOTAL: 0
};
class qZ extends rO {
  constructor(r, n) {
    super();
    cr(this, "title", "");
    cr(this, "options");
    cr(this, "status", 0);
    cr(this, "progress", 0);
    cr(this, "stats", A9);
    // FIFO stack
    cr(this, "queue", /* @__PURE__ */ new Set());
    cr(this, "handleTaskEvent", (r, n, ...i) => {
      const o = `task-${n}`;
      switch (o) {
        case "task-progress":
          this.emit(
            o,
            r,
            ...i
          );
          break;
        case "task-status-change":
          this.emit(
            o,
            r,
            ...i
          );
          break;
      }
    });
    this.title = r, this.options = {
      ...M9,
      ...n
    }, this.setStatus(
      0
      /* IDLE */
    ), this.on("task-status-change", this.updateMetrics), this.on("register-task", this.updateMetrics), this.on("unregister-task", this.updateMetrics), this.loop();
  }
  register(...r) {
    r.forEach((n) => {
      this.queue.has(n) || (this.queue.add(n), n.on(qf.ALL, this.handleTaskEvent), this.emit("register-task", n));
    });
  }
  async unregister(r) {
    return new Promise((n, i) => {
      this.queue.has(r) ? r.stop().catch(i).then(() => this.queue.delete(r)).then(() => r.off(qf.ALL, this.handleTaskEvent)).then(() => this.emit("unregister-task", r)).then(() => n()) : i(new Error(`task (${r.title}) is not found`));
    });
  }
  async pause() {
    this.setStatus(
      2
      /* PAUSED */
    );
  }
  async resume() {
    this.setStatus(
      0
      /* IDLE */
    );
  }
  loop() {
    if (this.Status === 2) {
      setTimeout(this.loop.bind(this), this.options.delay);
      return;
    }
    const r = this.nextTasks();
    if (!r.length) {
      setTimeout(this.loop.bind(this), this.options.delay);
      return;
    }
    r.map((n) => n.start()), setTimeout(this.loop.bind(this), this.options.delay);
  }
  nextTasks() {
    const r = this.Tasks, n = r.filter(
      (s) => s.Status === wi.RUNNING
    ).length;
    if (n >= this.options.maxConcurency)
      return [];
    const i = this.options.maxConcurency - n, o = [];
    for (const s of r)
      if (s.Status === wi.PENDING && o.push(s), o.length >= i)
        break;
    return o;
  }
  setStatus(r) {
    this.status = r, this.emit("status-change", r);
  }
  updateMetrics(r) {
    const n = this.Tasks;
    if (this.Status !== 2) {
      const o = n.some((s) => !s.isInTerminalState) ? 1 : 0;
      this.setStatus(o);
    }
    const i = {
      // terminal states
      FAILED: this.Stats.FAILED,
      FINISHED: this.Stats.FINISHED,
      STOPED: this.Stats.STOPED,
      // non terminal states
      RUNNING: 0,
      PENDING: 0,
      TOTAL: 0,
      PROCESSED: 0
    };
    r.isInTerminalState && (i[r.Status] += 1), n.filter((o) => !o.isInTerminalState).forEach((o) => {
      i[o.Status] += 1;
    }), i.PROCESSED = i.FAILED + i.FINISHED + i.STOPED, i.TOTAL = i.PROCESSED + i.RUNNING + i.PENDING, this.stats = i, this.progress = i.PROCESSED * 100 / i.TOTAL, this.emit("progress", this.progress);
  }
  get Status() {
    return this.status;
  }
  get Tasks() {
    return Array.from(this.queue.keys());
  }
  get Stats() {
    return this.stats;
  }
  get Progress() {
    return this.progress;
  }
  get ProgressForDispaly() {
    return `${Math.round(this.Progress)}%`;
  }
  // setMaxConcurency update max concurency tasks
  // this will be applied next loop iteration
  setMaxConcurency(r) {
    this.options.maxConcurency = r;
  }
}
const qa = /* @__PURE__ */ Be.createContext({});
process.env.NODE_ENV !== "production" && (qa.displayName = "ListContext");
function N9(e) {
  return Mn("MuiList", e);
}
An("MuiList", ["root", "padding", "dense", "subheader"]);
const j9 = ["children", "className", "component", "dense", "disablePadding", "subheader"], k9 = (e) => {
  const {
    classes: t,
    disablePadding: r,
    dense: n,
    subheader: i
  } = e;
  return Kn({
    root: ["root", !r && "padding", n && "dense", i && "subheader"]
  }, N9, t);
}, L9 = Xr("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disablePadding && t.padding, r.dense && t.dense, r.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => it({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), oO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: o,
    component: s = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: f
  } = n, h = Hr(n, j9), g = Be.useMemo(() => ({
    dense: l
  }), [l]), S = it({}, n, {
    component: s,
    dense: l,
    disablePadding: c
  }), b = k9(S);
  return /* @__PURE__ */ y.jsx(qa.Provider, {
    value: g,
    children: /* @__PURE__ */ y.jsxs(L9, it({
      as: s,
      className: nt(b.root, o),
      ref: r,
      ownerState: S
    }, h, {
      children: [f, i]
    }))
  });
});
process.env.NODE_ENV !== "production" && (oO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: D.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: D.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: D.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
const US = {
  disabled: !1
};
var z9 = process.env.NODE_ENV !== "production" ? D.oneOfType([D.number, D.shape({
  enter: D.number,
  exit: D.number,
  appear: D.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && D.oneOfType([D.string, D.shape({
  enter: D.string,
  exit: D.string,
  active: D.string
}), D.shape({
  enter: D.string,
  enterDone: D.string,
  enterActive: D.string,
  exit: D.string,
  exitDone: D.string,
  exitActive: D.string
})]);
const Vf = dt.createContext(null);
var ic = "unmounted", Rs = "exited", Is = "entering", Ol = "entered", om = "exiting", Fo = /* @__PURE__ */ function(e) {
  Ql(t, e);
  function t(n, i) {
    var o;
    o = e.call(this, n, i) || this;
    var s = i, l = s && !s.isMounting ? n.enter : n.appear, c;
    return o.appearStatus = null, n.in ? l ? (c = Rs, o.appearStatus = Is) : c = Ol : n.unmountOnExit || n.mountOnEnter ? c = ic : c = Rs, o.state = {
      status: c
    }, o.nextCallback = null, o;
  }
  t.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === ic ? {
      status: Rs
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== Is && s !== Ol && (o = Is) : (s === Is || s === Ol) && (o = om);
    }
    this.updateStatus(!1, o);
  }, r.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, r.getTimeouts = function() {
    var i = this.props.timeout, o, s, l;
    return o = s = l = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, l = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: l
    };
  }, r.updateStatus = function(i, o) {
    i === void 0 && (i = !1), o !== null ? (this.cancelNextCallback(), o === Is ? this.performEnter(i) : this.performExit()) : this.props.unmountOnExit && this.state.status === Rs && this.setState({
      status: ic
    });
  }, r.performEnter = function(i) {
    var o = this, s = this.props.enter, l = this.context ? this.context.isMounting : i, c = this.props.nodeRef ? [l] : [ac.findDOMNode(this), l], f = c[0], h = c[1], g = this.getTimeouts(), S = l ? g.appear : g.enter;
    if (!i && !s || US.disabled) {
      this.safeSetState({
        status: Ol
      }, function() {
        o.props.onEntered(f);
      });
      return;
    }
    this.props.onEnter(f, h), this.safeSetState({
      status: Is
    }, function() {
      o.props.onEntering(f, h), o.onTransitionEnd(S, function() {
        o.safeSetState({
          status: Ol
        }, function() {
          o.props.onEntered(f, h);
        });
      });
    });
  }, r.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), l = this.props.nodeRef ? void 0 : ac.findDOMNode(this);
    if (!o || US.disabled) {
      this.safeSetState({
        status: Rs
      }, function() {
        i.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: om
    }, function() {
      i.props.onExiting(l), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: Rs
        }, function() {
          i.props.onExited(l);
        });
      });
    });
  }, r.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, r.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(l) {
      s && (s = !1, o.nextCallback = null, i(l));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : ac.findDOMNode(this), l = i == null && !this.props.addEndListener;
    if (!s || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], f = c[0], h = c[1];
      this.props.addEndListener(f, h);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, r.render = function() {
    var i = this.state.status;
    if (i === ic)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var l = zs(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ dt.createElement(Vf.Provider, {
        value: null
      }, typeof s == "function" ? s(i, l) : dt.cloneElement(dt.Children.only(s), l))
    );
  }, t;
}(dt.Component);
Fo.contextType = Vf;
Fo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: D.shape({
    current: typeof Element > "u" ? D.any : function(e, t, r, n, i, o) {
      var s = e[t];
      return D.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, r, n, i, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: D.oneOfType([D.func.isRequired, D.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: D.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: D.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: D.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: D.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: D.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: D.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var r = z9;
    t.addEndListener || (r = r.isRequired);
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      i[o - 1] = arguments[o];
    return r.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: D.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: D.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: D.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: D.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: D.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: D.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: D.func
} : {};
function Sl() {
}
Fo.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Sl,
  onEntering: Sl,
  onEntered: Sl,
  onExit: Sl,
  onExiting: Sl,
  onExited: Sl
};
Fo.UNMOUNTED = ic;
Fo.EXITED = Rs;
Fo.ENTERING = Is;
Fo.ENTERED = Ol;
Fo.EXITING = om;
function Hy(e, t) {
  var r = function(o) {
    return t && oc(o) ? t(o) : o;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && jA.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    n[i.key] = r(i);
  }), n;
}
function B9(e, t) {
  e = e || {}, t = t || {};
  function r(h) {
    return h in t ? t[h] : e[h];
  }
  var n = /* @__PURE__ */ Object.create(null), i = [];
  for (var o in e)
    o in t ? i.length && (n[o] = i, i = []) : i.push(o);
  var s, l = {};
  for (var c in t) {
    if (n[c])
      for (s = 0; s < n[c].length; s++) {
        var f = n[c][s];
        l[n[c][s]] = r(f);
      }
    l[c] = r(c);
  }
  for (s = 0; s < i.length; s++)
    l[i[s]] = r(i[s]);
  return l;
}
function Ms(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function F9(e, t) {
  return Hy(e.children, function(r) {
    return Ns(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: Ms(r, "appear", e),
      enter: Ms(r, "enter", e),
      exit: Ms(r, "exit", e)
    });
  });
}
function W9(e, t, r) {
  var n = Hy(e.children), i = B9(t, n);
  return Object.keys(i).forEach(function(o) {
    var s = i[o];
    if (oc(s)) {
      var l = o in t, c = o in n, f = t[o], h = oc(f) && !f.props.in;
      c && (!l || h) ? i[o] = Ns(s, {
        onExited: r.bind(null, s),
        in: !0,
        exit: Ms(s, "exit", e),
        enter: Ms(s, "enter", e)
      }) : !c && l && !h ? i[o] = Ns(s, {
        in: !1
      }) : c && l && oc(f) && (i[o] = Ns(s, {
        onExited: r.bind(null, s),
        in: f.props.in,
        exit: Ms(s, "exit", e),
        enter: Ms(s, "enter", e)
      }));
    }
  }), i;
}
var H9 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, $9 = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, $y = /* @__PURE__ */ function(e) {
  Ql(t, e);
  function t(n, i) {
    var o;
    o = e.call(this, n, i) || this;
    var s = o.handleExited.bind(yv(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, o) {
    var s = o.children, l = o.handleExited, c = o.firstRender;
    return {
      children: c ? F9(i, l) : W9(i, s, l),
      firstRender: !1
    };
  }, r.handleExited = function(i, o) {
    var s = Hy(this.props.children);
    i.key in s || (i.props.onExited && i.props.onExited(o), this.mounted && this.setState(function(l) {
      var c = ct({}, l.children);
      return delete c[i.key], {
        children: c
      };
    }));
  }, r.render = function() {
    var i = this.props, o = i.component, s = i.childFactory, l = zs(i, ["component", "childFactory"]), c = this.state.contextValue, f = H9(this.state.children).map(s);
    return delete l.appear, delete l.enter, delete l.exit, o === null ? /* @__PURE__ */ dt.createElement(Vf.Provider, {
      value: c
    }, f) : /* @__PURE__ */ dt.createElement(Vf.Provider, {
      value: c
    }, /* @__PURE__ */ dt.createElement(o, l, f));
  }, t;
}(dt.Component);
$y.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: D.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: D.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: D.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: D.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: D.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: D.func
} : {};
$y.defaultProps = $9;
function aO(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: i,
    rippleY: o,
    rippleSize: s,
    in: l,
    onExited: c,
    timeout: f
  } = e, [h, g] = Be.useState(!1), S = nt(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), b = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + i
  }, p = nt(r.child, h && r.childLeaving, n && r.childPulsate);
  return !l && !h && g(!0), Be.useEffect(() => {
    if (!l && c != null) {
      const v = setTimeout(c, f);
      return () => {
        clearTimeout(v);
      };
    }
  }, [c, l, f]), /* @__PURE__ */ y.jsx("span", {
    className: S,
    style: b,
    children: /* @__PURE__ */ y.jsx("span", {
      className: p
    })
  });
}
process.env.NODE_ENV !== "production" && (aO.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: D.object.isRequired,
  className: D.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: D.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: D.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: D.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: D.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: D.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: D.number,
  /**
   * exit delay
   */
  timeout: D.number.isRequired
});
const Hi = An("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), U9 = ["center", "classes", "className"];
let Sp = (e) => e, GS, qS, VS, YS;
const am = 550, G9 = 80, q9 = Bc(GS || (GS = Sp`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), V9 = Bc(qS || (qS = Sp`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Y9 = Bc(VS || (VS = Sp`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), K9 = Xr("span", {
  name: "MuiTouchRipple",
  slot: "Root",
  skipSx: !0
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), X9 = Xr(aO, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(YS || (YS = Sp`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Hi.rippleVisible, q9, am, ({
  theme: e
}) => e.transitions.easing.easeInOut, Hi.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Hi.child, Hi.childLeaving, V9, am, ({
  theme: e
}) => e.transitions.easing.easeInOut, Hi.childPulsate, Y9, ({
  theme: e
}) => e.transitions.easing.easeInOut), sO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: o = {},
    className: s
  } = n, l = Hr(n, U9), [c, f] = Be.useState([]), h = Be.useRef(0), g = Be.useRef(null);
  Be.useEffect(() => {
    g.current && (g.current(), g.current = null);
  }, [c]);
  const S = Be.useRef(!1), b = Be.useRef(null), p = Be.useRef(null), v = Be.useRef(null);
  Be.useEffect(() => () => {
    clearTimeout(b.current);
  }, []);
  const w = Be.useCallback((W) => {
    const {
      pulsate: z,
      rippleX: B,
      rippleY: K,
      rippleSize: Z,
      cb: ee
    } = W;
    f((he) => [...he, /* @__PURE__ */ y.jsx(X9, {
      classes: {
        ripple: nt(o.ripple, Hi.ripple),
        rippleVisible: nt(o.rippleVisible, Hi.rippleVisible),
        ripplePulsate: nt(o.ripplePulsate, Hi.ripplePulsate),
        child: nt(o.child, Hi.child),
        childLeaving: nt(o.childLeaving, Hi.childLeaving),
        childPulsate: nt(o.childPulsate, Hi.childPulsate)
      },
      timeout: am,
      pulsate: z,
      rippleX: B,
      rippleY: K,
      rippleSize: Z
    }, h.current)]), h.current += 1, g.current = ee;
  }, [o]), C = Be.useCallback((W = {}, z = {}, B) => {
    const {
      pulsate: K = !1,
      center: Z = i || z.pulsate,
      fakeElement: ee = !1
      // For test purposes
    } = z;
    if (W.type === "mousedown" && S.current) {
      S.current = !1;
      return;
    }
    W.type === "touchstart" && (S.current = !0);
    const he = ee ? null : v.current, _e = he ? he.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Te, fe, Oe;
    if (Z || W.clientX === 0 && W.clientY === 0 || !W.clientX && !W.touches)
      Te = Math.round(_e.width / 2), fe = Math.round(_e.height / 2);
    else {
      const {
        clientX: ye,
        clientY: de
      } = W.touches ? W.touches[0] : W;
      Te = Math.round(ye - _e.left), fe = Math.round(de - _e.top);
    }
    if (Z)
      Oe = Math.sqrt((2 * _e.width ** 2 + _e.height ** 2) / 3), Oe % 2 === 0 && (Oe += 1);
    else {
      const ye = Math.max(Math.abs((he ? he.clientWidth : 0) - Te), Te) * 2 + 2, de = Math.max(Math.abs((he ? he.clientHeight : 0) - fe), fe) * 2 + 2;
      Oe = Math.sqrt(ye ** 2 + de ** 2);
    }
    W.touches ? p.current === null && (p.current = () => {
      w({
        pulsate: K,
        rippleX: Te,
        rippleY: fe,
        rippleSize: Oe,
        cb: B
      });
    }, b.current = setTimeout(() => {
      p.current && (p.current(), p.current = null);
    }, G9)) : w({
      pulsate: K,
      rippleX: Te,
      rippleY: fe,
      rippleSize: Oe,
      cb: B
    });
  }, [i, w]), M = Be.useCallback(() => {
    C({}, {
      pulsate: !0
    });
  }, [C]), L = Be.useCallback((W, z) => {
    if (clearTimeout(b.current), W.type === "touchend" && p.current) {
      p.current(), p.current = null, b.current = setTimeout(() => {
        L(W, z);
      });
      return;
    }
    p.current = null, f((B) => B.length > 0 ? B.slice(1) : B), g.current = z;
  }, []);
  return Be.useImperativeHandle(r, () => ({
    pulsate: M,
    start: C,
    stop: L
  }), [M, C, L]), /* @__PURE__ */ y.jsx(K9, it({
    className: nt(o.root, Hi.root, s),
    ref: v
  }, l, {
    children: /* @__PURE__ */ y.jsx($y, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
process.env.NODE_ENV !== "production" && (sO.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: D.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string
});
function J9(e) {
  return Mn("MuiButtonBase", e);
}
const Z9 = An("MuiButtonBase", ["root", "disabled", "focusVisible"]), Q9 = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"], eK = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: i
  } = e, s = Kn({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, J9, i);
  return r && n && (s.root += ` ${n}`), s;
}, tK = Xr("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Z9.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Uy = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: o = !1,
    children: s,
    className: l,
    component: c = "button",
    disabled: f = !1,
    disableRipple: h = !1,
    disableTouchRipple: g = !1,
    focusRipple: S = !1,
    LinkComponent: b = "a",
    onBlur: p,
    onClick: v,
    onContextMenu: w,
    onDragLeave: C,
    onFocus: M,
    onFocusVisible: L,
    onKeyDown: W,
    onKeyUp: z,
    onMouseDown: B,
    onMouseLeave: K,
    onMouseUp: Z,
    onTouchEnd: ee,
    onTouchMove: he,
    onTouchStart: _e,
    tabIndex: Te = 0,
    TouchRippleProps: fe,
    type: Oe
  } = n, ye = Hr(n, Q9), de = Be.useRef(null), ce = Be.useRef(null), {
    isFocusVisibleRef: Fe,
    onFocus: le,
    onBlur: J,
    ref: re
  } = qE(), [be, Me] = Be.useState(!1);
  f && be && Me(!1), Be.useImperativeHandle(i, () => ({
    focusVisible: () => {
      Me(!0), de.current.focus();
    }
  }), []), Be.useEffect(() => {
    be && S && !h && ce.current.pulsate();
  }, [h, S, be]);
  function Ae(gt, hr, Nn = g) {
    return Ps((hn) => (hr && hr(hn), !Nn && ce.current && ce.current[gt](hn), !0));
  }
  const Re = Ae("start", B), Ee = Ae("stop", w), Ce = Ae("stop", C), X = Ae("stop", Z), ie = Ae("stop", (gt) => {
    be && gt.preventDefault(), K && K(gt);
  }), Ie = Ae("start", _e), xe = Ae("stop", ee), Pe = Ae("stop", he), ae = Ae("stop", (gt) => {
    J(gt), Fe.current === !1 && Me(!1), p && p(gt);
  }, !1), rt = Ps((gt) => {
    de.current || (de.current = gt.currentTarget), le(gt), Fe.current === !0 && (Me(!0), L && L(gt)), M && M(gt);
  }), Ze = () => {
    const gt = de.current;
    return c && c !== "button" && !(gt.tagName === "A" && gt.href);
  }, ht = Be.useRef(!1), mt = Ps((gt) => {
    S && !ht.current && be && ce.current && gt.key === " " && (ht.current = !0, ce.current.stop(gt, () => {
      ce.current.start(gt);
    })), gt.target === gt.currentTarget && Ze() && gt.key === " " && gt.preventDefault(), W && W(gt), gt.target === gt.currentTarget && Ze() && gt.key === "Enter" && !f && (gt.preventDefault(), v && v(gt));
  }), At = Ps((gt) => {
    S && gt.key === " " && ce.current && be && !gt.defaultPrevented && (ht.current = !1, ce.current.stop(gt, () => {
      ce.current.pulsate(gt);
    })), z && z(gt), v && gt.target === gt.currentTarget && Ze() && gt.key === " " && !gt.defaultPrevented && v(gt);
  });
  let Bt = c;
  Bt === "button" && (ye.href || ye.to) && (Bt = b);
  const Gt = {};
  Bt === "button" ? (Gt.type = Oe === void 0 ? "button" : Oe, Gt.disabled = f) : (!ye.href && !ye.to && (Gt.role = "button"), f && (Gt["aria-disabled"] = f));
  const It = Gi(re, de), sr = Gi(r, It), [et, at] = Be.useState(!1);
  Be.useEffect(() => {
    at(!0);
  }, []);
  const Qt = et && !h && !f;
  process.env.NODE_ENV !== "production" && Be.useEffect(() => {
    Qt && !ce.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Qt]);
  const pr = it({}, n, {
    centerRipple: o,
    component: c,
    disabled: f,
    disableRipple: h,
    disableTouchRipple: g,
    focusRipple: S,
    tabIndex: Te,
    focusVisible: be
  }), wr = eK(pr);
  return /* @__PURE__ */ y.jsxs(tK, it({
    as: Bt,
    className: nt(wr.root, l),
    ownerState: pr,
    onBlur: ae,
    onClick: v,
    onContextMenu: Ee,
    onFocus: rt,
    onKeyDown: mt,
    onKeyUp: At,
    onMouseDown: Re,
    onMouseLeave: ie,
    onMouseUp: X,
    onDragLeave: Ce,
    onTouchEnd: xe,
    onTouchMove: Pe,
    onTouchStart: Ie,
    ref: sr,
    tabIndex: f ? -1 : Te,
    type: Oe
  }, Gt, ye, {
    children: [s, Qt ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ y.jsx(sO, it({
        ref: ce,
        center: o
      }, fe))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Uy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: UE,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: D.bool,
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Cm,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: D.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: D.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: D.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: D.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: D.string,
  /**
   * @ignore
   */
  href: D.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: D.elementType,
  /**
   * @ignore
   */
  onBlur: D.func,
  /**
   * @ignore
   */
  onClick: D.func,
  /**
   * @ignore
   */
  onContextMenu: D.func,
  /**
   * @ignore
   */
  onDragLeave: D.func,
  /**
   * @ignore
   */
  onFocus: D.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: D.func,
  /**
   * @ignore
   */
  onKeyDown: D.func,
  /**
   * @ignore
   */
  onKeyUp: D.func,
  /**
   * @ignore
   */
  onMouseDown: D.func,
  /**
   * @ignore
   */
  onMouseLeave: D.func,
  /**
   * @ignore
   */
  onMouseUp: D.func,
  /**
   * @ignore
   */
  onTouchEnd: D.func,
  /**
   * @ignore
   */
  onTouchMove: D.func,
  /**
   * @ignore
   */
  onTouchStart: D.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * @default 0
   */
  tabIndex: D.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: D.object,
  /**
   * @ignore
   */
  type: D.oneOfType([D.oneOf(["button", "reset", "submit"]), D.string])
});
function rK(e) {
  return Mn("MuiIconButton", e);
}
const nK = An("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), iK = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], oK = (e) => {
  const {
    classes: t,
    disabled: r,
    color: n,
    edge: i,
    size: o
  } = e, s = {
    root: ["root", r && "disabled", n !== "default" && `color${Wr(n)}`, i && `edge${Wr(i)}`, `size${Wr(o)}`]
  };
  return Kn(s, rK, t);
}, aK = Xr(Uy, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "default" && t[`color${Wr(r.color)}`], r.edge && t[`edge${Wr(r.edge)}`], t[`size${Wr(r.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: e.palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: Na(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => it({}, t.color === "inherit" && {
  color: "inherit"
}, t.color !== "inherit" && t.color !== "default" && it({
  color: e.palette[t.color].main
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: Na(e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}), t.size === "small" && {
  padding: 5,
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  padding: 12,
  fontSize: e.typography.pxToRem(28)
}, {
  [`&.${nK.disabled}`]: {
    backgroundColor: "transparent",
    color: e.palette.action.disabled
  }
})), Ep = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: o,
    className: s,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: f = !1,
    size: h = "medium"
  } = n, g = Hr(n, iK), S = it({}, n, {
    edge: i,
    color: l,
    disabled: c,
    disableFocusRipple: f,
    size: h
  }), b = oK(S);
  return /* @__PURE__ */ y.jsx(aK, it({
    className: nt(b.root, s),
    centerRipple: !0,
    focusRipple: !f,
    disabled: c,
    ref: r,
    ownerState: S
  }, g, {
    children: o
  }));
});
process.env.NODE_ENV !== "production" && (Ep.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The icon to display.
   */
  children: es(D.node, (e) => Be.Children.toArray(e.children).some((r) => /* @__PURE__ */ Be.isValidElement(r) && r.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: D.oneOfType([D.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), D.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: D.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: D.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: D.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: D.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: D.oneOfType([D.oneOf(["small", "medium", "large"]), D.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
function sK(e) {
  return Mn("MuiToolbar", e);
}
An("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const lK = ["className", "component", "disableGutters", "variant"], uK = (e) => {
  const {
    classes: t,
    disableGutters: r,
    variant: n
  } = e;
  return Kn({
    root: ["root", !r && "gutters", n]
  }, sK, t);
}, cK = Xr("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.disableGutters && t.gutters, t[r.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), lO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiToolbar"
  }), {
    className: i,
    component: o = "div",
    disableGutters: s = !1,
    variant: l = "regular"
  } = n, c = Hr(n, lK), f = it({}, n, {
    component: o,
    disableGutters: s,
    variant: l
  }), h = uK(f);
  return /* @__PURE__ */ y.jsx(cK, it({
    as: o,
    className: nt(h.root, i),
    ref: r,
    ownerState: f
  }, c));
});
process.env.NODE_ENV !== "production" && (lO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properites to be used to lay out the children.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: D.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: D.oneOfType([D.oneOf(["dense", "regular"]), D.string])
});
function Gy() {
  const e = zm(Fm);
  return process.env.NODE_ENV !== "production" && Be.useDebugValue(e), e;
}
const dK = yC(), ia = h2({
  defaultTheme: dK,
  defaultClassName: "MuiBox-root",
  generateClassName: Rm.generate
});
function fK(e) {
  return Mn("MuiTypography", e);
}
An("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const pK = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], hK = (e) => {
  const {
    align: t,
    gutterBottom: r,
    noWrap: n,
    paragraph: i,
    variant: o,
    classes: s
  } = e, l = {
    root: ["root", o, e.align !== "inherit" && `align${Wr(t)}`, r && "gutterBottom", n && "noWrap", i && "paragraph"]
  };
  return Kn(l, fK, s);
}, gK = Xr("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.variant && t[r.variant], r.align !== "inherit" && t[`align${Wr(r.align)}`], r.noWrap && t.noWrap, r.gutterBottom && t.gutterBottom, r.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  margin: 0
}, t.variant && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), KS = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, vK = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, mK = (e) => vK[e] || e, As = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiTypography"
  }), i = mK(n.color), o = pC(it({}, n, {
    color: i
  })), {
    align: s = "inherit",
    className: l,
    component: c,
    gutterBottom: f = !1,
    noWrap: h = !1,
    paragraph: g = !1,
    variant: S = "body1",
    variantMapping: b = KS
  } = o, p = Hr(o, pK), v = it({}, o, {
    align: s,
    color: i,
    className: l,
    component: c,
    gutterBottom: f,
    noWrap: h,
    paragraph: g,
    variant: S,
    variantMapping: b
  }), w = c || (g ? "p" : b[S] || KS[S]) || "span", C = hK(v);
  return /* @__PURE__ */ y.jsx(gK, it({
    as: w,
    ref: r,
    ownerState: v,
    className: nt(C.root, l)
  }, p));
});
process.env.NODE_ENV !== "production" && (As.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: D.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: D.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: D.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: D.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: D.oneOfType([D.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), D.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: D.object
});
var Gu = {}, XS;
function yK() {
  if (XS) return Gu;
  XS = 1;
  var e = Vi();
  Object.defineProperty(Gu, "__esModule", {
    value: !0
  }), Gu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
  }), "Pause");
  return Gu.default = n, Gu;
}
var bK = /* @__PURE__ */ yK();
const wK = /* @__PURE__ */ jr(bK);
var qu = {}, JS;
function xK() {
  if (JS) return qu;
  JS = 1;
  var e = Vi();
  Object.defineProperty(qu, "__esModule", {
    value: !0
  }), qu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M8 5v14l11-7z"
  }), "PlayArrow");
  return qu.default = n, qu;
}
var _K = /* @__PURE__ */ xK();
const SK = /* @__PURE__ */ jr(_K);
function EK(e) {
  return Mn("MuiListItem", e);
}
const Rl = An("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), CK = An("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function TK(e) {
  return Mn("MuiListItemSecondaryAction", e);
}
An("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const OK = ["className"], RK = (e) => {
  const {
    disableGutters: t,
    classes: r
  } = e;
  return Kn({
    root: ["root", t && "disableGutters"]
  }, TK, r);
}, IK = Xr("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => it({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), qy = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: i
  } = n, o = Hr(n, OK), s = Be.useContext(qa), l = it({}, n, {
    disableGutters: s.disableGutters
  }), c = RK(l);
  return /* @__PURE__ */ y.jsx(IK, it({
    className: nt(c.root, i),
    ownerState: l,
    ref: r
  }, o));
});
process.env.NODE_ENV !== "production" && (qy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
qy.muiName = "ListItemSecondaryAction";
const DK = ["className"], PK = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected"], MK = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.alignItems === "flex-start" && t.alignItemsFlexStart, r.divider && t.divider, !r.disableGutters && t.gutters, !r.disablePadding && t.padding, r.button && t.button, r.hasSecondaryAction && t.secondaryAction];
}, AK = (e) => {
  const {
    alignItems: t,
    button: r,
    classes: n,
    dense: i,
    disabled: o,
    disableGutters: s,
    disablePadding: l,
    divider: c,
    hasSecondaryAction: f,
    selected: h
  } = e;
  return Kn({
    root: ["root", i && "dense", !s && "gutters", !l && "padding", c && "divider", o && "disabled", r && "button", t === "flex-start" && "alignItemsFlexStart", f && "secondaryAction", h && "selected"],
    container: ["container"]
  }, EK, n);
}, NK = Xr("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: MK
})(({
  theme: e,
  ownerState: t
}) => it({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && it({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${CK.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${Rl.focusVisible}`]: {
    backgroundColor: e.palette.action.focus
  },
  [`&.${Rl.selected}`]: {
    backgroundColor: Na(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Rl.focusVisible}`]: {
      backgroundColor: Na(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Rl.disabled}`]: {
    opacity: e.palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${e.palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: e.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Rl.selected}:hover`]: {
    backgroundColor: Na(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: Na(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), jK = Xr("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Vy = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: i = "center",
    autoFocus: o = !1,
    button: s = !1,
    children: l,
    className: c,
    component: f,
    components: h = {},
    componentsProps: g = {},
    ContainerComponent: S = "li",
    ContainerProps: {
      className: b
    } = {},
    dense: p = !1,
    disabled: v = !1,
    disableGutters: w = !1,
    disablePadding: C = !1,
    divider: M = !1,
    focusVisibleClassName: L,
    secondaryAction: W,
    selected: z = !1
  } = n, B = Hr(n.ContainerProps, DK), K = Hr(n, PK), Z = Be.useContext(qa), ee = {
    dense: p || Z.dense || !1,
    alignItems: i,
    disableGutters: w
  }, he = Be.useRef(null);
  wc(() => {
    o && (he.current ? he.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [o]);
  const _e = Be.Children.toArray(l), Te = _e.length && Om(_e[_e.length - 1], ["ListItemSecondaryAction"]), fe = it({}, n, {
    alignItems: i,
    autoFocus: o,
    button: s,
    dense: ee.dense,
    disabled: v,
    disableGutters: w,
    disablePadding: C,
    divider: M,
    hasSecondaryAction: Te,
    selected: z
  }), Oe = AK(fe), ye = Gi(he, r), de = h.Root || NK, ce = g.root || {}, Fe = it({
    className: nt(Oe.root, ce.className, c),
    disabled: v
  }, K);
  let le = f || "li";
  return s && (Fe.component = f || "div", Fe.focusVisibleClassName = nt(Rl.focusVisible, L), le = Uy), Te ? (le = !Fe.component && !f ? "div" : le, S === "li" && (le === "li" ? le = "div" : Fe.component === "li" && (Fe.component = "div")), /* @__PURE__ */ y.jsx(qa.Provider, {
    value: ee,
    children: /* @__PURE__ */ y.jsxs(jK, it({
      as: S,
      className: nt(Oe.container, b),
      ref: ye,
      ownerState: fe
    }, B, {
      children: [/* @__PURE__ */ y.jsx(de, it({}, ce, !Bl(de) && {
        as: le,
        ownerState: it({}, fe, ce.ownerState)
      }, Fe, {
        children: _e
      })), _e.pop()]
    }))
  })) : /* @__PURE__ */ y.jsx(qa.Provider, {
    value: ee,
    children: /* @__PURE__ */ y.jsxs(de, it({}, ce, {
      as: le,
      ref: ye,
      ownerState: fe
    }, !Bl(de) && {
      ownerState: it({}, fe, ce.ownerState)
    }, Fe, {
      children: [_e, W && /* @__PURE__ */ y.jsx(qy, {
        children: W
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Vy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: D.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  autoFocus: D.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  button: D.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: es(D.node, (e) => {
    const t = Be.Children.toArray(e.children);
    let r = -1;
    for (let n = t.length - 1; n >= 0; n -= 1) {
      const i = t[n];
      if (Om(i, ["ListItemSecondaryAction"])) {
        r = n;
        break;
      }
    }
    return r !== -1 && r !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: D.shape({
    Root: D.elementType
  }),
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  componentsProps: D.object,
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: Cm,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: D.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: D.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  disabled: D.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: D.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: D.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: D.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: D.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: D.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  selected: D.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
function kK(e) {
  return Mn("MuiListItemText", e);
}
const ZS = An("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), LK = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], zK = (e) => {
  const {
    classes: t,
    inset: r,
    primary: n,
    secondary: i,
    dense: o
  } = e;
  return Kn({
    root: ["root", r && "inset", o && "dense", n && i && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, kK, t);
}, BK = Xr("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${ZS.primary}`]: t.primary
    }, {
      [`& .${ZS.secondary}`]: t.secondary
    }, t.root, r.inset && t.inset, r.primary && r.secondary && t.multiline, r.dense && t.dense];
  }
})(({
  ownerState: e
}) => it({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), Yy = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiListItemText"
  }), {
    children: i,
    className: o,
    disableTypography: s = !1,
    inset: l = !1,
    primary: c,
    primaryTypographyProps: f,
    secondary: h,
    secondaryTypographyProps: g
  } = n, S = Hr(n, LK), {
    dense: b
  } = Be.useContext(qa);
  let p = c ?? i, v = h;
  const w = it({}, n, {
    disableTypography: s,
    inset: l,
    primary: !!p,
    secondary: !!v,
    dense: b
  }), C = zK(w);
  return p != null && p.type !== As && !s && (p = /* @__PURE__ */ y.jsx(As, it({
    variant: b ? "body2" : "body1",
    className: C.primary,
    component: "span",
    display: "block"
  }, f, {
    children: p
  }))), v != null && v.type !== As && !s && (v = /* @__PURE__ */ y.jsx(As, it({
    variant: "body2",
    className: C.secondary,
    color: "text.secondary",
    display: "block"
  }, g, {
    children: v
  }))), /* @__PURE__ */ y.jsxs(BK, it({
    className: nt(C.root, o),
    ownerState: w,
    ref: r
  }, S, {
    children: [p, v]
  }));
});
process.env.NODE_ENV !== "production" && (Yy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Alias for the `primary` prop.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: D.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: D.bool,
  /**
   * The main content element.
   */
  primary: D.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: D.object,
  /**
   * The secondary content element.
   */
  secondary: D.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: D.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
const FK = Object.values(iO), WK = (e) => Kt(
  (t, ...r) => {
    function n() {
      t(this);
    }
    const i = r.length > 1 ? r : FK, s = (Array.isArray(e) ? e : [e]).reduce((l, c) => l.concat(
      ...i.map((f) => {
        const h = n.bind(c);
        return c.on(f, h), () => c.off(f, h);
      })
    ), []);
    return () => {
      s.forEach((l) => l());
    };
  },
  [e]
), uO = () => cm(() => ({}), {})[1], cO = (e) => {
  const t = uO(), r = WK(e);
  pt(() => r(t), [r, t]);
};
function HK(e) {
  return Mn("MuiListItemIcon", e);
}
An("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
const $K = ["className"], UK = (e) => {
  const {
    alignItems: t,
    classes: r
  } = e;
  return Kn({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, HK, r);
}, GK = Xr("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  minWidth: 56,
  color: e.palette.action.active,
  flexShrink: 0,
  display: "inline-flex"
}, t.alignItems === "flex-start" && {
  marginTop: 8
})), dO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: i
  } = n, o = Hr(n, $K), s = Be.useContext(qa), l = it({}, n, {
    alignItems: s.alignItems
  }), c = UK(l);
  return /* @__PURE__ */ y.jsx(GK, it({
    className: nt(c.root, i),
    ownerState: l,
    ref: r
  }, o));
});
process.env.NODE_ENV !== "production" && (dO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
var Vu = {}, QS;
function qK() {
  if (QS) return Vu;
  QS = 1;
  var e = Vi();
  Object.defineProperty(Vu, "__esModule", {
    value: !0
  }), Vu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), "Close");
  return Vu.default = n, Vu;
}
var VK = /* @__PURE__ */ qK();
const YK = /* @__PURE__ */ jr(VK);
var Yu = {}, eE;
function KK() {
  if (eE) return Yu;
  eE = 1;
  var e = Vi();
  Object.defineProperty(Yu, "__esModule", {
    value: !0
  }), Yu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm1 14H8c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1zm3-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
  }), "AssignmentRounded");
  return Yu.default = n, Yu;
}
var XK = /* @__PURE__ */ KK();
const JK = /* @__PURE__ */ jr(XK);
var Ku = {}, tE;
function ZK() {
  if (tE) return Ku;
  tE = 1;
  var e = Vi();
  Object.defineProperty(Ku, "__esModule", {
    value: !0
  }), Ku.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.29 16.29 6.7 13.7a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l5.88-5.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-6.59 6.59c-.38.39-1.02.39-1.41 0z"
  }), "AssignmentTurnedInRounded");
  return Ku.default = n, Ku;
}
var QK = /* @__PURE__ */ ZK();
const eX = /* @__PURE__ */ jr(QK);
var Xu = {}, rE;
function tX() {
  if (rE) return Xu;
  rE = 1;
  var e = Vi();
  Object.defineProperty(Xu, "__esModule", {
    value: !0
  }), Xu.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM12 13c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
  }), "AssignmentLateRounded");
  return Xu.default = n, Xu;
}
var rX = /* @__PURE__ */ tX();
const nX = /* @__PURE__ */ jr(rX), iX = Object.values(qf), oX = (e) => Kt(
  (t, ...r) => {
    function n() {
      t(this);
    }
    const i = r.length > 1 ? r : iX, s = (Array.isArray(e) ? e : [e]).reduce((l, c) => l.concat(
      ...i.map((f) => {
        const h = n.bind(c);
        return c.on(f, h), () => c.off(f, h);
      })
    ), []);
    return () => {
      s.forEach((l) => l());
    };
  },
  [e]
), aX = (e, ...t) => {
  const r = uO(), n = oX(e);
  pt(() => n(r, ...t), [n, r, t]);
}, sX = (e) => {
  switch (e.Status) {
    case wi.FAILED:
      return /* @__PURE__ */ y.jsx(nX, { color: "error" });
    case wi.FINISED:
      return /* @__PURE__ */ y.jsx(eX, { color: "success" });
    case wi.PENDING:
    case wi.STOPED:
      return /* @__PURE__ */ y.jsx(JK, { color: "disabled" });
    case wi.RUNNING:
      return /* @__PURE__ */ y.jsx(
        un,
        {
          variant: "determinate",
          value: e.Progress,
          sx: { maxHeight: (t) => t.spacing(3), maxWidth: (t) => t.spacing(3) },
          color: "info"
        }
      );
    default:
      return /* @__PURE__ */ y.jsx(y.Fragment, {});
  }
}, lX = ({
  task: e
}) => {
  const [t, r] = Xe(!1), [n, i] = Xe(e.DurationForDisplay);
  aX(e), pt(() => {
    const c = setInterval(() => {
      i(e.DurationForDisplay);
    }, 1e3);
    return () => clearInterval(c);
  }, [e]);
  const o = (c) => {
    c.preventDefault(), r(!0), e.stop().finally(() => r(!1));
  }, s = e.RetryCountForDispaly ? `${e.title}...${e.RetryCountForDispaly}` : e.title, l = e.isInTerminalState || t;
  return /* @__PURE__ */ y.jsxs(Vy, { sx: { pt: 0, pb: 0 }, children: [
    /* @__PURE__ */ y.jsx(
      dO,
      {
        sx: {
          minWidth: (c) => c.spacing(5),
          "& > svg": {
            fontSize: "large"
          }
        },
        children: sX(e)
      }
    ),
    /* @__PURE__ */ y.jsx(
      Yy,
      {
        primary: s,
        secondary: `${n} - ${e.ProgressMessage}`,
        primaryTypographyProps: {
          sx: {
            fontWeight: "500",
            fontSize: ".9rem",
            textTransform: "uppercase"
          }
        }
      }
    ),
    /* @__PURE__ */ y.jsx(ia, { sx: { flexGrow: 1, minWidth: (c) => c.spacing(2) } }),
    /* @__PURE__ */ y.jsx(ia, { children: /* @__PURE__ */ y.jsx(
      Ep,
      {
        disabled: l,
        onClick: o,
        sx: {
          visibility: !e.isInTerminalState && e.isStoppable ? "visible" : "hidden"
        },
        children: /* @__PURE__ */ y.jsx(YK, {})
      }
    ) })
  ] });
}, uX = (e, t) => /* @__PURE__ */ y.jsx(lX, { task: e }, t), cX = () => /* @__PURE__ */ y.jsx(Vy, { children: /* @__PURE__ */ y.jsx(Yy, { primary: "aucune tâche enregistrée" }) }), dX = ({
  queue: e,
  renderTask: t,
  className: r
}) => {
  cO(e);
  const n = e.Status === nO.PAUSED;
  return /* @__PURE__ */ y.jsxs(
    ia,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden",
        minWidth: "30vw"
      },
      className: r,
      children: [
        /* @__PURE__ */ y.jsxs(lO, { variant: "dense", children: [
          /* @__PURE__ */ y.jsx(
            As,
            {
              variant: "subtitle2",
              component: "div",
              noWrap: !0,
              sx: { fontWeight: "700" },
              children: e.title
            }
          ),
          /* @__PURE__ */ y.jsx(ia, { sx: { flexGrow: 1 } }),
          /* @__PURE__ */ y.jsx(
            ia,
            {
              sx: {
                visibility: e.Stats.TOTAL - e.Stats.PROCESSED > 0 ? "visible" : "hidden"
              },
              children: /* @__PURE__ */ y.jsx(
                Ep,
                {
                  color: "inherit",
                  size: "small",
                  edge: "end",
                  onClick: (i) => {
                    i.preventDefault(), n ? e.resume() : e.pause();
                  },
                  children: n ? /* @__PURE__ */ y.jsx(SK, {}) : /* @__PURE__ */ y.jsx(wK, {})
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ y.jsxs(
          ia,
          {
            sx: {
              paddingLeft: (i) => i.spacing(4),
              fontSize: "smaller",
              backgroundColor: (i) => i.palette.info.light
            },
            children: [
              e.Stats.PROCESSED,
              " sur ",
              e.Stats.TOTAL,
              " terminées"
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(oO, { sx: { overflowY: "auto" }, children: e.Tasks.length > 0 ? e.Tasks.map(
          (i, o) => t ? t(i, o, e) : uX(i, o)
        ) : cX() })
      ]
    }
  );
};
function fX(e) {
  return Mn("MuiCircularProgress", e);
}
const pX = An("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]), hX = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let Cp = (e) => e, nE, iE, oE, aE;
const Pa = 44, gX = Bc(nE || (nE = Cp`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), vX = Bc(iE || (iE = Cp`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), mX = (e) => {
  const {
    classes: t,
    variant: r,
    color: n,
    disableShrink: i
  } = e, o = {
    root: ["root", r, `color${Wr(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Wr(r)}`, i && "circleDisableShrink"]
  };
  return Kn(o, fX, t);
}, yX = Xr("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], t[`color${Wr(r.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => it({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: t.palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && RE(oE || (oE = Cp`
      animation: ${0} 1.4s linear infinite;
    `), gX)), bX = Xr("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), wX = Xr("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.circle, t[`circle${Wr(r.variant)}`], r.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => it({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && RE(aE || (aE = Cp`
      animation: ${0} 1.4s ease-in-out infinite;
    `), vX)), sm = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: i,
    color: o = "primary",
    disableShrink: s = !1,
    size: l = 40,
    style: c,
    thickness: f = 3.6,
    value: h = 0,
    variant: g = "indeterminate"
  } = n, S = Hr(n, hX), b = it({}, n, {
    color: o,
    disableShrink: s,
    size: l,
    thickness: f,
    value: h,
    variant: g
  }), p = mX(b), v = {}, w = {}, C = {};
  if (g === "determinate") {
    const M = 2 * Math.PI * ((Pa - f) / 2);
    v.strokeDasharray = M.toFixed(3), C["aria-valuenow"] = Math.round(h), v.strokeDashoffset = `${((100 - h) / 100 * M).toFixed(3)}px`, w.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ y.jsx(yX, it({
    className: nt(p.root, i),
    style: it({
      width: l,
      height: l
    }, w, c),
    ownerState: b,
    ref: r,
    role: "progressbar"
  }, C, S, {
    children: /* @__PURE__ */ y.jsx(bX, {
      className: p.svg,
      ownerState: b,
      viewBox: `${Pa / 2} ${Pa / 2} ${Pa} ${Pa}`,
      children: /* @__PURE__ */ y.jsx(wX, {
        className: p.circle,
        style: v,
        ownerState: b,
        cx: Pa,
        cy: Pa,
        r: (Pa - f) / 2,
        fill: "none",
        strokeWidth: f
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (sm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'primary'
   */
  color: D.oneOfType([D.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), D.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: es(D.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   * @default 40
   */
  size: D.oneOfType([D.number, D.string]),
  /**
   * @ignore
   */
  style: D.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: D.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: D.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: D.oneOf(["determinate", "indeterminate"])
});
var Ju = {}, sE;
function xX() {
  if (sE) return Ju;
  sE = 1;
  var e = Vi();
  Object.defineProperty(Ju, "__esModule", {
    value: !0
  }), Ju.default = void 0;
  var t = e(/* @__PURE__ */ Yi()), r = Ci(), n = (0, t.default)(/* @__PURE__ */ (0, r.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }), "Check");
  return Ju.default = n, Ju;
}
var _X = /* @__PURE__ */ xX();
const SX = /* @__PURE__ */ jr(_X), EX = ({
  labelProps: e,
  value: t,
  text: r,
  done: n,
  ...i
}) => /* @__PURE__ */ y.jsxs(ia, { sx: { position: "relative", display: "inline-flex" }, ...i, children: [
  /* @__PURE__ */ y.jsxs(ia, { sx: { position: "relative", display: "flex" }, children: [
    /* @__PURE__ */ y.jsx(
      sm,
      {
        variant: "determinate",
        size: "2.5rem",
        thickness: 3,
        value: 100
      }
    ),
    /* @__PURE__ */ y.jsx(
      sm,
      {
        variant: "determinate",
        size: "2.5rem",
        thickness: 3,
        value: t,
        sx: {
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${pX.circle}`]: {
            strokeLinecap: "round"
          }
        }
      }
    )
  ] }),
  /* @__PURE__ */ y.jsx(
    ia,
    {
      sx: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: n ? /* @__PURE__ */ y.jsx(SX, {}) : /* @__PURE__ */ y.jsx(
        As,
        {
          variant: "caption",
          sx: {
            fontSize: "0.65rem"
          },
          ...e,
          children: r || `${Math.round(t)}%`
        }
      )
    }
  )
] }), CX = ({
  queue: e,
  ...t
}) => (cO(e), /* @__PURE__ */ y.jsx(
  EX,
  {
    done: e.Progress === 100,
    value: e.Progress,
    text: `${e.Stats.PROCESSED}/${e.Stats.TOTAL}`,
    ...t
  }
)), fO = (e) => e.scrollTop;
function Yf(e, t) {
  var r, n;
  const {
    timeout: i,
    easing: o,
    style: s = {}
  } = e;
  return {
    duration: (r = s.transitionDuration) != null ? r : typeof i == "number" ? i : i[t.mode] || 0,
    easing: (n = s.transitionTimingFunction) != null ? n : typeof o == "object" ? o[t.mode] : o,
    delay: s.transitionDelay
  };
}
const TX = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function lm(e) {
  return `scale(${e}, ${e ** 2})`;
}
const OX = {
  entering: {
    opacity: 1,
    transform: lm(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Ky = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const {
    addEndListener: n,
    appear: i = !0,
    children: o,
    easing: s,
    in: l,
    onEnter: c,
    onEntered: f,
    onEntering: h,
    onExit: g,
    onExited: S,
    onExiting: b,
    style: p,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: w = Fo
  } = t, C = Hr(t, TX), M = Be.useRef(), L = Be.useRef(), W = Gy(), z = Be.useRef(null), B = Gi(o.ref, r), K = Gi(z, B), Z = (de) => (ce) => {
    if (de) {
      const Fe = z.current;
      ce === void 0 ? de(Fe) : de(Fe, ce);
    }
  }, ee = Z(h), he = Z((de, ce) => {
    fO(de);
    const {
      duration: Fe,
      delay: le,
      easing: J
    } = Yf({
      style: p,
      timeout: v,
      easing: s
    }, {
      mode: "enter"
    });
    let re;
    v === "auto" ? (re = W.transitions.getAutoHeightDuration(de.clientHeight), L.current = re) : re = Fe, de.style.transition = [W.transitions.create("opacity", {
      duration: re,
      delay: le
    }), W.transitions.create("transform", {
      duration: re * 0.666,
      delay: le,
      easing: J
    })].join(","), c && c(de, ce);
  }), _e = Z(f), Te = Z(b), fe = Z((de) => {
    const {
      duration: ce,
      delay: Fe,
      easing: le
    } = Yf({
      style: p,
      timeout: v,
      easing: s
    }, {
      mode: "exit"
    });
    let J;
    v === "auto" ? (J = W.transitions.getAutoHeightDuration(de.clientHeight), L.current = J) : J = ce, de.style.transition = [W.transitions.create("opacity", {
      duration: J,
      delay: Fe
    }), W.transitions.create("transform", {
      duration: J * 0.666,
      delay: Fe || J * 0.333,
      easing: le
    })].join(","), de.style.opacity = "0", de.style.transform = lm(0.75), g && g(de);
  }), Oe = Z(S), ye = (de) => {
    v === "auto" && (M.current = setTimeout(de, L.current || 0)), n && n(z.current, de);
  };
  return Be.useEffect(() => () => {
    clearTimeout(M.current);
  }, []), /* @__PURE__ */ y.jsx(w, it({
    appear: i,
    in: l,
    nodeRef: z,
    onEnter: he,
    onEntered: _e,
    onEntering: ee,
    onExit: fe,
    onExited: Oe,
    onExiting: Te,
    addEndListener: ye,
    timeout: v === "auto" ? null : v
  }, C, {
    children: (de, ce) => /* @__PURE__ */ Be.cloneElement(o, it({
      style: it({
        opacity: 0,
        transform: lm(0.75),
        visibility: de === "exited" && !l ? "hidden" : void 0
      }, OX[de], p, o.props.style),
      ref: K
    }, ce))
  }));
});
process.env.NODE_ENV !== "production" && (Ky.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: D.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: D.bool,
  /**
   * A single child content element.
   */
  children: Kl.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: D.oneOfType([D.shape({
    enter: D.string,
    exit: D.string
  }), D.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: D.bool,
  /**
   * @ignore
   */
  onEnter: D.func,
  /**
   * @ignore
   */
  onEntered: D.func,
  /**
   * @ignore
   */
  onEntering: D.func,
  /**
   * @ignore
   */
  onExit: D.func,
  /**
   * @ignore
   */
  onExited: D.func,
  /**
   * @ignore
   */
  onExiting: D.func,
  /**
   * @ignore
   */
  style: D.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: D.oneOfType([D.oneOf(["auto"]), D.number, D.shape({
    appear: D.number,
    enter: D.number,
    exit: D.number
  })])
});
Ky.muiSupportAuto = !0;
const RX = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], IX = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, DX = {
  enter: fv.enteringScreen,
  exit: fv.leavingScreen
}, pO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const {
    addEndListener: n,
    appear: i = !0,
    children: o,
    easing: s,
    in: l,
    onEnter: c,
    onEntered: f,
    onEntering: h,
    onExit: g,
    onExited: S,
    onExiting: b,
    style: p,
    timeout: v = DX,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: w = Fo
  } = t, C = Hr(t, RX), M = Gy(), L = Be.useRef(null), W = Gi(o.ref, r), z = Gi(L, W), B = (Oe) => (ye) => {
    if (Oe) {
      const de = L.current;
      ye === void 0 ? Oe(de) : Oe(de, ye);
    }
  }, K = B(h), Z = B((Oe, ye) => {
    fO(Oe);
    const de = Yf({
      style: p,
      timeout: v,
      easing: s
    }, {
      mode: "enter"
    });
    Oe.style.webkitTransition = M.transitions.create("opacity", de), Oe.style.transition = M.transitions.create("opacity", de), c && c(Oe, ye);
  }), ee = B(f), he = B(b), _e = B((Oe) => {
    const ye = Yf({
      style: p,
      timeout: v,
      easing: s
    }, {
      mode: "exit"
    });
    Oe.style.webkitTransition = M.transitions.create("opacity", ye), Oe.style.transition = M.transitions.create("opacity", ye), g && g(Oe);
  }), Te = B(S), fe = (Oe) => {
    n && n(L.current, Oe);
  };
  return /* @__PURE__ */ y.jsx(w, it({
    appear: i,
    in: l,
    nodeRef: L,
    onEnter: Z,
    onEntered: ee,
    onEntering: K,
    onExit: _e,
    onExited: Te,
    onExiting: he,
    addEndListener: fe,
    timeout: v
  }, C, {
    children: (Oe, ye) => /* @__PURE__ */ Be.cloneElement(o, it({
      style: it({
        opacity: 0,
        visibility: Oe === "exited" && !l ? "hidden" : void 0
      }, IX[Oe], p, o.props.style),
      ref: z
    }, ye))
  }));
});
process.env.NODE_ENV !== "production" && (pO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: D.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: D.bool,
  /**
   * A single child content element.
   */
  children: Kl.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: D.oneOfType([D.shape({
    enter: D.string,
    exit: D.string
  }), D.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: D.bool,
  /**
   * @ignore
   */
  onEnter: D.func,
  /**
   * @ignore
   */
  onEntered: D.func,
  /**
   * @ignore
   */
  onEntering: D.func,
  /**
   * @ignore
   */
  onExit: D.func,
  /**
   * @ignore
   */
  onExited: D.func,
  /**
   * @ignore
   */
  onExiting: D.func,
  /**
   * @ignore
   */
  style: D.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: duration.enteringScreen,
   *   exit: duration.leavingScreen,
   * }
   */
  timeout: D.oneOfType([D.number, D.shape({
    appear: D.number,
    enter: D.number,
    exit: D.number
  })])
});
const PX = ["children", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"], MX = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, AX = Xr("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => it({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), hO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  var n;
  const i = Wn({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: o,
    components: s = {},
    componentsProps: l = {},
    className: c,
    invisible: f = !1,
    open: h,
    transitionDuration: g,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = pO
  } = i, b = Hr(i, PX), p = it({}, i, {
    invisible: f
  }), v = MX(p);
  return /* @__PURE__ */ y.jsx(S, it({
    in: h,
    timeout: g
  }, b, {
    children: /* @__PURE__ */ y.jsx(JE, {
      className: c,
      invisible: f,
      components: it({
        Root: AX
      }, s),
      componentsProps: {
        root: it({}, l.root, (!s.Root || !Bl(s.Root)) && {
          ownerState: it({}, (n = l.root) == null ? void 0 : n.ownerState)
        })
      },
      classes: v,
      ref: r,
      children: o
    })
  }));
});
process.env.NODE_ENV !== "production" && (hO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The components used for each slot inside the Backdrop.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: D.shape({
    Root: D.elementType
  }),
  /**
   * The props used for each slot inside the Backdrop.
   * @default {}
   */
  componentsProps: D.object,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: D.bool,
  /**
   * If `true`, the component is shown.
   */
  open: D.bool.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: D.oneOfType([D.number, D.shape({
    appear: D.number,
    enter: D.number,
    exit: D.number
  })])
});
const NX = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"], jX = (e) => e.classes, kX = Xr("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, !r.open && r.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  position: "fixed",
  zIndex: e.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), LX = Xr(hO, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), gO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  var n;
  const i = Wn({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: o = LX,
    closeAfterTransition: s = !1,
    children: l,
    components: c = {},
    componentsProps: f = {},
    disableAutoFocus: h = !1,
    disableEnforceFocus: g = !1,
    disableEscapeKeyDown: S = !1,
    disablePortal: b = !1,
    disableRestoreFocus: p = !1,
    disableScrollLock: v = !1,
    hideBackdrop: w = !1,
    keepMounted: C = !1
  } = i, M = Hr(i, NX), [L, W] = Be.useState(!0), z = {
    closeAfterTransition: s,
    disableAutoFocus: h,
    disableEnforceFocus: g,
    disableEscapeKeyDown: S,
    disablePortal: b,
    disableRestoreFocus: p,
    disableScrollLock: v,
    hideBackdrop: w,
    keepMounted: C
  }, B = it({}, i, z, {
    exited: L
  }), K = jX(B);
  return /* @__PURE__ */ y.jsx(ZE, it({
    components: it({
      Root: kX
    }, c),
    componentsProps: {
      root: it({}, f.root, (!c.Root || !Bl(c.Root)) && {
        ownerState: it({}, (n = f.root) == null ? void 0 : n.ownerState)
      })
    },
    BackdropComponent: o,
    onTransitionEnter: () => W(!1),
    onTransitionExited: () => W(!0),
    ref: r
  }, M, {
    classes: K
  }, z, {
    children: l
  }));
});
process.env.NODE_ENV !== "production" && (gO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: D.elementType,
  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: D.object,
  /**
   * A single child content element.
   */
  children: Kl.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: D.bool,
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: D.shape({
    Root: D.elementType
  }),
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  componentsProps: D.object,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: D.oneOfType([yc, D.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: D.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: D.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: D.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: D.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   * @default false
   */
  disableRestoreFocus: D.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: D.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: D.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: D.bool,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: D.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: D.func,
  /**
   * If `true`, the component is shown.
   */
  open: D.bool.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object])
});
function zX(e) {
  return Mn("MuiPaper", e);
}
An("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const BX = ["className", "component", "elevation", "square", "variant"], lE = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, FX = (e) => {
  const {
    square: t,
    elevation: r,
    variant: n,
    classes: i
  } = e, o = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${r}`]
  };
  return Kn(o, zX, i);
}, WX = Xr("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, t[r.variant], !r.square && t.rounded, r.variant === "elevation" && t[`elevation${r.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => it({
  backgroundColor: e.palette.background.paper,
  color: e.palette.text.primary,
  transition: e.transitions.create("box-shadow")
}, !t.square && {
  borderRadius: e.shape.borderRadius
}, t.variant === "outlined" && {
  border: `1px solid ${e.palette.divider}`
}, t.variant === "elevation" && it({
  boxShadow: e.shadows[t.elevation]
}, e.palette.mode === "dark" && {
  backgroundImage: `linear-gradient(${Na("#fff", lE(t.elevation))}, ${Na("#fff", lE(t.elevation))})`
}))), vO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiPaper"
  }), {
    className: i,
    component: o = "div",
    elevation: s = 1,
    square: l = !1,
    variant: c = "elevation"
  } = n, f = Hr(n, BX), h = it({}, n, {
    component: o,
    elevation: s,
    square: l,
    variant: c
  }), g = FX(h);
  return process.env.NODE_ENV !== "production" && Gy().shadows[s] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${s}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${s}]\` is defined.`].join(`
`)), /* @__PURE__ */ y.jsx(WX, it({
    as: o,
    ownerState: h,
    className: nt(g.root, i),
    ref: r
  }, f));
});
process.env.NODE_ENV !== "production" && (vO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: D.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: es(KE, (e) => {
    const {
      elevation: t,
      variant: r
    } = e;
    return t > 0 && r === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${r}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: D.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: D.oneOfType([D.oneOf(["elevation", "outlined"]), D.string])
});
function HX(e) {
  return Mn("MuiPopover", e);
}
An("MuiPopover", ["root", "paper"]);
const $X = ["onEntering"], UX = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
function uE(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.height / 2 : t === "bottom" && (r = e.height), r;
}
function cE(e, t) {
  let r = 0;
  return typeof t == "number" ? r = t : t === "center" ? r = e.width / 2 : t === "right" && (r = e.width), r;
}
function dE(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function bf(e) {
  return typeof e == "function" ? e() : e;
}
const GX = (e) => {
  const {
    classes: t
  } = e;
  return Kn({
    root: ["root"],
    paper: ["paper"]
  }, HX, t);
}, qX = Xr(gO, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), VX = Xr(vO, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), mO = /* @__PURE__ */ Be.forwardRef(function(t, r) {
  const n = Wn({
    props: t,
    name: "MuiPopover"
  }), {
    action: i,
    anchorEl: o,
    anchorOrigin: s = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: c = "anchorEl",
    children: f,
    className: h,
    container: g,
    elevation: S = 8,
    marginThreshold: b = 16,
    open: p,
    PaperProps: v = {},
    transformOrigin: w = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: C = Ky,
    transitionDuration: M = "auto",
    TransitionProps: {
      onEntering: L
    } = {}
  } = n, W = Hr(n.TransitionProps, $X), z = Hr(n, UX), B = Be.useRef(), K = Gi(B, v.ref), Z = it({}, n, {
    anchorOrigin: s,
    anchorReference: c,
    elevation: S,
    marginThreshold: b,
    PaperProps: v,
    transformOrigin: w,
    TransitionComponent: C,
    transitionDuration: M,
    TransitionProps: W
  }), ee = GX(Z), he = Be.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const ce = bf(o), Fe = ce && ce.nodeType === 1 ? ce : No(B.current).body, le = Fe.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const J = Fe.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && J.top === 0 && J.left === 0 && J.right === 0 && J.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: le.top + uE(le, s.vertical),
      left: le.left + cE(le, s.horizontal)
    };
  }, [o, s.horizontal, s.vertical, l, c]), _e = Be.useCallback((ce) => ({
    vertical: uE(ce, w.vertical),
    horizontal: cE(ce, w.horizontal)
  }), [w.horizontal, w.vertical]), Te = Be.useCallback((ce) => {
    const Fe = {
      width: ce.offsetWidth,
      height: ce.offsetHeight
    }, le = _e(Fe);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: dE(le)
      };
    const J = he();
    let re = J.top - le.vertical, be = J.left - le.horizontal;
    const Me = re + Fe.height, Ae = be + Fe.width, Re = zl(bf(o)), Ee = Re.innerHeight - b, Ce = Re.innerWidth - b;
    if (re < b) {
      const X = re - b;
      re -= X, le.vertical += X;
    } else if (Me > Ee) {
      const X = Me - Ee;
      re -= X, le.vertical += X;
    }
    if (process.env.NODE_ENV !== "production" && Fe.height > Ee && Fe.height && Ee && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Fe.height - Ee}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), be < b) {
      const X = be - b;
      be -= X, le.horizontal += X;
    } else if (Ae > Ce) {
      const X = Ae - Ce;
      be -= X, le.horizontal += X;
    }
    return {
      top: `${Math.round(re)}px`,
      left: `${Math.round(be)}px`,
      transformOrigin: dE(le)
    };
  }, [o, c, he, _e, b]), fe = Be.useCallback(() => {
    const ce = B.current;
    if (!ce)
      return;
    const Fe = Te(ce);
    Fe.top !== null && (ce.style.top = Fe.top), Fe.left !== null && (ce.style.left = Fe.left), ce.style.transformOrigin = Fe.transformOrigin;
  }, [Te]), Oe = (ce, Fe) => {
    L && L(ce, Fe), fe();
  };
  Be.useEffect(() => {
    p && fe();
  }), Be.useImperativeHandle(i, () => p ? {
    updatePosition: () => {
      fe();
    }
  } : null, [p, fe]), Be.useEffect(() => {
    if (!p)
      return;
    const ce = GE(() => {
      fe();
    }), Fe = zl(o);
    return Fe.addEventListener("resize", ce), () => {
      ce.clear(), Fe.removeEventListener("resize", ce);
    };
  }, [o, p, fe]);
  let ye = M;
  M === "auto" && !C.muiSupportAuto && (ye = void 0);
  const de = g || (o ? No(bf(o)).body : void 0);
  return /* @__PURE__ */ y.jsx(qX, it({
    BackdropProps: {
      invisible: !0
    },
    className: nt(ee.root, h),
    container: de,
    open: p,
    ref: r,
    ownerState: Z
  }, z, {
    children: /* @__PURE__ */ y.jsx(C, it({
      appear: !0,
      in: p,
      onEntering: Oe,
      timeout: ye
    }, W, {
      children: /* @__PURE__ */ y.jsx(VX, it({
        elevation: S
      }, v, {
        ref: K,
        className: nt(ee.paper, v.className),
        children: f
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (mO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: UE,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the popover.
   */
  anchorEl: es(D.oneOfType([yc, D.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = bf(e.anchorEl);
      if (t && t.nodeType === 1) {
        const r = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: D.shape({
    horizontal: D.oneOfType([D.oneOf(["center", "left", "right"]), D.number]).isRequired,
    vertical: D.oneOfType([D.oneOf(["bottom", "center", "top"]), D.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: D.shape({
    left: D.number.isRequired,
    top: D.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: D.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: D.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: D.object,
  /**
   * @ignore
   */
  className: D.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: D.oneOfType([yc, D.func]),
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: KE,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * @default 16
   */
  marginThreshold: D.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: D.func,
  /**
   * If `true`, the component is shown.
   */
  open: D.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   * @default {}
   */
  PaperProps: D.shape({
    component: Cm
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: D.oneOfType([D.arrayOf(D.oneOfType([D.func, D.object])), D.func, D.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: D.shape({
    horizontal: D.oneOfType([D.oneOf(["center", "left", "right"]), D.number]).isRequired,
    vertical: D.oneOfType([D.oneOf(["bottom", "center", "top"]), D.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: D.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: D.oneOfType([D.oneOf(["auto"]), D.number, D.shape({
    appear: D.number,
    enter: D.number,
    exit: D.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition) component.
   * @default {}
   */
  TransitionProps: D.object
});
const VZ = ({
  queue: e,
  popoverProps: t,
  ...r
}) => {
  const [n, i] = Xe(null);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(Nr, { title: e.title, children: /* @__PURE__ */ y.jsx(Ep, { ...r, ref: (o) => i(o), children: /* @__PURE__ */ y.jsx(CX, { queue: e }) }) }),
    n && /* @__PURE__ */ y.jsx(
      mO,
      {
        PaperProps: {
          sx: {
            display: "flex",
            maxHeight: "calc(100% - 150px)"
          }
        },
        anchorEl: n,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        ...t,
        children: /* @__PURE__ */ y.jsx(dX, { queue: e })
      }
    )
  ] });
}, YX = Rt((e) => ({
  nodeItem: ({ depth: t, clickable: r }) => ({
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: e.spacing(3 * t),
    cursor: r ? "pointer" : void 0
  }),
  checkbox: {
    height: e.spacing(4),
    width: e.spacing(4)
  },
  label: {
    paddingLeft: e.spacing(0.5)
  }
})), yO = (e) => (e == null ? void 0 : e.reduce(
  (t, r) => [...t, r.id, ...yO(r.children)],
  []
)) || [], bO = (e, t, r) => {
  let n = { checkedIds: e, hasChanged: !1 };
  if (!(t != null && t.length)) return n;
  const i = t.map((o) => o.id);
  return r && e.includes(r) && i.some((o) => !e.includes(o)) && (n = {
    checkedIds: [
      // We filter to avoid adding already checked children
      ...e.filter((o) => !i.includes(o)),
      ...i
    ],
    hasChanged: !0
  }), r && !e.includes(r) && i.every((o) => e.includes(o)) && (n = { checkedIds: [...e, r], hasChanged: !0 }), t.reduce((o, s) => {
    const { checkedIds: l, hasChanged: c } = bO(o.checkedIds, s.children, s.id);
    return {
      checkedIds: l,
      hasChanged: o.hasChanged || c
    };
  }, n);
}, wO = ({
  node: e,
  parentIds: t,
  checkedIds: r,
  setCheckedIds: n,
  closedIds: i,
  setClosedIds: o
}) => {
  var b, p, v;
  const s = !!((b = e.children) != null && b.length), l = YX({
    depth: (t == null ? void 0 : t.length) || 0,
    clickable: s
  }), c = kt(
    () => yO(e.children),
    [e.children]
  ), f = kt(
    () => c.reduce(
      (w, C) => r.includes(C) ? w + 1 : w,
      0
    ) || 0,
    [r, c]
  ), h = kt(
    () => f > 0 && f < c.length,
    [f, c.length]
  ), g = Kt(
    (w) => {
      w.target.type !== "checkbox" && o((C) => C.includes(e.id) ? C.filter((M) => M !== e.id) : [...C, e.id]);
    },
    [o, e.id]
  ), S = Kt(
    (w) => {
      w ? n == null || n((C) => [...C, e.id]) : n == null || n(
        (C) => C.filter(
          (M) => ![e.id, ...t || [], ...c].includes(M)
        )
      );
    },
    [n, e.id, t, c]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs(Qf, { onClick: g, className: l.nodeItem, dense: !0, children: [
      /* @__PURE__ */ y.jsx(
        Ba,
        {
          checked: r.includes(e.id),
          indeterminate: h,
          color: h ? "default" : void 0,
          onChange: (w, C) => S(C),
          className: l.checkbox
        }
      ),
      /* @__PURE__ */ y.jsx(Ya, { className: l.label, primary: e.label }),
      ((p = e.children) == null ? void 0 : p.length) && (i.includes(e.id) ? /* @__PURE__ */ y.jsx(_m, {}) : /* @__PURE__ */ y.jsx(_E, {}))
    ] }),
    ((v = e.children) == null ? void 0 : v.length) && /* @__PURE__ */ y.jsx(iN, { in: !i.includes(e.id), children: /* @__PURE__ */ y.jsx(Nc, { component: "div", disablePadding: !0, dense: !0, children: e.children.map((w) => /* @__PURE__ */ y.jsx(
      wO,
      {
        node: w,
        parentIds: [...t || [], e.id],
        checkedIds: r,
        setCheckedIds: n,
        closedIds: i,
        setClosedIds: o
      },
      w.id
    )) }) })
  ] });
}, YZ = ({
  nodes: e,
  checkedIds: t,
  setCheckedIds: r,
  closedIds: n,
  setClosedIds: i,
  className: o
}) => {
  const [s, l] = Xe([]);
  return pt(() => {
    l(n || []);
  }, [n, l]), pt(() => {
    const { checkedIds: c, hasChanged: f } = bO(
      t || [],
      e
    );
    f && (r == null || r(c));
  }, [e, t, r]), /* @__PURE__ */ y.jsx(Nc, { className: o, dense: !0, children: e.map((c) => /* @__PURE__ */ y.jsx(
    wO,
    {
      node: c,
      checkedIds: t || [],
      setCheckedIds: r,
      closedIds: s,
      setClosedIds: (f) => {
        l(f), i == null || i(f);
      }
    },
    c.id
  )) });
}, El = 10, KX = Rt(
  (e) => ({
    popper: {
      zIndex: e.zIndex.tooltip
    },
    card: ({ tipPosition: t }) => ({
      margin: e.spacing(2, 0),
      position: "relative",
      overflow: "visible",
      "&:before": {
        content: '""',
        display: "block",
        width: 0,
        height: 0,
        position: "absolute",
        borderBottom: `${El}px solid ${e.palette.common.white}`,
        borderLeft: `${El}px solid transparent`,
        borderRight: `${El}px solid transparent`,
        left: t || "50%",
        top: -El,
        transform: "translateX(-50%)"
      }
    }),
    cardTop: {
      "&:before": {
        borderBottom: "0 !important",
        top: "auto !important",
        borderTop: `${El}px solid ${e.palette.common.white}`,
        bottom: -El
      }
    },
    cardContent: {
      maxWidth: 300,
      paddingBottom: 0
    },
    cardPadding: {
      paddingTop: e.spacing(1)
    },
    cardActions: {
      justifyContent: "flex-end"
    },
    stepper: {
      marginRight: "auto"
    },
    closeButton: {
      position: "absolute",
      top: e.spacing(1),
      right: e.spacing(1),
      color: e.palette.grey[500]
    }
  })
), XX = ({
  anchorRef: e,
  tipPosition: t,
  content: r,
  open: n,
  lastOne: i,
  stepper: o,
  onNextClick: s,
  onCloseClick: l
}) => {
  const c = KX({ tipPosition: t });
  return /* @__PURE__ */ y.jsx(
    Jf,
    {
      open: n,
      anchorEl: e.current,
      transition: !0,
      className: c.popper,
      children: ({ TransitionProps: f, placement: h }) => /* @__PURE__ */ y.jsx(
        Zf,
        {
          ...f,
          style: {
            transformOrigin: h === "bottom" ? "center top" : "center bottom"
          },
          children: /* @__PURE__ */ y.jsxs(
            Bo,
            {
              className: nt(
                c.card,
                !i && c.cardPadding,
                h === "top" && c.cardTop
              ),
              raised: !0,
              children: [
                /* @__PURE__ */ y.jsx(pE, { className: c.cardContent, children: r }),
                /* @__PURE__ */ y.jsxs(vm, { className: c.cardActions, children: [
                  o && /* @__PURE__ */ y.jsx(
                    Lt,
                    {
                      color: "primary",
                      variant: "subtitle2",
                      className: c.stepper,
                      children: o
                    }
                  ),
                  i && /* @__PURE__ */ y.jsx(Fr, { size: "small", color: "primary", onClick: l, children: i ? "OK" : "Fermer" }),
                  !i && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                    /* @__PURE__ */ y.jsx(
                      fr,
                      {
                        color: "primary",
                        onClick: l,
                        size: "small",
                        className: c.closeButton,
                        children: /* @__PURE__ */ y.jsx(ql, { fontSize: "small" })
                      }
                    ),
                    /* @__PURE__ */ y.jsx(Fr, { size: "small", color: "primary", onClick: s, children: "Suivant" })
                  ] })
                ] })
              ]
            }
          )
        }
      )
    }
  );
}, iv = "TUTORIAL_SEEN_", xO = Ac(
  void 0
), KZ = ({ children: e }) => {
  const [t, r] = Xe([]), [n, i] = Xe(0), o = (f) => {
    en.get(`${iv}${f.id}`) || r((h) => {
      const g = h.findIndex(({ id: b }) => b === f.id), S = [...h];
      return g > -1 ? S[g] = f : f.index !== void 0 ? S.splice(f.index, 0, f) : S.push(f), S.filter(({ anchorRef: b }) => !!b.current);
    });
  }, s = (f) => {
    r((h) => h.filter(({ id: g }) => !f.includes(g))), i(0);
  }, l = () => {
    t.forEach(
      ({ id: f }) => en.set(`${iv}${f}`, !0)
    ), r([]), i(0);
  }, c = () => {
    en.set(
      `${iv}${t[n].id}`,
      !0
    ), i((f) => f + 1);
  };
  return /* @__PURE__ */ y.jsxs(
    xO.Provider,
    {
      value: {
        registerTutorial: o,
        unregisterTutorials: s
      },
      children: [
        e,
        t.map(({ id: f, anchorRef: h, tipPosition: g, content: S }, b) => /* @__PURE__ */ y.jsx(
          XX,
          {
            anchorRef: h,
            tipPosition: g,
            content: S,
            open: n === b,
            lastOne: b === t.length - 1,
            onCloseClick: l,
            onNextClick: c,
            stepper: t.length > 1 ? `${n + 1}/${t.length}` : void 0
          },
          f
        ))
      ]
    }
  );
}, XZ = () => {
  const [e, t] = Xe([]), r = qi(xO);
  if (!r)
    throw new Error("You need to wrap useTutorial inside TutorialProvider");
  const { registerTutorial: n, unregisterTutorials: i } = r;
  return pt(() => () => {
    i(e);
  }, [e]), { addTutorial: (l) => {
    t((c) => [...c, l.id]), n(l);
  }, removeTutorial: (l) => {
    i([l]), t((c) => c.filter((f) => f !== l));
  } };
}, JX = ({
  closeDialog: e,
  retrieveModif: t,
  deleteModifs: r
}) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsx(Gl, { children: "Récupérer les modifications" }),
  /* @__PURE__ */ y.jsx(Ao, { children: /* @__PURE__ */ y.jsx(za, { children: "Vos précédentes modifications n'ont pas été sauvegardées, souhaitez-vous les récupérer ?" }) }),
  /* @__PURE__ */ y.jsxs(ep, { children: [
    /* @__PURE__ */ y.jsx(
      Fr,
      {
        onClick: () => {
          r(), e();
        },
        children: "Effacer les modifications"
      }
    ),
    /* @__PURE__ */ y.jsx(
      Fr,
      {
        onClick: () => {
          t(), e();
        },
        color: "primary",
        variant: "contained",
        autoFocus: !0,
        children: "Récupérer"
      }
    )
  ] })
] }), df = "EDITING_CONTENT_", JZ = (e, t, r, n) => {
  const [i, o] = Xe(!0), { openDialog: s, closeDialog: l } = Jl(), c = Kt(() => {
    en.remove(`${df}${e}`), o(!1);
  }, [e]);
  return pt(() => {
    i || (r ? en.set(`${df}${e}`, t) : en.remove(`${df}${e}`));
  }, [t, r, e, i]), op(() => {
    const f = en.get(`${df}${e}`);
    f ? s(
      /* @__PURE__ */ y.jsx(
        JX,
        {
          closeDialog: l,
          retrieveModif: () => {
            n(f), o(!1);
          },
          deleteModifs: c
        }
      ),
      { disableClose: !0 }
    ) : o(!1);
  }), { clearUnsavedWork: c };
}, ZX = Rt((e) => ({
  snackBarInfo: {
    backgroundColor: e.palette.primary.main
  },
  buttonInfo: {
    backgroundColor: e.palette.common.white,
    color: e.palette.primary.main
  }
})), QX = 6e5, ZZ = () => {
  const e = ZX(), [t, r] = Xe(!1), n = () => fetch(`${location.origin}/version.json`).then((i) => i.json()).then(({ commit_sha: i }) => i);
  return op(() => {
    (async () => {
      const i = await n();
      setInterval(async () => {
        const o = await n();
        i !== o && r(!0);
      }, QX);
    })();
  }), /* @__PURE__ */ y.jsx(
    fm,
    {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      TransitionComponent: (i) => /* @__PURE__ */ y.jsx(gE, { ...i, direction: "up" }),
      open: t,
      children: /* @__PURE__ */ y.jsx(
        pm,
        {
          className: e.snackBarInfo,
          message: "Une nouvelle version est disponible",
          action: /* @__PURE__ */ y.jsx(
            Fr,
            {
              className: e.buttonInfo,
              size: "small",
              onClick: () => location.reload(),
              variant: "contained",
              children: "Mettre à jour"
            }
          )
        }
      )
    }
  );
}, eJ = Rt((e) => ({
  input: {
    backgroundColor: e.palette.common.white,
    alignItems: "center",
    borderRadius: 4
  },
  textFieldInput: {
    fontSize: e.typography.body1.fontSize,
    marginLeft: e.spacing(1),
    lineHeight: e.typography.body1.lineHeight
  },
  table: {
    width: "100%",
    backgroundColor: e.palette.grey[100],
    marginTop: e.spacing(1)
  },
  tableRow: {
    cursor: "pointer"
  },
  tableCell: {
    color: e.palette.common.black
  },
  tableCellMain: {
    fontWeight: "bold"
  },
  tableCellSmall: {
    width: "1%"
  },
  tableWrapper: {},
  wrapper: {
    display: "flex",
    flexDirection: "column",
    "& > *": {
      flex: "0 0 auto"
    },
    "& > $tableWrapper": {
      flex: "1",
      overflow: "auto"
    }
  }
})), tJ = ({ onChange: e, searchUser: t }) => {
  const r = eJ(), n = bt(null), [i, o] = Xe(""), s = Wc(i), [l, c] = Xe([]);
  return op(() => {
    n.current && n.current.focus();
  }), pt(() => {
    s ? t(s).then(c) : c([]);
  }, [s, t]), /* @__PURE__ */ y.jsxs("div", { className: r.wrapper, children: [
    /* @__PURE__ */ y.jsx(
      ln,
      {
        variant: "standard",
        "data-testid": "user-input-test",
        placeholder: "Chercher un utilisateur",
        fullWidth: !0,
        margin: "normal",
        onChange: ({ target: f }) => o(f.value),
        inputRef: n
      }
    ),
    l.length > 0 && /* @__PURE__ */ y.jsx(y.Fragment, { children: /* @__PURE__ */ y.jsx("div", { className: r.tableWrapper, children: /* @__PURE__ */ y.jsxs(yE, { className: r.table, children: [
      /* @__PURE__ */ y.jsx(oN, { children: /* @__PURE__ */ y.jsxs(wf, { children: [
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Utilisateur" }),
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Email" }),
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Role" }),
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Date de création" }),
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Id" }),
        /* @__PURE__ */ y.jsx(_n, { classes: { head: r.tableCell }, children: "Id Google" })
      ] }) }),
      /* @__PURE__ */ y.jsx(bE, { children: l.map((f) => /* @__PURE__ */ y.jsxs(
        wf,
        {
          className: r.tableRow,
          "data-testid": "user-row",
          onClick: () => e(f.id),
          children: [
            /* @__PURE__ */ y.jsx(
              _n,
              {
                classes: { body: r.tableCellMain },
                className: r.tableCell,
                children: f.name
              }
            ),
            /* @__PURE__ */ y.jsx(_n, { className: r.tableCell, children: f.email }),
            /* @__PURE__ */ y.jsx(_n, { className: r.tableCell, children: f.roles.join(" ") }),
            /* @__PURE__ */ y.jsx(_n, { className: r.tableCell, children: new Date(f.createdAt).toLocaleDateString() }),
            /* @__PURE__ */ y.jsx(_n, { className: r.tableCell, children: f.id }),
            /* @__PURE__ */ y.jsx(_n, { className: r.tableCell, children: f.googleId })
          ]
        },
        f.id
      )) })
    ] }) }) })
  ] });
}, QZ = ({ auth: e, searchUsers: t }) => {
  var i;
  const [r, n] = Xe(!1);
  return pt(() => {
    const o = (s) => {
      const l = s.metaKey && s.key === "e", c = s.ctrlKey && s.key === "e";
      (l || c) && (n(!0), s.preventDefault());
    };
    return e.isSuperAdmin() && window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o);
    };
  }, [e]), /* @__PURE__ */ y.jsx(
    jc,
    {
      "data-testid": "user-dialog-testid",
      maxWidth: "lg",
      fullWidth: !0,
      open: r,
      onClose: () => n(!1),
      children: /* @__PURE__ */ y.jsxs("div", { children: [
        /* @__PURE__ */ y.jsx(Gl, { children: "S'assigner les droits d'un autre utilisateur" }),
        /* @__PURE__ */ y.jsxs(Ao, { children: [
          e.isMainAuthenticated() && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
            /* @__PURE__ */ y.jsx(
              Fr,
              {
                onClick: e.backToMainUser,
                variant: "outlined",
                color: "primary",
                children: "Récupérer l'utilisateur principal"
              }
            ),
            " Connecté en tant que : ",
            (i = e.user) == null ? void 0 : i.name
          ] }),
          /* @__PURE__ */ y.jsx(tJ, { onChange: e.impersonate, searchUser: t })
        ] })
      ] })
    }
  );
};
export {
  Wi as ActionStyle,
  Fi as ActionType,
  xV as AdvancedSearchWrapper,
  kJ as AdviceProvider,
  RZ as Anchor,
  zJ as AppDrawerMenu,
  jt as AppName,
  bJ as Auth,
  Wm as AutocompleteList,
  ec as AutocompleteMode,
  gz as AutocompleteSelect,
  BJ as BackTo,
  HJ as BrandMenu,
  YJ as CardItem,
  bi as CardSize,
  Q8 as CharCounter,
  KJ as ChipList,
  XJ as ChipsInput,
  JJ as CircularProgressButton,
  MY as ClickableLink,
  xT as CropDialog,
  Ty as DEFAULT_MEDIA_HEIGHT,
  UJ as DialogDisplay,
  $J as DialogProvider,
  dZ as DraftAnchorIcon,
  UY as DraftBlockquoteIcon,
  kY as DraftBoldIcon,
  fZ as DraftCopyIcon,
  WY as DraftHeadlineIcon,
  LY as DraftItalicIcon,
  zY as DraftLinkIcon,
  HY as DraftListIcon,
  $Y as DraftOrderedListIcon,
  GY as DraftPasteIcon,
  IZ as DraftPluginC2c,
  BY as DraftStrikeThroughIcon,
  FY as DraftTitleIcon,
  cZ as DraftUnLinkIcon,
  X1 as DragDropContext,
  Cy as Draggable,
  bp as Droppable,
  ZJ as EditAppBar,
  QJ as EditAppBarTitle,
  TZ as Editor,
  eZ as ErrorBoundary,
  Wy as FRAME_PLUGIN_DATA_TYPE,
  bV as FileDropZone,
  tZ as FolderList,
  DZ as FotowebPlugin,
  PZ as FramePlugin,
  Ro as FrameType,
  rZ as GoogleAuthProvider,
  nZ as HistoryDialog,
  vq as HomeAppBar,
  gq as HomeAppBarDivider,
  HT as IMAGE_HEIGHT_RATIO,
  Lo as IconLabelButton,
  gf as IconPosition,
  iZ as ImageCompare,
  oZ as ImageGallery,
  WT as ImageGalleryItem,
  qc as ImageLoader,
  MZ as ImagePlugin,
  aZ as ImageSelectionBar,
  t8 as InfiniteList,
  QV as InfiniteListMode,
  sZ as InfiniteTable,
  _p as InnerMediaBlock,
  jV as Loader,
  _T as LoadingButton,
  IC as LockButton,
  lZ as LoginPage,
  hZ as MaterialDraft,
  jZ as MediaBlockContent,
  n7 as MediaFormat,
  CZ as MediaIcons,
  AZ as MediaPlugin,
  NZ as MediaPluginWithType,
  ui as MediaTypesEnum,
  FJ as MenuDisplay,
  WJ as MenuProvider,
  e8 as MultiMediaListHeaderTitle,
  ZV as MultiMediaListItemType,
  EZ as MultimediaManager,
  BZ as MultipleValuesField,
  vf as NEW_FOLDER_ID,
  FZ as NonEditableField,
  GJ as NotificationDisplay,
  qJ as NotificationProvider,
  jo as NotificationTypeEnum,
  kZ as PageBreakPlugin,
  WZ as PageWithDrawer,
  LZ as PastePlugin,
  HZ as PeriodSelect,
  n8 as PhotoSlider,
  jE as PreviewSize,
  nO as QueueStatus,
  $Z as ScheduleDialog,
  SV as SearchBar,
  Yn as SearchBarVariant,
  UZ as SimpleCheckBox,
  Fy as SimpleSelect,
  I_ as Skeletons,
  DY as SmartLink,
  Zv as SpecialNode,
  GT as StandeloneMaterialDraft,
  OZ as StylableLink,
  GZ as Task,
  qf as TaskEventName,
  qZ as TaskQueue,
  VZ as TaskQueueButton,
  iO as TaskQueueEventName,
  CX as TaskQueueProgress,
  dX as TaskQueueView,
  wi as TaskStatus,
  YZ as TreeList,
  KZ as TutorialProvider,
  ZZ as UpdateNotification,
  iT as UploadStatesEnum,
  QZ as UserDialog,
  pj as addProtocolToUrl,
  E7 as anchorsFromEditorState,
  yZ as areImagesValid,
  OJ as capitalize,
  Jv as countSearchParams,
  wZ as doMediasHaveCredits,
  bZ as doMediasHaveFormats,
  xZ as doMediasHaveSources,
  d7 as doesMediaHaveCredit,
  c7 as doesMediaHaveFormat,
  f7 as doesMediaHaveSource,
  pZ as draftActions,
  uZ as draftHasText,
  mj as encodeOrigin,
  rm as extractValue,
  xJ as fetchAndCache,
  _J as fetchData,
  CJ as fileExceedSizeInMo,
  vj as findAssetPreview,
  J0 as getAppLink,
  Nj as getAppLinks,
  Gf as getCanonical,
  QY as getCropZoneParam,
  Tj as getDeepObjectValuesByKey,
  BS as getDefaultForm,
  Qg as getEditableFieldErrors,
  YT as getEmbedHtml,
  EV as getFilteredFolders,
  l7 as getFirstImage,
  zy as getFirstMedia,
  h7 as getFirstVideo,
  jT as getFolderParentLabels,
  i7 as getImage,
  vZ as getImageFromMedias,
  Ul as getImageUrl,
  Y_ as getIsCurrentListItem,
  Rj as getIsValidURLFormat,
  CV as getLeveledFolders,
  im as getMediaSite,
  Za as getMediaType,
  SZ as getMediasSite,
  WE as getMenuHref,
  zZ as getOneMediaContentBlocksErrors,
  yJ as getOriginalImage,
  IJ as getPatternErrorMessage,
  X8 as getRawDraft,
  v7 as getRenderedImage,
  DJ as getRequiredErrorMessage,
  Sf as getSpacing,
  mZ as getThumbnail,
  vJ as getThumbnailSize,
  mJ as getThumbnailUrl,
  _Z as getVideoThumbnail,
  Cj as getWordCount,
  TJ as imageHasMinDimensions,
  gZ as isAffiliation,
  a7 as isBrightcoveVideo,
  x9 as isContentBlockDataIsOneMediaWithErrors,
  nm as isDailyMotionVideo,
  Ll as isDefined,
  go as isImage,
  LE as isImageFile,
  u7 as isImageValid,
  s7 as isMediaSite,
  wJ as isOdd,
  _9 as isOneMediaContentBlockWithErrors,
  o7 as isPodcast,
  Ly as isSlideshow,
  p7 as isVideo,
  EJ as isVideoFile,
  Lh as isWindow,
  Sm as loadImage,
  en as localStorage,
  VT as mediaFromIframely,
  wW as notificationQueue,
  PJ as objectsAreDifferents,
  J8 as parseDraftContent,
  xp as parseMedias,
  UT as pasteIntoEditorState,
  jS as paths,
  Po as pluralize,
  hj as prefixUrl,
  MJ as resizeImage,
  Uf as resizer,
  gj as selectMaxSize,
  _f as setDynamicPhrase,
  RJ as singularize,
  jj as toolsLinks,
  SJ as uploadFileToUrl,
  LJ as useAdvice,
  AJ as useAppBarHeight,
  VJ as useConcurrentialAccess,
  Wc as useDebounce,
  Jl as useDialog,
  $7 as useEditableFieldValidation,
  Ij as useInitialMount,
  Xl as useMenu,
  zE as useMountedState,
  Zl as useNotification,
  op as useOnMount,
  NJ as useOnScreen,
  jJ as usePrevious,
  oX as useTaskEvent,
  aX as useTaskEventUpdate,
  WK as useTaskQueueEvent,
  cO as useTaskQueueEventUpdate,
  XZ as useTutorial,
  JZ as useUnsavedWork
};
